const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Arrière Plan Des Arcanes Lunaires",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Échec de la publication en raison d'un nombre excessif d'actifs dans la scène. Veuillez supprimer certains actifs et réessayer.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Aucune autorisation d'accès aux fonctionnalités liées à l'adhésion n'a été accordée pour le moment",
  T_12_I_GIFT_SENDER_BELL: "Cloche",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "Capable de transporter {0} munitions supplémentaires (à l'exception du lance-grenades).",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Masque du Vieil Homme",
  T_12_L_COS_PINKMAN: "Dino rose",
  T_12_L_COS_POLAR: "Ours polaire",
  T_12_L_COS_RENDER: "Dino Coloré",
  T_12_L_COS_TIGER: "Combinaison Tigre",
  T_12_L_MALE_BOTTOM_COS_ELF: "Elfe d'Hiver (Bas)",
  T_12_L_MALE_COS_SANTA: "Vieil Homme Grincheux",
  T_12_L_MALE_HAIR_COS_ELF: "Elfe d'Hiver (Tete)",
  T_12_L_MALE_SHOE_COS_ELF: "Elfe d'Hiver (Chaussures)",
  T_12_L_MALE_TOP_COS_ELF: "Elfe d'Hiver (Haut)",
  T_12_O_CAT_NAME: "Chaton",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 - Winterlands",
  T_12_O_MACHETE_GOLD_NAME: "Parang - Lame d'or",
  T_12_O_PET_TITLE: "ANIMAUX",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Chaussures de Saut",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Chaussures fabriquées avec une technologie moderne. Permet aux humains de préformer des- sauts doubles.",
  T_12_Q_ITEM_FLYSHOE: "Chaussures Jet Pack",
  T_12_Q_ITEM_FLYSHOE_DESC: "Chaussures qui permettent à l'utilisateur de voler. Essayez de ne pas manquer de carburant dans l'air.",
  T_12_Q_ITEM_STOCK1: "Niveau de stock 1",
  T_12_Q_ITEM_STOCK2: "Niveau de stock 2",
  T_12_Q_ITEM_STOCK3: "Niveau de stock 3",
  T_12_Q_ITEM_TREATMENTGUN: "Pistolet de guérison",
  T_12_Q_ITEM_VEST4: "Combinaison anti-souffle",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Danse du tir",
  T_12_R_EMOTE_WAVE_NAME: "Vagues d'armes",
  T_12_R_SKILL_NAME_GANGLEADER: "Esprit de Gangster",
  T_12_R_SKILL_NAME_MONKEYGOD: "Illusion",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Amphibien",
  T_13_I_COLLECTION_V_JEEP: "Jeep",
  T_13_I_COLLECTION_V_MONSTER: "Monster Truck",
  T_13_I_COLLECTION_V_MOTOBIKE: "Motocyclette",
  T_13_I_COLLECTION_V_ROADSTER: "Voiture de Sport",
  T_13_I_COLLECTION_V_SUV: "Pickup",
  T_13_I_COLLECTION_V_TUTU: "Voiture Tu Tu",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Bleu Arctique (Masque)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Amour dans l'Air (En bas)",
  T_13_L_MALE_HAIR_COS_BJD: "Bleu Arctique (Tête)",
  T_13_L_MALE_TOP_COS_VALENTINE: "Amour dans l'Air (En haut)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Arme",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Skin d'animal: Chaton Détective",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR - Cupidon",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "Requin Bébé",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Poussez - vers le haut",
  T_13_R_EMOTE_EGYPT_NAME: "Danse de la Momie",
  T_13_R_PVE_WEAPON_SLOT: "Emplacement d'arme",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Portée effective",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Taux d'incendie",
  T_13_R_SKILL_DESC_HACKERGIRL: "Marquez vos ennemis, et Tiret pour [FFB300]{0}s[-], Vos coéquipiers aussi peuvent le voir.",
  T_13_R_SKILL_NAME_HACKERGIRL: "Oeil de pirate",
  T_13_Z_KICKOFF_BAN: "BAN",
  T_13_Z_ROOM_MORNING: "Jour",
  T_13_Z_ROOM_NIGHT: "Nuit",
  T_14_G_ITEM_KATANA: "Katana",
  T_14_I_HEADPIC_SONGKRAN_NAME: "ÉCLABOUSSURE!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Lapin Cubique",
  T_14_L_COS_EASTER: "Observateur 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Damme de Flamme (Chaussures)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Guerrier Lapin (Masque)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47 - Ballon d'Eau",
  T_14_O_DOG_NAME: "Chiot Mécanique",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Skin d'animal: Chiot En Acier",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Skin d'animal: Chiot D'Éclair",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Skin d'animal: Chiot Magnétique",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Skin d'animal: Chaton De Nuit",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - Lune De Sang",
  T_14_O_SCAR_SHARK_NAME: "SCAR - Attaque De Requin",
  T_14_Q_ITEM_RGS50: "RGS-50",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "Pour chaque [FFB300]{0}%[-] d'HP perdus, la pénétration d'armure augmente de [FFB300]{1}%[-].",
  T_14_R_SKILL_NAME_SAMURAI: "Pénétration d'armure",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Grève De La Faim (Masque)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Touche De Venin (Masque)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Grève De La Faim (Bas)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Touche De Venin (Bas)",
  T_15_L_MALE_SHOE_COS_FAIM: "Grève De La Faim (Chaussure)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Touche De Venin (Chaussure)",
  T_15_L_MALE_TOP_COS_FAIM: "Grève De La Faim (Haut)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Touche De Venin (Masque)",
  T_15_L_TOP_COS_MOTHERSDAY: "Meilleure Maman",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - Cataclysme",
  T_15_O_BASEBALLBAT_VIKING_NAME: "Batte - Le Viking",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - Cataclysme",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - Cataclysme",
  T_15_O_PANTHER_NAME: "Panthère De Nuit",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Skin d'animal: Capitaine",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Skin d'animal: Léopard Doré",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Skin d'animal: Domination",
  T_15_O_SKS_DEATH_NAME: "SKS - Souhait De Mort",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - Cataclysme",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "GATLING",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Secouer avec moi",
  T_15_R_SKILL_DESC_AGENT: "La précision augmente de [FFB300]{0}%[-] en fonction de la portée.",
  T_15_R_SKILL_NAME_AGENT: "Tireur d'élite",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Sac à dos - Ailes Violettes",
  T_16_B_ITEM_GRAPPLINGHOOK: "Crochet",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Pistolet à Crochet",
  T_16_L_MALE_COS_LEGO: "Briquetier Furieux",
  T_16_L_MALE_SHOE_COS_SUMMER: "Vacances d'été (Chaussure)",
  T_16_P_MANUAL_MONSTER: "Monster Truck",
  T_16_P_MANUAL_MUSHROOM1: "Champignon Lv1",
  T_16_P_MANUAL_MUSHROOM2: "Champignon Lv2",
  T_16_P_MANUAL_MUSHROOM3: "Champignon Lv3",
  T_16_P_MANUAL_MUSHROOM4: "Champignon Lv4",
  T_16_P_MANUAL_ROADSTER_DESC: "Voiture de sport élégante. HP faible mais vitesse max insensée. Peut transporter jusqu'à 2 joueurs.",
  T_16_P_MANUAL_STROP: "Strop",
  T_16_P_MANUAL_SUV: "Pickup",
  T_16_P_MANUAL_SUV_DESC: "Véhicule de Free Fire. Armure moyenne et vitesse maximale. Peut transporter jusqu'à 2 joueurs.",
  T_16_P_MANUAL_TUTU_DESC: "Un véhicule de faible HP pouvant voyager sur terre et sur l'eau. Peut transporter jusqu'à 3 joueurs.",
  T_16_P_MANUAL_WEAPON_AR: "Fusil",
  T_16_P_MANUAL_WEAPON_BOMB: "Grenades",
  T_16_P_MANUAL_WEAPON_PISTOL: "Pistolet",
  T_16_P_MANUAL_WEAPON_SG: "Shotgun",
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "Tireur d'élite",
  T_16_Q_MINISENTRY: "Mini Tourelle",
  T_16_Q_MINISENTRY_DESC: "Tourelle Auto faite de technologie moderne. Il va scanner et attaquer les ennemis à proximité.",
  T_16_R_EMOTE_DESERT_NAME: "Furieux Slam",
  T_16_R_EMOTE_EPHUNTER_NAME: "Danse de Bataille",
  T_16_R_EMOTE_EPHUNTER2_NAME: "Tape m'en cinq",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Moon Flip",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Marche agitée",
  T_16_W_AK_FIRE_NAME: "AK47 - Rouge Flamboyant",
  T_16_W_SCAR_LLENN_NAME: "SCAR - Diable Rose",
  T_16_W_SCAR_WATER_NAME: "SCAR - Eau Élémentaire",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "Détective Panda",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Skin d'animal: Panda Sauvage",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Skin d'animal: Crâne Panda",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Skin d'animal: Panda Éclair",
  T_17_B_CS_MODE_NAME: "Clash Squad",
  T_17_C_SKILL_NAME_PLAYBOY: "Mouvement Noisette",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Bouffon Royale (Masque)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Sanglante Maîtresse (Masque)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Sanglante Maîtresse (Bas)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Renard Magique (Tête)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Sanglante Maîtresse (Chaussures)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Sanglante Maîtresse (Haut)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Vengeance du Vampire (Masque)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Voyou de Rue (Bas)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Vengeance du Vampire (Bas)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Ombre Violet (Tête)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "Gentilhomme (Chaussures)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Vengeance du Vampire (Chaussures)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Vengeance du Vampire (Haut)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Ombre Doré (Haut)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Skin d'animal: Meow Princesse",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Skin d'animal: Conte Doré",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Skin d'animal: Bleu Profond",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Skin d'animal: Vert Chanceux",
  T_17_O_SHIBA_NAME: "Shiba",
  T_17_Q_FOLDWINGS: "Planeur",
  T_17_Q_FOLDWINGS_DESC: "Vous permet de glisser depuis des terrains surélevés.",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Danse de Soirée",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS - Vampire",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR - Assassin Fantôme",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR - Mode Classique",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "Nom",
  T_17_Z_ROOM_JUMP_SWITCH: "Hauteur du saut",
  T_17_Z_ROOM_SPEED_SWITCH: "Vitesse de Mouvement",
  T_18_B_THROWINGKNIFE_NAME: "FF Couteau",
  T_18_C_DUMMY_NAME: "Leurre",
  T_18_C_SKILL_DESC_DJMALE: "Crée une aura de [FFB300]{1}m[-] qui augmente la vitesse de déplacement de [FFB300]{3}%[-] et restaure [FFB300]{2} HP/s[-] pendant [FFB300]{0}s[-]. Les effets ne se cumulent pas. CD :  [FFB300]{4}s[-].",
  T_18_C_SKILL_NAME_DJMALE: "Rythme",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Recyclage",
  T_18_L_COS_INDIANEWYEAR: "Diwali Dino",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Visage Renfrogné",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Rouge Flamboyant (Masque)",
  T_18_O_FOX_NAME: "Renard Argenté",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Skin d'animal: Bataille Renard",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Skin d'animal: Renard Bleu",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Skin d'animal: Citrouille de lave",
  T_18_O_PETSKIN_PINKFOX_NAME: "Skin d'animal: Renard Rouge",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Skin d'animal: Esprit",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1 - Crâne Enflammé",
  T_18_W_UMP_GEISHA_N: "UMP - Art de Guerre",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Laila",
  T_19_B_HB_NAME: "Electric Surfboard",
  T_19_C_ICE_GUN_NAME: "Pistolet Gloo Wall",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "Les dégâts des armes explosives augmentent de [FFB300]{0}%[-] gamme de dégâts augmente de [FFB300]{1}%[-].",
  T_19_C_SKILL_DESC_TOMBOY: "Pendant la conduite, restaure [FFB300]{1} HP[-] toutes les [FFB300]{0}s[-] pour tout le monde dans le véhicule., jusqu'à un maximum de [FFB300]{2}[-] HP.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Art de la démolition",
  T_19_C_SKILL_NAME_TOMBOY: "Bénédiction du coureur",
  T_19_I_EVENT_INFI_ITEM: "Illimité",
  T_19_L_A_ICEFESTIVAL19_B: "Dernier rire",
  T_19_L_F_S_ICEFESTIVAL: "Servitude neigeuse (Chaussures)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Disco Fiasco (bas)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Disco Fiasco (Tête)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Disco Fiasco (Haut)",
  T_19_O_PETSKIN_NAME: "Skin d'animal: par défaut",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Skin de compagnie: Hiphop Panda",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Skin d'animal de compagnie: Panda polaire",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Skin de familier: Robo du pharaon",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Skin d'animal: Robo Fête du Printemps",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Skin d'animal de compagnie: Robo Snowy",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Skin d'animal de compagnie: Hiphop Shiba",
  T_19_O_ROBOT_NAME: "Robo",
  T_19_O_TDM_NAME: "Match à Mort",
  T_19_R_EMOTE_MIGUEL_NAME: "Break dance",
  T_19_S_SECOND_WEAPON_TITLE: "Arme secondaire",
  T_19_S_VEST_TITLE: "Gilet pare-balles",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Double Magazine",
  T_19_W_GROZA_TAGGERCREW_N: "Groza - Colère & rébellion",
  T_19_W_M60_ICEFESTIVAL_N: "M60 - Le choix du père Noël",
  T_19_W_MP40_PARK_N: "MP40 - Carnaval Carnage",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR - Dragon Aurous",
  T_19_X_PVE_SAMURAINAME: "Gardien samouraï",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Inhalateur",
  T_20_C_SKILL_DESC_PARKOURGUY: "Lorsque vous utilisez des armes à feu, toucher un ennemi récupère des HP pour l'utilisateur, renverser un ennemi récupère [FFB300]{0}%[-] HP pour l'utilisateur.",
  T_20_C_SKILL_NAME_GRAFFITIST: "Refuge peint",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Vitesse mortelle",
  T_20_C_SKILL_NAME_PARKOURGUY: "Raids soutenus",
  T_20_L_A_APRILFOOL2020: "Doggo",
  T_20_L_F_A_METALHEAD_RED: "Mme Fiery Imp-Head (masque)",
  T_20_L_F_B_THAIGIRL: "Adhésion à Phoenix (bas)",
  T_20_L_F_H_KILLERCUPID: "Cupidon amoureux (tête)",
  T_20_L_F_H_THAIGIRL: "Adhésion à Phoenix (Tête)",
  T_20_L_F_S_THAIGIRL: "Phoenix Accession (Chaussures)",
  T_20_L_F_T_METALHEAD_RED: "Ms. Fiery Imp-Head (Top)",
  T_20_L_F_T_THAIGIRL: "Adhésion à Phoenix (haut)",
  T_20_L_JEANDINO: "Denim Dino",
  T_20_L_M_A_METALHEAD_RED: "Ms. Fiery Imp-Head (masque)",
  T_20_L_M_T_METALHEAD_RED: "Mr. Fiery Imp-Head (Top)",
  T_20_L_M_T_STOCKING: "Gentle-man (Top)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Skin d'animal: Renard de la Saint-Valentin",
  T_20_P_CHANNEL_G: "Guilde",
  T_20_P_WORLD_SSPEAKER: "Haut-parleur",
  T_20_S_CSROOM_COIN: "Pièce par défaut",
  T_20_U_SHIELD_GUN_NAME: "Pistolet à bouclier",
  T_20_W_AN94_METALHEAD_N: "AN94 - Imp-Head de carotte",
  T_20_W_P90_EVILBONE_N: "P90 - Les punisseurs",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'Kelly "the Swift"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "Génère de la fumée, idéal pour les manœuvres de filtrage et d'accompagnement",
  T_21_B_SMOKEGRENADE_NAME: "Grenade fumigène",
  T_21_C_AUTOPICKUP_AVERAGE: "Par Défaut",
  T_21_C_SKILL_DESC_KPOPSINGER: "Tout en aidant un coéquipier, donne à ce coéquipier un bouclier de [FFB300]{0} HP[-] et une augmentation de la vitesse de déplacement de [FFB300]{1}%[-]. Les effets de boost sont réduits en [FFB300]{2}s[-] après une aide réussie. Réduit la vitesse de saignement des coéquipiers renversés de [FFB300]{3}%[-]. Les effets ne se cumulent pas.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Chaque élimination augmente max. HP par [FFB300]{0}[-]. Max. boost : [FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "Chanson de guérison",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Tour de chapeau",
  T_21_L_ANGELICAL: "L'Ange Dino",
  T_21_L_S_VNSLIPPER: "Chaussons Du Vietnam",
  T_21_O_OTTER_NAME: "Ottero",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Skin D'Animal: Radioactive Ottero",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Pet Skin: Sakura Ottero",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Skin D'Animal: Neon Ottero",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Pet Skin: Maître De La Mort",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Skin D'Animal: Boulon De Lumiere",
  T_21_R_EMOTE_SORROW_NAME: "Pourquoi? Oh pourquoi?",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "Sac à dos - Punkster",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Frappe finale de la mort",
  T_21_W_M79_RABBITKILLER_N: "M79 - Lapin Bagarreuse",
  T_21_W_PAN_VOLCANO_N: "Poêle - fureur volcanique",
  T_21_W_XM8_RAINBOW_N: "XM8- Abyssal",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "Localisez les positions des ennemis à moins de [FFB300]{0}m[-] qui ne sont pas couchés ou accroupis. Dure [FFB300]{1}s[-]. Les positions ennemies sont partagées avec les coéquipiers. Temps de recharge: [FFB300]{2}s[-]",
  T_22_C_SKILL_NAME_DETECTIVE: "Les etapes a suivre",
  T_22_C_SKILL_NAME_STREAMERGUY: "Centre d'attention",
  T_22_L_F_H_COLLEGE: "Étudiante Rebelle (cheveux)",
  T_22_L_F_S_SUMMER20: "Amoureuse d'Été (chaussure)",
  T_22_L_M_A_GREENCOAT: "Club Des Riches (mask)",
  T_22_L_M_A_PINKFUR: "Sakura Clubber (mask)",
  T_22_L_M_A_PLAGUE2: "Fantôme Épidémique (mask)",
  T_22_L_M_B_FAIM2: "Famine De Feu  (bas)",
  T_22_L_M_B_GREENCOAT: "Club Des Riches (bas)",
  T_22_L_M_B_PINKFUR: "Sakura Clubber (bas)",
  T_22_L_M_B_PLAGUE2: "Fantôme Épidémique (bas)",
  T_22_L_M_B_REDPANTS: "Clubber Moderne (bas)",
  T_22_L_M_B_TIGERSTRIPE: "Club Des Tigres (bas)",
  T_22_L_M_H_COLLEGE: "Étudiant Rebel (cheveux)",
  T_22_L_M_H_FAIM2: "Famine De Feu  (cheveux)",
  T_22_L_M_H_GREENCOAT: "Club Des Riches (cheveux)",
  T_22_L_M_H_PINKFUR: "Sakura Clubber (cheveux)",
  T_22_L_M_H_PLAGUE2: "Fantôme Épidémique (cheveux)",
  T_22_L_M_H_REDPANTS: "Clubber Moderne (cheveux)",
  T_22_L_M_H_TIGERSTRIPE: "Club Des Tigres (cheveux)",
  T_22_L_M_S_FAIM2: "Famine De Feu  (chaussure)",
  T_22_L_M_S_PLAGUE2: "Fantôme Épidémique (chaussure)",
  T_22_L_M_T_FAIM2: "Famine De Feu  (top)",
  T_22_L_M_T_GREENCOAT: "Club Des Riches (top)",
  T_22_L_M_T_PINKFUR: "Sakura Clubber (top)",
  T_22_L_M_T_PLAGUE2: "Fantôme Épidémique (top)",
  T_22_L_M_T_REDPANTS: "Clubber Moderne (top)",
  T_22_L_M_T_TIGERSTRIPE: "Club Des Tigres (top)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K - Académie rebelle",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Poêle - Pastèque",
  T_22_LC_SCAR_HERMIT_N: "SCAR - Chercheur mysterieux",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Pistolet de guérison - Rave Ultrasonique",
  T_22_O_HAWK_NAME: "Falco",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "skin d'animal: Apocalypse Fox",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Skin d'animal: Falco d'enfer",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Skin d'animal: Falco vert",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Skin d'Animal: Shiba Du soleil",
  T_22_Q_BOMB_PLIERS: "Pince à défusion",
  T_22_R_EMOTE_SHIMMY_NAME: "Shimmy",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "Pénétration d'armure",
  T_22_U_WPNSKN_SPEED_RUN: "Vitesse de mouvement",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "Horizaline",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Vindicate Slash",
  T_23_C_SKILL_NAME_SWATGUY: "Rechargement de la Rage",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'Hayato " Eveil"',
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Rappeuse D'or (Bas)",
  T_23_L_F_B_MIKOGIRL: "Prêtresse du Pole Nord (Bas)",
  T_23_L_F_B_NAVYGIRL: "Fille marine (Bas)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Rappeuse D'or (tête)",
  T_23_L_F_H_MIKOGIRL: "Prêtresse du Pole Nord (tête)",
  T_23_L_F_H_NAVYGIRL: "Fille marine (Tête)",
  T_23_L_F_S_MIKOGIRL: "Prêtresse du Pole Nord (Chaussures)",
  T_23_L_F_S_ORDERCHALLENGER: "Cerveau du Braquage (Chaussures)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Rappeuse Punitive  (haut)",
  T_23_L_F_T_MIKOGIRL: "Prêtresse du Pole Nord (Haut)",
  T_23_L_F_T_NAVYGIRL: "Fille marine (Haut)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Rappeur d'Or (Masque)",
  T_23_L_M_B_FOXGUY: "Sagedu Pole Nord (Bas)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Rappeur d'Or (Bas)",
  T_23_L_M_H_FOXGUY: "Sage du Pole Nord (Tête)",
  T_23_LC_SKS_GEMINI_N: "SKS - Maniaque hystérique",
  T_23_O_PENGUIN_NAME: "Mr. Waggor",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Skin d'animal : Waggor des Fêtes",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Skin d'animal : Cyber ​​Waggor",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Skin d'animal : Waggor d'or",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Clash Squad",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Personnage",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "ATTENTION",
  T_24_C_FLAMETHROWER_NAME: "Lance-flammes",
  T_24_C_SKILL_DESC_PROFESSOR: "L'EP max augmente de [FFB300]{0}[-]. Mode Jiu-jitsu: les alliés à moins de [FFB300]{2}m[-] obtiennent une augmentation de [FFB300]{1}%[-] du taux de conversion EP. Mode Psychologie: récupérez [FFB300]{5} EP[-] toutes les [FFB300]{4}s[-], jusqu'à [FFB300]{6} EP[-]. CD du commutateur de mode: [FFB300]{3}s[-].",
  T_24_C_SKILL_NAME_PARTYGIRL: "Faire la fête",
  T_24_C_SKILL_NAME_PROFESSOR: "Maître de tous",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "Pantalon MAX",
  T_24_L_H_PUMPKIN2020_A: "Citrouille tordue (tête)",
  T_24_L_T_TSHIRT_COMEDIAN: "Héros du dernier coup",
  T_24_LC_MP5_RICHBOXER_N: "MP5 - Boxeur Champion",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR - Célébration féroce",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD - Épéistes Légendaires",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Score total",
  T_24_V_TRAINING_BOX_ATTACH: "Pièces jointes",
  T_24_V_TRAINING_BOX_WEAPON: "Armes",
  T_24_W_ARMORY: "Armes",
  T_24_W_ARMOTY_MELEE: "Mêlée",
  T_24_W_ARMOTY_PISTOL: "Pistolets",
  T_24_W_ARMOTY_RIFLE: "Fusils",
  T_24_W_ARMOTY_SHOTGUN: "Shotgun",
  T_24_W_ARMOTY_SNIPER: "Tireurs d'élite",
  T_24_W_ARMOTY_SPECIAL: "Autres",
  T_24_W_ARMOTY_SUBMACHINE: "Mitraillette",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Skin d'Animal: Booyah Panda",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Skin d'Animal: Skeleton Rockie",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Skin d'animal: Party Rockie",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Skin d'animal: Rockie Mort-vivant",
  T_24_W_RACCOON_N: "Rockie",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Retourneur de temps",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "Préréglage 1",
  T_25_E_HUD_02: "Préréglage 2",
  T_25_L_F_B_DEMONKILLER: "Lycéenne Excitée (Bas)",
  T_25_L_F_H_DEMONKILLER: "Lycéenne Excitée (Tête)",
  T_25_L_F_S_DEMONKILLER: "Lycéenne Excitée (Chaussures)",
  T_25_L_F_T_DEMONKILLER: "Lycéenne Excitée (Haut)",
  T_25_L_HA_FP_EVIL: "Evil (Maquillage)",
  T_25_L_M_H_ANIMEHAIR: "Breezy (cheveux)",
  T_25_L_S_MAXSNEAKERS: "Baskets MAX",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Batte - Cyber Swing",
  T_25_LC_GLOO_WINTERFEST2020_N: "Gloo Wall - Winterlands 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887 - Winterlands 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Parang - Cyber Blade",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90 - Tune Blaster Green",
  T_25_LC_P90_MUSICFALL_RED_N: "P90 - Tune Blaster Rouge",
  T_25_LC_PAN_BOUNTY_N: "Poêle - Cyber chasseur de Bounty",
  T_25_R_LEGEND_REMIND: "Reminder",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Faux",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "Beaston",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Petskin: Glacier Beaston",
  T_25_W_PETSKIN_BABOON_HELL_N: "Petskin: Bête flamboyante",
  T_25_W_PETSKIN_BABOON_PURE_N: "Petskin: Grande bête blanche",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Skin d'animal: Panthère des neiges",
  T_25_Z_R_SIMULATOR_OFF: "Refuser",
  T_26_C_SKILL_DESC_SUPERSTAR: "Déchaîne une onde sonore vers l'avant pendant [FFB300]{0}m[-]. La vague explose et inflige des dégâts aux Gloo Walls dans un rayon de [FFB300]{1}m[-] pendant [FFB300]{2}s[-]. Temps de recharge: [FFB300]{3}s[-]..",
  T_26_C_SKILL_NAME_SUPERSTAR: "Rythme Riptide",
  T_26_D_CHARACTER_DELIVERY_N: "Shirou",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "UAV-Lite",
  T_26_L_A_FLAMING_PREM: "Soldat infernal (Masque)",
  T_26_L_A_SANTAMODE: "Bonhomme de neige Bob (Masque)",
  T_26_L_B_SANTAMODE: "Bonhomme de neige Bob (Bas)",
  T_26_L_F_B_WATERFEST21_A: "Brise d'été (Bas)",
  T_26_L_F_H_WATERFEST21_A: "Brise d'été (Tete)",
  T_26_L_F_S_WATERFEST21_A: "Brise d'été (Chaussures)",
  T_26_L_F_T_WATERFEST21_A: "Brise d'été (Haut)",
  T_26_L_M_A_EGGDAY2021: "Cyber lapin (Masque)",
  T_26_L_M_B_EGGDAY2021: "Cyber lapin (Bas)",
  T_26_L_M_B_PAIRING: "Duo dynamique M (Bas)",
  T_26_L_M_B_WATERFEST21_A: "Vague d'été (Bas)",
  T_26_L_M_H_EGGDAY2021: "Cyber lapin (Tete)",
  T_26_L_M_H_PAIRING: "Duo dynamique M (Tete)",
  T_26_L_M_H_WATERFEST21_A: "Vague d'été (Tete)",
  T_26_L_M_S_EGGDAY2021: "Cyber lapin (Chaussures)",
  T_26_L_M_S_PAIRING: "Duo dynamique M (Chaussures)",
  T_26_L_M_S_WATERFEST21_A: "Vague d'été (Chaussures)",
  T_26_L_M_T_EGGDAY2021: "Cyber lapin (Haut)",
  T_26_L_M_T_PAIRING: "Duo dynamique M (Haut)",
  T_26_L_M_T_WATERFEST21_A: "Vague d'été (Haut)",
  T_26_L_S_SANTAMODE: "Bonhomme de neige Bob (Chaussures)",
  T_26_L_T_SANTAMODE: "Bonhomme de neige Bob (Haut)",
  T_26_LC_AWM_KOICARP_N: "AWM - Koi Chanceux",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana - Saison de rose",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Voiture de sport - Cobra",
  T_26_P_SKILL_NAME_DELIVERY: "Dégâts infligés",
  T_26_V_TRAINING_BHH: "Marteau fantaisie",
  T_26_V_TRAINING_DICE: "Dés géants",
  T_26_W_DRAGON_N: "Dreki",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Skin d'animal: Dreki éclaboussant",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Skin d'animal: Dreki zapper",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Skin d'animal: Dreki Galaxy",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Skin d'animal: Waggor Amoureux",
  T_26_XL_SETTING_TEAMMATE_INFO: "Infos des coéquipiers",
  T_26_YP_HISTORY_WIN: "La victoire",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Femme",
  T_26_YP_SOCIAL_GENDER_MALE: "Mâle",
  T_26_YP_SOCIAL_NAME: "Surnom",
  T_27_C_SKILL_DESC__RACERGIRL: "La vitesse de conduite augmente de [FFB300]{0}%[-]. Dans le véhicule, il est plus difficile de viser le personnage et les dégâts subis diminuent de [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Crée un champ de force impénétrable qui bloque [FFB300]{0} DMG[-]. Incapable d'attaquer les ennemis extérieurs depuis le terrain. Tous les effets durent [FFB300]{1}s[-]. CD [FFB300]{2}s[-].",
  T_27_C_SKILL_DESC_FALCONER: "Les dégâts augmentent avec la distance, jusqu'à [FFB300]{0}%[-]. Les dégâts infligés aux ennemis marqués augmentent de [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Éveil: réduisez les dégâts frontaux de [FFB300]{1}%[-] pour chaque [FFB300]{0}%[-] d'HP perdu",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Éveil: sprint pendant [FFB300]{0}s[-] pour s'activer. Lorsqu'ils sont activés, les [FFB300]{2}[-] premiers tirs sur la cible infligent [FFB300]{1}%[-] de dégâts. Dure [FFB300]{3}s[-].",
  T_27_C_SKILL_NAME_FALCONER: "Ferveur du faucon",
  T_27_C_SKILL_NAME_XTREME: "Rencontre Xtreme",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'Andrew "le Féroce"',
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Zinah",
  T_27_F_EAP_PKG3_D: "Battle in style!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "Tigre en Papier (Masque)",
  T_27_L_B_CARDBOARD_REG: "Ours en papier (Bas)",
  T_27_L_M_S_KAZAKHSTAN: "Le Baghatur (Chaussures)",
  T_27_L_S_CARDBOARD_REG: "Ours en papier (Chaussures)",
  T_27_L_T_CARDBOARD_REG: "Ours en papier (Haut)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector - FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Monster Truck - FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Moto - Nuit Décisive",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Voiture de sport - Emerald Flash",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Pickup - Flame Draco",
  T_27_P_SKILL_NAME_HITMAN_RE: "Silencieux mort",
  T_27_R_EMOTE_GREETING_NAME: "Salutations",
  T_27_R_VEHICLE_ACCELERATION: "Accélération",
  T_27_R_VEHICLE_HP: "Durabilité",
  T_27_R_VEHICLE_SPEED: "Vitesse Max",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Éveil: La réduction des dégâts de l'armure est augmentée de [FFB300]{0}%[-]. Réduction des dégâts supplémentaire de [FFB300]{1}%[-] pour chaque coéquipier dans un rayon de [FFB300]{2}m[-].",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Meute de loups",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "Moony",
  T_27_W_ARMOTY_DMR: "Fusil de tireur d'élite",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Skin D'animal: Crystal Moony",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Skin d'animal: Gamer Moony",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Skin d'animal: Hipster Moony",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Skin d'animal: FFWS 2021 Pup",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Peau d'animal: Panda FFWS 2021",
  T_27_XC_REPLAY_DIE: "Mort",
  T_27_XC_REPLAY_KILL: "Kill",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "réparation",
  T_28_C_G_ICE_NAME: "Gel Rapide",
  T_28_C_SKILL_DESC_STREETBEAT: "Lorsque vous tirez en mouvement, la vitesse de déplacement augmente de [FFB300]{0}%[-], la précision augmente de [FFB300]{1}%[-].",
  T_28_C_SKILL_NAME_STREETBEAT: "Bullet Beats",
  T_28_D_CHARACTER_STREETBEAT_N: "D-bee",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "Maillot de football n ° 23 (Bas)",
  T_28_L_B_BRJERSEY_B: "Maillot de football n ° 10 (Bas)",
  T_28_L_B_BRJERSEY_C: "Maillot de football n ° 24 (Bas)",
  T_28_L_B_BRJERSEY_D: "Maillot de football n ° 30 (Bas)",
  T_28_L_B_BRJERSEY_E: "Maillot de football n ° 1 (Bas)",
  T_28_L_B_BRJERSEY_F: "Maillot de football n ° 20 (Bas)",
  T_28_L_F_B_FOURSYMBOLS_C: "Tourbillon vermillon (Bas)",
  T_28_L_F_H_FOURSYMBOLS_C: "Tourbillon vermillon (Tete)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Tourbillon vermillon (Maquillage)",
  T_28_L_F_S_FOURSYMBOLS_C: "Tourbillon vermillon (Chaussures)",
  T_28_L_F_T_FOURSYMBOLS_C: "Tourbillon vermillon (Haut)",
  T_28_L_HA_THUNDER: "Oeil de foudre (Maquillage)",
  T_28_L_M_A_SPORTSUIT: "Ballsy Skaterboi (Masque)",
  T_28_L_M_B_FOURSYMBOLS_D: "Ombre Earthshaker (Bas)",
  T_28_L_M_B_SPORTSUIT: "Ballsy Skaterboi (Bas)",
  T_28_L_M_H_FOURSYMBOLS_D: "Ombre Earthshaker (Tete)",
  T_28_L_M_H_SPORTSUIT: "Ballsy Skaterboi (Tete)",
  T_28_L_M_S_FOURSYMBOLS_D: "Ombre Earthshaker (Chaussures)",
  T_28_L_M_S_SPORTSUIT: "Ballsy Skaterboi (Chaussures)",
  T_28_L_M_T_FALLWINTER: "Sauce Swagger (Haut)",
  T_28_L_M_T_FOURSYMBOLS_D: "Ombre Earthshaker (Haut)",
  T_28_L_M_T_SPORTSUIT: "Ballsy Skaterboi (Haut)",
  T_28_L_T_BRJERSEY_A: "Maillot de football n ° 23 (Haut)",
  T_28_L_T_BRJERSEY_B: "Maillot de football n ° 10 (Haut)",
  T_28_L_T_BRJERSEY_C: "Maillot de football n ° 24 (Haut)",
  T_28_L_T_BRJERSEY_D: "Maillot de football n ° 30 (Haut)",
  T_28_L_T_BRJERSEY_E: "Maillot de football n ° 1 (Haut)",
  T_28_L_T_BRJERSEY_F: "Maillot de football n ° 23 (Haut)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 - Mariée Rubis",
  T_28_LC_GLOO_FALLWINTER_N: "Gloo Wall - Sauce Swagger",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Gloo Wall - Stormbringer",
  T_28_LC_KORD_SHINOBI_N: "Kord - Shinobi Flamboyant",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker - Nécromancien impitoyable",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - Nageoires mortelle",
  T_28_LC_PAN_FOURSYMBOLS_N: "Poêle - Earthshaker Stomp",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Jeep - Stormbringer",
  T_28_T_WS_ITEM1: "Boîte carrée",
  T_28_T_WS_ITEM10: "cabane",
  T_28_T_WS_ITEM11: "Tour de garde",
  T_28_T_WS_ITEM12: "Avant-poste",
  T_28_T_WS_ITEM13: "House A",
  T_28_T_WS_ITEM14: "House B",
  T_28_T_WS_ITEM15: "Maison C",
  T_28_T_WS_ITEM16: "Structure de sable",
  T_28_T_WS_ITEM17: "Fountaien",
  T_28_T_WS_ITEM18: "Cherry Blossom",
  T_28_T_WS_ITEM19: "Bananier",
  T_28_T_WS_ITEM2: "Boîte longue",
  T_28_T_WS_ITEM20: "Cuvette des toilettes",
  T_28_T_WS_ITEM21: "Clôture",
  T_28_T_WS_ITEM3: "Arbuste",
  T_28_T_WS_ITEM4: "Meule de foin",
  T_28_T_WS_ITEM5: "Voiture",
  T_28_T_WS_ITEM6: "Autobus",
  T_28_T_WS_ITEM7: "Conteneur A",
  T_28_T_WS_ITEM8: "Conteneur B",
  T_28_T_WS_ITEM9: "Conteneur C",
  T_28_T_WS_TYPE1: "Objets",
  T_28_T_WS_TYPE4: "Decorations",
  T_28_W_DUCK_N: "Dr. Beanie",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Petskin: Mythos Légendaire",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Petskin: Sgt. Beanie",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Petskin: Bonnet Gangster",
  T_28_W_PETSKIN_DUCK_SHINY_N: "Petskin: Bonnet DJ",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Éveil : les marques sur les ennemis touchés durent plus longtemps lorsque les ennemis se déplacent (jusqu'à [FFB300]{0}s[-] de plus).",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "L'œil d'Enigma",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Vibrations vitales",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "Battement de coeur de guérison",
  T_29_D_CHARACTER_AMOCO_N: 'Moco "Énigme"',
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Maillot de foot rayé (Bas)",
  T_29_L_M_A_FALCONER_C: "Mauvaise humeur Lavisher (Masque)",
  T_29_L_M_A_JUNGLE_GREEN: "Tortue de guerre camou (Masque)",
  T_29_L_M_B_FALCONER_C: "Mauvaise humeur Lavisher (Bas)",
  T_29_L_M_B_JUNGLE_GREEN: "Tortue de guerre camou (Bas)",
  T_29_L_M_H_FALCONER_C: "Mauvaise humeur Lavisher (Tête)",
  T_29_L_M_H_JUNGLE_GREEN: "Tortue de guerre camou (Tête)",
  T_29_L_M_S_FALCONER_C: "Mauvaise humeur Lavisher (Chaussure)",
  T_29_L_M_S_JUNGLE_GREEN: "Tortue de guerre camou (Chaussure)",
  T_29_L_M_T_FALCONER_C: "Mauvaise humeur Lavisher (Haut)",
  T_29_L_M_T_JUNGLE_GREEN: "Tortue de guerre camou (Haut)",
  T_29_L_T_TRJERSEY: "Maillot de foot rayé (Haut)",
  T_29_M_WS_ITEM22: "Conteneur robuste",
  T_29_M_WS_ITEM23: "Clôture robuste",
  T_29_M_WS_ITEM24: "Point d'apparition A",
  T_29_M_WS_ITEM25: "Point d'apparition B",
  T_29_M_WS_TYPE5: "Interactifs",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Skin d'animal : Sensei Tig de la Terre",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Skin d'animal : Sensei Tig de Feu",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Skin D'animal : Cyber Falco",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Skin d'animal de compagnie : Party Panda",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Skin d'animal : Sensei Tig de neige",
  T_29_W_TIGER_NINJA_N: "Sensei Tig",
  T_29_YF_MACHETE_MUSICFEST_N: "Parang - Thrasher à ondes sonores",
  T_29_YF_MAGEZINE_CHAIN_N: "AR Magazine",
  T_29_YF_MUZZLE_CRASH_N: "Museau SMG",
  T_29_YF_MUZZLE_WIDE_N: "Museau Shotgun",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12 - Téléportie cosmique",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi - Amber Doré",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Monster Truck - Gnawing Rager",
  T_30_AD_RP_ROUNDEND: "FIN DE TOUR",
  T_30_AD_TRAINING_SNOWBALL: "Boule de neige",
  T_30_AD_TRAINING_SNOWBALL_DES: "Faisons une bataille de boules de neige !",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] après avoir été attaqué, récupérez [FFB300]{1}HP[-]/s pour [FFB300]{2}s[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Buzzer Batteur",
  T_30_C_SKILL_NAME_MUERTOGUY: "Brume de mémoire",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Puce Jai's",
  T_30_L_A_BRMASCOT_ADULT: "Tête de poussin en colère",
  T_30_L_A_BRMASCOT_KIDS: "Tête de poussin adorable",
  T_30_L_A_SUGARSKULL21_BANDANA: "Masque de morsure de mort",
  T_30_L_B_BRFOOTBALL_BLACK: "Maillot de foot CBF - Noir (Bas)",
  T_30_L_B_BRFOOTBALL_GREEN: "Maillot de foot CBF - Vert",
  T_30_L_B_BRFOOTBALL_GREY: "Maillot de foot CBF - Gris",
  T_30_L_B_BRUNIFORM: "Petit Canari (Bas)",
  T_30_L_F_A_SUGARSKULL21: "Reine Dorée (Masque)",
  T_30_L_F_B_SUGARSKULL21: "Reine Dorée (Bas)",
  T_30_L_F_B_THASIAN: "Problème de corail (Bas)",
  T_30_L_F_H_CATEARS: "Oreilles Kawaii",
  T_30_L_F_H_SUGARSKULL21: "Reine Dorée (Tête)",
  T_30_L_F_H_THASIAN: "Problème de corail",
  T_30_L_F_S_SUGARSKULL21: "Reine Dorée (Chaussures)",
  T_30_L_F_S_THASIAN: "Problème de corail (Chaussures)",
  T_30_L_F_T_SUGARSKULL21: "Reine Dorée (Haut)",
  T_30_L_F_T_THASIAN: "Problème de corail (Haut)",
  T_30_L_H_CHILDRENSDAY_BLUE: "Tête de dauphin",
  T_30_L_H_CHILDRENSDAY_RED: "Tête d'éléphant",
  T_30_L_H_CLOWNHAT: "Chapeau de cirque- Jaune",
  T_30_L_H_ZASCARF: "Foulard en or audacieux",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Gangster Des Clans (Masque)",
  T_30_L_M_A_SUGARSKULL21: "Roi Doré (Masque)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Gangster Des Clans (Bas)",
  T_30_L_M_B_PKCRICKET: "Champ en vert (Bas)",
  T_30_L_M_B_SUGARSKULL21: "Roi Doré (Bas)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Coureur de vent (Bas)",
  T_30_L_M_B_THASIAN: "Rebelle de corail (Bas)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Gangster Des Clans (Tête)",
  T_30_L_M_H_SUGARSKULL21: "Roi Doré (Tête)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Coureur de vent (Tête)",
  T_30_L_M_H_THASIAN: "Rebelle de corail (Tête)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "gardien squelette alpha (Maquillage)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Gangster Des Clans (Chaussures)",
  T_30_L_M_S_PKCRICKET: "Champ en vert (Chaussures)",
  T_30_L_M_S_SUGARSKULL21: "Roi Doré (Chaussures)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Coureur de vent (Chaussures)",
  T_30_L_M_S_THASIAN: "Rebelle de corail (Chaussures)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Gangster Des Clans (Haut)",
  T_30_L_M_T_PKCRICKET: "Champ en vert (Haut)",
  T_30_L_M_T_SUGARSKULL21: "Roi Doré (Haut)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Coureur de vent (Haut)",
  T_30_L_M_T_THASIAN: "Rebelle de corail (Haut)",
  T_30_L_S_BRUNIFORM: "Petit Canari (Chaussures)",
  T_30_L_T_BRFOOTBALL_BLACK: "Maillot de foot CBF - Noir (Haut)",
  T_30_L_T_BRFOOTBALL_GREEN: "Maillot de foot CBF - Vert (Haut)",
  T_30_L_T_BRFOOTBALL_GREY: "Maillot de foot CBF - Gris (Haut)",
  T_30_L_T_BRUNIFORM: "Petit Canari",
  T_30_M_WS_PARTY_MODE: "Terrain de jeux",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Challenger",
  T_30_R_EMOTE_MAX_NAME: "Rap Swag",
  T_30_R_LEGEND_HALO_NAME: "Cercle de chaleur",
  T_30_T_WS_DEFAULTDESCRIPTION: "Une carte passionnante dans Free Fire Craftland",
  T_30_T_WS_ITEM26: "Pneus",
  T_30_T_WS_ITEM27: "Pneus en désordre A",
  T_30_T_WS_ITEM28: "Pneus en désordre B",
  T_30_T_WS_ITEM29: "Pneus en désordre C",
  T_30_T_WS_ITEM30: "Bumper car",
  T_30_T_WS_ITEM31: "Voiture amphibie",
  T_30_T_WS_ITEM32: "Jeep",
  T_30_T_WS_ITEM33: "Trash can",
  T_30_T_WS_ITEM34: "Ombre",
  T_30_T_WS_ITEM35: "Tente médicale",
  T_30_T_WS_ITEM36: "Garage",
  T_30_T_WS_ITEM37: "Murs Peints",
  T_30_T_WS_ITEM38: "Torii",
  T_30_T_WS_ITEM39: "Plate-forme de fer",
  T_30_T_WS_ITEM40: "Site Hut",
  T_30_T_WS_ITEM41: "Bande-annonce",
  T_30_T_WS_ITEM42: "Mur A",
  T_30_T_WS_ITEM43: "Mur B",
  T_30_T_WS_ITEM44: "Mur C",
  T_30_T_WS_ITEM45: "Mur D",
  T_30_T_WS_ITEM46: "Mur E",
  T_30_T_WS_ITEM47: "Mur F",
  T_30_U_ATTACHMENT_1: "Booster de Bouclier",
  T_30_U_ATTACHMENT_4: "Agrandisseur de gilet",
  T_30_U_ATTACHMENT_5: "Durcisseur de casque",
  T_30_U_ATTACHMENT_6: "Gilet Épaississant",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Skin D'animal: Beaston crâne",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Skin d'animal: Punk Waggor",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Skin d'animal: Bullseye Agent Hop",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Animal Skin: Carnival Agent Hop",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Skin d'animal : Cyber Agent Hop",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Skin d'animal: Nazar Robo",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Skin d'animal de compagnie : Robot Freeze vert",
  T_30_W_RABBIT_N: "Agent Hop",
  T_30_XH_PCMAP_P17: "Factory",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Gloo Wall - FÊTE DE BOOYAH ​2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Grenade - FÊTE DE BOOYAH 2021",
  T_30_YF_Healinggun_Sniper_N: "Sniper de Guérison",
  T_30_YF_MINI_LIGHTFEST_N: "AC80 - Guerrier Royal",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL - Héritier cramoisi",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR - Guerrier Royal",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- Masque Doré",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Voiture de sport - Crâne Punker",
  T_31_C_SKILL_NAME_WINTERGUY: "Fer à glace",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Batte - Basher d'hiver",
  T_31_HQ_GLOO_EAGLE_N: "Gloo Wall - Désert de chaleur",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Sniper de Guérison - Os de glace",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana - Chute des neiges",
  T_31_HQ_PAN_WINTERFEST21_N: "Poêle - Chute des neiges",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Skin D'snimal: Snow Ottero",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Skin d'animal : Waggor sur glace",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Skin D'animal: Yéti tribal",
  T_31_HQ_PETSKIN_YETI_RED_N: "Skin d'animal: Yéti fougueux",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Faux - Neige",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Moto - Fleurs de glace",
  T_31_HQ_YETI_N: "Yeti",
  T_31_KK_WINTER_BUJIX: "Caisse de ravitaillement",
  T_31_KK_WINTER_SANJITOU: "Casque",
  T_31_L_A_BDCRICKET: "Pâte de victoire (Masque)",
  T_31_L_A_WINTERFEST21: "Couverture de renne",
  T_31_L_B_BDCRICKET: "Pâte de victoire (Bas)",
  T_31_L_B_MEJERSEY_10: "Maillot Rubis n°10 (Bas)",
  T_31_L_B_MEJERSEY_11: "Maillot n°11 rouge (Bas)",
  T_31_L_B_MEJERSEY_13: "Maillot blanc n°13 (Bas)",
  T_31_L_B_MEJERSEY_18G: "Maillot Vert n°18 (Bas)",
  T_31_L_B_MEJERSEY_18R: "N°18 Marron (Bas)",
  T_31_L_B_MEJERSEY_7: "Maillot Basilic n°7 (Bas)",
  T_31_L_F_B_RUMUSICIAN: "Transe attachée (Bas)",
  T_31_L_F_B_THAGENT: "Provocateur de nuit (Bas)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Seau Tie Dye",
  T_31_L_F_H_RUMUSICIAN: "Transe attachée (Tête)",
  T_31_L_F_H_THAGENT: "Provocateur de nuit (Tête)",
  T_31_L_F_HA_RUMUSICIAN: "Transe attachée (Maquillage)",
  T_31_L_F_S_RUMUSICIAN: "Transe attachée (Chaussures)",
  T_31_L_F_S_THAGENT: "Provocateur de nuit (Chaussures)",
  T_31_L_F_T_RUMUSICIAN: "Transe attachée (Haut)",
  T_31_L_F_T_THAGENT: "Provocateur de nuit (Haut)",
  T_31_L_HA_RUMUSICIAN_MU: "Piège à sangle (Maquillage)",
  T_31_L_HA_WINTERFEST21_BLUE: "Clown des neiges Maquillage",
  T_31_L_HA_WINTERFEST21_PINK: "Maquillage Rose Firesparks",
  T_31_L_M_A_REGGAETON_B: "Néon Reggaeton (Masque)",
  T_31_L_M_A_REGGAETON_P: "Vanité vibrante (Masque)",
  T_31_L_M_A_RUMUSICIAN: "Piège à sangles (Masque)",
  T_31_L_M_A_THAGENT: "animateur de nuit (Masque)",
  T_31_L_M_B_PKCOSTUME: "Intelligent en vert (Bas)",
  T_31_L_M_B_REGGAETON_B: "Néon Reggaeton (Bas)",
  T_31_L_M_B_REGGAETON_P: "Vanité vibrante (Bas)",
  T_31_L_M_B_RUMUSICIAN: "Piège à sangles (Bas)",
  T_31_L_M_B_THAGENT: "animateur de nuit (Bas)",
  T_31_L_M_H_GREENCAP: "Casquette de vainqueur",
  T_31_L_M_H_PKCOSTUME: "Intelligent en vert (Tête)",
  T_31_L_M_H_REGGAETON_B: "Néon Reggaeton (Tête)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Chapeau Tie Dye",
  T_31_L_M_H_REGGAETON_P: "Vanité vibrante (Tête)",
  T_31_L_M_H_RUMUSICIAN: "Piège à sangles (Tête)",
  T_31_L_M_H_THAGENT: "animateur de nuit (Tête)",
  T_31_L_M_S_PKCOSTUME: "Intelligent en vert (Chaussures)",
  T_31_L_M_S_REGGAETON_B: "Néon Reggaeton (Chaussures)",
  T_31_L_M_S_REGGAETON_P: "Vanité vibrante (Chaussures)",
  T_31_L_M_S_RUMUSICIAN: "Piège à sangles (Chaussures)",
  T_31_L_M_S_THAGENT: "animateur de nuit (Chaussures)",
  T_31_L_M_T_PKCOSTUME: "Intelligent en vert (Haut)",
  T_31_L_M_T_REGGAETON_B: "Néon Reggaeton (Haut)",
  T_31_L_M_T_REGGAETON_P: "Vanité vibrante (Haut)",
  T_31_L_M_T_REGGAETON_TATOO: "Encre de Familia",
  T_31_L_M_T_RUMUSICIAN: "Piège à sangles (Haut)",
  T_31_L_M_T_THAGENT: "animateur de nuit (Haut)",
  T_31_L_S_BDCRICKET: "Pâte de victoire (Chaussures)",
  T_31_L_T_BDCRICKET: "Pâte de victoire (Haut)",
  T_31_L_T_BRBANK: "Bombardier marron",
  T_31_L_T_MEJERSEY_10: "Maillot Rubis n°10 (Haut)",
  T_31_L_T_MEJERSEY_11: "Maillot n°11 rouge (Haut)",
  T_31_L_T_MEJERSEY_13: "Maillot blanc n°13 (Haut)",
  T_31_L_T_MEJERSEY_18G: "Maillot Vert n°18 (Haut)",
  T_31_L_T_MEJERSEY_18R: "N°18 Marron (Haut)",
  T_31_L_T_MEJERSEY_7: "Maillot Basilic n°7 (Haut)",
  T_31_L_T_PKMOBILE: "T-shirt Infinix",
  T_31_L_T_REGGAETON_HOOD: "Sweat de Sourir du Gang",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "Numéro 1",
  T_31_RW_COMBINEMACHINE_2: "Akimbo activateur (Avancé)",
  T_31_RW_VIBRATION_EXPLOSION: "Explosions",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Armes Mêlée",
  T_31_RW_VIBRATION_OTHERWEAPONS: "D'autres armes",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Duo",
  T_31_T_WS_3PLAYERTEAM: "Trio",
  T_31_T_WS_4PLAYERTEAM: "Squade",
  T_31_T_WS_5PLAYERTEAM: "Contre 5",
  T_31_T_WS_6PLAYERTEAM: "Contre 6",
  T_31_T_WS_BUFFTIME_TITLE: "Temps de Rafraîchissement (s)",
  T_31_T_WS_BUFFTYPE_AMMO: "Ammo",
  T_31_T_WS_BUFFTYPE_ARMOR: "Armure",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "Aléatoire",
  T_31_T_WS_BUFFTYPE_TITLE: "Type de buff",
  T_31_T_WS_DESC48: "Vous emmène à un autre endroit, en quelques millisecondes",
  T_31_T_WS_DESC49: "Crée le son d'un piano",
  T_31_T_WS_DESC51: "Crée le son d'un tambour",
  T_31_T_WS_DESC53: "Crée le son d'un synthétiseur",
  T_31_T_WS_DESC59: "Un appareil qui génère périodiquement un buff. Ramassez-le pour obtenir une amélioration correspondante",
  T_31_T_WS_DRUMTYPE_CLAPS: "Taper",
  T_31_T_WS_DRUMTYPE_HIHATS: "Chapeau Salut",
  T_31_T_WS_DRUMTYPE_KICK: "grosse caisse",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Ouverture du charleston",
  T_31_T_WS_DRUMTYPE_RIDES: "Cymbale Ride",
  T_31_T_WS_DRUMTYPE_SNARES: "Caisse Claire",
  T_31_T_WS_EARLYSHRINK: "Rétrécissement rapide",
  T_31_T_WS_ITEM48: "Portail",
  T_31_T_WS_ITEM49: "Clé de piano",
  T_31_T_WS_ITEM51: "Clé de batterie",
  T_31_T_WS_ITEM53: "Touche combinée A",
  T_31_T_WS_ITEM55: "Touche combinée B",
  T_31_T_WS_ITEM57: "Touche combinée C",
  T_31_T_WS_ITEM59: "Générateur de buffs",
  T_31_T_WS_LATESHRINK: "Rétrécissement tardif",
  T_31_T_WS_ME_DAMAGE: "Dégâts infligés",
  T_31_T_WS_ME_DAMAGED: "Les dégâts subis",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "Proportion EP initiale",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "Rayon de la première zone de sécurité",
  T_31_T_WS_ME_EPQUICKRESTORE: "Conversion rapide EP",
  T_31_T_WS_ME_FLOW: "Mode",
  T_31_T_WS_ME_GENERALSETTING: "General",
  T_31_T_WS_ME_INRANDOMSPAWN: "Point d'apparition aléatoire",
  T_31_T_WS_ME_KILLSCORE: "Bonus de Kill",
  T_31_T_WS_ME_MAXEP: "Maximum EP",
  T_31_T_WS_ME_MAXHP: "Maximum HP",
  T_31_T_WS_ME_NEARTEAM: "Près des coéquipiers",
  T_31_T_WS_ME_REBIRTH: "Temps d'attente de réapparition",
  T_31_T_WS_ME_REBIRTHLOCATION: "Emplacement de réapparition",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Temps de rétrécissement de zone",
  T_31_T_WS_ME_WINSCORE: "Score gagnant",
  T_31_T_WS_MINIZONE: "Mini Zone",
  T_31_T_WS_MUSICTYPE_TITLE: "Type de musique",
  T_31_T_WS_UNLIMITEDAMMO: "Munitions illimitées",
  T_31_WT_WS_DESC1: "Une boîte en bois carrée qui peut être empilée",
  T_31_WT_WS_DESC10: "Une cabane délabrée avec des escaliers en bois pour monter jusqu'à",
  T_31_WT_WS_DESC11: "Construit avec plusieurs fenêtres à des fins de prise de vue",
  T_31_WT_WS_DESC12: "Fabriqué en métal et contient des portes et des fenêtres",
  T_31_WT_WS_DESC13: "Contient des portes et des fenêtres",
  T_31_WT_WS_DESC14: "Une maison à étage avec terrasse",
  T_31_WT_WS_DESC15: "Une maison à deux étages avec un toit scellé",
  T_31_WT_WS_DESC16: "Décor - une statue de sable en forme de cœur",
  T_31_WT_WS_DESC17: "Décor - une fontaine d'eau cristalline",
  T_31_WT_WS_DESC18: "Décor - un arbre de fleurs roses",
  T_31_WT_WS_DESC19: "Décor - un petit bananier sans bananes",
  T_31_WT_WS_DESC2: "Une boîte en bois rectangulaire qui peut être empilée",
  T_31_WT_WS_DESC20: "Un meuble de salle de bain blanc qui peut être placé à l'intérieur",
  T_31_WT_WS_DESC21: "Une petite clôture qui peut être utilisée pour diviser les zones",
  T_31_WT_WS_DESC22: "La planche de bois latérale de ce conteneur peut être brisée par la force",
  T_31_WT_WS_DESC23: "Une petite clôture qui peut être brisée par la force",
  T_31_WT_WS_DESC24: "Zone d'apparition pour l'équipe A (valable uniquement dans les modes Clash Squad, Team Deathmatch et Playground)",
  T_31_WT_WS_DESC25: "Zone d'apparition pour l'équipe B (valable uniquement dans les modes Clash Squad, Team Deathmatch et Playground)",
  T_31_WT_WS_DESC26: "Fait rebondir les joueurs dans la direction à laquelle ils font face, sur une courte distance",
  T_31_WT_WS_DESC27: "Fait rebondir les joueurs dans la direction prédéfinie, sur une courte distance",
  T_31_WT_WS_DESC28: "Fait rebondir les joueurs dans la direction prédéfinie, sur une distance moyenne",
  T_31_WT_WS_DESC29: "Fait rebondir les joueurs dans la direction prédéfinie, sur une longue distance",
  T_31_WT_WS_DESC3: "Orné de fleurs rouges et jaunes qui peuvent illuminer votre champ de bataille",
  T_31_WT_WS_DESC30: "Une auto tamponneuse qui peut être conduite",
  T_31_WT_WS_DESC31: "Une voiture amphibie qui peut être conduite",
  T_31_WT_WS_DESC32: "Une jeep qui peut être conduite",
  T_31_WT_WS_DESC33: "Rempli de déchets. Plus petit qu'un humain mais peut fournir une certaine couverture",
  T_31_WT_WS_DESC34: "Abri de piste de course métallique à ciel ouvert",
  T_31_WT_WS_DESC35: "Une tente de taille moyenne avec deux portes mais pas de fenêtres",
  T_31_WT_WS_DESC36: "Un grand garage construit en briques",
  T_31_WT_WS_DESC37: "Un grand mur de briques qui peut être utilisé pour diviser les zones",
  T_31_WT_WS_DESC38: "Un repère utile",
  T_31_WT_WS_DESC39: "Une grande plate-forme métallique qui peut être utilisée comme fosse de combat principale",
  T_31_WT_WS_DESC4: "Plus grand qu'un humain et peut donc servir de couverture",
  T_31_WT_WS_DESC40: "Ressemble à un véhicule récréatif et a plusieurs portes et fenêtres",
  T_31_WT_WS_DESC41: "Ressemble à un véhicule récréatif et a une porte et plusieurs fenêtres",
  T_31_WT_WS_DESC42: "Un mur unilatéral avec une entrée",
  T_31_WT_WS_DESC43: "Un mur unilatéral régulier",
  T_31_WT_WS_DESC44: "Un coin de mur",
  T_31_WT_WS_DESC45: "Un coin de mur irrégulier",
  T_31_WT_WS_DESC46: "Un coin de mur irrégulier",
  T_31_WT_WS_DESC47: "Un coin de mur avec des fenêtres",
  T_31_WT_WS_DESC5: "Une voiture abandonnée qui est légèrement plus courte qu'un humain mais peut fournir une certaine couverture",
  T_31_WT_WS_DESC6: "Plus grand qu'un humain et peut donc servir de couverture",
  T_31_WT_WS_DESC7: "Ouvert aux deux extrémités et peut être agencé pour former des chemins ou pour diviser des zones",
  T_31_WT_WS_DESC8: "Ouvert à une extrémité et peut être utilisé pour diviser les zones",
  T_31_WT_WS_DESC9: "Scellé aux deux extrémités et peut être utilisé pour diviser des zones",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Véhicule",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "Se précipite vers l'avant à une vitesse rapide pendant [FFB300]{0}s[-]. Cette compétence peut être accumulée jusqu'à [FFB300]{2} utilisations[-], avec un temps de recharge de {3}-secondes entre chaque utilisation. Temps de réapprovisionnement du Dash: [FFB300]{1}s[-].",
  T_32_C_SKILL_NAME_YAKUZA: "Ruée rebelle",
  T_32_HQ_AUG_VNSTREET_N: "AUG - Combattant Rugissant",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Sac à dos - Dawnlit Drago",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B - Vampire de Malveillance",
  T_32_HQ_GLOO_DUNHUANG_N: "Gloo Wall - Platine congelé",
  T_32_HQ_GLOO_HURRICANE_2_N: "Gloo Wall - Aurora Core",
  T_32_HQ_GRENADE_HURRICANE_N: "Grenade - Brassy Mic",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 - Platine congelé",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Skin D'animal : Bonnet rouge",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Skin d'animal: Cyber Flash",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Skin d'animal: Flash de joueur",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Skin D'animal: Flash festif",
  T_32_HQ_TORTOISE_N: "Flash",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Voiture de Sport - Poussière Enfouie",
  T_32_L_F_A_PHARAOH: "Cléo dorée (Masque)",
  T_32_L_F_B_PHARAOH: "Cléo dorée (Bas)",
  T_32_L_F_H_PHARAOH: "Cléo dorée (Tête)",
  T_32_L_F_HA_PHARAOH: "Cléo dorée (Maquillage)",
  T_32_L_F_S_PHARAOH: "Cléo dorée (Chaussures)",
  T_32_L_F_T_PHARAOH: "Cléo dorée (Haut)",
  T_32_L_M_A_JUNKFOOD: "Garçon du Hamburger (Masque)",
  T_32_L_M_A_PHARAOH: "Momie dorée (Masque)",
  T_32_L_M_B_JUNKFOOD: "Garçon du Hamburger (Bas)",
  T_32_L_M_B_PHARAOH: "Momie dorée (Bas)",
  T_32_L_M_H_JUNKFOOD: "Garçon du Hamburger (Tête)",
  T_32_L_M_H_PHARAOH: "Momie dorée (Tête)",
  T_32_L_M_S_JUNKFOOD: "Garçon du Hamburger (Chaussures)",
  T_32_L_M_S_PHARAOH: "Momie dorée (Chaussures)",
  T_32_L_M_T_JUNKFOOD: "Garçon du Hamburger (Haut)",
  T_32_L_M_T_PHARAOH: "Momie dorée (Haut)",
  T_32_L_T_WHITESWEATER: "Col Roulé Blanc",
  T_32_LC_NEWVAULT_EMOTE: "Emote",
  T_32_LO_WS_IMMORTAL: "Zone Immortelle",
  T_32_LO_WS_ITEM60: "Tuyau",
  T_32_LO_WS_ITEM60_DESC: "Un tunnel praticable",
  T_32_LO_WS_ITEM61: "Tuyau T",
  T_32_LO_WS_ITEM61_DESC: "Un tunnel en T praticable",
  T_32_LO_WS_ITEM62: "Intersection de tuyaux",
  T_32_LO_WS_ITEM62_DESC: "Un tunnel d'intersection praticable",
  T_32_LO_WS_ITEM63: "Coin de tuyau",
  T_32_LO_WS_ITEM63_DESC: "Un tunnel en angle praticable",
  T_32_LO_WS_ITEM64: "Camion de nourriture",
  T_32_LO_WS_ITEM64_DESC: "Arrêtez-vous ici pour prendre une bouchée",
  T_32_LO_WS_ITEM65: "Ombre bouillie",
  T_32_LO_WS_ITEM65_DESC: "Un gros champignon qui peut transporter un humain",
  T_32_LO_WS_ITEM66: "Cintre",
  T_32_LO_WS_ITEM66_DESC: "Fréquemment vu dans les zones résidentielles",
  T_32_LO_WS_ITEM67: "Une planche de bois",
  T_32_LO_WS_ITEM67_DESC: "Utiliser pour faire un pont en bois simple",
  T_32_LO_WS_ITEM68: "Écran en treillis",
  T_32_LO_WS_ITEM68_DESC: "Une ambiance orientale",
  T_32_LO_WS_ITEM69: "Pilier",
  T_32_LO_WS_ITEM69_DESC: "Souvent vu sur les chantiers de construction",
  T_32_LO_WS_ITEM70: "Cactus",
  T_32_LO_WS_ITEM70_DESC: "Puissant gros mais ne pique pas",
  T_32_LO_WS_ITEM71: "Arbre sans feuilles",
  T_32_LO_WS_ITEM71_DESC: "Un arbre qui a vécu pendant des siècles",
  T_32_LO_WS_ITEM72: "Lanterne en pierre",
  T_32_LO_WS_ITEM72_DESC: "Décoration pittoresque dans les jardins impériaux",
  T_32_LO_WS_ITEM73: "Réverbère",
  T_32_LO_WS_ITEM73_DESC: "Souvent vu dans les rues",
  T_32_LO_WS_ITEM74: "Panneau solaire",
  T_32_LO_WS_ITEM74_DESC: "Absorbe l'énergie de la lumière du soleil",
  T_32_LO_WS_ITEM75: "Climatiseur A",
  T_32_LO_WS_ITEM75_DESC: "Restez au frais dans la chaleur",
  T_32_LO_WS_ITEM76: "Ventilateur",
  T_32_LO_WS_ITEM77: "Poêle volant",
  T_32_LO_WS_ITEM78: "Cube",
  T_32_LO_WS_ITEM79: "Bague",
  T_32_LO_WS_ITEM80: "Marteau",
  T_32_LO_WS_ITEM81: "Conseil",
  T_32_LO_WS_ITEM82: "Cible de tir",
  T_32_LO_WS_ITEM83: "Mur flexible",
  T_32_LO_WS_ITEM84AMMO: "Point de butin de munitions",
  T_32_LO_WS_ITEM84AMMO_DESC: "Une fois placés, les types de munitions sélectionnés apparaîtront là-bas",
  T_32_LO_WS_ITEM84AR: "Point de butin d'armure",
  T_32_LO_WS_ITEM84AR_DESC: "Une fois placés, les types d'armure sélectionnés apparaîtront là-bas",
  T_32_LO_WS_ITEM84ARLV1: "Armure Niv. 1",
  T_32_LO_WS_ITEM84ARLV2: "Armure Niv. 2",
  T_32_LO_WS_ITEM84ARLV3: "Armure Niv. 3",
  T_32_LO_WS_ITEM84CO: "Point de butin de consommables",
  T_32_LO_WS_ITEM84CO_DESC: "Une fois placés, les types de consommables sélectionnés y apparaîtront",
  T_32_LO_WS_ITEM84JA: "Point de butin à jeter",
  T_32_LO_WS_ITEM84JA_DESC: "Une fois placés, les types de jets sélectionnés apparaîtront là",
  T_32_LO_WS_ITEM84TE: "Point de butin de lunette",
  T_32_LO_WS_ITEM84TE_DESC: "Lorsqu'ils sont placés, les types de portée sélectionnés y apparaîtront",
  T_32_LO_WS_ITEM84W: "Point de butin d'arme",
  T_32_LO_WS_ITEM84W_DESC: "Une fois placés, les types d'armes sélectionnés apparaîtront là",
  T_32_LO_WS_ITEM85: "Zone Funeste/Immortelle",
  T_32_LO_WS_ITEM85_DESC: "Une fois placés, les joueurs qui entrent dans la zone de déclenchement subiront un effet spécifié d'immortalité ou de malheur. (Non valable dans les modes Clash Squad, Team Deathmatch et Playground)",
  T_32_LO_WS_ITEM85CP: "Point de contrôle",
  T_32_LO_WS_ITEM85CP_DESC: "Un élément utilisé pour construire le gameplay en mode Parkour. Pour que le point de contrôle final apparaisse, les joueurs doivent passer par chaque point de contrôle un par un. Lorsqu'il est éliminé et réapparu, le joueur peut choisir de réapparaître au dernier point de contrôle qu'il a passé. (Non valable dans les modes Clash Squad, Team Deathmatch et Playground)",
  T_32_LO_WS_ITEM85TM: "Point d'arrivée",
  T_32_LO_WS_ITEM85TM_DESC: "Un élément utilisé pour construire le gameplay en mode Parkour. Les joueurs doivent arriver à l'intérieur de la ligne d'arrivée pour que le but soit complété. (Non valable dans les modes Clash Squad, Team Deathmatch et Playground)",
  T_32_LO_WS_ITEM86: "Point d'apparition",
  T_32_LO_WS_ITEM86_DESC: "Aucune équipe spécifique ne sera affectée à ce point. Une fois placée, une équipe aléatoire apparaîtra ici. (Non valable dans les modes Clash Squad, Team Deathmatch et Playground)",
  T_32_LO_WS_ITEM86L: "Grand point d'apparition",
  T_32_LO_WS_ITEM86L_DESC: "Un grand point d'apparition recommandé pour le mode Parkour, où tous les joueurs apparaîtront à la suite. (Non valable dans les modes Clash Squad, Team Deathmatch et Playground)",
  T_32_LO_WS_ITEM87: "Bloquer",
  T_32_LO_WS_ITEM87_DESC: "Permet la personnalisation de la taille",
  T_32_LO_WS_ITEM88: "Cuboïde et Pente",
  T_32_LO_WS_ITEM88_DESC: "Un cuboïde ou une pente dont la taille peut être ajustée",
  T_32_LO_WS_ITEMLINE: "Changement",
  T_32_LO_WS_ITEMMOVE: "Paramètres de déclenchement",
  T_32_LO_WS_ITEMROT: "Transformer",
  T_32_LO_WS_ITEMSCALE: "Échelle",
  T_32_LO_WS_KILLZONE: "Zone maudite",
  T_32_LO_WS_LOOT_AMMOTYPE: "Ammo",
  T_32_LO_WS_LOOT_ARTYPE: "Armure",
  T_32_LO_WS_LOOT_COTYPE: "Consommable",
  T_32_LO_WS_LOOT_JATYPE: "Jetable",
  T_32_LO_WS_LOOT_RANDOM: "Aléatoire",
  T_32_LO_WS_LOOT_TETYPE: "Portée",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Arme",
  T_32_LO_WS_SCALEX: "Longueur",
  T_32_LO_WS_SCALEY: "Hauteur",
  T_32_LO_WS_SCALEZ: "Largeur",
  T_32_LO_WS_TRIGGERH: "Cacher",
  T_32_LO_WS_TRIGGERHORP: "Afficher/Masquer les déclencheurs",
  T_32_LO_WS_TRIGGERP: "Montrer",
  T_32_LO_WS_TRIGGERTYPE: "Type de déclencheur",
  T_32_M_WS_MODE_ANNIHILATE: "Éliminer Tous",
  T_32_M_WS_MODE_SCORE: "Points à saisir",
  T_32_M_WS_MODE_SPEED: "Parkour",
  T_32_M_WS_MULTIPLETEAMS: "Combat multi-équipes",
  T_32_M_WS_ROUNDS: "Les manches",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Étapes de commutation",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Danger Zone",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Dégât",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Danger Zone",
  T_32_T_WS_ME_CUSTOM: "Personnaliser",
  T_32_T_WS_ME_ENDTYPE1: "Éliminer Tous",
  T_32_T_WS_ME_ENDTYPE2: "Points à saisir",
  T_32_T_WS_ME_ENDTYPE3: "Parkour",
  T_32_T_WS_ME_ENDTYPEDESC1: "Soyez la dernière équipe à survivre",
  T_32_T_WS_ME_ENDTYPEDESC2: `Un mode basé sur les points où la première équipe à atteindre le score cible gagne.
Vous pouvez définir les règles du jeu et modifier les paramètres du jeu comme vous le souhaitez, y compris le score attribué pour les éliminations.`,
  T_32_T_WS_ME_ENDTYPEDESC3: "Un mode parkour dans lequel la première équipe dont tous les membres atteignent le point d'arrivée gagne. Vous pouvez définir les règles du jeu et les objets des chemins et de la ligne d'arrivée comme vous le souhaitez.",
  T_32_T_WS_ME_MATCHTIME: "Temps de match",
  T_32_T_WS_ME_MECHANIC: "Mécanisme",
  T_32_T_WS_ME_NEARCHECKPOINT: "Près du point de contrôle",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "Impossible d'avoir plus de 12 joueurs au total",
  T_32_T_WS_ME_PREGAMETIME: "Temps de préparation",
  T_32_T_WS_ME_RESPAWN: "Réapparitions",
  T_32_T_WS_ME_RESPAWNSETTING: "Réapparitions",
  T_32_T_WS_ME_ROUNDNUM: "Nombre de tours",
  T_32_T_WS_ME_ROUNDOPEN: "Activer plusieurs tours",
  T_32_T_WS_ME_ROUNDRESET: "Réinitialisations rondes",
  T_32_T_WS_ME_ROUNDSETTING: "Tours",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Durée de rétrécissement de zone",
  T_32_T_WS_ME_SCORESETTING: "Score",
  T_32_T_WS_ME_TEAMMATENUM: "Members per team",
  T_32_T_WS_ME_TEAMNUM: "Nombre d'équipes",
  T_32_T_WS_ME_TEAMSETTING: "Équipe",
  T_32_U_ATTACHMENT_8: "Pochette de sac",
  "T_32_U_GOLD_FAMAS-I": "Famas-I",
  "T_32_U_GOLD_FAMAS-II": "Famas-II",
  "T_32_U_GOLD_FAMAS-III": "Famas-II",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Puce de mise à niveau",
  T_32_WT_WS_BARRIER: "Barrières",
  T_32_WT_WS_BDS: "Bâtiments",
  T_32_WT_WS_MMINVALIDERROR: "Code de carte invalide",
  T_32_WT_WS_TRGS: "Déclencheurs",
  T_32_YF_CHARGESHOT_N: "Chargeur Puissant",
  T_32_YF_GOLD_GROZA_N: "Groza - X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "Dégâts supplémentaires",
  T_32_YS_WEAPON_TAG_3: "Cadence de tir",
  T_32_YS_WEAPON_TAG_36: "Perforant",
  T_32_YS_WEAPON_TAG_39: "Prend en charge Akimbo",
  T_32_YS_WEAPON_TAG_42: "Mur de glace",
  T_33_C_SKILL_DESC_GRAFFITIST: "Crée une zone [FFB300]{0}m[-], où les éléments jetables ne sont pas valides. Les alliés dans la zone restaureront [FFB300]{1}%[-] de durabilité d'armure toutes les secondes et les dégâts des munitions seront réduits de [FFB300]{2}%[-]. Dure [FFB300]{3}s[-]. Les effets ne se cumulent pas. Temps de recharge : [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_HITMAN: "Lorsque vous utilisez des tireurs d'élite et des fusils de tireur d'élite, le son des tirs est réduit au silence et les ennemis renversés par l'utilisateur saignent [FFB300]{0}%[-] plus rapidement.",
  T_33_C_SKILL_DESC_KENTA: "Forme un bouclier de [FFB300]{0}m[-] de large qui réduit [FFB300]{1}%[-] les dégâts de l'arme venant de l'avant. Lors du tir, la réduction des dégâts est réduite à [FFB300]{2}%[-]. Dure [FFB300]{3}s[-]. Temps de recharge : [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_MADEMANA: "Libère une onde électromagnétique d'un diamètre de [FFB300]{0}m[-] qui désactive l'activation des compétences des ennemis, inflige [FFB300]{3} DMG[-] et interrompt le compte à rebours de leur interaction. Dure [FFB300]{1}s[-]. Temps de recharge : [FFB300]{2}s[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "Spécialiste des armes à feu",
  T_33_C_SKILL_NAME_KENTA: "Courroux de l'épéiste",
  T_33_C_SKILL_NAME_MADEMANA: "Frisson de la bataille",
  T_33_DY_AXOLOTL_N: "Zasil",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Skin d'animal: Zasil fruité",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Skin d'animal: Bonnet FFWS",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Skin d'animal: Falco en fleurs",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Batte - Baguette mortelle",
  T_33_HQ_EMOTE_SONGKRAN_N: "Venez danser",
  T_33_HQ_G18_CYBERTHIEF_N: "G18 - Hyper noyau Blues",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "Grenade - Hyper noyau Blues",
  T_33_HQ_M14_SPIDERLILY_N: "M14 - Lys brûlant",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7 - Voleur d'ombre",
  T_33_HQ_MP40_FFWS03_N: "MP40 - Guerrier du Havre",
  T_33_HQ_SCAR_FFWS03_N: "SCAR - Guerrier du Havre",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Faux - énergie d'émeraude",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Dague - Guerrier du Havre",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector - Hyper noyau Blues",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Jeep - Émeraude scintillante",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Monster Truck - Brise-Os de feu",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Pickup - Gardien du Havre",
  T_33_LO_WS_BHPARA_A: "Active",
  T_33_LO_WS_BHPARA_ATKMODE: "Type d'attaque",
  T_33_LO_WS_BHPARA_GROUP: "Équipe",
  T_33_LO_WS_BHPARA_NA: "Pas d'Attaque",
  T_33_LO_WS_BHPARA_P: "Passif",
  T_33_LO_WS_DICE_DESC: "Un dé qui améliore vos sauts et peut être utilisé dans divers gameplay",
  T_33_LO_WS_DICEVXZ: "Vitesse horizontale",
  T_33_LO_WS_DICEVY: "Vitesse verticale",
  T_33_LO_WS_DTOWER: "La tour",
  T_33_LO_WS_DTOWER_DESC: "Attaque automatiquement les ennemis qui se trouvent à une certaine distance de la structure défensive. Désactivé si ses HP atteignent zéro.",
  T_33_LO_WS_FORT: "Forteresse",
  T_33_LO_WS_FORT_DESC: "Attaque automatiquement les ennemis qui se trouvent à une certaine distance de la structure critique. Désactivé si ses HP atteignent zéro.",
  T_33_LO_WS_ITEM89: "Réservoir de raffinerie",
  T_33_LO_WS_ITEM89_DESC: "Une structure de stockage d'eau",
  T_33_LO_WS_ITEM90: "Niche à chien",
  T_33_LO_WS_ITEM90_DESC: "Une maison pour chiots",
  T_33_LO_WS_ITEM91: "Arrêt de bus",
  T_33_LO_WS_ITEM91_DESC: "Un arrêt de bus commun",
  T_33_LO_WS_ITEM92: "Mur de graffitis",
  T_33_LO_WS_ITEM92_DESC: "Un puits orné de peinture en aérosol",
  T_33_LO_WS_ITEM93: "Stable",
  T_33_LO_WS_ITEM93_DESC: "Structure de base en foin",
  T_33_LO_WS_ITEM94: "Banc",
  T_33_LO_WS_ITEM94_DESC: "Un banc de parc",
  T_33_LO_WS_ITEM95: "Pont de pierre",
  T_33_LO_WS_ITEM95_DESC: "Un pont construit avec des pierres",
  T_33_LO_WS_ITEM96: "Pare-soleil",
  T_33_LO_WS_ITEM96_DESC: "Prévenir les coups de soleil sous le parasol",
  T_33_LO_WS_ITEM97: "Arche de la ligne d'arrivée",
  T_33_LO_WS_ITEM97_DESC: "Indiquez la ligne d'arrivée",
  T_33_LO_WS_ITEM98: "Tableau Ad",
  T_33_LO_WS_ITEM98_DESC: "Une bannière régulière pour les annonces",
  T_33_LO_WS_PARA_DM: "Dégâts",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "Distance de balayage de l'ennemi",
  T_33_LO_WS_PARA_SP: "Vitesse",
  T_33_LO_WS_ZBPARA_AMOUNT: "Zombies par vague",
  T_33_LO_WS_ZBPARA_INTERVAL: "Intervalle de vague (s)",
  T_33_LO_WS_ZBPARA_ROUND: "# de vagues",
  T_33_LO_WS_ZBSPAWNER: "Apparition de zombies",
  T_33_LO_WS_ZBSPAWNER_DESC: "Génère automatiquement des zombies, dont le comportement peut être configuré",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "Niveau supérieur",
  T_33_RW_SKILL_DESC_GANGGIRL: "Augmente la cadence de [FFB300]{0}%[-]. Lorsque vous touchez l'ennemi, un maximum de [FFB300]{1}%[-] de cadence de tir est converti en vitesse de déplacement et la conversion se réinitialise quand vous survivez encore.",
  T_33_RW_SKILL_NAME_GANGGIRL: "Se battre ou s'enfuire",
  T_33_WT_WS_BASICSET1: "Basique",
  T_33_WT_WS_QCEPRTIP: "Convertir EP en HP plus rapidement",
  T_33_WT_WS_SKILLSET_TAG: "Compétence illimitée",
  T_33_WT_WS_SKILLSET1: "Paramètres des compétences",
  T_33_WT_WS_SKILLSET10: "Retourneur de temps (Chrono)",
  T_33_WT_WS_SKILLSET11: "Rythme Riptide (Skyler)",
  T_33_WT_WS_SKILLSET12: "Rencontre Xtreme (Zinah)",
  T_33_WT_WS_SKILLSET13: "Battement de coeur de guérison (Dimitri)",
  T_33_WT_WS_SKILLSET2: "Compétences passives",
  T_33_WT_WS_SKILLSET2_TIP: "Activer/désactiver les compétences passives",
  T_33_WT_WS_SKILLSET3: "Compétences actives (activer pour ajuster le temps de recharge ci-dessous)",
  T_33_WT_WS_SKILLSET3_TIP: "Activer/désactiver les compétences actives. Si activé, le temps de recharge peut être configuré ci-dessous.",
  T_33_WT_WS_SKILLSET4: "Camouflage (Wukong)",
  T_33_WT_WS_SKILLSET5: "Frisson de la bataille (A124)",
  T_33_WT_WS_SKILLSET6: "Laissez tomber le rythme (Alok)",
  T_33_WT_WS_SKILLSET7: "Refuge peint (Steffie)",
  T_33_WT_WS_SKILLSET8: "Étapes de suivi (Clu)",
  T_33_WT_WS_SKILLSET9: "Maître de tout (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/s",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "sec",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Poupée de pluie (Bas)",
  T_33_YS_H_ONIGIRI: "Onigiri Hood",
  T_33_YS_H_RAINCOAT: "Poupée de pluie (Tête)",
  T_33_YS_HA_CRYINGFACE: "Émote du Pleurer (Maquillage)",
  T_33_YS_M_H_FROGKING: "Casquette Roi Grenouille",
  T_33_YS_S_RAINCOAT: "Poupée de pluie (Chaussures)",
  T_33_YS_T_BLACKHOLE: "Le sweat à capuche Doppler Shift",
  T_33_YS_T_RAINCOAT: "Poupée de pluie (Haut)",
  T_33_YS_T_SOCCER_GREEN: "Coup électrifié",
  T_33_YS_T_SOCCER_YELLOW: "Coup énergique",
  T_33_YS_T_WIFI: "T-shirt Net et Next",
  T_34_C_SKILL_DESC_STREAMERGUY: "Chaque élimination ou spectateur accorde une pile de l'effet. Chaque pile réduit les dégâts de tir à la tête reçus de [FFB300]{0}%[-] (max. [FFB300]{1}%[-] au total) et augmente les dégâts de tir à la tête infligés aux ennemis de [FFB300]{2}%[-] (max. [FFB300]{3}%[-] au total).",
  T_34_C_SKILL_DESC_TRACKER: "Lâche un drone vers l'ennemi le plus proche à une distance frontale de [FFB300]100 m[-], créant une explosion pulsée de [FFB300]{5}m de diamètre[-] qui réduit la vitesse de déplacement de [FFB300]{0} %[-] et la vitesse de tir de [FFB300]{1} %[-]. Dure pendant [FFB300]{3}s[-]. provoque [FFB300]{2} DMG[-]. Temps de recharge : [FFB300]{4}s[-].",
  T_34_C_SKILL_NAME_TRACKER: "Onde de choc des sens",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Skin d'animal Finn Surfeur en colère",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Skin d'animal Finn Océan profond",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Skin d'animal Finn Orage",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Skin d'animal: Tig Digital",
  T_34_DY_SURFSHARK_N: "Finn",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Grand chef d'orchestre",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Énergique",
  T_34_HQ_EMOTE_RIDICULE_N: "Ridicule",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Pickup - Ingénieur maléfique",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuk Tuk - Chiot husky",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle - Explosion Hybride",
  T_34_JL_G36_MADBIONIC_N: "G36 - Évasement Bionique",
  T_34_JL_GRENADE_BIS_N: "Grenade - Pixel soldat",
  T_34_JL_MACHETE_RAMPAGE4_N: "Parang - Lame de nuit",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Dague - Banane",
  T_34_JL_UMP45_BIS_N: "UMP - Dasher numérique",
  T_34_LY_WS_ABS_DESC: "Obtenir la valeur absolue de ce nombre",
  T_34_LY_WS_ADD_DESC: "Ajouter un nouvel élément à la fin d'une liste",
  T_34_LY_WS_AUTO_A: "Analyse automatique des ennemis",
  T_34_LY_WS_BOT: "Ordinaire",
  T_34_LY_WS_BOT_PATH: "Chemin",
  T_34_LY_WS_BOT_TYPE: "Type",
  T_34_LY_WS_BOT4: "Axe",
  T_34_LY_WS_BOT5: "Lancer",
  T_34_LY_WS_BOT6: "Auto-explosion",
  T_34_LY_WS_BOT8: "Blindé",
  T_34_LY_WS_COL_DESC: "Sélectionnez une couleur",
  T_34_LY_WS_DEL_DESC: "Supprimer l'élément correspondant d'un index désigné dans une liste",
  T_34_LY_WS_DF_PER: "La défense %",
  T_34_LY_WS_FORT_INTERVAL: "Temps d'intervalle d'attaque (s)",
  T_34_LY_WS_GET: "Obtenir",
  T_34_LY_WS_GET_DESC: "Obtenir l'élément correspondant d'un index désigné dans une liste",
  T_34_LY_WS_GLEN_ARR_DESC: "Obtenir le nombre d'éléments dans la liste courante",
  T_34_LY_WS_GLEN_DESC: "Obtenir la longueur de cette chaîne de texte",
  T_34_LY_WS_GVX: "Obtenir la composante vectorielle x",
  T_34_LY_WS_GVX_DESC: "Obtenir la première composante d'un vecteur",
  T_34_LY_WS_GVY: "Obtenir la composante vectorielle y",
  T_34_LY_WS_GVY_DESC: "Obtenir la deuxième composante d'un vecteur",
  T_34_LY_WS_GVZ: "Obtenir la composante vectorielle z",
  T_34_LY_WS_GVZ_DESC: "Obtenir la troisième composante d'un vecteur",
  T_34_LY_WS_INDEX: "Index",
  T_34_LY_WS_JOIN: "Relier",
  T_34_LY_WS_NEG_DESC: "Obtenir la valeur négative de ce nombre",
  T_34_LY_WS_PATH: "Traceur de chemin",
  T_34_LY_WS_PATH_DESC: "Utiliser pour désigner le chemin de déplacement d'objets vivants spéciaux",
  T_34_LY_WS_POINT: "Marqueur",
  T_34_LY_WS_POINT_DESC: "Utiliser pour marquer l'emplacement de la position actuelle",
  T_34_LY_WS_RANGE_F: "Loin",
  T_34_LY_WS_RANGE_M: "Moyen",
  T_34_LY_WS_RANGE_N: "Près",
  T_34_LY_WS_RNDF_DESC: "Générer un nombre décimal aléatoire à partir d'un intervalle",
  T_34_LY_WS_RNDI_DESC: "Générer un entier aléatoire à partir d'un intervalle",
  T_34_LY_WS_SET: "Modier",
  T_34_LY_WS_SET_DESC: "Définir l'élément correspondant d'un index désigné dans une liste",
  T_34_LY_WS_SQRT_DESC: "Obtenir la racine carrée de ce nombre",
  T_34_LY_WS_STRC_DESC: "Connectez deux chaînes de textes",
  T_34_LY_WS_SVX: "Définir x composant vectoriel",
  T_34_LY_WS_SVX_DESC: "Définir la première composante d'un vecteur",
  T_34_LY_WS_SVY: "Définir la composante vectorielle y",
  T_34_LY_WS_SVY_DESC: "Définir la deuxième composante d'un vecteur",
  T_34_LY_WS_SVZ: "Définir la composante vectorielle z",
  T_34_LY_WS_SVZ_DESC: "Définir la troisième composante d'un vecteur",
  T_34_LY_WS_VADD: "Ajout de vecteur",
  T_34_LY_WS_VADD_DESC: "Ajouter deux vecteurs",
  T_34_LY_WS_VAL_DESC: "Saisir un entier ou un décimal selon le scénario",
  T_34_LY_WS_VANG_DESC: "Calculer l'angle entre deux vecteurs",
  T_34_LY_WS_VCP: "Produit croisé",
  T_34_LY_WS_VCP_DESC: "Calculer le produit vectoriel de deux vecteurs",
  T_34_LY_WS_VDIS_DESC: "Calculer la distance entre deux vecteurs",
  T_34_LY_WS_VDP: "Produit scalaire",
  T_34_LY_WS_VDP_DESC: "Calculer le produit scalaire de deux vecteurs",
  T_34_LY_WS_VFX1: "Sphérique",
  T_34_LY_WS_VFX2: "Cylindrique",
  T_34_LY_WS_VFX3: "Anneau",
  T_34_LY_WS_VFX4: "Boom",
  T_34_LY_WS_VFX5: "Pixels",
  T_34_LY_WS_VFX6: "Étincelles",
  T_34_LY_WS_VMOD_DESC: "Calculer la magnitude d'un vecteur",
  T_34_LY_WS_VMUL: "Multiplication vectorielle",
  T_34_LY_WS_VMUL_DESC: "Multiplier deux vecteurs",
  T_34_LY_WS_VNOR_DESC: "Normaliser un vecteur",
  T_34_LY_WS_VSUB: "Soustraction vectorielle",
  T_34_LY_WS_VSUB_DESC: "Soustraire deux vecteurs",
  T_34_M_WS_ANGLE: "Angle de rotation",
  T_34_M_WS_ARRAY: "Liste",
  T_34_M_WS_ATT: "Propriété",
  T_34_M_WS_BOOL: "Booléen",
  T_34_M_WS_COLORARRAY: "Gamme de couleurs",
  T_34_M_WS_COLOUR: "Couleur",
  T_34_M_WS_CONFRONBANNER: "Bannière de bataille",
  T_34_M_WS_COORDINATE: "Coordonnés",
  T_34_M_WS_CUSTOMINF: "Interface personnalisée",
  T_34_M_WS_CUSTOMMODEDESC: `Un mode vide et entièrement personnalisable, sans jeu prédéfini, où vous pouvez créer et jouer selon vos propres règles.
Un peu compliqué pour les créateurs de cartes débutants.`,
  T_34_M_WS_DAMAGETYPE: "Type de Dégâts",
  T_34_M_WS_DAMAGETYPEDESC: "Le type de dégâts actuellement défini par le système",
  T_34_M_WS_DESCTEXT: "Texte descriptif",
  T_34_M_WS_DURACTION: "Durée",
  T_34_M_WS_ECAMODE: "Personnaliser le mode",
  T_34_M_WS_ENDPHASEDESC: "Terminer immédiatement l'étape en cours et passer à la suivante",
  T_34_M_WS_ENTITY: "Entité",
  T_34_M_WS_FLOAT: "Décimal",
  T_34_M_WS_GAME: "Jeu",
  T_34_M_WS_GAMERESULTS: "Résultat du match",
  T_34_M_WS_GETCONTROL2: "Obtenez une entité de contrôle à partir de l'interface des joueurs pour modifier les propriétés de l'entité (y compris la conception, la couleur, le contenu, etc.)",
  T_34_M_WS_HEIGHT: "Hauteur",
  T_34_M_WS_HUDBUTTONWIDGET: "Bouton de contrôle",
  T_34_M_WS_HUDEMPTYWIDGET: "Pivot vide",
  T_34_M_WS_HUDIMAGEWIDGET: "Contrôle des images",
  T_34_M_WS_HUDINPUTWIDGET: "Contrôle de zone de texte",
  T_34_M_WS_HUDLABELWIDGET: "Contrôle du texte",
  T_34_M_WS_ICON: "Icône",
  T_34_M_WS_ICON_AIM: "Objectif",
  T_34_M_WS_ICON_ARROW: "Flèche",
  T_34_M_WS_ICON_BLAST: "Explosion",
  T_34_M_WS_ICON_CIRCULAR: "Circle",
  T_34_M_WS_ICON_CLOTH: "Palmier",
  T_34_M_WS_ICON_COLLIMATION: "Réticule",
  T_34_M_WS_ICON_CORPSE: "Zombie",
  T_34_M_WS_ICON_CROSS: "Croix",
  T_34_M_WS_ICON_DAY: "Soleil",
  T_34_M_WS_ICON_DEFENSE: "Bouclier",
  T_34_M_WS_ICON_DIALOGUE: "Dialogue",
  T_34_M_WS_ICON_DIAMONDS: "diamant",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Point d'exclamation",
  T_34_M_WS_ICON_FLAG: "Drapeau",
  T_34_M_WS_ICON_FOLDER: "Dossier",
  T_34_M_WS_ICON_GLASSES: "Œil",
  T_34_M_WS_ICON_GUN: "Arme",
  T_34_M_WS_ICON_HEART: "Cœur",
  T_34_M_WS_ICON_HEXAGON: "Hexagone",
  T_34_M_WS_ICON_HOURGLASS: "Sablier",
  T_34_M_WS_ICON_HOUSE: "Maison",
  T_34_M_WS_ICON_KEY: "Clé",
  T_34_M_WS_ICON_LIGHTNING: "Éclair",
  T_34_M_WS_ICON_LOCK: "Fermer à clé",
  T_34_M_WS_ICON_LOOP: "Boucle",
  T_34_M_WS_ICON_MAGNIFIER: "Loupe",
  T_34_M_WS_ICON_MONEY: "Argent",
  T_34_M_WS_ICON_MONTH: "Lune",
  T_34_M_WS_ICON_OPENFOLDER: "Dossier ouvert",
  T_34_M_WS_ICON_PLUS: "Plus",
  T_34_M_WS_ICON_QUADRI: "Quadrilatère",
  T_34_M_WS_ICON_QUESTIONMARK: "Point d'interrogation",
  T_34_M_WS_ICON_RECYCLING: "Recycler",
  T_34_M_WS_ICON_REFRESH: "Rafraîchir",
  T_34_M_WS_ICON_REST: "Repos",
  T_34_M_WS_ICON_RETURN: "Arrière",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Trapèze droit",
  T_34_M_WS_ICON_SCISSORS: "Ciseaux",
  T_34_M_WS_ICON_SETUP: "Paramètre",
  T_34_M_WS_ICON_SIGN: "Marquer",
  T_34_M_WS_ICON_SIGNOUT: "Quitter",
  T_34_M_WS_ICON_SQUARE: "Carré",
  T_34_M_WS_ICON_STAR: "Étoile",
  T_34_M_WS_ICON_STONE: "Calcul",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Anneau de natation",
  T_34_M_WS_ICON_TAGGING: "Epingle",
  T_34_M_WS_ICON_THESWORD: "Épée",
  T_34_M_WS_ICON_TRAPEZOID: "Trapèze",
  T_34_M_WS_ICON_TRASHCAN: "Poubelle",
  T_34_M_WS_ICON_TRIANGLE: "Triangle",
  T_34_M_WS_ICON_TROPHY: "Trophée",
  T_34_M_WS_ICON_UP: "Pouces vers le haut",
  T_34_M_WS_ICON_WRONG: "Mauvais",
  T_34_M_WS_ICON_YES: "Droite",
  T_34_M_WS_ICONNAME: "Nom de l'icône",
  T_34_M_WS_INT: "Entier",
  T_34_M_WS_KILLZONE: "Dome de Zone",
  T_34_M_WS_LEFTCOLOR: "Couleur gauche",
  T_34_M_WS_LEFTTEAMINDEX: "Indice de l'équipe de gauche",
  T_34_M_WS_LEFTTEAMSCORE: "Score de l'équipe de gauche",
  T_34_M_WS_LOCSWITCH: "Commutateur de localisation",
  T_34_M_WS_MAX: "Maximum",
  T_34_M_WS_MIN: "Minimum",
  T_34_M_WS_NUMBER: "Numéro",
  T_34_M_WS_OBJECT: "Entité",
  T_34_M_WS_OPEN: "On",
  T_34_M_WS_OPENSATUS: "Activer le statut",
  T_34_M_WS_PICTURE: "Graphique",
  T_34_M_WS_RANKARRAY: "Tableau de classement",
  T_34_M_WS_RESULTS: "Résultats",
  T_34_M_WS_RIGHTCOLOR: "Bonne couleur",
  T_34_M_WS_RIGHTTEAMINDEX: "Bon indice d'équipe",
  T_34_M_WS_RIGHTTEAMSCORE: "Bon score de l'équipe",
  T_34_M_WS_ROUNDBANNER: "Bannière ronde",
  T_34_M_WS_ROUNDDESC: "Descriptif du tour",
  T_34_M_WS_ROUNDHUD: "Numéro rond",
  T_34_M_WS_ROUNDPARAMS: "Tableau de nombres ronds",
  T_34_M_WS_SAME_NAME: "Nom répété. Veuillez en essayer un nouveau.",
  T_34_M_WS_SCOREARRAY: "Tableau des scores",
  T_34_M_WS_SCORINGTYPE: "Type de score",
  T_34_M_WS_SCORINGTYPEDECS: "Le type de score que les joueurs pourraient obtenir. Prend en charge la personnalisation des scores.",
  T_34_M_WS_SCUFFLESCORING: "Score multi-équipes",
  T_34_M_WS_SETATTRIBUTES: "Paramètres de propriété",
  T_34_M_WS_SHUT: "Off",
  T_34_M_WS_SOUND: "Effets sonores",
  T_34_M_WS_SOUNDCLICK: "En cliquant",
  T_34_M_WS_SOUNDDD: "Compte à rebours",
  T_34_M_WS_SOUNDFEMALEA: "Blessé (Femme)",
  T_34_M_WS_SOUNDM: "Fusillade",
  T_34_M_WS_SOUNDMALEA: "Blessé (Homme)",
  T_34_M_WS_SOUNDUAV: "Explosion",
  T_34_M_WS_ST_ASSISTCOUNT: "Aides",
  T_34_M_WS_ST_CHECKPROGRESS: "Progression du point de contrôle",
  T_34_M_WS_ST_DAMAGESUM: "Dégâts",
  T_34_M_WS_ST_FINISHCOUNT: "Nombre d'objectifs atteints",
  T_34_M_WS_ST_FINISHORDER: "Ordre des objectifs atteints",
  T_34_M_WS_ST_FINISHTIME: "Moment des objectifs atteints",
  T_34_M_WS_ST_KILLCOUNT: "Kills",
  T_34_M_WS_ST_MAINSCORE: "Score d'objective",
  T_34_M_WS_ST_RANKSCORE: "Note de classement",
  T_34_M_WS_ST_SURVIVALDURACTION: "Temps de survie",
  T_34_M_WS_ST_UNKOWN: "Inconnue",
  T_34_M_WS_STARTBANNER: "Bannière de démarrage",
  T_34_M_WS_STARTTIME: "Heure de début",
  T_34_M_WS_STRING: "Texte",
  T_34_M_WS_STUDIO: "STUDIO",
  T_34_M_WS_TEAMARRAY: "Tableau d'équipe",
  T_34_M_WS_TEXTCONTENT: "Contenu",
  T_34_M_WS_THEMECOLOR: "Couleur du thème",
  T_34_M_WS_TIME: "HUD Compte à rebours",
  T_34_M_WS_TITLETEXT: "Texte du titre",
  T_34_M_WS_TYPE: "Type",
  T_34_M_WS_UODATETYPE: "Type de mise à jour",
  T_34_M_WS_VARNAME: "Nom de variable",
  T_34_M_WS_VECTOR: "Vecteur",
  T_34_M_WS_VFX: "Effets visuels",
  T_34_M_WS_WIDTH: "Largeur",
  T_34_MF_CHARACTER_TRACKER_N: "Homer",
  T_34_PD_FlagBattle_HYPE_1: "Feu",
  T_34_SP_WS_BLOCK1_NAME: "Changer d'étape",
  T_34_SP_WS_BLOCK1_NAMEDESC: "Changez l'étape d'un match pour entrer dans une étape (ou un tour) souhaitée. Les rondes ont également des indices d'étape et sont un type spécial d'étape.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "L'indice de l'étape cible",
  T_34_SP_WS_BLOCK10_NAME: "Créer des effets visuels",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Créez une icône en utilisant les effets visuels désignés. Plus de propriétés de l'effet visuel peuvent être configurées en ajustant les propriétés de l'entité d'effets visuels.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Effet visuel",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "Les types d'effets visuels qui peuvent être appliqués",
  T_34_SP_WS_BLOCK12_NAME: "Supprimer les effets visuels",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Supprimer l'effet visuel désigné",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Entité d'effets visuels",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "L'entité d'effet visuel à supprimer",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Ordonner au client de jouer l'effet visuel",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "Liste des joueurs",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "Les joueurs qui recevront le message",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Chemin de ressource",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "Le chemin de la ressource système est in:path. Le chemin de ressource personnalisé est out:path. Vide par défaut.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "Canal RGBA, chaque canal prenant une valeur comprise entre 0 et 255 enregistrée dans int32. La couleur par défaut est le blanc (255,255,255,255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Zoom",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "Échelle de zoom ; la valeur par défaut est 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Position d'affichage exprimée en coordonnées globales. Vecteur3(0) par défaut.",
  T_34_SP_WS_BLOCK14_NAME: "Jouer un effet sonore",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Ordonner au client de jouer l'effet sonore",
  T_34_SP_WS_BLOCK15_NAME: "Journal de sortie",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Publier le contenu sur l'interface du journal",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Activez pour permettre des Dégâts aux joueurs en dehors de la zone de sécurité",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "Le point central de la zone de sécurité",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Rayon",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "Le rayon de la zone de sécurité",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "Le compte à rebours pour que la zone de sécurité commence à rétrécir",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "La durée de la réduction de la zone de sécurité",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "La quantité de dégâts subis en dehors de la zone de sécurité",
  T_34_SP_WS_BLOCK3_NAMEDESC: "Lorsque la zone de danger est désactivée, les joueurs en dehors de la zone de sécurité ne subiront pas de dégâts",
  T_34_SP_WS_BLOCK4_NAMEDESC: "Utiliser pour retarder une action ultérieure pendant une durée déterminée",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "La durée d'attente, mesurée en millisecondes",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Utiliser pour reporter une action ultérieure à l'image suivante",
  T_34_SP_WS_BLOCK6_NAME: "Créer un HUD personnalisé",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Créer un HUD personnalisé désigné",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "Nom utilisé pour créer une entité HUD. La variable locale à laquelle elle correspond est l'entité du HUD en cours de création.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Player",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "L'entité d'un joueur spécifique. Uniquement visible par ledit joueur.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "L'index unique d'un HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Créer un HUD par défaut, qui n'est visible que pour les joueurs désignés",
  T_34_SP_WS_BLOCK8_NAMEDESC: "Une fois supprimé, le HUD par défaut ne sera pas visible sur le client (masqué ou supprimé)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "Entité HUD",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "L'entité HUD à supprimer",
  T_34_SP_WS_BLOCK9_NAMEDESC: "Une fois supprimé, le HUD personnalisé ne sera pas visible sur le client (masqué ou supprimé)",
  T_34_T_WS_BLOCK1_NAMEDESC: "L'incident se déclenche au début du match",
  T_34_T_WS_BLOCK10_NAMEDESC: "L'incident se déclenche au début de chaque tour",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "Le joueur éliminé qui déclenchera l'incident",
  T_34_T_WS_BLOCK13_NAMEDESC: "L'incident se déclenche lorsqu'un joueur assiste un autre joueur",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "Le joueur éliminé",
  T_34_T_WS_BLOCK14_NAMEDESC: "L'incident se déclenche lorsqu'un joueur inflige des dégâts",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "Le joueur qui subit les dégâts",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "Le type de Dégâts infligés",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "Le montant des Dégâts infligés",
  T_34_T_WS_BLOCK15_NAMEDESC: "L'incident se déclenche lorsqu'un joueur élimine un autre joueur",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "Le joueur éliminé",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "Le type de Dégâts qui causent l'élimination",
  T_34_T_WS_BLOCK16_NAMEDESC: "L'incident se déclenche lorsqu'un joueur rejoint le match",
  T_34_T_WS_BLOCK17_NAMEDESC: "L'incident se déclenche lorsqu'un joueur est réanimé",
  T_34_T_WS_BLOCK18_NAMEDESC: "Incident déclenché lorsqu'une équipe est supprimée",
  T_34_T_WS_BLOCK19_NAMEDESC: "Incident déclenché lors de l'ajout d'une équipe",
  T_34_T_WS_BLOCK2_NAMEDESC: "L'incident se déclenche à la fin du match",
  T_34_T_WS_BLOCK20_NAMEDESC: "Un incident se déclenche lorsqu'une équipe est anéantie",
  T_34_T_WS_BLOCK3_NAMEDESC: "L'incident se déclenche au début de chaque tour",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "Le nombre rond commence à partir de 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Index rond",
  T_34_T_WS_BLOCK4_NAMEDESC: "L'incident se déclenche à la fin de chaque manche",
  T_34_T_WS_BLOCK5_NAMEDESC: "L'incident se déclenche au début de l'étape",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "Le numéro d'étape commence à 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Entité d'étape",
  T_34_T_WS_BLOCK6_NAMEDESC: "L'incident se déclenche à la fin de l'étape",
  T_34_T_WS_BLOCK7_NAMEDESC: "L'incident se déclenche lorsqu'un joueur quitte le match",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "Le joueur qui déclenchera l'incident",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Joueur déclencheur",
  T_34_T_WS_BLOCK8_NAMEDESC: "Un incident se déclenche lorsque le score d'un joueur change",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "Le type de score modifié",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "La valeur du score après le changement",
  T_34_T_WS_BLOCK9_NAMEDESC: "Un incident se déclenche lorsque le score d'une équipe change",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "L'équipe qui déclenchera l'incident",
  T_34_WT_WS_BORNENTITY_PARAM1: "Point d'apparition",
  T_34_WT_WS_BORNENTITY_PARAM2: "Coordonnées disponibles",
  T_34_WT_WS_BORNENTITY_PARAM3: "Définir comme point d'apparition par défaut",
  T_34_WT_WS_BORNENTITY_PARAM4: "Limites lumineuses",
  T_34_WT_WS_BORNENTITY_PARAM5: "Utilisé ou bien non",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "HUD de point de contrôle",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Statut ouvert",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Déclencheur d'état",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Déclencheur d'élimination ou bien non",
  T_34_WT_WS_ENTITY_PARAM1: "Entité de jeu",
  T_34_WT_WS_ENTITY_PARAM10: "# d'équipes",
  T_34_WT_WS_ENTITY_PARAM11: "# de membres de l'équipe",
  T_34_WT_WS_ENTITY_PARAM12: "Équipement réinitialisé à chaque tour",
  T_34_WT_WS_ENTITY_PARAM13: "Activer les dégâts hors zone",
  T_34_WT_WS_ENTITY_PARAM14: "Taille des zones",
  T_34_WT_WS_ENTITY_PARAM15: "Heure de début de réduction de zone",
  T_34_WT_WS_ENTITY_PARAM16: "Durée de réduction de zone",
  T_34_WT_WS_ENTITY_PARAM17: "Dégâts hors zone",
  T_34_WT_WS_ENTITY_PARAM18: "Objective du score",
  T_34_WT_WS_ENTITY_PARAM19: "Score d'élimination",
  T_34_WT_WS_ENTITY_PARAM2: "Statut invalide",
  T_34_WT_WS_ENTITY_PARAM20: "Type d'aide",
  T_34_WT_WS_ENTITY_PARAM21: "Critères de classement du score du tour (joueur)",
  T_34_WT_WS_ENTITY_PARAM22: "Importance des critères (joueur)",
  T_34_WT_WS_ENTITY_PARAM23: "Critères de classement des scores du tour (équipe)",
  T_34_WT_WS_ENTITY_PARAM24: "Importance des critères (équipe)",
  T_34_WT_WS_ENTITY_PARAM25: "Critères de classement des scores (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "Importance des critères (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "Score de classement du tour",
  T_34_WT_WS_ENTITY_PARAM28: "Afficher les critères sur la page de résultats",
  T_34_WT_WS_ENTITY_PARAM29: "Nombre total de tours",
  T_34_WT_WS_ENTITY_PARAM3: "Temps de jeu",
  T_34_WT_WS_ENTITY_PARAM4: "Indice du tour en cours",
  T_34_WT_WS_ENTITY_PARAM5: "Indice de l'étape actuelle",
  T_34_WT_WS_ENTITY_PARAM6: "ID de modèle de mode",
  T_34_WT_WS_ENTITY_PARAM7: "Activer la réactivation du joueur",
  T_34_WT_WS_ENTITY_PARAM8: "Activer la réactivation du bot",
  T_34_WT_WS_ENTITY_PARAM9: "Temps d'aide",
  T_34_WT_WS_ENTITY1_NAME: "Entité actuelle",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Revenir à l'entité actuelle",
  T_34_WT_WS_ENTITY10_NAME: "Supprimer l'icône",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Supprimer une icône désignée",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Sélectionnez l'icône que vous souhaitez supprimer",
  T_34_WT_WS_ENTITY11_NAME: "Supprimer le texte",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Supprimer une entité texte",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Sélectionnez le texte que vous souhaitez supprimer",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Ajouter un élément pour un joueur désigné",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Joueur(s) qui recevra(ont) l'objet",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "L'ID d'article spécifique à obtenir",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "Le nombre d'articles à donner",
  T_34_WT_WS_ENTITY12_PARAM3: "Quantité",
  T_34_WT_WS_ENTITY13_PARAM1: "Type",
  T_34_WT_WS_ENTITY13_PARAM2: "Location",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "Les coordonnées de l'emplacement d'apparition de l'objet",
  T_34_WT_WS_ENTITY13_PARAM4: "Objet",
  T_34_WT_WS_ENTITY14_NAME: "Supprimer l'objet",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Supprimer un objet désigné",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Supprimer l'objet",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Acquérir toutes les entités de joueur",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Acquérir toutes les entités de l'équipe",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Récupérez une quantité désignée de HP pour les joueurs désignés. Si la quantité de récupération dépasse le HP maximum, le HP va s'arr êter",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "Joueur(s) dont la/les fluctuation(s) HP sont en cours de configuration",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "La quantité désignée de HP à récupérer",
  T_34_WT_WS_ENTITY18_NAME: "Obtenir des coordonnées d'apparition aléatoires",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Configurez l'emplacement à partir duquel les joueurs désignés doivent apparaître et revenir",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Joueur(s) qui apparaîtront aléatoirement à partir de cet emplacement",
  T_34_WT_WS_ENTITY18_RETURNDESC: "Les coordonnées du lieu où le joueur sera affecté",
  T_34_WT_WS_ENTITY19_NAME: "Obtenir le score du joueur",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Acquérir certains scores de joueurs désignés",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Acquérir l'entité de score de ce(s) joueur(s)",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Acquérir le type de score",
  T_34_WT_WS_ENTITY19_RETURNDESC: "La valeur de score spécifique à obtenir",
  T_34_WT_WS_ENTITY2_NAME: "Définir la propriété",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Configurer la valeur d'une propriété, où le type de propriété a déjà été sélectionné",
  T_34_WT_WS_ENTITY2_PARAM1: "Entité",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "La valeur de propriété de l'entité de jeu",
  T_34_WT_WS_ENTITY2_PARAM3: "Propriété",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "Une certaine propriété de cette entité de jeu",
  T_34_WT_WS_ENTITY2_PARAM4: "Valeur",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "Une valeur spécifique d'une propriété. Assurez-vous que le type de propriété correspond à celui sélectionné et correspond au type configuré dans les blocs associés.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Configurer certains scores de joueurs désignés",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Configurer l'entité score de ce(s) joueur(s)",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Configurer le type de score",
  T_34_WT_WS_ENTITY20_PARAM3: "Score",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "La valeur de score spécifique définie",
  T_34_WT_WS_ENTITY21_NAME: "Obtenir le score total de l'équipe",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Acquérir un certain type de scores totaux des équipes désignées",
  T_34_WT_WS_ENTITY21_PARAM1: "Équipe",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Obtenir l'entité de score de cette (ces) équipe(s)",
  T_34_WT_WS_ENTITY22_NAME: "Définir le score du tour actuel de l'équipe",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Configurer un certain type de scores de la ronde actuelle des équipes désignées",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Configurer le(s) score(s) de cette/ces équipe(s)",
  T_34_WT_WS_ENTITY23_NAME: "Obtenir le score du tour du joueur",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Acquérir certains scores d'un certain tour pour les joueurs désignés",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Acquérir le(s) score(s) de la manche de ce(s) joueur(s)",
  T_34_WT_WS_ENTITY23_PARAM2: "Tour",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Obtenir le score de ce tour",
  T_34_WT_WS_ENTITY24_NAME: "Obtenir le score du tour par équipe",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Acquérir certains scores d'un certain tour pour les équipes désignées",
  T_34_WT_WS_ENTITY25_NAME: "Téléportation",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Téléporter les joueurs désignés à un endroit désigné",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Joueur(s) qui seront téléportés",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Coordonnées de l'endroit où le(s) joueur(s) seront téléportés",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Permettre aux joueurs désignés d'infliger des dégâts aux cibles désignées. Si aucun joueur attaquant n'est sélectionné, les cibles désignées subiront des dégâts du système.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Entités qui subiront les Dégâts",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "Le montant des dégâts infligés",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Réanimez les joueurs désignés",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Entités de joueur qui peuvent être sauvés",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Configurer le type de bloc",
  T_34_WT_WS_ENTITY3_PARAM1: "comme",
  T_34_WT_WS_ENTITY4_NAME: "Obtenir la propriété",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Obtenir une propriété spécifique d'une entité",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Obtenir l'entité de jeu spécifique de la valeur de la propriété",
  T_34_WT_WS_ENTITY4_RETURNDESC: "La valeur foncière spécifique à obtenir",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Configurez la possibilité de se déplacer pour tous les joueurs",
  T_34_WT_WS_ENTITY6_NAME: "Créer une icône",
  T_34_WT_WS_ENTITY6_PARAM1: "Icône",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "Une image affichée sur le HUD. Choisissez parmi différents modèles.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Sélectionnez l'icône sur laquelle le design doit être appliqué",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Créez une icône HUD pour les joueurs désignés. Si aucune entité de joueur n'est sélectionnée, le HUD sera créé pour tous les joueurs.",
  T_34_WT_WS_ENTITY7_PARAM1: "Joueur",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Créer une icône HUD pour certains joueurs",
  T_34_WT_WS_ENTITY8_NAME: "Créer un texte",
  T_34_WT_WS_ENTITY8_PARAM1: "Texte",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "Le contenu textuel spécifique à créer à partir de cette commande",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "L'entité de texte en cours de création",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Ajoutez une ligne de texte HUD pour les joueurs désignés. Si aucune entité de joueur n'est sélectionnée, le texte sera créé sur le HUD de tous les joueurs.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Ajouter un texte HUD pour certains joueurs",
  T_34_WT_WS_ICONENTITY_PARAM1: "Entité icône",
  T_34_WT_WS_ICONENTITY_PARAM2: "Concevoir",
  T_34_WT_WS_ICONENTITY_PARAM3: "Couleur",
  T_34_WT_WS_ICONENTITY_PARAM4: "Échelle",
  T_34_WT_WS_ICONENTITY_PARAM5: "Emplacement de l'affichage",
  T_34_WT_WS_ICONENTITY_PARAM6: "Suivre la cible",
  T_34_WT_WS_ICONENTITY_PARAM7: "Visible à travers les murs",
  T_34_WT_WS_ICONENTITY_PARAM8: "Toujours à l'écran",
  T_34_WT_WS_ONETEAM_TAG: "Une seule équipe",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Entité d'étape",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Indice d'étape",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Heure de début",
  T_34_WT_WS_PHASEENTITY_PARAM4: "Heure de fin",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Durée",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Entité joueur",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Point de réveil",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Taux de dégâts",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "Personnage modèle 3D",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Identité",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "HP actuel",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Max. HP",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Statut du joueur",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Temps de survie",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Invulnérable",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Équipe",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "ID du point de contrôle cible",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Point d'apparition",
  T_34_WT_WS_PROCIRCLE_ICON: "Icône",
  T_34_WT_WS_PVEDESC1: "Si au moins un joueur atteint la ligne d'arrivée avant la fin du temps imparti, l'équipe gagne. Si tous les joueurs sont éliminés en même temps, la partie est terminée.",
  T_34_WT_WS_PVEDESC2: "Survivre pendant un temps désigné pour gagner. Si tous les joueurs sont éliminés en même temps, la partie est terminée.",
  T_34_WT_WS_PVENAME1: "Se précipiter",
  T_34_WT_WS_PVENAME2: "Endurance",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "ID de point de contrôle actuel",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Numéro de point de contrôle du mode Parkour",
  T_34_WT_WS_SKILLSET14: "Colère de l'épéiste (Kenta)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Entité d'équipe",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Ace",
  T_34_WT_WS_TEAMENTITY_PARAM3: "Tous les membres",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Déclencheur régulier",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Type d'apparence",
  T_34_WT_WS_TXTENTITY_PARAM1: "Entité texte",
  T_34_WT_WS_TXTENTITY_PARAM2: "Contenu",
  T_34_WT_WS_VFXENTITY_PARAM1: "Entité d'effets visuels",
  T_34_WZ_WS_LOGIC10_NAME: "Continuer au suivant",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Ignorer l'itération de la boucle en cours et exécuter la suivante",
  T_34_WZ_WS_LOGIC11_NAME: "Retourner",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Termine l'exécution en cours et revient au programme principal. Permet de renvoyer des données lors du retour.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Valeur de retour",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "Les données à renvoyer au programme principal",
  T_34_WZ_WS_LOGIC2_NAME: "Comparer",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "Comparer 2 valeurs à l'aide d'un opérateur désigné",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Valeur de gauche",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "La valeur de gauche utilisée pour la comparaison",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Fonction de comparaison",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Sélectionnez la manière dont vous souhaitez comparer les valeurs. Les opérateurs pris en charge sont : >, ≥, ==, ≠, ≤, <, Et (booléen uniquement), Ou (booléen uniquement)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "La bonne valeur",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "La valeur de droite utilisée pour la comparaison",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Résultat de la comparaison",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Donne l'inverse d'une valeur logique",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "La valeur sur laquelle vous souhaitez utiliser l'opérateur NOT",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "Résultat de l'opération NOT",
  T_34_WZ_WS_LOGIC4_NAME: "Chèque vide",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Vérifier si une entité est vide/null",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Entité",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "L'entité pour laquelle vérifier le vide",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Si l'entité est vide ou non",
  T_34_WZ_WS_LOGIC5_NAME: "Si",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "S'exécute selon que les conditions sont remplies ou non. Les sous-processus sont les mêmes que les branches logiques suivantes.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Valeur",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "Le nombre de conditions et le nombre de sous-processus (branches logiques) doivent être identiques",
  T_34_WZ_WS_LOGIC6_NAME: "Boucle de plage d'entiers",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "Boucle de x à y d'un pas de z. Le sous-processus est la boucle elle-même.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "Le nom de l'index de boucle qui peut être utilisé pour extraire la valeur de l'index de boucle d'une variable locale",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Valeur de départ",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "La valeur à laquelle la boucle commence",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "Valeur finale",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "La valeur à laquelle la boucle se termine",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Étape",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "Le pas de chaque boucle. Lorsque la valeur de départ est inférieure à la valeur de fin, le pas doit être supérieur à 0. Lorsque la valeur de départ est supérieure à la valeur de fin, le pas doit être inférieur à 0.",
  T_34_WZ_WS_LOGIC7_NAME: "Bouclez chaque élément",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Permet de traverser un conteneur de données pour en extraire chaque sous-élément. Le sous-processus est la boucle elle-même.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Élément",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Parcourir ce nom extraira la valeur du sous-élément de la variable locale",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Conteneur de données",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "Conteneur de données à parcourir. Prend actuellement en charge les types de liste.",
  T_34_WZ_WS_LOGIC8_NAME: "Boucle conditionnelle",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "Une boucle conditionnelle se répète jusqu'à ce qu'une condition soit remplie. La boucle s'arrête lorsque la condition est fausse.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Condition",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Répète la boucle si la condition est vraie et s'arrête jusqu'à ce que la condition soit fausse",
  T_34_WZ_WS_LOGIC9_NAME: "Boucle de rupture",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Arrête le processus de boucle en cours et saute hors de la boucle",
  T_34_Y_B_DINOSAURS: "Illusion de dinosaure (Bas)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Ange pur (F)",
  T_34_YS_F_B_PANDACATTLE: "Moo Zoo (Bas)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Gloo Wall- Voleur aquatique (Bas)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Gloo Wall- Voleur aquatique (Tête)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Gloo Wall- Voleur aquatique (Maquillage)",
  T_34_YS_F_S_PANDACATTLE: "Moo Zoo (Chaussures)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Gloo Wall- Voleur aquatique (Chaussures)",
  T_34_YS_F_T_PANDACATTLE: "Moo Zoo (Haut)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Gloo Wall- Voleur aquatique (Haut)",
  T_34_YS_M_B_ANGEL_BW: "Ange pur (M)",
  T_34_YS_M_B_PANDACATTLE: "Pyjama de Panda (Bas)",
  T_34_YS_M_H_PANDACATTLE: "Pyjama de Panda (Tête)",
  T_34_YS_M_S_PANDACATTLE: "Pyjama de Panda (Chaussures)",
  T_34_YS_M_T_PANDACATTLE: "Pyjama de Panda (Haut)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Gagnez [FFB300]{0} EP[-] en renversant un ennemi.",
  T_35_DY_PET_OWL_N: "Hoot",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Skin d'animal: Vaisseau spatial lunaire",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Skin d'Animal: Azulcrema Trace Zasil",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Skin d'animal: Agui Bleu",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Skin d'animal: Hoot en feu",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Skin d'Animal: Hoot nocturne",
  T_35_DY_PETSKIN_OWL_STORM_N: "Skin d'animal: Hoot givrée",
  T_35_JL_KNOCKEDDOWN: "est Knocked down",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "Pendant  [FFB300]{1}s[-], tirer avec succès sur un mur Gloo marquera les ennemis à moins de [FFB300]{3}m[-] de celui-ci et pénétrera le mur Gloo pour infliger des dégâts aux ennemis marqués (les dégâts infligés seront inférieurs à la normale). Efficace sur [FFB300]{0}[-] Gloo Walls max. Temps de recharge : [FFB300]{2}s[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Bagarre murale",
  T_35_KY_INFECTION_MAPNAME: "Terre en friche",
  T_35_M_WS_BUTTONCLICKDESC: "Déclenche cet incident lorsque le bouton correspondant est appuyé. Le lecteur déclencheur peut être obtenu à l'aide de paramètres.",
  T_35_M_WS_GETTEAMMATEPOS: "Obtenir les emplacements des coéquipiers à proximité",
  T_35_M_WS_ROUND2: "Vague actuelle",
  T_35_PD_Infection_HUMANSELECT: "Sélectionnez une arme",
  T_35_PD_INFECTION_MODENAME: "Droïde Apocalypse",
  T_35_QX_WS_ICONTYPE_ITEM: "Objet",
  T_35_QX_WS_ICONTYPE_NATURE: "Formes de la nature",
  T_35_QX_WS_ICONTYPE_SHAPE: "Géométrique",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Symbole",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Arme",
  T_35_R_EMOTE_TAG_MUSIC_N: "Musique",
  T_35_RW_SKILL_DESC_Singers: "L'utilisateur de la compétence et ses alliés dans un rayon de [FFB300]{0}m[-] peuvent bloquer [FFB300]{1}%[-] de dégâts à l'aide d'EP. Dans ce cas, le montant d'EP déduit des alliés sera ajouté à l'EP de l'utilisateur de la compétence.",
  T_35_RW_SKILL_NAME_Singers: "Sentinelle silencieuse",
  T_35_SP_WS_COMMENTKEY_01: "Difficulté Appropriée",
  T_35_SP_WS_COMMENTKEY_02: "Créatif",
  T_35_SP_WS_COMMENTKEY_03: "Gameplay Intéressant",
  T_35_SP_WS_COMMENTKEY_04: "Peut être Joué à Plusieurs Reprises",
  T_35_SP_WS_COMMENTKEY_05: "Scénario intrigant",
  T_35_SP_WS_COMMENTKEY_06: "Bien équilibré",
  T_35_SP_WS_COMMENTKEY_07: "Expérience Agréable",
  T_35_SP_WS_COMMENTKEY_08: "Flexible",
  T_35_SP_WS_COMMENTKEY_09: "Esthétiquement plaisant",
  T_35_SP_WS_COMMENTKEY_10: "Trop Difficile",
  T_35_SP_WS_COMMENTKEY_11: "Trop Facile",
  T_35_SP_WS_COMMENTKEY_12: "Ennuyeux",
  T_35_SP_WS_COMMENTKEY_13: "Trop Long",
  T_35_SP_WS_COMMENTKEY_14: "Déséquilibré",
  T_35_SP_WS_COMMENTKEY_15: "Expérience Désagréable",
  T_35_SP_WS_IMAGE03: "Texture",
  T_35_SP_WS_IMAGE04: "Cadre",
  T_35_SY_CHARGESHOT_TEARS_N: "Chargeur Puissant - Lustre de lave",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Grenade - Cristal mystérieux",
  T_35_SY_GRENADE_PIRATES_N: "Grenade - Chahuteur Marin",
  T_35_SY_GRENADE_RIDERS_N: "Grenade - Cavalier sinistre",
  T_35_SY_M24_KUN_N: "M24 - Éclabousseur de rivière",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - Coureur Gusto",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Jeep - Puzzle monochrome",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Profitez de la fête !",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Moto - Crystal Symmetry",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Structure & Décor",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Structures",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Divers",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Architecture",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Grands Bâtiments",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Bâtiments de taille moyenne",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Objets Fonctionnels",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "L'essentiel des modes",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Musique",
  T_35_WT_WS_PVEMODE_TAG: "Mode de survie",
  T_35_WZY_WS_BECRE_NAMEDESC: "Se déclenche lorsque cette entité est créée",
  T_35_WZY_WS_BEKILL_NAMEDESC: `Se déclenche lorsque cette entité est éliminée. La source de l'attaque peut être identifiée à l'aide de "Entité de déclenchement" et le type d'attaque peut être identifié à l'aide de "Type de Dégâts".`,
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "L'entité qui déclenche l'incident",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Créez un type d'élément ou un ensemble d'éléments à un emplacement spécifique. Lors de la création d'un type d'article, le montant correspond au numéro de cet article. Lors de la création d'un ensemble d'articles, le montant est la liste des montants qui correspond à la liste des articles. Les éléments créés dépendront des unités de la carte.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "Une liste qui contient les éléments qui seront créés. Il peut également s'agir d'un seul élément.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "Une liste de montant qui correspond à la liste d'articles. Il ne peut contenir que le montant d'un type d'objet.",
  T_35_WZY_WS_DAMTYPE_CAR: "Véhicule",
  T_35_WZY_WS_DAMTYPE_FALL: "Automne",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Arme",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Grenade",
  T_35_WZY_WS_DAMTYPE_MELEE: "Mêlée",
  T_35_WZY_WS_DAMTYPE_ZONE: "Hors zone",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Supprimer un nombre spécifié d'éléments de joueurs spécifiques",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Entrer dans la zone de déclenchement",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: `Se déclenche lorsqu'une "entité de déclenchement" sort d'une zone de déclenchement`,
  T_35_WZY_WS_ENTITYPLAYER_DESC: "Le joueur pour obtenir l'entité. Lorsqu'elle est liée au joueur, les informations de l'entité ne seront mises à jour que pour ledit joueur. Lorsqu'aucun joueur n'est lié, tous les joueurs recevront les informations sur l'entité.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Entité de combat",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Obtenir tous les objets d'un type spécifié. Le résultat renvoyé est une liste.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Type d'objet",
  T_35_WZY_WS_HUDWIDGET_NAME: "Contrôle de l'interface utilisateur",
  T_35_WZY_WS_HURT_NAMEDESC: `Se déclenche lorsque cette entité subit des dégâts. La source de l'attaque peut être identifiée à l'aide de "Entité de déclenchement".`,
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "Le type d'article",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Objet de scène",
  T_35_WZY_WS_OBKILL_NAMEDESC: `Se déclenche lorsque cette entité élimine une autre entité. Le type d'entité éliminée peut être identifié à l'aide de "Entité éliminée".`,
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "L'entité qui est éliminée",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Se déclenche lorsqu'une entité cause des Dégâts",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "L'entité qui inflige des Dégâts",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Entité Cible",
  T_35_WZY_WS_PREFABID_NAME: "ID de modèle",
  T_35_WZY_WS_PROPERTY_EPNOW: "EP actuel",
  T_35_WZY_WS_PROPERTY_JUMP: "Hauteur du saut",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Sortir de la zone de déclenchement",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: `Se déclenche lorsqu'une "entité de déclenchement" sort d'une zone de déclenchement`,
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Supprimer un élément spécifique d'une liste. [Liste] est la liste dans laquelle se trouve l'élément. [Element] est l'élément à supprimer.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Valeur de l'élément",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "La valeur de l'élément à supprimer",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Entité ronde",
  T_35_WZY_WS_TOWER_PARAM1: "Tour et Forteresse",
  T_35_WZY_WS_TOWER_PARAM2: "ID d'équipe",
  T_35_WZY_WS_TOWER_PARAM3: "HP actuel",
  T_35_WZY_WS_TOWER_PARAM4: "Max. HP",
  T_35_WZY_WS_TOWER_PARAM5: "Dégâts",
  T_35_WZY_WS_TOWER_PARAM6: "Intervalle d'attaque",
  T_35_WZY_WS_TOWER_PARAM7: "Gamme d'attaque",
  T_35_WZY_WS_TOWER_PARAM8: "La défense %",
  T_35_XYL_PDM_REVENGE: "vengé",
  T_35_XYL_WS_BISPARTERRE: "Parterre de graffitis",
  T_35_XYL_WS_BISPARTERRE_DESC: "Un parterre de fleurs en pierre sur le thème Battle-In-Style",
  T_35_XYL_WS_BISWALL: "Mur de graffitis",
  T_35_XYL_WS_BISWALL_DESC: "Un mur sur le thème Battle-In-Style qui peut être combiné",
  T_35_XYL_WS_BOTDROP: "Activer/désactiver le butin",
  T_35_XYL_WS_CUSTOMTRIGGER: "Déclencheur personnalisé",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Placez un objet qui déclenche un certain effet spécial personnalisé lorsqu'un joueur l'active. L'effet doit être configuré dans le script. (Uniquement en mode Personnaliser.)",
  T_35_XYL_WS_DOUBLEDOOR: "Porte",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "Une porte qui s'est ouverte",
  T_35_XYL_WS_RESET: "Veuillez modifier cette carte à l'aide de FF Craftmate (PC)",
  T_35_XYL_WS_RESETN: "Non",
  T_35_XYL_WS_RESETY: "Oui",
  T_35_XYL_WS_ROADBLOCK: "Barrage routier A",
  T_35_XYL_WS_ROADBLOCK_DESC: "Empêche de passer",
  T_35_XYL_WS_STAIRS: "Escaliers",
  T_35_XYL_WS_STAIRS_DESC: "Des escaliers pouvant être combinés avec des paliers",
  T_35_XYL_WS_STAIRSL: "Palier B",
  T_35_XYL_WS_STAIRSL_DESC: "Une plate-forme qui peut être combinée avec des escaliers",
  T_35_XYL_WS_STAIRSZ: "Atterrissage A",
  T_35_XYL_WS_STAIRSZ_DESC: "Une plate-forme qui peut être combinée avec des escaliers",
  T_35_XYL_WS_TBOOTH: "Cabine téléphonique",
  T_35_XYL_WS_TBOOTH_DESC: "Souvent vu dans les rues",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "Agui",
  T_35_YS_A_CUBBY: "Masque de louveteau",
  T_35_YS_F_A_PANTOMIME: "Chagrin bicolore (Masque)",
  T_35_YS_F_A_RIDERS: "Cavalier fatal (Masque)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Réunificateur de beauté (Bas)",
  T_35_YS_F_B_GOLDCHAIN: "Armure des Richesses (Bas)",
  T_35_YS_F_B_PANTOMIME: "Chagrin bicolore (Bas)",
  T_35_YS_F_B_RIDERS: "Cavalier fatal (Bas)",
  T_35_YS_F_H_BEAR_HW: "Casquette Cub",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Réunificateur de beauté (Tête)",
  T_35_YS_F_H_GOLDCHAIN: "Armure des Richesses (Tête)",
  T_35_YS_F_H_PANTOMIME: "Chagrin bicolore (Tête)",
  T_35_YS_F_H_RIDERS: "Cavalier fatal (Tête)",
  T_35_YS_F_HA_GOLDCHAIN: "Armure des Richesses (Maquillage)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Réunificateur de beauté (Chaussures)",
  T_35_YS_F_S_GOLDCHAIN: "Armure des Richesses (Chaussures)",
  T_35_YS_F_S_PANTOMIME: "Chagrin bicolore (Chaussures)",
  T_35_YS_F_S_RIDERS: "Cavalier fatal (Chaussures)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Réunificateur de beauté (Haut)",
  T_35_YS_F_T_GOLDCHAIN: "Armure des Richesses (Haut)",
  T_35_YS_F_T_PANTOMIME: "Chagrin bicolore (Haut)",
  T_35_YS_F_T_RIDERS: "Cavalier fatal (Haut)",
  T_35_YS_ITEM_SUPERFAK: "Super Med",
  T_35_YS_M_A_GOLDCHAIN: "Chainz de Lux (Masque)",
  T_35_YS_M_A_RIDERS: "Cavalier sinistre (Masque)",
  T_35_YS_M_B_GOLDCHAIN: "Chainz de Lux (Bas)",
  T_35_YS_M_B_RIDERS: "Cavalier sinistre (Bas)",
  T_35_YS_M_H_BEAR_HW: "Casquette Cub",
  T_35_YS_M_H_GOLDCHAIN: "Chainz de Lux (Tête)",
  T_35_YS_M_H_RIDERS: "Cavalier sinistre (Tête)",
  T_35_YS_M_S_GOLDCHAIN: "Chainz de Lux (Chaussures)",
  T_35_YS_M_S_RIDERS: "Cavalier sinistre (Chaussures)",
  T_35_YS_M_T_GOLDCHAIN: "Chainz de Lux (Haut)",
  T_35_YS_M_T_RIDERS: "Cavalier sinistre (Haut)",
  T_35_YS_T_CHAMPION: "T-shirt champion",
  T_35_YS_T_PAINTING: "T-shirt à pression",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Obtenez des pièces au début du match",
  T_36_JH_WS_CESAYCLOSE: "Désactiver ou non la fermeture manuelle",
  T_36_JH_WS_CHOOSEEDITSHOP: "Sélectionnez un magasin à modifier",
  T_36_JH_WS_CHOOSESHOP: "Sélectionnez un magasin",
  T_36_JH_WS_COINCOUNT: "Montant en devise",
  T_36_JH_WS_COINHUD: "Afficher ou non le montant des pièces",
  T_36_JH_WS_CRAFTSHOP: "Modifier le magasin",
  T_36_JH_WS_CREATEGOLD: "Générateur de pièces",
  T_36_JH_WS_CSHOPENTITY: "Lier l'entité de magasin",
  T_36_JH_WS_CSHOPHUD: "Interface magasin",
  T_36_JH_WS_CURRENTLIMIT: "Limite d'achat restante",
  T_36_JH_WS_ECONOMIC: "Économie",
  T_36_JH_WS_INGAMEECONOMI: "Économie du jeu",
  T_36_JH_WS_ITEMINDEXID: "Numéro de marchandise",
  T_36_JH_WS_KILLMONEY: "Obtenir des pièces pour éliminer",
  T_36_JH_WS_KILLMONEYTIP: "Le nombre de pièces à gagner pour éliminer les zombies en mode Rush et en mode Endurance",
  T_36_JH_WS_LISTINDEX: "Liste des types de marchandises",
  T_36_JH_WS_NULL: "Nul",
  T_36_JH_WS_NUMBER: "Montant",
  T_36_JH_WS_OPTIONNAME: "Mode Exclusif Droïde Apocalypse",
  T_36_JH_WS_REALSHOPENTITY: "Entité magasin",
  T_36_JH_WS_SEEORHIDE: "Afficher le distributeur automatique",
  T_36_JH_WS_SHOPFRONT: "Magasin",
  T_36_JH_WS_SHOPITEMLIST: "Type de marchandise",
  T_36_JH_WS_SHOPOPENCON: "Statut ouvert",
  T_36_JH_WS_SSHOPNAME: "Nom du magasin",
  T_36_JH_WS_TOTALLIMIT: "Limite d'achat",
  T_36_JH_WS_TRIGGERWIDE: "Plage de déclenchement",
  T_36_JH_WS_VENDMACHINE: "Distributeur automatique",
  T_36_JH_WS_WINMONEY: "Obtenez des pièces pour la victoire",
  T_36_JH_WS_WORTH: "Valeur",
  T_36_JL_FOREGRIP_MR_N: "Poignée de tireur d'élite",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Crosse de Shotgun",
  T_36_JL_STOCK_SR_N: "Stock de tireur d'élite",
  T_36_KK_WS_MONTSTERDES: "Un camion 4 places avec une grande durabilité et peut se déplacer sur des terrains difficiles",
  T_36_M_WS_SETTEMPVAR: "Définir la variable temporaire",
  T_36_M_WS_TEMPVAR: "Variable temporaire",
  T_36_SY_AK47_MAMBAS_N: "AK47 - Morsure de Mamba",
  T_36_SY_AN94_MAMBAS_N: "AN94 - Morsure de Mamba",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher - Morsure de Mamba",
  T_36_SY_AUG_MAMBAS_N: "AUG - Morsure de Mamba",
  T_36_SY_AWM_MAMBAS_N: "AWM - Morsure de Mamba",
  T_36_SY_BLT_MAMBAS_N: "M82B - Morsure de Mamba",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Chargeur Puissant - Morsure de Mamba",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle - Morsure de Mamba",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS - Morsure de Mamba",
  T_36_SY_G18_MAMBAS_N: "G18 - Morsure de Mamba",
  T_36_SY_G36_MAMBAS_N: "G36 - Morsure de Mamba",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Grenade - Fête de la Marine",
  T_36_SY_GROZA_MAMBAS_N: "Groza - Morsure de Mamba",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Canon à mainc- Morsure de Mamba",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Sniper de Guérison - Morsure de Mamba",
  T_36_SY_ICE_GUN_MAMBAS_N: "Pistolet Gloo Wall - Morsure de Mamba",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - Morsure de Mamba",
  T_36_SY_KORD_MAMBAS_N: "Kord - Morsure de Mamba",
  T_36_SY_M1014_MAMBAS_N: "M1014 - Morsure de Mamba",
  T_36_SY_M14_MAMBAS_N: "M14 - Morsure de Mamba",
  T_36_SY_M1873_MAMBAS_N: "M1873 - Morsure de Mamba",
  T_36_SY_M1887_MAMBAS_N: "M1887 - Morsure de Mamba",
  T_36_SY_M1917_MAMBAS_N: "M1917 - Morsure de Mamba",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker - Morsure de Mamba",
  T_36_SY_M24_MAMBAS_N: "M24 - Morsure de Mamba",
  T_36_SY_M249_MAMBAS_N: "M24 - Morsure de Mamba",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - Morsure de Mamba",
  T_36_SY_M500_MAMBAS_N: "M500 - Morsure de Mamba",
  T_36_SY_M60_MAMBAS_N: "M60 - Morsure de Mamba",
  T_36_SY_M79_MAMBAS_N: "M79 - Morsure de Mamba",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - Morsure de Mamba",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - Morsure de Mamba",
  T_36_SY_MINI_MAMBAS_N: "AC80 - Morsure de Mamba",
  T_36_SY_MP40_MAMBAS_N: "MP40 - Morsure de Mamba",
  T_36_SY_MP5_MAMBAS_N: "MP5 - Morsure de Mamba",
  T_36_SY_P90_MAMBAS_N: "P90 - Morsure de Mamba",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL - Morsure de Mamba",
  T_36_SY_PP19_MAMBAS_N: "Bizon - Morsure de Mamba",
  T_36_SY_PP19_POLICEMAN_N: "Bizon - Spectre de Patrouille",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - Morsure de Mamba",
  T_36_SY_SKS_MAMBAS_N: "SKS - Morsure de Mamba",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 - Morsure de Mamba",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA - Morsure de Mamba",
  T_36_SY_SVD_MAMBAS_N: "SVD - Morsure de Mamba",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson - Morsure de Mamba",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Dague - Mamba",
  T_36_SY_THROWINGKNIFE_MENA_N: "Dague - Boho",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Pistolet de Guérison - Morsure de Mamba",
  T_36_SY_UMP45_MAMBAS_N: "UMP - Morsure de Mamba",
  T_36_SY_USP45_MAMBAS_N: "USP - Morsure de Mamba",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi - Morsure de Mamba",
  T_36_SY_VECTOR_MAMBAS_N: "Vector - Morsure de Mamba",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Monster Truck - Or aveuglant",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Moto - Balade spectrale",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Voiture de sport - Vitesse Acer",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuk Tuk - Tour du monde souterrain",
  T_36_SY_VSS_MAMBAS_N: "VSS - Morsure de Mamba",
  T_36_SY_XM8_MAMBAS_N: "XM8 - Morsure de Mamba",
  T_36_WZY_AFTERACCUMULATOR: "Accumulateur arrière",
  T_36_WZY_AVAILAB: "Activé",
  T_36_WZY_BACKANDFORTH: "Aller-retour",
  T_36_WZY_BASEMULTIPLIER: "Multiplicateur de base",
  T_36_WZY_BASIC: "Type de base",
  T_36_WZY_BEFORACCUMULATOR: "Accumulateur avant",
  T_36_WZY_CYLIC: "Cercle de retour",
  T_36_WZY_GUNPRO_PARAM1: "Dégâts de base",
  T_36_WZY_GUNPRO_PARAM10: "Début de la propagation des balles",
  T_36_WZY_GUNPRO_PARAM11: "Max. zone de propagation",
  T_36_WZY_GUNPRO_PARAM12: "Éclatement",
  T_36_WZY_GUNPRO_PARAM2: "Balles dans le magazine",
  T_36_WZY_GUNPRO_PARAM3: "Numéro de magasin initial",
  T_36_WZY_GUNPRO_PARAM4: "Intervalle de tir",
  T_36_WZY_GUNPRO_PARAM7: "Distance pour max. dégâts",
  T_36_WZY_GUNPRO_PARAM8: "Distance pour min. dégâts",
  T_36_WZY_GUNPRO_PARAM9: "Dégâts minimes",
  T_36_WZY_MULTIPLIR: "Multiplicateur",
  T_36_WZY_PRICE: "Prix",
  T_36_WZY_SUMMULTIPLIER: "Accumulateur multiplicateur",
  T_36_WZY_WS_3DZOOM: "Zoom 3D",
  T_36_WZY_WS_ABSRES: "Résultat en valeur absolue",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Ajoutez tous les éléments de la [Liste source] au bas de la [Liste cible]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "La liste cible pour ajouter les éléments",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "La liste source qui contient les éléments à ajouter",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Ajouter un certain montant de devise désignée dans un portefeuille désigné",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Porte monnaie",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "Le portefeuille pour ajouter de la monnaie dans",
  T_36_WZY_WS_ADDSUB: "Ajouter ou soustraire des valeurs",
  T_36_WZY_WS_AIENTITY: "Entité IA",
  T_36_WZY_WS_ALLSHOP_DESC: "Une liste composée d'entités de magasin",
  T_36_WZY_WS_ANGLE_DESC: "La mesure de l'angle",
  T_36_WZY_WS_ANYTYPE: "N'importe quel type",
  T_36_WZY_WS_ARILEFT: "Valeur de gauche dans l'opération",
  T_36_WZY_WS_ARIRES: "Résultat de l'opération",
  T_36_WZY_WS_ARIRIGHT: "Juste valeur dans l'opération",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 opérations arithmétiques",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "Les opérations de base sur les entiers prennent en charge l'addition, la soustraction, la multiplication, la division et le reste. Les opérations flottantes prennent en charge l'addition, la soustraction, la multiplication et la division.",
  T_36_WZY_WS_ARRAY_DESC: "La liste cible",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Vérifiez si une liste contient un élément désigné. La valeur renvoyée est booléenne.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "La liste désignée",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "L'élément à rechercher dans la liste",
  T_36_WZY_WS_ARRCONELERES: "Résultat indiquant si un élément désigné existe dans une liste. La valeur est booléenne.",
  T_36_WZY_WS_ATTACK: "Patrouiller et attaquer",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Se déclenche lorsque le joueur est renversé",
  T_36_WZY_WS_BIGFLOAT: "Grand décimal",
  T_36_WZY_WS_BIGTOYBALL: "Dé",
  T_36_WZY_WS_BOOLLIST: "Liste booléenne",
  T_36_WZY_WS_CEIL_NAME_DESC: "Arrondir une valeur au plus petit entier supérieur à lui-même",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "La valeur à arrondir",
  T_36_WZY_WS_CEILRES: "Résultat de tour",
  T_36_WZY_WS_CHASEENT_NAMEDESC: `L'IA sélectionnée poursuivra cette entité quelle que soit la distance. [Entité chassée] peut être n'importe quelle entité. Lorsque [l' 
   entité chassée] n'a pas de propriété HP, l'entité IA n'infligera aucun dégâts.`,
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "L'entité qui fait la chasse",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "L'entité cible qui est poursuivie. Il peut s'agir de n'importe quelle entité.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "Le modèle pour le clonage d'objets. Sélectionnez à l'aide du curseur. La propriété et le script du clone seront les mêmes que ceux de l'objet choisi.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "L'entité objet à cloner",
  T_36_WZY_WS_CONDITION: "Condition",
  T_36_WZY_WS_CONDITIONLIST: "Liste des conditions",
  T_36_WZY_WS_CONOFHUD: "L'entité HUD dans laquelle le contrôle existe",
  T_36_WZY_WS_CONTROL_DESC: "Le seul index d'un champ",
  T_36_WZY_WS_COS_NAMEDESC: "Trouver le cosinus d'un angle",
  T_36_WZY_WS_COSRES: "Cosinus de l'angle",
  T_36_WZY_WS_CREABLEOB: "Objet pouvant être créé",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Créez une entité d'objet à un emplacement désigné. (Version d'essai)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "Les coordonnées de l'objet à créer",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "Le type d'objet à créer",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "L'entité de l'objet à créer",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Devise",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Entité de marchandise",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Créer une entité marchandise",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Créez une entité de portefeuille. [Lier le joueur] est le joueur qui peut voir ce portefeuille. [Propriétaire] est le joueur à qui appartient le portefeuille. Invalide si un portefeuille existe déjà.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Joueur lié",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "Le joueur pour qui le portefeuille est visible. Si aucun paramètre n'est configuré, le portefeuille sera visible par tous.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "Le propriétaire du portefeuille",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Entité de portefeuille",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "L'entité wallet créée",
  T_36_WZY_WS_CURRAMT: "Montant en devise",
  T_36_WZY_WS_DATA_TYPE1: "Paramètre ajouté",
  T_36_WZY_WS_DATA_TYPE2: "Calcul de base et logique",
  T_36_WZY_WS_DATA_TYPE3: "Manipulation de liste",
  T_36_WZY_WS_DATA_TYPE4: "Calcul vectoriel",
  T_36_WZY_WS_DESTITEM_NAME: "Détruire l'élément du joueur",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Détruire un type d'objet désigné pour un joueur désigné",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Les objets pouvant être détruits sont les armes, les gilets et les casques",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "L'index d'emplacement du type d'élément sélectionné. L'indice d'arme est [1,3] et le gilet et le casque sont 1 par défaut.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Perdre de l'équipement lors de l'élimination",
  T_36_WZY_WS_DESTOBJ: "Objets destructibles",
  T_36_WZY_WS_DIRPOINT: "Point directionnel",
  T_36_WZY_WS_DIRPOINTDESC: "Le point de direction à créer",
  T_36_WZY_WS_ELEFINDRES: "Index de la première position d'un élément",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: `Obtenir l'index de la première position d'un élément dans une liste. Si l'élément cible n'existe pas dans la liste, le résultat renverra "-1".`,
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "L'élément à rechercher dans la liste",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: `Obtenir l'index de la dernière position d'un élément dans une liste. Si l'élément cible n'existe pas dans la liste, le résultat renverra "-1".`,
  T_36_WZY_WS_ELELINDRES: "Index de la dernière position d'un élément",
  T_36_WZY_WS_ELEMENTSNUM: "# d'éléments dans la liste",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Se déclenche lorsque l'[Entité de déclenchement] entre en collision avec ce déclencheur",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "L'entité avec laquelle ce déclencheur entre en collision",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Se déclenche lorsqu'une [entité de déclenchement] conduit le véhicule",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "L'entité qui conduit le véhicule",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Se déclenche lorsque le joueur entre dans le déclencheur",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "Le déclencheur pour entrer",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Se déclenche lorsqu'une [entité de déclenchement] quitte le véhicule",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "L'entité qui sort du véhicule",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Se déclenche lorsqu'une [entité de déclenchement] entre dans le véhicule",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "L'entité qui entre dans le véhicule",
  T_36_WZY_WS_ENTITY_TYPE1: "Fréquemment utilisé",
  T_36_WZY_WS_ENTITY_TYPE2: "Propriétés",
  T_36_WZY_WS_ENTITY_TYPE3: "Objets et objets",
  T_36_WZY_WS_ENTITY_TYPE4: "IA",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "La valeur de l'élément à modifier",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Joueur cible",
  T_36_WZY_WS_ENTITYLIST: "Liste des entités",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Se déclenche lorsqu'une [entité de déclenchement] rebondit sur le pneu",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "L'entité qui rebondit sur le pneu",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Se déclenche lorsqu'une [entité de déclenchement] entre dans le portail et est téléportée",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "L'entité qui est téléportée",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "Le type d'armure équipée, y compris le gilet, le casque et le sac à dos",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Se déclenche lorsqu'un joueur équipe avec succès une arme. [Joueur déclencheur] est le joueur qui équipe avec succès une arme. [Entité d'arme] est l'entité d'arme que le joueur a équipée.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "L'entité d'armes équipée",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Type d'arme",
  T_36_WZY_WS_EULERANGLE: "Angles d'Euler",
  T_36_WZY_WS_FACECAMERA: "Toujours face à la caméra",
  T_36_WZY_WS_FLOATLIST: "Liste flottante",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Arrondir une valeur au plus grand nombre entier plus petit que lui-même",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "La valeur à arrondir",
  T_36_WZY_WS_FLOORRES: "Résultat de l'arrondi",
  T_36_WZY_WS_FORMUENT: "Entité formulable par propriété",
  T_36_WZY_WS_FORMUFACT: "Type de facteur de formule de propriété",
  T_36_WZY_WS_GAME_TYPE2: "Jouabilité",
  T_36_WZY_WS_GAME_TYPE3: "Effets spéciaux",
  T_36_WZY_WS_GENENT_NAMEDESC: "Se déclenche lorsqu'un générateur génère des unités. [Liste des entités unitaires] est la liste des unités générées par le générateur. [# de vagues] est le nombre de vagues engendrées par la génération.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Entité unitaire",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "Une liste qui se compose d'entités unitaires générées par un générateur",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "Le nombre de vagues générées par un générateur",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Obtenez tous les magasins du match. La valeur renvoyée est une liste composée d'entités de magasin.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Utilisez le RVB pour obtenir une couleur",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Obtenir le montant d'une certaine devise dans un portefeuille spécifique",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "Le portefeuille à partir duquel obtenir le montant en devise",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "Le type de devise du montant en devise à obtenir",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Obtenir le type d'entité d'une entité cible",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "L'entité dont le type à obtenir",
  T_36_WZY_WS_GETENTTYPERES: "Type d'entité de l'entité cible",
  T_36_WZY_WS_GETFOR_NAME: "Obtenir les coordonnées de direction",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Obtenir le vecteur d'un point de direction désigné",
  T_36_WZY_WS_GETFORRES: "Vecteur du point de direction",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Obtenir l'entité monétaire d'un certain type de devise dans le portefeuille",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "Le portefeuille dans lequel l'entité monétaire est",
  T_36_WZY_WS_GETPOS_NAME: "Obtenir les coordonnées",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Obtenir les coordonnées d'un point de direction désigné",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "Le point de direction désigné",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Type d'équipement",
  T_36_WZY_WS_GETWALLET_NAME: "Obtenir un portefeuille",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Obtenir le portefeuille du propriétaire sélectionné",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Si un portefeuille de liaison existe",
  T_36_WZY_WS_GETWALLETRES: "Entité du portefeuille du propriétaire",
  T_36_WZY_WS_HUDCONTROL_DESC: "L'entité de contrôle d'un HUD",
  T_36_WZY_WS_HUDTYPE: "Type d'HUD",
  T_36_WZY_WS_INCIDENT_TYPE1: "Incident mondial",
  T_36_WZY_WS_INCIDENT_TYPE2: "Incident d'entité",
  T_36_WZY_WS_INDEX_DESC: "Une valeur d'index d'une liste. Commence à 0.",
  T_36_WZY_WS_INTLIST: "Liste d'entiers",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Vérifiez si un type d'entité appartient à une certaine sous-catégorie. Le résultat renvoyé est booléen.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "La catégorie parent pour vérifier si l'entité appartient à",
  T_36_WZY_WS_JENTSUBCLRES: "Résultat de la vérification de la catégorie parent",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Vérifiez si une entité appartient à un certain type d'entité. Le résultat renvoyé est booléen.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "L'entité à vérifier",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Signifie qu'il est identique au type d'entité",
  T_36_WZY_WS_JENTTYPERES: "Résultat du contrôle d'entité",
  T_36_WZY_WS_JUSTPATROL: "Patrouille seulement",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Se déclenche lorsque le joueur quitte la gâchette",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "Le déclencheur pour sortir",
  T_36_WZY_WS_LEVELOBLIST: "Liste d'objets",
  T_36_WZY_WS_LEVOBJSLIST: "Une liste de tous les objets cartographiques de cette correspondance",
  T_36_WZY_WS_LEVOBTYPE: "Type d'objet",
  T_36_WZY_WS_LISTT: "N'importe quelle liste",
  T_36_WZY_WS_LOGCONTEXT_DESC: "Le contenu à imprimer",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "La chaîne de gauche à connecter",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "La bonne chaîne à connecter",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "La valeur de l'élément à ajouter",
  T_36_WZY_WS_LOGOPER: "Lorsque vous effectuez des opérations logiques (et & ou) : si vous utilisez l'opération et et que les deux valeurs booléennes sont VRAI, le résultat est VRAI, et si vous utilisez l'opération ou et que les deux valeurs booléennes ne sont pas toutes les deux FAUX, le résultat est VRAI.",
  T_36_WZY_WS_LOOTPOINT: "Point de butin",
  T_36_WZY_WS_MAINWEAP: "Arme actuelle",
  T_36_WZY_WS_MAX_DESC: "La plage supérieure de l'entier généré (intervalle ouvert)",
  T_36_WZY_WS_MIN_DESC: "La plage inférieure de l'entier généré (intervalle fermé)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Entité d'arme",
  T_36_WZY_WS_MONENT: "Entité monétaire",
  T_36_WZY_WS_MONTYPE: "Type de devise",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Faites bouger l'IA vers un point cible. Utilisez [Return or not] pour sélectionner si l'IA reviendra à sa position d'origine. Utilisez [Attaquer ou non] pour sélectionner si l'IA recherchera les ennemis sur son chemin.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "L'entité IA qui voyagera",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "La destination",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Utilisez pour définir si l'IA reviendra à son emplacement d'origine après son arrivée à destination. VRAI signifie retour ; FAUX signifie ne pas revenir.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Attaquer ou pas",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Utilisez pour définir si l'IA attaquera les ennemis proches en cours de route. TRUE signifie rechercher des ennemis ; FALSE signifie ne pas rechercher d'ennemis.",
  T_36_WZY_WS_MULVALUE: "Scalaire",
  T_36_WZY_WS_MULVEC: "Vecteur de multiplication scalaire",
  T_36_WZY_WS_NEGRES: "Résultat de valeur négatif",
  T_36_WZY_WS_NEUTRAL: "Neutre",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Forcer le générateur désigné à produire la prochaine vague. Les générateurs incluent les spawns de zombies et les spawns d'objets.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Entité génératrice",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "L'entité génératrice désignée, telle que les spawns de zombies et les spawns d'objets",
  T_36_WZY_WS_OBJENT: "Entité objet",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Se déclenche lorsqu'un objet est obtenu. [Type d'élément] est le type d'élément obtenu.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Se déclenche lorsqu'une arme est obtenue. [Entité arme] est l'arme obtenue.",
  T_36_WZY_WS_ONEWAY: "Un seul chemin",
  T_36_WZY_WS_OPENSTATE: "Statut",
  T_36_WZY_WS_OPERMETHOD_NAME: "Opération",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "Les opérations arithmétiques de base. Actuellement, les opérations sur les nombres entiers incluent l'addition, la soustraction, la multiplication, la division et le reste, et les opérations flottantes incluent l'addition, la soustraction, la multiplication et la division.",
  T_36_WZY_WS_OWNERENT_DESC: "L'entité dont le portefeuille à obtenir",
  T_36_WZY_WS_PERCENTAGE: "Ajustement en pourcentage",
  T_36_WZY_WS_PLACOLLIDE_NAME: "Lorsque le joueur entre en collision avec la gâchette",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Se déclenche lorsque le [Joueur déclencheur] entre en collision avec le déclencheur",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "Le joueur qui entre en collision avec la gâchette",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "L'entité objet avec laquelle le joueur entre en collision",
  T_36_WZY_WS_PLADRIVEH_NAME: "Lorsque le joueur conduit un véhicule",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Triggers when the [Joueur déclencheur] drives a vehicle",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "Le joueur qui conduit le véhicule",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "L'entité de véhicule que le joueur conduit",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "Lorsque le joueur quitte le véhicule",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Se déclenche lorsque le [Joueur déclencheur] quitte un véhicule",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "Le joueur qui sort du véhicule",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "L'entité de véhicule que le joueur quitte",
  T_36_WZY_WS_PLAGETONVEH_NAME: "Lorsque le joueur entre dans le véhicule",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Se déclenche lorsque le [Joueur déclencheur] entre dans un véhicule",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "L'entité de véhicule dans laquelle le joueur entre",
  T_36_WZY_WS_PLAKNOFLY_NAME: "Quand le joueur rebondit sur un pneu",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Se déclenche lorsque le [Trigger player] rebondit sur un pneu",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "Le joueur qui rebondit sur un pneu",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "L'entité objet sur laquelle le joueur rebondit",
  T_36_WZY_WS_PLATP_NAME: "Après la téléportation du joueur",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "Le joueur qui utilise un portail",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "L'entité de portail utilisée par le joueur",
  T_36_WZY_WS_PLAYERLIST_DESC: "Une liste de tous les joueurs de ce match",
  T_36_WZY_WS_POINTPICKER: "Pivot de chemin",
  T_36_WZY_WS_PORTALENT: "Entité portail",
  T_36_WZY_WS_PREFAB: "Modèle",
  T_36_WZY_WS_PRODLIST: "Liste des marchandises",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Ordre de tri",
  T_36_WZY_WS_PROPMOD: "Méthode de changement de propriété",
  T_36_WZY_WS_RANKABLEE: "Entité classable",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Consommer une certaine quantité de devise désignée dans un portefeuille désigné",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "Le portefeuille qui dépense la monnaie",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "Le type de devise consommé",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "Le montant de la monnaie consommée",
  T_36_WZY_WS_RNDFRES: "Flottant aléatoire généré",
  T_36_WZY_WS_RNDIRES: "Résultat de la génération aléatoire d'entiers",
  T_36_WZY_WS_ROUND_NAME_DESC: "Arrondir une valeur à l'entier le plus proche",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "La valeur à arrondir",
  T_36_WZY_WS_ROUNDRES: "Résultat de l'arrondi",
  T_36_WZY_WS_RUNAI_NAMEDESC: "L'arbre de comportement que l'IA sélectionnée exécutera",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "L'entité unitaire qui arrête/exécute un arbre de comportement par défaut",
  T_36_WZY_WS_SCOREABLEE: "Entité évaluable",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Se déclenche lorsque le score change. [Type de score] est le type de score qui a changé. [Score] est le nouveau score.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Créer un point de direction",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Obtenez un point de direction nouvellement créé. Utilisez [Emplacement] pour définir les coordonnées du point et [Direction] pour définir le vecteur de la direction.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "Les coordonnées du point directeur",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Direction",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "Le vecteur du point directeur",
  T_36_WZY_WS_SETPATH_NAMEDESC: "Les entités IA voyageront selon l'ordre défini ici. Les types de voyage disponibles sont les allers-retours, les allers simples et les allers-retours. Vous pouvez également choisir si l'IA recherchera les ennemis sur son chemin.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "Une liste qui comprend les points vers lesquels l'IA doit se rendre",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Type de voyage",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "Ce sont les types de voyage. L'aller simple consiste pour l'IA à arrêter de voyager une fois arrivée à destination. Le retour circulaire permet à l'IA de rechercher un chemin de retour une fois qu'elle est arrivée à destination. L'aller-retour est pour l'IA le retour à l'emplacement d'origine selon l'ordre inverse de la liste des chemins.",
  T_36_WZY_WS_SHOPECON: "Magasin et économie",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Utilisez pour afficher les notifications qui flottent sur l'écran. Configurez le contenu à l'aide de [Texte], la couleur du texte à l'aide de [Couleur] et la durée d'affichage à l'aide de [Durée] (l'unité est la milliseconde).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "Le contenu de la notification flottante",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "La couleur de la notification flottante",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "La durée d'affichage de la notification flottante, en millisecondes",
  T_36_WZY_WS_SIN_NAMEDESC: "Trouver le sinus d'un angle",
  T_36_WZY_WS_SINRES: "Sinus de l'angle",
  T_36_WZY_WS_SKIPKNODOWN: "Qu'il soit éliminé lors d'un renversement",
  T_36_WZY_WS_SQRTRES: "Résultat racine carrée",
  T_36_WZY_WS_STRCONRES: "Résultat de la connexion de chaîne",
  T_36_WZY_WS_STRINGLIST: "Liste de chaînes",
  T_36_WZY_WS_STRLEN: "Longueur de chaine",
  T_36_WZY_WS_STRVAL: "Résultat de la chaîne",
  T_36_WZY_WS_TAN_NAMEDESC: "Trouver la tangente d'un angle",
  T_36_WZY_WS_TANRES: "Tangente de l'angle",
  T_36_WZY_WS_TEAMLIST: "Liste d'équipe",
  T_36_WZY_WS_TEAMLIST_DESC: "Une liste de toutes les équipes de ce match",
  T_36_WZY_WS_TIMETWEENTIPS: "Entité de notification de compte à rebours",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Convertir la valeur cible en chaîne",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "La valeur cible à convertir en chaîne",
  T_36_WZY_WS_TOSTRINGRES: "Résultat de la conversion de chaîne",
  T_36_WZY_WS_TOWERCAMP_DESC: "Le numéro de côté et le numéro d'équipe sont les mêmes. Les tours et forteresses neutres attaquent tous les joueurs et IA à portée.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Transférez une certaine quantité de devise désignée d'un portefeuille à un autre",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "Le portefeuille pour transférer la devise hors de",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "Le type de devise dans la transaction",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "Le montant de la devise dans la transaction",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "Le portefeuille pour transférer la monnaie dans",
  T_36_WZY_WS_TWEENTIPS: "Entité de notification flottante",
  T_36_WZY_WS_TYPEENUM: "Type d'énumération",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Se déclenche lorsqu'un joueur utilise un objet. [Joueur déclencheur] est le joueur qui utilise un objet. [Type d'objet] est l'objet utilisé par le joueur.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "Le type d'objet utilisé par le joueur",
  T_36_WZY_WS_VECADDLEFT: "Valeur de gauche de l'addition vectorielle",
  T_36_WZY_WS_VECADDRES: "Résultat de l'addition vectorielle",
  T_36_WZY_WS_VECADDRIGHT: "Valeur correcte de l'addition vectorielle",
  T_36_WZY_WS_VECANGLEFT: "Valeur gauche de l'angle des vecteurs",
  T_36_WZY_WS_VECANGRES: "Angle entre 2 vecteurs",
  T_36_WZY_WS_VECANGRIGHT: "Valeur droite des vecteurs angle",
  T_36_WZY_WS_VECCROLEFT: "Valeur de gauche du produit vectoriel",
  T_36_WZY_WS_VECCRORES: "Résultat du produit croisé",
  T_36_WZY_WS_VECCRORIGHT: "La bonne valeur du produit croisé",
  T_36_WZY_WS_VECDISLEFT: "Valeur de gauche de la distance des vecteurs",
  T_36_WZY_WS_VECDISRES: "Distance entre 2 vecteurs",
  T_36_WZY_WS_VECDISRIGHT: "La bonne valeur de la distance des vecteurs",
  T_36_WZY_WS_VECDOCLEFT: "Valeur de gauche du produit scalaire",
  T_36_WZY_WS_VECDOCRES: "Résultat du produit scalaire",
  T_36_WZY_WS_VECDOCRIGHT: "La bonne valeur du produit scalaire",
  T_36_WZY_WS_VECMULRES: "Résultat de la multiplication scalaire",
  T_36_WZY_WS_VECNORRES: "Vecteur normalisé",
  T_36_WZY_WS_VECSIZERES: "Magnitude d'un vecteur",
  T_36_WZY_WS_VECSUBLEFT: "Valeur de gauche de la soustraction vectorielle",
  T_36_WZY_WS_VECSUBRES: "Résultat de la soustraction vectorielle",
  T_36_WZY_WS_VECSUBRIGHT: "Bonne valeur de la soustraction vectorielle",
  T_36_WZY_WS_VECTORLIST: "Liste vectorielle",
  T_36_WZY_WS_VECX: "x composant",
  T_36_WZY_WS_VECY: "composant y",
  T_36_WZY_WS_VECZ: "composante z",
  T_36_WZY_WS_VEHENT: "Entité véhicule",
  T_36_WZY_WS_WALLCONT: "Contenu du portefeuille",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Continu",
  T_36_XYL_WS_AIBOT: "Unité",
  T_36_XYL_WS_AIGENERATOR: "Générateur d'unité",
  T_36_XYL_WS_AIGENERATOR_DESC: "Un générateur qui peut générer en continu des unités désignées (par exemple des zombies)",
  T_36_XYL_WS_AIWAVE: "# d'unités par vague",
  T_36_XYL_WS_ARROW: "Panneau de direction",
  T_36_XYL_WS_ARROW_DESC: "Un signe qui indique une direction",
  T_36_XYL_WS_BREAKBOX: "Boîte cassable",
  T_36_XYL_WS_BREAKBOX_DESC: "Une boîte en bois qui peut être brisée en cas d'attaque",
  T_36_XYL_WS_FENCE: "Clôture de fer",
  T_36_XYL_WS_FENCE_DESC: "Une clôture qui permet aux balles de voler à travers",
  T_36_XYL_WS_STAIRI: "Atterrissage C",
  T_36_XYL_WS_STAIRI_DESC: "Une plate-forme qui peut être combinée avec des escaliers",
  T_36_XYL_WS_ZOMBIEAI: "Zombi",
  T_36_XYL_WS_ZOMBIEAI_DESC: "Un zombie qui peut être personnalisé et être un sujet obtenu et dupliqué dans le générateur d'unités",
  T_36_YF_CORRODE_GRENADE_N: "Fondeur de Gloo",
  T_36_YF_SETTING_TYPE3: "Préréglage 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "Maillot CBF Océan (Bas)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "Maillot CBF de Soleil (Bas)",
  T_36_YS_F_A_GHOSTHUNTER: "Sétaire diabolique (Masque)",
  T_36_YS_F_B_GHOSTHUNTER: "Sétaire diabolique (Bas)",
  T_36_YS_F_H_GHOSTHUNTER: "Sétaire diabolique (Tête)",
  T_36_YS_F_S_GHOSTHUNTER: "Sétaire diabolique (Chaussures)",
  T_36_YS_SETTING_GRENADE: "Jetables",
  T_36_YS_SETTING_MOVE: "Mouvement",
  T_36_YS_T_BRFOOTBALL_BLUE01: "Maillot CBF Océan (Haut)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "Maillot CBF de Soleil",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Croc",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Skin d'animal Zasil violet",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Skin D'animal: Falco d'Éclair",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Skin d'animal Fang de Lava",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Skin d'animal: Guide spectral",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Skin d'animal Fang arctique",
  T_37_B_WS_HIDE: "Cache-Cache",
  T_37_HZ_WS_CATMODEDESC1: "Cache-Cache",
  T_37_JH_WS_CREATEGOLD_DESC: "Un distributeur automatique à partir duquel les joueurs peuvent acheter des objets. (Non valable dans les modes Clash Squad, Team Deathmatch, Playground et Droïde Apocalypse)",
  T_37_JH_WS_NAME1: "Couteau FF (Droïde Apocalypse)",
  T_37_JH_WS_NAME10: "M1887-X (Droïde Apocalypse)",
  T_37_JH_WS_NAME11: "SPAS12 (Droïde Apocalypse)",
  T_37_JH_WS_NAME12: "M1014 (Droïde Apocalypse)",
  T_37_JH_WS_NAME13: "MP40 (Droïde Apocalypse)",
  T_37_JH_WS_NAME14: "MP5-III (Droïde Apocalypse)",
  T_37_JH_WS_NAME15: "P90 (Droïde Apocalypse)",
  T_37_JH_WS_NAME16: "M60-III (Droïde Apocalypse)",
  T_37_JH_WS_NAME17: "Thompson (Droïde Apocalypse)",
  T_37_JH_WS_NAME18: "UMP (Droïde Apocalypse)",
  T_37_JH_WS_NAME19: "SVD (Droïde Apocalypse)",
  T_37_JH_WS_NAME2: "Groza (Droïde Apocalypse)",
  T_37_JH_WS_NAME20: "AWM (Droïde Apocalypse)",
  T_37_JH_WS_NAME21: "M82B (Droïde Apocalypse)",
  T_37_JH_WS_NAME22: "M249-X (Droïde Apocalypse)",
  T_37_JH_WS_NAME23: "Kar98k-III (Droïde Apocalypse)",
  T_37_JH_WS_NAME3: "AK47 (Droïde Apocalypse)",
  T_37_JH_WS_NAME4: "M4A1-III (Droïde Apocalypse)",
  T_37_JH_WS_NAME5: "SCAR (Droïde Apocalypse)",
  T_37_JH_WS_NAME6: "M14-III (Droïde Apocalypse)",
  T_37_JH_WS_NAME7: "PARAFAL (Droïde Apocalypse)",
  T_37_JH_WS_NAME8: "XM8 (Droïde Apocalypse)",
  T_37_JH_WS_NAME9: "MAG-7 (Droïde Apocalypse)",
  T_37_JH_WS_VENDMACHINE_DESC: "De l'or qui peut être ramassé sur la carte. (Non valable dans les modes Clash Squad, Team Deathmatch, Playground et Droïde Apocalypse)",
  T_37_JH_WS_X: "Axe X",
  T_37_JH_WS_Y: "Axe Y",
  T_37_JH_WS_Z: "Axe z",
  T_37_JL_FOOTBALL_TIE: "Cravate",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Bonhomme de neige Waggor",
  T_37_LC_BP_ENTRANCE_GIFT: "Cadeau!",
  T_37_M_WS_MISSING: "Source manquante",
  T_37_M_WS_NAMEERROR: "Contient des caractères sensibles. S'il vous plaît changer.",
  T_37_PD_HuntingGround_BOSSTITLE: "Le boucher",
  T_37_QL_JUMPPAD_DES: "Crée une rampe de saut au sol. Il peut être utilisé pour sauter haut dans les airs et permet le tir aérien.",
  T_37_QL_JUMPPAD_NAME: "Trampoline",
  T_37_R_TAILOR_LIMIT: "Temps limité",
  T_37_RW_LOADOUT_BORNFIRETAG: "Obtenez 2 Bonfires au début du match. Bonfire [FFBA00] régénère 5 HP et 20 EP par seconde [-] (jusqu'à 10 secondes) pour vous et vos coéquipiers dans la zone. Les effets de feu de joie ne se cumulent pas.",
  T_37_RW_PROPCATAPULT_DESC: "Une fois gonflée, la rampe de lancement peut être utilisée pour projeter un joueur dans les airs. Mais assurez-vous de rester dans la zone de sécurité !",
  T_37_RW_PROPCATAPULT_NAME: "Rampe de lancement",
  T_37_SP_WS_COLOR_02: "Couleur",
  T_37_SP_WS_COLOR_03: "Apparence",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "L'entité est nulle lors de l'obtention ou de la définition de sa propriété",
  T_37_SP_WS_LOG_PHASE_END: "L'étape {0} est terminée.",
  T_37_SP_WS_LOG_PHASE_START: "L'étape {0} commence",
  T_37_SP_WS_LOG_ROUND_END: "Tour {0} terminé.",
  T_37_SP_WS_LOG_ROUND_START: "Le tour {0} a commencé.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Type non concordant lors de l'attribution d'une valeur à la variable. Type actuel : {0}. Type requis : {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Variable locale indéfinie ou hors champ {0}",
  T_37_SP_WS_MAPACCESS_08: "Éditer",
  T_37_SP_WS_RACEMODE_01: "Mode compte à rebours",
  T_37_SP_WS_RACEMODE_02: "Compte à rebours",
  T_37_SP_WS_RACEMODE_04: "Lorsque cette option est activée, un compte à rebours s'enclenche lorsqu'une équipe entière atteint le point d'arrivée. Le jeu se termine à la fin du compte à rebours.",
  T_37_SY_AR15_KABUKI_N: "Kingfisher - Chanson d'Hana",
  T_37_SY_BACKPACK_STRAW_N: "Sac à dos - Chapeau de paille",
  T_37_SY_GRENADE_FFWS2022_01_N: "Grenade - Étoile Marine",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Trou noir",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Morsure de Mamba",
  T_37_SY_PET_FLYINGCREATURE_N: "Arvon",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Skin d'Animal: Beanie Glam star",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Skin d'Animal: Frêne Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Skin d'Animal: Galaxie Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Skin d'Animal: Arvon mythe du feu",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Skin d'Animal: Flash de pied",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Skin d'Animal: Yéti de Winterlands",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Jeep - Rockin' Festival Ride",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Pickup - Bête de Mer",
  T_37_WT_WS_PVE2DESC: `Un mode de survie zombie où les joueurs éliminent un certain nombre de zombies dans un temps limité ou survivent jusqu'à la fin.
Vous pouvez définir les règles du jeu et ajuster les paramètres des zombies comme vous le souhaitez, y compris le nombre cible de zombies à éliminer.`,
  T_37_WT_WS_RULEDESC: "Éliminez le nombre cible de zombies pour gagner.",
  T_37_WT_WS_RULETITLE: "Goal",
  T_37_WT_WS_TXT1: "Éliminer les zombies",
  T_37_WT_WS_TXT1DESC: "Lorsque cette option est activée, les joueurs gagnent en éliminant le nombre spécifié de zombies. Lorsqu'il est désactivé, les joueurs gagnent en survivant jusqu'à la fin.",
  T_37_WT_WS_TXT2: "Montant d'élimination",
  T_37_WZY_FRIDPLA: "Joueur amical",
  T_37_WZY_FRIDSIDE: "Faction amicale",
  T_37_WZY_FRIDTEAM: "Equipe sympathique",
  T_37_WZY_HOSTPLA: "Joueur ennemi",
  T_37_WZY_HOSTSIDE: "Faction ennemie",
  T_37_WZY_WS_ACCFRAMES: "Images cumulées",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Ajouter des articles à une marchandise. Vous pouvez ajouter un élément unique ou un groupe d'éléments. Le montant peut être soit le nombre d'articles individuels, soit une liste composée d'articles de ce montant.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "L'entité de marchandise à laquelle ajouter des articles",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "Les éléments à ajouter. Vous pouvez ajouter un élément unique ou un groupe d'éléments.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "Le montant des éléments individuels à ajouter ou une liste composée d'éléments de ce montant.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Ajouter une balise pour l'entité sélectionnée",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "L'entité à laquelle ajouter la balise",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "Le contenu textuel à ajouter",
  T_37_WZY_WS_AIMABLEENT: "Entité visée",
  T_37_WZY_WS_AIMASSISTTYPE: "Type d'aide à la visée",
  T_37_WZY_WS_ALLOWDROP_NAME: "Activer/désactiver le dépôt d'éléments",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Si un joueur peut déposer des objets",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "L'entité du joueur pour configurer s'il faut déposer des éléments",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Indique si un joueur peut déposer des objets. C'est la valeur booléenne.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Activer/désactiver le ramassage d'articles",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Si un joueur peut ramasser des objets",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "L'entité du joueur pour configurer s'il faut ramasser des objets",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Si un joueur peut ramasser des objets. C'est la valeur booléenne.",
  T_37_WZY_WS_AMBIENTCOLOR: "Couleur de la lumière d'ambiance",
  T_37_WZY_WS_AMRORTOOL: "Réparation d'armure",
  T_37_WZY_WS_ATTACK: "Attaquer",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Annulez le déguisement du joueur pour qu'il retrouve son apparence normale",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "L'entité joueur dont le déguisement à annuler",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Augmenter la vitesse d'un ballon de football",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "Le ballon de foot pour booster la vitesse",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "Le vecteur vitesse du boost",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Se déclenche lorsque le football est touché par le Football Shooter. [Player entity] est le joueur qui possède le Football Shooter. [Speed boost] est la vitesse supplémentaire du ballon après avoir été touché.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "Le joueur qui possède le Tireur de foot",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "Le vecteur vitesse du ballon après qu'il ait été touché",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Se déclenche lorsque le ballon entre en collision avec une entité et que la vitesse du ballon augmente. [Entité en collision] est l'entité qui entre en collision avec le ballon de football. [Speed boost] est la vitesse supplémentaire du ballon après la collision.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "L'entité qui entre en collision avec le football",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "Le vecteur vitesse qui est ajouté au ballon lors d'une collision",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Se déclenche lorsque l'entité est visée par un joueur",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "Le joueur qui vise l'entité",
  T_37_WZY_WS_BEHAVIORSTAT: "État du comportement du joueur",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "L'entité d'arme qui frappe cette entité",
  T_37_WZY_WS_BLOODBARENT: "Entité barre de santé",
  T_37_WZY_WS_BOMBEND: "Avant l'explosion",
  T_37_WZY_WS_BOMBSTART: "Indication de bombe",
  T_37_WZY_WS_CHANENT: "Entité de canal",
  T_37_WZY_WS_CHEER: "Bravo",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Vérifier si une entité sélectionnée contient des balises désignées",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "L'entité pour vérifier si elle contient des balises",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "La balise à vérifier",
  T_37_WZY_WS_CHELABELRES: "Le résultat de la vérification des balises. Il s'agit d'une valeur booléenne.",
  T_37_WZY_WS_CJERSEY_NAME: "Changer de maillot",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "Le joueur dont le maillot à changer",
  T_37_WZY_WS_CJERSEY_PARAM2: "Conception de maillot",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "Le design à changer",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "La couleur de la partie 1 sur le maillot",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "La couleur de la partie 2 sur le maillot",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "La couleur de la partie 3 sur le maillot",
  T_37_WZY_WS_CJERSEYTYPE1: "Conception 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Conception 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Conception 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Effacer tous les éléments de la liste",
  T_37_WZY_WS_CREABLEOB_DESC: "Le type d'objet qui peut être créé à l'aide de blocs",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Créez une marchandise personnalisable et renvoyez une entité de marchandise. Le contenu de la marchandise peut être configuré via les paramètres de propriété.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Créez une liste de marchandises personnalisable et renvoyez une entité de liste de marchandises. Le contenu de cette liste peut être modifié via les paramètres de propriété.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "L'entité liste de marchandises à créer",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Créer une entité de faction",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "L'entité de faction à créer",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Créez une boutique personnalisable et renvoyez une entité de boutique. Le contenu du magasin peut être modifié via les paramètres de propriété.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "L'entité magasin créée",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Changez l'environnement du ciel dans le jeu. Les options incluent le jour, le crépuscule et la nuit.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "Le type de ciel à changer. Les options incluent le jour, le crépuscule et la nuit.",
  T_37_WZY_WS_DARKNESS: "Obscurité générale",
  T_37_WZY_WS_DELENT_NAMEDESC: "Supprimer une entité désignée. Prend actuellement en charge l'entité d'icône, l'entité de texte, l'entité HUD, l'entité d'effets visuels, l'entité d'arme et d'autres entités d'objet.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "L'entité à supprimer",
  T_37_WZY_WS_DROP: "Erreur",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Se déclenche lorsque le joueur fait tomber un objet. [Type d'élément] est l'ID du type d'élément déposé.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "L'ID de type de l'élément déposé",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Se déclenche lorsque le joueur laisse tomber une arme. [Entité d'arme] est l'arme larguée.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "L'arme qui tombe",
  T_37_WZY_WS_DUMMYLEOBJ: "Objet de scène régulier",
  T_37_WZY_WS_DUST: "Crépuscule",
  T_37_WZY_WS_EMPTYCH: "Canal vide par défaut",
  T_37_WZY_WS_EMPTYCH1: "Canal vide 1",
  T_37_WZY_WS_EMPTYCH2: "Canal vide 2",
  T_37_WZY_WS_EMPTYCH3: "Canal vide 3",
  T_37_WZY_WS_EMPTYCH4: "Canal vide 4",
  T_37_WZY_WS_EMPTYCH5: "Canal vide 5",
  T_37_WZY_WS_EMPTYCH6: "Canal vide 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: `Obtenez une liste qui contient toutes les entités qui satisfont les 3 conditions. Le contenu inséré pour "Inclut tout", "Exclut" et "Inclut" est un type de composant unique ou une liste de types de composants. Le résultat renvoyé est une liste d'entités qui satisfont aux conditions.`,
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "Les entités filtrées doivent contenir tous les composants de ce tableau",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "Les entités filtrées ne doivent pas contenir de composant(s) désigné(s) de ce tableau",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "Les entités filtrées doivent contenir au moins un composant de ce tableau",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "Le type de propriété de cette entité à modifier",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "La valeur de la propriété à modifier",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Laissez le joueur quitter le canal actuel afin qu'il ne soit dans aucun canal",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "Le joueur quitte la chaîne",
  T_37_WZY_WS_FAKEENT: "Entité déguisée",
  T_37_WZY_WS_FIND_STR_DESC: "Trouver l'emplacement d'un texte désigné dans une chaîne",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "Le personnage à trouver",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Trouvez une chaîne à partir de l'emplacement de départ, qui commence à partir de 0.",
  T_37_WZY_WS_FINDSTRRES: "Le premier emplacement où la chaîne apparaît. Commence à 0.",
  T_37_WZY_WS_FOGCOLOR: "Couleur du brouillard",
  T_37_WZY_WS_FRICTIONCON: "Multiplicateur de frottement régulier",
  T_37_WZY_WS_FRICTIONIMP: "Multiplicateur de frottement de collision",
  T_37_WZY_WS_FROMDEATH: "Relance",
  T_37_WZY_WS_FROMKNODOWN: "Aider à se relever",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Obtenir le canal dans lequel se trouve le joueur désigné",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "L'entité joueur dont le canal à obtenir",
  T_37_WZY_WS_GETCHANRES: "Le canal dans lequel le joueur est actuellement",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "Selon les ID de canal 1 à 8, obtenez le canal vide qui a été créé par défaut au début du jeu",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID du canal vide par défaut",
  T_37_WZY_WS_GETEMPTYCH_RES: "L'entité de canal obtenue",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Obtenir l'entité de déguisement d'un joueur",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "L'objet dont l'entité de déguisement à obtenir",
  T_37_WZY_WS_GETGAMEENT_NAME: "Soyez global",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Obtenir l'entité de jeu de ce match",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Obtenir un joueur attaquant",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Entité de faction",
  T_37_WZY_WS_GOAL_NAMEDESC: "Se déclenche lorsqu'un ballon entre dans le but. [Goal] est le but dans lequel ce football entre. [Buteur] est le dernier joueur à avoir touché le ballon. [Assist] est l'avant-dernier joueur à avoir touché le ballon.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "Le but que ce football entre",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "Le dernier joueur à être entré en contact avec le ballon",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "L'avant-dernier joueur à être entré en contact avec le ballon",
  T_37_WZY_WS_HEARTBEAT: "Battement de coeur",
  T_37_WZY_WS_HEAVYWEAPON: "Arme lourde",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Angle de volée le plus petit",
  T_37_WZY_WS_HOSTPLA: "Une liste de joueurs attaquants",
  T_37_WZY_WS_HOSTSIDE: "Une liste des factions attaquables",
  T_37_WZY_WS_HOSTTEAM: "Une liste des équipes attaquables",
  T_37_WZY_WS_ICON_CLOCK: "Compte à rebours",
  T_37_WZY_WS_ICON_CLOTHES: "Vêtements",
  T_37_WZY_WS_ICON_QUIT: "Sortir",
  T_37_WZY_WS_INSERT_ARR_DESC: "Insérer un nouvel élément à un emplacement désigné dans la liste",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Extraire une chaîne d'une longueur désignée, à partir de l'emplacement de l'index. Si la longueur d'extraction dépasse la longueur de la chaîne, le contenu sera extrait jusqu'à la fin de la chaîne.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Durée de l'extraction",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "La chaîne qui a été extraite",
  T_37_WZY_WS_INTORINTL: "Entier ou liste d'entiers",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Laisser un joueur rejoindre une faction désignée",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "La faction que le joueur doit rejoindre",
  T_37_WZY_WS_JUMP: "Sauter",
  T_37_WZY_WS_LABEL: "Tag",
  T_37_WZY_WS_LENSFLARE: "Reflet",
  T_37_WZY_WS_LENTH: "Longueur",
  T_37_WZY_WS_LIGHTATTACK: "Coup réussi",
  T_37_WZY_WS_LIGHTCOLOR: "Couleur de la source lumineuse",
  T_37_WZY_WS_LIGHTINTENSITY: "Luminosité de la source lumineuse",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Charger une nouvelle scène",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "Le nom de la scène à charger",
  T_37_WZY_WS_MOROBJECT: "Objet de déguisement",
  T_37_WZY_WS_MOVEAXISX: "Déplacer le long de l'axe x",
  T_37_WZY_WS_MOVEAXISY: "Déplacer le long de l'axe y",
  T_37_WZY_WS_MOVEAXISZ: "Déplacer le long de l'axe z",
  T_37_WZY_WS_MOVEDISTITLE: "Distance de déplacement",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Activer/Désactiver les messages rapides",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Activez ou désactivez les messages rapides. Lorsqu'il est désactivé, le HUD de messages rapides ne peut pas être utilisé et les joueurs ne pourront pas envoyer ou recevoir de messages rapides.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "Le lecteur pour activer/désactiver les messages rapides pour",
  T_37_WZY_WS_MUTEVOICE_NAME: "Activer/Désactiver le chat vocal",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Activez ou désactivez le chat vocal. Lorsqu'il est désactivé, le HUD vocal ne peut pas être utilisé et les joueurs ne pourront pas envoyer ou recevoir de messages vocaux.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "Le joueur pour activer/désactiver le chat vocal pour",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Booléen. Vrai signifie désactivé ; Faux signifie activé.",
  T_37_WZY_WS_NIGHTMODE: "Mode nuit",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Se déclenche lorsque le joueur vise une entité pouvant viser. [Target entity] est l'entité visée. Lorsqu'aucune entité n'est visée, la valeur de retour est nulle.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Entité visée",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "L'entité que l'arme a touchée",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Se déclenche lorsque la scène se charge avec succès",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "Le nom de la scène à charger. Ceci est une chaîne.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Se déclenche lorsque le décor change avec succès",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "Nom du nouveau décor. Ceci est une chaîne.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Restaurer les vêtements du joueur à leur apparence par défaut",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "Le joueur dont les vêtements par défaut doivent être restaurés",
  T_37_WZY_WS_PETSET: "Réglage des Animaux",
  T_37_WZY_WS_PETSKILL: "Compétences des animaux",
  T_37_WZY_WS_PETSWITCH2: "Si les compétences des animaux peuvent être utilisées",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Activer ou non le mouvement du joueur. Il s'agit d'une valeur booléenne.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Type de comportement du joueur",
  T_37_WZY_WS_PRESS: "Clic doux",
  T_37_WZY_WS_PROGRESS: "Progrès en cours",
  T_37_WZY_WS_PROGRESSBAR: "Entité HUD de progression",
  T_37_WZY_WS_RANKDOWN: "Classement vers le bas",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Supprimer une balise pour l'entité sélectionnée",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "Le contenu textuel à supprimer",
  T_37_WZY_WS_REPLACE_STR_DESC: "Remplacer le contenu d'une chaîne par un contenu désigné",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "Le personnage à remplacer",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "Le nouveau caractère à remplacer par",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Inverser tous les éléments de cette liste",
  T_37_WZY_WS_REVIVEHERE: "Le joueur qui fait revivre ses coéquipiers à ce point de relance",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Se déclenche lorsqu'un joueur fait revivre ses coéquipiers à ce point de relance",
  T_37_WZY_WS_REVIVEWAYDESC: "La méthode par laquelle un joueur est réanimé ou aidé après avoir été éliminé ou renversé",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Configurez le statut des différents comportements des joueurs. Lorsqu'il est désactivé, les boutons correspondants sur le HUD ne peuvent pas être utilisés et les mouvements manuels et automatiques ne sont pas autorisés. Lorsqu'ils sont masqués, les boutons correspondants ne seront pas affichés sur le HUD et les mouvements manuels ne sont pas autorisés tandis que les mouvements automatiques sont autorisés. Lorsqu'il est activé, les boutons correspondants seront affichés sur le HUD, et les mouvements manuels et automatiques sont autorisés.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "Le joueur pour lequel définir le statut de comportement",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "Le comportement du joueur, y compris se déplacer, attaquer, sauter et sprinter",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "L'état comprend désactivé, masqué et activé. Lorsqu'ils sont masqués, les boutons correspondants ne seront pas affichés sur le HUD et les mouvements manuels ne sont pas autorisés tandis que les mouvements automatiques sont autorisés. Lorsqu'il est activé, les boutons correspondants seront affichés sur le HUD, et les mouvements manuels et automatiques sont autorisés.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "Les coordonnées du foot",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Si le ballon doit maintenir sa vitesse de pré-configuration. Il s'agit d'une valeur booléenne.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Paramètre d'attaque du joueur",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Configurez si [Setting player] peut attaquer [Target player]. Le paramètre par défaut est basé sur l'appartenance ou non du joueur ciblé à une équipe et à une faction qui peuvent être attaquées. Ce paramètre a une priorité plus élevée que le paramètre d'équipe/faction.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "Le joueur pour lequel configurer les ennemis",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "Le joueur qui est l'ennemi",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Attaquable ou non",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: `"Oui" signifie attaquable ; "Non" signifie non attaquable. Le paramètre par défaut est basé sur l'appartenance ou non du joueur ciblé à une équipe et à une faction qui peuvent être attaquées.`,
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"Oui" signifie attaquable ; "Non" signifie non attaquable',
  T_37_WZY_WS_SHADOWSTRENGTH: "Ombres",
  T_37_WZY_WS_SHOOTANGLE: "Angle de prise de vue le plus petit",
  T_37_WZY_WS_SKYBOX: "Ciel",
  T_37_WZY_WS_SKYBOXENT: "Entité du ciel",
  T_37_WZY_WS_SKYBOXTYPE: "Types de ciel de base",
  T_37_WZY_WS_STEPPED: "Marche sur la gâchette",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Changer le canal de chat vocal du joueur",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "Le lecteur pour changer de chaîne",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "Le canal vers lequel basculer",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Passer à un décor désigné",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "Le nom de la scène vers laquelle basculer",
  T_37_WZY_WS_TARGETSTR_DESC: "Chaîne cible",
  T_37_WZY_WS_TEAMASIDE: "Équipe et faction",
  T_37_WZY_WS_TELEPORTN_AUTO: "Automatique",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Téléportable ou non",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Manuel",
  T_37_WZY_WS_TELEPORTN_NO: "No",
  T_37_WZY_WS_TELEPORTN_TITLE: "Méthode de téléportation",
  T_37_WZY_WS_TELEPORTN_YES: "Oui",
  T_37_WZY_WS_TERRAINWET: "Humidité du terrain",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Remplacez l'apparence d'une [Player entity] par l'apparence d'un [Scenery object]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "L'entité du joueur dont l'apparence doit changer",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "Le joueur dont l'entité de déguisement à obtenir",
  T_37_WZY_WS_TRANSP: "Transparence",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Désinstaller une scène désignée",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "Le nom de la scène à désinstaller",
  T_37_WZY_WS_VFX1: "Symbolique",
  T_37_WZY_WS_VFX2: "Charbonneux",
  T_37_WZY_WS_VFX3: "Explosion de malédiction",
  T_37_WZY_WS_VFX5: "Congelé",
  T_37_WZY_WS_VFX6: "Projecteur",
  T_37_WZY_WS_VFX7: "Turbulence ascendante",
  T_37_WZY_WS_VFX8: "Explosion d'atmosphère",
  T_37_WZY_WS_VISABLE: "Visibilité",
  T_37_WZY_WS_WEAOPEN: "Afficher ou pas",
  T_37_WZY_WS_WEAPONENT: "Entité d'arme",
  T_37_WZY_WS_WEATARGETED: "Peut-il être ciblé par l'aide à la visée",
  T_37_XYL_CUSTOMJERSEY: "Machine à maillot",
  T_37_XYL_CUSTOMJERSEY_DESC: "Utilisez la Machine à maillot pour créer votre maillot idéal",
  T_37_XYL_FOOTGUN: "Tireur de Foot",
  T_37_XYL_SOCCER: "Football",
  "T_37_XYL_SOCCER_ RADIUS": "Rayon",
  T_37_XYL_SOCCER_DESC: "Un ballon de football dont les propriétés peuvent être personnalisées",
  T_37_XYL_SOCCER_HIGHT1: "Angle régulier",
  T_37_XYL_SOCCER_HIGHT2: "Angle de volée",
  T_37_XYL_SOCCER_RESET: "Réinitialiser le temps après un but (s)",
  T_37_XYL_SOCCER_RESIST1: "Frottement (mode coup de pied)",
  T_37_XYL_SOCCER_RESIST2: "Friction (mode d'arme)",
  T_37_XYL_SOCCERGOAL: "Goal",
  T_37_XYL_SOCCERGOAL_DESC: "C'est le but. Tirez le ballon de football dans le but pour marquer. (Valable uniquement dans Points Grab.)",
  T_37_XYL_SOCCERITEM: "Apparition d'objets",
  T_37_XYL_SOCCERITEM_DESC: "Une fois placé, il générera l'élément sélectionné",
  T_37_XYL_SPAWN_PEOPLE: "# de joueurs",
  T_37_XYL_WS_AIRCONDITIONER001: "Climatiseur B",
  T_37_XYL_WS_AMMUCHEST: "Coffre de guerre A",
  T_37_XYL_WS_BAFFLE001: "Barrière A",
  T_37_XYL_WS_BARREL001: "Fûts",
  T_37_XYL_WS_BARREL001_DES: "Fûts en bois circulaires couramment vus",
  T_37_XYL_WS_BOARD001: "Tableau publicitaire B",
  T_37_XYL_WS_BOOK001: "Pile de livres A",
  T_37_XYL_WS_BOOK002: "Jeu de plateau A",
  T_37_XYL_WS_BOUGAINVILLEA: "Bougainvillier",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Decor - illumine l'endroit !",
  T_37_XYL_WS_BOX001: "Pile de boîtes A",
  T_37_XYL_WS_BOX002: "Petite boîte",
  T_37_XYL_WS_BUSHCOVER: "Buisson",
  T_37_XYL_WS_BUSHCOVER_DES: "Un buisson qui peut être utilisé pour se cacher",
  T_37_XYL_WS_CABINET001: "Tiroirs A",
  T_37_XYL_WS_CHAIR001: "Chaise A",
  T_37_XYL_WS_COCONUTTREE: "Cocotier",
  T_37_XYL_WS_COCONUTTREE_DES: "Decor - Pour une ambiance beachy !",
  T_37_XYL_WS_COMPUTER001: "Ordinateur A",
  T_37_XYL_WS_DAMAGERATIO: "Taux de dégâts",
  T_37_XYL_WS_FIREEX: "Extincteur d'incendie",
  T_37_XYL_WS_GUIDEPOSE: "Poste de direction",
  T_37_XYL_WS_HUGEHOUSE001: "Maison B à 3 étages",
  T_37_XYL_WS_HUGEHOUSE002: "Maison B à 2 étages",
  T_37_XYL_WS_JACKSTRAW: "Épouvantail",
  T_37_XYL_WS_LADDER001: "Échelle A",
  T_37_XYL_WS_OILDRUM: "Jerrican",
  T_37_XYL_WS_ORNAMENT001: "Vase A",
  T_37_XYL_WS_PACKBOX: "Conteneur d'approvisionnement",
  T_37_XYL_WS_PILLA001: "Pilier en béton",
  T_37_XYL_WS_PRESENT: "Boite cadeau",
  T_37_XYL_WS_PRESENT_DES: "Contient des cadeaux de vacances",
  T_37_XYL_WS_PUMPKIN: "Lanterne Jack-O' carrée",
  T_37_XYL_WS_PUMPKINCUT: "Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT_DES: "Une décoration commune pour un festival fantasmagorique",
  T_37_XYL_WS_ROADBLOCK001: "Barrage B",
  T_37_XYL_WS_SHELF001: "Bibliothèque A",
  T_37_XYL_WS_SOFA001: "Canapé A",
  T_37_XYL_WS_SPAWNTEAM: "Toutes les équipes",
  T_37_XYL_WS_SUPPLYBOX: "Caisse de munitions",
  T_37_XYL_WS_TABLE001: "Tableau A",
  T_37_XYL_WS_TABLE002: "Tableau B",
  T_37_XYL_WS_TARGET001: "Cible",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Point d'arrivée du portail",
  T_37_XYL_WS_TELEPORTNEW: "Portail A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "Un portail qui peut téléporter le joueur au point d'arrivée du portail",
  T_37_XYL_WS_TIRES001: "Pneu A",
  T_37_XYL_WS_TOOLRACK: "Étagère à outils",
  T_37_XYL_WS_WALL001: "Mur",
  T_37_XYL_WS_WOOD001: "Bois coupé",
  T_37_XYL_WS_YELLOWDUCK001: "Flotteur canard",
  T_37_XYL_WS_YELLOWDUCK001_DES: "Une bouée gonflée en forme de canard",
  T_37_YM_BOMBSQUAD_DEFUSER: "Désamorceur",
  T_37_YS_B_BRFOOTBALL_WHITE: "Maillot blanc CBF (Bas)",
  T_37_YS_F_B_VN_STREET: "Auspicion Cramoisie (Bas)",
  T_37_YS_F_H_VN_STREET: "Auspicion Cramoisie (Tête)",
  T_37_YS_F_S_VN_STREET: "Auspicion Cramoisie (Chaussures)",
  T_37_YS_F_T_VN_STREET: "Auspicion Cramoisie (Haut)",
  T_37_YS_M_A_CRICKET_BLACK: "Joueur de Cricket (Masque)",
  T_37_YS_M_A_THKOL: "Homme d'Incendie (Masque)",
  T_37_YS_M_B_CRICKET_BLACK: "Joueur de Cricket (Bas)",
  T_37_YS_M_B_SILVERERA: "Grisgarde Intrépide (Bas)",
  T_37_YS_M_B_THKOL: "Homme d'Incendie (Bas)",
  T_37_YS_M_H_SILVERERA: "Grisgarde Intrépide (Tête)",
  T_37_YS_M_H_THKOL: "Homme d'Incendie (Tête)",
  T_37_YS_M_S_CRICKET_BLACK: "Joueur de Cricket (Chaussures)",
  T_37_YS_M_S_SILVERERA: "Grisgarde Intrépide (Chaussures)",
  T_37_YS_M_S_THKOL: "Homme d'Incendie (Chaussures)",
  T_37_YS_M_T_CRICKET_BLACK: "Joueur de Cricket (Haut)",
  T_37_YS_M_T_SILVERERA: "Grisgarde Intrépide",
  T_37_YS_M_T_THKOL: "Homme d'Incendie (Haut)",
  T_37_YS_T_BRFOOTBALL_WHITE: "Maillot blanc CBF (Haut)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Joueurs minimaux",
  T_38_BQ_SKILL_NAME_DUMMY1: "Doublure Cascadeuse",
  T_38_BQ_SKILL_NAME_DUMMY2: "Séparateur de forme",
  T_38_CJ_F_B_STREAMER_MUSIC: "e-Amoureux",
  T_38_CJ_F_H_STREAMER_MUSIC: "e-Amoureux",
  T_38_CJ_F_S_STREAMER_MUSIC: "e-Amoureux",
  T_38_CJ_F_T_STREAMER_MUSIC: "e-Amoureux (Haut)",
  T_38_JH_WS_CM1: "Règles Claires",
  T_38_JH_WS_CM2: "Règles pas Claires",
  T_38_JH_WS_CM3: "Abandons Fréquents",
  T_38_JL_M79_AMMO_N: "Munitions M79",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "Puce de J.Biebs",
  T_38_M_WS_VECTOR2: "2D Vector",
  T_38_R_TACTICS_N: "Préréglé",
  T_38_RW_NIW_NIWNAME: "Gloo Maker",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Trop de couches de blocs. Actuel : {0}. Max. : {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Le nombre d'éléments que vous avez créés ({0}) a dépassé la limite ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Le nombre d'incidents reçus dans la même trame ({0}) a dépassé la limite ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Limite de création d'entités dynamiques par trame atteinte ({0}); {1} tentative(s) de création refusée(s).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "La longueur de la liste initialisée ({0}) a dépassé la limite ({1}). Crée automatiquement une liste de capacité maximale.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Le nombre de boucles ({0}) a dépassé la limite ({1}). Boucle interrompue",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "Le nombre de coroutines simultanées ({0}) dans la portée de la coroutine a dépassé la limite ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Impossible d'ajouter l'élément à la liste. La liste {0} est vide",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Types de valeur incompatibles lors de l'exécution de l'opération arithmétique de base. Le type de valeur de gauche est {0} et le type de valeur de droite est {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Définition de variable temporaire répétée. Nom de variable : {0}.",
  T_38_SP_WS_REVIEW_01: "Toxique",
  T_38_SP_WS_REVIEW_02: "Vulgaire",
  T_38_SP_WS_REVIEW_03: "Insultant",
  T_38_SP_WS_REVIEW_04: "Extrêmement Toxique",
  T_38_SP_WS_REVIEW_05: "Menaçant",
  T_38_SP_WS_REVIEW_06: "Irrespectueux",
  T_38_SP_WS_REVIEW_07: "Sous examen",
  T_38_SP_WS_REVIEW_08: "{0} nom {1} ne respecte pas les règles. {2}.",
  T_38_SP_WS_REVIEW_09: "Chaîne",
  T_38_SP_WS_REVIEW_10: "Boutique",
  T_38_SP_WS_REVIEW_11: "Variable",
  T_38_SP_WS_REVIEW_12: "Fonction",
  T_38_SP_WS_REVIEW_13: "Objet",
  T_38_SP_WS_REVIEW_14: "Aller à la définition.",
  T_38_SP_WS_REVIEW_15: "Aller à Gérer les objets.",
  T_38_SP_WS_REVIEW_16: "Pas de redirection.",
  T_38_SP_WS_REVIEW_17: "Nom de la Carte",
  T_38_SP_WS_REVIEW_18: "Descritpion",
  T_38_SP_WS_REVIEW_19: "Image de couverture",
  T_38_SP_WS_REVIEW_20: "Le texte contient des mots sensibles.",
  T_38_SP_WS_REVIEW_21: "Échec de la sauvegarde. Impossible d'être examiné.",
  T_38_SP_WS_REVIEW_22: "Examen sous temps de recharge",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Batte - Destruction",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Skin d'animal - Kactus Fantôme",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Skin d'animal : Kactus Néon",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Skin d'animal : Kactus Palm Dream",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Skin d'animal: Fête Arvon",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Skin d'animal : Trendy Rockie",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Kami Feu de Nuit",
  T_38_SY_SICKLE_ES_N: "Faux - Pop-Pow",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Pickup - Camion de nourriture Mochi",
  T_38_WT_WS_MUITLEVEL: "Multi-niveau",
  T_38_WT_WS_SKILLSET15: "Frisson de la bataille (A124)",
  T_38_WT_WS_SKILLSET16: "Onde de choc des sens (Homer)",
  T_38_WT_WS_SKILLSET17: "Bagarre murale (Iris)",
  T_38_WT_WS_SKILLSET18: "Ruée Rebelle (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Utilisable en décor ou non",
  T_38_WZY_WS_ACTIVEB: "Activer ou non l'actualisation logique",
  T_38_WZY_WS_ACTIVEVALUE: "Le statut de l'activité",
  T_38_WZY_WS_AIR: "Air",
  T_38_WZY_WS_ALLOWMOVE: "Mobile ou non",
  T_38_WZY_WS_AMMOAMOUNT: "Quantité de munitions",
  T_38_WZY_WS_AMMONAME: "Munitions Entité",
  T_38_WZY_WS_ARMOR_DAMRED: "Multiplicateur de réduction des dégâts",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Multiplicateur de réduction des dégâts d'explosion",
  T_38_WZY_WS_ARMOR_DURABILITY: "Durabilité actuelle",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Durabilité Max.",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Dommageable ou non",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Destructible ou non",
  T_38_WZY_WS_ARMOR_LEVEL: "Niveau",
  T_38_WZY_WS_ASSCONZOM: "Assiste à l'élimination des zombies.",
  T_38_WZY_WS_BAGNAME: "Sac à dos Entité",
  T_38_WZY_WS_BAGSPACEEX: "Espace sac à dos supplémentaire",
  T_38_WZY_WS_BRIDGING: "Composant de rendu de pont",
  T_38_WZY_WS_BUBBLE: "Bulle",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Effacer tous les éléments du sac à dos de [l'entité du joueur]",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Éliminez les objets indésirables qui traînent sur la carte, tels que le butin, les résidus jetables et les boîtes à butin",
  T_38_WZY_WS_CLEARPRO: "Effacer le facteur de propriété unique",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Cloner une entité [objet de scène] à l'emplacement d'une [entité de joueur] et renvoyer l'[entité de déguisement]",
  T_38_WZY_WS_COMPONENT: "Composant",
  T_38_WZY_WS_COSTAMMO: "Consommer des munitions",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Créez une caméra et renvoyez une [entité caméra], dont les propriétés peuvent être modifiées via les paramètres de propriété",
  T_38_WZY_WS_CYCLES: "Fois jouées",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Vérifiez si une [entité] est à l'intérieur de la portée d'un pôle circulaire. Le [centre] est le centre du pôle, le [rayon] est le rayon de la surface circulaire, la [hauteur] est la hauteur du pôle, les [angles d'Euler] sont les angles d'orientation 3D du pôle.",
  T_38_WZY_WS_CYLINDERJUD_RES: "Le résultat de la vérification de la portée du pôle circulaire. Il s'agit d'une valeur booléenne.",
  T_38_WZY_WS_DAMSUMZOM: "Dégâts aux zombies",
  T_38_WZY_WS_DARKNESS: "Obscurité",
  T_38_WZY_WS_DIFCOLOR: "Couleur de surface",
  T_38_WZY_WS_DIFTEXTURE: "Texture de surface",
  T_38_WZY_WS_DRUMMUSIC: "Type de composant : tambours",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "Le joueur qui a été déconnecté",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "Le joueur qui se reconnecte",
  T_38_WZY_WS_EUIANCHOR: "Énumération du type d'ancre HUD",
  T_38_WZY_WS_FEATHER: "Plume",
  T_38_WZY_WS_FLAMEAMMO: "Munitions Lance-flammes",
  T_38_WZY_WS_FLOWER: "Fleur",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Définissez l'[entité] pour qu'elle suive toujours l'[entité suivie]. [Coordonnées de décalage] est la distance entre les deux entités.",
  T_38_WZY_WS_FOLLOWENT: "Entité suivie",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Obtenir l'entité caméra actuellement utilisée par une [entité joueur]",
  T_38_WZY_WS_GETCURCAMDESC: "La caméra actuellement utilisée par le joueur",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Obtenir le montant d'un objet dans le [type d'objet désigné] qu'un [joueur] possède",
  T_38_WZY_WS_GETITEMNUM_RES: "Le montant de l'objet désigné que le joueur possède",
  T_38_WZY_WS_GETVEC_NAME: "Obtenir le vecteur",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Obtenir un vector en utilisant les composants x, y et z d'un ensemble de coordonnées",
  T_38_WZY_WS_GETVECRES: "Le vector obtenu à partir des composantes x, y et z",
  T_38_WZY_WS_GHOST: "Fantôme",
  T_38_WZY_WS_GRENADEFROZENNAME: "Gel Rapide Entité",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Rayon de la zone de gel",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Durée de gel",
  T_38_WZY_WS_GRENADENAME: "Grenade Entité",
  T_38_WZY_WS_GRENADEPARAM1: "Dégâts Min.",
  T_38_WZY_WS_GRENADEPARAM2: "Dégâts Max.",
  T_38_WZY_WS_GRENADEPARAM4: "Gamme d'explosion",
  T_38_WZY_WS_GRENADEPARAM5: "Vitesse de lancer",
  T_38_WZY_WS_GRENADEPARAM6: "Retard d'explosion",
  T_38_WZY_WS_GRENADEPARAM7: "multiplicateur d'auto-dommages",
  T_38_WZY_WS_GRENADEPARAM8: "Multiplicateur de dégâts allié",
  T_38_WZY_WS_GRENADEPARAM9: "Multiplicateur de dégâts du véhicule",
  T_38_WZY_WS_GUNFIRE: "Fusillade",
  T_38_WZY_WS_GUNPRO_PARAM2: "La vitesse de rechargement",
  T_38_WZY_WS_GUNPRO_PARAM3: "Taux de dégâts des coups de corps",
  T_38_WZY_WS_GUNPRO_PARAM4: "Taux de dégâts des tirs à la tête",
  T_38_WZY_WS_GUNPRO_PARAM5: "Taux de dégâts des coups de membre",
  T_38_WZY_WS_GUNPRO_PARAM7: "Extra Dégâts",
  T_38_WZY_WS_HELMET_NAME: "Casque Entité",
  T_38_WZY_WS_ICON1: "Couronne",
  T_38_WZY_WS_ICON2: "Duel",
  T_38_WZY_WS_INITPOS: "Emplacement initial",
  T_38_WZY_WS_ISRESET: "Motion alternative",
  T_38_WZY_WS_KILLCONZOM: "Nb de zombies éliminés",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Éliminez [l'entité] choisie, qui doit être un type d'entité de combat. Ignore le statut invulnérable.",
  T_38_WZY_WS_LABELPARAM: "Liste des paramètres de contenu de texte",
  T_38_WZY_WS_LEADMUSICA: "Type de composant : piano (treble)",
  T_38_WZY_WS_LEADMUSICB: "Type de composant : piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Type de composant : piano (basse)",
  T_38_WZY_WS_LINE: "Ligne",
  T_38_WZY_WS_LIQUID: "Liquide",
  T_38_WZY_WS_LOCALKEY: "Clé localisée",
  T_38_WZY_WS_LOCALPOS: "Emplacement relatif",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Définissez une [entité] pour qu'elle soit face à [l'entité visée]. [Coordonnées de décalage] est la différence entre les coordonnées du point visé et la position de l'entité.",
  T_38_WZY_WS_MAINWEAPONA: "Arme principale 1",
  T_38_WZY_WS_MAINWEAPONB: "Arme principale 2",
  T_38_WZY_WS_MOTIONTIME: "Durée du mouvement",
  T_38_WZY_WS_MOTIONTYPE: "Méthode de mouvement",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "EP modifié",
  T_38_WZY_WS_MUSHROOMNAME: "Champignon Entité",
  T_38_WZY_WS_OBFACTION: "Regarde la faction",
  T_38_WZY_WS_OBGLOBAL: "Regardez tout",
  T_38_WZY_WS_OBSERVER: "Options spectateurs",
  T_38_WZY_WS_OBTEAM: "Regardez l'équipe",
  T_38_WZY_WS_OFFSETVEC: "Coordonnées de décalage",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Se déclenche lorsqu'un joueur achète des objets dans ce distributeur automatique. [Entité joueur] est le joueur qui effectue l'achat. [Entité marchande] est l'article acheté.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Se déclenche lorsqu'il est équipé par une [entité joueur]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Se déclenche lorsque le joueur termine l'action de saut",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Se déclenche lorsque le joueur termine la position couchée",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Se déclenche lorsque l'arme se recharge",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Se déclenche lorsque le joueur termine l'action de sprint",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Se déclenche lorsque le joueur termine l'action accroupie",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Se déclenche lorsque l'arme élimine une unité. [Entité éliminée] est l'unité qui a été éliminée.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Se déclenche lorsque l'arme inflige des dégâts à une entité de combat. [Hit target] est l'entité de combat à laquelle les dégâts ont été infligés. [Dégâts] correspond aux dégâts infligés.",
  T_38_WZY_WS_OWNER: "Propriétaire",
  T_38_WZY_WS_PARAMLIST: "Liste des paramètres",
  T_38_WZY_WS_PARTICALMAP: "Mapping des particules",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: `Mettez en pause ou reprenez l'emote en cours pour une [entité de joueur]. [Pause ou non] est une valeur booléenne. "Oui" signifie pause. "Non" signifie reprendre.`,
  T_38_WZY_WS_PLAENTTRI_DESC: "Activé par le joueur entrant dans la gâchette",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Activé par le joueur quittant la gâchette",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Forcez [l'entité du joueur] à jouer l'[emote] désignée une fois et à revenir à la position d'origine lorsque vous avez terminé",
  T_38_WZY_WS_PLAYSPEED: "Pourcentage de vitesse de lecture",
  T_38_WZY_WS_PREHUD_NAME: "Icône préréglage",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Laisser [l'entité du joueur] quitter sa faction actuelle",
  T_38_WZY_WS_RESETENT: "Réinitialiser les composants à chaque tour",
  T_38_WZY_WS_RESUUID: "Ressource UUID",
  T_38_WZY_WS_RIMCOLOR: "Couleur de la bordure",
  T_38_WZY_WS_RIMTEXTURE: "Texture de la bordure",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Vérifiez si une [entité] est à l'intérieur d'un cône. Le [centre] et le [rayon] sont le centre et le rayon du cône. Le [rayon extrait] est le rayon du plus petit secteur à l'intérieur du cône. La hauteur est la hauteur de la structure 3D. L'[angle] est l'angle central du cône. L'[angle de direction] est le vecteur de direction de l'axe central.",
  T_38_WZY_WS_SECTORJUD_RES: "Le résultat de la vérification de la portée en forme d'éventail. Il s'agit d'une valeur booléenne.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Définir le statut d'activité d'une [entité cible]. [le statut de l'activité] est une valeur booléenne et affecte la disponibilité, la visibilité et la collidabilité de l'entité.",
  T_38_WZY_WS_SETROUNDSCORE: "Définir le score du tour du joueur",
  T_38_WZY_WS_SHOOTANGMAX: "Angle de prise de vue max",
  T_38_WZY_WS_SHOWMAPINFO: "Afficher les informations sur la carte pour la même faction",
  T_38_WZY_WS_SHOWNAMEHUD: "Nom d'affichage HUD pour la même faction",
  T_38_WZY_WS_SOUND1: "Accélération",
  T_38_WZY_WS_SOUND10: "Début d'étape",
  T_38_WZY_WS_SOUND11: "Zombies",
  T_38_WZY_WS_SOUND12: "Horreur",
  T_38_WZY_WS_SOUND13: "Transformation",
  T_38_WZY_WS_SOUND14: "Cœur battant",
  T_38_WZY_WS_SOUND15: "Battement de cœur moyen",
  T_38_WZY_WS_SOUND16: "Battement de cœur lent",
  T_38_WZY_WS_SOUND17: "Temps de pointe",
  T_38_WZY_WS_SOUND18: "Cliquez",
  T_38_WZY_WS_SOUND19: "Récupération de compétences",
  T_38_WZY_WS_SOUND2: "Notification de disparition",
  T_38_WZY_WS_SOUND20: "Rejoindre une partie",
  T_38_WZY_WS_SOUND3: "Effets Visuels",
  T_38_WZY_WS_SOUND4: "Gazouillis nocturnes",
  T_38_WZY_WS_SOUND5: "Frappe (émoussé)",
  T_38_WZY_WS_SOUND6: "Réaction",
  T_38_WZY_WS_SOUND7: "Découverte surprise",
  T_38_WZY_WS_SOUND8: "Apparition",
  T_38_WZY_WS_SOUNDENT: "Entité musicale",
  T_38_WZY_WS_SPAWNPOS: "Ancien point d'apparition",
  T_38_WZY_WS_SPHERENAME: "Sphère Basique",
  T_38_WZY_WS_SPHERERADIUS: "Rayon de la Sphère",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Vérifiez si une [entité] se trouve à l'intérieur d'une portée sphérique. Le [centre] et le [rayon] sont le centre et le rayon de la structure sphérique.",
  T_38_WZY_WS_SPHERICALJUD_RES: "Le résultat de la vérification de la portée sphérique. Il s'agit d'une valeur booléenne.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Vérifiez si une [entité] se trouve dans la portée d'un cube. Le [centre] est le centre du cube, la [longueur], la [largeur] et la [hauteur] sont la longueur, la largeur et la hauteur du cube, et les [angles d'Euler] sont les angles de l'orientation 3D du cube.",
  T_38_WZY_WS_SQUAREJUD_RES: "Le résultat de la vérification de la portée cubique. Il s'agit d'une valeur booléenne.",
  T_38_WZY_WS_STARTGENTIME: "Heure de début d'apparition",
  T_38_WZY_WS_STAYTIME: "Durée des pauses",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Basculez la caméra d'un joueur vers l'[entité caméra]. [Mode de commutation] peut être soit aucune animation, soit un mouvement progressif. [Temps de commutation] est le temps de commutation en mode progressif.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Changez le mode de l'appareil photo. Vous pouvez choisir entre Aucune animation et Mouvement progressif.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: `Le temps de commutation pendant le mode de mouvement progressif. Lorsqu'il est sélectionné "pas d'animation", ce paramètre est nul.`,
  T_38_WZY_WS_TEXTHUD: "Composant de texte HUD",
  T_38_WZY_WS_TEXTTYPE: "Taille de police",
  T_38_WZY_WS_TEXTUREID: "Type de texture",
  T_38_WZY_WS_TRANDIST: "Distance Max.",
  T_38_WZY_WS_TWEENERENABLED: "Activer ou non le script UITweener",
  T_38_WZY_WS_TYPELIST: "liste de types",
  T_38_WZY_WS_TYPELISTORLIST: "Type ou liste de types",
  T_38_WZY_WS_VEST_NAME: "Gilet Entité",
  T_38_WZY_WS_VFX1: "Élimination des cacheurs",
  T_38_WZY_WS_VFX10: "Combustion cyclique",
  T_38_WZY_WS_VFX11: "Gaz empoisonné",
  T_38_WZY_WS_VFX13: "Cœur",
  T_38_WZY_WS_VFX15: "Porte",
  T_38_WZY_WS_VFX2: "Carnage",
  T_38_WZY_WS_VFX3: "Élimination des clones",
  T_38_WZY_WS_VFX4: "Appuyez sur les commentaires",
  T_38_WZY_WS_VFX5: "Cloner",
  T_38_WZY_WS_VFX6: "Déguisement",
  T_38_WZY_WS_VFX7: "Étincelles Flashbang",
  T_38_WZY_WS_VFX8: "Sentier de mouvement",
  T_38_WZY_WS_VFX9: "Charge de feu",
  T_38_WZY_WS_VFXENT: "VFX Instance",
  T_38_WZY_WS_VFXTYPEA_NAME: "Mapping VFX personnalisable",
  T_38_WZY_WS_VFXTYPEB_NAME: "Mapping VFX non personnalisable",
  T_38_WZY_WS_VISIBILITY: "Type de visibilité",
  T_38_WZY_WS_VOLUME: "Volume",
  T_38_WZY_WS_WEAPONGEN: "Générateur d'armes",
  T_38_WZY_WS_WHECYCLE: "Rejouer",
  T_38_XXJ_WS_BLOCKMODE: "Mode bloqué",
  T_38_XXJ_WS_CUSTOMCAMARA: "Caméra personnalisée",
  T_38_XXJ_WS_FFCLASSIC: "Classic FF (Tir)",
  T_38_XXJ_WS_FOV: "Champ de vision",
  T_38_XXJ_WS_FOVDESC: "Le champ de vision est la plage observable de la caméra.",
  T_38_XXJ_WS_FPS: "Première personne (tir)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Angle horizontal",
  T_38_XXJ_WS_INVISICAM: "Semi-transparent",
  T_38_XXJ_WS_OFFSET: "Décalage",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Orthographique",
  T_38_XXJ_WS_PERSPECTIVE: "Perspective",
  T_38_XXJ_WS_PROJECTIONMODE: "Mode Projection",
  T_38_XXJ_WS_STABLE: "Fixé",
  T_38_XXJ_WS_STARTCAMERA: "Caméra par défaut",
  T_38_XXJ_WS_STARTCAMERAMODE: "Mode de caméra par défaut",
  T_38_XXJ_WS_THIRD: "Caméra de poursuite",
  T_38_XXJ_WS_TOPVIEW: "Angle élevé",
  T_38_XXJ_WS_TPS: "troisième personne",
  T_38_XXJ_WS_TRANSVERSE: "Mouvement Horizontal",
  T_38_XXJ_WS_VERTICALANGLE: "Angle Vertical",
  T_38_XXJ_WS_ZOOM: "Zoom",
  T_38_XYL_WS_AISTARTTIME: "Heure de début (s)",
  T_38_XYL_WS_ARMORDESTROY: "Multiplicateur de dégâts d'armure",
  T_38_XYL_WS_BONFIRE: "Bonfire",
  T_38_XYL_WS_CANDLE01: "Bougie A",
  T_38_XYL_WS_CANNON01: "Canon Mécanique",
  T_38_XYL_WS_CLIPAMMOSIZE: "Stockage de Cartouches",
  T_38_XYL_WS_DAMAGEDTRUCK: "Truck endommagé",
  T_38_XYL_WS_DOLL01: "Poupée Eerie",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Maison de Briques A",
  T_38_XYL_WS_FENCE002: "Clôture de fer B",
  T_38_XYL_WS_FIREWORK01: "Feux d'artifice A",
  T_38_XYL_WS_GENERATOR: "Générateur",
  T_38_XYL_WS_GRAVITY: "Accélération gravitationnelle",
  T_38_XYL_WS_GRAVITYAREA: "Zone de gravité anormale",
  T_38_XYL_WS_GRAVITYAREA_DESC: "Une zone où les joueurs peuvent changer la gravité",
  T_38_XYL_WS_HOLDWEAPON: "Prise d'arme",
  T_38_XYL_WS_INDOORFURNITURE: "Meuble d'intérieur",
  T_38_XYL_WS_LIGHTTUBE001: "Tube Lumière A",
  T_38_XYL_WS_LOVEBALLOON01: "Ballon Valentine A",
  T_38_XYL_WS_LOVELAMP01: "Lampadaire du Coeur",
  T_38_XYL_WS_LOVESIGN01: "Néons d'Amour",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Taux de dommages au baril de pétrole",
  T_38_XYL_WS_OUTDOORPROPS: "Articles d'extérieur",
  T_38_XYL_WS_PIPEANDBOX: "Tuyaux et Conteneurs",
  T_38_XYL_WS_PLANT: "Plantes",
  T_38_XYL_WS_ROSE01: "Rose",
  T_38_XYL_WS_ROSEN: "Bouquet de Rose",
  T_38_XYL_WS_SMALLBUILDING: "Petits bâtiments",
  T_38_XYL_WS_SOFA002: "Canapé B",
  T_38_XYL_WS_TOWNHOUSE01: "Maison à 2 étages ancienne",
  T_38_XYL_WS_TV001: "Vieux téléviseur",
  T_38_ZP_CC_EXCHANGESTATUS: "Status",
  T_39_BQ_SKILL_NAME_VILLAIN: "Crimson Crush",
  T_39_CJ_A_BURN: "Marque d'éclat de la victoire",
  T_39_HJ_WS_Arrow002: "Flèche 2",
  T_39_HJ_WS_LIKERATE2: "{0} min",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} min",
  T_39_HJ_WS_SOUND10: "Étape",
  T_39_HJ_WS_SOUND11: "Mission Terminée 1",
  T_39_HJ_WS_SOUND13: "Alerte danger 1",
  T_39_HJ_WS_SOUND14: "Alerte Danger 2",
  T_39_HJ_WS_SOUND15: "Compte à rebours 3",
  T_39_HJ_WS_SOUND16: "Conseils Son",
  T_39_HJ_WS_SOUND17: "Corbeau croa",
  T_39_HJ_WS_SOUND18: "Bruit de téléportation dans une mauvaise zone",
  T_39_HJ_WS_SOUND19: "Son de téléportation dans une zone correcte",
  T_39_HJ_WS_SOUND2: "Compte à rebours 1",
  T_39_HJ_WS_SOUND20: "Téléporter",
  T_39_HJ_WS_SOUND21: "Choc Électrique",
  T_39_HJ_WS_SOUND23: "Obtenez l'Article",
  T_39_HJ_WS_SOUND24: "Musique électronique mignonne",
  T_39_HJ_WS_SOUND25: "musique de fond pour le jeu",
  T_39_HJ_WS_SOUND4: "Écho de l'appareil mécanique",
  T_39_HJ_WS_SOUND5: "Moustique",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Équipement Activé",
  T_39_HJ_WS_SOUND9: "Charge 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Gloo Walls Illimités",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Jetables Illimités",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Son de tir spécial",
  T_39_HQ_UGC_CUSTOMRES: "Ressources personnalisées",
  T_39_M_ACCOUNTID: "Compte",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Exécuter après un double clic",
  T_39_MF_SKILLTAG_4: "Mouvement",
  T_39_PD_HuntingGroundSnow_MYNAME: "M. V",
  T_39_QL_SKILL_OTHO_DES: "Après avoir renversé un ennemi, marquez leurs coéquipiers à moins de [FFB300]{0}m[-] de l'ennemi renversé et ralentissez leur vitesse de déplacement de [FFB300]{1}%[-]. Dure [FFB300]{2}s[-]. Lorsqu'il est renversé par un ennemi proche, marque et ralentit l'attaquant et ses coéquipiers.",
  T_39_QL_SKILL_WOLFRAHH_DES: "Après avoir renversé un ennemi, passez en mode Highlight, qui augmente la cadence de tir de [FFB300]{0}%[-] et la vitesse de déplacement de [FFB300]{1}%[-], mais diminue ensuite rapidement. Dure [FFB300]{2}s[-]. En mode Highlight, abattre des ennemis consécutivement réinitialisera le compte à rebours et augmentera encore la cadence de tir de [FFB300]{3}%[-] et la vitesse de déplacement de [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Mode Xtreme : obtenez [FFB300]{0} HP temporaires[-] pendant [FFB300]{1}s[-]. Pendant ce temps, les effets de guérison HP augmentent de [FFB300]{2}%[-]. Temps de recharge : [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "échoué",
  T_39_RW_SKILL_DESC_FORD: "Gagnez [FFB300]{1} HP/s[-] pendant [FFB300]{0}s[-] lorsque vous subissez des dégâts. Après avoir relâché une compétence active, cette compétence passive se réinitialisera immédiatement. Temps de recharge : [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "Entité d'article",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "Rageblast&quot',
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - 1001 Nuits",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Skin d'animal:lutin vert Arvon",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Skin d'animal : Tigre royal",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Skin Animal: Fang Scorpion",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Monster Truck - Géant Vert",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Char floral",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Éveil: [FFB300]{0}s[-] avant d'exploser, la grenade produit [FFB300]{1}[-] grenades supplémentaires, qui peuvent infliger [FFB300]{2}%[-] de dégâts par rapport à l'original.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Blitz divisé",
  T_39_WT_WS_EMPTYMAP_TAG: "Espace libre",
  T_39_WT_WS_FEMAPMODE: "Titre du mode",
  T_39_WT_WS_FEMAPTAG: "Balise de carte",
  T_39_WT_WS_MAPPLAYER: "Nombre de joueurs",
  T_39_WT_WS_MEDENTERNUM: "Limite de joueurs rejoignant en milieu de partie",
  T_39_WT_WS_MIDENTER: "Rejoindre en milieu de partie",
  T_39_WT_WS_MIDENTERCOUNT: "Quota d' adhésion en milieu de partie",
  T_39_WT_WS_MIDENTERTIME1: "Délai de participation en milieu de partie",
  T_39_WT_WS_MIDENTERTIME2: "Durée de l'adhésion en milieu de partie",
  T_39_WT_WS_MIDENTERTIMETIP: "Lorsque la limite du nombre de joueurs sur la carte n'est pas atteinte, autorisez les joueurs à participer dans les N secondes après le début du match. Les joueurs ne peuvent pas participer après N sec.",
  T_39_WT_WS_MIDENTERTIP: "Lorsqu'il est activé, les joueurs peuvent rejoindre cette carte en cours de partie",
  T_39_WT_WS_PLAYERCOUNT: "Numéro initial du joueur",
  T_39_WT_WS_PLAYERCOUNTTIP: "Le numéro du joueur au début du match. Plus de joueurs peuvent rejoindre le milieu du jeu jusqu'à ce qu'il atteigne la limite de la carte.",
  T_39_WT_WS_TAG1: "Gratuit pour tous",
  T_39_WT_WS_TAG10: "Facile",
  T_39_WT_WS_TAG11: "Moyen",
  T_39_WT_WS_TAG12: "Difficile",
  T_39_WT_WS_TAG13: "Très difficile",
  T_39_WT_WS_TAG14: "S'échapper",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Ressources personnalisées",
  T_39_WT_WS_TAG18: "Puzzles",
  T_39_WT_WS_TAG19: "Courses",
  T_39_WT_WS_TAG2: "Combat d'arme",
  T_39_WT_WS_TAG20: "Musique",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Aventure",
  T_39_WT_WS_TAG23: "Chasse Au Zombie",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "Party Game",
  T_39_WT_WS_TAG26: "Match à Mort",
  T_39_WT_WS_TAG27: "Défense de Tourelle",
  T_39_WT_WS_TAG28: "Entraînement",
  T_39_WT_WS_TAG3: "Roi des armes",
  T_39_WT_WS_TAG4: "Réapparition",
  T_39_WT_WS_TAG5: "Sniper",
  T_39_WT_WS_TAG6: "Survie",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Horreur",
  T_39_WT_WS_TAG9: "Occasionnel",
  T_39_WT_WS_TAGMAXTIP: "Sélectionnez jusqu'à {0} balises",
  T_39_WT_WS_TAGTYPE1: "Type de Jeu",
  T_39_WT_WS_TAGTYPE2: "Type de carte",
  T_39_WT_WS_TAGTYPE3: "Type de mode",
  T_39_WT_WS_TAGTYPE4: "Taille de l'équipe",
  T_39_WZY_WS_ACCSPEED: "Accelération",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Ajouter le script [Nom du script] pour [Entité]",
  T_39_WZY_WS_ASC: "Ascending",
  T_39_WZY_WS_ASCIGZERO: "Ignorer zéro en utilisant ascendant",
  T_39_WZY_WS_BALLISTMOVENT: "Entité de mouvement balistique",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Déclenche un incident lorsque l'objet est utilisé par [Entité du joueur]",
  T_39_WZY_WS_BODYSCALE: "Échelle de Corps",
  T_39_WZY_WS_BRAKETORQUE: "Puissance au frein",
  T_39_WZY_WS_CAMTRANTYPE: "Type de transition de caméra",
  T_39_WZY_WS_CARVEHICLE: "4 roues",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Vérifiez si un script spécifié [Nom du script] existe dans [Entité]. (La valeur renvoyée doit être booléenne)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Vérifier si l'entité a un résultat du script spécifié (booléen)",
  T_39_WZY_WS_COMBINEALL: "Double maniement (différents armes)",
  T_39_WZY_WS_COMBINESELF: "Double maniement (même arme)",
  T_39_WZY_WS_CONENAME: "Cône de base",
  T_39_WZY_WS_COORSYS: "Système de Coordonnées",
  T_39_WZY_WS_CRASHMAXD: "Dégâts d'accident maximum",
  T_39_WZY_WS_CRASHMIND: "Dommages minimaux",
  T_39_WZY_WS_CRAWLSPEED: "Pourcentage de vitesse de déplacement (couché)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Créer un mouvement balistique pour [Entité cible]. Peut modifier [Vitesse initiale], [Accélération] et [Distance maximale] accumulées dans la direction de la vitesse initiale pour l'entité cible, et renvoyer [Entité de Mouvement Balistique]",
  T_39_WZY_WS_CRETWEEN_NAME: "Créer un Mouvement d'Interpolation",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Créez un mouvement d'interpolation pour [Entité], avec [Attributs] de l'entité se déplaçant en douceur de [Valeur de départ] à [Valeur cible] en [Temps]. [Méthode] représente le mode de déplacement, y compris [Unidirectionnel], [PingPong], [Cycle]. [Courbe] est la courbe du mouvement. Et [Entité de mouvement d'interpolation] sera renvoyé après la création du mouvement.",
  T_39_WZY_WS_CURVE: "Courbe",
  T_39_WZY_WS_CUSTRESULT: "Résultat de correspondance personnalisé",
  T_39_WZY_WS_CYLINDERNAME: "Cylindre de base",
  T_39_WZY_WS_DEFAULT: "Aucune animation (par défaut)",
  T_39_WZY_WS_DESC: "décroissant",
  T_39_WZY_WS_DIFFUSEALPHA: "Transparence de surface",
  T_39_WZY_WS_DISCONNECT: "Déconnecter",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Récupération d'énergie par sec",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Consommer l'énergie",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Hauteur max du deuxième saut",
  T_39_WZY_WS_ENABLEJOIN: "Autoriser la participation à mi-chemin",
  T_39_WZY_WS_ENDPOS: "Coordonnées du point final",
  T_39_WZY_WS_ENGINETORQUE: "Puissance du moteur",
  T_39_WZY_WS_EXPLODED: "Dégâts d'explosion",
  T_39_WZY_WS_FEELDSPEED: "Pourcentage de vitesse de déplacement (à terre)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Temps de flash central",
  T_39_WZY_WS_FLASH_CRANGE: "Gamme centrale",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Temps de flash des bords",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Effet de coup de bombe éclair",
  T_39_WZY_WS_FLASH_RANGE: "Gamme d'explosion",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Vitesse de descente",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Max. altitude",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Vitesse de glisse horizontale",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Vitesse de glisse verticale",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Hauteur finale minimale",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Hauteur minimale de décollage",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Vitesse de descente après super high",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Vitesse de rotation",
  T_39_WZY_WS_FOLMOVENT: "Entité de mouvement suivant la position",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Obtenir la liste des compétences de [Entité du joueur]",
  T_39_WZY_WS_HB_BOOSTCD: "Temps de recharge du sprint",
  T_39_WZY_WS_HB_BOOSTDURATION: "Durée du sprint",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Temps de recharge du sprint sur Skyboard",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Temps de recharge du sprint sur Skyboard",
  T_39_WZY_WS_HB_BOOSTSPEED: "Vitesse de sprint",
  T_39_WZY_WS_HB_HOVERBCD: "Temps de recharge du sprint",
  T_39_WZY_WS_HB_JUMPCD: "Temps de recharge de saut",
  T_39_WZY_WS_HB_JUMPH: "Hauteur de saut en skyboard",
  T_39_WZY_WS_HEADSCALE: "Échelle de tête",
  T_39_WZY_WS_HEADSHOTDESCALE: "Réduction des dégâts de tir à la tête",
  T_39_WZY_WS_INTITALSPEED: "Vitesse Initiale",
  T_39_WZY_WS_INVENTORYBASE: "Types d' articles de base",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Coût d'énergie par sec",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Vitesse horizontale de base",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Vitesse verticale de base",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Coût d'énergie Dash par sec",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Vitesse horizontale de sprint",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Distance de sprint",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Coût d'énergie de pointe par sec",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Vitesse verticale de sprint",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Coût d'énergie à la hausse par sec",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Attaquable",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Auto-déclenchement",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Peut-il être déclenché par des alliés",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Déclenchement par véhicule",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Durée",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Heure d'activation",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Rayon de déclenchement",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Temps de déclenchement",
  T_39_WZY_WS_LEAVE: "Quitter",
  T_39_WZY_WS_LIMBSCALE: "Échelle des membres",
  T_39_WZY_WS_LISTLOCSTR: "Liste de textes localisés",
  T_39_WZY_WS_LOADRESULT_NAME: "Télécharger le résultat de la bataille",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Téléchargez le résultat de la bataille de [Joueur], y compris [Rang], [Résultat], [Nom du Score], [Valeur du Score]. Le type de résultat est un entier. 1 pour la victoire, 2 pour la défaite, 3 pour Booyah et 4 pour un match nul.",
  T_39_WZY_WS_LOOKMOVENT: "Entité de Mouvement suivant le Regard",
  T_39_WZY_WS_MAXCOUNT: "Quantité maximale",
  T_39_WZY_WS_MAXDISTANCE: "Distance Max.",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Angle de dépression de la tourelle",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Vitesse angulaire de la tourelle",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Angle d'élévation de la tourelle",
  T_39_WZY_WS_MINISENTRY_DAM: "Dégâts de la Tourelle",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Taux de réduction des dégâts",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Angle de tir",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Taux de réussite de la tourelle",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Intervalle d'attaque de la tourelle",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Nombre maximum de tourelle",
  T_39_WZY_WS_MINISENTRY_RANGE: "Portée d'attaque de la tourelle",
  T_39_WZY_WS_MOVEENT: "Entité de Mouvement",
  T_39_WZY_WS_NOCOMBINE: "Pas de double maniement",
  T_39_WZY_WS_ONCE: "Une fois",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Déclenche un incident lorsque l'objet est jeté par [Entité du joueur]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Déclenche un incident lorsque l'objet est équipé par [Entité du joueur]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Déclenche un incident quand le pistolet à crochet tire",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Déclenche un incident lorsque Landmine est activé",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Déclenche un incident lorsque Landmine est déclenché par [Entité du joueur]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Se déclenche lorsque le mouvement de l'entité s'arrête",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Se déclenche lorsque l'entité redémarre de la pause",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Se déclenche lorsque l'entité commence à bouger",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Déclenche un incident lorsque l'objet est ramassé par [Entité du joueur]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Déclenche un incident quand le jetable touche la cible",
  T_39_WZY_WS_OPENATTACK: "Activer l'attaque",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Mettre en pause l'Entité de Mouvement ou la Liste des Entités de Mouvement",
  T_39_WZY_WS_PAUSESOUND_NAME: "Mettre en pause l'effet sonore",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Mettre en pause l'entité sonore ou la liste des entités sonores",
  T_39_WZY_WS_PIANOTYPE: "Type de composant musical",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Liste des entités de mouvement",
  T_39_WZY_WS_PLAYINGSTATUE: "Statut",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Restaurez l'entité de mouvement ou la liste d'entités de mouvement en pause. Peut choisir de reprendre ou de redémarrer.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Jouer un effet sonore",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Restaurez l'entité sonore ou la liste d'entités sonores en pause. Peut choisir de reprendre ou de redémarrer",
  T_39_WZY_WS_PROCIRCLE_NAME: "Cercle de progression",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Émet un rayon le long de [Direction] à partir de [Coordonnées initiales], détecte la première entité touchée dans [Distance] et renvoie [Liste des Entités Hit] et [Liste des Coordonnées Hit]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Émet un rayon le long de [Direction] à partir de [Coordonnées initiales], détecte la première entité touchée dans [Distance] et renvoie [Entité Hit] et [Coordonnées Hit]",
  T_39_WZY_WS_REAHEALHP: "Valeur de récupération d'armure",
  T_39_WZY_WS_REAHEALTIME: "In-effect time interval",
  T_39_WZY_WS_RELATCOORSYS: "Système de coordonnées relatives",
  T_39_WZY_WS_REPAIRARM: "Kit de réparation",
  T_39_WZY_WS_REVERSE: "Inverse",
  T_39_WZY_WS_RIMALPHA: "Transparence des bords",
  T_39_WZY_WS_SCORENAME: "Nom du Score",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Envoyez un signal à l'entité cible, les paramètres téléchargés sont définis par des paramètres de signal prédéfinis. La sélection du type d'entité au moment de la définition générera l'événement d'acceptation de signal correspondant.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Créez une position en suivant le mouvement pour [Entité cible]. [Entité cible] suit [Entité suivante]. [Coordonnées de décalage] est le décalage de coordonnées entre [Entité cible] et [Entité suivante]. [Système de coordonnées] peut sélectionner le système de coordonnées mondial et le système de coordonnées relatives en fonction de l'orientation de l'entité suivante. [Entité de Position en suivant le Mouvement] sera renvoyé après la création du mouvement.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Créez un Mouvement suivant le Regard pour [Entité cible]. [Entité cible] suit [Entité suivante]. [Coordonnées de décalage] est le décalage de coordonnées entre [Entité cible] et [Entité suivante]. [Système de coordonnées] peut sélectionner le système de coordonnées mondial et le système de coordonnées relatives en fonction de l'orientation de l'entité suivante. [Entité de Mouvement suivant le Regard] sera renvoyé après la création du mouvement.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Pourcentage de dégâts en baisse",
  T_39_WZY_WS_SHOE_MAXENERGY: "Énergie Max.",
  T_39_WZY_WS_SKILLLIST: "Liste des compétences",
  T_39_WZY_WS_SKILLTYPE: "Compétence du personnage",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Durée de l'effet de fumée",
  T_39_WZY_WS_SMOOTH: "Commutateur de caméra",
  T_39_WZY_WS_SOUNDENTL: "Liste des entités d'effets sonores",
  T_39_WZY_WS_SOUNDENTLORSENT: "Entité ou liste d'effets sonores",
  T_39_WZY_WS_SPRINTSPEED: "Pourcentage de vitesse de sprint",
  T_39_WZY_WS_SQUATSPEED: "Pourcentage de vitesse de déplacement (accroupi)",
  T_39_WZY_WS_STARTCOO: "Coordonnées initiales",
  T_39_WZY_WS_STATE: "Statut de lecture",
  T_39_WZY_WS_TARGETVAL: "Valeur Cible",
  T_39_WZY_WS_THROWSPEED: "Vitesse de vol du crochet",
  T_39_WZY_WS_TOWER_PARAM10: "Angle de rotation",
  T_39_WZY_WS_TOWER_PARAM11: "État de la tourelle",
  T_39_WZY_WS_TOWER_PARAM12: "ID d'entité",
  T_39_WZY_WS_TOWER_PARAM9: "Cible d'attaque",
  T_39_WZY_WS_TOWSPEED: "Vitesse de déplacement du joueur",
  T_39_WZY_WS_TWEENCURVE_NAME: "Courbe personnalisée",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "La courbe personnalisée peut être utilisée pour le mouvement d'interpolation",
  T_39_WZY_WS_TWEENENT: "Entité de Mouvement d'Interpolation",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Méthodes de Mouvement",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Méthodes de Mouvement d'Interpolation",
  T_39_WZY_WS_TWEENSTYLE: "Méthode",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Supprimer le script [Nom du script] pour [Entité]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Randomiser les éléments listés",
  T_39_WZY_WS_VISIBLEONBACK: "Visible au dos",
  T_39_WZY_WS_WEAPCOMBINET: "Type d'arme à double maniement",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Dégâts supplémentaires sur les abattus",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Numéro de balle à un seul coup",
  T_39_WZY_WS_WEAREPLAY: "Redémarrer le Mouvement?",
  T_39_WZY_WS_WORLDCOORSYS: "Système de coordonnées mondial",
  T_39_XXJ_WS_ADDFRIEND: "Ajouter un ami",
  T_39_XXJ_WS_ALLOWZ: "Activer le mouvement de x-axis",
  T_39_XXJ_WS_BLOCKMODEDESC: "Mouvement de la caméra lorsqu'il y a un objet entre la caméra et la cible",
  T_39_XXJ_WS_CAMERADISTANCE: "Distance de la Cible",
  T_39_XXJ_WS_CAMERATYPEDESC: "Plusieurs types de caméras prédéfinies et personnalisées sont fournis",
  T_39_XXJ_WS_CAMERAUSER: "Utilisateur de la Caméra",
  T_39_XXJ_WS_CURENTCAMERA: "Caméra Utilisée",
  T_39_XXJ_WS_DETAILS: "Détails du Match",
  T_39_XXJ_WS_FFECONOMY: "Économie",
  T_39_XXJ_WS_FOCUSTARGET: "Cible Observée",
  T_39_XXJ_WS_FOLLOWTARGET: "Cible Suivie",
  T_39_XXJ_WS_GAMERESULT: "Résultat du Match",
  T_39_XXJ_WS_GAMETITLE1: "Match 1",
  T_39_XXJ_WS_GAMETITLE2: "Match 2",
  T_39_XXJ_WS_GIFT: "Cadeau",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Angle de rotation horizontale de la caméra",
  T_39_XXJ_WS_INVISICAM: "Translucide",
  T_39_XXJ_WS_INVISICAMDESC: "L'objet entre la caméra et la cible devient translucide",
  T_39_XXJ_WS_LEFTSCORE: "Score de l'équipe de gauche",
  T_39_XXJ_WS_LIKE: "Aimer",
  T_39_XXJ_WS_LOBBY: "Lobby",
  T_39_XXJ_WS_MAINSCORENAME: "Nom du score total",
  T_39_XXJ_WS_MAINSCORENUM: "Nombre Total du Score",
  T_39_XXJ_WS_MAPEVALUATE: "Évaluation de la Carte",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Résultat de plusieurs équipes",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Décalage du point d'observation",
  T_39_XXJ_WS_OFFSET2DESC: "Fait généralement référence au décalage du point de mise au point de la caméra par rapport à la position d'origine du joueur. (La signification varie selon le type de caméra)",
  T_39_XXJ_WS_OFFSETDESC: "Fait généralement référence au décalage de la position de la caméra par rapport à la position d'origine du joueur. (La signification varie selon le type de caméra)",
  T_39_XXJ_WS_ORTHOGONAL: "Orthogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "La caméra représente les cibles éloignées et proches comme ayant la même taille",
  T_39_XXJ_WS_PERSPECTIVE: "Perspective",
  T_39_XXJ_WS_PERSPECTIVEDESC: "La caméra utilise la projection en perspective pour observer la cible",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Formation d'image de la caméra lors du rendu",
  T_39_XXJ_WS_RANK1: "Classement d'équipe",
  T_39_XXJ_WS_RANK2: "Classement du Joueur",
  T_39_XXJ_WS_REPORT: "Signaler",
  T_39_XXJ_WS_REVIEW: "Rejouer",
  T_39_XXJ_WS_RIGHTSCORE: "Score de l'équipe de droite",
  T_39_XXJ_WS_SCORENUM1: "Score 1",
  T_39_XXJ_WS_SCORENUM2: "Score 2",
  T_39_XXJ_WS_SCORENUM3: "Score 3",
  T_39_XXJ_WS_SCORENUM4: "Score 4",
  T_39_XXJ_WS_SCORENUM5: "Score 5",
  T_39_XXJ_WS_SCORETITLELIST: "Liste des Noms du Score",
  T_39_XXJ_WS_SHARE: "Partager",
  T_39_XXJ_WS_SPECTATORSWITCH: "Spéctateur",
  T_39_XXJ_WS_STABLE: "Stable",
  T_39_XXJ_WS_STABLEDESC: "La caméra reste stable s'il y a un objet entre la caméra et l'entité suivie",
  T_39_XXJ_WS_TEAMNAME1: "Nom de l'équipe de Gauche",
  T_39_XXJ_WS_TEAMNAME2: "Nom de l'équipe de droite",
  T_39_XXJ_WS_TEAMRANK: "Classement d'équipe",
  T_39_XXJ_WS_TRANSITIONTIME: "Temps de transition de la caméra",
  T_39_XXJ_WS_TRANSITIONTYPE: "Type de transition de la caméra",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Résultat de 2 équipes",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Angle de rotation verticale de la caméra",
  T_39_XXJ_WS_ZOOM: "Zoom",
  T_39_XXJ_WS_ZOOMDESC: "La caméra effectue un zoom avant s'il y a un objet entre la caméra et l'entité suivie",
  T_39_XYL_WS_LIGHTINTENSITY: "Intensité lumineuse",
  T_39_XYL_WS_LIGHTRANGE: "Portée lumineuse",
  T_39_XYL_WS_POINTLIGHT: "Point lumineux",
  T_39_XYL_WS_WATERZONE: "Zone d'eau personnalisée",
  T_40_B_DISABLE_RECONNECT: "Désactiver la reconnexion Automatique",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Maillot Minuit",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Maillot Flamme arctique",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Maillot Charbon Cerise",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Maillot Ciel ensoleillé",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Maillot Flamber",
  T_40_DYEING_CLEAR: "Effacer le statut de coloration",
  T_40_HJ_WS_EFFECT32: "Baskets",
  T_40_HJ_WS_EFFECT33: "Explosion",
  T_40_HJ_WS_EFFECT34: "Point d'apparition",
  T_40_HJ_WS_EFFECT35: "Laser",
  T_40_HJ_WS_EFFECT36: "Munitions",
  T_40_HJ_WS_EFFECT37: "Effet de coup",
  T_40_HJ_WS_EFFECT38: "Effet de tir",
  T_40_HJ_WS_EFFECT43: "Toile d'araignée",
  T_40_HJ_WS_EFFECT44: "Libérer une compétence",
  T_40_HJ_WS_SOUND69: "Ouvrir une Boîte",
  T_40_HJ_WS_SOUND70: "Niveau supérieur",
  T_40_HJ_WS_SOUND71: "Niveau max",
  T_40_HJ_WS_SOUND72: "Appuyer sur un bouton",
  T_40_HJ_WS_SOUND73: "Compte à rebours 1",
  T_40_HJ_WS_SOUND74: "Sifflet",
  T_40_HJ_WS_SOUND75: "Jeu terminé",
  T_40_HJ_WS_SOUND76: "En Avant",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Point de contrôle",
  T_40_HJ_WS_SOUND79: "Compte à rebours 2",
  T_40_HJ_WS_SOUND80: "Le jeu commence",
  T_40_HJ_WS_SOUND81: "Obtenu de nombreuses pièces",
  T_40_HJ_WS_SOUND82: "Pièces obtenues",
  T_40_HJ_WS_SOUND83: "Obtenu quelques pièces",
  T_40_HJ_WS_SOUND84: "Rejoins le match",
  T_40_HJ_WS_SOUND85: "Ouverture de l'approvisionnement de la guilde",
  T_40_HJ_WS_SOUND86: "Klaxon",
  T_40_HJ_WS_SOUND87: "Éliminé un boss",
  T_40_HJ_WS_SOUND88: "Ouverture du coffre de guerre",
  T_40_HJ_WS_SOUND89: "Compétence de Peinture Explosive",
  T_40_HJ_WS_SOUND90: "Coup de balle",
  T_40_HJ_WS_SOUND91: "Compétence Bouclier de Peinture",
  T_40_HJ_WS_SOUND92: "Appuyer sur un bouton désactivé",
  T_40_HJ_WS_SOUND93: "Charge de compétence terminée",
  T_40_HJ_WS_SOUND95: "Compétence laser",
  T_40_HJ_WS_SOUND96: "Obtenir l'article 2",
  T_40_HJ_WS_SOUND97: "Jeu terminé 2",
  T_40_HJ_WS_SOUND98: "Avis d'élimination",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Musique de fond",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "Effet sonore en match",
  T_40_HJ_WS_SOUNDTYPE_UI: "Effet sonore du widget de l'interface utilisateur",
  T_40_JH_WS_MAPTAG1: "Jeu de Couleur",
  T_40_JH_WS_MAPTAG10: "Cache-Cache de Couleur",
  T_40_JH_WS_MAPTAG11: "Anniversaire",
  T_40_JH_WS_MAPTAG12: "Jeu de rôle",
  T_40_JH_WS_MAPTAG13: "Simulation",
  T_40_JH_WS_MAPTAG14: "Asymétrique",
  T_40_JH_WS_MAPTAG15: "Bataille de Ressource",
  T_40_JH_WS_MAPTAG16: "Escorte de Chariot",
  T_40_JH_WS_MAPTAG17: "Carte Officielle",
  T_40_JH_WS_MAPTAG18: "Mini Jeu",
  T_40_JH_WS_MAPTAG19: "Défi de Vitesse",
  T_40_JH_WS_MAPTAG2: "Spray de Couleur",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Combat de Couleur",
  T_40_JH_WS_MAPTAG4: "Combat de Couleurs",
  T_40_JH_WS_MAPTAG5: "Terrain de jeu de Couleur",
  T_40_JH_WS_MAPTAG6: "Couleur du Terrain de Jeu",
  T_40_JH_WS_MAPTAG7: "Fête des couleurs",
  T_40_JH_WS_MAPTAG8: "Parkour de Couleur",
  T_40_JH_WS_MAPTAG9: 'Parkour "Spider-Verse"',
  T_40_JH_WS_TAG30: "Magnat",
  T_40_JH_WS_TAG31: "Chaos Domestique",
  T_40_JH_WS_TAG32: "Ville mystère",
  T_40_JH_WS_TAG33: "Crise de l'aube",
  T_40_JH_WS_TAG34: "Soulèvement Mortel",
  T_40_JH_WS_TAG35: "Bagarre de poings",
  T_40_JH_WS_TAG36: "Toit de l'ancienne usine",
  T_40_JH_WS_UGCTOKENNAME: "Jeton Craftland",
  T_40_L_QUICKMESSAGE_MODE2: "Clash Squad",
  T_40_M_WS_HIS: "de",
  T_40_SP_WS_DYEING: "Couleur",
  T_40_SP_WS_DYEING_AREA: "Coloration de Zone",
  T_40_SP_WS_DYEING_COLOR: "Numéro de Couleur",
  T_40_SP_WS_DYEING_COUNT: "Compte de coloration",
  T_40_SP_WS_DYEING_DIR: "Orientation de coloration",
  T_40_SP_WS_DYEING_DIS: "Distance de Coloration",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Zone de coloration fixe",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Coloration de la zone du plan",
  T_40_SP_WS_DYEING_POSITION: "Coordinner",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Décroissance du taux de coloration aléatoire",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Taux de coloration aléatoire",
  T_40_SP_WS_DYEING_RANGE: "Zone de coloration",
  T_40_SP_WS_DYEING_STATE: "Statut de coloration",
  T_40_SP_WS_FACTIONTIPS_11: "Violet",
  T_40_SP_WS_SHOE_CURENERGY: "Énergie actuelle",
  T_40_SW_SKILL_Name_Nanoscientist: "Bouclier Nano",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Merveille de Waggor",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Alok éveillé",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Merveille de Waggor",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Merveille de Waggor",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Merveille de Waggor",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Merveille de Waggor",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: `Skin d'animal : "Spider-Verse" Moony`,
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Skin d'animal: Arvon électrique",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Skin d'animal: Pug yeux laser",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Skin d'animal: Pug Aloha",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Skin d'animal: Pug Rayures tigrées",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Merveille de Waggor",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Merveille de Waggor",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Merveille de Waggor",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Merveille de Waggor",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Merveille de Waggor",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Activer le contenu textuel",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Contenu du texte d'espace réservé",
  T_40_W_DJMALE_AWAKENING_D: "Éveil : pendant que l'aura est active, les notes de musique qui durent [FFB300]{2}s[-] seront lâchées [FFB300]{1}m[-] derrière l'utilisateur de la compétence toutes les [FFB300]{0}s[-]. Les coéquipiers qui récupèrent la note de musique recevront le même effet que l'aura.",
  T_40_W_DJMALE_AWAKENING_N: "Remix de Fête",
  T_40_W_NURSE_D: "Diffusez [FFB300]{0}%[-] de vos effets de soin à cible unique (compétence, kit médical, pistolet de guérison, etc.) sur vos coéquipiers dans un rayon de [FFB300]{1}m[-].",
  T_40_WH_MP_BOXING_NAME: "Match de Boxe",
  T_40_WH_MP_C_PACK: "Sac à dos Illégal",
  T_40_WH_MP_EXCH_COIN: "Cash",
  T_40_WH_MP_EXCH_TEMPCOIN: "Argent illégal",
  T_40_WH_MP_PAYCHECK: "Salaires",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "La vitesse d'aide aux coéquipiers est augmentée de [FFB300]{0}%[-]. Temps de recharge : [FFB300]{3}s[-]. Le coéquipier aidé récupère [FFB300]{2} HP[-] en [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Crée une zone de guérison de [FFB300]{0}m de rayon[-]. À l'intérieur, l'utilisateur et ses alliés récupèrent [FFB300]{1} HP/s[-]. L'aide sera automatiquement déclenchée en cas de besoin. La zone dure [FFB300]{2}s[-]. Les effets de l'aide aux coéquipiers peuvent être améliorés par d'autres compétences. Temps de recharge : [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Méthode d'affichage",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Capsule",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Hauteur",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Rayon",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Sphère",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Arabe simplifié",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarché",
  T_40_WZY_WS_ICONENTITY_COLOR: "Coleur",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progressif",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Ressources d'images",
  T_40_WZY_WS_ICONENTITY_NAME: "Objet Icône",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Méthode d'affichage",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simple",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-Grille",
  T_40_WZY_WS_ICONENTITY_TILED: "Carrelage",
  T_40_WZY_WS_NEWMAPTAG: "Nouvelle icône de carte",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Malédiction",
  T_40_WZY_WS_NEWVFX11: "Zone de gel",
  T_40_WZY_WS_NEWVFX12: "Air froid",
  T_40_WZY_WS_NEWVFX13: "Flocon de neige",
  T_40_WZY_WS_NEWVFX14: "Flamme",
  T_40_WZY_WS_NEWVFX15: "Faisceau de lumière",
  T_40_WZY_WS_NEWVFX16: "Propagation de gaz toxiques",
  T_40_WZY_WS_NEWVFX17: "Gaz empoisonné",
  T_40_WZY_WS_NEWVFX18: "Flamme explosive",
  T_40_WZY_WS_NEWVFX19: "Effet de lumière",
  T_40_WZY_WS_NEWVFX2: "Bulle",
  T_40_WZY_WS_NEWVFX20: "Étoile",
  T_40_WZY_WS_NEWVFX3: "Cendre",
  T_40_WZY_WS_NEWVFX4: "Éclaboussure de pierre",
  T_40_WZY_WS_NEWVFX5: "Ligne",
  T_40_WZY_WS_NEWVFX6: "Tremblement",
  T_40_WZY_WS_NEWVFX7: "Cercle",
  T_40_WZY_WS_NEWVFX8: "Particule montante",
  T_40_WZY_WS_NEWVFX9: "Fumée",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Taille de police",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Style de police",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Police",
  T_40_WZY_WS_TEXTENTITY_NAME: "Objet texte",
  T_40_WZY_WS_UIFONT_LATIN: "Agence FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Bouton d'interaction Composant HUD",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: `S'il peut être utilisé dans le paysage. Ceci est en lecture seule et dépend de "Parent disponible ou non" et "Statut de l'activité".`,
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Si tous les parents sont actifs. Ceci est en lecture seule et non visible pour les joueurs.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Parent disponible ou non",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Afficher lorsque le statut ouvert est vrai, sinon fermé",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: `S'il peut être actif sur soi. Pour l'utiliser dans la scène, vous devez utiliser "Actif dans la scène ou non". Ceci est en lecture seule et configuré à l'aide d'une API.`,
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "la caméra AbattageMasque",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Générer des jetons à un certain endroit",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "L'objet lootable à donner au joueur",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Orientation actuelle du joueur",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Direction",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "L'IA attaque l'entité",
  T_40_XXJ_WS_AITARGET_DESCKEY: "l'AI Attaquant",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "Le style d'alignement",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Alignement horizontal",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Alignement vertical",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparence",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "Le nombre de munitions restantes",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Munitions restantes",
  T_40_XXJ_WS_ANCHORMAX: "Ancre maximale",
  T_40_XXJ_WS_ANCHORMIN: "Ancrage minimal",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Position actuelle du joueur",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Position",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Commutateur HUD d'armure",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "ID d'actif configuré",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "ID d'élément",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Cible d'Attaque",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Jetables d'attaque",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "L'entité attaquée par l'IA",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Cible attaquée",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "Les coordonnées disponibles des spawnpoints",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Coordonnées disponibles",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "L'image du bas",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Arrière Plan",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Sac à dos",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Transparence de fond",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Couleur de l'arrière plan",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Couleur de l'arrière plan",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Que ce soit pour remplir l'arrière-plan",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Remplissage d'arrière-plan",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Nom d'arrière-plan",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Nom de l'arrière plan",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Delta de la taille d'arrière-plan",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Delta de la taille d'arrière-plan",
  T_40_XXJ_WS_BLUE: "Bleu",
  T_40_XXJ_WS_BODY_DESCKEY: "Torse",
  T_40_XXJ_WS_BODY_NAMEKEY: "Torse",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Échelle de squelette",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "Point d'apparition du joueur",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Point d'apparition",
  T_40_XXJ_WS_BOTH: "Soit",
  T_40_XXJ_WS_BUTTONNAME: "Nom du composant du bouton",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Caméra",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "La direction dans laquelle la caméra client est orientée",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "L'emplacement de la caméra client",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Détecter la ligne de caméra du client",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Détection de rayon de caméra",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Arrêtez de faire glisser lorsque coïncide avec la fenêtre",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Exit drag after fit",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "La distance entre le centre des demi-cercles de la forme de la pilule. Il ne peut pas être inférieur à deux fois le rayon de la sphère.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Taille de cellule",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Hauteur de la cellule enfant",
  T_40_XXJ_WS_CELLVALUE: "Lire le contenu d'une certaine cellule et retourner un objet",
  T_40_XXJ_WS_CENTER_DESCKEY: "Les coordonnées mondiales qui correspondent au centre de la minicarte. 0 par défaut.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Centre de la mini-carte",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "Le décalage de la position du bouton",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Décalage de position",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "Le centre de masse par rapport aux coordonnées locales",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Le centre de masse",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Afficher ou non la ligne médiane",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Afficher ou non la ligne médiane",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Position de la ligne médiane [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Position de la ligne médiane",
  T_40_XXJ_WS_CHASERANGE: "Voisinage de la Chasse",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "L'entité poursuivie par l'IA",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Cible poursuivie",
  T_40_XXJ_WS_CHILD_DESCKEY: "Entité Enfant",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Enfants des parents",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "Le point touché par la ligne de la caméra",
  T_40_XXJ_WS_CHOOSECARHUD: "Sélectionnez l'entité HUD de la carte",
  T_40_XXJ_WS_CLAMP_DESCKEY: "Si le paramètre se trouve dans la plage numérique entre les valeurs minimale et maximale, la fonction renverra la valeur du paramètre ; si le paramètre est supérieur à la plage, la fonction renverra la valeur maximale ; si l'argument est inférieur à la plage, la fonction renverra la valeur minimale",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Ne prend en charge que les entités qui ont le composant Transformer. Actuellement limité à tous les objets.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "La taille de la zone de clic",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Taille du clic",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Type d'écrêtage",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Type d'écrêtage",
  T_40_XXJ_WS_CLONEENT_D: "Clonez l'entité sélectionnée et ses attributs tout en conservant le parent d'origine. Si l'objet de niveau est sélectionné, il sera basé sur Créer un objet de niveau.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "La liste des tenues",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "ID de la tenue",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "ID de la Tenue",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "ID de la tenue",
  T_40_XXJ_WS_COL_DESC: "La colonne à lire.",
  T_40_XXJ_WS_COLNAME_DESC: "Le nom de la colonne à lire.",
  T_40_XXJ_WS_COLOR_DESCKEY: "Couleur",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Valeur",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Add color layers using the RGBA color channel. A channel value lies in between 0 and 255 and is stored in an Int32. White (255, 255, 255, 255) by default.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Couleur de la barre de progression",
  T_40_XXJ_WS_COLOR3_DESCKEY: "Le type de canal de couleur RGBA, qui va de 0 à 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "La couleur du texte",
  T_40_XXJ_WS_COLOR5_DESCKEY: "La couleur du HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "La couleur de l'éclairage",
  T_40_XXJ_WS_COLORA_DESCKEY: "La valeur de couleur A",
  T_40_XXJ_WS_COLORB_DESCKEY: "La valeur de couleur B",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Couleur de la barre de progression",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Baril de couleur",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Baril de couleur",
  T_40_XXJ_WS_COLORG_DESCKEY: "La valeur de couleur G",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Obtenir le canal RGBA",
  T_40_XXJ_WS_COLORGUN: "Fusil de pulvérisation arc-en-ciel",
  T_40_XXJ_WS_COLORGUN_01: "Fusil de pulvérisation arc-en-ciel (Rouge)",
  T_40_XXJ_WS_COLORGUN_02: "Fusil de pulvérisation arc-en-ciel (Jaune)",
  T_40_XXJ_WS_COLORGUN_03: "Fusil de pulvérisation arc-en-ciel (Bleu)",
  T_40_XXJ_WS_COLORGUN_04: "Fusil de pulvérisation arc-en-ciel (Vert)",
  T_40_XXJ_WS_COLORGUN_05: "Fusil de pulvérisation arc-en-ciel (Violet)",
  T_40_XXJ_WS_COLORR_DESCKEY: "La valeur de couleur R",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Couleur du texte",
  T_40_XXJ_WS_COLVALUE: "Contenu de la colonne",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "L'entité HUD d'un commutateur HUD général",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "Entité HUD du commutateur HUD général",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Contrainte",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Contrainte",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "Le nombre de contraintes",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Nombre de contraintes",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Contenu Original",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Orientation par défaut",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "Le point de départ du défilement. Coin supérieur gauche par défaut.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Générer un pixel statique pour un certain objet dans la carte. Le pixel ne bougera pas avec l'objet.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Créer une icône de mini-carte",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Définir une chaîne localisée pour un horodatage",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Créer un composant d'interface utilisateur personnalisé au HUD personnalisé désigné et au composant parent",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Ramper",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Afficher si vrai, sinon fermé",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Accroupissement",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "Il s'agit du calque de rendu AbattageMasque de la caméra. Vous pouvez filtrer l'entité de rendu en utilisant le niveau du calque visible.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "AbattageMasque",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "Top ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Haut",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "ID du Maquillage",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "ID des chaussures",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Chaussures",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "ID du Chef",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Tête",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "ID du Maquillage",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Masque",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "Le Bouton ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Bas",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Maquillage",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "L'ID de l'ensemble",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Combinaison",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "La quantité de traînée dans la direction xy",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "Glissement XY",
  T_40_XXJ_WS_DB: "Lire la valeur du tableau",
  T_40_XXJ_WS_DB_DESC: "Lire la valeur correspondante d'un certain identifiant sur une certaine table dans la base de données.",
  T_40_XXJ_WS_DBDELETE_DESC: "Supprimer une valeur correspondante d'un certain identifiant sur une certaine table dans la base de données.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "Un nom personnalisé utilisé pour identifier les données",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identifiant",
  T_40_XXJ_WS_DBTABLENAME: "Nom de la table de base de données",
  T_40_XXJ_WS_DBTABLENAME_DESC: "Le nom d'une table dans une base de données.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "La valeur à écrire",
  T_40_XXJ_WS_DBWRITE: "Écrire la valeur de la table",
  T_40_XXJ_WS_DBWRITE_DESC: "Ecrire une valeur correspondante d'un certain identifiant sur une certaine table dans la base de données.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Jetables de défense",
  T_40_XXJ_WS_DEFULT: "Défault",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Supprimer une valeur correspondante d'une certaine clé sur une certaine table de classement dans la base de données.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Supprimez une valeur correspondante d'un certain rang sur une certaine table de classement dans la base de données.",
  T_40_XXJ_WS_DEPTH: "Couche HUD",
  T_40_XXJ_WS_DEPTH_D: "La couche de base du HUD",
  T_40_XXJ_WS_DICTANDLIST: "Liste et dictionnaire",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "La valeur du dictionnaire ciblé",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "La transparence de la surface",
  T_40_XXJ_WS_DIR_DESCKEY: "Vecteur",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "Un point qui est fourni et qui peut être utilisé comme point de relance, etc.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Organisé",
  T_40_XXJ_WS_DISABLEALL: "Tout désselectionner",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Couleur désactivée",
  T_40_XXJ_WS_DISTANT_DESCKEY: "La distance de détection de la ligne de la caméra",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Distance de projection",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Prend en charge plusieurs directions de glissement",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Effet de traînée",
  T_40_XXJ_WS_DRIVER_DESCKEY: "Le conducteur du véhicule",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Conducteur",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Modifier un valeur",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Afficher des effets spéciaux",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Afficher des effets spéciaux",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Couleur des effets",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "L'entité effets spéciaux représente l'effet spécial à afficher",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "L'objet à effets spéciaux",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Commutateur Emoji HUD",
  T_40_XXJ_WS_ENABLEALL: "Tout sélectionner",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Indique s'il faut activer la mise à jour logique. Lorsqu'il est désactivé, les blocs de cette entité cesseront de mettre à jour chaque image.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "Lorsqu'elles sont écrites dans les attributs de l'arme, les statistiques de base de l'arme seront affectées par le skin de l'arme",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Écrire l'attribut de skin d'arme",
  T_40_XXJ_WS_ENTITY_DESCKEY: "Une entité est un vaisseau qui contient tous les composants, qui doivent être ajoutés aux entités pour être activés",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Type d'Entité",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "Le composant de base d'une entité. Tous les composants combineront ce composant.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "L'entité à transformer en",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "Le nom du paramètre utilisé dans le code pour représenter l'entité du contrôle d'interface utilisateur personnalisé nouvellement ajouté. Sa valeur de variable locale correspondante est l'entité du contrôle d'interface utilisateur personnalisé nouvellement ajouté.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "Le nom de la variable d'entité",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "Le nom du paramètre utilisé dans le code pour représenter l'entité de l'icône créée. Sa valeur de variable locale correspondante est l'entité de l'icône créée.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "Commutateur HUD de la barre EP",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Angles d'Euler",
  T_40_XXJ_WS_FACINFECTION: "Faction (Droïde Apocalypse)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Faction du joueur. 1 = humain, 2 = droïde.",
  T_40_XXJ_WS_FEMALE: "Femme",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Remplir la direction",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Direction du Tri",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Feu",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "La valeur du flotteur",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "L'entité cible à suivre. Vide par défaut.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "La taille du texte",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Taille de police",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "Le style de police",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Gloo Wall Football",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "Le style de formatage",
  T_40_XXJ_WS_FORWARD_DESCKEY: "L'orientation du joueur",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "La direction pour se téléporter",
  T_40_XXJ_WS_FREE_DESCKEY: "Une caméra contrôlable par le joueur et pouvant être déplacée librement",
  T_40_XXJ_WS_FREE_NAMEKEY: "Caméra Gratuite",
  T_40_XXJ_WS_GENDER: "Genre",
  T_40_XXJ_WS_GENDER_DESCKEY: "Genre",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Énumération de genre",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Obtenir la caméra AbattageMasque",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Ne prend en charge que les entités qui ont le composant Transformer. Actuellement limité à tous les objets.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Ne prend en charge que les entités qui ont le composant Transformer. Actuellement limité à tous les objets.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Ne prend en charge que les entités qui ont le composant Transformer. Actuellement limité à tous les objets.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Obtenir l'ID de la tenue du joueur",
  T_40_XXJ_WS_GETPLAYERRANK: "Obtenir le classement du joueur",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Obtenir le classement total du joueur",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Obtenir le classement du tour du joueur",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Obtenir le classement du tour spécifique au joueur",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Rechercher les données du jeton du joueur",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Obtenir le skin d'arme du joueur",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Obtenir un ensemble de coordonnées qui n'a pas été occupé par des spawnpoints aléatoires",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Obtenir la boîte Ciel d'un décor",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Obtenir la région d'un serveur",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Obtenir l'horodatage d'un serveur",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Obtenir un emplacement près du coéquipier, en évitant les zones où les joueurs ne peuvent pas se tenir debout",
  T_40_XXJ_WS_GETTEAMRANK: "Obtenir le classement de l'équipe",
  T_40_XXJ_WS_GETTEAMRANK_D: "Obtenir le classement total de l'équipe",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Obtenir le classement de la manche d'équipe",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Obtenez le classement de la manche spécifique à l'équipe",
  T_40_XXJ_WS_GREEN: "Vert",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "La moitié des dimensions d'une forme tridimensionnelle",
  T_40_XXJ_WS_HEAD_DESCKEY: "Tête",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Tête",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "L'entité d'effet de battement de coeur",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Entité d'effet de battement de cœur",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "La hauteur",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Bouton Indice",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Bouton Conseils",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "L'entité à afficher à l'emplacement cible",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entité ciblée",
  T_40_XXJ_WS_HITPOS_DESCKEY: "L'endroit qui est touché",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "Le type d'affichage horizontal",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Type d'affichage horizontal",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "L'entité qui suit une autre entité",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "L'entité qui regarde une autre entité",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Commutateur HUD de la barre de santé",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "L'entité d'insertion HUD. C'est le HUD que les joueurs modifient depuis l'éditeur.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Composant de panneau HUD vide",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "L'entité HUD à laquelle elle appartient",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "L'entité d'insertion HUD. C'est le HUD que le joueur édite à l'aide de l'éditeur.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "Composant de grille HUD",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "L'entité d'insertion HUD. 'le HUD que le joueur édite à l'aide de l'éditeur.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "Composant du panneau HUD",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "L'entité d'insertion HUD. C'est le HUD que le joueur édite à l'aide de l'éditeur.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "Composant de vue de défilement HUD",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "ID de modèle humain",
  T_40_XXJ_WS_ICON_DESCKEY: "Le nom de ressource de l'icône",
  T_40_XXJ_WS_ICON_NAMEKEY: "Icône",
  T_40_XXJ_WS_ICON1_DESCKEY: "Sélectionner une icône",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "L'entité icône représente l'icône à afficher",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "Un chemin de ressource. La ressource intégrée est in:path. La ressource personnalisée est sortie : chemin. Vide par défaut.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Nom de l'Icône",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Nom de l'icône",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "Le chemin de la ressource. Vide par défaut.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "S'il peut rechercher des déclencheurs",
  T_40_XXJ_WS_INDEX_DESCKEY: "L'index de l'enfant sous le parent",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Valeur initiale [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "La valeur de l'entier",
  T_40_XXJ_WS_IS3D: "Effet sonore 3D",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Toujours face à la caméra",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Gras",
  T_40_XXJ_WS_ISBYORDER_D: "Détecter si les joueurs doivent déclencher des objets de niveau dans l'ordre chronologique",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Est le bouton FirEditor",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Si la ligne de caméra a touché l'entité",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "S'il est visible pour une certaine couche",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Italique",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Qu'ils soient marqués par scan",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Scanné ou pas",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Qu'il soit marqué par le bouton d'épingle",
  T_40_XXJ_WS_ISTRIGGER: "Est déclencheur",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Souligné",
  T_40_XXJ_WS_ITEMID_DESCKEY: "ID d'article correspondant à l'entité",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "ID d'article",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "L'ID de l'objet (uniquement l'ID d'arme disponible dans la version actuelle)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "L'ID d'objet de l'arme",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "ID de l'objet",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Zone Métropole",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Zone Métropole",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Sauter",
  T_40_XXJ_WS_KEY_DESCKEY: "La valeur de la clé",
  T_40_XXJ_WS_KEY_NAMEKEY: "Clé",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "Nom de la clé à parcourir. Vous pouvez l'utiliser pour obtenir la valeur d'une clé dans une variable locale.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Annonce d'élimination",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Couleur du Texte",
  T_40_XXJ_WS_LANDMINEOBJ: "Entité après la création d'une mine terrestre",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "Le masque du calque de collision. Les couches non sélectionnées ne seront pas incluses dans l'analyse. Lorsqu'il est vide, tous les calques seront inclus dans l'analyse.",
  T_40_XXJ_WS_LAYERSEDIT: "Modifier les calques",
  T_40_XXJ_WS_LAYERSETTING: "Paramètres de calque visibles",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "La couche de collision de la détection de ligne de caméra",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Couche",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Type de Mise en page",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Type de mise en page",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Composant HUD du tableau de bord",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "L'entité HUD du tableau de bord. La modification des propriétés de l'entité affectera le contenu à afficher sur l'interface utilisateur correspondante.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Nom du Classement",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "Le nom de la table de classement dans la base de données.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "L'accélération au balancement",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Laisser l'accélération",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Bras gauche",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Bras gauche",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "La couleur de gauche",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Icône gauche",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Afficher ou non les effets spéciaux à gauche",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Afficher l'effet gauche ou non",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Pied gauche",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Pied gauche",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Main gauche",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Main gauche",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Icone gauche",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Icône gauche",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "La jambe gauche",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Jambe gauche",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Texte de score à gauche",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Texte du score de gauche",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Texte gauche",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Texte gauche",
  T_40_XXJ_WS_LERP_DESCKEY: 't est compris entre 0 et 1. Lorsque t=0, renvoie "de". Lorsque t=1, retourner "à". Lorsque t=0.5, renvoie la moyenne des valeurs de "de" et "à".',
  T_40_XXJ_WS_LEVELOBJECT: "Objet de niveau",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Interligne",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Comparer les valeurs d'une liste et renvoyer la plus grande",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Comparer les valeurs d'une liste et renvoyer la plus petite",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "Liste ou Dict",
  T_40_XXJ_WS_LOCALPOSITION: "Poste local",
  T_40_XXJ_WS_LOCALROTA: "Angles d'Euler locaux",
  T_40_XXJ_WS_LOCALROTATIONQ: "Rotation locale des quaternions",
  T_40_XXJ_WS_LOCALSACLE: "Échelle locale",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Commutateur de localisation",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "Le conteneur à traverser",
  T_40_XXJ_WS_MALE: "Male",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Supprimer le dictionnaire",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Obtenir la longueur du dictionnaire",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Obtenir la valeur de la clé désignée dans l'élément du dictionnaire",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Supprimer la paire clé-valeur désignée dans le dictionnaire",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Configurer la valeur d'une clé désignée dans le dictionnaire",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "La taille de la mini-carte. Sa largeur et sa hauteur sont égales.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Taille de la carte",
  T_40_XXJ_WS_MAPT: "Modèle de dictée",
  T_40_XXJ_WS_MAPT_D: "Le modèle de données pour dict. Vous pouvez désigner le type de contenu via T1 et T2.",
  T_40_XXJ_WS_MAPVALUE_D: "Un conteneur de données pour dict. L'élément est une paire composée d'une clé et d'une valeur.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "Le dictionnaire cible",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "Le type de masque est le nom de l'image utilisé lors du masquage",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Nom du masque",
  T_40_XXJ_WS_MASS_DESCKEY: "Masse (en kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Masse (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Comparez 2 valeurs et retournez la plus grande",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Longueur max",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "La valeur Maximale",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "Le plus grand ID de composant",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "Max. ID de widget",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Objets de guérison",
  T_40_XXJ_WS_MIN_DESCKEY: "Comparez 2 valeurs et retournez la plus petite",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Composant de mini-carte",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Pixel de la mini-carte",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Icône de mini-carte",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Mini-carte",
  T_40_XXJ_WS_MINNUM_DESCKEY: "La Valeur minimale",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "Le facteur de l'élan. Plus la valeur est élevée, plus l'élan pendant le défilement est important.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Facteur de momentum",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Manette de mouvement",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Résultat du match",
  T_40_XXJ_WS_NEWENTITY_D: "La nouvelle entité d'élément après la création (peut être nulle)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Crée un nouveau dictionnaire",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "Nouvelle dict",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "La normale du coup",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "Position HUD [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "Position HUD",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "La liste pour convertir les indices en nombres",
  T_40_XXJ_WS_OBJECT_DESCKEY: "L'objet que l'arme pulvérisateur frappe",
  T_40_XXJ_WS_OBSOLETE: "Supprimé, pour des raisons de sécurité, veuillez remplacer ce bloc.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "La position d'affichage. Lorsqu'il y a une cible suivie, c'est le décalage entre la nouvelle position et la position d'origine. Lorsqu'il n'y a pas de cible suivie, ce sont les coordonnées de l'écran (la valeur par défaut est Vecteur3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "Les coordonnées de l'écran (la valeur par défaut est le Vecteur 3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "La position d'affichage. Lorsqu'il y a une cible suivie, c'est le décalage entre la nouvelle position et la position d'origine. Lorsqu'il n'y a pas de cible suivie, ce sont les coordonnées de l'écran (la valeur par défaut est Vecteur3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Position d'affichage (l'ancre est dans le coin supérieur droit)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Décalage horizontal",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Décalage horizontal",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "Le décalage vertical",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Décalage vertical",
  T_40_XXJ_WS_OK_DESCKEY: "Conversion réussie",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Déclenchez cet événement lorsque l'entité entre dans le voisinage de l'attaque",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Déclenchez cet événement lorsque l'entité entre dans le voisinage de chasse",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Déclenchez cet événement lorsque l'entité quitte le voisinage de l'attaque",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Déclenchez cet événement lorsque l'entité quitte le voisinage de la chasse",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Déclencher une détection de ligne de caméra via le client",
  T_40_XXJ_WS_ONCOLLISION_D: "Seules les entités avec le composant Collisionneur attaché prennent en charge cet événement",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Déclenchez cet événement lorsque l'arme touche une entité",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "Quand le tir s'arrête",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "Lorsqu'un joueur change de zone de décor",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Afficher lorsque le statut ouvert est vrai, sinon fermé",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Ouvrir les Status",
  T_40_XXJ_WS_ORANGE: "Orange",
  T_40_XXJ_WS_ORDER_DESC: "Le classement au classement",
  T_40_XXJ_WS_ORDER1: "Rang de départ",
  T_40_XXJ_WS_ORDER2: "Classement final",
  T_40_XXJ_WS_ORIGINAL: "Gardez la logique d'origine",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Méthode de débordement",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "Lorsqu'ils sont prioritaires, les attributs de l'arme du joueur remplaceront les attributs d'origine de l'arme",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Donner la priorité à la skin d'arme du joueur",
  T_40_XXJ_WS_OWNER_DESCKEY: "Le joueur qui possède cette entité",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "L'UID global de la scène enfant à laquelle il appartient",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID de la scène enfant",
  T_40_XXJ_WS_PARENT_DESCKEY: "Entité Parent",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Parent",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "ID d'entité de composant parent",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "L'ID de fichier du composant parent",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "Tous les passagers du véhicule",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Passager",
  T_40_XXJ_WS_PHYSICALLAYER: "Couche physique",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Matrice de couche physique",
  T_40_XXJ_WS_PHYSICALTIP1: "Le nom existe déjà",
  T_40_XXJ_WS_PHYSICALTIP2: "Supprimez un nom de couche et rendez-le invisible dans la matrice de couche physique et l'énumération de couche, mais les objets d 'entité au sein de cette couche ne seront pas affectés.",
  T_40_XXJ_WS_PHYSICS: "Physique",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Commutateur HUD de liste de butin",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "Une entité jouable",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "Une entité fait toujours face à une autre entité",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "Une entité suit une autre entité",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "L'animation de traînée de balles est une animation simulée d'une traînée de balles",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "Le joueur qui recevra le message",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "L'avatar utilisé par le joueur",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "La tenue équipée par le joueur",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Tenue de joueur",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "Type de HUD du joueur",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Type de joueur HUD",
  T_40_XXJ_WS_PLAYERIDINFAC: "Num de série de la faction",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "Le joueur à enregistrer dans le journal",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Consommer le jeton d'un certain joueur",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "La liste des compétences du joueur",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "Le statut d'un joueur : vivant, renversé ou éliminé",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Vitesse de lecture",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Vitesse de lecture",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "Par exemple, 1,25 signifie 25 % plus rapide que la vitesse d'origine",
  T_40_XXJ_WS_POS_DESCKEY: "Les coordonnées pour se téléporter",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "Le type d'autocollant d'effets spéciaux",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Couleur sur presse",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Exécute une traversée d'un conteneur pour obtenir la paire clé-valeur. Inclut un processus enfant, qui est la boucle.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Visite en boucle",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progression [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progression [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "Le bouton pour la progression des compétences",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Bouton de progression de compétence",
  T_40_XXJ_WS_QUATERNION: "Rotation des quaternions",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Commutateur HUD msg rapide",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Msgs à côté de la liste d'équipe",
  T_40_XXJ_WS_RADIUS_DESCKEY: "Le rayon des deux demi-cercles d'une forme de pilule",
  T_40_XXJ_WS_READCELL: "Lire une cellule",
  T_40_XXJ_WS_READCSV: "Lire le contenu du tableau",
  T_40_XXJ_WS_READCSV_DESC: "Lire le contenu sur l'ensemble du tableau. Renvoie un tableau à deux dimensions.",
  T_40_XXJ_WS_READCSVCELL: "Lire par ligne # et nom de colonne",
  T_40_XXJ_WS_READCSVCOL_DESC: "Lire le contenu d'une certaine colonne sur le tableau. Retourne un tableau.",
  T_40_XXJ_WS_READCSVROW_DESC: "Lire le contenu d'une certaine ligne sur le tableau. Retourne un tableau.",
  T_40_XXJ_WS_READLEADERBOARD: "Lire la valeur du classement",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Lire une valeur correspondante d'un certain identifiant sur une table de classement dans la base de données.",
  T_40_XXJ_WS_READLEADERBOARD2: "Lecture par plage de classement",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Lire la valeur de la différence entre un certain rang et un certain rang sur le classement dans une base de données.",
  T_40_XXJ_WS_RED: "Rouge",
  T_40_XXJ_WS_RELOAD: "Recharger",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Méthode d'affichage",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Restaurer la tenue par défaut du joueur",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Restaurer le skin d'arme par défaut du joueur",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Indique si le glissement est contraint à la fenêtre. Sélectionné par défaut.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Contraindre ou non la traînée",
  T_40_XXJ_WS_RESULT_DESCKEY: "Le résultat de la lecture",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Résultat",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Que ce soit pour trouver le plus grand nombre dans la liste",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Que ce soit pour trouver le plus petit nombre dans la liste",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Trouver le plus petit nombre dans une liste",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Trouver le plus grand nombre dans une liste",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "Le point de relance d'un joueur. S'il n'y a pas de points de contrôle, utilisez un spawnpoint. Sinon, utilisez les points de contrôle.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Point de Relance",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Bras droit",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Bras droit",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "La couleur de droite",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Couleur de droite",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Afficher ou non les effets spéciaux à droite",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Afficher l'effet droit ou non",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Pied droit",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Pied droit",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Main droite",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Main droite",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Icône de droite",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Icône droite",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Jambe droite",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Jambe droite",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Texte de la partition droite",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Texte de score droit",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Texte Droit",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Texte Droit",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "Le composant du type corps rigide",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Composant de corps rigide",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "L'énumération du type de corps rigide",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Énumération de type de corps rigide",
  T_40_XXJ_WS_ROW_DECS: "La ligne à lire.",
  T_40_XXJ_WS_ROWVALUE: "Contenu de la ligne",
  T_40_XXJ_WS_SCALE_DESCKEY: "Configurer l'échelle de zoom de l'objet",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Échelle",
  T_40_XXJ_WS_SCALE0_DESCKEY: "L'échelle de zoom de la série de coordonnées dans le monde",
  T_40_XXJ_WS_SCALE1_DESCKEY: "L'échelle de zoom. 1 par défaut.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "La valeur d'échelle",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "Le nom de la Zone",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Barre de score",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Barre de Score",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Prend en charge plusieurs directions de défilement",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Sens de défilement",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "Le facteur du défilement. Plus la valeur est grande, plus le défilement est rapide.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Facteur de défilement",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Configurer la caméra AbattageMasque",
  T_40_XXJ_WS_SETGLOBAL: "Définir global",
  T_40_XXJ_WS_SETPARENT_D: "Ne prend en charge que les entités qui ont le composant Transformer",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Configurer l'ID de tenue du joueur",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Modifier les tenues de plusieurs joueurs",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Définir la direction du joueur",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Configurer le commutateur HUD d'un joueur",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Configurez le skin d'arme du joueur",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Afficher ou non les entités à l'emplacement cible",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Afficher l'entité sur la cible",
  T_40_XXJ_WS_SHOWPLAYER: "Afficher l'entité",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Entité HUD des détails du match solo",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "Une entité HUD pour les matchs solo. La modification des propriétés de l'entité affectera le contenu à afficher sur l'interface utilisateur correspondante.",
  T_40_XXJ_WS_SIZEDELTA: "Delta de taille de la boîte d'ancrage et du composant",
  T_40_XXJ_WS_SKELETON: "Squelette",
  T_40_XXJ_WS_SKELETON_D: "Le pivot utilisé pour accéder au masque squelette",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Partie squelette",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Entité HUD du bouton de compétence",
  T_40_XXJ_WS_SLOT_DESCKEY: "L'emplacement de l'arme",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "Lorsqu'il est sélectionné, il y aura un mouvement lent lors du glissement. Lorsqu'il n'est pas sélectionné, le glissement correspond à la vitesse de la souris.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Mouvement fluide ou pas",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Douceur",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Douceur",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Entité sonore",
  T_40_XXJ_WS_SPACE_DESCKEY: "Espace",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Espacement des cellules enfants",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "Les coordonnées du point d'apparition de l'IA",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Coordonnées du point d'apparition",
  T_40_XXJ_WS_SPEED_DESCKEY: "Vitesse",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Vitesse",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Sprint",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "Le rayon de la sphère",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "La couleur du spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Couleur de pulvérisation",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "Le résultat de la pulvérisation",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Résultat de la pulvérisation",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "Le pistolet pulvérisateur (fusil d'assaut)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Fusil pulvérisateur",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Vitesse initiale",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Retourner l'autocollant",
  T_40_XXJ_WS_SPRITEID: "ID d'élément Sprite",
  T_40_XXJ_WS_SPRITEID_D: "L'ID utilisé pour décrire l'actif sprite",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Type d'autocollant",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "L'entité cible à générer dans un pixel statique",
  T_40_XXJ_WS_STARTPOSITION_D: "Les coordonnées du centre géométrique de la forme",
  T_40_XXJ_WS_STAY_D: "Conserver la position mondiale actuelle, la rotation et la mise à l'échelle de l'enfant ? Ceci est généralement défini sur vrai et les paramètres de l'interface utilisateur sont inefficaces pour cette option.",
  T_40_XXJ_WS_STRING_NAMEKEY: "Chaîne",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Convertir une chaîne en flottant",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Convertir une chaîne à un entier",
  T_40_XXJ_WS_STYLE_DESCKEY: "La méthode de lecture de l'interpolation. Les options incluent jouer une fois, boucler et rejouer.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Changer la zone du joueur",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Valeur de Commutation",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Changez d'arme en fonction de l'emplacement du joueur",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Changer l'emplacement de l'objet",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Changement d'article",
  T_40_XXJ_WS_TABLENAME_DESC: "Affiché comme nom de table mais est en fait l'UID",
  T_40_XXJ_WS_TABLEVALUE: "Contenu du tableau",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "La liste des balises",
  T_40_XXJ_WS_TARGET_DESCKEY: "L'entité cible pour générer le pixel de la carte. Vide par défaut.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entité pour créer un pixel de carte",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Cible d'attaque",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "L'entité cible",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entité",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "L'entité où se trouve la fonction personnalisée",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "L'entité attaquée par l'IA",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "L'entité cible à suivre",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "L'entité article (peut être vide)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "L'entité cible à regarder",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "L'entité sonore à mettre en pause",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "L'entité sonore à jouer après la pause",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "L'entité sonore à supprimer",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Info sur les Coéquipiers",
  T_40_XXJ_WS_TELEPORTA_D: "Téléporter le joueur à un endroit désigné avec une direction définie",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Texte de l'astuce",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Couleur du texte des notifications",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "L'entité texte représente le texte à afficher",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "Les touches de texte à afficher",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Clé de Texte",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "L'horodatage",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "Le style d'affichage d'une chaîne localisée",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Style d'affichage de l'horodatage",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "La chaîne localisée pour un horodatage",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Horodatage de la Chaîne Loc",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Indice",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Conseil",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "La quantité d'objets pillables",
  T_40_XXJ_WS_TOKENID_DESCKEY: "ID d'un objet lootable",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "La vitesse de remorquage d'un joueur",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Type de traduction",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "L'entité d'animation d'interpolation",
  T_40_XXJ_WS_TYPE_DESCKEY: `C'est le type de la description. Utilisation de "typede" renverra son type.`,
  T_40_XXJ_WS_TYPE_NAMEKEY: "Type de corps rigide",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Différents types de corps rigides ont des fonctions différentes",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Seules les devises de base sont prises en charge dans la version actuelle",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Activer ou non l'affichage de la profondeur de la mini-carte",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Utiliser la carte de profondeur",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "S'il suit la loi gravitationnelle",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitationnel ou non",
  T_40_XXJ_WS_UUID_DESCKEY: "L'identifiant unique d'un joueur",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "La valeur",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Valeur",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Valeur [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "La première valeur",
  T_40_XXJ_WS_VALUE2_DESCKEY: "La deuxième valeur",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Valeur [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "La valeur de départ",
  T_40_XXJ_WS_VALUEB_DESCKEY: "La valeur cible",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "Nom de la valeur à parcourir. Vous pouvez l'utiliser pour obtenir la valeur d'une variable locale.",
  T_40_XXJ_WS_VALUET_DESCKEY: "La progression de l'interpolation. Se situe entre 0 et 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Type de variable",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "Le type d'affichage vertical",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Type d'affichage vertical",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "Le niveau de visibilité d'un objet",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Couche visible",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Les tenues incluent l'ensemble, la tête, le masque, le maquillage, le haut, le bas et les chaussures",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Type de tenue",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Emplacement de tenue",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Armes",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "L'ID de skin d'arme",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "ID skin d'arme",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "L'ID du skin d'arme",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "Skin d'arme du joueur",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Énumération de type de composant",
  T_40_XXJ_WS_WIDTH_DESCKEY: "La largeur",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Retour à la ligne",
  T_40_XXJ_WS_WRITELEADERBOARD: "Écrire la valeur du classement",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Écrivez une valeur correspondante d'une certaine clé sur une certaine table de classement dans la base de données.",
  T_40_XYL_WS_BUMPERFACTORY: "Usine de voitures tamponneuses",
  T_40_XYL_WS_BURNDAMAGE: "Dégâts de Combustion",
  T_40_XYL_WS_BURNINTERVAL: "Intervalle de Dégâts de Combustion (s)",
  T_40_XYL_WS_BURNTIME: "Temps de Combustion après Explosion",
  T_40_XYL_WS_COLORFULSKY: "Ciel coloré",
  T_40_XYL_WS_CRANEMACHINE: "Grue à griffes",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Dégâts de Crash Maximum",
  T_40_XYL_WS_CRASHMAXSPEED: "Limite de Vitesse Maximale en cas de Crash",
  T_40_XYL_WS_CRASHMESS: "Paramètre de Masse pendant le Crash",
  T_40_XYL_WS_CRASHMINDAMAGE: "Dégâts de Crash Minimum",
  T_40_XYL_WS_DISPLAYBOARD: "Panneau d'affichage",
  T_40_XYL_WS_EXPLODEDAMAGE: "Dégâts d'Explosion",
  T_40_XYL_WS_EXPLODEDELAY: "Temps de Retard d'Explosion",
  T_40_XYL_WS_EXPLODERANGE: "Plage d'Explosion",
  T_40_XYL_WS_FERRISWHEEL: "Grande roue",
  T_40_XYL_WS_FOODTRUCK002: "Camion de restauration B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Temps de Changement d'Équipement (s)",
  T_40_XYL_WS_ICAROUSEL001: "Manège Composant A",
  T_40_XYL_WS_ICAROUSEL002: "Manège Composant B",
  T_40_XYL_WS_ICAROUSEL003: "Manège",
  T_40_XYL_WS_ICEDANCEDOOL: "Poupée bleue",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Rapport de puissance de stationnement incontrôlé",
  T_40_XYL_WS_LOLLIPOP: "Sucette Géante",
  T_40_XYL_WS_NEWHOOKGUN: "Super Pistolet à crochet",
  T_40_XYL_WS_OPENSWING: "Bouton de Rotation",
  T_40_XYL_WS_OPENTRACTION: "Bouton de Remorquage",
  T_40_XYL_WS_PODIUM: "Podium",
  T_40_XYL_WS_SKYCITY: "Ville",
  T_40_XYL_WS_SKYSCRAPER_A001: "Gratte-ciel A Composant A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Gratte-ciel A Composant B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Gratte-ciel A Composant C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Gratte-ciel B Composant A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Gratte-ciel B Composant B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Gratte-ciel B Composant C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Gratte-ciel C Composant A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Gratte-ciel C Composant B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Gratte-ciel C Composant C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Gratte-ciel D Composant A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Gratte-ciel D Composant B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Gratte-ciel D Composant C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Gratte-ciel E Composant A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Gratte-ciel E Composant B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Gratte-ciel E Composant C",
  T_40_XYL_WS_STEERANGLE: "Rayon de Virages à grande Vitesse",
  T_40_XYL_WS_STEERSPEED: "Vitesse Maximale pendant les Virages à grande vitesse",
  T_40_XYL_WS_SWINGSPEED: "Vitesse de Rotation",
  T_40_XYL_WS_TARGETOBJECT: "Ancre de mouvement",
  T_40_XYL_WS_TRACTIONSPEED: "Vitesse de Remorquage",
  T_40_XYL_WS_TRIGGERCAPSULE: "Déclencheur de capsule personnalisé",
  T_40_XYL_WS_TRIGGERSPHERE: "Déclencheur de sphère personnalisé",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Objet personnalisé",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "Un composant d'objet vide qui peut être utilisé avec le composant de rendu et le composant de collision.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Composant de rendu personnalisé",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "Un composant de rendu personnalisé, utilisé pour le rendu avec des ressources de modèle personnalisées.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Vos marques ennemies ont une valeur de prime. Toute personne de l'équipe alliée qui élimine un ennemi marqué gagnera [FFB300]{0} devise du match[-]. Vous gagnerez [FFB300]100[-] supplémentaires pour avoir éliminé un ennemi. Recevez des [FFB300]{1}pièces FF[-] supplémentaires des machines à pièces lors des matchs BR.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Masque Argent",
  T_41_CJ_A_ESPORTS_TH: "FFTC Le Pro (Masque)",
  T_41_CJ_B_ESPORTS_TH: "FFTC Le Pro (Bas)",
  T_41_CJ_H_ESPORTS_TH: "FFTC Le Pro (Tête)",
  T_41_CJ_S_ESPORTS_TH: "FFTC Le Pro (Chaussures)",
  T_41_CJ_T_ESPORTS_TH: "FFTC Le Pro (Haut)",
  T_41_CJ_T_FFSI: "Maillot FFSI Champion",
  T_41_CJ_T_FOOTBALL_EU01: "Maillot Sunburst",
  T_41_CJ_T_FOOTBALL_EU02: "Maillot Rouge Vif",
  T_41_CJ_T_FOOTBALL_EU03: "Maillot Couronne Majestueuse",
  T_41_CJ_T_FOOTBALL_EU04: "Maillot Regal Titan",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Article",
  T_41_R_CD_COIL: "Réduction de zone",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Activer ou non cet appareil",
  T_41_SJ_WS_SPECIALITEM_NAME: "Appareil",
  T_41_SW_SKILL_DESC_DELIVERY: "Lorsqu'il est touché par un ennemi à moins de [FFB300]{0}m[-], ledit attaquant est marqué pendant [FFB300]{1}s[-] (les informations sont partagées avec ses coéquipiers). Max. [FFB300]{2} marquages[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Obtenez [FFB300]{0} points de bouclier supplémentaires[-] au début du match. Récupère les Points de Bouclier après avoir survécu au combat.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "Lors de l'utilisation d'une compétence active, donne [FFB300]{1} points de bouclier[-] à soi-même et à ses coéquipiers dans un délai de [FFB300]{0}m[-]. Les points de bouclier décroissent après [FFB300]{2}s[-], après quoi les joueurs peuvent à nouveau obtenir les effets. Temps de recharge : [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Deployed Gloo Walls restore [FFB300]{0}[-] durability per second when hit, during which teammates within [FFB300]{1}m[-] restore [FFB300]{2} HP/s[-]. Max. [FFB300]{3} HP[-] per teammate from each Gloo Wall.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Skin d'Animal: Kactus du souvenir",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Skin d'Animal: Falco Encré",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Type",
  T_41_WT_SKILL_DESC_FIREBOY: "Déploie un écran de flammes de [FFB300]{1}m[-] de large qui dure [FFB300]{0}s[-] et avance à [FFB300]{2}m/s[-] pendant [FFB300]{3}s[-]. Pendant l'effet, utilisez à nouveau la compétence pour arrêter l'écran. Les [FFB300]ennemis (ou Gloo Walls)[-] qui entrent en contact avec lui subissent instantanément [FFB300]{4} (ou {5}) DMG[-], puis [FFB300]{6} (ou {7}) DMG[-]/s. Dure [FFB300]{8}s[-]. Temps de recharge: [FFB300]{9}s[-]. Jusqu'à [FFB300]{10}[-] utilisations de compétences peuvent être stockées, avec un temps de recharge de [FFB300]{11}s[-] entre chaque utilisation.",
  T_41_WT_SKILL_NAME_FIREBOY: "Mirage de Flamme",
  T_41_WZY_WS_CHARGEMAX: "Charge Max Gloo Maker",
  T_41_WZY_WS_CROSSBOWNAME: "Arbalète",
  T_41_WZY_WS_DECELERATIONRATIO: "% de décélération dans l'eau",
  T_41_WZY_WS_DEICEWALLPARAM1: "Rayon de la zone de fusion",
  T_41_WZY_WS_DEICEWALLPARAM2: "Durée de la fonte",
  T_41_WZY_WS_EXPPERCHIP: "EXP de la puce Gloo",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP de la distribution de DMG",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP de chaque mètre parcouru",
  T_41_WZY_WS_EXPPERSECOND: "EXP par seconde",
  T_41_WZY_WS_GRENADEEXPTIME: "Retard d'explosion",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosifs",
  T_41_WZY_WS_GRENADEMAX: "DMG Maximum",
  T_41_WZY_WS_GRENADEMIN: "Minimum DMG",
  T_41_WZY_WS_GRENADERANGE: "Gamme d'explosion",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "Coefficient DMG sur les véhicules",
  T_41_WZY_WS_GRENADERATIOSELF: "Coefficient DMG sur soi",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "Coefficient DMG sur les coéquipiers",
  T_41_WZY_WS_GRENADTHROWSPEED: "Vitesse de voyage explosive",
  T_41_WZY_WS_HANDCANNONNAME: "Canon à main",
  T_41_XXJ_WS_ACCELERATION: "Accélération",
  T_41_XXJ_WS_ACCELERATION_D: "Créer un effet d'accélération désigné",
  T_41_XXJ_WS_ACTION: "Nœud Action",
  T_41_XXJ_WS_ACTION_D: "Pivot d'action",
  T_41_XXJ_WS_ADDHP: "Objets de guérison",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Ajouter HP max.",
  T_41_XXJ_WS_AICASTSKILL_D: "Compétence de libération IA",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Décalage du centre d'assistance à la visée",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Distance d'assistance à la visée",
  T_41_XXJ_WS_AIMASSISTENTITY: "Entité d'assistance à la visée",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entité pouvant être assistée à la visée",
  T_41_XXJ_WS_AISKILLTYPE: "Type de compétence Zombie",
  T_41_XXJ_WS_AISKILLTYPE_D: "Type de compétence Zombie",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "Tous les articles",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "Tous les articles",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Modifier la taille du magazine",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Des balles dans le magazine",
  T_41_XXJ_WS_ANCHORPOSITION_D: "Les coordonnées de l'ancre par rapport au parent",
  T_41_XXJ_WS_ANGLE_D: "Angle de rotation de l'axe z",
  T_41_XXJ_WS_ANGULARDRAG: "Drag Angulaire",
  T_41_XXJ_WS_ANGULARVELOCITY: "Vélocité Angulaire",
  T_41_XXJ_WS_ANIMATIONCLIP: "État des animations",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Contrôleur d'Animations",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Entité Animation",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "Le fichier et la ressource utilisés pour gérer le contrôleur d'animation",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "UUID de ressource de contrôleur d'animation",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Type de Boucle enum",
  T_41_XXJ_WS_ANIMATIONSTATE: "État des animations",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Opération, où tous les types d'affectation de valeur sont pris en charge, et les types numériques prennent également en charge l'auto-incrémentation, l'auto-soustraction, l'auto-multiplication et l'auto-division",
  T_41_XXJ_WS_ATTACHMENT: "Pièce jointe",
  T_41_XXJ_WS_ATTACHMENT_D: "Pièce jointe",
  T_41_XXJ_WS_ATTACHTARGET: "Entité liée",
  T_41_XXJ_WS_BAG: "Sac à dos",
  T_41_XXJ_WS_BAG_D: "Composant de Sac à dos",
  T_41_XXJ_WS_BANNERID: "ID Bannière",
  T_41_XXJ_WS_BANNERID_D: "Bannière ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "Arbre de comportement",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Arbre de comportement",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Entité arbre montable par comportement",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "Une entité d'arbre de comportement qui peut être montée",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Nœud personnalisé de l'arbre de comportement",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Pivot personnalisé de l'arbre de comportement",
  T_41_XXJ_WS_BODY: "Corps",
  T_41_XXJ_WS_BORDERLR: "Bordure (gauche et droite)",
  T_41_XXJ_WS_BORDERLR_D: "La bordure gauche et droite",
  T_41_XXJ_WS_BORDERTB: "Bordure (haut et bas)",
  T_41_XXJ_WS_BORDERTB_D: "La bordure supérieure et inférieure",
  T_41_XXJ_WS_BRPEAKRANK: "Classement BR le plus élevé",
  T_41_XXJ_WS_BRPEAKRANK_D: "Classement BR le plus élevé",
  T_41_XXJ_WS_BRRANK: "Rang BR",
  T_41_XXJ_WS_BRRANK_D: "Rang BR",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Type de nœud d'arbre de comportement",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Type de pivot de l'arbre de comportement",
  T_41_XXJ_WS_BTREE: "Arbre de comportement",
  T_41_XXJ_WS_BTREENODESTATE: "État du nœud de l'arbre de comportement",
  T_41_XXJ_WS_BTREENODESTATE_D: "Statut de fonctionnement du pivot de l'arbre de comportement",
  T_41_XXJ_WS_BUFFABLEENTITY: "Entité activée par Buff",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Permet d'ajouter des buffs, de supprimer des buffs et d'obtenir des listes de buffs ajoutées",
  T_41_XXJ_WS_BUILDINGICEWALL: "Gloo Wall",
  T_41_XXJ_WS_CAMOUFLAGE: "Articles fonctionnels",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Skyboard, Camouflage...",
  T_41_XXJ_WS_CAPICITY_D: "Capacité initiale",
  T_41_XXJ_WS_CENTERINVISIBLE: "Invisible au centre",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Non visible au centre",
  T_41_XXJ_WS_COLOR: "Couleur",
  T_41_XXJ_WS_COLOR_D: "La couleur",
  T_41_XXJ_WS_CONDITION: "Nœud Condition",
  T_41_XXJ_WS_CONDITION_D: "Les conditions sont un type booléen spécial",
  T_41_XXJ_WS_CONDITION1_D: "Pivot Condition",
  T_41_XXJ_WS_CONSTRAIN: "Contrainte RigidBody",
  T_41_XXJ_WS_CONSTRAIN_D: "Ajoutez des contraintes au RigidBody. Ceci est une compilation du type de contrainte RigidBody.",
  T_41_XXJ_WS_COUNT_D: "Montant",
  T_41_XXJ_WS_CROSSBOW_D: "Arbalète",
  T_41_XXJ_WS_CSPEAKRANK: "Classement CS le plus élevé",
  T_41_XXJ_WS_CSPEAKRANK_D: "Classement CS le plus élevé",
  T_41_XXJ_WS_CSRANK: "Rang CS",
  T_41_XXJ_WS_CSRANK_D: "Rang CS",
  T_41_XXJ_WS_CSVNAME_D: "Le fichier csv sous SceneData qui correspond au mode. Se termine par .csv. Les en-têtes sont écrits en lettres minuscules.",
  T_41_XXJ_WS_CURCAPACITY: "Capacité utilisée",
  T_41_XXJ_WS_CURPROGRESS: "Progression actuelle",
  T_41_XXJ_WS_CURRENTCLIP: "Clip actuel",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Progression du Clip actuel",
  T_41_XXJ_WS_CURRENTSTATE: "État actuel",
  T_41_XXJ_WS_CUSTOMHUDID: "ID HUD personnalisé",
  T_41_XXJ_WS_CUSTOMHUDID_D: "L'ID utilisé pour décrire une ressource HUD personnalisée",
  T_41_XXJ_WS_DASHATTACK: "Attaque rapide",
  T_41_XXJ_WS_DEBUG: "Démarrer le débogage",
  T_41_XXJ_WS_DEBUG_D: "Réparer",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "% de décélération : la décélération lorsqu'un objet est dans l'eau (plage temporairement définie sur 0-100)",
  T_41_XXJ_WS_DEPTH_D: "La profondeur",
  T_41_XXJ_WS_DRAG: "Coefficient de traînée",
  T_41_XXJ_WS_DRAG_D: "Plus le coefficient est grand, plus la décélération de la vitesse de déplacement est rapide",
  T_41_XXJ_WS_DUMMY: "Dummy",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Activer le mode graphique bas",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "Lorsque le faible fps est activé, le jeu fonctionnera à 15 fps ; ou bien 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Liste d'entités de retour créée",
  T_41_XXJ_WS_ENTITYNAME: "Nom de l'objet",
  T_41_XXJ_WS_ENTITYNAME_D: "Le nom de l'objet personnalisé par le joueur",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "ID d'entité logique ou de préfabriqué",
  T_41_XXJ_WS_EQUIPANDBAG: "Armure et Sac à dos",
  T_41_XXJ_WS_EQUIPMENTSLOT: "emplacements d'équipement enum",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "emplacements d'équipement Enum",
  T_41_XXJ_WS_EXPLODE: "Auto-explosion",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Arme Explosive",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Vitesse de recharge auto",
  T_41_XXJ_WS_FILEID: "ID Interne",
  T_41_XXJ_WS_FILEID_D: "L'ID interne du contrôle dans le préfabriqué",
  T_41_XXJ_WS_FILLAMOUNT: "Remplir le montant",
  T_41_XXJ_WS_FILLAMOUNT_D: "La valeur de remplissage",
  T_41_XXJ_WS_FILLDIR: "Remplir direction",
  T_41_XXJ_WS_FILLDIR_D: "Le sens du remplissage",
  T_41_XXJ_WS_FILLDIR_D1: "Remplir direction enum",
  T_41_XXJ_WS_FILLTYPE: "Remplir type",
  T_41_XXJ_WS_FILLTYPE_D: "Le type de remplissage",
  T_41_XXJ_WS_FILLTYPE_D1: "Remplir type enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Trouver le chemin",
  T_41_XXJ_WS_FINISH: "Complet",
  T_41_XXJ_WS_FIREINTERVAL: "Intervalle de tir",
  T_41_XXJ_WS_FIREINTERVAL_D: "Intervalle d'Attaque",
  T_41_XXJ_WS_FLIP: "Retourner la méthode",
  T_41_XXJ_WS_FLIP_D: "La méthode flip",
  T_41_XXJ_WS_FLYBOMBBEE: "Zombie Volant",
  T_41_XXJ_WS_FORCE: "Force",
  T_41_XXJ_WS_FORCE_D: "Créer une force d'une intensité désignée",
  T_41_XXJ_WS_FORCETYPE: "Type de Force",
  T_41_XXJ_WS_FORCETYPE_D: "Les différents types de forces sur le RigidBody. P.S : Efficace uniquement sur les types RigidBody dynamiques.",
  T_41_XXJ_WS_FREEZEALL: "Geler les mouvements et rotations",
  T_41_XXJ_WS_FREEZEPOSITION: "Geler le mouvement linéaire",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Geler l'axe x",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Geler l'axe y",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Geler l'axe z",
  T_41_XXJ_WS_FREEZEROTATION: "Geler toute rotation",
  T_41_XXJ_WS_FREEZEROTATIONX: "Geler la rotation x",
  T_41_XXJ_WS_FREEZEROTATIONY: "Geler la rotation y",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Geler la rotation z",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Distance pour dégâts max.",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Distance pour dégâts max.",
  T_41_XXJ_WS_GAMEID_D: "Mission ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Donner un objet Metropolis",
  T_41_XXJ_WS_GRADIENT: "Dégradé",
  T_41_XXJ_WS_GRADIENT_D: "Le dégradé",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Dégradé en bas",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "Le dégradé en bas",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparence en bas",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Transparence du bas",
  T_41_XXJ_WS_GRADIENTTOP: "Dégradé en haut",
  T_41_XXJ_WS_GRADIENTTOP_D: "Le dégradé en haut",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparence au top",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Top Transparence",
  T_41_XXJ_WS_GRAPHID: "ID de script",
  T_41_XXJ_WS_GRAPHID_D: "ID utilisé pour décrire un élément de script",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Conposante Fondeur de Gloo",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Retard d'Explosion",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Jetable",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Max. DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Min. DMG",
  T_41_XXJ_WS_GRENADERANGE_D: "Gamme d'Explosion",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Multiplicateur de DMG auto",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Allié multiplicateur de DMG",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Multiplicateur DMG de véhicule",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Vitesse de lancer",
  T_41_XXJ_WS_GRENADEWEAPON: "Catégorie jetables",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Types jetables de base",
  T_41_XXJ_WS_HANDCANNON_D: "Jetables",
  T_41_XXJ_WS_HEAD: "Tête",
  T_41_XXJ_WS_HEADID: "Avatar ID",
  T_41_XXJ_WS_HEADID_D: "Avatar ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Arme Lourde",
  T_41_XXJ_WS_HELMET_D: "Le casque actuel",
  T_41_XXJ_WS_HELMET1_D: "Casque",
  T_41_XXJ_WS_HELMET2_D: "Entité Casque",
  T_41_XXJ_WS_HITBODYPART_D: "La partie du corps touchée",
  T_41_XXJ_WS_HITBPDYPART: "Partie du corps touchée",
  T_41_XXJ_WS_HITENTITY_D: "Entité Hit",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "L'entité HUD à laquelle elle appartient",
  T_41_XXJ_WS_HUD3DCONTAINER: "Conteneur de contenu 3D",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "L'entité conteneur 3D du HUD. C'est le HUD que les joueurs modifient depuis l'éditeur.",
  T_41_XXJ_WS_HUDGRID: "Commande Disposition personnalisée (panneau)",
  T_41_XXJ_WS_HUDLAYOUT: "Contrôle de disposition",
  T_41_XXJ_WS_HUDLAYOUT_D: "L'entité d'insertion HUD. C'est le HUD que les joueurs modifient depuis l'éditeur.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Contrôle d'avatar personnalisé",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "L'entité d'informations de profil HUD. C'est le HUD que les joueurs modifient depuis l'éditeur.",
  T_41_XXJ_WS_HUDTEXTURE: "Contrôle de la texture",
  T_41_XXJ_WS_HUDTEXTURE_D: "L'entité de texture HUD. C'est le HUD que les joueurs modifient depuis l'éditeur.",
  T_41_XXJ_WS_HUDTRANSFORM: "Composant de contrôle UITransform",
  T_41_XXJ_WS_HUDTRANSFORM_D: "L'entité de contrôle UITransform",
  T_41_XXJ_WS_IMPULSE: "Frappe",
  T_41_XXJ_WS_IMPULSE_D: "Créez une frappe d'une intensité désignée",
  T_41_XXJ_WS_INITIALWORLDPOS: "Coordonnées mondiales initiales",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Buff enum",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Correspond à la colonne ID dans BuffData.csv. Avant d'ajouter un nouveau contenu, veuillez d'abord vérifier la compatibilité avec GPP.",
  T_41_XXJ_WS_INVERTFILL: "Inverser remplissage",
  T_41_XXJ_WS_INVERTFILL_D: "Inverser le remplissage",
  T_41_XXJ_WS_ISLOOP: "Est boucle",
  T_41_XXJ_WS_ISLOOP_D: "Que ce soit pour boucler ou non. La valeur par défaut est false.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Génération NavMesh statique",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Utilisé uniquement pour vérifier la génération de NavMesh statique lors du chargement statique d'objets",
  T_41_XXJ_WS_ISSUCCESS_D: "Détruit ou pas",
  T_41_XXJ_WS_ITEMENTITY_D: "Entité d'Article",
  T_41_XXJ_WS_ITEMID: "ID d'Article",
  T_41_XXJ_WS_ITEMID_D: "ID d'Article",
  T_41_XXJ_WS_ITEMID_D1: "L'ID d'élément correspondant de la pièce jointe",
  T_41_XXJ_WS_ITEMLIST: "Liste des Articles",
  T_41_XXJ_WS_ITEMTYPE_D: "Type d'Article",
  T_41_XXJ_WS_JUMPATTACK: "Attaque par saut",
  T_41_XXJ_WS_LANDMINE: "Mine terrestre",
  T_41_XXJ_WS_LENGTH: "Longueur du clip",
  T_41_XXJ_WS_LENGTH_D: "La longueur de la barre de progression. La valeur par défaut est la longueur sur l'interface utilisateur préfabriquée.",
  T_41_XXJ_WS_LIMB: "Membres",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Impossible d'ajouter un élément car la longueur de la liste a dépassé la capacité",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Liste des buffs",
  T_41_XXJ_WS_LOOP: "Boucle",
  T_41_XXJ_WS_LOOP_D: "Boucle",
  T_41_XXJ_WS_MAXCAPACITY: "Capacité",
  T_41_XXJ_WS_MAXCAPACITY_D: "La capacité du sac à dos",
  T_41_XXJ_WS_MAXPROGRESS: "Progrès max.",
  T_41_XXJ_WS_MELEEWEAPON_D: "Arme de Mêlée",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Distance pour dégâts min.",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Distance pour dégâts min.",
  T_41_XXJ_WS_MINISENTRY: "Tourelle Auto",
  T_41_XXJ_WS_NAME: "Nom",
  T_41_XXJ_WS_NAME_D: "Le nom du bouton de compétence. Utilisé pour l'envoi de paramètres lors d'incidents OnClick, l'unicité doit donc être garantie.",
  T_41_XXJ_WS_NAME1_D: "Nom de la marchandise",
  T_41_XXJ_WS_NAME2_D: "Nom de la liste de marchandises",
  T_41_XXJ_WS_NAME3_D: "Nom du Distributeur Automatique",
  T_41_XXJ_WS_NICKNAME: "Surnom",
  T_41_XXJ_WS_NICKNAME_D: "Nom du Joueur",
  T_41_XXJ_WS_NOCHANGE: "Aucun changement",
  T_41_XXJ_WS_NONE: "Aucune contrainte",
  T_41_XXJ_WS_NONE1: "Aucun",
  T_41_XXJ_WS_OFFSET: "Décalage",
  T_41_XXJ_WS_OFFSET_D: "Décalage",
  T_41_XXJ_WS_OFFSET1_D: "Valeur de décalage écrite",
  T_41_XXJ_WS_ONCE: "Une fois",
  T_41_XXJ_WS_ONCE_D: "Une fois",
  T_41_XXJ_WS_ONHIDE: "Quand l'interface est fermée",
  T_41_XXJ_WS_ONHIDE_D: "Quand l'interface est fermée",
  T_41_XXJ_WS_ONNODEENTER_D: "Quand le pivot entre",
  T_41_XXJ_WS_ONSHOW: "Quand l'interface est ouverte",
  T_41_XXJ_WS_ONSHOW_D: "Quand l'interface est ouverte",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Se déclenche lorsque la zone de texte a changé",
  T_41_XXJ_WS_PERSONALUAV: "UAV-Lite",
  T_41_XXJ_WS_PINID: "ID Épingle",
  T_41_XXJ_WS_PINID_D: "ID Épingle",
  T_41_XXJ_WS_PLAYERBAG: "Entité sac à dos du joueur",
  T_41_XXJ_WS_PLAYERBAG_D: "Entité sac à dos du joueur",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Sac à dos joueur",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Sac à dos du Joueur",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Coefficient de vitesse modifié tout en étant inclus",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Impact de la vitesse de déplacement pendant le tir",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Impact of movement speed while firing",
  T_41_XXJ_WS_PREFABID: "ID Préfabriqué",
  T_41_XXJ_WS_PREFABID_D: "ID utilisé pour décrire un élément préfabriqué",
  T_41_XXJ_WS_PREFABID1_D: "L'entité de modèle HUD que cet ID représente",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Arme Principale 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Arme Principale 2",
  T_41_XXJ_WS_PROFILEINFO: "Profil du Joueur",
  T_41_XXJ_WS_PROFILEINFO_D: "Bio du joueur",
  T_41_XXJ_WS_PROGRESSICON_D: "L'icône de progression",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Nom d'Icone de progrès",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Quitter le mini-jeu Metropolis",
  T_41_XXJ_WS_RANGE: "Champ de tir",
  T_41_XXJ_WS_RANGE_D: "Portée d'Attaque",
  T_41_XXJ_WS_RANGE_D1: "Gamme d'Explosion",
  T_41_XXJ_WS_RANGE_D2: "Portée de Tourelle",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Lire le contenu sur l'ensemble du tableau. Renvoie un tableau à deux dimensions.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Lire le contenu d'une certaine cellule",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Lire le contenu d'une certaine colonne. Retourne un tableau.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Lire le contenu d'une certaine ligne. Retourne un tableau.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Lire la base de données accumulée",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Lire la valeur correspondant à une clé dans une table de la base de données accumulée",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Récupérer en continu HP",
  T_41_XXJ_WS_RELOADSPEED: "Vitesse de recharge",
  T_41_XXJ_WS_RELOADSPEED_D: "Vitesse de recharge (vitesse de base x multiplicateur)",
  T_41_XXJ_WS_RESOURCEID: "Resource UUID",
  T_41_XXJ_WS_RESOURCEID_D: "Resource UUID",
  T_41_XXJ_WS_RESUUID: "ID de Ressource",
  T_41_XXJ_WS_RESUUID_D: "L'UUID de la ressource désignée à rendre",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "Type de contrainte RigidBody",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Chaque contrainte est définie par un bit de marquage et peut être utilisée comme une combinaison",
  T_41_XXJ_WS_ROTATION: "Rotation",
  T_41_XXJ_WS_ROTATION_D: "L'angle de rotation dans les coordonnées du monde. x, y, z désignent respectivement le lacet, le tangage et le roulis.",
  T_41_XXJ_WS_ROTATION1_D: "La rotation",
  T_41_XXJ_WS_RUNNING: "Courant",
  T_41_XXJ_WS_SCALE: "Échelle",
  T_41_XXJ_WS_SCALE_D: "Échelle",
  T_41_XXJ_WS_SCALE1_D: "Échelle le long d'un certain axe. Peut être une combinaison de trois axes.",
  T_41_XXJ_WS_SCATTERMAX: "Dispersion max. des balles",
  T_41_XXJ_WS_SCATTERMAX_D: "La valeur à laquelle commence la propagation de la balle",
  T_41_XXJ_WS_SCATTERMOVE1: "Étendre la taille lors du déplacement",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Vitesse de récupération de la propagation",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Vitesse de récupération de la propagation",
  T_41_XXJ_WS_SCATTERSPEED: "Augmentation de la vitesse de propagation",
  T_41_XXJ_WS_SCATTERSPEED_D: "Augmentation de la vitesse de propagation (0,1 = Le réticule s'agrandit de 10 % pour chaque augmentation d'une rafale)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Moins étendu sur le ventre et accroupi",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Arme Secondaire",
  T_41_XXJ_WS_SHADERNAME: "Nom du Shader",
  T_41_XXJ_WS_SHADERNAME_D: "Le nom du shader",
  T_41_XXJ_WS_SHIELDBROKEN: "Attaque brise-bouclier",
  T_41_XXJ_WS_SHIELDUP: "Attaque de bouclier",
  T_41_XXJ_WS_SHOCKWAVE: "Onde de choc",
  T_41_XXJ_WS_SHOWNAME: "Afficher le surnom",
  T_41_XXJ_WS_SHOWNAME_D: "Afficher le Surnom",
  T_41_XXJ_WS_SHOWPIN: "Afficher l'épingle",
  T_41_XXJ_WS_SHOWPIN_D: "Afficher l'épingle",
  T_41_XXJ_WS_SHOWRANK: "Afficher le rang",
  T_41_XXJ_WS_SHOWRANK_D: "Afficher le Rang",
  T_41_XXJ_WS_SHOWTYPE: "Conception",
  T_41_XXJ_WS_SHOWTYPE_D: "Type",
  T_41_XXJ_WS_SHRINKSPEED: "Vitesse de rétrécissement",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Activer l'aide à la visée sur la portée",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Sensibilité du réticule d'aide à la visée avec distance (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Coefficient de priorisation de la distance pour l'aide à la visée (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Distance Max.pour prioriser la distance pour l'aide à la visée",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Min. distance pour donner la priorité à la distance pour l'aide à la visée",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Prioriser la distance pour l'aide à la visée",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Sensibilité du réticule d'aide à la visée (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Facteur de zoom de la portée",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV facteur de zoom",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Coefficient de sensibilité à la rotation de la portée",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Coefficient modifié x de min inclus dans DMG",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Portée dans le temps de zoom de UI de tir (s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Portée dans le facteur de zoom de UI de tir",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Portée dans le temps de reprise de UI de déclenchement (s)",
  T_41_XXJ_WS_SPEED: "Vitesse de lecture",
  T_41_XXJ_WS_SPEEQUIP: "Équipement fonctionnel",
  T_41_XXJ_WS_SPEITEM: "Appareils",
  T_41_XXJ_WS_STATICGRAPHID: "ID de script statique",
  T_41_XXJ_WS_STATICGRAPHID_D: "ID utilisé pour décrire un élément de script statique",
  T_41_XXJ_WS_STATICWAINING: "Impossible de modifier le type Rigidbody statique",
  T_41_XXJ_WS_TARGETTREE: "Entité d'arbre de comportement",
  T_41_XXJ_WS_TARGETTREE_D: "L'entité de l'arbre de comportement",
  T_41_XXJ_WS_TEAMINDEX: "N° de série de l'équipe",
  T_41_XXJ_WS_TEAMINDEX_D: "L'index de l'équipe, qui coïncide avec l'index de l'équipe dans la salle",
  T_41_XXJ_WS_TEAMINDEX_D1: "Numéro de Faction d'Équipe",
  T_41_XXJ_WS_TEMPLATEPREFABID: "ID préfabriqué de modèle",
  T_41_XXJ_WS_TEXT_D: "Contenu",
  T_41_XXJ_WS_TEXTURENAME: "Nom de la texture",
  T_41_XXJ_WS_TEXTURENAME_D: "Le nom de la texture",
  T_41_XXJ_WS_THROWATTACK: "Grenade",
  T_41_XXJ_WS_TICKINTERVAL: "Intervalle d'actualisation",
  T_41_XXJ_WS_TICKINTERVAL_D: "Intervalle d'actualisation. Plus le nombre est grand, plus le rafraîchissement prend du temps.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Activer les appareils spéciaux dans le sac à dos du joueur",
  T_41_XXJ_WS_UVRECTWH: "Largeur et hauteur UV",
  T_41_XXJ_WS_UVRECTWH_D: "La largeur et la hauteur des UV",
  T_41_XXJ_WS_UVRECTXY: "Décalage UV",
  T_41_XXJ_WS_UVRECTXY_D: "Le décalage UV",
  T_41_XXJ_WS_VELOCITY: "Vélocité",
  T_41_XXJ_WS_VELOCITY_D: "Évitez de modifier directement la vitesse du RigidBody. Vous pouvez le modifier à l'aide des API associées.",
  T_41_XXJ_WS_VEST_D: "Le gilet actuel",
  T_41_XXJ_WS_VEST1_D: "Gilet",
  T_41_XXJ_WS_WIDGETID: "ID de Contrôle",
  T_41_XXJ_WS_WIDGETID_D: "ID utilisé pour décrire un contrôle dans les actifs de l'interface. Il doit être associé à un ID HUD personnalisé afin de s'assurer qu'il correspond à un ID de contrôle unique.",
  T_41_XXJ_WS_WINDATTACK: "Attaque de Tornade",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Écrire l'offset de base de données accumulé",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Écrire l'offset correspondant à une clé dans une table de la base de données accumulée",
  T_41_XXJ_WS_ZONEDURATION_D: "Durée de gel",
  T_41_XXJ_WS_ZONEDURATION1_D: "Durée Fondeur de Gloo",
  T_41_XXJ_WS_ZONERADIUS_D: "Geler Rayon de la zone",
  T_41_XXJ_WS_ZONERADIUS1_D: "Rayon Fondeur de Gloo",
  T_41_XYL_WS_BOT12: "Foreur de terre",
  T_41_XYL_WS_BOT9: "Zombie lanceur mutant",
  T_41_XYL_WS_ITEM262: "Frozen Steel Panel A",
  T_41_XYL_WS_ITEM263: "Conteneur congelé A",
  T_41_XYL_WS_ITEM264: "Conteneur de ravitaillement congelé",
  T_41_XYL_WS_ITEM265: "Portail en métal gelé",
  T_41_XYL_WS_ITEM266: "Conteneur congelé B",
  T_41_XYL_WS_ITEM267: "Pierre gelée A",
  T_41_XYL_WS_ITEM268: "Pierre gelée B",
  T_41_XYL_WS_ITEM269: "Pierre gelé C",
  T_41_XYL_WS_ITEM270: "Pierre gelée D",
  T_41_XYL_WS_ITEM271: "Voiture de métro abandonnée",
  T_41_XYL_WS_MODELMATCHNAME: "Concours Canvas",
  T_41_XYL_WS_NAVMESH: "Navmesh Dynamique",
  T_41_XYL_WS_REFCUBE: "Cube Réfléchissant",
  T_41_XYL_WS_SNOWSKY: "Galaxie de givre",
  T_41_XYL_WS_TOYCUBE: "Cube de Jeu",
  T_42_CJ_F_B_VOCATIONAL: "Plan d'Engrenage (Bas)",
  T_42_CJ_F_H_VOCATIONAL: "Plan d'Engrenage (Tête)",
  T_42_CJ_F_S_VOCATIONAL: "Plan d'Engrenage (Chaussures)",
  T_42_CJ_F_T_VOCATIONAL: "Plan d'Engrenage (Haut)",
  T_42_CJ_HA_THUNDER_GOLD: "Maquillage Éclair",
  T_42_CJ_M_B_VOCATIONAL: "Mechanic Masterplan (Bas)",
  T_42_CJ_M_H_VOCATIONAL: "Mechanic Masterplan (Tête)",
  T_42_CJ_M_S_VOCATIONAL: "Mechanic Masterplan (Chaussures)",
  T_42_CJ_M_T_VOCATIONAL: "Mechanic Masterplan (Haut)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Gloo Wall - Fureur du Tigre",
  T_42_H_GRENADE_SMUDGE_N: "Grenade - Ombre féline",
  T_42_H_M1917_EMPIRE_N: "M1917 - Conquérant Couronné",
  T_42_HJ_WS_VFX_INK: "Encre",
  T_42_JH_WS_BANMATCHMAKING: "Matchmaking non autorisé pour cette carte",
  T_42_JH_WS_BANROOMCREATE: "Impossible de créer une room",
  T_42_JH_WS_FPS: "TPP",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Remix de Fête (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Mur de Flamme (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Séparateur de forme (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Bouclier Nano (Sonia)",
  T_42_JH_WS_TAG1: "Bagarre de givre",
  T_42_JH_WS_TAG10: "Coureur infini",
  T_42_JH_WS_TAG11: "Course de Vitesse",
  T_42_JH_WS_TAG12: "Course de Voiture",
  T_42_JH_WS_TAG13: "Exclure des populaires",
  T_42_JH_WS_TAG14: "Ligne de front",
  T_42_JH_WS_TAG15: "Guerre de Zombies",
  T_42_JH_WS_TAG16: "Légende D'héritage",
  T_42_JH_WS_TAG2: "Île sociale 1.0",
  T_42_JH_WS_TAG3: "Île sociale 2.0",
  T_42_JH_WS_TAG4: "Jouer ensemble",
  T_42_JH_WS_TAG5: "Survivant de Ruine",
  T_42_JH_WS_TAG6: "Fête de Proie",
  T_42_JH_WS_TAG7: "Fête de Proie",
  T_42_JH_WS_TAG8: "Fort Feud 2.0",
  T_42_JH_WS_TAG9: "Chasse aux primes",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Placez un portail n'importe où et téléportez-vous!",
  T_42_RW_PORTALSPERSONAL_NAME: "Portal Go",
  T_42_SJ_WS_ACCESSORIESITEM: "Équiper l'attachement",
  T_42_SJ_WS_AUTOPLAY: "Lecture Auto",
  T_42_SJ_WS_CLIMB: "Grimper par-dessus",
  T_42_SJ_WS_CLOCK_EVENTS: "Compilation d'événements",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Compte à rebours ou pas",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Boucles",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Suspendre l'événement",
  T_42_SJ_WS_CLOCK_START_EVENT: "Démarrer l'événement",
  T_42_SJ_WS_CLOCK_START_TIME: "Heure de début du compte à rebours",
  T_42_SJ_WS_CLOCK_STATE: "Statut du chronomètre",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Arrêter l'événement",
  T_42_SJ_WS_DAMRATIOHEAD: "Changement du coefficient DMG du tir à la tête",
  T_42_SJ_WS_DAMRATIOLIMB: "Changement du coefficient DMG des membres",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Coefficient de réduction du DMG explosif",
  T_42_SJ_WS_DRIVE: "Conduire",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Afficher les calques",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Capacité de sac à dos supplémentaire",
  T_42_SJ_WS_EXTRAHPRATIO: "Rapport HP",
  T_42_SJ_WS_GETOFF_DRIVE: "Sortir du véhicule",
  T_42_SJ_WS_GETON_DRIVE: "Entrer le véhicule",
  T_42_SJ_WS_KNIFEITEM: "Dague",
  T_42_SJ_WS_KNIFEITEMPICK: "Dague (butin au sol)",
  T_42_SJ_WS_MARKBTNHUD: "Le bouton épingle sur le HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "Vous pouvez activer ou désactiver le bouton épingler",
  T_42_SJ_WS_MAXDISTANCE: "Distance Max.",
  T_42_SJ_WS_MAXDURARATIO: "Rapport de durabilité max",
  T_42_SJ_WS_MICBTNHUD: "L'interrupteur du micro sur le HUD",
  T_42_SJ_WS_MICBTNHUD_D: "Vous pouvez activer ou désactiver le bouton du micro",
  T_42_SJ_WS_MINDISTANCE: "Distance Min.",
  T_42_SJ_WS_OPE_VEHICLE: "Conduire un véhicule",
  T_42_SJ_WS_PLANE_DESC: "Un maillage de base dont la taille peut être ajustée librement",
  T_42_SJ_WS_PLANENAME: "Avion de Base",
  T_42_SJ_WS_PRIORITY: "Priorité",
  T_42_SJ_WS_REPLACEPRIORITY: "Remplacer la priorité",
  T_42_SJ_WS_SETBTNHUD: "Le bouton de paramètres sur le HUD",
  T_42_SJ_WS_SETBTNHUD_D: "Vous pouvez activer ou désactiver le bouton des paramètres",
  T_42_SJ_WS_SIGNALBTNHUD: "Le bouton de connexion réseau sur le HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "Vous pouvez activer ou désactiver le bouton de connexion réseau",
  T_42_SJ_WS_SPEAKERBTNHUD: "Le bouton klaxon sur le HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "Vous pouvez activer ou désactiver le bouton du klaxon du véhicule",
  T_42_SJ_WS_START_TIME: "Heure de début (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Obtenez une capacité supplémentaire de [FFB300]{0}[-] dans votre sac à dos pour les munitions, à l'exclusion du lance-grenades. ([FFB300]{1}[-] Munitions AR, [FFB300]{2}[-] Munitions SMG, [FFB300]{3}[-] Munitions pour tireur d'élite, [FFB300]{4}[-] Munitions SG)",
  T_42_SW_SKILL_DESC_Bodyguard: "La vitesse de rechargement augmente de [FFB300]{0} %[-]. Chaque fois que l'utilisateur de la compétence touche un ennemi, cette cible bénéficiera d'une déduction de soins de [FFB300]{1}%[-] qui dure [FFB300]{3}s[-] (déduction maximale : [FFB300]{2} %[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Devenez immunisé contre les effets perturbateurs (par exemple, ralentissement, marquage, désactivation des compétences) et bénéficiez d'une augmentation de vitesse de déplacement de [FFB300]{1}%[-] pendant [FFB300]{2}s[-]. Temps de recharge : [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "Après avoir renversé un adversaire ou utilisé une compétence active, [FFB300]{0}%[-] du chargeur de l'arme se recharge automatiquement",
  T_42_SW_SKILL_NAME_Playboy: "Cuillère d'Argent",
  T_42_SY_BACKPACK_EMPIRE_N: "Sac à dos - Rugissement Couronné",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Skin d'animal: Hop glacé",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Moto - Scooter Urbain",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Argentée",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Noire",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rouge",
  T_42_TYC_CST_LOSE_MONEY_1: "Montant du CS Cash obtenu après avoir perdu un tour",
  T_42_TYC_CST_LOSE_MONEY_2: "Montant de CS Cash obtenu sur une séquence de 2 défaites consécutives",
  T_42_TYC_CST_LOSE_MONEY_3: "Montant de CS Cash obtenu sur une séquence de 3 défaites consécutives",
  T_42_WH_ITEM_HEALUAV: "Heal UAV-Lite",
  T_42_WH_ITEM_HEALUAV_DESC: "Déploie un UAV-Lite qui vole vers l'avant et soigne continuellement les coéquipiers dans la portée dessous",
  T_42_WH_ITEM_SKILLCARD: "Compétence: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `À utiliser pour libérer la compétence active de [ffba00]{0}[-] : [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Type de munitions",
  T_42_XXJ_WS_AMMOTYPE_D: "Type de munitions",
  T_42_XXJ_WS_ASSETCONFIGID: "ID du Skin",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Skin",
  T_42_XXJ_WS_ATTACKSTATUS: `Statut d'
attaque`,
  T_42_XXJ_WS_AUTOPLAY: "Lecture Auto",
  T_42_XXJ_WS_AUTOPLAY_D: "Lecture Auto",
  T_42_XXJ_WS_AVATARABLE: `Composant d'
apparence modifiable`,
  T_42_XXJ_WS_AVATARABLE_D: "Changer d'apparence selon les pièces",
  T_42_XXJ_WS_AVATARRESUUID: `UUID de ressource d'
apparence`,
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Convertir la représentation axe-angle d'une rotation en quaternions",
  T_42_XXJ_WS_B_D: "La valeur de couleur B",
  T_42_XXJ_WS_BASEVALUE_D: "Base du logarithme",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier curve",
  T_42_XXJ_WS_BEZIERCURVE_D: "La courbe de Bézier",
  T_42_XXJ_WS_BOTDIFFICULTY: "Difficulté de Bot",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Méthode de Combinaison des Rebondissements",
  T_42_XXJ_WS_BOUNCINES: "Rebondissement",
  T_42_XXJ_WS_BTREEID: `ID de l'
arbre de comportement`,
  T_42_XXJ_WS_BTREEID_D: "ID de l'arbre de comportement",
  T_42_XXJ_WS_CANPURCHAS: "Achetable ou Non",
  T_42_XXJ_WS_CANPURCHAS_D: "Achetable ou non",
  T_42_XXJ_WS_CLIMBSTATUS: `Comportement d'
escalade`,
  T_42_XXJ_WS_CLOCK: "Objet minuterie",
  T_42_XXJ_WS_CLOCK_D: "Objet minuterie",
  T_42_XXJ_WS_CLOCK_D1: "Minuteur",
  T_42_XXJ_WS_CONTAINER: "Récipient",
  T_42_XXJ_WS_CONTROLPOINTS: "Points de contrôle",
  T_42_XXJ_WS_CONTROLPOINTS_D: "Les points de contrôle",
  T_42_XXJ_WS_COROUTINEID: "Poignée de coroutine",
  T_42_XXJ_WS_COROUTINEID_D: "L'ID de coroutine fait référence au handle d'une coroutine spécifique. Il permet d'effectuer diverses opérations sur le manche.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Créer un relatif à soi",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Créer un proche",
  T_42_XXJ_WS_CREATESOUND: "Créer un effet sonore",
  T_42_XXJ_WS_CREATESOUND_D: "Jouez l'effet sonore désigné. S'il y a d'autres propriétés à définir, vous pouvez le faire en configurant ses propriétés d'entité.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Terminer une mission personnalisée",
  T_42_XXJ_WS_DAMAGELIST_D: "Liste d'incréments DMG",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Rapport de DMG de tir à la tête",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Multiplicateur de réduction des DMG d'explosion",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Matériel physique par défaut",
  T_42_XXJ_WS_DEFAULTFIST_D: "Poing par défaut",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Intervalle de trame logique",
  T_42_XXJ_WS_DELTATIME_D: "L'intervalle entre les 2 mises à jour de la trame logique du GS",
  T_42_XXJ_WS_DEPTH: "Couche",
  T_42_XXJ_WS_DEPTH_D: "Afficher les calques sur l'icône",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "Liste des butins au sol désactivés",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "La liste des objets qui ne sont pas du butin au sol",
  T_42_XXJ_WS_DRIVER: "Siège conducteur",
  T_42_XXJ_WS_DRIVINGSTATUS: "Conduire",
  T_42_XXJ_WS_DURATION_D1: "La durée du compte à rebours en secondes",
  T_42_XXJ_WS_DURATION_D2: "La durée en secondes",
  T_42_XXJ_WS_DURATION_D3: "La durée",
  T_42_XXJ_WS_DURATION_D4: "La durée de l'invulnérabilité en secondes",
  T_42_XXJ_WS_DURATIONTIMES: "Temps Durée",
  T_42_XXJ_WS_DURATIONTIMES_D: "La durée en secondes",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Friction Dynamique",
  T_42_XXJ_WS_EASY: "Très Facile",
  T_42_XXJ_WS_ENDTIMES: "Heure de fin",
  T_42_XXJ_WS_ENDTIMES_D: "L'heure de fin sur la minuterie en secondes",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Seuil énergétique global",
  T_42_XXJ_WS_ENTITYVARNAME_D: "L'entité auto-relative",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Équiper l'attachement",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Convertir les angles d'Euler donnés en quaternions",
  T_42_XXJ_WS_EXPONENTIATION_D: "Exponentiation",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Capacité de sac à dos supplémentaire",
  T_42_XXJ_WS_FIST: "Poing",
  T_42_XXJ_WS_FONTTYPE: "Énum de police",
  T_42_XXJ_WS_FONTTYPE_D: "Énum de police",
  T_42_XXJ_WS_FORCESYNCVALUE: "Forcer la sync du statut GS",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "La valeur de sync forcée",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "Les info de localisation. de la sync de force GS",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Informations de localisation issues de la sync forcée",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "Une entité capable de formuler des propriétés",
  T_42_XXJ_WS_FORWARD_D: "Vecteur de direction",
  T_42_XXJ_WS_FRICTION_COMBINE: "Méthode de Combinaison de Friction",
  T_42_XXJ_WS_FUNCPOINT: "Pointeur de fonction",
  T_42_XXJ_WS_FUNCPOINT_D: "Un pointeur qui pointe vers une instance d'une fonction. Il est utilisé pour implémenter des fonctions virtuelles ou des mécanismes de délégation.",
  T_42_XXJ_WS_GETMAPID_D: "Obtenir l'ID de la carte",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Sortir du véhicule",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Entrez le véhicule (conducteur)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Entrez le véhicule (passager)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Rechercher les données des jetons de joueur d'aujourd'hui",
  T_42_XXJ_WS_GRAVITY: "Gravité Globale",
  T_42_XXJ_WS_HANDHELDITEM: "Appareil portatif actuel",
  T_42_XXJ_WS_HANDHELDITEM_D: "Le portable actuel",
  T_42_XXJ_WS_HARD: "Dur",
  T_42_XXJ_WS_HASCOMPONENT_D: "S'il existe un composant",
  T_42_XXJ_WS_HEIGHTLIST_D: "Liste d'incréments de hauteur",
  T_42_XXJ_WS_INDEXLIST_D: "Accéder à la liste d'index de la chaîne",
  T_42_XXJ_WS_INSCENE: "en scène",
  T_42_XXJ_WS_INSCENE_D: "En scène",
  T_42_XXJ_WS_IS3D_D: "Qu'il s'agisse d'une musique 3D",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Compte à rebours ou chronomètre",
  T_42_XXJ_WS_ISLOOP: "Boucle ou pas",
  T_42_XXJ_WS_ISLOOP_D: "La commande IsLoop",
  T_42_XXJ_WS_ISREPLAY_D: "Faut-il ou non recommencer depuis le début",
  T_42_XXJ_WS_ISSWITCH_D: "Lorsqu'il est défini sur vrai, il peut être combiné avec un mouvement relatif. Lorsqu'il est défini sur faux, il peut être combiné avec un mouvement absolu.",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Statut du saut",
  T_42_XXJ_WS_LEFTVALUE: "Valeur Gauche",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logarithme",
  T_42_XXJ_WS_LOOPABLE: "Bouclable",
  T_42_XXJ_WS_LOOPABLE_D: "Bouclable",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Obtenez toutes les clés du dict",
  T_42_XXJ_WS_MAPVALUE_D: "Dict Cible",
  T_42_XXJ_WS_MARKBTNHUD: "Le bouton épingle sur le HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "La distance maximale",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "L'interrupteur du micro sur le HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "La distance minimale",
  T_42_XXJ_WS_MISSIONID_D: "ID de Mission",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progrès (ne peut pas être un nombre négatif)",
  T_42_XXJ_WS_MODERATE: "Modéré",
  T_42_XXJ_WS_MONSTERTRUCK: "Monster Truck",
  T_42_XXJ_WS_MOTORBIKE: "Moto",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Statut de Mouvement",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplication de deux quaternions (représentant la superposition de rotation)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Écarté",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Activer la perspective du joueur",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Activer la perspective du joueur",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Type d'arme",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Type d'arme",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Prioriser la config. du joueur",
  T_42_XXJ_WS_PARAMSARRAY: "Tableau de paramètres",
  T_42_XXJ_WS_PARAMSARRAY_D: "Le tableau de paramètres est une liste de paramètres impliqués dans la sortie. Il doit correspondre au nombre de %v dans la description du format.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "The list of actual parameters passed to the custom functions.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Masque de visibilité pièce 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Masque de visibilité pièce 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Masque de visibilité pièce 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Masque de visibilité pièce 4",
  T_42_XXJ_WS_PASSENGER1: "Siège passager 1",
  T_42_XXJ_WS_PASSENGER2: "Siège passager 2",
  T_42_XXJ_WS_PASSENGER3: "Siège passager 3",
  T_42_XXJ_WS_PHYMAT: "Matériel de physique",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entité",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Mouvement relatif dans chaque image",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Mouvement relatif à chaque image",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Mouvement Auto-Relatif",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "Le mouvement auto-relatif",
  T_42_XXJ_WS_PLAYER_D: "Le joueur qui doit entrer dans le véhicule",
  T_42_XXJ_WS_PLAYERBEHAVIOR: `Sync des propriétés de comportement de l'
entité du joueur`,
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "L'entité de sync des propriétés de comportement du joueur",
  T_42_XXJ_WS_PRIORITY_D: "Priorité",
  T_42_XXJ_WS_PROPID_D: "L'ID de propriété",
  T_42_XXJ_WS_QUATERNION: "Quaternion",
  T_42_XXJ_WS_QUATERNION_D: "Le quaternion est un vecteur spécial à quatre dimensions utilisé uniquement pour représenter une rotation",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Convertir les quaternions donnés en représentation axe-angle",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Convertissez les quaternions donnés en angles d'Euler. Si les quaternions ne répondent pas à la norme, renvoyez (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "Le nombre de fois joué. La valeur par défaut est 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Réinitialiser",
  T_42_XXJ_WS_RIGHTVALUE: "Valeur Droite",
  T_42_XXJ_WS_RIGHTVALUE_D: "Pouvoir",
  T_42_XXJ_WS_SEATTYPE: "Énum des sièges du véhicule",
  T_42_XXJ_WS_SEPSTR_D: "Chaîne utilisée pour la séparation",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Définir les DMG de chute du joueur",
  T_42_XXJ_WS_SETTINGSBTNHUD: "Le bouton de paramètres sur le HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Afficher l'emplacement",
  T_42_XXJ_WS_SHOWPOSITION_D: "Afficher l'emplacement",
  T_42_XXJ_WS_SIGNALICOHUD: "Le bouton de connexion réseau sur le HUD",
  T_42_XXJ_WS_SIMPLE: "Facile",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Interpolation de quaternions sphériques de A à B",
  T_42_XXJ_WS_SOUNDENTITY_D: "L'entité d'effet sonore représente un effet sonore qui est joué",
  T_42_XXJ_WS_SPEAKERBTNHUD: "Le bouton klaxon sur le HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Utilisez une certaine chaîne comme délimiteur pour diviser la chaîne en une tranche",
  T_42_XXJ_WS_SPORTSCAR: "Voiture de Sport",
  T_42_XXJ_WS_SPRINTSTATUS: "Statut du sprint",
  T_42_XXJ_WS_SRCVAL_D: "La valeur de la source",
  T_42_XXJ_WS_STARTTICKCOUNT: "Le moment où la GS commence à tiquer",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "Le moment où GS commence à tiquer",
  T_42_XXJ_WS_STARTTIME_D: "Heure de début",
  T_42_XXJ_WS_STARTTIME_D1: "Heure de début",
  T_42_XXJ_WS_STATE_D: "Statut d'un joueur : actif, renversé ou éliminé",
  T_42_XXJ_WS_STATE_D1: "Vérifiez si cet effet sonore est joué",
  T_42_XXJ_WS_STATIC_FRICTION: "Friction statique",
  T_42_XXJ_WS_STRELEMS_D: "Ensemble de chaînes cible",
  T_42_XXJ_WS_STRINGFINDAT_D: "Renvoie la chaîne combinée finale selon la liste d'index",
  T_42_XXJ_WS_STRINGJOIN_D: "Joindre des chaînes en utilisant un identifiant spécifié",
  T_42_XXJ_WS_STRINGLOWER_D: "Convertir tous les caractères de la chaîne en minuscules",
  T_42_XXJ_WS_STRINGSTRIP_D: "Supprimer les caractères d'espacement des deux côtés de la chaîne",
  T_42_XXJ_WS_STRINGUPPER_D: "Convertir tous les caractères de la chaîne en majuscules",
  T_42_XXJ_WS_STYLE_D: "Comment ça se joue",
  T_42_XXJ_WS_SUV: "Pickup",
  T_42_XXJ_WS_SWITCH: "Changer",
  T_42_XXJ_WS_SWITCH_D: "Lorsqu'il est défini sur true, il peut être combiné avec un mouvement relatif. Lorsqu'il est défini sur false, il doit être combiné avec un mouvement absolu, sinon les propriétés ne prendront pas effet correctement.",
  T_42_XXJ_WS_TARGETENTITY_D: "L'entité cible",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Bannière de score de ronde d'équipe",
  T_42_XXJ_WS_TEAMSEQ_D: "Le numéro de série de l'équipe qui correspond à la propriété de numéro de série de l'entité d'équipe",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Points de bouclier temporaires",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Points de bouclier temporaires",
  T_42_XXJ_WS_TEXT_D: "Le texte original sur lequel effectuer un filtre de grossièretés",
  T_42_XXJ_WS_THREESTATESWITCH: "Commutateur à 3 états",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Dague (butin au sol)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Dague",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Détails du match des équipes",
  T_42_XXJ_WS_UNIQUEID: "ID Unique",
  T_42_XXJ_WS_UNIQUEID_D: "ID Unique",
  T_42_XXJ_WS_VALUE_D: "La valeur",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Vecteur de direction aux angles d'Euler",
  T_42_XXJ_WS_VEHICLEID: "ID du Véhicule",
  T_42_XXJ_WS_VEHICLESKINID: "ID du Skin du Véhicule",
  T_42_XXJ_WS_VERYHARD: "Très Difficile",
  T_42_XXJ_WS_VOLUME_D: "Le volume sonore. La valeur par défaut est 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Type principal d'arme",
  T_42_XXJ_WS_WORKSHOPCODE: "Code de Carte",
  T_42_XXJ_WS_WORKSHOPCODE_D: "Le code de la carte qui correspond à une donnée de la base de données",
  T_42_XXJ_WS_WORLDPOSITION: "Coordonnées mondiales",
  T_42_XXJ_WS_WORLDPOSITION_D: "Coordonnées mondiales",
  T_42_XYL_WS_ITEM275: "Réservoir de carburant",
  T_42_XYL_WS_ITEM276: "Sac de sable A",
  T_42_XYL_WS_ITEM277: "Sac de sable B",
  T_42_XYL_WS_ITEM278: "Sac de sable C",
  T_42_XYL_WS_ITEM279: "Sac de sable",
  T_42_XYL_WS_ITEM280: "Villa à deux étages",
  T_42_XYL_WS_ITEM281: "Usine d’armes",
  T_42_XYL_WS_ITEM282: "Mur de pierre A",
  T_42_XYL_WS_ITEM283: "Mur de pierre B",
  T_42_XYL_WS_ITEM284: "Mur de pierre C",
  T_42_XYL_WS_ITEM285: "Mur de pierre D",
  T_42_XYL_WS_ITEM286: "Boîte de fournitures militaires A",
  T_42_XYL_WS_ITEM287: "Pièce de cuivre",
  T_42_XYL_WS_ITEM288: "Pièce d'argent",
  T_42_XYL_WS_ITEM289: "Pièce d'Or",
  T_42_XYL_WS_ITEM290: "Diamant",
  T_42_XYL_WS_ITEM291: "Éclats de diamant",
  T_42_XYL_WS_ITEM292: "Rubis",
  T_42_XYL_WS_ITEM293: "Emeraude",
  T_42_XYL_WS_ITEM294: "Sapphire",
  T_42_XYL_WS_ITEM295: "Signe d'avertissement",
  T_42_XYL_WS_ITEM297: "Ruine",
  T_42_XYL_WS_ITEM297TRUE: "Dispositif de contrôle",
  T_42_XYL_WS_ITEM298: "Conteneur d'alimentation B",
  T_42_XYL_WS_ITEM299: "Pile de neige",
  T_42_XYL_WS_ITEM300: "Mur High-tech A",
  T_42_XYL_WS_ITEM301: "Mur High-tech B",
  T_42_XYL_WS_ITEM302: "Pierre gelée F",
  T_42_XYL_WS_ITEM303: "Pierre gelée E",
  T_42_XYL_WS_ITEM304: "Plateforme High-tech A",
  T_42_XYL_WS_ITEM305: "Escalier High-tech A",
  T_42_XYL_WS_ITEM306: "Lampe d'exploration A",
  T_42_XYL_WS_ITEM307: "Déflecteur de ruines A",
  T_42_XYL_WS_ITEM308: "Déflecteur de ruines B",
  T_42_XYL_WS_ITEM309: "Support en acier de ruine A",
  T_42_XYL_WS_ITEM310: "Pierre de Ruine A",
  T_42_XYL_WS_ITEM311: "Pierre de Ruine B",
  T_42_XYL_WS_ITEM312: "Pierre de Ruine C",
  T_42_XYL_WS_ITEM313: "Lampe de poche A",
  T_42_XYL_WS_ITEM314: "Barre d’armature en ruine A",
  T_42_XYL_WS_LOGICALOBJECT: "Logique",
  T_42_XYL_WS_THEMEHIGHTECH: "Futuriste",
  T_42_XYL_WS_THEMEICE: "Glacé",
  T_42_XYL_WS_THEMEMILITARY: "Militaire",
  T_42_XYL_WS_THEMEOBJECTS: "Objets à Thème",
  T_42_XYL_WS_TIMERCONTINUE: "Incident de reprise de minuterie",
  T_42_XYL_WS_TIMERCYCLE: "Compte de boucle",
  T_42_XYL_WS_TIMERDOWN: "Compte à rebours",
  T_42_XYL_WS_TIMEREND: "Incident de fin de minuterie",
  T_42_XYL_WS_TIMEREVENT: "Incident de minuterie personnalisé",
  T_42_XYL_WS_TIMEREVENT1: "Minuterie de Contrôle",
  T_42_XYL_WS_TIMEREVENT2: "Définir les incidents de minuterie",
  T_42_XYL_WS_TIMERORDER: "Méthode de timing",
  T_42_XYL_WS_TIMERPAUSE: "Incident de pause de la minuterie",
  T_42_XYL_WS_TIMERSTART1: "Minuterie Heure de démarrage",
  T_42_XYL_WS_TIMERSTART2: "Incident de démarrage de la minuterie",
  T_42_XYL_WS_TIMERUP: "Compter jusqu'à",
  T_42_XYL_WS_TRIGGERTIME_MS: "Temps de déclenchement (en millisecondes)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "Un skywing pouvant accueillir plusieurs joueurs.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Score individuel",
  T_42_ZZ_GUILDWAR_SCORE: "Score",
  T_43_B_SKILL_DESC_MONKEYGOD: "Se transforme en buisson qui dure [FFB300]{1}s[-]. Temps de recharge : [FFB300]{0}s[-]. La transformation se termine lorsque Wukong attaque. Le CD se réinitialise lorsque Wukong élimine un ennemi.",
  T_43_B_SKILL_DESC_Nanoscientist: "Après avoir subi des dégâts mortels, entrez dans un état invulnérable et immobile pendant [FFB300]{0}s[-]. Ensuite, gagnez un [FFB300]{1} bouclier HP[-] qui dure [FFB300]{2}s[-]. L'utilisateur de la compétence sera éliminé lorsque le bouclier disparaîtra. Temps de recharge : [FFB300]{3}s[-].",
  T_43_B_SKILL_DESC_ORION: "Remplace EP par [FFB300]{0} Crimson Energy[-]. Consomme [FFB300]{1} Crimson Energy[-] pour activer sa protection, pendant laquelle vous ne pouvez pas subir de dégâts ni attaquer les ennemis et absorberez [FFB300]{4} HP[-] (en ignorant les points de bouclier ennemis) des ennemis à moins de [FFB300]{3}m[-]. Dure [FFB300]{2}s[-], pendant lesquels votre vitesse de déplacement diminuera de [FFB300]{6}%[-]. Temps de recharge : [FFB300]{5}s[-].",
  T_43_CJ_F_A_RACER: "Coureur de vitesse (Masque)",
  T_43_CJ_F_B_RACER: "Coureur de vitesse (Bas)",
  T_43_CJ_F_H_RACER: "Coureur de vitesse (Tête)",
  T_43_CJ_F_HA_RACER: "Coureur de vitesse (Maquillage)",
  T_43_CJ_F_S_RACER: "Coureur de vitesse (Chaussures)",
  T_43_CJ_F_T_RACER: "Coureur de vitesse (Haut)",
  T_43_CJ_M_A_RACER: "Turbo Racer (Masque)",
  T_43_CJ_M_B_MACHINERY: "Tech turquoise (Bas)",
  T_43_CJ_M_B_RACER: "Turbo Racer (Bas)",
  T_43_CJ_M_H_MACHINERY: "Tech turquoise (Tête)",
  T_43_CJ_M_H_RACER: "Turbo Racer (Tête)",
  T_43_CJ_M_HA_MACHINERY: "Tech turquoise (Maquillage)",
  T_43_CJ_M_S_MACHINERY: "Tech turquoise (Chaussures)",
  T_43_CJ_M_S_RACER: "Turbo Racer (Chaussures)",
  T_43_CJ_M_T_MACHINERY: "Tech turquoise (Haut)",
  T_43_CJ_M_T_RACER: "Turbo Racer (Haut)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Morsure de Mamba",
  T_43_HJ_WS_OPTION8: "Autres",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bamboo",
  T_43_HJ_WS_TEXTURE_BEACH: "Plage",
  T_43_HJ_WS_TEXTURE_BRICK1: "Mur De Briques A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Mur De Briques B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Mur De Briques C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Sol en Béton",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Béton",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Cristal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Herbe A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Herbe B",
  T_43_HJ_WS_TEXTURE_ICE: "Bloc de glace",
  T_43_HJ_WS_TEXTURE_IRON: "Sol en Métal",
  T_43_HJ_WS_TEXTURE_IRON2: "Conteneur",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Sol en Marbre",
  T_43_HJ_WS_TEXTURE_NONE: "Vide",
  T_43_HJ_WS_TEXTURE_STONE: "Pierre",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Nappe A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Nappe B",
  T_43_HJ_WS_TEXTURE_WOOD: "Bois",
  T_43_HJ_WS_TEXTURE_WOODEN: "Sol en Bois A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Sol en Bois B",
  T_43_JH_WS_MAPTAG1: "Adapté aux débutants",
  T_43_JH_WS_MAPTAG10: "Nouveau contenu ennuyeux",
  T_43_JH_WS_MAPTAG11: "Peu de sentiment de récompense",
  T_43_JH_WS_MAPTAG12: "Déséquilibre des récompenses",
  T_43_JH_WS_MAPTAG13: "Faible sentiment de progrès",
  T_43_JH_WS_MAPTAG14: "Inamical pour les débutants",
  T_43_JH_WS_MAPTAG15: "Tutoriel déroutant",
  T_43_JH_WS_MAPTAG16: "Manque de tutoriels",
  T_43_JH_WS_MAPTAG17: "Les joueurs quittent beaucoup",
  T_43_JH_WS_MAPTAG18: "Contrôles compliqués",
  T_43_JH_WS_MAPTAG19: "UI encombrée",
  T_43_JH_WS_MAPTAG2: "Nouveau contenu préféré",
  T_43_JH_WS_MAPTAG20: "Mauvaise conception de carte",
  T_43_JH_WS_MAPTAG21: "Tireur Passionnant",
  T_43_JH_WS_MAPTAG22: "Visage au rythme",
  T_43_JH_WS_MAPTAG23: "Monde Ouvert",
  T_43_JH_WS_MAPTAG24: "Riche en Histoire",
  T_43_JH_WS_MAPTAG25: "Progression",
  T_43_JH_WS_MAPTAG26: "Simulation de Sport",
  T_43_JH_WS_MAPTAG27: "Mission Co-op",
  T_43_JH_WS_MAPTAG28: "Social",
  T_43_JH_WS_MAPTAG29: "Instances Diverses",
  T_43_JH_WS_MAPTAG3: "Joueurs actifs",
  T_43_JH_WS_MAPTAG30: "Exploration Libre",
  T_43_JH_WS_MAPTAG31: "Défi de Classement",
  T_43_JH_WS_MAPTAG32: "Réalisation",
  T_43_JH_WS_MAPTAG33: "Échange De Devise",
  T_43_JH_WS_MAPTAG4: "Carte bien conçue",
  T_43_JH_WS_MAPTAG40: "Multiples récompenses",
  T_43_JH_WS_MAPTAG41: "Progrès satisfaisant",
  T_43_JH_WS_MAPTAG42: "Terrains d'entraînement populaires",
  T_43_JH_WS_MAPTAG43: "Tour Solo Populaire",
  T_43_JH_WS_MAPTAG44: "Zone de guerre populaire",
  T_43_JH_WS_MAPTAG5: "Bégaiement",
  T_43_JH_WS_MAPTAG6: "Co-op dure",
  T_43_JH_WS_MAPTAG7: "Trop de Bugs",
  T_43_JH_WS_MAPTAG8: "Quelques mises à jour",
  T_43_JH_WS_MAPTAG9: "Événements en match ennuyeux",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Piège à Araignée (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Articles du Largage",
  T_43_SJ_WS_AIRDROP_NAME: "Largage",
  T_43_SJ_WS_AIRDROP_TIME: "Début du Temps de Largage",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Articles du Largage",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Est Lecture Auto",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Est Position Centrale",
  T_43_SJ_WS_ANITRIGGER_CLIP: "ID du Clip d'Animation",
  T_43_SJ_WS_ANITRIGGER_LOOP: "est Boucle",
  T_43_SJ_WS_ANITRIGGER_NAME: "Déclencheur d'animation HUD",
  T_43_SJ_WS_RESET_ROUND: "Réinitialisation par manche",
  T_43_SJ_WS_START_DROPTIME: "Début du Temps de Dépôt (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Déclencheur d'animation",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Skin d'Animal: Meow Meow Zasil",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Moto - Vitesse incarnée",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Contient des fournitures de combat essentielles telles que des munitions et des articles médicaux",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Boîte de Fournitures",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Générez un mannequin [FFB300]{1} HP[-] qui se déplace de manière autonome pendant [FFB300]{0}s[-]. Lorsque le mannequin se trouve à moins de [FFB300]{3}m[-], utilisez à nouveau la compétence pour changer de position avec lui. Vous ne pouvez changer qu'une seule fois en [FFB300]{4}s[-], dans la limite de [FFB300]{2} fois[-] au total. Le joueur qui détruit le mannequin recevra une note de [FFB300]{5}s[-]. Temps de recharge : [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Compétence Active",
  T_43_XXJ_WS_AIRDROP: "Largage et Zombie",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "La transparence globale du HUD, avec une plage de 0 à 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "ID du contrôleur d'animation",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "L'ID utilisé pour décrire un élément de contrôleur d'animation",
  T_43_XXJ_WS_AUDIOID: "ID de l'Audio",
  T_43_XXJ_WS_AUDIOID_D: "L'ID utilisé pour décrire un élément audio",
  T_43_XXJ_WS_BACKGRCOLOR: "Couleur de fond",
  T_43_XXJ_WS_BACKGRCOLOR_D: "La couleur de la bordure de la barre de santé et l'arrière-plan flou",
  T_43_XXJ_WS_BURNING: "Brûlant",
  T_43_XXJ_WS_CSVID: "ID CSV",
  T_43_XXJ_WS_CSVID_D: "L'ID utilisé pour décrire un actif de table de configuration",
  T_43_XXJ_WS_CURRENTHP: "HP Actuel",
  T_43_XXJ_WS_CURRENTHP_D: "Valeur HP Actuelle",
  T_43_XXJ_WS_DAMAGEMAKER_D: "L'entité du jeu qui inflige des dégâts",
  T_43_XXJ_WS_DAMAGEZONE: "Zone de Dégât",
  T_43_XXJ_WS_DEFAULT: "Défaut",
  T_43_XXJ_WS_DEFAULT_D: "Défaut",
  T_43_XXJ_WS_EFFECTID: "ID de l'Effet",
  T_43_XXJ_WS_EFFECTID_D: "L'ID utilisé pour décrire un élément d'effet spécial",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "Une entité qui peut combattre (par exemple lancer des attaques, être attaquée ou être éliminée)",
  T_43_XXJ_WS_FOLLOWTARGET: "Suivre la cible",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Doit suivre une entité avec un composant Transform",
  T_43_XXJ_WS_GAINHPCOLOR: "Gagner de la Couleur HP",
  T_43_XXJ_WS_GAINHPCOLOR_D: "La portion accrue de HP s'affichera dans cette couleur pendant une courte période",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Est Aucun dégâts de chute",
  T_43_XXJ_WS_ISOPENTWEEN: "Est Tween Ouvert",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Activez ceci pour afficher les modifications HP dans différentes couleurs",
  T_43_XXJ_WS_KNOCKDOWN_D1: "Le joueur est dans un état renversé",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Paramètres pour la réponse à l'état de renversement lors de l'élimination",
  T_43_XXJ_WS_KNOCKDOWN_D3: "Le type de source de relance. Un joueur peut être réanimé s'il est renversé.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "État de renversement",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Type d'État de renversement",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "La réponse à l'état de renversement : maintenir la logique par défaut, ignorer l'état de renversement ou forcer le renversement.",
  T_43_XXJ_WS_LEVEL: "Niveau",
  T_43_XXJ_WS_LEVEL_D: "Niveau",
  T_43_XXJ_WS_LEVEL_D1: "Le niveau de zombie actuel",
  T_43_XXJ_WS_LINESPACING: "Interligne",
  T_43_XXJ_WS_LINESPACING_D: "Ne s'affiche pas lorsque le HP segmenté entre deux diviseurs ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Perdre la couleur HP",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "La partie réduite des HP s'affichera dans cette couleur pendant une courte période",
  T_43_XXJ_WS_MAINCOLOR: "Couleur Principal",
  T_43_XXJ_WS_MAINCOLOR_D: "La couleur des HP, des niveaux et des contours",
  T_43_XXJ_WS_MINISENTRY: "Tourelle",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "L'énumération des types de cibles qu'une tourelle peut attaquer",
  T_43_XXJ_WS_MISSILEEXPLODE: "Explosion de missile",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Doit être renversé",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Renversement Forcé",
  T_43_XXJ_WS_OFFSET: "Décalage",
  T_43_XXJ_WS_OFFSET_D: "Décalage par rapport à la cible suivie",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Le baril de pétrole explose",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Déclenché uniquement lorsque le contrôleur initie un mouvement",
  T_43_XXJ_WS_PLAYER_D: "L'entité du joueur dans le jeu. Chaque joueur en possède un.",
  T_43_XXJ_WS_PLAYERHEADHUD: "Tête de joueur HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "Les informations affichées au-dessus de la tête du joueur",
  T_43_XXJ_WS_PLAYERNAME: "Nom du Joueur",
  T_43_XXJ_WS_PLAYERNAME_D: "Affiche le nom du propriétaire actuel de la barre de santé",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Joueur ou Véhicule",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "L'alias du type d'entité joueur/véhicule",
  T_43_XXJ_WS_SCALE: "Échelle",
  T_43_XXJ_WS_SCALE_D: "Détermine la taille globale de l’échelle du HUD, avec la police mise à l’échelle pour correspondre.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Afficher le Nombre de Dégâts",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "Vrai par défaut. Affiche le numéro des dégâts.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Passer le renversement",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Évitez l'état de renversement et soyez éliminé instantanément",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Est Ignorer l'animation décalée",
  T_43_XXJ_WS_TEAM_D: "(Obsolète. Veuillez utiliser l'ID d'équipe.)",
  T_43_XXJ_WS_TERRAIN: "Terrain",
  T_43_XXJ_WS_TERRAIN_D: "Un composant de terrain dont les attributs ne peuvent pas être modifiés. Utilisé uniquement pour tester les fonctions.",
  T_43_XXJ_WS_TOTALHP: "HP Total",
  T_43_XXJ_WS_TOTALHP_D: "Valeur Totale HP",
  T_43_XXJ_WS_TWEENENTITY: "Entité interpolée",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Le véhicule explose",
  T_43_XXJ_WS_WIDTH: "Largeur",
  T_43_XXJ_WS_WIDTH_D: "La largeur de la barre de santé affichée",
  T_43_XXJ_WS_ZOMBIE: "Zombie",
  T_43_XYL_WS_DROIDFIST: "Poing (Droïde Apocalypse)",
  T_43_XYL_WS_DROIDFLAME: "Lance-flammes (Droïde Apocalypse)",
  T_43_XYL_WS_JAPANESE: "Style Japonais",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Personnalisez les journaux d'événements de match. Utilisé pour l'analyse de l'expérience utilisateur.",
  T_43_YU_WS_AIRDROPSTATE: "État du largage",
  T_43_YU_WS_AIRDROPSTATE_D: "État du largage (1 : prêt, 2 : chute, 3 : atterri)",
  T_43_YU_WS_ANIMATIONCLIPID: "ID du Clip d'Animation",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Personnaliser l'ID du clip d'animation",
  T_43_YU_WS_ASKBUYTARGET: "Demander Acheter Cibler",
  T_43_YU_WS_ASKBUYTARGET_D: "Spécifie la cible et envoie la demande d'achat",
  T_43_YU_WS_ASKEDLIST: "Liste demandée",
  T_43_YU_WS_ASKEDLIST_D: "La liste des éléments demandés",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Couleur de fond 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "The upper background color",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Couleur de fond 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "La couleur de fond du bas",
  T_43_YU_WS_BATCHCOMBINERENDER: "Rendu combiné par lots",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Lier la liste des entités monétaires",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "La liste des entités monétaires liées",
  T_43_YU_WS_BINDWALLETENTITYID: "Lier l'ID d'entité du portefeuille",
  T_43_YU_WS_BINDWALLETENTITYID_D: "L'ID de l'entité du portefeuille lié",
  T_43_YU_WS_CENTEROFFSET: "Décalage central",
  T_43_YU_WS_CENTEROFFSET_D: "La valeur de décalage pour le collisionneur de capsules",
  T_43_YU_WS_COLLECTIONID: "ID de Collection",
  T_43_YU_WS_COLLECTIONID_D: "L'ID de collection utilisé pour la collecte d'informations sur les actifs",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Créer un largage",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Créer un numéro de dégâts",
  T_43_YU_WS_CROSSPLATFORM_D: "Lorsque sélectionné, envoie au client s'il est appelé sur le serveur et vice versa.",
  T_43_YU_WS_CSROUNDRESULTHUD: "HUD de résultat du tour CS",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Résultats affichés à la fin de chaque tour",
  T_43_YU_WS_CURRENTEMOTECLIP: "Clip d'émote actuel",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID du clip d'émote actuel",
  T_43_YU_WS_DAMAGE_D: "Les dégâts hors zone",
  T_43_YU_WS_DICTIONARY: "Dictionnaire",
  T_43_YU_WS_DIRECTIONRULERHUD: "Règle de direction HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "La boussole en haut",
  T_43_YU_WS_DOTWEEN_D: "S'il faut effectuer des animations interpolées",
  T_43_YU_WS_DROPITEMS_D: "Articles dans le Largage",
  T_43_YU_WS_DURATION: "Durée",
  T_43_YU_WS_ENERGY: "Energie",
  T_43_YU_WS_ENERGY_D: "Valeur de modification EP",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Sujet",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Accroupissement",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Sprint",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Rester",
  T_43_YU_WS_EVENTID: "ID de l'événement",
  T_43_YU_WS_EVENTID_D: "Représente un événement",
  T_43_YU_WS_FACTION: "Faction",
  T_43_YU_WS_FACTION_D: "L'entité de faction",
  T_43_YU_WS_FACTION_D1: "Demandez de l'aide à la faction pour l'achat",
  T_43_YU_WS_FINALRADIUS_D: "Le rayon final de la zone de sécurité",
  T_43_YU_WS_FIRSTAIDKIT: "Kit Médical",
  T_43_YU_WS_FIRSTAIDKIT_D: "Kit Médical",
  T_43_YU_WS_FIRSTPERSONMODEL: "Modèle à la première personne",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "La caméra à la première personne",
  T_43_YU_WS_FONTCOLOR_D: "La couleur de la police",
  T_43_YU_WS_FONTSIZE_D: "La taille de la police",
  T_43_YU_WS_FORBIDEN: "Interdit",
  T_43_YU_WS_FORBIDEN_D: "Désactivez le HUD pour la demande d'achat",
  T_43_YU_WS_FREEZINGTIME: "Temps de Gel",
  T_43_YU_WS_FREEZINGTIME_D: "La durée pendant laquelle la cible touchée reste gelée",
  T_43_YU_WS_GRAVITY: "Gravité",
  T_43_YU_WS_GRAVITY_D: "L'accélération gravitationnelle. N'affecte que le contrôleur du joueur.",
  T_43_YU_WS_HANDCATAPULT: "Rampe de lancement",
  T_43_YU_WS_HANDCATAPULT_D: "Rampe de lancement",
  T_43_YU_WS_HEALTH: "Santé",
  T_43_YU_WS_HEALTH_D: "La valeur de récupération de la durabilité de l'armure",
  T_43_YU_WS_HEIGHT: "Hauteur",
  T_43_YU_WS_HELPEDPLAYER_D: "Le joueur aidé",
  T_43_YU_WS_HELPPLAYER_D: "Le joueur qui aide à l'achat",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Angle maximal horizontal",
  T_43_YU_WS_HORIZONTALMINANGLE: "Angle minimal horizontal",
  T_43_YU_WS_HUDTOGGLE: "Basculement du HUD",
  T_43_YU_WS_HUDTOGGLE_D: "L'entité HudToggle que les joueurs peuvent modifier dans l'éditeur HUD",
  T_43_YU_WS_INHALER: "Inhalateur",
  T_43_YU_WS_INHALER_D: "Inhalateur",
  T_43_YU_WS_INITRADIUS_D: "Le rayon initial de la zone de sécurité",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "Un entier signé de 64 bits",
  T_43_YU_WS_ISAPPLYSHADOW: "Est Appliquer une ombre",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Le fond est-il en Collision",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Est Boucle d'émote actuelle",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "S'il faut définir l'animation Emote actuelle en boucle",
  T_43_YU_WS_ISSIDECOLLIDING: "Est-ce Une Collision Latérale",
  T_43_YU_WS_ISSLIDING: "Est Glissement",
  T_43_YU_WS_ISTOPCOLLIDING: "Le sommet est-il en Collision",
  T_43_YU_WS_ITEM331: "Appareil Futuriste A",
  T_43_YU_WS_ITEM332: "Rocher Brillant A",
  T_43_YU_WS_ITEM333: "Écran Futuriste A",
  T_43_YU_WS_ITEM334: "Conteneur Futuriste A",
  T_43_YU_WS_ITEM335: "Conteneur Futuriste A",
  T_43_YU_WS_ITEM336: "Canapé en pierre A",
  T_43_YU_WS_ITEM337: "Interrupteur Futuriste A",
  T_43_YU_WS_ITEM338: "Tuyau Futuriste A",
  T_43_YU_WS_ITEM339: "Plateforme métallique A",
  T_43_YU_WS_ITEM340: "Table Futuriste A",
  T_43_YU_WS_ITEM341: "Table Futuriste  B",
  T_43_YU_WS_ITEM342: "Table Futuriste C",
  T_43_YU_WS_ITEM343: "Ordinateur Futuriste  A",
  T_43_YU_WS_ITEM344: "Pierre A",
  T_43_YU_WS_ITEM345: "Pierre B",
  T_43_YU_WS_ITEM346: "Pierre C",
  T_43_YU_WS_ITEM347: "Pierre D",
  T_43_YU_WS_ITEM348: "Pierre E",
  T_43_YU_WS_ITEM349: "Pierre F",
  T_43_YU_WS_ITEM350: "Pierre G",
  T_43_YU_WS_ITEM351: "Rideau de style japonais A",
  T_43_YU_WS_ITEM352: "Rideau de style japonais B",
  T_43_YU_WS_ITEM353: "Rideau de style japonais C",
  T_43_YU_WS_ITEM354: "Chaise de style japonais A",
  T_43_YU_WS_ITEM355: "Clôture de style japonais A",
  T_43_YU_WS_ITEM356: "Clôture de style japonais B",
  T_43_YU_WS_ITEM357: "Clôture de style japonais C",
  T_43_YU_WS_ITEM358: "Plateforme de style japonais A",
  T_43_YU_WS_ITEM359: "Mur de style japonais B",
  T_43_YU_WS_ITEM360: "Portail style japonais B",
  T_43_YU_WS_ITEM361: "Mur Futuriste D",
  T_43_YU_WS_ITEM362: "Mur Futuriste B",
  T_43_YU_WS_ITEM363: "Plinthe inclinée Futuriste",
  T_43_YU_WS_LEFTCOLOR: "Couleur Gauche",
  T_43_YU_WS_LEFTCOLOR_D: "La couleur du côté gauche",
  T_43_YU_WS_LEFTPLAYERARRAY: "Tableau du joueur de gauche",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "Le tableau du joueur de gauche",
  T_43_YU_WS_LEFTSCORE: "Score de Gauche",
  T_43_YU_WS_LEFTSCORE_D: "Le score du côté gauche",
  T_43_YU_WS_LEFTSCOREAFTER: "Score gauche après",
  T_43_YU_WS_LEFTSCOREAFTER_D: "Le score final du latéral gauche. Utilisé dans les animations de transition de partition.",
  T_43_YU_WS_LEVELOBJECTID: "ID d'objet de niveau",
  T_43_YU_WS_LEVELOBJECTID_D: "Décrit le type d'objet. Nécessite une analyse via la table de configuration SceneEditPrefab avant le chargement.",
  T_43_YU_WS_LOCALPOSITION_D: "Coordonnées dans le système de coordonnées local",
  T_43_YU_WS_LOCALPOSITION_D1: "La position relative",
  T_43_YU_WS_LOCALPOSITION_D2: "La position par rapport à l'ancre en bas à droite",
  T_43_YU_WS_LOCALPOSITION_D3: "La position par rapport à l'ancre",
  T_43_YU_WS_LOCALROTATION_D: "Angles de rotation dans le système de coordonnées local (X : lacet, Y : tangage et Z : roulis)",
  T_43_YU_WS_LOCALROTATIONQ_D: "Le quaternion dans le système de coordonnées local",
  T_43_YU_WS_LOCALSCALE_D: "La taille de l'échelle dans le système de coordonnées mondial",
  T_43_YU_WS_MASS: "Masse",
  T_43_YU_WS_MATERIALS: "Matériaux",
  T_43_YU_WS_MATERIALS_D: "La liste des matériaux utilisés pour le rendu",
  T_43_YU_WS_MAXSPEED: "Vitesse Max",
  T_43_YU_WS_MAXSPEED_D: "Aucune puissance supplémentaire ne sera générée une fois la vitesse maximale atteinte, mais la vitesse du véhicule peut dépasser la limite (par exemple en raison d'une accélération lors d'une descente d'une colline).",
  T_43_YU_WS_MESHID: "ID de Maillage",
  T_43_YU_WS_MESHID_D: "Décrit le type de maillage",
  T_43_YU_WS_MESHID1: "ID de Maillage",
  T_43_YU_WS_MESHID1_D: "Le maillage à utiliser pour le rendu",
  T_43_YU_WS_MINMOVEDISTANCE: "Distance de déplacement minimale",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Les mouvements avec une distance inférieure à cette valeur ne seront pas exécutés. Il est recommandé de le définir sur 0, sauf exigences particulières.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "Largage",
  T_43_YU_WS_MODULE_ANIMATION: "Animation",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Attributs de base",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Arbre de Comportement",
  T_43_YU_WS_MODULE_BUFF: "Buff",
  T_43_YU_WS_MODULE_CAMERA: "Caméra",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Canal de Chat",
  T_43_YU_WS_MODULE_CHECKPOINT: "Point de contrôle",
  T_43_YU_WS_MODULE_COLLECTION: "Collection",
  T_43_YU_WS_MODULE_COMBAT: "Combat",
  T_43_YU_WS_MODULE_COMPONENT: "Composant",
  T_43_YU_WS_MODULE_CONVERT: "Convertir",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Personnaliser les paramètres de la pièce",
  T_43_YU_WS_MODULE_DATABASE: "Stockage de Données",
  T_43_YU_WS_MODULE_DYEING: "Teinture",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Navmesh Dynamique",
  T_43_YU_WS_MODULE_ECONOMY: "Economie",
  T_43_YU_WS_MODULE_FF_PLATFORM: "Plateforme FF",
  T_43_YU_WS_MODULE_FOOTBALL: "Football",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Mode Fréquence d'Images",
  T_43_YU_WS_MODULE_GAMERESULT: "Résultat de jeu",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Scripts Globaux",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK et Triche",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Système de Saisie",
  T_43_YU_WS_MODULE_ITEMS: "Articles",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Objet de niveau",
  T_43_YU_WS_MODULE_LIST: "Liste",
  T_43_YU_WS_MODULE_MAP: "Carte",
  T_43_YU_WS_MODULE_MATCHING: "Match",
  T_43_YU_WS_MODULE_MATH: "Math",
  T_43_YU_WS_MODULE_MECHANISM: "Paramètres du Mécanisme",
  T_43_YU_WS_MODULE_MINIMAP: "Mini carte",
  T_43_YU_WS_MODULE_MORPH: "Morph",
  T_43_YU_WS_MODULE_OTHER: "Autre",
  T_43_YU_WS_MODULE_PET: "Animal",
  T_43_YU_WS_MODULE_PHYSICS: "Physique",
  T_43_YU_WS_MODULE_PLAYABLE: "Jouable",
  T_43_YU_WS_MODULE_PLAYER: "Joueur",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Scripts du Joueur",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Personnage prédéfini",
  T_43_YU_WS_MODULE_PROFILE: "Profil",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Formule de propriété",
  T_43_YU_WS_MODULE_SAFEZONE: "Zone de sécurité",
  T_43_YU_WS_MODULE_SCENE: "Scène",
  T_43_YU_WS_MODULE_SKILL: "Compétence",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Scripts statiques",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Rapport",
  T_43_YU_WS_MODULE_STDLIBRARY: "Librairie STD",
  T_43_YU_WS_MODULE_STRINGS: "Chaîne",
  T_43_YU_WS_MODULE_TEAM: "Équipe",
  T_43_YU_WS_MODULE_WORKFLOW: "Flux de travail",
  T_43_YU_WS_MONEYICON: "Icône d’argent",
  T_43_YU_WS_MONEYICON_D: "L’icône de la devise",
  T_43_YU_WS_MONEYICONCOLOR: "Couleur de l’icône d’argent",
  T_43_YU_WS_MONEYICONCOLOR_D: "La couleur de l'icône de la devise",
  T_43_YU_WS_MOVESAFEZONE_D: "Déplace en douceur la zone de sécurité de sa position de départ à la position finale. Les joueurs en dehors de la zone subiront un certain nombre de dégâts.",
  T_43_YU_WS_NEWVECTOR2: "Nouveau Vecteur2",
  T_43_YU_WS_NEWVECTOR2_D: "Obtient un nouveau vecteur 2D",
  T_43_YU_WS_OFFSET_D: "La position mondiale décalée par rapport à l'entité cible",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "Quand la demande d'achat du joueur est satisfaite",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "Quand un joueur demande de l'aide pour un achat en magasin",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Déclencher lorsque l'état du composant Toggle change",
  T_43_YU_WS_OPENSTATE: "État ouvert",
  T_43_YU_WS_OPENSTATE_D: "S'affiche lorsqu'il est défini sur true et se cache sinon",
  T_43_YU_WS_PACEMAKER: "Horizaline",
  T_43_YU_WS_PACEMAKER_D: "Horizaline",
  T_43_YU_WS_PARAMS_D: "La liste des paramètres",
  T_43_YU_WS_PARENT_D: "L'ID d'entité enregistré lors de la sérialisation",
  T_43_YU_WS_PHYSICALCCT: "CCT Physique",
  T_43_YU_WS_PHYSICALCCT_D: "Le contrôleur de joueur avec effets physiques",
  T_43_YU_WS_PLAYER_D: "Le Joueur acheteur",
  T_43_YU_WS_PLAYERDATAID: "ID de données de joueur",
  T_43_YU_WS_PLAYERDATAID_D: "Personnaliser l'ID de l'actif du personnage",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Type de pose PhysX du joueur",
  T_43_YU_WS_POSITION: "Position",
  T_43_YU_WS_POSITION_D: "Coordonnées dans le système de coordonnées mondial",
  T_43_YU_WS_POSITION_D1: "Coordonnées dans le système de coordonnées mondial. Efficace uniquement pour la musique 3D.",
  T_43_YU_WS_PRESSEDSPRITE: "Sprite pressé",
  T_43_YU_WS_PRESSEDSPRITE_D: "Le sprite pressé",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Type de Sprite pressé",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "Le type de sprite pressé",
  T_43_YU_WS_PRETIME: "Prétemps",
  T_43_YU_WS_RADIUS: "Rayon",
  T_43_YU_WS_RANDOMRANGE_D: "Corriger la position définie en fonction d'une plage aléatoire",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Type de demande d'achat",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Demande d'achat en magasin",
  T_43_YU_WS_REQUESTTYPE: "Type de Demande",
  T_43_YU_WS_REQUESTTYPE_D: "Le type de cible demandé par le joueur HUD actuel",
  T_43_YU_WS_RESPLAYERUUID: "Type de Joueur Prédéfini",
  T_43_YU_WS_RESPLAYERUUID_D: "L'ID de l'actif du joueur",
  T_43_YU_WS_RESUUID: "UUID de l'actif",
  T_43_YU_WS_RESUUID_D: "Spécifie l'UUID de l'actif par lots à restituer",
  T_43_YU_WS_RIGHTCOLOR: "Couleur de Droite",
  T_43_YU_WS_RIGHTCOLOR_D: "La couleur du côté droit",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Tableau du joueur de Droite",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "Le tableau du joueur de droite",
  T_43_YU_WS_RIGHTSCORE: "Score de Droite",
  T_43_YU_WS_RIGHTSCORE_D: "Le score du côté droit",
  T_43_YU_WS_RIGHTSCOREAFTER: "Score de Droite après",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "Le score final du côté droit. Utilisé dans les animations de transition de partition.",
  T_43_YU_WS_ROTATIONQ_D: "Le quaternion dans le système de coordonnées mondial",
  T_43_YU_WS_ROUNDINFOHUD: "HUD d'info sur le tour",
  T_43_YU_WS_ROUNDINFOHUD_D: "Informations affichées au début d'un tour",
  T_43_YU_WS_SELECTEDCOLOR: "Couleur Sélectionnée",
  T_43_YU_WS_SELECTEDCOLOR_D: "La couleur du sprite sélectionnée",
  T_43_YU_WS_SELECTEDSPRITE: "Sprite Sélectionné",
  T_43_YU_WS_SELECTEDSPRITE_D: "Le sprite sélectionné",
  T_43_YU_WS_SELECTEDTYPE: "Type Sélectionné",
  T_43_YU_WS_SELECTEDTYPE_D: "Le type de sprite sélectionné",
  T_43_YU_WS_SHADOWCOLOR: "Couleur de l'ombre",
  T_43_YU_WS_SHADOWOFFSET: "Décalage de l'ombre",
  T_43_YU_WS_SHOWTAG: "Afficher la balise",
  T_43_YU_WS_SHOWTAG_D: "Afficher les marquages d'équipe/faction",
  T_43_YU_WS_SHRINKDURATION_D: "La durée réduite de la zone de sécurité",
  T_43_YU_WS_SIMPLERENDER_D: "Le composant de rendu de transition utilisé pour le rendu avec les modèles intégrés",
  T_43_YU_WS_SKINWIDTH: "Largeur du Skin",
  T_43_YU_WS_SKINWIDTH_D: "La profondeur de pénétration dans la capsule pour éviter que le personnage ne reste coincé ou ne tremble",
  T_43_YU_WS_SLOPELIMIT: "Limite de pente",
  T_43_YU_WS_SLOPELIMIT_D: "Les objets placés sur la pente dépassant cet angle glisseront vers le bas",
  T_43_YU_WS_SPEED: "Vitesse",
  T_43_YU_WS_STARTDROPTIME_D: "L'heure d'arrivée du largage en millisecondes",
  T_43_YU_WS_STARTPOS_D: "La position de départ de la zone de sécurité",
  T_43_YU_WS_STATICICONCOLORS: "Couleurs des icônes statiques",
  T_43_YU_WS_STATICICONCOLORS_D: "Couleurs des icônes affichées sur la règle",
  T_43_YU_WS_STATICICONS: "Icônes statiques",
  T_43_YU_WS_STATICICONS_D: "Les icônes affichées sur les règles",
  T_43_YU_WS_STEPOFFSET: "Décalage de pas",
  T_43_YU_WS_STEPOFFSET_D: "Seuls les obstacles dépassant cette hauteur auront un effet bloquant",
  T_43_YU_WS_SUBTITLE: "Sous-titre",
  T_43_YU_WS_SUBTITLE_D: "Le sous-titre",
  T_43_YU_WS_TARGET: "Cible",
  T_43_YU_WS_TARGET_D: "L'entité cible pour le numéro de dommage affiché",
  T_43_YU_WS_TARGETICONCOLORS: "Couleurs des icônes cibles",
  T_43_YU_WS_TARGETICONCOLORS_D: "Couleurs de l'icône affichée par la cible marquée",
  T_43_YU_WS_TARGETICONS: "Icônes cibles",
  T_43_YU_WS_TARGETICONS_D: "Les icônes affichées par les cibles marquées",
  T_43_YU_WS_TARGETPOS_D: "La position finale cible de la zone de sécurité",
  T_43_YU_WS_TEAM: "Équipe",
  T_43_YU_WS_TEAM_D: "L'entité de l'équipe dans le jeu. Chaque équipe a une entité.",
  T_43_YU_WS_TEAM_D1: "Demandez de l'aide à l'équipe pour l'achat",
  T_43_YU_WS_TIMEOFSTAY_D: "La durée d'affichage en millisecondes",
  T_43_YU_WS_TITLE: "Titre",
  T_43_YU_WS_TITLE_D: "Le Titre Principal",
  T_43_YU_WS_TRANSFORM_D: "Rotation, mise à l'échelle et enregistrement parent-enfant",
  T_43_YU_WS_UNSELECTEDCOLOR: "Couleur non sélectionnée",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "La couleur du sprite non sélectionnée",
  T_43_YU_WS_UNSELECTEDSPRITE: "Sprite non sélectionné",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "Le sprite non sélectionné",
  T_43_YU_WS_UNSELECTEDTYPE: "Type non sélectionné",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Type de sprite non sélectionné",
  T_43_YU_WS_USEPHYSICALCCT: "Utiliser le CCT physique",
  T_43_YU_WS_VALUE_D: "Le contenu affiché",
  T_43_YU_WS_VECTOR2ADD: "Vecteur2 Ajouter",
  T_43_YU_WS_VECTOR2GETX: "Vecteur2 Obtenir X",
  T_43_YU_WS_VECTOR2GETY: "Vecteur2 ObtenirY",
  T_43_YU_WS_VECTOR2SCALE: "Échelle Vecteur2",
  T_43_YU_WS_VECTOR2SETX: "Vecteur2 Ensemble X",
  T_43_YU_WS_VECTOR2SETY: "Vecteur2 Ensemble Y",
  T_43_YU_WS_VECTOR2SUB: "Vecteur2 Sub",
  T_43_YU_WS_VELOCITY: "Vitesse",
  T_43_YU_WS_VERTICALMAXANGLE: "Angle vertical maximum",
  T_43_YU_WS_VERTICALMINANGLE: "Angle vertical minimum",
  T_43_YU_WS_VISIBILITY_D: "Indique si la visibilité peut être définie",
  T_43_YU_WS_VISIBLE_D: "Le paramètre de visibilité. S'il est défini sur invisible, le client arrête le rendu de la cible.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Mur Futuriste A",
  T_43_ZY_WS_ITEM320: "Mur Futuriste C",
  T_43_ZY_WS_ITEM321: "Fenêtre Futuriste",
  T_43_ZY_WS_ITEM322: "Porte Futuriste",
  T_43_ZY_WS_ITEM323: "Toit incliné Futuriste",
  T_43_ZY_WS_ITEM324: "Toit Circulaire Futuriste",
  T_43_ZY_WS_ITEM325: "Plinthe Futuriste",
  T_43_ZY_WS_ITEM326: "Plinthe Circulaire Futuriste",
  T_43_ZY_WS_ITEM327: "Chaise Futuriste",
  T_43_ZY_WS_ITEM328: "Décoration Futuriste A",
  T_43_ZY_WS_ITEM329: "Immeuble Futuriste A",
  T_43_ZY_WS_ITEM330: "Immeuble Futuriste B",
  T_44_CJ_M_B_SPORT_TH: "Uniforme de Gym (Bas)",
  T_44_CJ_M_H_SPORT_TH: "Uniforme de Gym (Tête)",
  T_44_CJ_M_S_SPORT_TH: "Uniforme de Gym (Chaussures)",
  T_44_CJ_M_T_SPORT_TH: "Uniforme de Gym (Haut)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Attaque du Feu Follet",
  T_44_H_USP45_CARNIVORE_N: "USP – Dent de Poison",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Moto - Coups de Tonnerre",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Forcer le démarrage avec Min. Joueurs",
  T_44_JH_WS_HALFWAYKEY1: "Priorisez le démarrage avec une équipe complète",
  T_44_PD_PVE_DRAGON_NAME: "Méchadrake",
  T_44_QL_GRENADE_DRAGON: "Gel de Dragon",
  T_44_QL_GRENADE_DRAGON_DES: "Un Flash Freeze mis à niveau qui explosera trois fois consécutivement à l'impact",
  T_44_QL_JUMPSHOESX: "Dragon Sprinters",
  T_44_QL_JUMPSHOESX_DES: "Une paire de chaussures de saut spéciales qui permettent de sprinter dans les airs lors d'un double saut",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Temps de fermeture de la zone de sécurité",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Moment où la zone de sécurité disparaît.Si le Temps De Fermeture De La Zone De Sécurité est inférieur au Temps De Début De La Zone De Sécurité, aucune Zone De Sécurité ne sera générée.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Couleur de la zone de sécurité",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Intervalle de Dégâts",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Intervalle de dégâts",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Valeur des Dégâts",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "Les dégâts infligés à un joueur hors zone en une seule instance",
  T_44_SJ_WS_SAFEZONE_DESC: "Un objet hors zone pouvant être placé",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Rayon de fin hors zone",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "Rayon final de la zone hors de la zone",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Liste des joueurs de la zone de sécurité",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Obtenez la liste des joueurs dans la zone de sécurité",
  T_44_SJ_WS_SAFEZONE_NAME: "La zone hors zone",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Durée De Rétrécissement (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Durée du rétrécissement de la zone",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Rayon initial hors zone",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Rayon initial de la zone hors zone",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Début du temps de rétrécissement",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Moment où le retrait de la zone commence",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Heure de début de la zone de sécurité",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Heure à laquelle la zone de sécurité apparaît à chaque tour du match. 0 par défaut.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Alpha Activé",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "alpha activé",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Hud Du Bouton De Compétence Active",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Ajouter un composant à une entité. Ne prend en charge que les composants personnalisés. (Un composant ne sera pas ajouté à nouveau s'il existe déjà).",
  T_44_XXJ_WS_ALLMEMBERS: "Tous Les Membres",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Autoriser La Pression À L'extérieur",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Autoriser le déclenchement en dehors de la zone désignée",
  T_44_XXJ_WS_ARROWIMAGE: "Image De Flèche",
  T_44_XXJ_WS_ARROWIMAGE_D: "Image de flèche",
  T_44_XXJ_WS_ARROWOFFSET: "Décalage De La Flèche",
  T_44_XXJ_WS_ARROWOFFSET_D: "Décalage de la flèche",
  T_44_XXJ_WS_ARROWSIZE: "Taille de la flèche",
  T_44_XXJ_WS_ARROWSIZE_D: "Taille de flèche",
  T_44_XXJ_WS_AUTOPLAY_D: "Jouer automatiquement à la création",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Image D'arrière-plan",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Image de base",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Rayon d'arrière-plan",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Rayon de Base",
  T_44_XXJ_WS_BAGSKINID: "ID De Skin De Sac À Dos",
  T_44_XXJ_WS_BAGSKINID_D: "L'ID du skin du sac à dos",
  T_44_XXJ_WS_BONEPOSITION: "Position Des Os",
  T_44_XXJ_WS_BONEPOSITION_D: "Coordonnées mondiales du nœud osseux",
  T_44_XXJ_WS_CCTMOVE: "Déplacer le CCT",
  T_44_XXJ_WS_COLLIDER: "Collisionneur",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Collection Collisionneur",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "Le composant utilisé pour décrire la forme de la collision",
  T_44_XXJ_WS_COLOR: "Couleur",
  T_44_XXJ_WS_CONTENT: "Contenu",
  T_44_XXJ_WS_CONTENT_D: "Le contenu du portefeuille est une collection de devises",
  T_44_XXJ_WS_CONTEXT_D: "Contenu à imprimer",
  T_44_XXJ_WS_CROSSHAIRSHUD: "HUD de Réticules",
  T_44_XXJ_WS_CURVE_D: "Courbe",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Couleur de la texture de surface",
  T_44_XXJ_WS_ENABLE: "Activer",
  T_44_XXJ_WS_ENTITY_D: "Entité",
  T_44_XXJ_WS_GETBAGSKINID_D: "Obtenir la configuration du skin du sac à dos du joueur",
  T_44_XXJ_WS_GETFACTION_D: "Obtenir la faction",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Récupérez les scènes chargées qui n'ont pas été désinstallées",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Obtenez le joueur local",
  T_44_XXJ_WS_GROUPID: "Id De Groupe",
  T_44_XXJ_WS_GROUPID_D: "Pour la logique interne",
  T_44_XXJ_WS_HUDJOYSTICK: "Widget Manette De Jeu HUD",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Entité Joystick. Les joueurs peuvent modifier le HUD via le HUD Editor.",
  T_44_XXJ_WS_HUDTOUCHPAD: "Widget Du Pavé Tactile Hud",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "Le widget HUD Touchpad que les joueurs peuvent modifier dans l'éditeur HUD",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "HUD personnalisé ou widget HUD",
  T_44_XXJ_WS_ICON: "Icône",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Toujours Afficher La Marque",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Toujours afficher les marques sur la boussole",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Alpha Non Activé",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Alpha non activé",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "Lors de l'appel, le nombre de paramètres réels ne correspond pas à celui des paramètres formels. Le nombre attendu est {0}, tandis que le nombre réel est {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Est Un Obstacle Dynamique",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Est un obstacle dynamique pour NavMesh",
  T_44_XXJ_WS_ISEND: "C'est Fin",
  T_44_XXJ_WS_ISEND_D: "EstFin",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Est Piloté Par Le Serveur",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "S'il est faux, les objets personnalisés ne peuvent pas être contrôlés par les API.",
  T_44_XXJ_WS_ISSUC_D: "Renvoyer le résultat d'exécution",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Rayon De Traînée De La Manette De Jeu",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Rayon de glissement du joystick",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Image De La Manette De Jeu",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Image de Joystick",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Rayon De La Manette De Jeu",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Rayon du joystick",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Liste D'id De Compétence De Personnage",
  T_44_XXJ_WS_LOOPTYPE_D: "Type de boucle",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Quitter La Configuration Intermédiaire",
  T_44_XXJ_WS_MOUNTABLE: "Hiérarchique",
  T_44_XXJ_WS_MOUNTABLE_D: "Entité capable de monter les nœuds enfants",
  T_44_XXJ_WS_MOVEMENT: "Mouvement",
  T_44_XXJ_WS_NAME_D: "Nom",
  T_44_XXJ_WS_NATURALCONST: "Constante Naturelle",
  T_44_XXJ_WS_NATURALCONST_D: "Enum des constantes naturelles pour réduire les définitions redondantes",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Jouer à l'animation de l'icône",
  T_44_XXJ_WS_OFFSET_D: "Décalage d'origine par défaut",
  T_44_XXJ_WS_ONFIRE_D: "Déclenche l'événement chaque fois que le joueur tire, attaque avec les poings ou attaque avec des armes de mêlée.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Déclenche l'événement lorsque le joueur se relève de sa position couchée/accroupie.",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Déclenche l'événement lorsque le joueur appuie sur le bouton de tir",
  T_44_XXJ_WS_OPTION: "Options",
  T_44_XXJ_WS_PASSIVESKILLHUD: "HUD De Compétence Passive",
  T_44_XXJ_WS_PHYSICALMOVER: "Déménageur Physique",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Les joueurs sur cette plateforme suivront automatiquement les mouvements et la rotation",
  T_44_XXJ_WS_PHYSICALOBJECT: "Objet Physique",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Peut lui appliquer une force",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "La constante mathématique π (Pi)",
  T_44_XXJ_WS_PLAYERS: "Liste Des Joueurs",
  T_44_XXJ_WS_PLAYERS_D: "Liste des joueurs",
  T_44_XXJ_WS_PLAYERSKILLID: "Id De Compétence De Personnage",
  T_44_XXJ_WS_PLAYERSKILLID_D: "ID de compétence de personnage dans AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "La pose précédente avant que le joueur ne se lève",
  T_44_XXJ_WS_PRINT: "Imprimer",
  T_44_XXJ_WS_PRINTERROR: "Erreur D'impression",
  T_44_XXJ_WS_PRINTERROR_D: "Imprimer les données cibles en tant qu'erreur dans la console",
  T_44_XXJ_WS_PRINTWARNING: "Imprimer L'avertissement",
  T_44_XXJ_WS_PRINTWARNING_D: "Imprimer les données cibles comme avertissement à la console",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Prioriser La Configuration Du Skin Du Joueur",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Donne la priorité à la configuration du skin de joueur en dehors du match",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Lire le contenu des cellules d'une ligne en fonction du numéro de colonne et de la clé.",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Effacer la configuration du skin du sac à dos du joueur",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Supprimer un composant d'une entité. Ne prend en charge que les composants personnalisés.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Réinitialiser la configuration du skin du sac à dos du joueur sur sa configuration Hors match",
  T_44_XXJ_WS_SETBAGSKINID_D: "Définir la configuration du skin du sac à dos du joueur",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entité prenant en charge les composants Transform, SkeletonPart, Player et MountPoint",
  T_44_XXJ_WS_SHOWBACKGROUND: "Afficher l'arrière-plan",
  T_44_XXJ_WS_SKINID_D: "ID de skin de sac à dos et configuration du skin",
  T_44_XXJ_WS_SPEED_D: "Vitesse de lecture",
  T_44_XXJ_WS_TARGET: "Cible",
  T_44_XXJ_WS_TARGET_D: "Objet cible",
  T_44_XXJ_WS_TITLE: "Titre",
  T_44_XXJ_WS_TYPEID_D: "ID de type de composant. Ne prend en charge que les composants personnalisés.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Télécharger les résultats de la match personnalisée",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Incompatibilité de type. Impossible de lire le contenu du tableau.",
  T_44_XXJ_WS_X_D: "Coordonnée de l'axe-X",
  T_44_XXJ_WS_Y_D: "Coordonnées de l'axe-Y",
  T_44_XYL_WS_CTZSAFEZONE: "Zone de sécurité personnalisée",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Génère les points de départ et d'arrivée d'une zone de sécurité en fonction des positions et des propriétés définies",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Coque Hémisphérique",
  T_44_XYL_WS_QUARTERCYLINDER: "Quart de Cylindre",
  T_44_XYL_WS_SQUAREPYRAMID: "Pyramide Carré",
  T_44_XYL_WS_TORUS: "Torus",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Pyramide Triangulaire",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Ajouter la carte du journal des événements de jeu",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Ajouter un journal des événements utilisateur",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "Le journal des événements du match personnalisé utilisé pour l'analyse des données UX",
  T_44_YU_WS_ITEM366: "Mur militaire A",
  T_44_YU_WS_ITEM367: "Mur militaire B",
  T_44_YU_WS_ITEM368: "Mur militaire C",
  T_44_YU_WS_ITEM369: "Mur militaire D",
  T_44_YU_WS_ITEM370: "Fenêtre militaire A",
  T_44_YU_WS_ITEM371: "Fenêtre militaire B",
  T_44_YU_WS_ITEM372: "Fenêtre militaire C",
  T_44_YU_WS_ITEM373: "Porte militaire A",
  T_44_YU_WS_ITEM374: "Porte militaire B",
  T_44_YU_WS_ITEM375: "Toit à angle militaire A",
  T_44_YU_WS_ITEM376: "Toit à angle militaire B",
  T_44_YU_WS_ITEM377: "Escalier militaire A",
  T_44_YU_WS_ITEM378: "Escalier militaire B",
  T_44_YU_WS_ITEM379: "Pilier militaire A",
  T_44_YU_WS_ITEM380: "Main courante militaire A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Personnaliser",
  T_45_CJ_TREATMENTGUN_Y_N: "Pistolet de Guérison-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Marche du Champion",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Inspecter",
  T_45_HL_Moderation_fail_1: "Malheureusement, le projet que vous avez soumis n'a pas passé l'examen.",
  T_45_HL_Moderation_fail_2: "implique",
  T_45_HL_Moderation_fail_3: "Raisons incluses:",
  T_45_HL_Moderation_fail_Location_1: "Contenu Du Jeu",
  T_45_HL_Moderation_fail_reason_1: "Contenu Toxique",
  T_45_HL_Moderation_fail_reason_10: "Violation Des Directives De Communauté",
  T_45_HL_Moderation_fail_reason_11: "Impacts Négatifs Sur Les Économies Du Jeu Et Violation De La Propriété Virtuelle",
  T_45_HL_Moderation_fail_reason_2: "Contenu Inapproprié",
  T_45_HL_Moderation_fail_reason_3: "Politiquement Sensibilité",
  T_45_HL_Moderation_fail_reason_4: "Fausse information",
  T_45_HL_Moderation_fail_reason_5: "Violation des droits d'auteur",
  T_45_HL_Moderation_fail_reason_6: "Violation De La Vie Privée",
  T_45_HL_Moderation_fail_reason_7: "Préoccupations De Sécurité",
  T_45_HL_Moderation_fail_reason_8: "Discours De Haine",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Autres Problèmes",
  T_45_JH_WS_CLEMPTYOBJECT: "Groupe D'objet",
  T_45_JH_WS_PETSWITCH1: "Afficher ou non les animaux de compagnie pendant le match",
  T_45_QL_CSFPP_DES: "Éliminez tous les adversaires en vue à la première personne dans ce mode CS spécial!",
  T_45_QL_CSFPP_NAME: "Clash Squad: FPP",
  T_45_QL_CSFPP_RANKNAME: "Première-Personne",
  T_45_SJ_WS_REVIEW_23: "Contenu Du Jeu",
  T_45_SJ_WS_REVIEW_24: "{0} implique {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} implique {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Appuyez pour afficher les détails >>[-]",
  T_45_SJ_WS_REVIEW_27: "Non Approuvé",
  T_45_SJ_WS_REVIEW_28: "Retour de Révision",
  T_45_SJ_WS_REVIEW_29: "Le contenu implique {0} violation(s)",
  T_45_SJ_WS_REVIEW_31: "Non Approuvé",
  T_45_SJ_WS_REVIEW_32: "La révision a échoué en raison d'exceptions du serveur",
  T_45_SJ_WS_REVIEW_TITLE: "Détails de la Violation",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Déclenche le saut (sauter par-dessus les obstacles)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Distance de Saut",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Modifie la distance de saut",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Hauteur du Saut",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Contrôle la hauteur de déplacement vers le haut et vers le bas lors du saut",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Déclencheur De Saut",
  T_45_TYC_CL_TEMPLATE_WS: `Un mode d'élimination où les joueurs éliminent toutes les équipes adverses dans une bataille chaotique pour gagner.
Vous pouvez définir les règles du jeu et modifier les paramètres du jeu comme vous le souhaitez.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Skyblaster",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = attaque automatique, 1 = attaque défensive, 2 = ne pas attaquer",
  T_45_XXJ_WS_ADDFRIEND: "Ajouter un Ami",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Auto",
  T_45_XXJ_WS_BASEDATA: "Données de Base",
  T_45_XXJ_WS_BOTH: "Les deux",
  T_45_XXJ_WS_BYHIERARCHY: "Par Hiérarchie",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "Par Priorité Élevée à Faible",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "Par Priorité Faible à Élevée",
  T_45_XXJ_WS_CAMERA: "Caméra",
  T_45_XXJ_WS_CAMERATYPE: "Type de Caméra",
  T_45_XXJ_WS_CENTERINVISIBLE: "Centre Invisible",
  T_45_XXJ_WS_CLIENT: "Client",
  T_45_XXJ_WS_COLLIDERID: "ID du Collisionneur",
  T_45_XXJ_WS_COLLIDERID_D: "L'ID du Collisionneur",
  T_45_XXJ_WS_COMPONENT: "Composant",
  T_45_XXJ_WS_CURRENTCAMERA: "Caméra Actuelle",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Force de Poussée Personnalisée",
  T_45_XXJ_WS_DOUBLE: "Double",
  T_45_XXJ_WS_DUMP: "Jeter",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Activer le déplacement en l'air",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Activer Rotation avec Gravité",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Événement",
  T_45_XXJ_WS_FILLAMOUNT: "Remplissez le Montant",
  T_45_XXJ_WS_FILLDIR: "Direction de Remplissage",
  T_45_XXJ_WS_FIRETYPE: "Type de Tir",
  T_45_XXJ_WS_FIRETYPE_D: "Le type de tir",
  T_45_XXJ_WS_FIXEDDELTATIME: "Temps Delta Fixe",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "L'intervalle de temps fixe pour les mises à jour des cadres en millisecondes",
  T_45_XXJ_WS_FORWARD: "Avant",
  T_45_XXJ_WS_FORWARD_D: "La direction de l'axe-z dans le système de coordonnées local",
  T_45_XXJ_WS_FUNCTIONTYPE: "Type de Fonction",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "Le type de fonction",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "La direction de visée du joueur local",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Obtenez l'horodatage local",
  T_45_XXJ_WS_GRADIENT: "Dégradé",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Bas Dégradé",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Bas Dégradé Alpha",
  T_45_XXJ_WS_GRADIENTTOP: "Haut Dégradé",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Haut Dégradé Alpha",
  T_45_XXJ_WS_HITPOSITION_D: "La position mondiale de la cible touchée par les balles",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "Widget du Bouton Social de L'interface Utilisateur",
  T_45_XXJ_WS_INVERTFILL: "Inverser le Remplissage",
  T_45_XXJ_WS_ISGROUNDED: "Est mis à terre",
  T_45_XXJ_WS_ISSILENCE: "Est Silence",
  T_45_XXJ_WS_ISSILENCE_D: "S'il est silencieux ou non",
  T_45_XXJ_WS_ISSINGLESHOT: "Est un Seul Coup",
  T_45_XXJ_WS_ISSINGLESHOT_D: "S'il s'agit d'un seul coup ou non",
  T_45_XXJ_WS_JUMPHEIGHT: "Hauteur du Saut",
  T_45_XXJ_WS_JUMPHEIGHT_D: "La hauteur du saut",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Type de Tri de Mise En Page",
  T_45_XXJ_WS_LIGHT_D: "Lumières",
  T_45_XXJ_WS_LOCAL: "Locale",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Max. Nombre de Sauts",
  T_45_XXJ_WS_MODULE: "Module",
  T_45_XXJ_WS_NONE: "Aucun",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Exécutez la commande à chaque fois avant que l'entité n'inflige des dégâts",
  T_45_XXJ_WS_ONDISABLE_D: "S'exécute lorsque l'entité est désactivée",
  T_45_XXJ_WS_ONEACHLOOP_D: "Exécuté à chaque fois que Jouable est bouclé. Efficace uniquement côté client pour les entités telles que les Effets Sonores et les Effets Spéciaux.",
  T_45_XXJ_WS_ONENABLE_D: "S'exécute lorsque l'entité est activée",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "Lors de l'entrée dans une image à une fréquence fixe de 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Déclenche l'événement client lorsque le joueur ajoute ou supprime un ami",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Déclenchez l'événement lorsque le jeu est en pause à cause de l'API appelée",
  T_45_XXJ_WS_ONGAMERESUME_D: "Déclenchez l'événement lorsque le jeu reprend à cause de l'API appelée",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "Quand le joueur arrête de sprinter",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "Quand le joueur arrête de surfer",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "Quand le joueur surfe",
  T_45_XXJ_WS_PHYSICALLAYER_D: "La couche physique personnalisée dans une plage de 0 à 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Type de Plateforme",
  T_45_XXJ_WS_PLATFORMTYPE_D: "Le type de plateforme",
  T_45_XXJ_WS_PLAYER: "Joueur",
  T_45_XXJ_WS_PLAYERCCT: "CCT Joueur",
  T_45_XXJ_WS_PLAYERCCT_D: "Un contrôleur de personnage avec des effets physiques et utilisé uniquement pour les personnages Free Fire",
  T_45_XXJ_WS_PRIORITY: "Priorité",
  T_45_XXJ_WS_REMAINMULTINUM: "Nombre de Sauts Restants",
  T_45_XXJ_WS_REPORT: "Rapport",
  T_45_XXJ_WS_RIGHT: "Droite",
  T_45_XXJ_WS_RIGHT_D: "La direction de l'axe-x dans le système de coordonnées local",
  T_45_XXJ_WS_SERVER: "Serveur",
  T_45_XXJ_WS_SINGLE: "Seul",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Type de Style du Bouton Social",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "Le style du bouton social",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Type de Bouton Social",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "le type de bouton social",
  T_45_XXJ_WS_SORTTYPE_D: "Types de tri: croissant non nul, décroissant et croissant",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Vitesse de déplacement pendant l'ADS",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "La vitesse de déplacement en visant vers le bas",
  T_45_XXJ_WS_STRINGORLOCSTRING: "Chaîne ou chaîne localisée",
  T_45_XXJ_WS_TRIPLE: "Triple",
  T_45_XXJ_WS_UP: "En haut",
  T_45_XXJ_WS_UP_D: "La direction de l'axe-y dans le système de coordonnées local",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Utilisez une Force de Poussée Personnalisée",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Lancez une fusée de signalisation vers la zone désignée pour invoquer un véhicule aléatoire",
  T_45_ZD_VEHICLEDROP_R_NAME: "Véhicule Mystère",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Temps Joué",
  T_46_HJ_WS_SHAREBY: "Par {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Mode de Jeu",
  T_46_HJ_WS_SHARETEAM: "Équipe",
  T_46_HJ_WS_SHARETEAMVS: "{0} contre {1}",
  T_46_HX_B_SCHOOL_VN: "Top de Classe (Bas)",
  T_46_HX_H_SCHOOL_VN: "Top de Classe (Tête)",
  T_46_HX_S_SCHOOL_VN: "Top de Classe (Chaussures)",
  T_46_HX_T_SCHOOL_VN: "Top de Classe (Haut)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutoriel",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Autres",
  T_46_XXJ_WS_ACTUALPOSITION: "Position Actuelle",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Ajoutez l'objet à surveiller avec la synchronisation AOI au-delà de la ligne de vue",
  T_46_XXJ_WS_APPEARANCE: "Apparence",
  T_46_XXJ_WS_APPEARANCERES: "Ressource D'apparence",
  T_46_XXJ_WS_BECOME: "Activer",
  T_46_XXJ_WS_BRAKETORQUE_D: "La puissance en chevaux fournie au véhicule lors de l'utilisation du Frein/L'inversion",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Type De Restriction D'angle De Rotation De La Caméra",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Effacer tous les objets surveillés de la cible",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "Les dégâts d'accident maximaux utilisés pour le calcul des dégâts",
  T_46_XXJ_WS_CRASHMAXSPEED: "Vitesse Max. D'accident",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Utilisé pour le calcul des dégâts d'accident. Une fois cette vitesse dépassée, aucun dégât supplémentaire ne sera ajouté.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Facteur de Masse D'accident",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "Un paramètre utilisé dans la formule de calcul des dégâts en cas d'accident.",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "Dégâts minimaux en cas d'accident, utilisés pour le calcul des dégâts",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "La limite de lecture et écriture du stockage de données a été dépassée",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Exception de paramètre",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Expiration du délai de stockage des données. S'applique principalement à la lecture et à l'écriture maintenant.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Modifier L'apparence",
  T_46_XXJ_WS_ENDVALUE_D: "La valeur de destination",
  T_46_XXJ_WS_ENGINETORQUE_D: "La puissance en chevaux donnée au véhicule lorsque la pédale d'accélérateur est utilisée",
  T_46_XXJ_WS_ERRORCODE_D: "L'énumération du code d'erreur",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Angle d'Euler vers Vecteur3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Convertir l'angle d'Euler en un vecteur 3D",
  T_46_XXJ_WS_EXPIRE: "Expire",
  T_46_XXJ_WS_FEMALEAVATAR: "Personnage Féminin",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Obtenir la Date D'expiration de L'adhésion",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "Si l'observateur surveille un objet ou non",
  T_46_XXJ_WS_HELICOPTER: "Skyblaster",
  T_46_XXJ_WS_HELICOPTER_D: "Un type de véhicule volant",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "Restriction de Braquage à Grande Vitesse",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "L'angle de braquage maximal dans un état de vitesse élevée",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "Angle de Braquage à Grande Vitesse",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "Le seuil de vitesse pour l'angle de braquage maximal à grande vitesse",
  T_46_XXJ_WS_IDLE: "Animation D'inactivité",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Entrée Du Frein De Ralenti",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "Lorsque vous ne conduisez pas un véhicule, décélérez-le par (Entrée du Frein de Ralenti) x (Couple de Freinage).",
  T_46_XXJ_WS_INTTOFLOAT: "Int à float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Convertir un nombre entier en nombre à virgule flottante",
  T_46_XXJ_WS_ISPREMIUM: "Est Adhérent",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "Le nom du tableau de classement dans la base de données",
  T_46_XXJ_WS_MALEAVATAR: "Personnage Masculin",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "Persona de l'IA",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "Nouvelle Apparence de l'UMA",
  T_46_XXJ_WS_NONE_D: "Aucune erreur",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "L'objet NPC",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Conseils: Les NPCs humanoïdes ont généralement un modèle de collision avec une capsule de 1,4 m de haut et de 0,25 m de rayon. Les animaux NPC ont généralement un modèle de collision avec une capsule de 1m de haut et de 0,4m de rayon.",
  T_46_XXJ_WS_OBSERVER_D: "L'observateur qui surveille les objets",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "Sur L'adhésion à Craftland",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "Sur L'abandon de L'adhésion à Craftland",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Adhésion Ouverte à Craftland",
  T_46_XXJ_WS_PERSONA: "Persona",
  T_46_XXJ_WS_PERSONACENTER: "Centre Persona",
  T_46_XXJ_WS_PET: "Animaux",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Joueur ou Transform",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "Un alias pour le Joueur et l'entité de Transformation",
  T_46_XXJ_WS_PREMIUM: "Adhésion",
  T_46_XXJ_WS_PREMIUMSTATUS: "Statut D'adhésion",
  T_46_XXJ_WS_PROXYOBSERVER: "Observateur Proxy",
  T_46_XXJ_WS_PROXYOBSERVER_D: "L'observateur de proxy",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Supprimez l'objet surveillé et annulez la synchronisation AOI au-delà de la ligne de vue",
  T_46_XXJ_WS_RENEWAL: "Renouveler",
  T_46_XXJ_WS_ROTATEVECTOR: "Faire Pivoter le Vecteur",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Faites pivoter un vecteur en fonction des quaternions",
  T_46_XXJ_WS_SKIN: "Engrenage",
  T_46_XXJ_WS_STARTVALUE_D: "Valeur de la source",
  T_46_XXJ_WS_STATUS: "Statut",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Changer l'observateur proxy de L'utilisateur",
  T_46_XXJ_WS_TARGET_D: "La cible qui est surveillée",
  T_46_XXJ_WS_USER_D: "L'utilisateur",
  T_46_XXJ_WS_VALUE: "Valeur",
  T_46_XXJ_WS_VALUE_D: "Vecteur",
  T_46_XYL_WS_CTZSAFEZONEEND: "Point de Fin de la Zone de Sécurité",
  T_46_XYL_WS_RESOURCETYPE1: "Structures Basiques",
  T_46_XYL_WS_RESOURCETYPE1_1: "Géométries",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visuel et Audio",
  T_46_XYL_WS_RESOURCETYPE2: "Articles de Scène",
  T_46_XYL_WS_RESOURCETYPE2_2: "Fournitures de Combat",
  T_46_XYL_WS_RESOURCETYPE3: "Nature",
  T_46_XYL_WS_RESOURCETYPE4: "Composant Modulaire",
  T_46_XYL_WS_TYPEOTHERPROP: "Divers",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Conteneurs et Boîtes",
  T_47_CJ_FOREGRIP_SOFT_N: "Poignée Avant Légère",
  T_47_CJ_MAGEZINE_FAST_N: "Chargeur Rapide",
  T_47_CJ_STOCK_FAST_N: "Stock D'énergie",
  T_47_GT_WS_USERMANUAL: "Manuel D'utilisateur",
  T_47_HJ_WS_VFX_FOG: "VFX de Brouillard",
  T_47_HJ_WS_VFX_LIGHTING: "VFX D'éclairage",
  T_47_HJ_WS_VFX_TRAILING: "VFX de Traîne",
  T_47_HL_CL_CREATOR_LABEL1: "Talent de la Communauté",
  T_47_HL_CL_MAP_LABEL1: "Œuvres Sélectionnées Par Les Talents De La Communauté",
  T_47_JH_WS_MODERATION_REASON12: "Liés aux jeux de hasard",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "Collaboration NARUTO SHIPPUDEN",
  T_47_SD_RES_MATERIAL: "Fichier de Matériel",
  T_47_SD_RES_MESH: "Maillage",
  T_47_SD_WS_MAPTAG_AI: "Génération de Carte d'IA",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "Un couteau spécial qui se colle au point d'impact après avoir été lancé, déclenchant une explosion enflammée après un court délai pour infliger des dégâts de brûlure.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Kunai Ardent",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "Un couteau spécial qui colle au point d'impact après avoir été lancé, déclenchant un coup de Foudre après un court délai pour paralyser la cible.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Kunai de Foudre",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "Un couteau spécial qui se colle au point d'impact après avoir été lancé, déclenchant une tempête de vent après un court délai pour ralentir la cible qui se déplace vers son centre.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Kunai du Vent",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "Un type de shuriken adapté au combat à moyenne et longue portée. Un seul lancer permet de lancer une pièce rapidement et d'infliger d'importants dégâts.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Shuriken Lourd",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "Un type de shuriken adapté au combat à courte et moyenne portée avec deux modes d'attaque. En lançant le shuriken, trois pièces sont projetées, infligeant un petit nombre de dégâts.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Shuriken Léger",
  T_47_XXJ_WS_ACTION: "Action",
  T_47_XXJ_WS_AOISETTING: "Paramètre AOI",
  T_47_XXJ_WS_BAGSKINTYPE: "Type De Skin Du Sac À Dos",
  T_47_XXJ_WS_CLEARMEMORY: "Effacer la Mémoire",
  T_47_XXJ_WS_CLNPC: "NPC Avancé",
  T_47_XXJ_WS_CLOTHTYPE: "Type de Skin de Tenue",
  T_47_XXJ_WS_COMMON_ERROR: "Erreur courante",
  T_47_XXJ_WS_CONTENT: "Contenu",
  T_47_XXJ_WS_CREATERANDOMSEED: "Créer une Graine Aléatoire",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Pourcentage Écoulé",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Activer la Fonction Brouillard",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Activer La Fonction De Rotation De Lumière",
  T_47_XXJ_WS_ERRORCODE: "Code D'erreur",
  T_47_XXJ_WS_EXPONENTIAL: "Exponentiel",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponentielle Au Carré",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Échec de la création de la chambre: pas d'ID Persona valides",
  T_47_XXJ_WS_FOG: "Brouillard",
  T_47_XXJ_WS_FOGDENSITY: "Densité du Brouillard",
  T_47_XXJ_WS_FOGENDDISTANCE: "Distance de Fin de Brouillard",
  T_47_XXJ_WS_FOGMODE: "Mode Brouillard",
  T_47_XXJ_WS_FOGMODETYPE: "Type de Mode Brouillard",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Distance de Départ du Brouillard",
  T_47_XXJ_WS_HEIGHTSCALE: "Échelle D'hauteur",
  T_47_XXJ_WS_ISVISIBLE: "Est Visible",
  T_47_XXJ_WS_JOINNEWTEAM: "Rejoindre Une Nouvelle Équipe",
  T_47_XXJ_WS_JOINTEAM: "Rejoindre L'équipe",
  T_47_XXJ_WS_LIGHTROTATE: "Rotation De Lumière",
  T_47_XXJ_WS_LINEAR: "Linéaire",
  T_47_XXJ_WS_LLMCHATHUD: "UI de Chat Persona",
  T_47_XXJ_WS_NEWTEAM: "Nouvelle Équipe",
  T_47_XXJ_WS_NEXT: "Suivant",
  T_47_XXJ_WS_NPC_TIP: "Vous pouvez modifier l'apparence des NPC et leur faire jouer des animations",
  T_47_XXJ_WS_OBSERVERS: "Observateurs",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "Sur L'envoie De Message par Joueur via l'UI de Chat Persona",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "Statut D'adhésion Modifié",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "Sur Réception d'une action par Persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "Sur Réception de Contenu par Persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "Sur Réception de Fin Par Persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "Sur Réception de Statut Par Persona",
  T_47_XXJ_WS_PARTICLESID: "ID des Particules",
  T_47_XXJ_WS_PERSONAAVATAR: "Avatar Persona",
  T_47_XXJ_WS_PERSONAID: "ID Persona",
  T_47_XXJ_WS_PERSONANICKNAME: "Surnom de Persona",
  T_47_XXJ_WS_PLAYERORNPC: "Joueur ou NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Adhésion Fermée",
  T_47_XXJ_WS_RANDOM: "Aléatoire",
  T_47_XXJ_WS_SEED: "Graine",
  T_47_XXJ_WS_SENDER: "Expéditeur",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Définir L'observateur Persona",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Définir la possibilité pour le joueur de quitter le jeu à mi-parcours",
  T_47_XXJ_WS_SHOULDREPLY: "Doit Répondre",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Afficher La Réponse Du Système",
  T_47_XXJ_WS_SPOTANGLE: "Angle du Spot",
  T_47_XXJ_WS_SPOTLIGHT: "Projecteur",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Envoyer Un Message De Système À Persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Diffuser Les Messages Du Système À Persona",
  T_47_XXJ_WS_TARGETTEAM: "Équipe Cible",
  T_47_XXJ_WS_THISENTITY: "Cette Entité",
  T_47_XXJ_WS_USERAVATAR: "Avatar D'utilisateur",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Envoyer Un Message Utilisateur À Persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Diffuser Les Messages D'utilisateur À Persona",
  T_47_XXJ_WS_USERNICKNAME: "Surnom de L'utilisateur",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Type De Skin Du Véhicule",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Type De Skin D'arme",
  T_47_XYL_NB_UGC_EFFECT001: "VFX du Rasengan",
  T_47_XYL_NB_UGC_EFFECT002: "VFX du Chidori",
  T_47_XYL_NB_UGC_EFFECT003: "VFX du Choc Des Cerisiers En Fleurs",
  T_47_XYL_NB_UGC_EFFECT004: "VFX du Jutsu de Boule De Feu",
  T_47_XYL_NB_UGC_EFFECT005: "VFX de Jutsu Du Dragon Aqueux",
  T_47_XYL_NB_UGC_EFFECT006: "VFX de la Grande Brèche",
  T_47_XYL_NB_UGC_EFFECT007: "VFX de la Bombe Des Démons à Queues",
  T_47_XYL_NB_UGC_EFFECT008: "VFX de la Marque de Malédiction de Réanimation",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Boutique D'actifs",
  T_47_XYL_UGC_DONKEYCART: "Charrette À Âne",
  T_47_XYL_UGC_SPOTLIGHT: "Projecteur",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Angle du Projecteur",
  T_48_H_EMOTE_WATERFEST25_N: "Pas Rapides",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Moto - Écume de Mer",
  T_48_HJ_AC_STATENOTEXIST: "L'état {0} n'existe pas dans le contrôleur d'animation",
  T_48_HL_CODESCRIPT: "Script de Code",
  T_48_HL_GLOBAL_VAR: "Nom de la Variable Globale",
  T_48_HL_GRAPH: "Bloc",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Tableau de Classement",
  T_48_HL_LOCAL_VAR: "Nom de la Variable Locale",
  T_48_HL_LOCALIZATION: "Nom de la Localisation",
  T_48_HL_OPEN_ATTRIBUTES: "Nom de l'Attribut Ouvert",
  T_48_HX_A_WATERFEST25: "Écume de Mer (Masque)",
  T_48_HX_B_WATERFEST25: "Écume de Mer (Bas)",
  T_48_HX_F_B_BLACKDRESS: "Antimatière (Bas)",
  T_48_HX_F_H_BLACKDRESS: "Antimatière (Tête)",
  T_48_HX_F_HA_BLACKDRESS: "Antimatière (Peinture de Visage)",
  T_48_HX_F_S_BLACKDRESS: "Antimatière (Chaussures)",
  T_48_HX_F_T_BLACKDRESS: "Antimatière (Haut)",
  T_48_HX_H_WATERFEST25: "Écume de Mer (Tête)",
  T_48_HX_HA_WATERFEST25: "Écume de Mer (Peinture de Visage)",
  T_48_HX_M_A_BLACKDRESS: "Matière Noire (Masque)",
  T_48_HX_M_B_BLACKDRESS: "Matière Noire (Bas)",
  T_48_HX_M_H_BLACKDRESS: "Matière Noire (Tête)",
  T_48_HX_M_HA_BLACKDRESS: "Matière Noire (Peinture de Visage)",
  T_48_HX_M_S_BLACKDRESS: "Matière Noire (Chaussures)",
  T_48_HX_M_T_BLACKDRESS: "Matière Noire (Haut)",
  T_48_HX_S_WATERFEST25: "Écume de Mer (Chaussures)",
  T_48_HX_T_WATERFEST25: "Écume de Mer (Haut)",
  T_48_JH_WS_STRINGDESC: `Saisissez un paragraphe de texte ou d'autres chaînes de caractères. Certains widgets peuvent afficher du texte enrichi. Ajoutez de la couleur au texte avec du texte enrichi en utilisant le format suivant: [#XXXXXX] texte texte [-]. "#XXXXXX" est la couleur que vous souhaitez afficher. Veuillez noter que la couleur du texte du widget correspondant doit être en blanc.`,
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Trouver l'Entité par ID",
  T_48_META_API_10001_P0: "ID de l'Entité",
  T_48_META_API_1098: "Lecture par lots de la valeur de la feuille de la base de données",
  T_48_META_API_1098_D: "Lecture par lots de plusieurs entrées de données à partir d'une feuille de base de données spécifiée, où les entrées de la liste d'ID unique du joueur correspondent une à une à celles de la liste des clés.",
  T_48_META_API_1098_P1: "Les ID du Compte",
  T_48_META_API_1098_P1_D: "La liste des ID uniques des lecteurs, qui lit les données correspondant aux clés au même index dans la liste des clés.",
  T_48_META_API_1098_P2: "Clés",
  T_48_META_API_1098_P2_D: "La liste des clés, qui lit les données correspondant aux ID uniques des joueurs au même index dans la liste des ID.",
  T_48_META_API_1098_P5: "Codes de Statut",
  T_48_META_API_1098_P5_D: "La liste des codes de statut",
  T_48_META_API_1105: "Notifier le Début du Graphe",
  T_48_META_API_1105_D: "Commencez la lecture du graphe spécifié pour le joueur déclencheur",
  T_48_META_API_1105_P1_D: "L'ID du Graphe",
  T_48_META_API_1108: "Obtenez la langue locale",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Définir Le Poids D'une Partie Du Corps",
  T_48_META_API_3300_D: "Définissez le poids de la partie du corps cible lorsque vous la mélangez avec d'autres animations de moindre priorité",
  T_48_META_API_3300_P0_D: "Le composant du contrôleur d'animation ajoutable auquel appartient la partie du corps",
  T_48_META_API_3300_P1: "Nom De La Partie Du Corps",
  T_48_META_API_3300_P1_D: "Le nom de la partie du corps",
  T_48_META_API_3300_P2: "Poids",
  T_48_META_API_3300_P2_D: "Poids ayant un intervalle de [0, 1], représentant le degré de fusion avec les animations de moindre priorité.",
  T_48_META_API_3315: "Jouez le clip d'animation du personnage",
  T_48_META_API_3315_D: "Jouez un clip d'animation de personnage avec la possibilité de remplacer l'animation par défaut du jeu",
  T_48_META_API_3315_P3: "Remplacer le Contrôle du Gameplay",
  T_48_META_API_3315_P3_D: "Si l'on veut remplacer l'animation par défaut du jeu",
  T_48_META_API_3316: "Arrêter l'animation",
  T_48_META_API_3316_D: "Arrêter la lecture de l'animation pour la cible au statut spécifié",
  T_48_META_API_90_P1: "Peut Quitter à Mi-Chemin",
  T_48_META_API_93: "Créer Un Mouvement Le Long D'une Trajectoire",
  T_48_META_API_93_D: "Créez un mouvement interpolé le long d'une trajectoire pour que l'objet se déplace le long de la trajectoire spécifiée",
  T_48_META_API_93_P1: "Chemin",
  T_48_META_API_93_P1_D: "Le chemin du mouvement",
  T_48_META_API_93_P3_D: "La magnitude de la vitesse",
  T_48_META_API_93_P4: "Face Tangente",
  T_48_META_API_93_P4_D: "Si l'objet est orienté dans le sens du mouvement. Cette propriété reste inchangée même si l'orientation de l'objet est modifiée de force par d'autres moyens.",
  T_48_META_API_96: "Instancier la Prefab",
  T_48_META_API_96_D: "Créer une instance de préfabriqué avec l'option de la traiter de manière asynchrone",
  T_48_META_API_96_P2: "Chargement Async",
  T_48_META_API_96_P2_D: "Si le chargement est asynchrone",
  T_48_META_EVT_3140: "Lors Du Changement D'équipe",
  T_48_META_EVT_3140_D: "Se déclenche lorsque l'équipe de l'entité actuelle change.",
  T_48_META_EVT_3140_P0: "Ancienne Équipe",
  T_48_META_EVT_3140_P0_D: "L'équipe à laquelle on appartenait avant le changement",
  T_48_META_EVT_3140_P1: "Équipe Actuelle",
  T_48_META_EVT_3140_P1_D: "L'équipe à laquelle on appartient après le changement",
  T_48_META_EVT_3141: "Au Début du Graphe",
  T_48_META_EVT_3141_D: "Déclenche lorsque le graphe commence à jouer",
  T_48_META_EVT_3141_P1: "L'ID du Graphe",
  T_48_META_EVT_3141_P1_D: "L'ID du Graphe",
  T_48_META_EVT_3142: "À la Fin du Graphe",
  T_48_META_EVT_3142_D: "Se déclenche lorsque le graphe finit",
  T_48_META_EVT_3142_P0_D: "Le joueur déclencheur",
  T_48_META_EVT_3142_P1_D: "L'ID du Graphe",
  T_48_META_EVT_3143: "Option de Déclenchement du Graphe",
  T_48_META_EVT_3143_D: "Se déclenche lorsqu'une option est sélectionnée dans le graphe",
  T_48_META_EVT_3143_P1_D: "L'ID du Graphe",
  T_48_META_EVT_3143_P2: "ID d'Option",
  T_48_META_EVT_3143_P2_D: "L'ID de l'option sélectionnée",
  T_48_META_TYP_409_I10: "Échec du Changement D'équipe_Équipe Invalide",
  T_48_META_TYP_409_I11: "Changement d'équipe Échoué_Éliminé",
  T_48_META_TYP_409_I12: "Échec du Changement D'équipe_En Véhicule",
  T_48_META_TYP_409_I7: "Échec du Changement D'équipe_Non Supporté",
  T_48_META_TYP_409_I8: "Échec du Changement D'équipe_Déjà en équipe",
  T_48_META_TYP_409_I9: "Changement d'équipe Echoué_Cible Invalide",
  T_48_META_TYP_41_I19: "Désactiver le Collisionneur",
  T_48_META_TYP_417: "Particules",
  T_48_META_TYP_428: "Transformation du Joueur ou Tenue de L'NPC",
  T_48_META_TYP_431: "Mouvement le Long du Chemin",
  T_48_META_TYP_431_I1: "Chemin",
  T_48_META_TYP_432: "Type de Chemin à Courbe Personnalisée",
  T_48_META_TYP_432_I0: "Rouler",
  T_48_META_TYP_432_I1: "Tangente",
  T_48_META_TYP_433: "Type de Chemin à Courbe Personnalisée",
  T_48_META_TYP_433_I0: "Linéaire",
  T_48_META_TYP_433_I1: "Fluide",
  T_48_META_TYP_433_I2: "Personnalisé",
  T_48_META_TYP_434: "Chemin à Courbe Personnalisée",
  T_48_META_TYP_434_I2: "Boucle Fermée",
  T_48_META_TYP_434_I3: "Points de Passage",
  T_48_META_TYP_437_I5: "Noms des Types de Score",
  T_48_META_TYP_437_I6: "Contenu du Score à Gauche",
  T_48_META_TYP_437_I7: "Contenu du Score à Droite",
  T_48_META_TYP_438_I1: "Joueurs",
  T_48_META_TYP_438_I2: "Classements",
  T_48_META_TYP_438_I3: "Scores Totaux",
  T_48_META_TYP_438_I4: "Noms des Types de Score",
  T_48_META_TYP_438_I5: "Couleurs",
  T_48_META_TYP_438_I6: "Scores",
  T_48_META_TYP_439: "Groupe",
  T_48_META_TYP_442_I1: "Score à Gauche",
  T_48_META_TYP_442_I10: "Icône Éliminée à Droite",
  T_48_META_TYP_442_I2: "Score à Droite",
  T_48_META_TYP_442_I3: "Nombre de Vivants à Gauche",
  T_48_META_TYP_442_I4: "Nombre de Vivants à Droite",
  T_48_META_TYP_442_I5: "Nombre Éliminée à Gauche",
  T_48_META_TYP_442_I6: "Nombre Éliminée à Droite",
  T_48_META_TYP_442_I7: "Icône Vivant à Gauche",
  T_48_META_TYP_442_I8: "Icône Vivant à Droite",
  T_48_META_TYP_442_I9: "Icône Éliminée à Gauche",
  T_48_META_TYP_444: "Type de Langue",
  T_48_META_TYP_444_I0: "Anglais",
  T_48_META_TYP_444_I1: "Chinois Simplifié",
  T_48_META_TYP_444_I10: "Français",
  T_48_META_TYP_444_I11: "Allemand",
  T_48_META_TYP_444_I12: "Turc",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Japonais",
  T_48_META_TYP_444_I15: "Roumain",
  T_48_META_TYP_444_I16: "Arabe",
  T_48_META_TYP_444_I17: "Birman",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengali",
  T_48_META_TYP_444_I2: "Chinois Traditionnel",
  T_48_META_TYP_444_I3: "Thaï",
  T_48_META_TYP_444_I4: "Vietnamien",
  T_48_META_TYP_444_I5: "Indonésien",
  T_48_META_TYP_444_I6: "Portugais",
  T_48_META_TYP_444_I7: "Espagnol",
  T_48_META_TYP_444_I8: "Russe",
  T_48_META_TYP_444_I9: "Coréen",
  T_48_SD_ERROR_DIVISOR: "Le diviseur ne peut pas être 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "La clé spécifiée n'existe pas dans la carte: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "Index de liste hors de portée: {0}",
  T_48_SD_SK_WARNING: "N'a pas trouvé {1} dans {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: "Étant donné que l'attribut 'IsServerDriven' du contrôleur de personnage Craftland {0} est désactivé, l'API serveur associée n'a pas d'effet.",
  T_48_XXJ_WS_PARENTERROR: "Échec de définition du parent",
  T_48_XXJ_WS_PERFORMANCE: "Performance",
  T_48_XXJ_WS_TANGENT: "Tangente",
  T_48_XXJ_WS_WAYPOINT: "Point de Passage",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "Liste d'objets",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Utiliser une Mini-carte Personnalisée",
  T_48_XYL_UGC_HIDEMINIMAP: "Masquer l'HUD de la Mini-carte",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Surface Personnalisée de Base",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Découpe du Cylindre",
  T_48_XYL_WS_BASICHEMISPHERE: "Hémisphère de Base",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Quart de Tore",
  T_48_XYL_WS_BASICQUARTERTORUS: "Quart de Tore Carré",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Tore",
  T_48_XYL_WS_BASICTRIANGLE: "Surface Du Triangle",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Joueurs de match = Nombre d'équipes × Nombre de joueurs par équipe. Plus il y a de joueurs, plus le temps de matchmaking est long.",
  T_48_XYL_WS_MAPPLAYERSWARNING: "Un nombre élevé de joueurs peut entraîner un allongement du temps de matchmaking.",
  T_49_HL_CL_CREATOR_LABEL2: "Talent de la Communauté Craftland",
  T_49_HL_CL_MAPS_LABEL2: "Gagnant de la Carte",
  T_49_HL_CL_MAPS_LABEL3: "Gagnant du Gameplay",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Trajectoire",
  T_49_JH_WS_SKILLKASSIE: "Électro Thérapie (Kassie)",
  T_49_JH_WS_SKILLKODA: "Vision d'Aurore (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Dash Vaillant (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Générer avec l'IA",
  T_49_META_API_10065: "Changer La Caméra Personnalisée",
  T_49_META_API_10067: "Obtenir La Caméra Personnalisée Actuelle",
  T_49_META_API_10069: "Créer Une Caméra Personnalisée",
  T_49_META_API_10070: "Définir Un Masque De Sélection De Caméra Personnalisé",
  T_49_META_API_10070_D: "Définir le masque de sélection de la caméra cible pour contrôler la visibilité sur toutes les couches",
  T_49_META_API_10071: "Obtenir Un Masque De Sélection De Caméra Personnalisé",
  T_49_META_API_10071_D: "Obtenez le masque de sélection de la caméra cible",
  T_49_META_API_10072: "Définir Une Couche De Masque De Sélection De Caméra Personnalisée",
  T_49_META_API_10072_D: "Définir la visibilité de la caméra cible pour une couche spécifique",
  T_49_META_API_10073: "Effectuer une capture d'écran",
  T_49_META_API_10073_D: "Effectuer une capture d'écran (pour le test interne)",
  T_49_META_API_106: "Obtenir L'horodatage du Serveur (ms)",
  T_49_META_API_106_D: "Obtenir l'horodatage du serveur avec une précision en millisecondes",
  T_49_META_API_107: "Horodatage à la Chaîne Localisée (ms)",
  T_49_META_API_107_D: "Convertir les horodatages (en ms) en chaînes de caractères basés sur certains formats",
  T_49_META_API_107_P0: "Horodatage (ms)",
  T_49_META_API_107_P0_D: "Un horodatage en millisecondes",
  T_49_META_API_108: "Vecteur3 de Lerp",
  T_49_META_API_108_D: "Effectuer une interpolation linéaire du vecteur 3D A vers le vecteur B",
  T_49_META_API_1089_P2: "ID de la Requête",
  T_49_META_API_109: "Mettez à jour le Contexte du Personnage",
  T_49_META_API_109_D: "Mettez à jour le contexte du modèle d'un personnage spécifié dans la chambre en cours et écrasez le contexte original après l'exécution. Le contexte influencera l'interprétation par le personnage de l'arrière-plan, de l'historique ou de certains paramètres pour le dialogue en cours.",
  T_49_META_API_109_P1: "Contexte",
  T_49_META_API_109_P1_D: "Détails du contexte",
  T_49_META_API_110: "Commentaire sur la Réponse Persona",
  T_49_META_API_110_D: "Soumettez vos commentaires sur le contenu des réponses d'un persona, qui seront utilisés pour optimiser notre modèle.",
  T_49_META_API_110_P1: "Est apprécié",
  T_49_META_API_110_P1_D: "Que la réponse soit appréciée ou non. Vrai = like",
  T_49_META_API_1109: "Définir la Position du Joueur Local",
  T_49_META_API_1109_D: "Lorsque le joueur utilise des personnages de jeu classiques, cette API permet de définir la position du joueur.",
  T_49_META_API_1109_P0_D: "La Position Cible",
  T_49_META_API_111: "Vecteur3 de Slerp",
  T_49_META_API_111_D: "Effectuez une interpolation sphérique du vecteur 3D A vers le vecteur B pour une rotation fluide",
  T_49_META_API_1110: "Définir l'avancement du joueur local",
  T_49_META_API_1110_D: "Lorsque le joueur utilise des personnages de jeu classiques, cette API permet de définir la direction que le joueur affronte.",
  T_49_META_API_1110_P0_D: "Le vecteur d'avancement",
  T_49_META_API_112: "Faire Revenir la Mémoire Persona",
  T_49_META_API_112_D: "Faire revenir la mémoire d'un persona avant l'ID de réponse spécifique. Toute la mémoire des dialogues antérieurs à cette réponse, à l'exception de la réponse elle-même, sera effacée.",
  T_49_META_API_113: "Lecture de l'audio d'un seul coup",
  T_49_META_API_113_D: "Lecture d'effets de son d'un seul coup avec volume réglable",
  T_49_META_API_113_P0_D: "L'ID de la ressource d'effet de son à jouer",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "Le volume de lecture de l'effet de son, avec une portée de 0 à 1.",
  T_49_META_API_97: "Créer un Contrôleur de Vue de la Partie Squelette",
  T_49_META_API_97_D: "Après avoir créé une entité de contrôleur de vue de partie de squelette, vous pouvez utiliser cette entité pour contrôler la partie de squelette spécifiée et faire en sorte qu'elle soit toujours orientée vers une cible spécifique.",
  T_49_META_API_97_P0_D: "L'entité du contrôleur de vue de la partie squelette. Si l'entité est détruite, la fonctionnalité de vue cessera.",
  T_49_META_API_97_P1_D: "La partie du squelette qui est contrôlée",
  T_49_META_API_97_P2_D: "La cible visée",
  T_49_META_API_98: "Projection",
  T_49_META_API_98_D: "Calculez la projection du vecteur A sur le vecteur B",
  T_49_META_API_99: "Obtenir L'horodatage Local (ms)",
  T_49_META_API_99_D: "Obtenir l'horodatage local avec une précision en millisecondes",
  T_49_META_EVT_16_P1_D: "À partir de 0, chaque requête sortante consommera un ID numérique séquentiel, tel que la création de chambre et le nettoyage de la mémoire.",
  T_49_META_EVT_16_P2: "ID de Réponse",
  T_49_META_EVT_16_P2_D: "Chaque réponse complète aura un ID unique",
  T_49_META_TYP_122_I19: "Matériel Personnalisé",
  T_49_META_TYP_122_I19_D: "Permet de remplacer la boîte-ciel par un matériel personnalisé",
  T_49_META_TYP_14_I78_D: "Obtenir ou définir l'entité caméra qui rend actuellement la scène sur le client du joueur. Remarque: l'entité camera représente essentiellement les données de configuration pour le contrôle de la caméra côté client.",
  T_49_META_TYP_335_I9: "Temps écoulé (ms)",
  T_49_META_TYP_335_I9_D: "La durée de lecture de l'effet de son en millisecondes. Cette propriété n'est accessible que du côté client.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Echec",
  T_49_META_TYP_409_I14_D: "LLM_Echec",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Persona_Invalide",
  T_49_META_TYP_409_I16_D: "LLM_PersonaOuchambre_Invalide",
  T_49_META_TYP_409_I17: "LLM_Limite_Jeton",
  T_49_META_TYP_409_I17_D: "LLM_Limite_Jeton",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "Demande_Fréquente_LLM",
  T_49_META_TYP_409_I19: "LLM_Demande_Fréquente",
  T_49_META_TYP_409_I19_D: "Demande_Fréquente_LLM",
  T_49_META_TYP_441: "ID de Performance",
  T_49_META_TYP_445: "ID du Contrôleur Jouable",
  T_49_META_TYP_446: "Attachable de Manette Jouable",
  T_49_META_TYP_446_I0: "Contrôleur Jouable",
  T_49_META_TYP_447: "Contrôleur de Partie de Squelette",
  T_49_META_TYP_448: "Contrôleur De Vue De La Partie Squelette",
  T_49_META_TYP_448_I0: "Cible Contrôlée",
  T_49_META_TYP_448_I1: "Cible De Vue",
  T_49_META_TYP_449: "Caméra Personnalisée",
  T_49_META_TYP_449_I2: "Taille Orthographique",
  T_49_META_TYP_449_I2_D: "Contrôler la taille de la zone visible par la caméra",
  T_49_META_TYP_450: "Horodatage Chaîne Localisée (ms)",
  T_49_META_TYPE_449_D: "Une caméra personnalisée est entièrement contrôlée par le développeur et détermine ce que le joueur voit pendant le jeu",
  T_49_META_TYPE_450_D: "Formater un horodatage au niveau de la milliseconde dans un format texte lisible",
  T_49_SD_SEARCH_ICONDESC: "Association Intelligente",
  T_49_SD_SEARCHKEY_ACTION: "Action",
  T_49_SD_SEARCHKEY_ANICLIPID: "ID du clip d'animation",
  T_49_SD_SEARCHKEY_AS: "En tant que",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "ID de la Pièce Jointe",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Type d'effet de son",
  T_49_SD_SEARCHKEY_BAGSKINID: "ID de Skin du Sac à Dos",
  T_49_SD_SEARCHKEY_BEZIER: "Courbe de Bézier",
  T_49_SD_SEARCHKEY_BOOL: "Booléen",
  T_49_SD_SEARCHKEY_BREAK: "Pause",
  T_49_SD_SEARCHKEY_BTREEID: "ID de L'Arbre du Comportement",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "Sur bouton cliqué",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "Sur bouton double-cliqué",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "Sur Bouton appuyé",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "Sur relâchement du bouton",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Type de tenue",
  T_49_SD_SEARCHKEY_COLOR: "Couleur",
  T_49_SD_SEARCHKEY_COMMENT: "Note de Commentaire",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Énumération du composant",
  T_49_SD_SEARCHKEY_CONCANT: "Connecter",
  T_49_SD_SEARCHKEY_CONTINUE: "Continuer",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "HUD Personnalisé",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Widget hud personnalisé",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "création dynamique d'un type d'objet de niveau",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Type d'effets visuels",
  T_49_SD_SEARCHKEY_ENTITY: "Sélectionner l'objet de scène",
  T_49_SD_SEARCHKEY_FLOAT: "Flottant",
  T_49_SD_SEARCHKEY_FOR: "Pour l'index",
  T_49_SD_SEARCHKEY_FOREACH: "Pour chaque",
  T_49_SD_SEARCHKEY_FUNCTION: "Fonction",
  T_49_SD_SEARCHKEY_GETCSV: "Obtenir le CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Obtenez un actif enregistré par clé",
  T_49_SD_SEARCHKEY_GETVALUE: "Obtenir la valeur de la propriété",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Obtenir une variable globale",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Définir une Variable Globale",
  T_49_SD_SEARCHKEY_IF: "Si",
  T_49_SD_SEARCHKEY_IFELSE: "Si autre",
  T_49_SD_SEARCHKEY_IMGENUM: "Type de Créature",
  T_49_SD_SEARCHKEY_INT: "Entier",
  T_49_SD_SEARCHKEY_INTERNALHUD: "Type d'HUD",
  T_49_SD_SEARCHKEY_ITEMENUM: "Type D'article",
  T_49_SD_SEARCHKEY_LISTAPPEND: "Ajouter une liste",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "Portée d'ajout de liste",
  T_49_SD_SEARCHKEY_LISTCLEAR: "Effacer la liste",
  T_49_SD_SEARCHKEY_LISTCLONE: "Clone de liste",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "Liste contient",
  T_49_SD_SEARCHKEY_LISTCREATE: "Créer une liste",
  T_49_SD_SEARCHKEY_LISTDELETE: "Supprimer la Liste",
  T_49_SD_SEARCHKEY_LISTGET: "Obtenir la liste",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "Lister l'indice de",
  T_49_SD_SEARCHKEY_LISTINSERT: "Insertion de liste",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "Lister le dernier indice de",
  T_49_SD_SEARCHKEY_LISTLENGTH: "Longueur de liste",
  T_49_SD_SEARCHKEY_LISTREVERSE: "Inversion de liste",
  T_49_SD_SEARCHKEY_LISTSET: "définir une liste",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "Mélange de la liste",
  T_49_SD_SEARCHKEY_LOCALKEY: "Clé Localisée",
  T_49_SD_SEARCHKEY_LOCALVAR: "Variable locale",
  T_49_SD_SEARCHKEY_LOGICAL: "Et ou",
  T_49_SD_SEARCHKEY_LOGINFO: "Impression d'info du journal",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "obtenir toutes les clés du dict obtenir toutes les clés de la carte",
  T_49_SD_SEARCHKEY_MAPCLEAR: "vider le dict vider la carte",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict contient la clé carte contient la clé",
  T_49_SD_SEARCHKEY_MAPCREATE: "créer dict créer carte",
  T_49_SD_SEARCHKEY_MAPGET: "obtenir la valeur du dict par clé obtenir la valeur de la carte par clé",
  T_49_SD_SEARCHKEY_MAPLENGTH: "longueur du dict longueur de la carte",
  T_49_SD_SEARCHKEY_MAPREMOVE: "supprimer le dict supprimer la carte",
  T_49_SD_SEARCHKEY_MAPSET: "définir la valeur du dict définir la valeur de la carte",
  T_49_SD_SEARCHKEY_MATH: "additionner soustraire multiplier diviser",
  T_49_SD_SEARCHKEY_NEWLIST: "Nouvelle liste",
  T_49_SD_SEARCHKEY_NULL: "Nul",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Nombre vers chaîne de caractères",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Propriétés des Particules",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "ID des Données du Joueur",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Type de compétence du personnage",
  T_49_SD_SEARCHKEY_PREEFFECT: "Type d'autocollant spécial",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "ID Brut",
  T_49_SD_SEARCHKEY_READSTATIS: "Lire les données accumulées",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "Uuid de la Ressource",
  T_49_SD_SEARCHKEY_RETURN: "Retour",
  T_49_SD_SEARCHKEY_SCENEENUM: "Fichier de scène",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Définir la valeur de la propriété",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Type d'ID d'article spécial",
  T_49_SD_SEARCHKEY_TEXT: "Texte",
  T_49_SD_SEARCHKEY_TEXTUREID: "Type de texture",
  T_49_SD_SEARCHKEY_THISENTITY: "Cette Entité",
  T_49_SD_SEARCHKEY_TIMELINE: "Chronologie",
  T_49_SD_SEARCHKEY_TYPEENUM: "Tout type",
  T_49_SD_SEARCHKEY_V2VCREATE: "Créer Vecteur2",
  T_49_SD_SEARCHKEY_V2VGET: "Obtenir les composants Vecteur2",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vecteur2 opération ajouter soustraire multiplier Produit scalaire angle de distance",
  T_49_SD_SEARCHKEY_V2VSET: "Définir les composants du Vecteur2",
  T_49_SD_SEARCHKEY_V3VCREATE: "Créer Vecteur3",
  T_49_SD_SEARCHKEY_V3VGET: "Obtenir les composants Vector3",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vecteur3 opération ajouter soustraire multiplier produit scalaire produit vectoriel angle de distance",
  T_49_SD_SEARCHKEY_V3VSET: "Définir les composants du Vecteur3",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "ID du skin du véhicule",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "ID du Skin D'arme",
  T_49_SD_SEARCHKEY_WHILE: "Pendant",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Écrire le décalage de la base de données accumulée",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Écrire le décalage de la base de données accumulée par le code de la carte",
  T_49_XXJ_WS_DURATIONS: "Durée (s)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Modifier la Performance",
  T_49_XXJ_WS_PERFORMANCE: "Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Supprimer la Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "La performance supprimée ne peut pas être restaurée, continuer?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Modification {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "Ce nom a déjà été utilisé, veuillez le modifier et réessayer.",
  T_49_XXJ_WS_PERFORMANCENAME: "Nom de la Performance",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Ajouter un Cadre de Clé",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Ajouter une Sous-Piste",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Ajouter La Piste",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Supprimer la Piste",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Piste d'Acteur",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Piste D'événement",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Le Cadre de Clé existe déjà",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "La piste d'acteur correspondante existe déjà",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Contenu",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Des noms de pistes en double ont été détectés. Veuillez les modifier et réessayer.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Veuillez lancer l'enregistrement ou choisir d'abord un cadre clé",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Enregistrement...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Supprimer le Cadre de la Clé",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Vue de Scène",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Sélectionnez un objet pour créer une piste ou appuyez directement sur le bouton d'ajout de piste",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Appuyez sur le bouton d'ajout de piste pour créer une nouvelle piste",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Sous-Piste",
  T_49_XXJ_WS_TIMELINE_TRACK: "Piste",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Vue de Piste",
  T_49_XYL_WS_DAILYPROPS: "Basique",
  T_49_XYL_WS_STOREGAMPLAY: "Gameplay",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Académie de Trouble",
  T_50_H_MACHETE_VA_N: "Parang - Académie de Trouble",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Champs du Tableau de Cassement",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Débordement",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Envelopper",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Réduire la police",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Créer le Tuple",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Obtenir le Tuple",
  T_50_HJ_SEARCHKEY_TUPLESET: "Définir le Tuple",
  T_50_HJ_TEXTOBGJ_H: "Hauteur",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Options de débordement",
  T_50_HJ_TEXTOBGJ_W: "Largeur",
  T_50_HZY_REVIEW_TEXTOBJ: "Contenu de l'objet texte",
  T_50_JH_WS_HIDEMAPERROR: "Impossible de masquer la mini-carte sans image de couverture personnalisée",
  T_50_JH_WS_HIDEMAPTIP: "Lorsque la minicarte est masquée, elle n’est plus utilisée comme image de couverture",
  T_50_JH_WS_HIDEMINIMAP: "Masquer la Mini-carte",
  T_50_META_API_10073_P0: "Nom de Fichier",
  T_50_META_API_10073_P0_D: "Le nom de fichier",
  T_50_META_API_10073_P1_D: "Le résultat de l'exécution. Consultez l'énumération des Codes d'État.",
  T_50_META_API_1102: "Lire la Valeur de Colonne de la Feuille de Base de Données",
  T_50_META_API_1102_D: "Récupérer la valeur d'une colonne spécifique pour une clé donnée depuis une table de base de données standard",
  T_50_META_API_1102_P3: "Indice de colonne",
  T_50_META_API_1102_P3_D: "L'index de colonne de la table de base de données (0 = première colonne)",
  T_50_META_API_1106: "Créer une Performance",
  T_50_META_API_1106_D: "Créez une entité de performance",
  T_50_META_API_1106_P0_D: "L'atout performance",
  T_50_META_API_1111: "Lire les Valeurs d’Association du Tableau de Classement dans la Base de Données",
  T_50_META_API_1111_D: "Lire la combinaison des valeurs d'un tableau de classement et de son tableau associé dans la base de données",
  T_50_META_API_1111_P5: "Code d'État d'Association",
  T_50_META_API_1111_P5_D: "Code d'Erreur d'Association",
  T_50_META_API_1112: "Lire les Valeurs d’Association du Tableau de Classement dans la Base de Données par Plage",
  T_50_META_API_1112_D: "Lisez les valeurs du tableau de classement dans une plage de classement spécifiée, lisez les valeurs correspondantes par les clés récupérées dans le tableau associé et les combiner.",
  T_50_META_API_1112_P6: "Code d'État d'Association",
  T_50_META_API_1112_P6_D: "Code d'Erreur d'Association",
  T_50_META_API_1113: "Écrire la Valeur de l'Association du Tableau de Classement de la Base de Données",
  T_50_META_API_1113_D: "Écrire la valeur pour une clé donnée dans le Tableau de Classement et sa table associée dans la base de données",
  T_50_META_API_1113_P5: "Code d'État d'Association",
  T_50_META_API_1113_P5_D: "Code d'Erreur d'Association",
  T_50_META_API_114_D: "Créez une UI personnalisée",
  T_50_META_API_114_P0_D: "Le code est utilisé comme nom de paramètre pour la création d'une entité UI, et la valeur de la variable locale correspondante représente l'entité UI créée.",
  T_50_META_API_114_P1_D: "L'entité du joueur à laquelle elle appartient, visible uniquement par le joueur.",
  T_50_META_API_114_P2: "ID de Ressource UI",
  T_50_META_API_114_P2_D: "L'ID d'actif UI personnalisé",
  T_50_META_API_115_D: "Créer l'UI personnalisée spécifiée",
  T_50_META_API_116: "Définir la Surbrillance de l’Objet du Niveau",
  T_50_META_API_116_D: "Définit l'état de la mise en évidence de l'objet. Il peut être affecté par d'autres logiques du jeu.",
  T_50_META_API_116_P0_D: "Objet Cible",
  T_50_META_API_116_P1_D: "Mettre en évidence l'état",
  T_50_META_API_117: "Commun bit à bit",
  T_50_META_API_117_D: "Bits et/ou/xor/shift à gauche/shift à droite",
  T_50_META_API_117_P0_D: "Valeur à gauche",
  T_50_META_API_117_P1_D: "Valeur correcte",
  T_50_META_API_117_P2_D: "Type d'opération",
  T_50_META_API_118: "NON bit à bit",
  T_50_META_API_118_D: "NOT par bit, également connu sous le nom de complément par bit.",
  T_50_META_API_118_P0_D: "Valeur",
  T_50_META_API_119: "Liste de Bits vers Int",
  T_50_META_API_119_D: "Effectuer l'opération OU par bit sur tous les éléments de la liste et transformer la sortie en une valeur entière.",
  T_50_META_API_119_P0: "Tableau de Bits",
  T_50_META_API_119_P0_D: "Tableau de bits",
  T_50_META_API_120: "Int vers Liste de Bits",
  T_50_META_API_120_D: "Convertir les valeurs décimales représentées par les bits en position 1 d'un entier sous sa forme binaire en une liste",
  T_50_META_API_120_P0_D: "Entier",
  T_50_META_API_121: "Angle Quaternion",
  T_50_META_API_121_D: "Calculez l'angle entre deux quaternions",
  T_50_META_API_121_P0_D: "Quaternion 1",
  T_50_META_API_121_P1_D: "Quaternion 2",
  T_50_META_API_122: "Point Quaternion",
  T_50_META_API_122_D: "Calculer le produit en points de deux quaternions",
  T_50_META_API_123: "Inverse de Quaternion",
  T_50_META_API_123_D: "Calculez l'inverse d'un quaternion",
  T_50_META_API_123_P0_D: "Quaternion",
  T_50_META_API_124: "Quaternion De À Rotation",
  T_50_META_API_124_D: 'Calculer le quaternion de rotation de "de" à "à"',
  T_50_META_API_124_P0_D: "Le point de départ",
  T_50_META_API_124_P1_D: "Le point d'arrivée",
  T_50_META_API_125: "Quaternion Rotation Vers",
  T_50_META_API_125_D: `Calculez le quaternion de rotation de "de" à "à". Max Degrés Delta est l'angle de rotation maximum.`,
  T_50_META_API_125_P0: "De",
  T_50_META_API_125_P0_D: "Quaternion initial",
  T_50_META_API_125_P1: "Vers",
  T_50_META_API_125_P1_D: "Le quaternion cible",
  T_50_META_API_125_P2: "Delta de degrés Max.",
  T_50_META_API_125_P2_D: "L'angle de rotation max.",
  T_50_META_API_126: "Obtenez l'Orientation du Gyroscope",
  T_50_META_API_126_D: "Orientation de l'appareil dans l'espace 3D, représentant les angles de rotation autour des trois axes.",
  T_50_META_API_127: "Obtenir la Gravité du Gyroscope",
  T_50_META_API_127_D: "La composante de gravité détectée par le capteur de votre appareil",
  T_50_META_API_128: "Obtenir le Taux de Rotation du Gyroscope",
  T_50_META_API_128_D: "Il s'agit de la vitesse de rotation d'un appareil. Il s'agit d'un terme lié aux capteurs gyroscopiques qui décrit la vitesse de rotation de l'appareil dans un espace tridimensionnel.",
  T_50_META_API_129: "Obtenez La Rotation Du Gyroscope Non Biaisée",
  T_50_META_API_129_D: "Décrit la vitesse de rotation de l'appareil et fournit un résultat plus précis en compensant le bruit ou le biais des capteurs de l'appareil.",
  T_50_META_API_130: "Obtenir l'Accélération Utilisateur du Gyroscope",
  T_50_META_API_130_D: "La partie de l’accélération de l’appareil dont la composante de gravité a été supprimé, qui est l’accélération causée par les actions de l’utilisateur ou les forces externes.",
  T_50_META_API_131: "Obtenez les infos de toucher",
  T_50_META_API_131_D: "Obtenez les informations de contact de l'écran d'indexation spécifié (y compris la position, le déplacement et le temps de changement).",
  T_50_META_API_131_P0_D: "Distribuer les ID des points de contact, en commençant par 0",
  T_50_META_API_131_P1_D: "Appuyez sur les positions",
  T_50_META_API_131_P2: "Position Delta",
  T_50_META_API_131_P2_D: "Le changement de position par rapport à la dernière image",
  T_50_META_API_131_P3: "Temps Delta",
  T_50_META_API_131_P3_D: "Temps écoulé depuis la derniere image",
  T_50_META_API_132: "Obtenez le Nombre de Touchers Écran",
  T_50_META_API_132_D: "Obtenir le nombre actuel de points de contact sur l'écran",
  T_50_META_API_133: "Vibrer l'Appareil",
  T_50_META_API_133_D: "Faire vibrer l'appareil une fois",
  T_50_META_API_134_D: "Notifier l'appareil du joueur cible pour lire l'audio",
  T_50_META_API_134_P0_D: "Le joueur cible",
  T_50_META_API_134_P1_D: "L'atout audio",
  T_50_META_API_134_P2_D: "La vitesse de lecture (plage valide: 0,1~3,0; 1 = normal, <1 = ralentir, >1 = accélérer)",
  T_50_META_API_135_D: "Lire le fichier audio unique",
  T_50_META_API_135_P0_D: "Ressources audio",
  T_50_META_API_135_P1_D: "Vitesse de Lecture",
  T_50_META_API_136: "Chaîne de Format",
  T_50_META_API_136_D: "Format des chaînes de caractères",
  T_50_META_API_136_P0_D: "Chaînes formatées utilisant les contrôles du verbe de formatage Go",
  T_50_META_API_136_P1: "Tableau de paramètres",
  T_50_META_API_136_P1_D: "Liste des Paramètres",
  T_50_META_API_137: "Collez le Composant",
  T_50_META_API_137_D: "Copiez ou ajoutez des données sur les composants",
  T_50_META_API_137_P0: "Source",
  T_50_META_API_137_P0_D: "L'entité source",
  T_50_META_API_137_P1_D: "Entité Cible",
  T_50_META_API_137_P2: "Type de Composant",
  T_50_META_API_137_P2_D: "Type de Composant",
  T_50_META_API_137_P3: "Est Une Réussite",
  T_50_META_API_137_P3_D: "Qu'elle soit réussie ou pas",
  T_50_META_API_138: "Réanimer à la prochaine image",
  T_50_META_API_138_D: "Réanimer à la prochaine image",
  T_50_META_API_139: "Éliminez À La Prochaine Image",
  T_50_META_API_139_D: "Éliminer l'entité de bataille à la prochaine image",
  T_50_META_API_139_P0_D: "L'entité de bataille",
  T_50_META_API_140: "Quittez le Jeu à La Prochaine Image",
  T_50_META_API_140_D: "Quitter le jeu à la prochaine image",
  T_50_META_API_141: "Obtenez Le Volume Du Microphone",
  T_50_META_API_141_D: "Récupère le volume du microphone. Renvoie l'état lorsque le microphone du joueur est désactivé ou qu'aucun accès n'est autorisé.",
  T_50_META_API_141_P0: "Volume",
  T_50_META_API_141_P0_D: "Le volume du microphone",
  T_50_META_API_141_P1_D: "Le microphone est activé ou désactivé",
  T_50_META_API_142: "Obtenir la Qualité de Rendu",
  T_50_META_API_142_D: "Obtenez la qualité de rendu actuelle (enum: Low/Medium/High/Ultra)",
  T_50_META_API_143: "Obtenez la Rrésolution de Rendu",
  T_50_META_API_143_D: "Obtenir la résolution de rendu actuelle",
  T_50_META_API_144: "Associer le Joueur Personnalisé",
  T_50_META_API_144_D: "Définir dynamiquement la cible à laquelle ce joueur se lie, ce qui aura pour effet de remplacer les liens existants. Retourne false en cas d'échec.",
  T_50_META_API_144_P0: "Joueur Personnalisé",
  T_50_META_API_144_P0_D: "Après avoir lié ce Joueur Personnalisé au joueur, les données telles que la position et la direction seront automatiquement synchronisées",
  T_50_META_API_144_P1_D: "Joueur Cible",
  T_50_META_API_145: "Dissocier le Joueur Personnalisé",
  T_50_META_API_145_D: "Annule la liaison. Retourne false en cas d'échec.",
  T_50_META_API_145_P0: "Joueur Personnalisé",
  T_50_META_API_145_P0_D: "Efface toutes les liaisons pour cette cible. Après la suppression des liaisons, les données telles que la position et la direction ne seront plus automatiquement synchronisées.",
  T_50_META_API_146_P0_D: "Un joueur personnalisé",
  T_50_META_API_147: "Définir l’État du Joueur Personnalisé",
  T_50_META_API_147_D: "Charger automatiquement vers le serveur et synchroniser avec tous les clients. Retourne false en cas d'échec.",
  T_50_META_API_147_P0: "Joueur Personnalisé",
  T_50_META_API_147_P1: "État",
  T_50_META_API_147_P1_D: "Généralement utilisé pour sauvegarder les états d'animation. Obtenez l'état synchronisé avec Obtenir L’État Du Joueur Personnalisé.",
  T_50_META_API_148: "Obtenir L’État Du Joueur Personnalisé",
  T_50_META_API_148_D: "Les données d'état sont automatiquement synchronisées avec le serveur. Retourne false en cas d'échec.",
  T_50_META_API_148_P0: "Joueur Personnalisé",
  T_50_META_API_148_P1: "État",
  T_50_META_API_148_P1_D: "Définir l'état avec Définir l’État du Joueur Personnalisé",
  T_50_META_API_149: "Définir les Volumes de Distance",
  T_50_META_API_149_D: "Définissez la portée de distance entre les joueurs pour définir dynamiquement le volume audio.",
  T_50_META_API_149_P0: "Liste de Distances",
  T_50_META_API_149_P0_D: "Une liste de portées de distance, chacune correspondant à un élément de la liste des volumes.",
  T_50_META_API_149_P1: "Liste de Volumes",
  T_50_META_API_149_P1_D: "Une liste de volumes, chacun correspondant à un élément de la liste des distances.",
  T_50_META_API_150: "Obtenir Des Amis",
  T_50_META_API_150_D: "Obtenir la liste des ID d'amis du joueur",
  T_50_META_API_151: "Obtenir Les Infos UI Par Défaut",
  T_50_META_API_151_D: "Obtenir l'emplacement UI par défaut du joueur",
  T_50_META_API_151_P0_D: "L'interface par défaut",
  T_50_META_API_151_P1_D: "Statut",
  T_50_META_API_151_P2_D: "Position UI",
  T_50_META_API_151_P3: "Taille",
  T_50_META_API_151_P3_D: "Taille UI",
  T_50_META_API_152: "Diffuser un Évènement Personnalisé",
  T_50_META_API_152_D: "Diffusion d'un événement personnalisé pour toute entité recevant (écoutant) cet événement",
  T_50_META_API_153: "Envoyer un Événement à l’Entité",
  T_50_META_API_153_D: "Envoyer l'évènement personnalisé à l'entité cible",
  T_50_META_EVT_17: "Début de l'écran tactile",
  T_50_META_EVT_17_D: "Démarrer l'évènement lorsque l'écran est touché",
  T_50_META_EVT_17_P0: "Index Tactile",
  T_50_META_EVT_17_P0_D: "Appuyez sur l'index des points",
  T_50_META_EVT_17_P1_D: "Appuyez sur les positions",
  T_50_META_EVT_18: "À la Fin du Toucher Écran",
  T_50_META_EVT_18_D: "Terminer l'évènement lorsque l'écran est touché",
  T_50_META_EVT_18_P0: "Index tactile",
  T_50_META_EVT_18_P0_D: "Appuyez sur l'index des points",
  T_50_META_EVT_18_P1_D: "Appuyez sur les positions sur l'écran",
  T_50_META_EVT_19: "À la réception du résultat de création de salle Persona",
  T_50_META_EVT_19_D: "Recevoir le résultat correspondant en cas d'échec de création du salon Persona",
  T_50_META_EVT_19_P1: "ID de Chambre",
  T_50_META_EVT_19_P1_D: "ID de la chambre",
  T_50_META_EVT_20: "En Cas de Sortie de l'Utilisateur ou de Fin de Match de l'Utilisateur",
  T_50_META_EVT_20_D: "Déclenchement lorsque l'utilisateur quitte le match ou lorsque le match se termine",
  T_50_META_TYP_11_I44: "Volumes de distance",
  T_50_META_TYP_11_I44_D: "Ajustez dynamiquement le volume audio en fonction de la distance entre les joueurs",
  T_50_META_TYP_22_I9_D: "ID de l'actif utilisé pour créer UI",
  T_50_META_TYP_244_I12_D: "Largeur de la zone de texte",
  T_50_META_TYP_244_I13_D: "Hauteur de la zone de texte",
  T_50_META_TYP_244_I14_D: "Le type de débordement",
  T_50_META_TYP_335_I10_D: "La vitesse de lecture (valeur valide > 0, valeur par défaut = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "IO opération échouée: une erreur est survenue lors de la création du fichier.",
  T_50_META_TYP_409_I21: "IO_Invalid_File_Name",
  T_50_META_TYP_409_I21_D: "Échec de l'opération IO. Nom de fichier non valide.",
  T_50_META_TYP_448_I0_D: "La partie contrôlée du squelette",
  T_50_META_TYP_448_I1_D: "La cible que la partie squelette regarde",
  T_50_META_TYP_451: "Type de débordement",
  T_50_META_TYP_451_D: "La méthode de traitement des débordements de texte",
  T_50_META_TYP_452: "ID de Ressource UI Personnalisé",
  T_50_META_TYP_452_D: "L'ID décrivant l'actif HUD personnalisé",
  T_50_META_TYP_453: "Type de Qualité de Rendu",
  T_50_META_TYP_453_D: "L'énumération de qualité de rendu",
  T_50_META_TYPE_448_D: "Cette entité est utilisée pour contrôler la partie du squelette afin qu'elle regarde une cible",
  T_50_SD_WS_MAPTAG_AI3DGEN: "Carte de Génération d’Objet 3D",
  T_50_SD_WS_MAPTAG_AIRACING: "L'IA Des Courses Génère Une Carte",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Énumération du Nom d'État d'Animation",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Désactiver la Vibration des Pas",
  T_50_XXJ_WS_NOPERFORMANCE: "Aucun fichier de performance encore disponible",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Version Bêta",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Chers créateurs, l'éditeur de performance est encore en phase de test. Il peut contenir des anomalies ou manquer de fonctionnalités essentielles. Veuillez l'utiliser avec prudence.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Ajoutez une Performance",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Ajoutez un Clip de Clé",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Le long du chemin",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animation",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Piste d'animation",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Piste Audio",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Maintenez",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Boucle Pour Toujours",
  T_50_XXJ_WS_TIMELINE_DURATION: "Durée: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Inadéquation entre l'animation et le modèle",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Chevauchement du clip clé",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Entité liée manquante",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "Le nom de la piste ne peut pas être vide",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "Trace NPC",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Suivi de la Propriété",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Enlevez le Clip de la Clé",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Limite du nombre de pistes dépassée",
  T_50_XYL_WS_AIGETERATESHOW: "Blocs de construction",
  T_50_YU_F_B_VA_WITCH: "Mystique de Trouble (Bas)",
  T_50_YU_F_H_VA_WITCH: "Mystique de Trouble (Tête)",
  T_50_YU_F_HA_VA_WITCH: "Mystique de Trouble (Peinture de visage)",
  T_50_YU_F_S_VA_WITCH: "Mystique de Trouble (Chaussures)",
  T_50_YU_F_T_VA_WITCH: "Mystique de Trouble (Haut)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Événement Personnalisé",
  T_51_GT_WS_BASIC: "Basique",
  T_51_GT_WS_GLOBALEVENT: "Événement Global",
  T_51_GT_WS_PRIVATEEVENT: "Événement Privé",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "Temps de préparation avant le début du jeu",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Propriété Lecture-Seule",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Veste en cuir noir (Femme)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Chasseur de champignons",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Black Activewear (Shoes)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "Shorts du Star de Garena",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "Jupe du Star de Garena",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Black Activewear (Hoodie)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Haut typique de Songkran.",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Roses et champignons",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "Chemise sans manches du Star de Garena",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "White Prosperity (Bottom)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Pantalon de survêtement noir (homme)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Braconnier.",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Pantalon Survivant",
  TXT_AVATAR_MALE_PANTS_MARIO: "Mama Mia",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Chaussures de survivant",
  TXT_AVATAR_MALE_SHOE_RED: "Bottes Rouges (Homme)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "White Prosperity (Top)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Maillot de Baseball Noir (Homme)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Sweat à capuche Rebelle",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Cool Activewear (Hoodie)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Chemise de patron de Mob",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Chemise de survivant",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Chemise romantique d'un plombier",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Veste Enflammée (F)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Clown de la Nuit (Tête)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Veste Enflammée (M)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Veste Sans Manches (Vert)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "M. Squido",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Samurai Zombifié (Masque)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Tatouage complet",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Libérer soi-même",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Victoria",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Ailes de psionique",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Couleur de pêche",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Les cerises rouges",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Glacial",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Trou bleu",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Mille sakura",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Delta",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Personne comme dieu",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Danseur avec l'ombre",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Eléphant de combat",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Calcaire",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Sinistre",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Etoile de fer noir",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Le cristal bleu",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Fin du combat",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Etoile montante",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Chemin du Bushido",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "Le tourbillon de couleur blanche",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Coup d'envoi de fantaisie (bas)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Jacket de Foudre (F)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Coup d'envoi de fantaisie (Hauts)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Ligue nationale de baseball (bas)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "Talent du hip hop (Tête)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Ligue nationale de baseball (chaussures)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Jacket de Foudre (M)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Ligue nationale de baseball (Hauts)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dragon en bulles",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Les bottes d'argent du gagnant",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Les trois lions",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Smoking (masque)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Smoking (top)",
  TXT_AVATAR_PARACHUTE_8: "Parachute - Smiley",
  TXT_AVATAR_SHIRT_PLAID_2: "Favori des programmeurs (rouge)",
  TXT_AVATAR_SHOES_1: "Chaussures de sport (Blanc)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Uniforme (bégonia)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Uniforme (Rose)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Uniforme (chrysanthème)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Uniforme (Violet)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Uniforme (Jasmine)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Écolière (foncé)",
  TXT_AVATAR_TSHIRT_WEEK_007: "STARRY SUN",
  TXT_BANNER_NAME_MISHA: "Misha",
  TXT_CHARACTER_ADAM_NAME: "Primis",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Nulla",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "Nom",
  TXT_COLLECTION_DESCRIPTION: "Description",
  TXT_COLLECTION_HEADPORTRAIT: "Avatar",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Équipement",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "Munitions AR",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Sac Lv1",
  TXT_ITEM_BAG2: "Sac Lv2",
  TXT_ITEM_BAG3: "Sac Lv3",
  TXT_ITEM_BASEBALLPOLE: "Batte",
  TXT_ITEM_BOWAMMO: "Carreau d'arbalète",
  TXT_ITEM_CHANGUO: "Poêle",
  TXT_ITEM_CROSSBOW: "Arbalète",
  TXT_ITEM_DESC_FLASH: "Un engin explosif pouvant désorienter temporairement les sens de l'ennemi.",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "Kit Médical",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Poing",
  TXT_ITEM_FLASH: "Grenade Assourdissante",
  TXT_ITEM_FOREGRIP1: "Poignée avant Lv1",
  TXT_ITEM_FOREGRIP2: "Poignée avant Lv2",
  TXT_ITEM_FOREGRIP3: "Poignée avant Lv3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "Grenade",
  TXT_ITEM_GROZA: "Groza",
  TXT_ITEM_HANDCANNON: "Canon à main",
  TXT_ITEM_HEATSIGHT: "Portée thermique",
  TXT_ITEM_HELMET1: "Casque Lv1",
  TXT_ITEM_HELMET2: "Casque Lv2",
  TXT_ITEM_HELMET3: "Casque Lv3",
  TXT_ITEM_HGAMMO: "Munitions HG",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Machette",
  TXT_ITEM_MAGEZINE1: "Chargeur Lv1",
  TXT_ITEM_MAGEZINE2: "Chargeur Lv2",
  TXT_ITEM_MAGEZINE3: "Chargeur Lv3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Bouche Lv1",
  TXT_ITEM_MUZZLE2: "Bouche Lv2",
  TXT_ITEM_MUZZLE3: "Bouche Lv3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "Munitions SG",
  TXT_ITEM_SIGHT2: "2 x lunette",
  TXT_ITEM_SIGHT4: "2 x lunette",
  TXT_ITEM_SILENCER1: "Silencieux",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "Munitions SMG",
  TXT_ITEM_SNAMMO: "Munitions Sniper",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Gilet Lv1",
  TXT_ITEM_VEST2: "Gilet Lv2",
  TXT_ITEM_VEST3: "Gilet Lv3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Résultat",
  TXT_MESSAGEBOX_ERROR: "Erreur !",
  TXT_OB10_HQW_ITEM_BIPOD: "Bipied",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Baril de Pétrole",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Tueur Fou",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Batte - Maïs Grillé Mexicain",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Portée de l'explosion",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "Parang - Le Bourreau",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Mines terrestres",
  TXT_OB11_HQW_LANDMINE_DESC: "Une mine qui peut être déployée sur le terrain. Attention, ne marchez pas dessus!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Applaudissements",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Dab",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Poulet Espiègle",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Salut!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Provoquer",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "Lorsque vous tenez un Shotgun, la vitesse de déplacement augmente de [FFB300]{0}%[-].",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Agilité",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "Guépard: Croc",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "Futuriste",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Kit de réparation",
  TXT_OB5_HISTORY_HEADSHOOT: "Tirs à la tête",
  TXT_OB5_HISTORY_LIVE: "Survie",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maxime",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "Manger des champignons et utiliser des kits médicaux plus rapidement de [FFB300]{0}%[-].",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Gourmandise",
  TXT_OB7_ZC_CLAN_NICKNAME: "Surnom",
  TXT_OB7_ZJS_HISTORY_TIME: "Temps",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Barre de feu de joie",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Parachute - Foudre",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Chala",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Les Dégâts causés par les poings ont augmenté de [FFB300]{0}%[-]",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Techniqueultime de la boxe",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "Particules vertes",
  TXT_OB8_ZXR_G18_CAMO_NAME: "La fragmentation quantique",
  TXT_OB8_ZXR_M249_CAMO_NAME: "Le roi de la forêt",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Le tonnerre",
  TXT_OB8_ZXR_USP_CAMO_NAME: "Le léopard des neiges",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Traiter les armes",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Skyboard - Étoile verte",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Gloo mur",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "Camouflage numérique",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "Bloody Mary",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Chasseur de désert",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "Blueflame",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "Parade violet",
  TXT_OB9_ZXR_M14_CAMO_NAME: "Lifestream",
  TXT_OB9_ZXR_M1873_NAME: "La mer d'un bleu profond",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Parang - Espadon",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "Harvesteur",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "Quartz violet",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "La terre brûlée",
  TXT_OPTION_HIGH_BRIGHTNESS: "Brillant",
  TXT_PLAYER_RANK: "RANG",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "Bermudes",
  TXT_SETTING_CHANGEWEAPON: "Bouton De Changement Rapide d'Arme",
  TXT_SETTING_OB4_NOTREAL: "Sombre",
  TXT_SKILL_DESC_COP: "La perte de durabilité de l'armure diminue de [FFB300]{0}%[-].",
  TXT_SKILL_DESC_RUNNER: "Augmentation de vitesse de Sprint de [FFB300]{0}%[-].",
  TXT_SKILL_NAME_COP: "Spécialiste de l'armure",
  TXT_SKILL_NAME_NURSE: "Touche Soignant",
  TXT_SKILL_NAME_RACERGIRL: "Afterburner",
  TXT_SKILL_NAME_RUNNER: "Tableau de bord courant",
  TXT_SKILL_NAME_SEAMAN: "La volonté de fer",
  TXT_TUTORIAL_HUD: "COLLIMATEUR",
  TXT_TUTORIAL_HUD_LABEL10: "Sprint",
  TXT_TUTORIAL_PICKUP_LABEL0: "Arme",
  T_34_M_WS_VFXTYPE: "Type de VFX",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Cible De L'attaque",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Type d'UI du Joueur",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Type de compétence de monstre",
  T_45_META_WS_DESCRIPTIVECOLOR: "Couleur Descriptive",
  T_45_META_WS_GAMETIME: "Temps de Jeu",
  T_45_META_WS_PROPERTY: "Propriété",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "UI Type de Style du Bouton Social",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "Type de bouton social",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "Déclencheur",
  T_46_META_WS_A_ACCOUNTID: "Ressource",
  T_46_META_WS_A_ACTIONTYPE: "Valeur droite",
  T_46_META_WS_A_ACTIVE: "Position",
  T_46_META_WS_A_ANGLE: "Angle",
  T_46_META_WS_A_ANY: "N'importe lequel",
  T_46_META_WS_A_APPEARANCEGROUP: "Position cible",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Expression d'assertion",
  T_46_META_WS_A_ATTACHMENT: "Accessoire",
  T_46_META_WS_A_ATTACHMENTS: "Accessoires",
  T_46_META_WS_A_ATTACKABLE: "Objet",
  T_46_META_WS_A_ATTACKER: "Attaquant",
  T_46_META_WS_A_ATTACKTARGET: "Cible d'attaque",
  T_46_META_WS_A_AUTOPLAY: "Normale",
  T_46_META_WS_A_AXIS: "N'importe quel",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "Base",
  T_46_META_WS_A_BOUNDTARGET: "Cible liée",
  T_46_META_WS_A_BTREE: "Arbre de comportement",
  T_46_META_WS_A_BUFF: "Index",
  T_46_META_WS_A_CAMERA: "ID de mission",
  T_46_META_WS_A_CAPICITY: "Capacité",
  T_46_META_WS_A_CENTER: "Centre",
  T_46_META_WS_A_CHANGEROTATION: "Trouver la valeur",
  T_46_META_WS_A_CHANNEL: "Canal",
  T_46_META_WS_A_CHASEENEMY: "Valeur gauche",
  T_46_META_WS_A_CHILD: "B",
  T_46_META_WS_A_COLOR: "Couleur",
  T_46_META_WS_A_COLUMN: "Gauche",
  T_46_META_WS_A_COLUMNNAME: "Droite",
  T_46_META_WS_A_COMEBACK: "Retour",
  T_46_META_WS_A_COMPONENT: "Composant",
  T_46_META_WS_A_CONTENT: "Contenu",
  T_46_META_WS_A_COORDINATESYSTEM: "Type de filtre",
  T_46_META_WS_A_COUNT: "Nombre",
  T_46_META_WS_A_COUNTS: "Quantités",
  T_46_META_WS_A_CREATEDENTITY: "Entité créée",
  T_46_META_WS_A_CROSSPLATFORM: "Cross-plateforme",
  T_46_META_WS_A_CULLINGMASK: "Masque de découpe",
  T_46_META_WS_A_CURVE: "Direction",
  T_46_META_WS_A_CUSTOMTAG: "Quantité",
  T_46_META_WS_A_CUTRADIUS: "Rayon de coupe",
  T_46_META_WS_A_DAMAGE: "Dégâts",
  T_46_META_WS_A_DAMAGESEGMENTS: "Segments de dégâts",
  T_46_META_WS_A_DEGREE: "Degré",
  T_46_META_WS_A_DELTA: "ValeurB",
  T_46_META_WS_A_DEPTH: "Profondeur",
  T_46_META_WS_A_DESTVAL: "R",
  T_46_META_WS_A_DIFFICULTY: "Difficulté",
  T_46_META_WS_A_DIRECTION: "Direction",
  T_46_META_WS_A_DISABLE: "Rayon",
  T_46_META_WS_A_DISPLACEMENT: "Portefeuille",
  T_46_META_WS_A_DISTANCE: "Contenu",
  T_46_META_WS_A_DIVINGMAXSPEED: "Vitesse maximale en plongée",
  T_46_META_WS_A_DOTWEEN: "Appliquer l'interpolation",
  T_46_META_WS_A_DURATION: "Durée (s)",
  T_46_META_WS_A_EMOTE: "Emote",
  T_46_META_WS_A_ENABLE: "Activer",
  T_46_META_WS_A_ENDAREACENTER: "Centre de la zone finale",
  T_46_META_WS_A_ENDAREARANGE: "Plage de la zone finale",
  T_46_META_WS_A_ENDPOSITION: "Position finale",
  T_46_META_WS_A_ENDRANK: "Rang de fin",
  T_46_META_WS_A_EQUIPMENTS: "Rotation",
  T_46_META_WS_A_EVENTID: "ID de l'événement",
  T_46_META_WS_A_EXPONENT: "Exposant",
  T_46_META_WS_A_FACTION: "Cible",
  T_46_META_WS_A_FACTORTYPE: "Type de facteur",
  T_46_META_WS_A_FILTERTYPE: "Type de filtre",
  T_46_META_WS_A_FINALRADIUS: "Rayon final",
  T_46_META_WS_A_FINDVALUE: "Trouver une valeur",
  T_46_META_WS_A_FIXEDRANGE: "Conseils",
  T_46_META_WS_A_FOLLOWTARGET: "Suivre la cible",
  T_46_META_WS_A_FONTCOLOR: "Couleur de la police",
  T_46_META_WS_A_FONTSIZE: "Taille de la police",
  T_46_META_WS_A_FOOTBALL: "Objet de niveau",
  T_46_META_WS_A_FORCE: "Propriété",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Hauteur du parachute forcée",
  T_46_META_WS_A_FORCEMODE: "Type de modification",
  T_46_META_WS_A_FORWARD: "Direction",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "ID de widget",
  T_46_META_WS_A_HALFEXTENTS: "ID de propriété",
  T_46_META_WS_A_HEIGHT: "Hauteur",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Segments de hauteur",
  T_46_META_WS_A_HITDISTANCE: "Distance de l'impact",
  T_46_META_WS_A_HITDISTANCES: "Composant",
  T_46_META_WS_A_HITENTITIES: "Style",
  T_46_META_WS_A_HITENTITY: "Entité touchée",
  T_46_META_WS_A_HITNORMAL: "Normale de l'impact",
  T_46_META_WS_A_HITNORMALS: "ID d'événement",
  T_46_META_WS_A_HITPOINTS: "Positions",
  T_46_META_WS_A_HITPOSITION: "Position de l'impact",
  T_46_META_WS_A_INCLUDETRIGGER: "Revenir",
  T_46_META_WS_A_INDEX: "Index",
  T_46_META_WS_A_INDEXS: "Index",
  T_46_META_WS_A_INITIALVELOCITY: "Décalage",
  T_46_META_WS_A_INITRADIUS: "Rayon initial",
  T_46_META_WS_A_INWALLET: "Portefeuille d'entrée",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "Portefeuille d'entrée",
  T_46_META_WS_A_ISEXIST: "Existence",
  T_46_META_WS_A_ISLOOP: "Position de départ",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Est mappé à l'écran",
  T_46_META_WS_A_ISPAUSE: "Pause",
  T_46_META_WS_A_ISSIDECOLLIDING: "Portefeuille de sortie",
  T_46_META_WS_A_ISSUCCESS: "Succès",
  T_46_META_WS_A_ISTOPCOLLIDING: "Type de monnaie",
  T_46_META_WS_A_ITEM: "Objet",
  T_46_META_WS_A_ITEMID: "Est en pause",
  T_46_META_WS_A_ITEMS: "Objets",
  T_46_META_WS_A_ITEMTYPE: "Emote",
  T_46_META_WS_A_JERSEYTYPE: "Type de maillot",
  T_46_META_WS_A_KEEPVELOCITY: "ID de jeton",
  T_46_META_WS_A_KEY: "Clé",
  T_46_META_WS_A_KEYCOLUMN: "ValeurA",
  T_46_META_WS_A_KEYS: "Largeur",
  T_46_META_WS_A_LAYER: "Calque",
  T_46_META_WS_A_LAYERMASK: "Emplacement",
  T_46_META_WS_A_LEFT: "Gauche",
  T_46_META_WS_A_LEFTVALUE: "Valeur gauche",
  T_46_META_WS_A_LENGTH: "Longueur",
  T_46_META_WS_A_LEVELOBJECT: "Objet de niveau",
  T_46_META_WS_A_LOG: "Angle",
  T_46_META_WS_A_LOOKATTARGET: "Objets",
  T_46_META_WS_A_LOOPTYPE: "Dégâts",
  T_46_META_WS_A_MAINCOLOR1: "Indice de phase",
  T_46_META_WS_A_MAINCOLOR2: "Statut",
  T_46_META_WS_A_MAPCODE: "Couleur",
  T_46_META_WS_A_MAPPEDPOSITION: "Position mappée",
  T_46_META_WS_A_MAX: "Maximum",
  T_46_META_WS_A_MAXDISPLACEMENT: "Attaquant",
  T_46_META_WS_A_MAXDISTANCE: "Type de facteur",
  T_46_META_WS_A_MIN: "Minimum",
  T_46_META_WS_A_MISSIONID: "ID de mission",
  T_46_META_WS_A_MISSIONPROGRESS: "Progression de mission",
  T_46_META_WS_A_MODIFYTYPE: "Type de modification",
  T_46_META_WS_A_MONEYTYPE: "Type de monnaie",
  T_46_META_WS_A_MUST: "Obligatoire",
  T_46_META_WS_A_NAME: "Propriétaire",
  T_46_META_WS_A_NEWVALUE: "Nouvelle valeur",
  T_46_META_WS_A_NODE: "Nœud",
  T_46_META_WS_A_NORMAL: "Normale",
  T_46_META_WS_A_NOT: "Non",
  T_46_META_WS_A_OBSERVER: "Observateur",
  T_46_META_WS_A_OFFSET: "Décalage",
  T_46_META_WS_A_OLDVALUE: "Ancienne valeur",
  T_46_META_WS_A_OPERATIOMETHOD: "Méthode d'opération",
  T_46_META_WS_A_OPTIONS: "Options",
  T_46_META_WS_A_OTHERCOLOR: "Entité créée",
  T_46_META_WS_A_OUTFIT: "Index de départ",
  T_46_META_WS_A_OUTFITS: "Séparateur",
  T_46_META_WS_A_OUTWALLET: "Portefeuille de sortie",
  T_46_META_WS_A_OWNER: "Propriétaire",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Vitesse maximale en parachute",
  T_46_META_WS_A_PARAMS: "Paramètres",
  T_46_META_WS_A_PARENT: "G",
  T_46_META_WS_A_PARENTWIDGET: "Cible d'attaque",
  T_46_META_WS_A_PATH: "Rayon initial",
  T_46_META_WS_A_PATHPOINTS: "Points de chemin",
  T_46_META_WS_A_PHASEINDEX: "Index de phase",
  T_46_META_WS_A_PLATFORM: "Plateforme",
  T_46_META_WS_A_PLAYER: "Position",
  T_46_META_WS_A_PLAYSPEED: "Durée (s)",
  T_46_META_WS_A_POSITION: "Position",
  T_46_META_WS_A_POSITIONS: "Positions",
  T_46_META_WS_A_POSTION: "Position",
  T_46_META_WS_A_PREFAB: "ID de scène",
  T_46_META_WS_A_PROPERTY: "Propriété",
  T_46_META_WS_A_PROPERTYID: "ID de propriété",
  T_46_META_WS_A_PURSUITTARGET: "Cible poursuivie",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Rayon",
  T_46_META_WS_A_RANDOMDECAY: "Clé",
  T_46_META_WS_A_RANDOMRANGE: "Plage aléatoire",
  T_46_META_WS_A_RANDOMRATIO: "Paramètres",
  T_46_META_WS_A_RANGE: "Expression d'assertion",
  T_46_META_WS_A_RANK: "Échelle",
  T_46_META_WS_A_REALCOIN: "ID UI",
  T_46_META_WS_A_REALNUMBER: "Nombre réel",
  T_46_META_WS_A_RESET: "Suivre la cible",
  T_46_META_WS_A_RESOURCE: "Ressource",
  T_46_META_WS_A_RESULT: "Doit",
  T_46_META_WS_A_RIGHT: "Droite",
  T_46_META_WS_A_RIGHTVALUE: "Valeur droite",
  T_46_META_WS_A_ROTATION: "Rotation",
  T_46_META_WS_A_ROW: "Max",
  T_46_META_WS_A_SAMPLEPOINT: "Point d'échantillonnage",
  T_46_META_WS_A_SCALE: "Échelle",
  T_46_META_WS_A_SCENEID: "ID de scène",
  T_46_META_WS_A_SCORE: "Score",
  T_46_META_WS_A_SCORENAME: "Nom du score",
  T_46_META_WS_A_SCREENPOSITION: "Position sur l'écran",
  T_46_META_WS_A_SCRIPT: "Rayon final",
  T_46_META_WS_A_SEAT: "Siège",
  T_46_META_WS_A_SEP: "Séparateur",
  T_46_META_WS_A_SEPSTR: "Séparateur",
  T_46_META_WS_A_SHEETNAME: "Min",
  T_46_META_WS_A_SHOPITEM: "Succès",
  T_46_META_WS_A_SHOWBACKGROUND: "Afficher l'arrière-plan",
  T_46_META_WS_A_SHOWMATCHRESULT: "Comptes",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "Afficher le message lors de l'annulation",
  T_46_META_WS_A_SKILL: "Compétence",
  T_46_META_WS_A_SKILLS: "Valeur",
  T_46_META_WS_A_SKILLTARGET: "Cible de compétence",
  T_46_META_WS_A_SKIN: "Skin de sac à dos",
  T_46_META_WS_A_SLOT: "Emplacement",
  T_46_META_WS_A_SRCVAL: "Degré",
  T_46_META_WS_A_SRCVALUE: "Valeur source",
  T_46_META_WS_A_STARTAREACENTER: "Centre de la zone de départ",
  T_46_META_WS_A_STARTAREARANGE: "Plage de la zone de départ",
  T_46_META_WS_A_STARTINDEX: "Index de départ",
  T_46_META_WS_A_STARTPOSITION: "Position de départ",
  T_46_META_WS_A_STARTRANK: "Rang de départ",
  T_46_META_WS_A_STATE: "Temps d'attente (s)",
  T_46_META_WS_A_STATUS: "Statut",
  T_46_META_WS_A_STATUSCODE: "Code de statut",
  T_46_META_WS_A_STYLE: "Style",
  T_46_META_WS_A_SURFINGMAXSPEED: "Vitesse maximale en surf",
  T_46_META_WS_A_TARGET: "Cible",
  T_46_META_WS_A_TARGETPOSITION: "Position cible",
  T_46_META_WS_A_TEAMSEQ: "Avant",
  T_46_META_WS_A_THRESHOLD: "Canal",
  T_46_META_WS_A_TIMESTAMP: "Horodatage",
  T_46_META_WS_A_TIPS: "Conseils",
  T_46_META_WS_A_TITLE: "Titre",
  T_46_META_WS_A_TOKENCOUNT: "Nombre de jetons",
  T_46_META_WS_A_TOKENID: "ID de jeton",
  T_46_META_WS_A_TORQUE: "Existe",
  T_46_META_WS_A_TOUCHPOINT: "Point de contact",
  T_46_META_WS_A_TRANSITIONTIME: "Compte de jeton",
  T_46_META_WS_A_TRANSITIONTYPE: "Progression de mission",
  T_46_META_WS_A_TRIGGER: "Déclencheur",
  T_46_META_WS_A_TYPE: "Type",
  T_46_META_WS_A_UI: "Cible de poursuite",
  T_46_META_WS_A_UIID: "ID de l'UI",
  T_46_META_WS_A_UPWARD: "Type de maillot",
  T_46_META_WS_A_VALUE: "Valeur",
  T_46_META_WS_A_VALUEA: "Valeur A",
  T_46_META_WS_A_VALUEB: "Valeur B",
  T_46_META_WS_A_VALUES: "Rayon de coupe",
  T_46_META_WS_A_VALUET: "Ne doit pas",
  T_46_META_WS_A_VALUETYPE: "Type de valeur",
  T_46_META_WS_A_VEHICLE: "Véhicule",
  T_46_META_WS_A_VEHICLESKIN: "Apparence du véhicule",
  T_46_META_WS_A_VELOCITY: "Centre",
  T_46_META_WS_A_VELOCITYXZ: "Nouvelle valeur",
  T_46_META_WS_A_VELOCITYY: "Ancienne valeur",
  T_46_META_WS_A_VISIBLE: "Visible",
  T_46_META_WS_A_WAITTIME: "Temps d'attente (s)",
  T_46_META_WS_A_WALLET: "Portefeuille",
  T_46_META_WS_A_WEAPON: "Séparateur",
  T_46_META_WS_A_WEAPONSKIN: "Indexes",
  T_46_META_WS_A_WIDGETID: "ID du widget",
  T_46_META_WS_A_WIDGETTYPE: "Activer",
  T_46_META_WS_A_WIDTH: "Largeur",
  T_46_META_WS_A_WORLDPOSITION: "Position dans le monde",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "Type",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Valeur Absolue",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "Ajouter un suivi spécial AOI",
  T_46_META_WS_ADDATTACHMENTS: "Ajouter Des Accessoires",
  T_46_META_WS_ADDBUFF: "Ajouter un buff",
  T_46_META_WS_ADDCOMPONENT: "Ajouter un composant",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Ajouter la vitesse du ballon",
  T_46_META_WS_ADDFORCE: "Ajouter une force",
  T_46_META_WS_ADDFORCEATPOSITION: "Ajouter une force à la position",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Ajouter un facteur de propriété de formule",
  T_46_META_WS_ADDGAMEEVENTLOG: "Ajouter un journal d'événements de jeu",
  T_46_META_WS_ADDHP: "Ajouter des HP",
  T_46_META_WS_ADDITEM: "Ajouter un Élément",
  T_46_META_WS_ADDITEMINSCENE: "Créer un Élément dans la Scène",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Ajouter un article à l'article",
  T_46_META_WS_ADDMONEY: "Ajouter de l'argent",
  T_46_META_WS_ADDSCRIPT: "Ajouter un script",
  T_46_META_WS_ADDTAG: "Ajouter une étiquette",
  T_46_META_WS_ADDTOKEN: "Ajouter un Token",
  T_46_META_WS_ADDTORQUE: "Ajouter un couple",
  T_46_META_WS_ADDUSEREVENTLOG: "Ajouter un journal d'événements utilisateur",
  T_46_META_WS_ANGEL: "Angle",
  T_46_META_WS_APPEND: "Ajouter",
  T_46_META_WS_APPENDRANGE: "Ajouter une Plage",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Appliquer la configuration de sortie en cours",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "Assurer",
  T_46_META_WS_ASSISTPLAYER: "Joueur assistant",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Attaquant",
  T_46_META_WS_ATTACKTARGET: "Cible d'attaque",
  T_46_META_WS_AXISANGLETOQUATERNION: "Angle d'axe en quaternion",
  T_46_META_WS_BOXCAST: "Détection de boîte",
  T_46_META_WS_BOXOVERLAP: "Superposition de boîte",
  T_46_META_WS_BUTTONNAME: "Nom du bouton",
  T_46_META_WS_C_ACTIONTYPE: "Type d'action",
  T_46_META_WS_C_AIMABLE: "Composant pouvant être ciblé",
  T_46_META_WS_C_AIMASSISTABLE: "Composant assisté pour la visée",
  T_46_META_WS_C_AIMASSISTTYPE: "Aim Assist Type",
  T_46_META_WS_C_AIRDROP: "Largage aérien",
  T_46_META_WS_C_AMMO: "Munitions",
  T_46_META_WS_C_AMMOTYPE: "Ammo Type",
  T_46_META_WS_C_AMPHIBIAN: "Amphibie",
  T_46_META_WS_C_ANIMATIONCLIP: "Clip d'animation",
  T_46_META_WS_C_ANIMATIONCLIPID: "ID de clip d'animation",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Contrôleur d'animation",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Composant attachable de contrôleur d'animation",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "ID de contrôleur d'animation",
  T_46_META_WS_C_ANIMATIONSTATE: "État d'animation",
  T_46_META_WS_C_ANIMATIONTRIGGER: "Déclencheur d'animation",
  T_46_META_WS_C_APPEARENCE: "Apparence",
  T_46_META_WS_C_ASSETCONFIGID: "ID de configuration d'actif",
  T_46_META_WS_C_ASSETID: "ID d'actif",
  T_46_META_WS_C_ATTACHMENT: "Accessoire",
  T_46_META_WS_C_ATTACKABLETYPE: "Type attaquable",
  T_46_META_WS_C_AUDIOID: "ID audio",
  T_46_META_WS_C_BACKPACK: "Sac à dos",
  T_46_META_WS_C_BACKPACKSKINID: "ID de skin de sac à dos",
  T_46_META_WS_C_BASEDATAALIAS: "Alias de données de base",
  T_46_META_WS_C_BASICAPPEARANCE: "Apparence de base",
  T_46_META_WS_C_BASICCYLINDER: "Cylindre de base",
  T_46_META_WS_C_BASICSCALABLE: "Échelle de base",
  T_46_META_WS_C_BASICSPHERE: "Sphère de base",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Composant de rendu par lot",
  T_46_META_WS_C_BEVTREE: "Arbre de comportement",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Arbre de comportement attachable",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Nœud personnalisé de l'arbre de comportement",
  T_46_META_WS_C_BEVTREEID: "ID D'arbre De Comportement",
  T_46_META_WS_C_BEVTREENODESTATUS: "Statut Du Nœud De L'arbre De Comportement",
  T_46_META_WS_C_BEVTREENODETYPE: "Type De Nœud De L'arbre De Comportement",
  T_46_META_WS_C_BEZIERCURVE: "Courbe de Bézier",
  T_46_META_WS_C_BOOL: "Booléen",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Type de difficulté des bots",
  T_46_META_WS_C_BOUNCINGTIRE: "Pneus rebondissants",
  T_46_META_WS_C_BUFFABLE: "Buffable",
  T_46_META_WS_C_BUFFGENERATOR: "Générateur de buff",
  T_46_META_WS_C_BUFFTYPE: "Type de buff",
  T_46_META_WS_C_BUILTINRENDER: "Rendu Intégré",
  T_46_META_WS_C_BUILTINUI: "UI intégré",
  T_46_META_WS_C_BUILTINUITYPE: "Type d'UI intégré",
  T_46_META_WS_C_CAMERA: "Caméra",
  T_46_META_WS_C_CAMERABLOCKMODE: "Mode de blocage de la caméra",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Mode de projection de la caméra",
  T_46_META_WS_C_CAMERARAYCASTUI: "UI de détection de rayons de la caméra",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Type de transition de la caméra",
  T_46_META_WS_C_CAMERATYPE: "Type de caméra",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Restriction d'angle de vue de la caméra",
  T_46_META_WS_C_CAPSULETRIGGER: "Déclencheur en capsule",
  T_46_META_WS_C_CAR: "Voiture",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Contrôleur de personnage",
  T_46_META_WS_C_CHATCHANNEL: "Canal de chat",
  T_46_META_WS_C_CHATCHANNELTYPE: "Type de canal de chat",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Déclencheur de point de contrôle",
  T_46_META_WS_C_COINGENERATOR: "Générateur de pièces",
  T_46_META_WS_C_COLLECTIONID: "ID de collection",
  T_46_META_WS_C_COLLIDER: "Colliseur",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Forme du collider",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "ID de collection de colliders",
  T_46_META_WS_C_COLORDRUM: "Tambour de couleur",
  T_46_META_WS_C_COMBATABLE: "Combatif",
  T_46_META_WS_C_COMPONENT: "Composant",
  T_46_META_WS_C_CONDITION: "Condition",
  T_46_META_WS_C_CONTAINER: "Conteneur",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Type de système de coordonnées",
  T_46_META_WS_C_CROSSBOW: "Grenade arbalète",
  T_46_META_WS_C_CSVID: "ID CSV",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Déclencheur personnalisable",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Objet personnalisé",
  T_46_META_WS_C_CUSTOMPATH: "Custom Path",
  T_46_META_WS_C_CUSTOMUI: "UI personnalisée",
  T_46_META_WS_C_CUSTOMUIID: "ID d'interface utilisateur",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "UI ou Widget personnalisé",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "ID de widget d'interface utilisateur",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Type de Partie du Corps Endommagée",
  T_46_META_WS_C_DAMAGETYPE: "Damage Type",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Déclencheur de mort ou d'invulnérabilité",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Objet destructible",
  T_46_META_WS_C_DICE: "Dé",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "Chaussures de double saut",
  T_46_META_WS_C_DRUMMUSIC: "Musique de batterie",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Dual-Wield Weapon Type",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Objet de niveau commun",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Type d'objet de niveau créé dynamiquement",
  T_46_META_WS_C_DYNAMICFENCE: "Clôture dynamique",
  T_46_META_WS_C_EFFECT: "Effet",
  T_46_META_WS_C_EFFECTCONTAINER: "Conteneur d'effets",
  T_46_META_WS_C_EFFECTID: "ID d'effet",
  T_46_META_WS_C_EMOTETYPE: "Type d'émotion",
  T_46_META_WS_C_ENDPOINTTRIGGER: "Déclencheur de point final",
  T_46_META_WS_C_ENTITY: "Entité",
  T_46_META_WS_C_ENTITYORPREFABID: "Entité ou ID de prefab",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Accessoire d'équipement",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Equipment Slot Type",
  T_46_META_WS_C_EQUIPMENTTYPE: "Equipment Type",
  T_46_META_WS_C_EVENTID: "ID d'événement",
  T_46_META_WS_C_FACTION: "Faction",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Type de direction de remplissage",
  T_46_META_WS_C_FILLTYPE: "Type de remplissage",
  T_46_META_WS_C_FIRETYPE: "Fire Type",
  T_46_META_WS_C_FLOAT: "Flottant",
  T_46_META_WS_C_FOLDWING: "Ailes pliantes",
  T_46_META_WS_C_FOLLOW: "Suivre",
  T_46_META_WS_C_FONTTYPE: "Type de police",
  T_46_META_WS_C_FOOTBALL: "Football",
  T_46_META_WS_C_FORCETYPE: "Type de force",
  T_46_META_WS_C_FORMULABLE: "Formulable",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Auto-relatif par image",
  T_46_META_WS_C_GAMERESULTTYPE: "Type de résultat du jeu",
  T_46_META_WS_C_GENDERTYPE: "Gênero",
  T_46_META_WS_C_GENERALSPAWNPOINT: "Point D'apparition Général",
  T_46_META_WS_C_GRENADEDEICEWALL: "Граната для блокировки льда",
  T_46_META_WS_C_GRENADEFLASHBANG: "Grenade éclairante",
  T_46_META_WS_C_GRENADEFROZEN: "Grenade de congélation",
  T_46_META_WS_C_GRENADELAUNCHER: "Lance-grenades",
  T_46_META_WS_C_GRENADESMOKE: "Grenade fumigène",
  T_46_META_WS_C_GRENADEWEAPON: "Base de grenade",
  T_46_META_WS_C_GRID: "Grille",
  T_46_META_WS_C_HANDCANNON: "Grenade à main pistolet",
  T_46_META_WS_C_HELMET: "Casque",
  T_46_META_WS_C_HIERARCHICAL: "Hiérarchique",
  T_46_META_WS_C_HOOKGUN: "Arme à crochet",
  T_46_META_WS_C_HORIZALINE: "Ligne horizontale",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI Transformateur",
  T_46_META_WS_C_HUMANMODELID: "ID de modèle humain",
  T_46_META_WS_C_ICEWALL: "Mur de glace",
  T_46_META_WS_C_ICEWALLCREATED: "Mur de glace créé",
  T_46_META_WS_C_ICEWALLMAKER: "Créateur de Mur de Glace",
  T_46_META_WS_C_ICON: "Entité d'icône",
  T_46_META_WS_C_ICONTYPE: "Icon Type",
  T_46_META_WS_C_INHALER: "Inhalateur",
  T_46_META_WS_C_INT: "Entier",
  T_46_META_WS_C_INT64: "Entier 64 bits",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Modèle de carte entière",
  T_46_META_WS_C_INTORINTLIST: "Entier ou liste d'entiers",
  T_46_META_WS_C_INVENTORYTYPE: "Inventory Type",
  T_46_META_WS_C_ITEMBASE: "Base de l'objet",
  T_46_META_WS_C_ITEMCONTAINER: "Item Container",
  T_46_META_WS_C_ITEMID: "ID d'article",
  T_46_META_WS_C_ITEMIDTYPE: "Item ID Type",
  "T_46_META_WS_C_JERSEY STYLE": "Jersey Style",
  T_46_META_WS_C_JERSEYMACHINE: "JerseyMachine",
  T_46_META_WS_C_JETSHOES: "Chaussures à réaction",
  T_46_META_WS_C_KEYBOARD: "Clavier",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Knock-down Type",
  T_46_META_WS_C_LANDMINE: "Mine terrestre",
  T_46_META_WS_C_LANDMINECREATED: "Mine créée",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Niveau de l'objet de lancement",
  T_46_META_WS_C_LAUNCHPAD: "Plate-forme de lancement",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Type de tri de mise en page",
  T_46_META_WS_C_LEAD1MUSIC: "Musique Lead1",
  T_46_META_WS_C_LEAD2MUSIC: "Musique Lead2",
  T_46_META_WS_C_LEAD3MUSIC: "Musique Lead3",
  T_46_META_WS_C_LEVELOBJECTID: "ID d'objet de niveau",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Type d'objet de niveau",
  T_46_META_WS_C_LIST: "Liste",
  T_46_META_WS_C_LISTORMAP: "Liste ou carte",
  T_46_META_WS_C_LISTT: "Modèle de liste",
  T_46_META_WS_C_LISTT_BOOL: "Liste de booléens",
  T_46_META_WS_C_LISTT_CONDITION: "Liste des conditions",
  T_46_META_WS_C_LISTT_ENTITY: "Entity List",
  T_46_META_WS_C_LISTT_FLOAT: "Liste de flottants",
  T_46_META_WS_C_LISTT_INT: "Liste d'entiers",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Liste des objets",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Level Object List",
  T_46_META_WS_C_LISTT_LOCKEY: "Liste des clés de localisation",
  T_46_META_WS_C_LISTT_PLAYABLE: "Liste des objets jouables",
  T_46_META_WS_C_LISTT_PLAYER: "Player List",
  T_46_META_WS_C_LISTT_SKILLID: "Liste d'ID de Compétences",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Liste des effets sonores",
  T_46_META_WS_C_LISTT_STRING: "Liste de chaînes",
  T_46_META_WS_C_LISTT_TEAM: "Team List",
  T_46_META_WS_C_LISTT_TYPE: "Liste de types",
  T_46_META_WS_C_LISTT_VECTOR3: "Liste Vector3",
  T_46_META_WS_C_LOCKEY: "Clé de localisation",
  T_46_META_WS_C_LOOKAT: "Regarder",
  T_46_META_WS_C_LOOPABLE: "Loopable",
  T_46_META_WS_C_LOOPTYPE: "Type de boucle",
  T_46_META_WS_C_LOOTAMMOTYPE: "Type de munitions de butin",
  T_46_META_WS_C_LOOTARMOR: "Armure de butin",
  T_46_META_WS_C_LOOTARMORTYPE: "Type d'armure de butin",
  T_46_META_WS_C_LOOTCONSUMABLE: "Consommable de butin",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Type de consommable de butin",
  T_46_META_WS_C_LOOTIAMMO: "Munitions de butin",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Boîte à loot football",
  T_46_META_WS_C_LOOTSCOPE: "Lunette de butin",
  T_46_META_WS_C_LOOTSCOPETYPE: "Type de lunette de butin",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Type de loot football",
  T_46_META_WS_C_LOOTTHROWABLE: "Objet lançable de butin",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Type d'objet lançable de butin",
  T_46_META_WS_C_LOOTWEAPON: "Arme de butin",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Type d'arme de butin",
  T_46_META_WS_C_LOWGRAVITY: "Zone de faible gravité",
  T_46_META_WS_C_MAP: "Carte",
  T_46_META_WS_C_MAPT: "Modèle de carte",
  T_46_META_WS_C_MATERIALID: "ID de matériau",
  T_46_META_WS_C_MEDKIT: "Kit de premiers secours",
  T_46_META_WS_C_MESHID: "ID de maillage",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Configuration de sortie de jeu",
  T_46_META_WS_C_MINIMAP: "Mini-carte",
  T_46_META_WS_C_MINIMAPICON: "Icône de mini-carte",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Rendu de pixels de la minimap",
  T_46_META_WS_C_MINISENTRY: "Mini-tourelle",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Type de portée d'attaque du mini-tourelle",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini-tourelle créée",
  T_46_META_WS_C_MONEY: "Monnaie",
  T_46_META_WS_C_MONEYTYPE: "Type de monnaie",
  T_46_META_WS_C_MONSTER: "Monster",
  T_46_META_WS_C_MONSTERSPAWN: "Spawn de monstre",
  T_46_META_WS_C_MONSTERTYPE: "Monster Type",
  T_46_META_WS_C_MORPHABLEOBJECT: "Objet morphable",
  T_46_META_WS_C_MORPHOBJECT: "Objet morphable",
  T_46_META_WS_C_MOTOBIKE: "Moto",
  T_46_META_WS_C_MOVEPLATFORM: "Déplacer la plate-forme",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Déplacer Le Type De Plate-forme",
  T_46_META_WS_C_MUSHROOM: "Champignon",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Constante Naturelle",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "Nombre",
  T_46_META_WS_C_OBJECT: "Objet",
  T_46_META_WS_C_OILDRUM: "Baril de pétrole",
  T_46_META_WS_C_OUTFITID: "ID de tenue",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Type de slot pour vêtement",
  T_46_META_WS_C_PATHPOINT: "Path Point",
  T_46_META_WS_C_PATROLSTYLETYPE: "Patrol Style Type",
  T_46_META_WS_C_PATROLTYPE: "Patrol Type",
  T_46_META_WS_C_PERSONA: "Persona",
  T_46_META_WS_C_PHASE: "Phase",
  T_46_META_WS_C_PHYSICALMOVER: "Déplaceur physique",
  T_46_META_WS_C_PHYSICALOBJECT: "Objet physique",
  T_46_META_WS_C_PLATFORMTYPE: "Type de plateforme",
  T_46_META_WS_C_PLAYABLE: "Playable",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Jouable ou tableaux de jouables",
  T_46_META_WS_C_PLAYER: "Player",
  T_46_META_WS_C_PLAYERBACKPACK: "Sac à dos du joueur",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Type de statut de comportement du joueur",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Type de comportement du joueur",
  T_46_META_WS_C_PLAYERCCT: "Contrôleur de personnage pour FF",
  T_46_META_WS_C_PLAYERDATAID: "Type de personnage prédéfini",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Joueur ou transformation",
  T_46_META_WS_C_PLAYERORVEHICLE: "Joueur ou véhicule",
  T_46_META_WS_C_PLAYEROUTFIT: "Player Outfit",
  T_46_META_WS_C_PLAYERPOSETYPE: "Player Pose Type",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Player Revival Source Type",
  T_46_META_WS_C_PLAYERSTATETYPE: "Player State Type",
  T_46_META_WS_C_POINTLIGHT: "Lumière ponctuelle",
  T_46_META_WS_C_PORTAL: "Portail",
  T_46_META_WS_C_PREFABID: "ID de prefab",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "Générateur d'effet de présentation",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Type de texture d'effet",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Widget de photo de profil",
  T_46_META_WS_C_PROPERTY: "Propriété",
  T_46_META_WS_C_PROPERTYFORMULA: "Formule de propriété",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Type de facteur de formule de propriété",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Type de modification de propriété",
  T_46_META_WS_C_QUATERNION: "Quaternaire",
  T_46_META_WS_C_RANKABLE: "Classable",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Type de couche de raycast",
  T_46_META_WS_C_REPAIRKIT: "Kit de réparation",
  T_46_META_WS_C_RESETABLE: "Resetable",
  T_46_META_WS_C_RIGIDBODY: "Corps rigide",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "Type de contrainte de corps rigide",
  T_46_META_WS_C_RIGIDBODYTYPE: "Type de corps rigide",
  T_46_META_WS_C_ROUND: "Tour",
  T_46_META_WS_C_SAFEZONE: "Zone de sécurité",
  T_46_META_WS_C_SCOREABLE: "Évaluable",
  T_46_META_WS_C_SCRIPTID: "ID de script",
  T_46_META_WS_C_SEATTYPE: "Type de siège",
  T_46_META_WS_C_SELFRELATIVE: "Auto-relatif",
  T_46_META_WS_C_SHOP: "Magasin",
  T_46_META_WS_C_SHOPITEM: "Article de magasin",
  T_46_META_WS_C_SHOPSHELF: "Étagère de magasin",
  T_46_META_WS_C_SKATEBOARD: "Planche à roulettes",
  T_46_META_WS_C_SKELETON: "Squelette",
  T_46_META_WS_C_SKELETONPART: "Partie du squelette",
  T_46_META_WS_C_SKILLID: "ID de compétence",
  T_46_META_WS_C_SKYBLASTER: "Skyblaster",
  T_46_META_WS_C_SKYBOX: "Skybox",
  T_46_META_WS_C_SKYBOXTYPE: "Type de skybox",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Boule de neige de l'île sociale",
  T_46_META_WS_C_SORTTYPE: "Sort Type",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Type de son de tambour",
  T_46_META_WS_C_SOUNDEFFECT: "Effet sonore",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "Effet sonore ou liste des effets sonores",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "SoundEffect Type",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Type de son Lead1",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Type de son Lead2",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Type de son Lead3",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Type de son piano",
  T_46_META_WS_C_SPAWN: "Spawn",
  T_46_META_WS_C_SPAWNABLE: "Spawnable",
  T_46_META_WS_C_SPAWNBOX: "Zone d'Apparition",
  T_46_META_WS_C_SPAWNPOSITION: "Point D'apparition",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "Special Item ID Type",
  T_46_META_WS_C_SPHERETRIGGER: "Déclencheur sphérique",
  T_46_META_WS_C_SPORTSCAR: "Voiture de sport",
  T_46_META_WS_C_SPRAYCOLOR: "Couleur de spray",
  T_46_META_WS_C_SPRAYGUN: "Pistolet à spray",
  T_46_META_WS_C_SPRAYRESULTUI: "UI de résultats de spray",
  T_46_META_WS_C_SPRAYRIFLE: "Fusil à spray",
  T_46_META_WS_C_SPRITEID: "ID de sprite",
  T_46_META_WS_C_STATICSCRIPTID: "ID de script statique",
  T_46_META_WS_C_STRING: "Chaîne",
  T_46_META_WS_C_STRINGORLOCSTRING: "Chaîne ou chaîne localisée",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Déclencheur de boîte de ravitaillement",
  T_46_META_WS_C_SWINGGUN: "Arme à balancier",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Changement de slot d'équipement",
  T_46_META_WS_C_TEAM: "Équipe",
  T_46_META_WS_C_TERRAIN: "Terrain",
  T_46_META_WS_C_TEXT: "Entité de texte",
  T_46_META_WS_C_TEXTUREID: "ID de texture",
  T_46_META_WS_C_TEXTURETYPE: "Texture de l'objet",
  T_46_META_WS_C_TIMER: "Minuteur",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Стиль форматирования временной метки",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "Chaîne de localisation de timestamp",
  T_46_META_WS_C_TRAJECTORY: "Trajectoire",
  T_46_META_WS_C_TRANSFORM: "Transformation",
  T_46_META_WS_C_TUKTUK: "Tuk Tuk",
  T_46_META_WS_C_TURRET: "Tour",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Courbe de Tween",
  T_46_META_WS_C_TWEENSTYLE: "Type de style de Tween",
  T_46_META_WS_C_TYPE: "Type",
  T_46_META_WS_C_TYPEENUM: "Enumération des types",
  T_46_META_WS_C_TYPEORTYPELIST: "Type ou liste de types",
  T_46_META_WS_C_UIADDSCORE: "Ajouter un score UI",
  T_46_META_WS_C_UIANITRIGGERHUD: "Déclencheur d'animation HUD UI",
  T_46_META_WS_C_UIBUILTINSWITCH: "Commutateur UI Intégré",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "UI du Contrôleur de commutation UI intégré",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "Panneau de Sélection de Cartes UI",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "Indicateur de Point De Contrôle UI",
  T_46_META_WS_C_UICOMPASS: "Boussole UI",
  T_46_META_WS_C_UICOUNTDOWN5: "Compte à rebours de 5 secondes UI",
  T_46_META_WS_C_UICOUNTDOWNHINT: "Indication De Compte À Rebours UI",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "Rappel de compte à rebours UI",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "Barre de Suivi de Santé UI",
  T_46_META_WS_C_UIHEALTHBAR: "Barre de Santé UI",
  T_46_META_WS_C_UIHEARTBEAT: "Battement de cœur UI",
  T_46_META_WS_C_UIICONNOTIFICATION: "Notification d'icône UI",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "Notification D'identité UI",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "Bouton d'interaction UI",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "Bouton de tableau de classement UI",
  T_46_META_WS_C_UIMATCHSUBTITLE: "Sous-titre Du Match UI",
  T_46_META_WS_C_UIMONSTERLEVEL: "Niveau Du Monstre UI",
  T_46_META_WS_C_UIMONSTERUI: "UI de Monstre",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "Tableau de Classement Multi-Équipes UI",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "Panneau De Résultat Multi-équipes UI",
  T_46_META_WS_C_UIOPENINGBANNER: "Bannière d'ouverture UI",
  T_46_META_WS_C_UIPANEL: "Panneau UI",
  T_46_META_WS_C_UIPANELEMPTY: "Panneau Vide UI",
  T_46_META_WS_C_UIPHASETIMER: "Minuteur de Phase UI",
  T_46_META_WS_C_UIPROGRESSBAR: "Barre de progression UI",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "Cercle de progression UI",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "Bouton de progression de compétence UI",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "Type de demande d'achat UI",
  T_46_META_WS_C_UIROUNDINFOBANNER: "Bannière d'information sur le tour UI",
  T_46_META_WS_C_UIROUNDNUMBER: "Numéro de tour UI",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "Bannière De Résultat De Tour UI",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "Bannière de début de tour UI",
  T_46_META_WS_C_UIROUNDTRANSITION: "Transition de tour UI",
  T_46_META_WS_C_UISCOREBAR: "Barre De Score UI",
  T_46_META_WS_C_UISCROLLPANEL: "Panneau de défilement UI",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "Bannière de score de tour simple UI",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "Bannière de début de tour simple UI",
  T_46_META_WS_C_UISIMPLETIP: "Astuce simple UI",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "Bannière de Versus Simple UI",
  T_46_META_WS_C_UISKILLBUTTON: "Bouton de compétence UI",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "Widget du Bouton Sociale de l'UI",
  T_46_META_WS_C_UISOLOLEADERBOARD: "Tableau de classement solo UI",
  T_46_META_WS_C_UISTORE: "Interface de Magasin UI",
  T_46_META_WS_C_UITEAMMATCHINFO: "Informations sur le match d'équipe UI",
  T_46_META_WS_C_UITEXTTIP: "Astuce de Texte UI",
  T_46_META_WS_C_UITIMERINFO: "Informations Sur Le Minuteur UI",
  T_46_META_WS_C_UITIPBUTTON: "Bouton D'astuce UI",
  T_46_META_WS_C_UITITLEBANNER: "Bannière de Titre UI",
  T_46_META_WS_C_UITWEENTIP: "Astuce de transition UI",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "Informations brèves sur les deux équipes UI",
  T_46_META_WS_C_UITWOTEAMINFO: "UI D'informations Sur Les Deux Équipes",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "Tableau De Bord Des Deux Équipes UI",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "Panneau de résultat des deux équipes UI",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "Bannière de score de tour des deux équipes UI",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "Panneau De Score Des Deux Équipes UI",
  T_46_META_WS_C_UIVERSUSBANNER: "Bannière de Versus UI",
  T_46_META_WS_C_UIWIDGET: "Widget UI",
  T_46_META_WS_C_UIWIDGETBUTTON: "Bouton de Widget UI",
  T_46_META_WS_C_UIWIDGETCONTAINER: "Conteneur de Widget UI",
  T_46_META_WS_C_UIWIDGETEMPTY: "Widget vide UI",
  T_46_META_WS_C_UIWIDGETIMAGE: "Image de widget UI",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "Label D'entrée Du Widget UI",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "Joystick de widget UI",
  T_46_META_WS_C_UIWIDGETLABEL: "Label UI Widget",
  T_46_META_WS_C_UIWIDGETLAYOUT: "Disposition du widget UI",
  T_46_META_WS_C_UIWIDGETPROFILE: "Profil de Widget UI",
  T_46_META_WS_C_UIWIDGETTEXTURE: "Texture de Widget UI",
  T_46_META_WS_C_UIWIDGETTOGGLE: "Basculement du widget UI",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "Pavé Tactile de Widget UI",
  T_46_META_WS_C_UIWINORLOSEBANNER: "Bannière de victoire ou défaite UI",
  T_46_META_WS_C_UNITSPAWN: "Unit Spawn",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Objet de logique de grimpe de fenêtre",
  T_46_META_WS_C_VECTOR2: "Vecteur2",
  T_46_META_WS_C_VECTOR3: "Vecteur3",
  T_46_META_WS_C_VEHICLE: "Véhicule",
  T_46_META_WS_C_VEHICLEIDTYPE: "Type d'ID de véhicule",
  T_46_META_WS_C_VEHICLESKINID: "ID de peau de véhicule",
  T_46_META_WS_C_VENDINGMACHINE: "Distributeur automatique",
  T_46_META_WS_C_VEST: "Gilet",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "Texture Remplaçable VFX",
  T_46_META_WS_C_VFXTEXTURE: "Texture VFX",
  T_46_META_WS_C_VISIBILITY: "Visibilité",
  T_46_META_WS_C_WALLET: "Portefeuille",
  T_46_META_WS_C_WALLETHUD: "UI de portefeuille",
  T_46_META_WS_C_WATERZONE: "Zone d'eau",
  T_46_META_WS_C_WAVECOUNTTYPE: "Wave Count Type",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Wave Interval Type",
  T_46_META_WS_C_WEAPON: "Weapon",
  T_46_META_WS_C_WEAPONGENERATOR: "Weapon Generator",
  T_46_META_WS_C_WEAPONSKINID: "ID de skin d'arme",
  T_46_META_WS_C_WEAPONTYPE: "Weapon Type",
  T_46_META_WS_C_WIDGETTYPE: "Type de widget",
  T_46_META_WS_C_ZIPLINE: "Tyrolienne",
  T_46_META_WS_CAMERADIRECTION: "Direction de la caméra",
  T_46_META_WS_CAMERAPOSITION: "Position de la caméra",
  T_46_META_WS_CAPSULECAST: "Détection de capsule",
  T_46_META_WS_CAPSULEOVERLAP: "Superposition de capsule",
  T_46_META_WS_CEIL: "Arrondir à l'Exposant",
  T_46_META_WS_CHATCHANNEL: "Canal de discussion",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Vérifier le Déclencheur par Ordre",
  T_46_META_WS_CLAMP: "Clamping",
  T_46_META_WS_CLEAR: "Vider",
  T_46_META_WS_CLEARALLCHILDREN: "Effacer tous les enfants",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "Effacer le suivi spécial AOI",
  T_46_META_WS_CLEARBACKPACK: "Vider le sac",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Effacer le facteur de propriété de formule",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Nettoyer les Objets de Niveau Résiduels",
  T_46_META_WS_CLIPNAME: "Nom du clip",
  T_46_META_WS_CLONE: "Cloner",
  T_46_META_WS_COLLIDEDENTITY: "Entité percutée",
  T_46_META_WS_COLORGET: "Obtenir la Couleur",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Compléter une Mission Personnalisée",
  T_46_META_WS_CONNECT: "Connecter",
  T_46_META_WS_CONSUMABLEID: "ID de l'objet",
  T_46_META_WS_CONTAIN: "Contient",
  T_46_META_WS_CONTAINKEY: "Vérifier l'Existence de la Clé",
  T_46_META_WS_COPYTOMORPH: "Copier dans la transformation",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Coût de l'argent",
  T_46_META_WS_COSTTOKEN: "Dépenser un Token",
  T_46_META_WS_CREATEAIRDROP: "Créer une caisse de largage",
  T_46_META_WS_CREATEBOT: "Créer un bot",
  T_46_META_WS_CREATEBUILTINUI: "Créer une UI Intégrée",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Créer une UI Intégrée",
  T_46_META_WS_CREATECAMERA: "Créer une caméra",
  T_46_META_WS_CREATECURVE: "Créer une courbe",
  T_46_META_WS_CREATECUSTOMUI: "Créer une UI Personnalisée",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Créer une UI Personnalisée",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Créer un widget UI personnalisé",
  T_46_META_WS_CREATEDAMAGENUM: "Créer un nombre de dégâts",
  T_46_META_WS_CREATEEFFECT: "Créer un effet",
  T_46_META_WS_CREATEEFFECTCLIENT: "Créer un effet",
  T_46_META_WS_CREATEFACTION: "Créer une faction",
  T_46_META_WS_CREATEFOLLOW: "Créer un suivi",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Créer relatif à soi-même pour chaque cadre",
  T_46_META_WS_CREATEFROMPREFAB: "Créer à partir d'un préfabriqué",
  T_46_META_WS_CREATELEVELOBJECT: "Créer un Objet de Niveau",
  T_46_META_WS_CREATELOOKAT: "Créer une cible",
  T_46_META_WS_CREATEMINIMAPICON: "Créer une icône de mini-carte",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Créer un pixel de mini-carte",
  T_46_META_WS_CREATEMONSTER: "Créer un monstre",
  T_46_META_WS_CREATEMORPH: "Créer une transformation",
  T_46_META_WS_CREATESELFRELATIVE: "Créer relatif à soi-même",
  T_46_META_WS_CREATESHOP: "Créer un magasin",
  T_46_META_WS_CREATESHOPITEM: "Créer un article",
  T_46_META_WS_CREATESHOPSHELF: "Créer une étagère de magasin",
  T_46_META_WS_CREATESOUND: "Créer un son",
  T_46_META_WS_CREATESOUNDCLIENT: "Créer un son",
  T_46_META_WS_CREATETOKENINSCENE: "Créer un Token dans la Scène",
  T_46_META_WS_CREATETRAJECTORY: "Créer une trajectoire",
  T_46_META_WS_CREATETWEEN: "Créer une interpolation",
  T_46_META_WS_CREATEWALLET: "Créer un portefeuille",
  T_46_META_WS_CROSS: "Produit Vectoriel",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "Nom de la colonne CSV en entier",
  T_46_META_WS_CURRENTAMMOCOUNT: "Compte actuel de munitions",
  T_46_META_WS_DAMAGE: "Dégâts",
  T_46_META_WS_DAMAGEDBODYPART: "Partie du corps endommagée",
  T_46_META_WS_DAMAGEDPLAYERS: "Joueurs endommagés",
  T_46_META_WS_DAMAGETYPE: "Type de dégâts",
  T_46_META_WS_DEALDAMAGE: "Infliger des Dégâts",
  T_46_META_WS_DELETE: "Supprimer",
  T_46_META_WS_DELETEAT: "Supprimer à la Position",
  T_46_META_WS_DELETECUSTOMUI: "Supprimer l'UI Personnalisée",
  T_46_META_WS_DELETEFROMDATABASE: "Supprimer de la base de données",
  T_46_META_WS_DELETEFROMDATASTORE: "Supprimer de la base de données",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Supprimer du tableau des leaders par clé",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Supprimer du tableau des leaders par rang",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Supprimer de la base de données du classement par clé",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Supprimer de la base de données du classement par rang",
  T_46_META_WS_DELETETAG: "Supprimer une étiquette",
  T_46_META_WS_DELTA: "Delta",
  T_46_META_WS_DESTROY: "Détruire",
  T_46_META_WS_DESTROYBOT: "Détruire un bot",
  T_46_META_WS_DESTROYBUILTINUI: "Détruire l'UI Intégrée",
  T_46_META_WS_DESTROYEQUIPMENT: "Détruire l'équipement",
  T_46_META_WS_DESTROYITEM: "Détruire l'Élément",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Direction en angle d'Euler",
  T_46_META_WS_DISABLESAFEZONE: "Désactiver la Zone de Sécurité",
  T_46_META_WS_DISPATCHEVENT: "Déclencher un événement",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Envoyer un événement avec la plateforme",
  T_46_META_WS_DISTANCE: "Distance",
  T_46_META_WS_DOT: "Produit Scalaire",
  T_46_META_WS_DROPITEM: "Lâcher l'objet",
  T_46_META_WS_DYEATAREA: "Teindre dans la zone",
  T_46_META_WS_DYEATPLANE: "Teindre sur le plan",
  T_46_META_WS_DYEATPOSITION: "Teindre à la position",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Zone de faible gravité",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "Acceleration",
  T_46_META_WS_E_ACTIONNODE: "NœudAction",
  T_46_META_WS_E_ACTIVE: "Active",
  T_46_META_WS_E_ACTIVESKILL: "Compétence Active",
  T_46_META_WS_E_ADBOARD: "Panneau publicitaire",
  T_46_META_WS_E_ADD: "Ajouter",
  T_46_META_WS_E_ADDFRIEND: "Ajouter Un Ami",
  T_46_META_WS_E_AGENCYFB: "FB de l'Agence",
  T_46_META_WS_E_AIM: "Viser",
  T_46_META_WS_E_AIR: "Air",
  T_46_META_WS_E_AIRCONDITIONERA: "Climatiseur",
  T_46_META_WS_E_AIRDROP: "Largage Aérien, Suicide de Zombie",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Vivant",
  T_46_META_WS_E_AMMO: "VFX De Balles",
  T_46_META_WS_E_AMPHIBIANCAR: "Véhicule amphibie",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Enfants Jouant",
  T_46_META_WS_E_AR: "Fusil",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "Munitions AR",
  T_46_META_WS_E_ARMAGAZINE: "Chargeur AR",
  T_46_META_WS_E_ARMOR: "Armure",
  T_46_META_WS_E_ARMORBUFF: "Armor Buff",
  T_46_META_WS_E_ARMORLV1: "Armure Lv1",
  T_46_META_WS_E_ARMORLV2: "Armure Lv2",
  T_46_META_WS_E_ARMORLV3: "Armure Lv3",
  T_46_META_WS_E_ARMORPIERCING: "Briser L'armure",
  T_46_META_WS_E_ARMORSPECIALIST: "Compétence 1",
  T_46_META_WS_E_ARROW: "Flèche",
  T_46_META_WS_E_ASC: "Ordre Croissant",
  T_46_META_WS_E_ASCIGNOREZERO: "Ordre Croissant Exclut les Zéros",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Explosion de Gaz",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Accessoire1 Pour Compatibilité",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Accessoire4 Pour Compatibilité",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Accessoire5 Pour Compatibilité",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Accessoire 6 Pour Compatibilité",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Accessoire8 Pour Compatibilité",
  T_46_META_WS_E_ATTACK: "Attaque",
  T_46_META_WS_E_ATTACKGRENADE: "Grenade D'attaque",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Automatique",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Retour",
  T_46_META_WS_E_BACKANDFORTH: "Aller-Retour",
  T_46_META_WS_E_BAG: "Sac à dos",
  T_46_META_WS_E_BAG1: "Sac1",
  T_46_META_WS_E_BAG2: "Sac2",
  T_46_META_WS_E_BAG3: "Sac3",
  T_46_META_WS_E_BAMBOOA: "Bamboo A",
  T_46_META_WS_E_BANANATREE: "Arbre à bananes",
  T_46_META_WS_E_BASEBALLPOLE: "Poteau De Baseball",
  T_46_META_WS_E_BASECOEFFICIENT: "Coefficient de base",
  T_46_META_WS_E_BASIC: "De base",
  T_46_META_WS_E_BASICCONE: "Conique de base",
  T_46_META_WS_E_BASICCYLINDER: "Cylindre de base",
  T_46_META_WS_E_BASICSPHERE: "Sphère de base",
  T_46_META_WS_E_BATTLEINSTYLE: "Bataille En Style",
  T_46_META_WS_E_BELL: "Cloche",
  T_46_META_WS_E_BENCH: "Banc",
  T_46_META_WS_E_BIGHEADHAMMER: "Marteau Fantaisie",
  T_46_META_WS_E_BILLBOARD: "Grand écran",
  T_46_META_WS_E_BIPOD: "Bipied",
  T_46_META_WS_E_BISGRAFFITIWALL: "Mur à thème BIS",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "VFX D'explosion De Trou Noir",
  T_46_META_WS_E_BLACKHOLEBOOM: "Effets visuels de boule de cristal",
  T_46_META_WS_E_BLAST: "Explosion",
  T_46_META_WS_E_BLOCK: "Carré",
  T_46_META_WS_E_BLOODBALL: "VFX De Trou Noir",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Bleu",
  T_46_META_WS_E_BLUEDOLL: "Poupée de glace",
  T_46_META_WS_E_BOARD: "Plateforme mobile",
  T_46_META_WS_E_BODY: "Corps",
  T_46_META_WS_E_BOMBINDICATION: "Alerte À La Bombe",
  T_46_META_WS_E_BOMBPLIERS: "Pinces À Bombe",
  T_46_META_WS_E_BONFIRE: "Bonfire Flamboyant",
  T_46_META_WS_E_BOOM: "Boom",
  T_46_META_WS_E_BOOYAH: "Victoire",
  T_46_META_WS_E_BOTH: "Les deux",
  T_46_META_WS_E_BOUNCETIRE: "Pneu",
  T_46_META_WS_E_BOWAMMO: "Munitions Arc",
  T_46_META_WS_E_BREAKABLEBOX: "Caisson en bois destructible",
  T_46_META_WS_E_BREAKABLECONTAINER: "Conteneur destructible",
  T_46_META_WS_E_BREAKABLEFENCE: "Clôture destructible",
  T_46_META_WS_E_BRICKA: "Brick A",
  T_46_META_WS_E_BRICKB: "Brick B",
  T_46_META_WS_E_BRICKC: "Brick C",
  T_46_META_WS_E_BRICKHOUSEA: "Petite maison A",
  T_46_META_WS_E_BRIGHT: "Clair",
  T_46_META_WS_E_BUBBLE: "Bubble",
  T_46_META_WS_E_BUFFGENERATOR: "Générateur de buff",
  T_46_META_WS_E_BULLETBUFF: "Bullet Buff",
  T_46_META_WS_E_BULLETHITTING: "Impact De Balle",
  T_46_META_WS_E_BUMPERCAR: "Auto-tamponneuse",
  T_46_META_WS_E_BUMPERCARFACTORY: "Fabricant de voiture à amortisseurs",
  T_46_META_WS_E_BURNING: "Dégâts De Brûlure Par Explosion De Véhicule",
  T_46_META_WS_E_BUSHES: "Buissons",
  T_46_META_WS_E_BUSSTOP: "Station de bus",
  T_46_META_WS_E_BUTTOM: "Usure Du Bas",
  T_46_META_WS_E_BUTTONWIDGET: "Widget bouton",
  T_46_META_WS_E_BYHIERARCHY: "Par hiérarchie",
  T_46_META_WS_E_CABINET: "Armoire",
  T_46_META_WS_E_CACTUS: "Cactus",
  T_46_META_WS_E_CAMOUFLAGE: "Compétence 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Déclencheur de capsule",
  T_46_META_WS_E_CARDIOTONIC: "Cardiotonique",
  T_46_META_WS_E_CASUALGAMEBGM: "BGM Jeu de Loisirs",
  T_46_META_WS_E_CEMENTA: "Cement A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "Canal A",
  T_46_META_WS_E_CHANNELB: "Canal B",
  T_46_META_WS_E_CHANNELC: "Canal C",
  T_46_META_WS_E_CHANNELD: "Canal D",
  T_46_META_WS_E_CHANNELE: "Canal E",
  T_46_META_WS_E_CHANNELF: "Canal F",
  T_46_META_WS_E_CHARACTERSKILL: "Compétence du Personnage",
  T_46_META_WS_E_CHARACTOR: "Personnage",
  T_46_META_WS_E_CHARGE: "Charge 1",
  T_46_META_WS_E_CHARGEBUSTER: "Chargeur Puissant",
  T_46_META_WS_E_CHECKPOINT: "Point de contrôle",
  T_46_META_WS_E_CHEER: "Applaudir",
  T_46_META_WS_E_CHERRYBLOSSOM: "Arbre de cerisier",
  T_46_META_WS_E_CIRCLE: "Circle",
  T_46_META_WS_E_CIRCLEBACK: "Boucle",
  T_46_META_WS_E_CIRCLEOFHEAT: "Barre de Pied",
  T_46_META_WS_E_CITY: "Ville",
  T_46_META_WS_E_CLAPS: "Claps",
  T_46_META_WS_E_CLEAR: "Clear",
  T_46_META_WS_E_CLIENT: "Client",
  T_46_META_WS_E_CLONE: "Changeur d’Apparence",
  T_46_META_WS_E_CLONEKILL: "Mort de Clone",
  T_46_META_WS_E_CLOSE: "Fermer",
  T_46_META_WS_E_CLOTHES: "Vêtements",
  T_46_META_WS_E_COINGENERATOR: "Générateur d'Or",
  T_46_META_WS_E_COLDAIR: "Brouillard",
  T_46_META_WS_E_COLORBLOCK: "Bloc teinté",
  T_46_META_WS_E_COLOROILBARREL: "Fût teinté",
  T_46_META_WS_E_COMBINEALL: "Combiner tout",
  T_46_META_WS_E_COMBINESELF: "Combiner soi-même",
  T_46_META_WS_E_COMBOKEYA1: "Notes de musique - Synthétiseur A",
  T_46_META_WS_E_COMBOKEYA2: "Notes de musique - Synthétiseur A",
  T_46_META_WS_E_COMBOKEYB1: "Notes de musique - Synthétiseur B",
  T_46_META_WS_E_COMBOKEYB2: "Notes de musique - Synthétiseur B",
  T_46_META_WS_E_COMBOKEYC1: "Notes de musique - Synthétiseur C",
  T_46_META_WS_E_COMBOKEYC2: "Notes de musique - Synthétiseur C",
  T_46_META_WS_E_CONCRETEPILLAR: "Pilier en béton",
  T_46_META_WS_E_CONDITIONNODE: "NœudCondition",
  T_46_META_WS_E_CONTAINERA: "Container A",
  T_46_META_WS_E_CONTAINERB: "Conteneur B",
  T_46_META_WS_E_CONTAINERC: "Conteneur C",
  T_46_META_WS_E_CONTAINERWIDGET: "Widget conteneur",
  T_46_META_WS_E_CONTINUOUS: "Continu",
  T_46_META_WS_E_COUNTDOWN: "Compte à rebours",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Compte à Rebours",
  T_46_META_WS_E_COUNTDOWNDIDI: "Beep Du Compte À Rebours",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Compte à Rebours",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Compte à Rebours 3",
  T_46_META_WS_E_CROSS: "Croix",
  T_46_META_WS_E_CROSSBOW: "Arbalète",
  T_46_META_WS_E_CROSSHAIR: "Réticule",
  T_46_META_WS_E_CROSSHAIRS: "Réticule",
  T_46_META_WS_E_CROUCH: "S'accroupir",
  T_46_META_WS_E_CROUCHING: "Accroupi",
  T_46_META_WS_E_CROWCAW: "Croassement de Corbeau",
  T_46_META_WS_E_CROWN: "Couronne",
  T_46_META_WS_E_CUBE: "Mécanisme de bloc",
  T_46_META_WS_E_CURSE: "Talisman",
  T_46_META_WS_E_CURSEEXPLOSION: "Explosion de Talisman",
  T_46_META_WS_E_CUSTOM: "Personnalisé",
  T_46_META_WS_E_CUSTOMTRIGGER: "Déclencheur personnalisé",
  T_46_META_WS_E_CUSTOMWATERZONE: "Corps d'eau personnalisé",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Brûlage en Boucle",
  T_46_META_WS_E_CYLIC: "Cyclique",
  T_46_META_WS_E_DAGGER: "Couteau de lancer",
  T_46_META_WS_E_DAMAGEDTRUCK: "Camion endommagé",
  T_46_META_WS_E_DAMAGEZONE: "Zone De Dégâts",
  T_46_META_WS_E_DANGERALARM: "Danger 2",
  T_46_META_WS_E_DANGERVIBRATING: "Danger 1",
  T_46_META_WS_E_DARK: "Sombre",
  T_46_META_WS_E_DARKNESS: "Darkness",
  T_46_META_WS_E_DASHATTACK: "Attaque Rapide",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Limite De Stockage Des Données Dépassée",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Erreur De Paramètre De Stockage Des Données",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Expiration du délai de stockage des données",
  T_46_META_WS_E_DATETIME: "Date et Heure",
  T_46_META_WS_E_DAY: "Jour",
  T_46_META_WS_E_DEAD: "Mort",
  T_46_META_WS_E_DEATH: "Mort",
  T_46_META_WS_E_DEFAULT: "Par défaut",
  T_46_META_WS_E_DEFAULTFIST: "Poing",
  T_46_META_WS_E_DEFENCEGRENADE: "Grenade de défense",
  T_46_META_WS_E_DESC: "Ordre Décroissant",
  T_46_META_WS_E_DIALOGUE: "Dialogue",
  T_46_META_WS_E_DIAMOND: "Diamant",
  T_46_META_WS_E_DIRECTIONSIGN: "Signe",
  T_46_META_WS_E_DIRVEVEHICLE: "Conduire le véhicule",
  T_46_META_WS_E_DISABLE: "Désactiver",
  T_46_META_WS_E_DISABLED: "Désactivé",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Indice de disparition",
  T_46_META_WS_E_DISCONNECT: "Déconnexion",
  T_46_META_WS_E_DISGUISE: "Cloner",
  T_46_META_WS_E_DOGHOUSE: "Maison pour chien",
  T_46_META_WS_E_DOOR: "Porte",
  T_46_META_WS_E_DOUBLE: "Double",
  T_46_META_WS_E_DOUBLEDOOR: "Double porte",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "Chaussure De Double Saut",
  T_46_META_WS_E_DOUBLEMAGEZINE: "Chargeur double",
  T_46_META_WS_E_DRAW: "Égalité",
  T_46_META_WS_E_DRILLZOMBIE: "Zombie De Forage",
  T_46_META_WS_E_DRIVE: "Conduire",
  T_46_META_WS_E_DRIVER: "Conducteur",
  T_46_META_WS_E_DROPBEAT: "Compétence 4",
  T_46_META_WS_E_DRUMKEY1: "Notes de musique - Batterie",
  T_46_META_WS_E_DRUMKEY2: "Notes de musique - Batterie",
  T_46_META_WS_E_DUEL: "Bataille",
  T_46_META_WS_E_DUMMY: "Mannequin",
  T_46_META_WS_E_DUMMYGRENADE: "Grenade Factice",
  T_46_META_WS_E_DUMP: "Décharge",
  T_46_META_WS_E_DUSK: "Crépuscule",
  T_46_META_WS_E_DUST: "Fumée et Poussière",
  T_46_META_WS_E_DYNAMIC: "Dynamique",
  T_46_META_WS_E_E: "Constante naturelle",
  T_46_META_WS_E_EAGLE: "AIGLE",
  T_46_META_WS_E_EASY: "Facile",
  T_46_META_WS_E_ELECTRICSHOCK: "Choc Électrique",
  T_46_META_WS_E_ELECTRICSURFBOARD: "Surfboard Électrique",
  T_46_META_WS_E_ELECTRICZONE: "Zone Électrique",
  T_46_META_WS_E_ELECTRONICBGM: "BGM Fantaisie Électronique Mignonne",
  T_46_META_WS_E_ELIMINATEDBOSS: "Révocation du Leader de Guilde",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Indice de Tuer",
  T_46_META_WS_E_EMOTE: "Émote",
  T_46_META_WS_E_ENABLE: "Activer",
  T_46_META_WS_E_ENERGETIC: "Énergique",
  T_46_META_WS_E_ENTERVEHICLE: "Entrer dans le véhicule",
  T_46_META_WS_E_EP: "EP",
  T_46_META_WS_E_EXCLAMATIONMARK: "Point d'exclamation",
  T_46_META_WS_E_EXIT: "Quitter",
  T_46_META_WS_E_EXITVEHICLE: "Sortir Du Véhicule",
  T_46_META_WS_E_EXPLODE: "Auto-destruction",
  T_46_META_WS_E_EXPLOSION: "VFX d’Explosion",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Flammes d’Explosion",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Compétence Orbe d'Énergie",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Zombie Explosif",
  T_46_META_WS_E_EYE: "Lunettes",
  T_46_META_WS_E_FACEPAINT: "Peinture De Visage",
  T_46_META_WS_E_FACTION: "Faction",
  T_46_META_WS_E_FALLING: "Chute",
  T_46_META_WS_E_FALLINGSTAR: "Obtenir Consommable",
  T_46_META_WS_E_FALSE: "Non",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Mécanisme à hélice",
  T_46_META_WS_E_FAR: "Loin",
  T_46_META_WS_E_FEATHER: "Feather",
  T_46_META_WS_E_FEMALE: "Féminin",
  T_46_META_WS_E_FENCE: "Clôture",
  T_46_META_WS_E_FGL24: "FGL-24",
  T_46_META_WS_E_FIGHTINGENTITY: "EntitéDeCombat",
  T_46_META_WS_E_FILLED: "Rempli",
  T_46_META_WS_E_FINISH: "Terminer",
  T_46_META_WS_E_FINISHINGPOINT: "Point de fin",
  T_46_META_WS_E_FINISHLINEARCH: "Bannière d'arrivée",
  T_46_META_WS_E_FIRE: "Fire",
  T_46_META_WS_E_FIRECHARGE: "Boule de Feu",
  T_46_META_WS_E_FIREWORK: "Feux d’Artifice",
  T_46_META_WS_E_FIRINGEFFECT: "VFX de Tir",
  T_46_META_WS_E_FIRSTPERSON: "Première-Personne",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "Classique En Première Personne",
  T_46_META_WS_E_FIST: "Poing",
  T_46_META_WS_E_FIT: "Ajusté",
  T_46_META_WS_E_FLAG: "Drapeau",
  T_46_META_WS_E_FLAME: "Feu",
  T_46_META_WS_E_FLAMEGUN: "Pistolet À Flamme",
  T_46_META_WS_E_FLAMETHROWER: "Lance-Flammes",
  T_46_META_WS_E_FLASH: "Grenade aveuglante",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "Fumée de Grenade Éclairante",
  T_46_META_WS_E_FLASHFREEZE: "Congélation",
  T_46_META_WS_E_FLEXWALL: "Mur rétractable",
  T_46_META_WS_E_FLICKER: "Clignotement",
  T_46_META_WS_E_FLOWER: "Flower",
  T_46_META_WS_E_FLYBOMBBEE: "Abeille bombe volante",
  T_46_META_WS_E_FLYPAN: "Mécanisme de poêle",
  T_46_META_WS_E_FLYSHOE: "Chaussures volantes",
  T_46_META_WS_E_FOLDER: "Dossier",
  T_46_META_WS_E_FOLDWINGS: "Ailes Pliantes",
  T_46_META_WS_E_FOODTRUCK: "Camion de nourriture",
  T_46_META_WS_E_FOODTRUCKB: "Camion de Nourriture B",
  T_46_META_WS_E_FOOTBALL: "Football",
  T_46_META_WS_E_FOOTBALLGUN: "Pistolet de football",
  T_46_META_WS_E_FOOTBALLICE: "Glace de Football",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Tireur de football",
  T_46_META_WS_E_FORCE: "Force",
  T_46_META_WS_E_FOREGRIP_MR: "Poignée Avant_MR",
  T_46_META_WS_E_FOREGRIP1: "Poignée avant1",
  T_46_META_WS_E_FOREGRIP2: "Poignée avant2",
  T_46_META_WS_E_FOREGRIP3: "Poignée avant3",
  T_46_META_WS_E_FORWARD: "En avant",
  T_46_META_WS_E_FOUNTAIN: "Fontaine",
  T_46_META_WS_E_FREE: "Gratuit",
  T_46_META_WS_E_FREEZEALL: "Gel Tout",
  T_46_META_WS_E_FREEZEPOSITION: "Gel de Position",
  T_46_META_WS_E_FREEZEPOSITIONX: "Gel de Position X",
  T_46_META_WS_E_FREEZEPOSITIONY: "Gel de Position Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Gel de Position Z",
  T_46_META_WS_E_FREEZEROTATION: "Gel de Rotation",
  T_46_META_WS_E_FREEZEROTATIONX: "Gel de Rotation X",
  T_46_META_WS_E_FREEZEROTATIONY: "Gel de Rotation Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "Gel de Rotation Z",
  T_46_META_WS_E_FREEZEZONE: "Zone Gelée",
  "T_46_META_WS_E_FROST GALAXY": "Galaxie Gelée",
  T_46_META_WS_E_FROZEN: "Congélation",
  T_46_META_WS_E_FROZENGRENADE: "Grenade Gelante",
  T_46_META_WS_E_FUNCTIONALITEMS: "Objets Fonctionnels",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Jeu",
  T_46_META_WS_E_GAMEOVER: "Fin de Jeu 2",
  T_46_META_WS_E_GAMESTART: "Début du Jeu",
  T_46_META_WS_E_GARAGE: "Garage",
  T_46_META_WS_E_GATLING: "Rotatif",
  T_46_META_WS_E_GEARSWITCHEDON: "Mécanisme Activé",
  T_46_META_WS_E_GENTLETAP: "Tapotement Léger",
  T_46_META_WS_E_GETITEM: "Obtenir Consommable 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Ghost",
  T_46_META_WS_E_GIANTDICE: "Dé",
  T_46_META_WS_E_GIANTLOLLIPOP: "Grande sucette",
  T_46_META_WS_E_GIFT: "Cadeau",
  T_46_META_WS_E_GLOOWALL: "Mur de gel",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "Groza D'or",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ Pourl'infection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "Parterre de fleurs à thème BIS",
  T_46_META_WS_E_GRAFFITIWALL: "Mur de graffiti",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Pistolet à Crochet",
  T_46_META_WS_E_GREATCONDUCTOR: "Grand Conducteur",
  T_46_META_WS_E_GREEN: "Vert",
  T_46_META_WS_E_GRENADE: "Grenade",
  T_46_META_WS_E_GRID: "Grille",
  T_46_META_WS_E_GROZA: "Groza",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Tour de guet",
  T_46_META_WS_E_GUILD: "Guilde",
  T_46_META_WS_E_GUN: "Arme",
  T_46_META_WS_E_GUNFIRE: "Gunfire",
  T_46_META_WS_E_HALO: "Aura",
  T_46_META_WS_E_HAMMER: "Mécanisme du marteau géant",
  T_46_META_WS_E_HANDCANNON: "Canon à Main",
  T_46_META_WS_E_HANGER: "Séchoir",
  T_46_META_WS_E_HARD: "Difficile",
  T_46_META_WS_E_HATTRICK: "Compétence 8",
  T_46_META_WS_E_HAYSTACK: "Meule de foin",
  T_46_META_WS_E_HEAD: "Coiffure",
  T_46_META_WS_E_HEADSHOOT: "Tir à la tête",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "Pistolet de Guérison_X",
  T_46_META_WS_E_HEALPISTOL: "Arme de Guérison",
  T_46_META_WS_E_HEART: "Cœur",
  T_46_META_WS_E_HEARTBEAT: "Battement de cœur",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "Arme lourde",
  T_46_META_WS_E_HELL: "Très dur",
  T_46_META_WS_E_HELMET: "Casque",
  T_46_META_WS_E_HELMET1: "Casque1",
  T_46_META_WS_E_HELMET2: "Casque2",
  T_46_META_WS_E_HELMET3: "Casque3",
  T_46_META_WS_E_HEXAGON: "Hexagone",
  T_46_META_WS_E_HGAMMO: "Munitions HG",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Lance-Flammes Cache-Cache",
  T_46_META_WS_E_HIDERKILL: "Cacheur Éliminé",
  T_46_META_WS_E_HIHATS: "Hihats",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Coup Sourd",
  T_46_META_WS_E_HITEFFECT: "VFX d'Impact de Balles",
  T_46_META_WS_E_HITFEEDBACK: "Retour d’Information de Tir",
  T_46_META_WS_E_HOOK: "Crochet",
  T_46_META_WS_E_HOOKGUN: "Pistolet À Crochet",
  T_46_META_WS_E_HOOKGUNAMMO: "Crochet",
  T_46_META_WS_E_HORIZALINE: "Horizon",
  T_46_META_WS_E_HORIZONTAL: "Horizontal",
  T_46_META_WS_E_HORN: "Haut-Parleur",
  T_46_META_WS_E_HORROR: "Horreur",
  T_46_META_WS_E_HOURGLASS: "Sabliers",
  T_46_META_WS_E_HOUSE: "Maison",
  T_46_META_WS_E_HOUSEA: "Maison de plain-pied",
  T_46_META_WS_E_HOUSEB: "Maison à deux étages",
  T_46_META_WS_E_HOUSEC: "Maison à trois étages",
  T_46_META_WS_E_HP: "HP",
  T_46_META_WS_E_HPBUFF: "HP Buff",
  T_46_META_WS_E_HUT: "Cabine",
  T_46_META_WS_E_ICEA: "Ice A",
  T_46_META_WS_E_ICEGUN: "Pistolet de Glace",
  T_46_META_WS_E_ICEWALLMAKER: "Fabricant de mur de glace",
  T_46_META_WS_E_ICONOBJECT: "Icône",
  T_46_META_WS_E_IMAGEWIDGET: "Widget image",
  T_46_META_WS_E_IMPULSE: "Impulse",
  T_46_META_WS_E_INHALER: "Inhalateur",
  T_46_META_WS_E_INJUREDFEMALE: "Femme criant sur un coup",
  T_46_META_WS_E_INJUREDMALE: "Homme criant sur coup",
  T_46_META_WS_E_INK: "VFX d’Encre",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Widget d’étiquette de saisie",
  T_46_META_WS_E_INSECTCHIRPING: "Bourdonnement des Insectes",
  T_46_META_WS_E_INTERVAL10SECONDS: "10s",
  T_46_META_WS_E_INTERVAL15SECONDS: "15s",
  T_46_META_WS_E_INTERVAL30SECONDS: "30s",
  T_46_META_WS_E_INTERVAL3SECONDS: "3s",
  T_46_META_WS_E_INTERVAL5SECONDS: "5s",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999s",
  T_46_META_WS_E_INVISIBLE: "Invisible",
  T_46_META_WS_E_IPIPE: "Tuyau I",
  T_46_META_WS_E_IRONFENCE: "Clôture",
  T_46_META_WS_E_IRONFENCEB: "Clôture B",
  T_46_META_WS_E_IRONPLATFORM: "Plateforme en fer",
  T_46_META_WS_E_ITEMENTITY: "Générateur de consommables",
  T_46_META_WS_E_JEEP: "Jeep",
  T_46_META_WS_E_JERRYCAN: "Fût de pétrole",
  T_46_META_WS_E_JERSEYMACHINE: "Machine à maillot",
  T_46_META_WS_E_JOINEDGAMEDULL: "Rejoindre la Bataille",
  T_46_META_WS_E_JOINGAME: "Rejoindre le Jeu",
  T_46_META_WS_E_JOYSTICKWIDGET: "Widget joystick",
  T_46_META_WS_E_JUMP: "Saut",
  T_46_META_WS_E_JUMPATTACK: "Attaque sautante",
  T_46_META_WS_E_JUSTPATROL: "Patrouille Simple",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "Clé",
  T_46_META_WS_E_KICK: "Kick",
  T_46_META_WS_E_KILLINGTIPS: "Conseils de mise à mort",
  T_46_META_WS_E_KILLZONE: "Zone de Mort",
  T_46_META_WS_E_KINEMATIC: "Cinématique",
  T_46_META_WS_E_KNIFE: "Couteau",
  T_46_META_WS_E_KNOCKDOWN: "À terre",
  T_46_META_WS_E_KNOCKEDDOWN: "Abattu",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "Widget d’étiquette",
  T_46_META_WS_E_LANDINGA: "Palier de l'escalier A",
  T_46_META_WS_E_LANDINGB: "Palier de l'escalier B",
  T_46_META_WS_E_LANDINGC: "Palier de l'escalier C",
  T_46_META_WS_E_LANDMINE: "Mine",
  T_46_META_WS_E_LANUNCHERAMMO: "Munitions De Lanceur",
  T_46_META_WS_E_LASER: "VFX Laser",
  T_46_META_WS_E_LASERSKILL: "Compétence Laser",
  T_46_META_WS_E_LATTICESCREEN: "Écran",
  T_46_META_WS_E_LAWNA: "Lawn A",
  T_46_META_WS_E_LAWNB: "Lawn B",
  T_46_META_WS_E_LAYOUTWIDGET: "Widget de mise en page",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Bois mort",
  T_46_META_WS_E_LEVELMAXED: "Niveau Max.",
  T_46_META_WS_E_LEVELUP: "Monter en Classement",
  T_46_META_WS_E_LEVELUPDISCARDED: "Monter en Classement",
  T_46_META_WS_E_LIGHTBEAM: "Faisceau Lumineux",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Faisceau de Lumière",
  T_46_META_WS_E_LIGHTEFFECT: "Effet Lumineux",
  T_46_META_WS_E_LIGHTNING: "Lightning",
  T_46_META_WS_E_LIMB: "Membre",
  T_46_META_WS_E_LINE: "Line",
  T_46_META_WS_E_LIQUID: "Liquid",
  T_46_META_WS_E_LOCAL: "Local",
  T_46_META_WS_E_LOCALPOSITION: "Position Locale",
  T_46_META_WS_E_LOCK: "Verrouiller",
  T_46_META_WS_E_LONGBOX: "Caisse en bois longue",
  T_46_META_WS_E_LOOP: "Boucle",
  T_46_META_WS_E_LOOTITEMBOX: "Arme de butin",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Munitions de butin",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Armure de butin",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Consommable de butin",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Objet jetable de butin",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Lunette de butin",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "Grenade glacée",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Butin de football aléatoire",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Bouclier de football",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Butin d'arme aléatoire",
  T_46_META_WS_E_LOSE: "Défaite",
  T_46_META_WS_E_LOUDSPEAKER: "Haut-parleur",
  T_46_META_WS_E_LOWFALLING: "Chute Faible",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "Grenade M79",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "Grenade Spécialisée M79",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Parang",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Chargeur1",
  T_46_META_WS_E_MAGEZINE2: "Chargeur2",
  T_46_META_WS_E_MAGEZINE3: "Chargeur3",
  T_46_META_WS_E_MAGMAA: "Magma A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Loupe",
  T_46_META_WS_E_MALE: "Masculin",
  T_46_META_WS_E_MARK: "Marque",
  T_46_META_WS_E_MARKER: "Marque",
  T_46_META_WS_E_MASK: "Peinture De Visage",
  T_46_META_WS_E_MAXVALUE: "Valeur max",
  T_46_META_WS_E_MECHANICAL: "Clignotement Rapide 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Écho du Dispositif Mécanique",
  T_46_META_WS_E_MEDICALPROPS: "Articles Médicaux",
  T_46_META_WS_E_MEDICALTENT: "Tente médicale",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Battement de Cœur Moyen",
  T_46_META_WS_E_MEDKIT: "Kit de soins",
  T_46_META_WS_E_MELEE: "Arme de mêlée",
  T_46_META_WS_E_MELEEWEAPONS: "Arme De Mêlée",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Microphone",
  T_46_META_WS_E_MIDDLE: "Milieu",
  T_46_META_WS_E_MINIHANDLE: "Mini-Poignée",
  T_46_META_WS_E_MINIMAP: "Mini-Carte",
  T_46_META_WS_E_MINISENTRY: "Mini sentinelle",
  T_46_META_WS_E_MINVALUE: "Valeur min",
  T_46_META_WS_E_MISSILEEXPLODE: "Arme de Type Missile",
  T_46_META_WS_E_MISSIONCOMPLETE: "Succès de Mission 1",
  T_46_META_WS_E_MISTAKE: "Erreur",
  T_46_META_WS_E_MODERATE: "Modéré",
  T_46_META_WS_E_MONEY: "Argent",
  T_46_META_WS_E_MONSTER: "Zombie",
  T_46_META_WS_E_MONSTERSPAWN: "Point D'apparition Du Monstre",
  T_46_META_WS_E_MONSTERTRUCK: "Monster Truck",
  T_46_META_WS_E_MOON: "Lune",
  T_46_META_WS_E_MOSQUITO: "Moustique",
  T_46_META_WS_E_MOTIONTRAIL: "Extrémité Arrière",
  T_46_META_WS_E_MOTOBIKE: "Moto",
  T_46_META_WS_E_MOTORBIKE: "Moto",
  T_46_META_WS_E_MOVE: "Déplacer",
  T_46_META_WS_E_MOVEMENT: "Déplacer",
  T_46_META_WS_E_MOVINGJOYSTICK: "Joystick Mobile",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "MrV",
  T_46_META_WS_E_MULTIPLIER: "Multiplicateur",
  T_46_META_WS_E_MULTIPLY: "Multiplier",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Multiplier et accumuler",
  T_46_META_WS_E_MUSHROOM1: "Champignon 1",
  T_46_META_WS_E_MUSHROOM2: "Champignon2",
  T_46_META_WS_E_MUSHROOM3: "Champignon3",
  T_46_META_WS_E_MUSHROOM4: "Champignon4",
  T_46_META_WS_E_MUSHSHADE: "Groupe de champignons géants",
  T_46_META_WS_E_MUSIC: "Musique",
  T_46_META_WS_E_MUZZLE1: "Bouche 1",
  T_46_META_WS_E_MUZZLE2: "Bouche 2",
  T_46_META_WS_E_MUZZLE3: "Bouche 3",
  T_46_META_WS_E_NEAR: "Près",
  T_46_META_WS_E_NIGHT: "Nuit",
  T_46_META_WS_E_NOATTACK: "Pas D'attaque",
  T_46_META_WS_E_NODUALWIELDING: "Pas d'Akimbo",
  T_46_META_WS_E_NOERROR: "Pas d'Erreur",
  T_46_META_WS_E_NONE: "Aucun",
  T_46_META_WS_E_NORMAL: "Normal",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "Ne Pas Passer l’Abattu",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Compétence 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Obtenir Or Moyen",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Obtenir Or Gros",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Obtenir Or Petit",
  T_46_META_WS_E_OILDRUMEXPLODE: "Explosion de Fût d’Huile",
  T_46_META_WS_E_ONCE: "Une fois",
  T_46_META_WS_E_ONEWAY: "Une Voie",
  T_46_META_WS_E_OPENFOLDER: "Dossier ouvert",
  T_46_META_WS_E_OPENHIHATS: "OpenHihats",
  T_46_META_WS_E_OPENINGBOX: "Boîte Ouverte",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Approvisionnement de Guilde",
  T_46_META_WS_E_OPENINGWARCHEST: "Sauver Entrepôt",
  T_46_META_WS_E_ORANGE: "Orange",
  T_46_META_WS_E_ORTHOGONAL: "Orthogonal",
  T_46_META_WS_E_OUTPOST: "Poste de garde",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Mur peint",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Bassin De Compétence Cramoisi",
  T_46_META_WS_E_PALM: "Papier",
  T_46_META_WS_E_PANEL: "Panneau",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Passager A",
  T_46_META_WS_E_PASSENGERB: "Passager B",
  T_46_META_WS_E_PASSENGERC: "Passager C",
  T_46_META_WS_E_PASSIVE: "Passive",
  T_46_META_WS_E_PASSIVESKILL: "Compétence Passive",
  T_46_META_WS_E_PATROLWHILEATTACK: "Patrouille Pendant L'attaque",
  T_46_META_WS_E_PERSONALUAV: "Drone Personnel",
  T_46_META_WS_E_PERSPECTIVE: "Perspective",
  T_46_META_WS_E_PETTABBG: "Animal",
  T_46_META_WS_E_PHASESTART: "Début de Phase",
  T_46_META_WS_E_PHONEBOOTH: "Cabine téléphonique",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Notes de musique - Piano",
  T_46_META_WS_E_PIANOKEY2: "Notes de musique - Piano",
  T_46_META_WS_E_PICKUPS: "Pickups",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "Colonne en béton",
  T_46_META_WS_E_PIN: "Appel",
  T_46_META_WS_E_PINGPONG: "Ping-pong",
  T_46_META_WS_E_PIPECORNER: "Tuyau coude",
  T_46_META_WS_E_PIPEINTERSECTION: "Tuyau croisé",
  T_46_META_WS_E_PISTOL: "Pistolet",
  T_46_META_WS_E_PISTOLAMMO: "Munitions De Pistolet",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Bloc de parc d'attractions à carreaux",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Joueur",
  T_46_META_WS_E_PLUS: "Plus",
  T_46_META_WS_E_PODIUM: "Podium",
  T_46_META_WS_E_POISONGAS: "Gaz Toxique",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Gaz Toxique",
  T_46_META_WS_E_PORTAL: "Portail",
  T_46_META_WS_E_POSTACCUMULATOR: "Accumulateur post",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "Battement de Cœur Rapide",
  T_46_META_WS_E_PREACCUMULATOR: "Accumulateur pré",
  T_46_META_WS_E_PRIMARYWEAPONA: "Arme Principale A",
  T_46_META_WS_E_PRIMARYWEAPONB: "Arme principale B",
  T_46_META_WS_E_PRIOREXPLOSION: "Avant L'explosion De La Bombe",
  T_46_META_WS_E_PROFILEWIDGET: "Widget profil",
  T_46_META_WS_E_PRONE: "Allongé",
  T_46_META_WS_E_PUMPKIN: "Citrouille",
  T_46_META_WS_E_PURPLE: "Violet",
  T_46_META_WS_E_QUADRILATERAL: "Quadrilatère",
  T_46_META_WS_E_QUESTIONMARK: "Point d'interrogation",
  T_46_META_WS_E_QUICKCHAT: "Discussion rapide",
  T_46_META_WS_E_QUICKCHATSHOW: "Affichage De La Discussion Rapide",
  T_46_META_WS_E_RADIAL180: "Radial 180°",
  T_46_META_WS_E_RADIAL360: "Radial 360°",
  T_46_META_WS_E_RADIAL90: "Radial 90°",
  T_46_META_WS_E_RAMPAGE: "Carnage",
  T_46_META_WS_E_RANDOM: "Aléatoire",
  T_46_META_WS_E_RANDOMBUFF: "Random Buff",
  T_46_META_WS_E_RANKDOWN: "Baisse Du Classement",
  T_46_META_WS_E_REACTION: "Répondre",
  T_46_META_WS_E_RECOVER: "Récupération",
  T_46_META_WS_E_RECYCLE: "Recyclage",
  T_46_META_WS_E_RED: "Rouge",
  T_46_META_WS_E_REFINERYTANK: "Pot d'eau",
  T_46_META_WS_E_REFLECTIVECUBE: "Bloc de couleur unie réfléchissant 1",
  T_46_META_WS_E_REFRESH: "Actualiser",
  T_46_META_WS_E_RELEASINGSKILL: "VFX de Lancement de Compétence",
  T_46_META_WS_E_RELOAD: "Recharger",
  T_46_META_WS_E_REMINDER: "Rappel",
  T_46_META_WS_E_REPAIR: "Réparation",
  T_46_META_WS_E_REPAIREQUIP: "Réparer L'équipement",
  T_46_META_WS_E_REPAIRKIT: "Kit de réparation",
  T_46_META_WS_E_REPLACER: "Remplaçant",
  T_46_META_WS_E_REPORT: "Signaler",
  T_46_META_WS_E_REST: "Repos",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Rides",
  T_46_META_WS_E_RIDICULE: "Ridicule",
  T_46_META_WS_E_RIDICULEFUNNY: "Ridicule Amusant",
  T_46_META_WS_E_RIFLE: "Fusil",
  T_46_META_WS_E_RIFLEAMMO: "Munitions de Fusil",
  T_46_META_WS_E_RIGHT: "Droit",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Trapèze À Angle Droit",
  T_46_META_WS_E_RING: "Mécanisme de bague",
  T_46_META_WS_E_RINGPREDISCARDED: "Anneau",
  T_46_META_WS_E_RIPTIDERHYTHM: "Compétence 9",
  T_46_META_WS_E_RISINGPARTICLE: "Particules Montantes",
  T_46_META_WS_E_ROADBLOCK: "Barricade",
  T_46_META_WS_E_ROTATE: "Rotation",
  T_46_META_WS_E_RUNNING: "En cours",
  T_46_META_WS_E_RUSHTIME: "Carnage",
  T_46_META_WS_E_SAMURAI: "Samouraï",
  T_46_META_WS_E_SANDA: "Sand A",
  T_46_META_WS_E_SANDSTRUCTURE: "Sculpture de sable",
  T_46_META_WS_E_SCALE: "Échelle",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Épouvantail",
  T_46_META_WS_E_SCISSORS: "Ciseaux",
  T_46_META_WS_E_SCOPE2X: "Lunette 2x",
  T_46_META_WS_E_SCOPE4X: "Lunette 4x",
  T_46_META_WS_E_SCROLLPANEL: "Panneau défilant",
  T_46_META_WS_E_SECONDARYWEAPON: "Arme Secondaire",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Compétence 10",
  T_46_META_WS_E_SERVER: "Serveur",
  T_46_META_WS_E_SET: "Combinaison",
  T_46_META_WS_E_SETTING: "Paramètres",
  T_46_META_WS_E_SETTINGS: "Paramètres",
  T_46_META_WS_E_SG: "Shotgun",
  T_46_META_WS_E_SGAMMO: "Munitions SN",
  T_46_META_WS_E_SHARPMECHANICAL: "Clignotement Rapide 1",
  T_46_META_WS_E_SHIELD: "Défense",
  T_46_META_WS_E_SHIELDBROKEN: "Bouclier Brisé",
  T_46_META_WS_E_SHIELDGUN: "Pistolet À Bouclier",
  T_46_META_WS_E_SHIELDUP: "Levée De Bouclier",
  T_46_META_WS_E_SHOCKWAVE: "Onde De Choc",
  T_46_META_WS_E_SHOES: "Chaussures",
  T_46_META_WS_E_SHOOTINGTARGET: "Cible mobile",
  T_46_META_WS_E_SHORTDATE: "Date courte",
  T_46_META_WS_E_SHORTDATETIME: "Date et Heure Courtes",
  T_46_META_WS_E_SHORTTIME: "Courte durée",
  T_46_META_WS_E_SHOTGUN: "Shotgun",
  T_46_META_WS_E_SHOTGUNAMMO: "Munitions De Shotgun",
  T_46_META_WS_E_SHOTGUNMUZZLE: "Bouche de Shotgun",
  T_46_META_WS_E_SHOW: "Afficher",
  T_46_META_WS_E_SHRUB: "Caisse en bois longue couverte de buissons",
  T_46_META_WS_E_SICKLE: "Faux",
  T_46_META_WS_E_SIDESCROLLING: "Défilement latéral",
  T_46_META_WS_E_SIGNAL: "Signal",
  T_46_META_WS_E_SIGNOUT: "Quitter",
  T_46_META_WS_E_SILENCER: "Silencieux",
  T_46_META_WS_E_SIMPLE: "Simple",
  T_46_META_WS_E_SIMPLEWIDGET: "Widget simple",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "Arabe Simplifié",
  T_46_META_WS_E_SINGLE: "Unique",
  T_46_META_WS_E_SITEHUT: "Maison conteneur",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Chargement de Compétence Complet",
  T_46_META_WS_E_SKILLRECOVER: "Récupération de Compétence",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Passer l’Abattu",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "Découpé",
  T_46_META_WS_E_SLOPE: "Pente",
  T_46_META_WS_E_SLOWHEARTBEAT: "Battement de Cœur Lent",
  T_46_META_WS_E_SMG: "SMG",
  T_46_META_WS_E_SMGAMMO: "Munitions SMG",
  T_46_META_WS_E_SMGMUZZLE: "Bouche SMG",
  T_46_META_WS_E_SMILEY: "Visage souriant",
  T_46_META_WS_E_SMOKE: "Fumée",
  T_46_META_WS_E_SMOKEGRENADE: "Grenade fumigène",
  T_46_META_WS_E_SMOKEY: "Fumée",
  T_46_META_WS_E_SMOOTH: "Fluide",
  T_46_META_WS_E_SNAMMO: "Munitions SN",
  T_46_META_WS_E_SNARES: "Snares",
  T_46_META_WS_E_SNEAKERS: "Effet des Chaussures de Course",
  T_46_META_WS_E_SNIPER: "Fusil Tireur D'élite",
  T_46_META_WS_E_SNIPERAMMO: "Munitions De Fusil Tireur D'élite",
  T_46_META_WS_E_SNOWA: "Snow A",
  T_46_META_WS_E_SNOWFLAKE: "Flocon de Neige",
  T_46_META_WS_E_SOCCER: "Football",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Widget bouton social",
  T_46_META_WS_E_SOLARPANEL: "Panneau solaire",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "Par priorité de haut en bas",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "Par priorité de bas en haut",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "VFX De Point D'apparition",
  T_46_META_WS_E_SPEAKER: "Haut-parleur",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Son Spécial d'Arme",
  T_46_META_WS_E_SPECIALGUN: "Arme Spéciale",
  T_46_META_WS_E_SPHERE: "Sphère",
  T_46_META_WS_E_SPHERETRIGGER: "Déclencheur de collision sphérique",
  T_46_META_WS_E_SPIDERWEB: "VFX de Compétence",
  T_46_META_WS_E_SPORTSCAR: "Voiture de Sport",
  T_46_META_WS_E_SPOTLIGHT: "Lumière",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Diffusion de Gaz Toxique",
  T_46_META_WS_E_SPRINT: "En Course",
  T_46_META_WS_E_SQUARE: "Carré",
  T_46_META_WS_E_SQUAREBOX: "Caisse en bois carrée",
  T_46_META_WS_E_SR: "Fusil de précision",
  T_46_META_WS_E_STABLE: "Hutte en chaume",
  T_46_META_WS_E_STAIRS: "Escalier",
  T_46_META_WS_E_STANDING: "Debout",
  T_46_META_WS_E_STAR: "Étoile",
  T_46_META_WS_E_STATIC: "Statique",
  T_46_META_WS_E_STATUSTRIGGER: "Déclencheur de mort ou d'invincibilité",
  T_46_META_WS_E_STEP: "Pas",
  T_46_META_WS_E_STEPTRIGGER: "Activer le mécanisme",
  T_46_META_WS_E_STOCK_S: "Crosse_S",
  T_46_META_WS_E_STOCK_SR: "Crosse_SR",
  T_46_META_WS_E_STOCK1: "Crosse1",
  T_46_META_WS_E_STOCK2: "Crosse2",
  T_46_META_WS_E_STOCK3: "Crosse 3",
  T_46_META_WS_E_STONE: "Pierre",
  T_46_META_WS_E_STONEBRIDGE: "Pont en arc en pierre",
  T_46_META_WS_E_STONELANTERN: "Lantern de palais",
  T_46_META_WS_E_STONESPLASH: "Débris Volants",
  T_46_META_WS_E_STORE: "Magasin",
  T_46_META_WS_E_STREETLAMP: "Réverbère",
  T_46_META_WS_E_STYLEA: "Style A",
  T_46_META_WS_E_STYLEB: "Style B",
  T_46_META_WS_E_STYLEC: "Style C",
  T_46_META_WS_E_SUBMACHINEGUN: "SMG",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "Munitions SMG",
  T_46_META_WS_E_SUCCESSFULHIT: "Frapper",
  T_46_META_WS_E_SUN: "Soleil",
  T_46_META_WS_E_SUNSHADE: "Ensemble de patio avec parasol",
  T_46_META_WS_E_SUPERCAR: "Voiture de sport",
  T_46_META_WS_E_SUPERMARKET: "Supermarché",
  T_46_META_WS_E_SURPRISEFIND: "Découvrir Surprise",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Changement Rapide D'arme",
  T_46_META_WS_E_SWIMRING: "Bouée",
  T_46_META_WS_E_SWORD: "Épée",
  T_46_META_WS_E_SYMBOLIC: "Marqueur au Sol",
  T_46_META_WS_E_TANKZOMBIE: "Zombie tank",
  T_46_META_WS_E_TAP: "Tapoter",
  T_46_META_WS_E_TAPPINGBUTTON: "Bouton de Tapotement",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Appuyez Sur Le Bouton Désactiver",
  T_46_META_WS_E_TEAM: "Équipe",
  T_46_META_WS_E_TEAMMATESINFO: "Infos des coéquipiers",
  T_46_META_WS_E_TELEPORT: "Téléportation",
  T_46_META_WS_E_TELEPORTCORRECT: "Balisage De Destination Correct",
  T_46_META_WS_E_TELEPORTWRONG: "Balise de Destination Incorrecte",
  T_46_META_WS_E_TEXT: "Texte",
  T_46_META_WS_E_TEXTOBJECT: "Texte",
  T_46_META_WS_E_TEXTUREWIDGET: "Widget texture",
  T_46_META_WS_E_THERMALSCOPE: "Lunette thermique",
  T_46_META_WS_E_THIRDPERSON: "Troisième-Personne",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Classique En Troisième Personne",
  T_46_META_WS_E_THIRDPERSONLOCK: "Verrouillage À La Troisième Personne",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "Couteau De Lancer2 Pour Compatibilité",
  T_46_META_WS_E_THRILLBATTLE: "Compétence 5",
  T_46_META_WS_E_THROWATTACK: "Attaque Par Lancer",
  T_46_META_WS_E_THROWINGKNIFE: "Couteau À Lancer",
  T_46_META_WS_E_THROWREDZOMBIE: "Lancer Zombie Rouge",
  T_46_META_WS_E_THROWZOMBIE: "Zombie Lanceur",
  T_46_META_WS_E_THUMBSUP: "J'aime",
  T_46_META_WS_E_THUNDER: "Choc Électrique",
  T_46_META_WS_E_TILEA: "Tile A",
  T_46_META_WS_E_TILEB: "Tile B",
  T_46_META_WS_E_TILEC: "Tile C",
  T_46_META_WS_E_TILED: "Carrelé",
  T_46_META_WS_E_TIPSSOUND: "Afficher Les Astuces",
  T_46_META_WS_E_TOGGLEWIDGET: "Widget de bascule",
  T_46_META_WS_E_TOILETBOWL: "Toilette",
  T_46_META_WS_E_TONEA: "tone A",
  T_46_META_WS_E_TOP: "Coffre",
  T_46_META_WS_E_TOPDOWN: "Haut-Bas",
  T_46_META_WS_E_TORII: "Torii",
  T_46_META_WS_E_TOUCHPADWIDGET: "Widget pavé tactile",
  T_46_META_WS_E_TOWER: "Forteresse",
  T_46_META_WS_E_TPIPE: "Tuyau T",
  T_46_META_WS_E_TRACINGSTEPS: "Compétence 3",
  T_46_META_WS_E_TRAILER: "Remorque",
  T_46_META_WS_E_TRANSFORMATION: "Changeur de Look",
  T_46_META_WS_E_TRANSPARENT: "Transparent",
  T_46_META_WS_E_TRAPEZOID: "Trapèze",
  T_46_META_WS_E_TRASHCAN: "Poubelle",
  T_46_META_WS_E_TRIANGLE: "Triangle",
  T_46_META_WS_E_TRIGGERS: "Déclencheur",
  T_46_META_WS_E_TRIPLE: "Triple",
  T_46_META_WS_E_TROPHY: "Trophée",
  T_46_META_WS_E_TRUE: "Oui",
  T_46_META_WS_E_TUKTUK: "Tuk Tuk",
  T_46_META_WS_E_TUTUCAR: "Tuk-Tuk",
  T_46_META_WS_E_TYRANTZOMBIE: "Zombie Tyrant",
  T_46_META_WS_E_UAVLITE: "Drone Léger",
  T_46_META_WS_E_UIFINISH: "Fin",
  T_46_META_WS_E_UITAP: "Tap interface",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Générateur d'unités",
  T_46_META_WS_E_UPWARDTURBULENCE: "Courant Ascendant",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "Voûte Par Dessus",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "Véhicule",
  T_46_META_WS_E_VEHICLEEXPLODE: "Explosion de Véhicule",
  T_46_META_WS_E_VELOCITY: "Velocity",
  T_46_META_WS_E_VENDINGMACHINE: "Distributeur automatique",
  T_46_META_WS_E_VERTICAL: "Vertical",
  T_46_META_WS_E_VEST: "Gilet",
  T_46_META_WS_E_VEST1: "Gilet1",
  T_46_META_WS_E_VEST2: "Gilet2",
  T_46_META_WS_E_VEST3: "Gilet3",
  T_46_META_WS_E_VEST4: "Gilet4",
  T_46_META_WS_E_VISUALEFFECTS: "Effets Visuels",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Mur A",
  T_46_META_WS_E_WALLBRAWL: "Compétence 2",
  T_46_META_WS_E_WARNING: "Avertissement",
  T_46_META_WS_E_WATERRING: "Éclaboussure d’Eau",
  T_46_META_WS_E_WAVE1: "Vague1",
  T_46_META_WS_E_WAVE2: "Vague2",
  T_46_META_WS_E_WAVE3: "Vague3",
  T_46_META_WS_E_WEAPONGENERATOR: "Arme",
  T_46_META_WS_E_WEAPONSLOT: "Emplacement d'arme",
  T_46_META_WS_E_WHISTLE: "Vaincre L'ennemi",
  T_46_META_WS_E_WIDERANGE: "Large gamme",
  T_46_META_WS_E_WIN: "Victoire",
  T_46_META_WS_E_WINDATTACK: "Attaque Du Vent",
  T_46_META_WS_E_WOODA: "Wood A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Hache Zombie",
  T_46_META_WS_E_WOODENPLANK: "Pont en planches",
  T_46_META_WS_E_WORLDPOSITION: "Coordonnées mondiales",
  T_46_META_WS_E_WRECKEDBUS: "Bus accidenté",
  T_46_META_WS_E_WRECKEDCAR: "Voiture accidentée",
  T_46_META_WS_E_WRONG: "Incorrect",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Zombie",
  T_46_META_WS_E_ZOMBIES: "Zombie",
  T_46_META_WS_E_ZOOM: "Zoom",
  T_46_META_WS_ELIMINATE: "Éliminer",
  T_46_META_WS_ELIMINATEDENTITY: "Entité éliminée",
  T_46_META_WS_ELIMINATEDPLAYER: "Joueur éliminé",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Activer l'arbre de comportement par défaut",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Activer la Zone de Sécurité Mobile",
  T_46_META_WS_ENABLESAFEZONE: "Activer la Zone de Sécurité",
  T_46_META_WS_ENDCURRENTPHASE: "Finir la Phase Actuelle",
  T_46_META_WS_ENDMORPH: "Terminer la transformation",
  T_46_META_WS_ENDPOSITION: "Position finale",
  T_46_META_WS_ENTERVEHICLE: "Entrer dans le véhicule",
  T_46_META_WS_ENTITY: "Entité",
  T_46_META_WS_EQUIPMENTID: "ID de l'équipement",
  T_46_META_WS_EULERANGLETOQUATERNION: "Angles d'Euler en quaternion",
  T_46_META_WS_EXITVEHICLE: "Sortir du véhicule",
  T_46_META_WS_EXPONENTIATION: "Exponentiation",
  T_46_META_WS_FILTERENTITY: "Filtrer l'entité",
  T_46_META_WS_FILTERLEVELOBJECTS: "Filtrer les Objets de Niveau",
  T_46_META_WS_FIND: "Trouver",
  T_46_META_WS_FINDAT: "Trouver à",
  T_46_META_WS_FINDPATH: "Trouver un chemin",
  T_46_META_WS_FLOOR: "Arrondir à l'Inférieur",
  T_46_META_WS_FOOTBALLGOAL: "But de football",
  T_46_META_WS_FORMAT: "Formater",
  T_46_META_WS_GETALLKEYS: "Obtenir Toutes les Clés",
  T_46_META_WS_GETALLPLAYERS: "Obtenir Tous les Joueurs",
  T_46_META_WS_GETALLSHOPS: "Obtenir tous les magasins",
  T_46_META_WS_GETALLTEAMS: "Obtenir Toutes les Équipes",
  T_46_META_WS_GETATTACKABLEENTITY: "Obtenir l'entité attaquable",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Obtenir les factions attaquables",
  T_46_META_WS_GETBACKPACKSKIN: "Obtenir la peau du sac à dos",
  T_46_META_WS_GETBLACKBOARDVALUE: "Obtenir la valeur du tableau noir",
  T_46_META_WS_GETBUFFS: "Obtenir les buffs",
  T_46_META_WS_GETCHATCHANNEL: "Obtenir le canal de discussion",
  T_46_META_WS_GETCHILDBYINDEX: "Obtenir un enfant par index",
  T_46_META_WS_GETCHILDBYNAME: "Obtenir un enfant par nom",
  T_46_META_WS_GETCHILDREN: "Obtenir les enfants",
  T_46_META_WS_GETCOLORCHANNEL: "Obtenir le canal de couleur",
  T_46_META_WS_GETCONSUMABLES: "Obtenir les consommables",
  T_46_META_WS_GETCULLINGMASK: "Obtenir le masque de culling",
  T_46_META_WS_GETCURRENTCAMERA: "Obtenir la caméra actuelle",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Obtenir le canal de discussion actuel",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Obtenir la progression de la mission personnalisée",
  T_46_META_WS_GETDYEDCOUNT: "Obtenir le nombre de teintures",
  T_46_META_WS_GETDYEDSTATUS: "Obtenir le statut de teinture",
  T_46_META_WS_GETEQUIPMENTS: "Obtenir l'équipement",
  T_46_META_WS_GETFACTION: "Obtenir la faction",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Obtenir le seuil de sommeil global",
  T_46_META_WS_GETITEMCOUNT: "Obtenir le Nombre d'Éléments",
  T_46_META_WS_GETLOADEDSCENES: "Obtenir les scènes chargées",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Obtenir la direction de visée locale",
  T_46_META_WS_GETLOCALPLAYER: "Obtenir le joueur local",
  T_46_META_WS_GETLOCALTIMESTAMP: "Obtenir le timestamp local",
  T_46_META_WS_GETMAPID: "Obtenir l'ID de la carte",
  T_46_META_WS_GETMINIMAP: "Obtenir la mini-carte",
  T_46_META_WS_GETMONEY: "Obtenir de l'argent",
  T_46_META_WS_GETMONEYCOUNT: "Obtenir le nombre d'argent",
  T_46_META_WS_GETMORPH: "Obtenir la transformation",
  T_46_META_WS_GETNODEVARIABLE: "Obtenir la variable du nœud",
  T_46_META_WS_GETOUTFIT: "Obtenir une tenue",
  T_46_META_WS_GETOWNER: "Obtenir le Propriétaire",
  T_46_META_WS_GETPARENT: "Obtenir le parent",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Obtenir la Position Près d'un Coéquipier",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Obtenir une Position de Spawn Aléatoire",
  T_46_META_WS_GETRESULTFROMCURVE: "Obtenir le résultat de la courbe",
  T_46_META_WS_GETSCENESKYBOX: "Obtenir le skybox de la scène",
  T_46_META_WS_GETSERVERREGION: "Obtenir la Région du Serveur",
  T_46_META_WS_GETSERVERTIMESTAMP: "Obtenir le Timestamp du Serveur",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Obtenir une partie du squelette par nom",
  T_46_META_WS_GETSKILLS: "Obtenir les compétences",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Obtenir le seuil de sommeil",
  T_46_META_WS_GETTOKENCOUNT: "Obtenir le Nombre de Tokens",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Obtenir le Nombre de Tokens d'Aujourd'hui",
  T_46_META_WS_GETTYPE: "Obtenir le type",
  T_46_META_WS_GETVEHICLESKIN: "Obtenir la peau du véhicule",
  T_46_META_WS_GETWALLET: "Obtenir le portefeuille",
  T_46_META_WS_GETWEAPONSKIN: "Obtenir un skin d'arme",
  T_46_META_WS_GETWIDGETBYPATH: "Obtenir le widget par chemin",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Obtenir le Widget de l'UI Personnalisée",
  T_46_META_WS_GIVEJAILBREAKITEM: "Donner un objet de jailbreak",
  T_46_META_WS_GIVEJAILBREAKREWARD: "Donner une récompense de jailbreak",
  T_46_META_WS_HASAOISPECIALFOLLOW: "Avoir un suivi spécial AOI",
  T_46_META_WS_HASCOMPONENT: "A un composant",
  T_46_META_WS_HASSCRIPT: "A un script",
  T_46_META_WS_HASTAG: "A une étiquette",
  T_46_META_WS_HELPEDPLAYER: "Joueur assisté",
  T_46_META_WS_HELPPLAYER: "Joueur assistant",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Cacher le groupe d'apparence",
  T_46_META_WS_HITENTITY: "Entité touchée",
  T_46_META_WS_HITFLY: "Envoyer en vol",
  T_46_META_WS_HITNORMAL: "Normale d'impact",
  T_46_META_WS_HITOBJECT: "Objet touché",
  T_46_META_WS_HITPOSITION: "Position de l'impact",
  T_46_META_WS_INDEXOF: "Obtenir la Position de la Première Apparition de l'Élément",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Zombie Infecté Grandir",
  T_46_META_WS_INSERT: "Insérer",
  T_46_META_WS_ISATTACKABLE: "Est attaquable",
  T_46_META_WS_ISCHATCHANNELEMPTY: "Le canal de discussion est vide",
  T_46_META_WS_ISEQUAL: "Est égal",
  T_46_META_WS_ISFRIEND: "Est-ce un ami",
  T_46_META_WS_ISHIT: "Est touché",
  T_46_META_WS_ISINSIDEBOX: "À l'Intérieur de la Boîte",
  T_46_META_WS_ISINSIDECYLINDER: "À l'Intérieur du Cylindre",
  T_46_META_WS_ISINSIDESECTOR: "À l'Intérieur du Secteur",
  T_46_META_WS_ISINSIDESPHERE: "À l'Intérieur de la Sphère",
  T_46_META_WS_ISSLEEPING: "Est-ce que c'est en train de dormir",
  T_46_META_WS_ISSUBTYPEOF: "Est un sous-type de",
  T_46_META_WS_ITEM: "Entité",
  T_46_META_WS_ITEMID: "ID de l'objet",
  T_46_META_WS_JOIN: "Joindre",
  T_46_META_WS_JOINCHATCHANNEL: "Rejoindre le canal de discussion",
  T_46_META_WS_JOINFACTION: "Rejoindre une faction",
  T_46_META_WS_LASTINDEXOF: "Obtenir la Position de la Dernière Apparition de l'Élément",
  T_46_META_WS_LENGTH: "Longueur",
  T_46_META_WS_LERP: "Interpolation",
  T_46_META_WS_LOADSCENE: "Charger la scène",
  T_46_META_WS_LOGARITHM: "Logarithme",
  T_46_META_WS_LOGERROR: "Consigner une erreur",
  T_46_META_WS_LOGINFO: "Enregistrer les Informations",
  T_46_META_WS_LOGWARNING: "Consigner un avertissement",
  T_46_META_WS_LOOKROTATION: "Rotation du regard",
  T_46_META_WS_MAGNITUDE: "Magnitude",
  T_46_META_WS_MAKER: "Créateur",
  T_46_META_WS_MAX: "Max",
  T_46_META_WS_MECHANISM: "Mécanisme",
  T_46_META_WS_MIN: "Min",
  T_46_META_WS_MONSTERUSESKILL: "Utiliser une compétence",
  T_46_META_WS_MORPHOBJECT: "Objet de morphing",
  T_46_META_WS_MORPHTO: "Se transformer en",
  T_46_META_WS_MORPHTOBYITEMID: "Se transformer selon l'ID de l'objet",
  T_46_META_WS_MOVECCT: "Déplacer le CCT",
  T_46_META_WS_MOVEPOSITION: "Déplacer la position",
  T_46_META_WS_MOVEROTATION: "Déplacer la rotation",
  T_46_META_WS_MULTIPLYQUATERNION: "Multiplier quaternion",
  T_46_META_WS_MULTIRAYCAST: "Détection de rayons multiples",
  T_46_META_WS_NEGATE: "Négatif",
  T_46_META_WS_NEW: "Nouveau",
  T_46_META_WS_NODENAME: "Nom du nœud",
  T_46_META_WS_NORMALIZE: "Normaliser",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Notifier l'Exécution d'un Effet",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "Notifier l'animation de l'icône de lecture",
  T_46_META_WS_NOTIFYPLAYSOUND: "Notifier la Lecture d'un Son",
  T_46_META_WS_NOTIFYSHOWTIPS: "Notifier l'Affichage des Conseils",
  T_46_META_WS_NUMTOSTRING: "Nombre en chaîne",
  T_46_META_WS_ONACCESSEQUIPMENT: "Accéder à l'équipement",
  T_46_META_WS_ONACCESSITEM: "Accès à l'objet",
  T_46_META_WS_ONACCESSWEAPON: "Accès à l'arme",
  T_46_META_WS_ONACE: "Réalisation d'un ACE",
  T_46_META_WS_ONAIMED: "Visée",
  T_46_META_WS_ONAIMING: "Viser",
  T_46_META_WS_ONASSIST: "Assistance",
  T_46_META_WS_ONATTACK: "Attaque",
  T_46_META_WS_ONATTACKSTOP: "Arrêt de l'attaque",
  T_46_META_WS_ONAWAKE: "Réveil",
  T_46_META_WS_ONBEKNOCKEDDOWN: "Joueur mis à terre",
  T_46_META_WS_ONBOUNCEDBYTIRE: "Rebond sur un pneu",
  T_46_META_WS_ONBOUNCEENTITY: "Rebond de l'entité",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "Appui sur le bouton de l'interface intégrée",
  T_46_META_WS_ONBULLETHIT: "Impact de balle",
  T_46_META_WS_ONCAMERARAYCAST: "Raycast de la caméra",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "Impact du contrôleur de personnage",
  T_46_META_WS_ONCHASE: "Chasse",
  T_46_META_WS_ONCHASESTOP: "Arrêt de la chasse",
  T_46_META_WS_ONCLIPEND: "Fin du clip",
  T_46_META_WS_ONCOLLISIONENTER: "Début de collision",
  T_46_META_WS_ONCOLLISIONEXIT: "Fin de collision",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "Fin du compte à rebours",
  T_46_META_WS_ONCREEP: "Ramper",
  T_46_META_WS_ONCROUCH: "Accroupi",
  T_46_META_WS_ONDEALDAMAGE: "Infliger des dommages",
  T_46_META_WS_ONDESTROY: "Destruction",
  T_46_META_WS_ONDISABLE: "Désactivation",
  T_46_META_WS_ONDISCONNECT: "Déconnexion",
  T_46_META_WS_ONDOUBLETAPPED: "Double-tappé",
  T_46_META_WS_ONDRAG: "Glissement",
  T_46_META_WS_ONDRAGEND: "Fin du glissement",
  T_46_META_WS_ONDRAGSTART: "Début du glissement",
  T_46_META_WS_ONDRIVED: "Conduit",
  T_46_META_WS_ONDRIVEVEHICLE: "Conduite du véhicule",
  T_46_META_WS_ONDROPCONSUMABLE: "Lâcher de consommable",
  T_46_META_WS_ONDROPPED: "Lâché",
  T_46_META_WS_ONDROPWEAPON: "Lâcher d'une arme",
  T_46_META_WS_ONEACHLOOP: "Chaque boucle",
  T_46_META_WS_ONELIMINATE: "Élimination",
  T_46_META_WS_ONELIMINATED: "Élimination",
  T_46_META_WS_ONENABLE: "Activation",
  T_46_META_WS_ONEND: "Fin",
  T_46_META_WS_ONENTERED: "Entré",
  T_46_META_WS_ONENTERVEHICLE: "Entrée dans le véhicule",
  T_46_META_WS_ONENTITYENTER: "Sur Déclencheur Entrer",
  T_46_META_WS_ONENTITYEXIT: "Sur déclencheur Quitter",
  T_46_META_WS_ONEQUIPARMOR: "Équiper l'armure",
  T_46_META_WS_ONEQUIPED: "Équipé",
  T_46_META_WS_ONEQUIPWEAPON: "Équiper l'arme",
  T_46_META_WS_ONEXPLODE: "Explosion",
  T_46_META_WS_ONFALL: "Lors de la chute",
  T_46_META_WS_ONFALLSTOP: "Lors de l'arrêt de la chute",
  T_46_META_WS_ONFIRE: "Tirer",
  T_46_META_WS_ONFIXEDUPDATE: "Mise à jour fixe",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "Collision avec un ballon de football",
  T_46_META_WS_ONFRIENDSUPDATE: "Mise à jour du statut d'amitié ",
  T_46_META_WS_ONGAMEEND: "Fin du jeu",
  T_46_META_WS_ONGAMEPAUSE: "Pause du jeu",
  T_46_META_WS_ONGAMERESUME: "Reprise du jeu",
  T_46_META_WS_ONGAMESTART: "Début du jeu",
  T_46_META_WS_ONGOAL: "But",
  T_46_META_WS_ONHITBYBULLET: "Touché par une balle",
  T_46_META_WS_ONHITFLY: "Impact en vol",
  T_46_META_WS_ONHITFLYENTITY: "Impact sur une entité en vol",
  T_46_META_WS_ONHOOKGUNFIRE: "Tir avec un pistolet à crochet",
  T_46_META_WS_ONIDLE: "Inactivité",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Début de la zone de fuite",
  T_46_META_WS_ONJAILBREAKAREAEND: "Fin de la zone de fuite",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Connexion du joueur à la zone de fuite",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Déconnexion du joueur de la zone de fuite",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "Connexion réussie au canal de discussion",
  T_46_META_WS_ONJOYSTICKMOVE: "Mouvement du joystick",
  T_46_META_WS_ONJOYSTICKPRESSED: "Appuyé",
  T_46_META_WS_ONJOYSTICKRELEASED: "Relâché",
  T_46_META_WS_ONJUMP: "Saut",
  T_46_META_WS_ONJUMPSTOP: "Lors de l'arrêt du saut",
  T_46_META_WS_ONLANDMINEACTIVE: "Activation de la mine terrestre",
  T_46_META_WS_ONLANDMINETRIGGER: "Déclenchement de la mine terrestre",
  T_46_META_WS_ONLEAVECHATCHANNEL: "Sortie du canal de discussion",
  T_46_META_WS_ONLEAVEVEHICLE: "Sortie du véhicule",
  T_46_META_WS_ONLEFT: "Sorti",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "Transformation d'un objet du niveau",
  T_46_META_WS_ONMOVE: "Mouvement",
  T_46_META_WS_ONNODEENTER: "Entrée du nœud",
  T_46_META_WS_ONNODEEXIT: "Sortie du nœud",
  T_46_META_WS_ONPAUSE: "Pause",
  T_46_META_WS_ONPHASEEND: "Fin de phase",
  T_46_META_WS_ONPHASESTART: "Début de phase",
  T_46_META_WS_ONPICKEDUP: "Ramassé",
  T_46_META_WS_ONPLAYERASSIST: "Assistance du joueur",
  T_46_META_WS_ONPLAYERBEELIMINATED: "Élimination du joueur",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "Joueur mis à terre",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "Dommages infligés par le joueur",
  T_46_META_WS_ONPLAYERELIMINATE: "Élimination par le joueur",
  T_46_META_WS_ONPLAYERENTER: "Entrée du joueur",
  T_46_META_WS_ONPLAYERJOIN: "Connexion du joueur",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "Échec de connexion au canal de discussion",
  T_46_META_WS_ONPLAYERLEAVE: "Sortie du joueur",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "Demande d'achat par le joueur",
  T_46_META_WS_ONPLAYERQUIT: "Le Joueur Quitte à Mi-parcours",
  T_46_META_WS_ONPLAYERRANKCHANGE: "Changement de rang du joueur",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "Demande d'achat remplie par le joueur",
  T_46_META_WS_ONPLAYERREVIVED: "Réanimation du joueur",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "Réanimation du joueur au point d'apparition",
  T_46_META_WS_ONPLAYERSCORECHANGE: "Changement de score du joueur",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "Changement de scène du joueur",
  T_46_META_WS_ONPREDEALDAMAGE: "Avant d'infliger des dommages",
  T_46_META_WS_ONPREPURCHASE: "Avant l'achat",
  T_46_META_WS_ONPRESSED: "Appuyé",
  T_46_META_WS_ONPRETAKEDAMAGE: "Avant de prendre des dommages",
  T_46_META_WS_ONPURCHASE: "Achat",
  T_46_META_WS_ONRANKCHANGED: "Changement de rang de l'entité",
  T_46_META_WS_ONRECONNECT: "Reconnexion",
  T_46_META_WS_ONRELEASED: "Relâché",
  T_46_META_WS_ONRELOAD: "Recharge",
  T_46_META_WS_ONRESUME: "Reprise",
  T_46_META_WS_ONREVIVED: "Réanimation",
  T_46_META_WS_ONROUNDEND: "Fin du round",
  T_46_META_WS_ONROUNDSTART: "Début du round",
  T_46_META_WS_ONSCENELOAD: "Chargement de la scène",
  T_46_META_WS_ONSCENESWITCH: "Changement de scène",
  T_46_META_WS_ONSCORECHANGE: "Changement de score de l'entité",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "Tir par un tireur de football",
  T_46_META_WS_ONSLEEP: "Sommeil",
  T_46_META_WS_ONSPAWN: "Apparition",
  T_46_META_WS_ONSPRAY: "Pulvériser",
  T_46_META_WS_ONSPRAYED: "Pulvérisé",
  T_46_META_WS_ONSPRINT: "Sprints",
  T_46_META_WS_ONSPRINTSTOP: "Arrêt du sprint",
  T_46_META_WS_ONSTANDUP: "Se lever",
  T_46_META_WS_ONSTART: "Début",
  T_46_META_WS_ONSTARTFIRE: "Attaque",
  T_46_META_WS_ONSTATEEND: "Fin de l'état",
  T_46_META_WS_ONSURFING: "Surf",
  T_46_META_WS_ONSURFINGSTOP: "Arrêt du surf",
  T_46_META_WS_ONSWITCHHANDHELD: "Changer de tenue à main",
  T_46_META_WS_ONTAKEDAMAGE: "Prise de dommages",
  T_46_META_WS_ONTAPPED: "Appuyé",
  T_46_META_WS_ONTEAMACE: "Élimination complète de l'équipe",
  T_46_META_WS_ONTEAMADD: "Ajout à l'équipe",
  T_46_META_WS_ONTEAMREMOVE: "Suppression de l'équipe",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "Changement de rang d'équipe au round",
  T_46_META_WS_ONTEAMSCORECHANGE: "Changement de score de l'équipe",
  T_46_META_WS_ONTELEPORTENTITY: "Téléportation de l'entité",
  T_46_META_WS_ONTEXTCHANGE: "Changement de texte",
  T_46_META_WS_ONTHROWABLEEXPLODE: "Explosion d'un objet jetable",
  T_46_META_WS_ONTOGGLE: "Basculer",
  T_46_META_WS_ONTOUCHDOWN: "Toucher vers le bas",
  T_46_META_WS_ONTOUCHUP: "Toucher vers le haut",
  T_46_META_WS_ONUIHIDE: "Masquer l'interface",
  T_46_META_WS_ONUISHOW: "Affichage de l'interface",
  T_46_META_WS_ONUPDATE: "Mise à jour",
  T_46_META_WS_ONUSEAVATARSKILL: "Utilisation de la compétence de l'avatar",
  T_46_META_WS_ONUSECONSUMABLE: "Utilisation de consommable",
  T_46_META_WS_ONUSED: "Utilisé",
  T_46_META_WS_ONUSEPORTAL: "Utilisation d'un portail",
  T_46_META_WS_ONWAKEUP: "Réveil",
  T_46_META_WS_ONWEAPONBEEQUIPED: "Arme équipée",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "Dommages infligés par l'arme",
  T_46_META_WS_ONWEAPONELIMINATE: "Élimination par l'arme",
  T_46_META_WS_ONWEAPONSTOPFIRING: "Arrêt du tir de l'arme",
  T_46_META_WS_OWNER: "Propriétaire",
  T_46_META_WS_P_ACCELERATE: "Accélération",
  T_46_META_WS_P_ACCELERATION: "Accélération",
  T_46_META_WS_P_ACCOUNTID: "ID compte",
  T_46_META_WS_P_ACCURACY: "Précision",
  T_46_META_WS_P_ACTIONTYPE: "Type D'action",
  T_46_META_WS_P_ACTIVATEDALPHA: "Alpha Activé",
  T_46_META_WS_P_ACTIVE: "Actif",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Actif Dans La Hiérarchie",
  T_46_META_WS_P_ACTIVESELF: "Soi Actif",
  T_46_META_WS_P_ACTIVETEXT: "Texte Actif",
  T_46_META_WS_P_ACTUALPOSITION: "Position réelle",
  T_46_META_WS_P_AFTERACCUMULATOR: "Accumulateur après",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Décalage Du Centre D'assistance À La Visée",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Distance D'assistance à la Visée",
  T_46_META_WS_P_AIMASSISTTYPE: "Type D'aide à La Visée",
  T_46_META_WS_P_AIRDROPSTATE: "État du largage aérien",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Alignement Horizontal",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Alignement Vertical",
  T_46_META_WS_P_ALLITEMS: "Tous Les Articles",
  T_46_META_WS_P_ALLMEMBERS: "Tous les Membres",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Autoriser Le Verrouillage Par Assistance à La Visée",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Autoriser le Pressage Hors Zone",
  T_46_META_WS_P_ALLPLAYERS: "Tous les Joueurs",
  T_46_META_WS_P_ALLTEAMMATES: "Tous les Coéquipiers",
  T_46_META_WS_P_ALPHA: "Alpha",
  T_46_META_WS_P_ALWAYSSHOWMARK: "Afficher toujours le marqueur",
  T_46_META_WS_P_AMBIENTCOLOR: "Couleur Ambiante",
  T_46_META_WS_P_AMMOCLIPSIZE: "Taille Du Chargeur",
  T_46_META_WS_P_AMMOMAGSIZE: "Taille Du Chargeur De Munitions",
  T_46_META_WS_P_AMMOPERSHOT: "Munitions Par Tir",
  T_46_META_WS_P_AMMOTYPE: "Type de munitions",
  T_46_META_WS_P_ANCHORMAX: "Ancre max",
  T_46_META_WS_P_ANCHORMIN: "Ancre min",
  T_46_META_WS_P_ANCHOROBJECT: "Objet D’ancre",
  T_46_META_WS_P_ANCHORPOSITION: "Position d'ancrage",
  T_46_META_WS_P_ANCHORTYPE: "Script UITweener activé",
  T_46_META_WS_P_ANGLE: "Angle",
  T_46_META_WS_P_ANGLEDOWN: "Angle vers le Bas",
  T_46_META_WS_P_ANGLEUP: "Angle vers le Haut",
  T_46_META_WS_P_ANGULARDRAG: "Résistance angulaire",
  T_46_META_WS_P_ANGULARSPEED: "Vitesse Angulaire",
  T_46_META_WS_P_ANGULARVELOCITY: "Vitesse angulaire (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "Nom de l'animation",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Contrôleur D'animation",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "ID De Ressource Du Contrôleur D'animation",
  T_46_META_WS_P_ARMORPENETRATION: "Pénétration d'Armure",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Facteur De Pénétration D'armure",
  T_46_META_WS_P_ARMORTYPE: "Type d'armure",
  T_46_META_WS_P_ARROWOFFSET: "Décalage de Flèche",
  T_46_META_WS_P_ARROWSIZE: "Taille de Flèche",
  T_46_META_WS_P_ARROWSPRITE: "Sprite de Flèche",
  T_46_META_WS_P_ASKBUYTARGET: "Demander L'achat de la Cible",
  T_46_META_WS_P_ATTACHTARGET: "Cible d'attachement",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Factions Attaquables",
  T_46_META_WS_P_ATTACKDAMAGE: "Dégâts D'attaque",
  T_46_META_WS_P_ATTACKINTERVAL: "Intervalle d'Attaque",
  T_46_META_WS_P_ATTACKRANGE: "Portée d'Attaque",
  T_46_META_WS_P_ATTACKTARGET: "Cible D'attaque",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Cibles Attaquables",
  T_46_META_WS_P_AUTOPLAY: "Statut De Lecture Automatique",
  T_46_META_WS_P_AVAILABLEPOINT: "Point disponible",
  T_46_META_WS_P_AVATAR: "Avatar",
  T_46_META_WS_P_AVATARID: "ID avatar",
  T_46_META_WS_P_BACKGROUND: "Arrière-plan",
  T_46_META_WS_P_BACKGROUNDALPHA: "Alpha de Fond",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Couleur de fond",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Couleur de fond 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Couleur de fond 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Remplissage de Fond",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Nom de l'icône de fond",
  T_46_META_WS_P_BACKGROUNDNAME: "Nom de Fond",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Décalage de Fond",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Rayon de Fond",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Changement de Taille de Fond",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Sprite de Fond",
  T_46_META_WS_P_BACKPACK: "Sac à dos",
  T_46_META_WS_P_BACKPACKSKINID: "ID De Skin Du Sac à Dos",
  T_46_META_WS_P_BACKWARDSPEED: "Vitesse vers l'arrière",
  T_46_META_WS_P_BANNERID: "ID bannière",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Vitesse Horizontale De Base",
  T_46_META_WS_P_BASEMULTIPLIER: "Multiplicateur de base",
  T_46_META_WS_P_BASETIME: "Temps de base",
  T_46_META_WS_P_BASEVERTICALSPEED: "Vitesse Verticale De Base",
  T_46_META_WS_P_BEFOREACCUMULATOR: "Accumulateur avant",
  T_46_META_WS_P_BEVTREEID: "ID de L'arbre De Comportement",
  T_46_META_WS_P_BINDPROPERTYID: "ID de la propriété liée",
  T_46_META_WS_P_BODY: "Torse",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Facteur de dégâts au corps",
  T_46_META_WS_P_BONEPOSITION: "Position Des Os",
  T_46_META_WS_P_BONESCALE: "Détartrage Osseux",
  T_46_META_WS_P_BOOSTCD: "CD De Boost",
  T_46_META_WS_P_BOOSTDURATION: "Durée Du Boost",
  T_46_META_WS_P_BOOSTSPEED: "Vitesse de Boost",
  T_46_META_WS_P_BORDERLR: "Bord Gauche-Droit",
  T_46_META_WS_P_BORDERTB: "Bord Haut-Bas",
  T_46_META_WS_P_BOTTOMALPHA: "Alpha Bas",
  T_46_META_WS_P_BOUNDWALLET: "Type d'ancre HUD",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Puissance des freins",
  T_46_META_WS_P_BRAKETORQUE: "Puissance des freins",
  T_46_META_WS_P_BRRANK: "Rang BR",
  T_46_META_WS_P_BUFFTYPE: "Type de buff",
  T_46_META_WS_P_BURNDAMAGE: "Dégâts de combustion",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Intervalle de dégâts de combustion",
  T_46_META_WS_P_BURNTIME: "Temps de combustion",
  T_46_META_WS_P_BUTTOM: "Bas",
  T_46_META_WS_P_BUTTONCOLORS: "Couleurs des boutons",
  T_46_META_WS_P_BUTTONNAMES: "Noms des boutons",
  T_46_META_WS_P_BUTTONSTYLE: "Style De Bouton",
  T_46_META_WS_P_CAMERABLOCKMODE: "Mode Blocage De La Caméra",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Mode De Projection De La Caméra",
  T_46_META_WS_P_CAMERATYPE: "Type de Caméra",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Annuler le Glissement si Adapté",
  T_46_META_WS_P_CANCOSTDURABILITY: "Peut Coûter En Durabilité",
  T_46_META_WS_P_CANDAMAGED: "Peut être Endommagé",
  T_46_META_WS_P_CANDESTROY: "Peut Détruire",
  T_46_META_WS_P_CANDESTROYED: "Peut être Détruit",
  T_46_META_WS_P_CANSELFTRIGGER: "Peut être Déclenché Par Soi",
  T_46_META_WS_P_CANTEAMTRIGGER: "Peut être Déclenché par L'équipe",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Peut Être Déclenché Par Soi-Même",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Peut être déclenché par l'équipe",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Peut Être Déclenché Par Un Véhicule",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Peut Déclencher Un Véhicule",
  T_46_META_WS_P_CELLSIZE: "Taille de Cellule",
  T_46_META_WS_P_CELLSPACE: "Espace entre Cellules",
  T_46_META_WS_P_CENTER: "Centre",
  T_46_META_WS_P_CENTERINVISIBLE: "Centre Invisible",
  T_46_META_WS_P_CENTEROFFSET: "Décalage du centre",
  T_46_META_WS_P_CENTEROFMASS: "Centre de masse",
  T_46_META_WS_P_CENTERRANGE: "Portée Centrale",
  T_46_META_WS_P_CENTRALFLASHTIME: "Temps de flash central",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Ligne Centrale Active",
  T_46_META_WS_P_CENTRALLINEPOSITION: "Position de la Ligne Centrale",
  T_46_META_WS_P_CHANNELID: "ID du Canal de Chat",
  T_46_META_WS_P_CHARGEMAX: "Charge max.",
  T_46_META_WS_P_CHASETARGET: "Cible De Chasse",
  T_46_META_WS_P_CHATCHANNEL: "Canal De Chat",
  T_46_META_WS_P_CHECKPOINTID: "ID de checkpoint",
  T_46_META_WS_P_CHILDINDEX: "Index enfant",
  T_46_META_WS_P_CHIPEXP: "Exp De Puce",
  T_46_META_WS_P_CLICKSIZE: "Taille Du Clic",
  T_46_META_WS_P_CLIPLENGTH: "Longueur du Clip",
  T_46_META_WS_P_CLIPPINGTYPE: "Type de Découpage",
  T_46_META_WS_P_COLLIDERID: "ID du Collider",
  T_46_META_WS_P_CONSTRAIN: "Contrainte",
  T_46_META_WS_P_CONSTRAINT: "Contrainte",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Nombre de Contraintes",
  T_46_META_WS_P_CONSUMABLETYPE: "Type de consommable",
  T_46_META_WS_P_CONTENT: "Contenu",
  T_46_META_WS_P_CONTENTORIGIN: "Origine du Contenu",
  T_46_META_WS_P_CONTROLPOINTS: "Points de Contrôle",
  T_46_META_WS_P_COORDINATESYSTEM: "Système de Coordonnées",
  T_46_META_WS_P_COUNT: "Nombre",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Heure de fin du compte à rebours (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "Clé du compte à rebours",
  T_46_META_WS_P_COUNTDOWNTIME: "Temps du compte à rebours",
  T_46_META_WS_P_COUNTPERWAVE: "Nombre par vague",
  T_46_META_WS_P_CRASHMAXDAMAGE: "Dégâts maximaux de collision",
  T_46_META_WS_P_CRASHMAXSPEED: "Vitesse maximale de collision",
  T_46_META_WS_P_CRASHMESSFACTOR: "Facteur de qualité de collision",
  T_46_META_WS_P_CRASHMINDAMAGE: "Dégâts minimaux de collision",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Échelle De Vitesse De Rampement",
  T_46_META_WS_P_CREATEDENTITY: "Entité Créée",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Échelle De Vitesse De Marche Accroupie",
  T_46_META_WS_P_CSRANK: "Rang CS",
  "T_46_META_WS_P_CURRENT AMMO": "Munitions Actuelles",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "Ressource D'animation Actuelle",
  T_46_META_WS_P_CURRENTCLIP: "Clip Actuel",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Progrès du Clip Actuel",
  T_46_META_WS_P_CURRENTDURABILITY: "Durabilité Actuelle",
  T_46_META_WS_P_CURRENTENERGY: "Énergie Actuelle",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Objet Tenu Actuellement",
  T_46_META_WS_P_CURRENTHP: "HP actuel",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Index De La Phase Actuelle",
  T_46_META_WS_P_CURRENTPROGRESS: "Progression actuelle",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Index De La Ronde Actuelle",
  T_46_META_WS_P_CURRENTSTATE: "État Actuel",
  T_46_META_WS_P_CURRENTVALUE: "Valeur actuelle",
  T_46_META_WS_P_CURRENTWAVE: "Vague actuelle",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Ressource De Personnage Personnalisée",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Résultat du jeu personnalisé",
  T_46_META_WS_P_CUSTOMGRAVITY: "Gravité Personnalisée",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Force de poussée",
  T_46_META_WS_P_CUSTOMXY: "XY Personnalisé",
  T_46_META_WS_P_DAMAGE: "Dégâts",
  "T_46_META_WS_P_DAMAGE RANGE": "Portée",
  T_46_META_WS_P_DAMAGEFACTOR: "Facteur de Dégâts",
  T_46_META_WS_P_DAMAGEINTERVAL: "Intervalle de dommage (s)",
  T_46_META_WS_P_DAMAGERADIUS: "Rayon de Dégâts",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Coefficient de dégâts à la tête",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Coefficient De Dégâts Aux Membres",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Facteur de Réduction des Dégâts",
  T_46_META_WS_P_DAMAGETAKENPCT: "Pourcentage De Dégâts Reçus",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Pourcentage De Dégâts Subis",
  T_46_META_WS_P_DAMAGEVALUE: "Valeur de dommage",
  T_46_META_WS_P_DARKNESS: "Obscurité",
  T_46_META_WS_P_DECELERATIONPERCENT: "Pourcentage De Décélération",
  T_46_META_WS_P_DEFAULTTEXT: "Texte Par Défaut",
  T_46_META_WS_P_DEFENSE: "Taux de Défense",
  T_46_META_WS_P_DEFENSERATE: "Taux de défense",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "Temps Delta",
  T_46_META_WS_P_DELTAVALUE: "Valeur Delta",
  T_46_META_WS_P_DEPTH: "Profondeur",
  T_46_META_WS_P_DESC: "Description",
  T_46_META_WS_P_DESCRIPTION: "Description",
  T_46_META_WS_P_DESCRIPTIONKEY: "Clé de description",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "Paramètres des conseils",
  T_46_META_WS_P_DESTVAL: "Valeur Dest",
  T_46_META_WS_P_DETECTRANGE: "Portée De Détection",
  T_46_META_WS_P_DIFFUSEALPHA: "Alpha Diffuse",
  T_46_META_WS_P_DIFFUSECOLOR: "Diffuser La Couleur",
  T_46_META_WS_P_DIFFUSETEXTURE: "Diffuser la texture",
  T_46_META_WS_P_DISABLECOLOR: "Couleur Désactivée",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Désactiver les dégâts de chute",
  T_46_META_WS_P_DISABLEITEMDROP: "Désactiver Le Dépôt D'objets",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Désactiver Le Ramassage D'objets",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Désactiver la Fermeture Manuelle",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Désactiver le Chat Rapide",
  T_46_META_WS_P_DISABLERECIPROCATING: "Désactiver le mouvement alternatif",
  T_46_META_WS_P_DISABLEVOICECHAT: "Désactiver le Chat Vocal",
  T_46_META_WS_P_DISTANCE: "Distance",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Type De Double Arme",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Échelle de Vitesse du Rampement des Abattues",
  T_46_META_WS_P_DOWNSPEED: "Vitesse vers le bas",
  T_46_META_WS_P_DRAG: "Résistance",
  T_46_META_WS_P_DRIVER: "Conducteur",
  T_46_META_WS_P_DROPITEMS: "Articles tombés",
  T_46_META_WS_P_DURABILITY: "Durabilité",
  T_46_META_WS_P_DURABILITYRECOVERY: "Récupération De Durabilité",
  T_46_META_WS_P_DURATION: "Durée",
  T_46_META_WS_P_EDGEFLASHTIME: "Temps De Flash De Bord",
  T_46_META_WS_P_EFFECTACTIVE: "Effet actif",
  T_46_META_WS_P_EFFECTCOLOR: "Couleur de l'effet",
  T_46_META_WS_P_EFFECTDURATION: "Durée De L'effet",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Intervalle De Temps Effectif",
  T_46_META_WS_P_EFFECTRESID: "Chemin de ressource d'effet",
  T_46_META_WS_P_ENABLE: "Activer",
  T_46_META_WS_P_ENABLEATTACK: "Activer l'Attaque",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Activer La Réanimation De Bot",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Activer la carte de profondeur",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Activer la chute à la mort",
  T_46_META_WS_P_ENABLELOCALIZATION: "Localisation",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "Déplacement en l'air",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Activer La Réanimation Du Joueur",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Vue du joueur",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Rotation avec gravité",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Activer Les Attributs Du Skin",
  T_46_META_WS_P_ENABLESWINGING: "Activer Le Balancement",
  T_46_META_WS_P_ENABLETRACTION: "Activer La Traction",
  T_46_META_WS_P_ENDPOSITION: "Position de Fin",
  T_46_META_WS_P_ENDRADIUS: "Rayon de fin",
  T_46_META_WS_P_ENDTIME: "Temps de fin (s)",
  T_46_META_WS_P_ENDTIMES: "Temps de Fin",
  T_46_META_WS_P_ENDVALUE: "Valeur de Fin",
  T_46_META_WS_P_ENERGY: "Énergie",
  T_46_META_WS_P_ENERGYCOST: "Coût D'énergie",
  T_46_META_WS_P_ENERGYRECOVERY: "Récupération D'énergie",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Puissance du moteur",
  T_46_META_WS_P_ENGINETORQUE: "Puissance du moteur",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "EP Max",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "Quantité de Récupération d'EP",
  T_46_META_WS_P_EVENTS: "Événements",
  T_46_META_WS_P_EXPLODEDAMAGE: "Dégâts de l'explosion",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Facteur de réduction des dégâts d'explosion",
  T_46_META_WS_P_EXPLODEDELAY: "Délai d'explosion",
  T_46_META_WS_P_EXPLODERANGE: "Portée de l'explosion",
  T_46_META_WS_P_EXPLOSIONDELAY: "Retard D'explosion",
  T_46_META_WS_P_EXPLOSIONRANGE: "Portée De L'explosion",
  T_46_META_WS_P_EXPLOSIONTIME: "Délai D'explosion",
  T_46_META_WS_P_EXPPERDAMAGE: "Exp par dégât",
  T_46_META_WS_P_EXPPERMOVEMILE: "Exp Par Mile Parcouru",
  T_46_META_WS_P_EXPPERSECOND: "Exp par seconde",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Capacité Supplémentaire Du Sac à Dos",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Espace Supplémentaire Du Sac À Dos",
  T_46_META_WS_P_EXTRAHPRATIO: "Coefficient D'HP Extra",
  T_46_META_WS_P_FACEPAINT: "Peinture De Visage",
  T_46_META_WS_P_FACTION: "Faction",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Coefficient De Dégâts De Chute",
  T_46_META_WS_P_FALLSPEED: "Vitesse de Chute",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Vitesse de Rechargement Automatique",
  T_46_META_WS_P_FILEID: "ID interne",
  T_46_META_WS_P_FILL: "Remplir",
  T_46_META_WS_P_FILLAMOUNT: "Valeur de Remplissage",
  T_46_META_WS_P_FILLDIRECTION: "Direction de Remplissage",
  T_46_META_WS_P_FILLTYPE: "Type de Remplissage",
  T_46_META_WS_P_FIREANGLELIMIT: "Limite d'Angle de Tir",
  T_46_META_WS_P_FIRETYPE: "Type De Feu",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "Paramètres du premier score",
  T_46_META_WS_P_FIRSTSCORETITLE: "Titre du premier score",
  T_46_META_WS_P_FIRSTSCOREVALUE: "Valeur du premier score",
  T_46_META_WS_P_FIXEDDELTATIME: "Temps Delta Fixe",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Commutateur D'effet De Frappe Flashbang",
  T_46_META_WS_P_FLIP: "Inverser",
  T_46_META_WS_P_FLIPTYPE: "Type de Retour",
  T_46_META_WS_P_FLYMAXHEIGHT: "Hauteur Max De Vol",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Vitesse Horizontale de Vol",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Vitesse Verticale De Vol",
  T_46_META_WS_P_FOGCOLOR: "Couleur Du Brouillard",
  T_46_META_WS_P_FOLLOWTARGET: "Suivre cible",
  T_46_META_WS_P_FONT: "Police",
  T_46_META_WS_P_FONTSIZE: "Taille de police",
  T_46_META_WS_P_FONTSTYLE: "Style De Police",
  T_46_META_WS_P_FONTTYPE: "Type De Police",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Forcer La Synchronisation Au Client",
  T_46_META_WS_P_FORWARD: "Avant",
  T_46_META_WS_P_FORWARDSPEED: "Vitesse vers l'avant",
  T_46_META_WS_P_FOV: "Champ De Vision",
  T_46_META_WS_P_FREEZEDURATION: "Durée de Congélation (s)",
  T_46_META_WS_P_FRIENDFACTIONS: "Factions Amies",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Joueurs Amicaux",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Distance De Dégâts Complets",
  T_46_META_WS_P_FUNCTIONTYPE: "Type de Fonction",
  T_46_META_WS_P_GAINHPCOLOR: "Couleur de gain de HP",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Nombre de Cadres",
  T_46_META_WS_P_GAMETIMECOUNT: "Temps De Jeu",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Délai de Changement de Vitesse",
  T_46_META_WS_P_GENDER: "Genre",
  T_46_META_WS_P_GETONBOOSTCD: "CD de montée en boost",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Commutateur de CD pour Monter sur Boost",
  T_46_META_WS_P_GETONSKATEBOARDCD: "CD Pour Monter Sur Le Skateboard",
  T_46_META_WS_P_GRADIENT: "Dégradé",
  T_46_META_WS_P_GRADIENTBOTTOM: "Dégradé Bas",
  T_46_META_WS_P_GRADIENTTOP: "Dégradé Haut",
  T_46_META_WS_P_GRAVITY: "Gravité",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "Dommages max. des grenades",
  T_46_META_WS_P_GRENADEMINDAMAGE: "Dommages min. des grenades",
  T_46_META_WS_P_GRENADERANGE: "Portée des grenades",
  T_46_META_WS_P_GROUPID: "ID du Groupe",
  T_46_META_WS_P_HEAD: "Tête",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Facteur De Dégâts À La Tête",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Réduction Des Dégâts à La Tête",
  T_46_META_WS_P_HEIGHT: "Hauteur",
  T_46_META_WS_P_HELMET: "Casque",
  T_46_META_WS_P_HIGHESTBRRANK: "Rang BR maximum",
  T_46_META_WS_P_HIGHESTCSRANK: "Rang CS maximum",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Angle D'élévation Min.",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "Limite de direction à haute vitesse",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "Limite de direction à haute vitesse à une certaine vitesse",
  T_46_META_WS_P_HITPOINTEFFECT: "Effet Du Point D'impact",
  T_46_META_WS_P_HORIZONTALBAR: "Barre Horizontale",
  T_46_META_WS_P_HORIZONTALOFFSET: "Décalage Horizontal",
  T_46_META_WS_P_HOSTILETEAMS: "Équipes Ennemies",
  T_46_META_WS_P_HOSTTEAM: "Équipe Hôte",
  T_46_META_WS_P_HP: "PV",
  T_46_META_WS_P_HPMAX: "Max. PV",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "Quantité De Récupération Des HP",
  T_46_META_WS_P_HPRECOVERYSPEED: "Vitesse de Récupération des HP (ms)",
  T_46_META_WS_P_ICON: "Icône",
  T_46_META_WS_P_ICONCOLOR: "Couleur de l'icône",
  T_46_META_WS_P_ICONNAME: "Nom de l'icône",
  T_46_META_WS_P_ICONRESOURCE: "Ressource de l'icône",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Intervalle de Dégâts (s)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "Entrée de frein au ralenti",
  T_46_META_WS_P_INACTIVATEDALPHA: "Alpha Non Activé",
  T_46_META_WS_P_INDEX: "Index",
  T_46_META_WS_P_INITIALMAGCOUNT: "Nombre Initial De Chargeurs",
  T_46_META_WS_P_INITIALSPEED: "Vitesse Initiale",
  T_46_META_WS_P_INITIALVALUE: "Valeur initiale",
  T_46_META_WS_P_INITIALWORLDPOSITION: "Position Initiale du Monde",
  T_46_META_WS_P_INSCENE: "Dans la scène",
  T_46_META_WS_P_INSTANCEID: "ID D'instance",
  T_46_META_WS_P_INTENSITY: "Intensité",
  T_46_META_WS_P_INVERTFILL: "Inverser le Remplissage",
  T_46_META_WS_P_INVINCIBLE: "Invincible",
  "T_46_META_WS_P_IS SHOW": "Est-ce visible",
  T_46_META_WS_P_IS3D: "Est En 3D",
  T_46_META_WS_P_ISACE: "Est ACE",
  T_46_META_WS_P_ISACED: "Élimination Complète",
  T_46_META_WS_P_ISAI: "Est IA",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Est Toujours Dans L'écran",
  T_46_META_WS_P_ISAPPLYSHADOW: "Appliquer l'Ombre",
  T_46_META_WS_P_ISATTACKABLE: "Est Attaquable",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Est en Poursuite Automatique De L'ennemi",
  T_46_META_WS_P_ISAUTOPLAY: "Lecture automatique",
  T_46_META_WS_P_ISAUTOTELEPORT: "Est-ce un téléport automatique",
  T_46_META_WS_P_ISBILLBOARD: "Est Un Panneau D'affichage",
  T_46_META_WS_P_ISBOLD: "Gras",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Collision inférieure",
  T_46_META_WS_P_ISCENTERPOS: "Est une position centrale",
  T_46_META_WS_P_ISCONSUMEAMMO: "Consomme Des Munitions",
  T_46_META_WS_P_ISCONTINUOUS: "Est-ce continu",
  T_46_META_WS_P_ISCOUNTDOWN: "Est un compte à rebours",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "Animation Actuelle En Boucle",
  T_46_META_WS_P_ISDEADDROP: "Support de mort",
  T_46_META_WS_P_ISDEATHTRIGGER: "Est-ce un déclencheur de mort",
  T_46_META_WS_P_ISDEBUG: "Activer le débogage BTree",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "Est Un Point D'apparition Par Défaut",
  T_46_META_WS_P_ISDROPONELIMINATED: "Est Déposé Lorsqu'éliminé",
  T_46_META_WS_P_ISEND: "Fin",
  T_46_META_WS_P_ISFEBUTTON: "Est un Bouton FE",
  T_46_META_WS_P_ISGREY: "Est gris",
  T_46_META_WS_P_ISGROUNDED: "Au sol",
  T_46_META_WS_P_ISIGNOREDEPTH: "Ignore La Profondeur",
  T_46_META_WS_P_ISINVINCIBLE: "Est Invincible",
  T_46_META_WS_P_ISITALIC: "Italique",
  T_46_META_WS_P_ISLASTROUND: "Dernier round",
  T_46_META_WS_P_ISLOCALPOS: "Activer le système de coordonnées local",
  T_46_META_WS_P_ISLOOP: "Boucle",
  T_46_META_WS_P_ISMATCHPOINT: "Round décisif",
  T_46_META_WS_P_ISMOVEABLE: "Activer Le Mouvement",
  T_46_META_WS_P_ISOCCUPIED: "Est-ce occupé",
  T_46_META_WS_P_ISOPENTWEEN: "Activer l'effet de changement de HP",
  T_46_META_WS_P_ISPLAYING: "Joue",
  T_46_META_WS_P_ISPURCHASABLE: "Liste des articles",
  T_46_META_WS_P_ISREVERSE: "Inverser",
  T_46_META_WS_P_ISSERVERDRIVEN: "Contrôlé par le serveur",
  T_46_META_WS_P_ISSHOW: "Afficher",
  T_46_META_WS_P_ISSHOWHUDNAME: "Afficher le Nom HUD",
  T_46_META_WS_P_ISSHOWMAPINFO: "Afficher les Informations sur la Carte",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Afficher le Message Rapide",
  T_46_META_WS_P_ISSHOWSCAN: "Afficher le Scan",
  T_46_META_WS_P_ISSHOWTAG: "Afficher le Tag",
  T_46_META_WS_P_ISSIDECOLLIDING: "Collision latérale",
  T_46_META_WS_P_ISSILENCE: "Est Mis en Silence",
  T_46_META_WS_P_ISSINGLESHOT: "Est Tir Unique",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Est Ignorer L'animation Décalée",
  T_46_META_WS_P_ISSLIDING: "Glisse-t-il",
  T_46_META_WS_P_ISTOPCOLLIDING: "Collision supérieure",
  T_46_META_WS_P_ISUNDERLINE: "Souligné",
  T_46_META_WS_P_ISVISIBLE: "Est Visible",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "Couleurs de fond des cartes",
  T_46_META_WS_P_ITEMBACKGROUNDS: "Arrière-plan des cartes",
  T_46_META_WS_P_ITEMCOUNTS: "Achat possible",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "Descriptions des cartes",
  T_46_META_WS_P_ITEMICONS: "Icônes des cartes",
  T_46_META_WS_P_ITEMID: "ID D'article",
  T_46_META_WS_P_ITEMIDS: "IDs De L'article",
  T_46_META_WS_P_ITEMNAMES: "Noms des cartes",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Liste Des Articles Interdits Au Ramassage",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Rayon de Glissement du Cap du Joystick",
  T_46_META_WS_P_JOYSTICKIMAGE: "Image du Cap du Joystick",
  T_46_META_WS_P_JOYSTICKRADIUS: "Rayon du Cap du Joystick",
  T_46_META_WS_P_JUMPCD: "CD De Saut",
  T_46_META_WS_P_JUMPHEIGHT: "Hauteur de saut",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Échelle De L'hauteur Du Saut",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Bonus De Dégâts De Renversement",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Statut de renversement",
  T_46_META_WS_P_LABEL: "Étiquette",
  T_46_META_WS_P_LABELCOLOR: "Couleur de l'Étiquette",
  T_46_META_WS_P_LABELKEY: "Clé de l'étiquette",
  T_46_META_WS_P_LABELPARAMS: "Paramètres de l'étiquette",
  T_46_META_WS_P_LASTCHECKPOINTID: "ID Du Point De Contrôle Actuel",
  T_46_META_WS_P_LASTSURVIVALTIME: "Dernier Temps De Survie",
  T_46_META_WS_P_LAYERTYPE: "Type de Couche",
  T_46_META_WS_P_LAYOUTTYPE: "Type de Mise en Page",
  T_46_META_WS_P_LEFTARM: "Bras Gauche",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Couleur de fond à gauche",
  T_46_META_WS_P_LEFTCOLOR: "Couleur à gauche",
  T_46_META_WS_P_LEFTDESCRIPTION: "Description à gauche",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Effet Gauche Actif",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Angle De Tir à Gauche",
  T_46_META_WS_P_LEFTFOOT: "Pied Gauche",
  T_46_META_WS_P_LEFTHAND: "Main Gauche",
  T_46_META_WS_P_LEFTICON: "Icône gauche",
  T_46_META_WS_P_LEFTICONNAME: "Nom de l'icône à gauche",
  T_46_META_WS_P_LEFTLEG: "Jambe Gauche",
  T_46_META_WS_P_LEFTPLAYERS: "Joueurs de gauche",
  T_46_META_WS_P_LEFTSCORE: "Score gauche",
  T_46_META_WS_P_LEFTSCOREAFTER: "Score final gauche",
  T_46_META_WS_P_LEFTSCORETEXT: "Score gauche",
  T_46_META_WS_P_LEFTTEAM: "Équipe droite",
  T_46_META_WS_P_LEFTTEAMINDEX: "Indice de l'équipe gauche",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Nombre de joueurs vivants à gauche",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Nombre de drapeaux à gauche",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "États à gauche",
  T_46_META_WS_P_LEFTTEAMNAME: "Nom de l'équipe de gauche",
  T_46_META_WS_P_LEFTTEAMSCORE: "Score de l'équipe de gauche",
  T_46_META_WS_P_LEFTTEXT: "Texte gauche",
  T_46_META_WS_P_LENGTH: "Longueur",
  T_46_META_WS_P_LENSFLARE: "Facteur de Flare",
  T_46_META_WS_P_LEVEL: "Niveau",
  T_46_META_WS_P_LIFETIME: "Durée de Vie (s)",
  T_46_META_WS_P_LIGHTCOLOR: "Couleur de Lumière",
  T_46_META_WS_P_LIGHTINTENSITY: "Intensité De Lumière",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Facteur de dégâts aux membres",
  T_46_META_WS_P_LINESPACING: "Espacement des Lignes",
  T_46_META_WS_P_LOCALPOSITION: "Position locale",
  T_46_META_WS_P_LOCALROTATION: "Rotation Locale",
  T_46_META_WS_P_LOCALROTATIONQ: "Quaternion De Rotation Locale",
  T_46_META_WS_P_LOCALSCALE: "Échelle Locale",
  T_46_META_WS_P_LOCKEY: "Clé de Localisation",
  T_46_META_WS_P_LOOPCOUNT: "Nombre de boucles",
  T_46_META_WS_P_LOOTSOCCER: "Loot Soccer",
  T_46_META_WS_P_LOSEHPCOLOR: "Couleur de perte de HP",
  T_46_META_WS_P_LOSEMVPS: "MVP de la Défaite",
  T_46_META_WS_P_LOSETEXT: "Texte de défaite",
  "T_46_META_WS_P_MAIN CAMERA": "Caméra Principale",
  T_46_META_WS_P_MAINCOLOR: "Couleur principale",
  T_46_META_WS_P_MAINSCORELIST: "Scores Principaux",
  T_46_META_WS_P_MAINSCORETITLE: "Titre Principal du Score",
  T_46_META_WS_P_MAINWEAPON: "Arme Principale",
  T_46_META_WS_P_MAPSIZE: "Taille de la carte",
  T_46_META_WS_P_MASK: "Masque",
  T_46_META_WS_P_MASKNAME: "Nom du Masque",
  T_46_META_WS_P_MASS: "Masse (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "Titre du Match Gauche",
  T_46_META_WS_P_MATCHTITLERIGHT: "Titre du Match Droite",
  T_46_META_WS_P_MAXCAPACITY: "Capacité Max",
  T_46_META_WS_P_MAXCOUNT: "Nombre Max.",
  T_46_META_WS_P_MAXDAMAGE: "Dégâts Max.",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Angle De Dépression Max",
  T_46_META_WS_P_MAXDISPLACEMENT: "Déplacement Max.",
  T_46_META_WS_P_MAXDISTANCE: "Distance Max.",
  T_46_META_WS_P_MAXDURABILITY: "Durabilité Max",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Coefficient De Durabilité Max.",
  T_46_META_WS_P_MAXENERGY: "Énergie Max",
  T_46_META_WS_P_MAXEP: "EP Max",
  T_46_META_WS_P_MAXHP: "PV Max.",
  T_46_META_WS_P_MAXJUMPCOUNT: "Nombre maximum de sauts",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Hauteur De Saut Max",
  T_46_META_WS_P_MAXLENGTH: "Longueur Maximale",
  T_46_META_WS_P_MAXPROGRESS: "Progression maximale",
  T_46_META_WS_P_MAXSCATTERRATIO: "Ratio de Dispersion Maximal",
  T_46_META_WS_P_MAXSPEED: "Vitesse maximale",
  T_46_META_WS_P_MAXTURRETCOUNT: "Max. Nombre de Tourelles",
  T_46_META_WS_P_MAXVALUE: "Valeur max",
  T_46_META_WS_P_MAXWIDGETID: "ID Widget maximum",
  T_46_META_WS_P_MINDAMAGE: "Dégâts Min",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Distance Min De Dégâts",
  T_46_META_WS_P_MINDISTANCE: "Distance Min.",
  T_46_META_WS_P_MINELEVATIONANGLE: "Angle D'élévation Min.",
  T_46_META_WS_P_MINENDHEIGHT: "Hauteur Minimale de Fin",
  T_46_META_WS_P_MINFLYHEIGHT: "Hauteur Min. De Vol",
  T_46_META_WS_P_MINMOVEDISTANCE: "Distance minimale de déplacement",
  T_46_META_WS_P_MINVALUE: "Valeur minimale",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Dégâts maximum de missile",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Dégâts Minimum De Missile",
  T_46_META_WS_P_MISSILERANGE: "Portée du Missile",
  T_46_META_WS_P_MODEL: "Modèle",
  T_46_META_WS_P_MODELVISIBILITY: "Visibilité du modèle",
  T_46_META_WS_P_MODELVISIBLE: "Modèle Visible",
  T_46_META_WS_P_MONEY: "Argent",
  T_46_META_WS_P_MONEYLIST: "Liste D'argent",
  T_46_META_WS_P_MONEYS: "Portefeuille lié",
  T_46_META_WS_P_MONEYTYPE: "Type de monnaie",
  T_46_META_WS_P_MONSTERTYPE: "Type de Monstre",
  T_46_META_WS_P_MOTIONTYPE: "Type de mouvement",
  T_46_META_WS_P_MOTIONVALUEX: "Valeur du mouvement X",
  T_46_META_WS_P_MOTIONVALUEY: "Valeur du mouvement Y",
  T_46_META_WS_P_MOTIONVALUEZ: "Valeur du mouvement Z",
  T_46_META_WS_P_MOVEMENTDURATION: "Durée du mouvement",
  T_46_META_WS_P_MULTIPLIER: "Multiplicateur",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Type d'élément musical",
  T_46_META_WS_P_MUZZLEVELOCITY: "Vélocité De La Bouche",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Nom",
  T_46_META_WS_P_NEXTROUNDINDEX: "Indice du round suivant",
  T_46_META_WS_P_NICKNAME: "Pseudonyme",
  T_46_META_WS_P_NORMALCOLOR: "Couleur Normale",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Position Normalisée",
  T_46_META_WS_P_NUMBERINFACTION: "Numéro Dans la Faction",
  T_46_META_WS_P_OBJECTID: "ID de l'objet",
  T_46_META_WS_P_OFFSET: "Décalage",
  T_46_META_WS_P_OPTIONS: "Options",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Autre Facteur De Dégâts",
  T_46_META_WS_P_OUTFIT: "Tenue",
  T_46_META_WS_P_OVERFLOW: "Débordement",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Vitesse De Chute De La Sur-Hauteur",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Priorité à la configuration du joueur",
  T_46_META_WS_P_OWNER: "Propriétaire",
  T_46_META_WS_P_PARAMS: "Paramètres de description",
  T_46_META_WS_P_PARENT: "Parent",
  T_46_META_WS_P_PARENTID: "ID parent",
  T_46_META_WS_P_PARENTUI: "UI parent",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "ID De L'entité Du Widget Parent",
  T_46_META_WS_P_PARENTWIDGETFILEID: "FileID du Widget Parent",
  T_46_META_WS_P_PARTMASKA: "Masque de pièce 1",
  T_46_META_WS_P_PASSENGERS: "Passagers",
  T_46_META_WS_P_PATHID: "ID De Chemin",
  T_46_META_WS_P_PAUSEEVENT: "Pause de l'événement",
  T_46_META_WS_P_PERSONAID: "ID de persona",
  T_46_META_WS_P_PHASEDURATION: "Durée (ms)",
  T_46_META_WS_P_PHASEENDTIME: "Heure de fin (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "Couche physique",
  T_46_META_WS_P_PINID: "ID insigne",
  T_46_META_WS_P_PITCH: "Terrain",
  T_46_META_WS_P_PIVOT: "Pivot",
  T_46_META_WS_P_PLAYER: "Joueur",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Facteur de Vitesse de Visée du Joueur",
  T_46_META_WS_P_PLAYERLIST: "Liste des Joueurs",
  T_46_META_WS_P_PLAYERNAME: "Nom du joueur",
  T_46_META_WS_P_PLAYERRANK: "Classement du Joueur",
  T_46_META_WS_P_PLAYERRANKS: "Classements des joueurs",
  T_46_META_WS_P_PLAYERS: "Joueurs",
  T_46_META_WS_P_PLAYERSCORETYPES: "Types de score des joueurs",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Facteur De Vitesse Du Joueur",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Facteur De Vitesse Du Joueur Lors Du Tir",
  T_46_META_WS_P_PLAYERSTATUS: "Statut Du Joueur",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Vitesse De Traction Du Joueur",
  T_46_META_WS_P_PLAYINGSTATUS: "Statut du Jeu",
  T_46_META_WS_P_PLAYSPEED: "Vitesse de lecture",
  T_46_META_WS_P_POINTPOSITION: "Position du point",
  T_46_META_WS_P_POINTS: "Points",
  T_46_META_WS_P_POSITION: "Position",
  T_46_META_WS_P_PREFABID: "ID préfabriqué",
  T_46_META_WS_P_PRESSEDCOLOR: "Couleur Pressée",
  T_46_META_WS_P_PRESSEDSPRITE: "Sprite Pressé",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Type de Sprite Pressé",
  T_46_META_WS_P_PRICE: "Prix",
  T_46_META_WS_P_PRIORITY: "Priorité",
  T_46_META_WS_P_PROFILEINFO: "Informations de Profil",
  T_46_META_WS_P_PROGRESS: "Progression [0,1]",
  T_46_META_WS_P_PROGRESSICON: "Icône de progression",
  T_46_META_WS_P_PROGRESSICONNAME: "Nom de l'icône de progression",
  T_46_META_WS_P_PROPID: "ID du Prop",
  T_46_META_WS_P_PURCHASELIMIT: "Limite d'achat",
  T_46_META_WS_P_RADIUS: "Rayon",
  T_46_META_WS_P_RANGE: "Portée",
  T_46_META_WS_P_RANK: "Rang",
  T_46_META_WS_P_RATIOSELFFACTOR: "Facteur De Dégâts Personnels",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Proportion du Facteur Coéquipier",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Proportion Du Facteur De Véhicule",
  T_46_META_WS_P_REFRESHTIME: "Temps de rafraîchissement du buff (s)",
  T_46_META_WS_P_RELOADSPEED: "Vitesse de rechargement",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Facteur De Vitesse De Rechargement",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Sauts restants",
  T_46_META_WS_P_REMAINQUANTITY: "Quantité restante",
  T_46_META_WS_P_RENDERTYPE: "Type De Rendu",
  T_46_META_WS_P_REPEATTIMES: "Nombre De Répétitions",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Priorité De Remplacement",
  T_46_META_WS_P_REQUESTEDITEMLIST: "ID du joueur déclencheur",
  T_46_META_WS_P_REQUESTTYPE: "Liste des articles demandés",
  T_46_META_WS_P_RESETPERROUND: "Réinitialisation Par Tour",
  T_46_META_WS_P_RESETPOSITION: "Réinitialiser La Position",
  T_46_META_WS_P_RESETTIME: "Temps De Réinitialisation",
  T_46_META_WS_P_RESOURCE: "Ressource",
  T_46_META_WS_P_RESOURCEID: "ID De Ressource",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Restriction dans le Panneau",
  T_46_META_WS_P_RESULT: "Résultat",
  T_46_META_WS_P_RESULTTYPE: "Type de résultat",
  T_46_META_WS_P_REVIVALPOINT: "Point De Reanimation",
  T_46_META_WS_P_REVIVECD: "CD De Réanimation",
  T_46_META_WS_P_RIGHT: "Droite",
  T_46_META_WS_P_RIGHTARM: "Bras Droit",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Couleur de fond à droite",
  T_46_META_WS_P_RIGHTCOLOR: "Couleur à droite",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Description à droite",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Effet Droit Actif",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Angle De Tir à Droite",
  T_46_META_WS_P_RIGHTFOOT: "Pied Droit",
  T_46_META_WS_P_RIGHTHAND: "Main Droite",
  T_46_META_WS_P_RIGHTICON: "Icône droite",
  T_46_META_WS_P_RIGHTICONNAME: "Nom de l'icône à droite",
  T_46_META_WS_P_RIGHTLEG: "Jambe Droite",
  T_46_META_WS_P_RIGHTPLAYERS: "Joueurs de droite",
  T_46_META_WS_P_RIGHTSCORE: "Score droite",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Score final droite",
  T_46_META_WS_P_RIGHTSCORETEXT: "Score droite",
  T_46_META_WS_P_RIGHTTEAM: "Titres",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Indice de l'équipe droite",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Nombre de joueurs vivants à droite",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Nombre de drapeaux du joueur de droite",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "États à droite",
  T_46_META_WS_P_RIGHTTEAMNAME: "Nom de l'équipe de droite",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Score de l'équipe de droite",
  T_46_META_WS_P_RIGHTTEXT: "Texte droite",
  T_46_META_WS_P_RIMALPHA: "Alpha de bordure",
  T_46_META_WS_P_RIMCOLOR: "Couleur De La Jante",
  T_46_META_WS_P_RIMTEXTURE: "Texture De Bordure",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Coefficient De Frottement Au Roulement",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Coefficient de frottement en course",
  T_46_META_WS_P_ROTATION: "Rotation",
  T_46_META_WS_P_ROTATIONANGLE: "Angle de rotation",
  T_46_META_WS_P_ROTATIONQ: "Rotation Quaternion",
  T_46_META_WS_P_ROUNDINCOME: "Revenus de round",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Nombres des détails de revenu par tour",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Titres Des Détails De Revenu Par Tour",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Titre des revenus de round",
  T_46_META_WS_P_ROUNDNUM: "Numéro de tour",
  T_46_META_WS_P_ROUNDNUMKEY: "Clé de tour",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Paramètres de clé de tour",
  T_46_META_WS_P_RUNSPEED: "Vitesse De Course",
  T_46_META_WS_P_RUNSPEEDSCALE: "Échelle de Vitesse de Course",
  T_46_META_WS_P_RUSHDISTANCE: "Distance de Ruée",
  T_46_META_WS_P_RUSHENERGYCOST: "Coût D'énergie De Ruée",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Vitesse Verticale De Ruée",
  T_46_META_WS_P_SCALE: "Échelle",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Vitesse D'augmentation De Dispersion",
  T_46_META_WS_P_SCATTERMAX: "Dispersion maximale",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Multiplicateur De Dispersion En Mouvement",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Vitesse de Récupération De La Dispersion",
  T_46_META_WS_P_SCATTERSPEED: "Vitesse de Dispersion",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Vitesse de dispersion Accroupi Couché",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Seuil de dispersion",
  T_46_META_WS_P_SCOPETYPE: "Type de lunette",
  T_46_META_WS_P_SCORE: "Score",
  T_46_META_WS_P_SCORES1: "Liste des Scores 1",
  T_46_META_WS_P_SCORES2: "Liste des Scores 2",
  T_46_META_WS_P_SCORES3: "Liste des Scores 3",
  T_46_META_WS_P_SCORES4: "Liste des Scores 4",
  T_46_META_WS_P_SCORES5: "Liste des Scores 5",
  T_46_META_WS_P_SCORETEXTKEY: "Clé du texte du score",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Paramètres de la clé du texte du score",
  T_46_META_WS_P_SCROLLCONTINUITY: "Continuité du Défilement",
  T_46_META_WS_P_SCROLLDIRECTION: "Direction du Défilement",
  T_46_META_WS_P_SCROLLEFFECT: "Effet de Défilement",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Vitesse de Défilement de la Roue",
  T_46_META_WS_P_SECONDSCORETITLE: "Titre du deuxième score",
  T_46_META_WS_P_SECONDSCOREVALUE: "Valeur du deuxième score",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "Paramètres du deuxième score",
  T_46_META_WS_P_SELECTEDCOLOR: "Couleur Sélectionnée",
  T_46_META_WS_P_SELECTEDINDEX: "Index de l'élément sélectionné",
  T_46_META_WS_P_SELECTEDSPRITE: "Sprite Sélectionné",
  T_46_META_WS_P_SELECTEDTYPE: "Type Sélectionné",
  T_46_META_WS_P_SELF: "Soi",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Facteur De Dégâts à Soi-Même",
  T_46_META_WS_P_SET: "Ensemble",
  T_46_META_WS_P_SHADERNAME: "Nom du Shader",
  T_46_META_WS_P_SHADOWCOLOR: "Couleur de l'Ombre",
  T_46_META_WS_P_SHADOWOFFSET: "Décalage de l'Ombre",
  T_46_META_WS_P_SHADOWSTRENGTH: "Force De L'ombre",
  T_46_META_WS_P_SHELFS: "Fermeture manuelle désactivée",
  T_46_META_WS_P_SHOES: "Chaussures",
  T_46_META_WS_P_SHOOTANGLEMAX: "Angle De Tir Max",
  T_46_META_WS_P_SHOOTANGLEMIN: "Angle De Tir Min",
  T_46_META_WS_P_SHOP: "Boutique",
  T_46_META_WS_P_SHOPITEMS: "Liste des étagères",
  T_46_META_WS_P_SHOWADDFRIEND: "Afficher Ajouter un Ami",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Afficher grenade d'attaque",
  T_46_META_WS_P_SHOWBACKGROUND: "Afficher L'arrière-Plan",
  T_46_META_WS_P_SHOWCROUCH: "Afficher accroupi",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Afficher Le Numéro De Dégâts",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Afficher grenade de défense",
  T_46_META_WS_P_SHOWECCONOMY: "Afficher l'Économie",
  T_46_META_WS_P_SHOWECONOMY: "Afficher l'Économie",
  T_46_META_WS_P_SHOWFIRE: "Afficher tir",
  T_46_META_WS_P_SHOWFRAME: "Afficher le cadre",
  T_46_META_WS_P_SHOWGIFT: "Afficher le Cadeau",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Montrer L'effet Du Point D'impact",
  T_46_META_WS_P_SHOWJUMP: "Afficher saut",
  T_46_META_WS_P_SHOWLIKE: "Afficher les J'aime",
  T_46_META_WS_P_SHOWLOBBY: "Afficher le Hall",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Afficher l'Évaluation de la Carte",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Afficher les Détails du Match",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Afficher joystick",
  T_46_META_WS_P_SHOWNAME: "Afficher le Surnom",
  T_46_META_WS_P_SHOWPIN: "Afficher l'Épinglette",
  T_46_META_WS_P_SHOWPRONE: "Afficher couché",
  T_46_META_WS_P_SHOWRANK: "Afficher le Rang",
  T_46_META_WS_P_SHOWREPLAY: "Afficher la Relecture",
  T_46_META_WS_P_SHOWREPORT: "Afficher le Rapport",
  T_46_META_WS_P_SHOWSHARE: "Afficher le Partage",
  T_46_META_WS_P_SHOWSPRINT: "Afficher course",
  T_46_META_WS_P_SHOWTAG: "Afficher les balises",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Afficher infos coéquipiers",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "État de l'équipe",
  T_46_META_WS_P_SHOWTEAMSCORE: "Afficher le score de l'équipe",
  T_46_META_WS_P_SHOWTIMETYPE: "Afficher le temps",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "Score des deux équipes",
  T_46_META_WS_P_SHRINKDURATION: "Durée de réduction (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "Temps de fin de réduction (ms)",
  T_46_META_WS_P_SHRINKSPEED: "Taux De Convergence",
  T_46_META_WS_P_SHRINKSTARTTIME: "Temps de début de réduction (s)",
  T_46_META_WS_P_SIGHTAIMASSIST: "Autoriser L'assistance à La Visée ADS",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Coefficient d'atténuation de la distance de l'assistance à la visée (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Coefficient D'impact De Priorité De La Distance D'assistance À La Visée (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Distance maximale prioritaire pour l'assistance à la visée",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Distance Minimale Prioritaire Pour L'assistance à la Visée",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Autoriser La Distance D'assistance à La Visée D'abord",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Ratio d'attraction de la réticule d'assistance à la visée sur l'écran (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Coefficient d'amplification de la visée",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "Agrandissement FOV",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "Sensibilité de Rotation de L'ADS",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "Coefficient X De Correction De La Distance Minimale De Dégâts De L'ADS",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "Temps D'agrandissement ADS (s)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "Agrandissement ADS",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "Temps De Récupération ADS (s)",
  T_46_META_WS_P_SIZE: "Taille",
  T_46_META_WS_P_SIZEDELTA: "Delta de taille",
  T_46_META_WS_P_SKELETON: "Squelette",
  T_46_META_WS_P_SKIN: "Skin",
  T_46_META_WS_P_SKINID: "ID du Skin",
  T_46_META_WS_P_SKINWIDTH: "Épaisseur de la peau",
  T_46_META_WS_P_SKYBOXENV: "Skybox",
  T_46_META_WS_P_SKYBOXRESOURCE: "Ressource Du Skybox",
  T_46_META_WS_P_SLOPELIMIT: "Limite de pente",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Début du Défilement Souple",
  T_46_META_WS_P_SOFTNESS: "Douceur",
  T_46_META_WS_P_SORTTYPE: "Type de Tri",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Nombre D'apparitions Par Vague",
  T_46_META_WS_P_SPAWNPOINT: "Point D'apparition",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Nombre de Points D'apparition",
  T_46_META_WS_P_SPAWNPOSITION: "Position D'apparition",
  T_46_META_WS_P_SPEED: "Vitesse",
  T_46_META_WS_P_SPEEDWHILEAIMING: "Taux Vitesse de Mouvement ADS",
  T_46_META_WS_P_SPRAYCOLOR: "Couleur de Pulvérisation",
  T_46_META_WS_P_SPRINTENERGYCOST: "Coût Énergétique Pour Le Sprint",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Vitesse Horizontale du Sprint",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Échelle de Vitesse du Sprint",
  T_46_META_WS_P_SPRITENAME: "Forme du sprite",
  T_46_META_WS_P_SPRITERESOURCE: "Ressource Sprite",
  T_46_META_WS_P_SRCVAL: "Valeur Src",
  T_46_META_WS_P_STARTDROPTIME: "Heure de début du dépôt (ms)",
  T_46_META_WS_P_STARTEVENT: "Démarrer l'événement",
  T_46_META_WS_P_STARTPOSITION: "Position de Départ",
  T_46_META_WS_P_STARTRADIUS: "Rayon de départ",
  T_46_META_WS_P_STARTSPAWNTIME: "Temps de spawn de départ (s)",
  T_46_META_WS_P_STARTTIME: "Heure de début (s)",
  T_46_META_WS_P_STARTVALUE: "Valeur de Départ",
  T_46_META_WS_P_STATICICONCOLORS: "Couleurs des icônes statiques",
  T_46_META_WS_P_STATICICONS: "Icônes statiques",
  T_46_META_WS_P_STATUS: "État du mini-sentry",
  T_46_META_WS_P_STEPOFFSET: "Décalage de marche",
  T_46_META_WS_P_STOPDURATION: "Durée d'arrêt",
  T_46_META_WS_P_STOPEVENT: "Arrêter l'événement",
  T_46_META_WS_P_STORE: "Magasin",
  T_46_META_WS_P_STROPID: "ID du Strop",
  T_46_META_WS_P_STYLE: "Style",
  T_46_META_WS_P_SUBTITLE: "Sous-titre",
  T_46_META_WS_P_SUMMULTIPLIER: "Multiplicateur de somme",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Accélération de Sortie de Balancement",
  T_46_META_WS_P_SWINGINGSPEED: "Vitesse De Balancement",
  T_46_META_WS_P_TAGS: "Balises",
  T_46_META_WS_P_TARGETCHECKPOINTID: "ID du Point de Contrôle Cible",
  T_46_META_WS_P_TARGETICONCOLORS: "Couleurs des icônes cibles",
  T_46_META_WS_P_TARGETICONS: "Icônes cibles",
  T_46_META_WS_P_TARGETID: "ID de la cible",
  T_46_META_WS_P_TARGETITEMID: "ID de l'Élément Cible",
  T_46_META_WS_P_TARGETROTATION: "Rotation Cible",
  T_46_META_WS_P_TARGETSCALE: "Échelle Cible",
  T_46_META_WS_P_TEAMCOLOR: "Couleur de l'équipe",
  T_46_META_WS_P_TEAMCOLORS: "Couleurs des équipes",
  T_46_META_WS_P_TEAMINDEXS: "Indices des équipes",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Facteur De Dégâts Des Coéquipiers",
  T_46_META_WS_P_TEAMMEMBERNUM: "Nombre De Membres D’équipe",
  T_46_META_WS_P_TEAMNUM: "Nombre D'équipes",
  T_46_META_WS_P_TEAMRANK: "Classement de l'Équipe",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Affichage du Classement de l'Équipe",
  T_46_META_WS_P_TEAMRANKS: "Classements des équipes",
  T_46_META_WS_P_TEAMSCORES: "Scores des équipes",
  T_46_META_WS_P_TEAMSEQ: "Séquence de l'Équipe",
  T_46_META_WS_P_TEMPLATEENTITY: "Entité Modèle",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Points De Boucliers Temporaires",
  T_46_META_WS_P_TERRAINWETNESS: "Humidité Du Terrain",
  T_46_META_WS_P_TEXT: "Texte",
  T_46_META_WS_P_TEXTCOLOR: "Couleur du texte",
  T_46_META_WS_P_TEXTKEY: "Clé de texte",
  T_46_META_WS_P_TEXTKEYPARAMS: "Paramètres de clé de texte",
  T_46_META_WS_P_TEXTURERESOURCE: "Ressource de Texture",
  T_46_META_WS_P_THEMECOLOR: "Couleur du thème",
  T_46_META_WS_P_THROWABLETYPE: "Type d'objet jetable",
  T_46_META_WS_P_THROWINGSPEED: "Vitesse De Lancer",
  T_46_META_WS_P_THROWSPEED: "Vitesse De Lancer",
  T_46_META_WS_P_TICKINTERVAL: "Intervalle de tick",
  T_46_META_WS_P_TIMEREQUIRED: "Temps Requis (ms)",
  T_46_META_WS_P_TIPSTYPE: "Type de conseil",
  T_46_META_WS_P_TITLE: "Titre",
  T_46_META_WS_P_TITLELIST: "Titres",
  T_46_META_WS_P_TITLES: "Scores 1",
  T_46_META_WS_P_TOP: "Usure Du Haut",
  T_46_META_WS_P_TOPALPHA: "Alpha Haut",
  T_46_META_WS_P_TOTALHP: "HP total",
  T_46_META_WS_P_TOTALLEVEL: "Niveau total",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Nombre Total De Tours",
  T_46_META_WS_P_TOWSPEED: "Vitesse de Remorquage",
  T_46_META_WS_P_TRANSITIONSTAGE: "Phase de transition",
  T_46_META_WS_P_TRANSITIONTYPE: "Type de Transition",
  T_46_META_WS_P_TRIGGERPLAYERID: "Argent",
  T_46_META_WS_P_TRIGGERRADIUS: "Portée De Déclenchement",
  T_46_META_WS_P_TRIGGERRANGE: "Plage de déclenchement",
  T_46_META_WS_P_TRIGGERTIME: "Temps De Déclenchement",
  T_46_META_WS_P_TURNSPEED: "Vitesse de Rotation",
  T_46_META_WS_P_TWEENERENABLED: "Équipe gauche",
  T_46_META_WS_P_TWEENSTYLE: "Style de Transition",
  T_46_META_WS_P_TYPE: "Type",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Couleur Non Sélectionnée",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Sprite Non Sélectionné",
  T_46_META_WS_P_UNSELECTEDTYPE: "Type Non Sélectionné",
  T_46_META_WS_P_UP: "Haut",
  T_46_META_WS_P_UPDATETYPE: "Type de mise à jour",
  T_46_META_WS_P_UPENERGYCOST: "Coût D'augmentation De L'énergie",
  T_46_META_WS_P_UPSPEED: "Vitesse vers le haut",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Force de poussée personnalisée",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Utiliser une ressource personnalisée",
  T_46_META_WS_P_USEDCAPACITY: "Capacité Utilisée",
  T_46_META_WS_P_USEGRAVITY: "Utiliser la gravité",
  T_46_META_WS_P_USEPHYSICALCCT: "Utiliser CCT physique",
  T_46_META_WS_P_USERUID: "UID de L'utilisateur",
  T_46_META_WS_P_UVOFFSET: "Décalage UV",
  T_46_META_WS_P_UVSIZE: "Taille UV",
  T_46_META_WS_P_VALUE: "Valeur",
  T_46_META_WS_P_VAULTDISTANCE: "Distance de saut",
  T_46_META_WS_P_VAULTHEIGHT: "Hauteur de saut",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Facteur De Dégâts Au Véhicule",
  T_46_META_WS_P_VEHICLESKINID: "ID de la peau du véhicule",
  T_46_META_WS_P_VEHICLESKINIDS: "ID De Skin De Véhicule",
  T_46_META_WS_P_VELOCITY: "Vitesse (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "Vitesse XZ",
  T_46_META_WS_P_VELOCITYY: "Vitesse Y",
  T_46_META_WS_P_VERTICALBAR: "Barre Verticale",
  T_46_META_WS_P_VERTICALOFFSET: "Décalage Vertical",
  T_46_META_WS_P_VEST: "Gilet",
  T_46_META_WS_P_VFXTEXTURETYPE: "Type de texture VFX",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Restriction De L'angle De Vue",
  T_46_META_WS_P_VISIBILITYLAYER: "Couche De Visibilité",
  T_46_META_WS_P_VISIBLE: "Visible",
  T_46_META_WS_P_VISIBLEONBACK: "Visible Sur Le Dos",
  T_46_META_WS_P_VISIBLEPLAYERS: "Joueurs visibles",
  T_46_META_WS_P_VOLUME: "Volume",
  T_46_META_WS_P_WALLETID: "ID de Portefeuille",
  T_46_META_WS_P_WANDERRANGE: "Portée De Déplacement",
  T_46_META_WS_P_WAVECOUNT: "Nombre de vagues",
  T_46_META_WS_P_WAVEINTERVAL: "Intervalle entre les vagues",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Taux De Dégâts D'arme",
  T_46_META_WS_P_WEAPONSKINIDS: "ID's de Skin D'arme",
  T_46_META_WS_P_WEAPONSUBTYPE: "Sous-Type D'arme",
  T_46_META_WS_P_WEAPONTYPE: "Type d'arme",
  T_46_META_WS_P_WIDTH: "Largeur",
  T_46_META_WS_P_WINMVPS: "MVP de la Victoire",
  T_46_META_WS_P_WINTEXT: "Texte de victoire",
  T_46_META_WS_P_WORDWRAP: "Enveloppement de Mots",
  T_46_META_WS_P_WORLDPOSITION: "Position mondiale",
  T_46_META_WS_P_YAW: "Yaw",
  T_46_META_WS_PATROLALONG: "Patrouiller le long de",
  T_46_META_WS_PATROLTO: "Patrouiller jusqu'à",
  T_46_META_WS_PAUSE: "Pause",
  T_46_META_WS_PAUSEEMOTE: "Mettre en Pause l'Émote",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Suspendre la mise à jour fixe",
  T_46_META_WS_PHASE: "Phase",
  T_46_META_WS_PLAY: "Jouer",
  T_46_META_WS_PLAYANIMATION: "Jouer l'animation",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Jouer le clip d'animation du personnage",
  T_46_META_WS_PLAYEMOTE: "Jouer l'Émote",
  T_46_META_WS_PLAYER: "Joueur",
  T_46_META_WS_PORTAL: "Portail",
  T_46_META_WS_POSE: "Pose",
  T_46_META_WS_POSITION: "Position",
  T_46_META_WS_PREPOSE: "Pré-pose ",
  T_46_META_WS_PROFANITYFILTER: "Filtre de profanité",
  T_46_META_WS_PURSUITTARGET: "Cible de poursuite",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Quaternion en angle d'axe",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Quaternion en angles d'Euler",
  T_46_META_WS_QUITCHATCHANNEL: "Quitter le canal de discussion",
  T_46_META_WS_QUITFACTION: "Quitter la faction",
  T_46_META_WS_QUITGAME: "Quitter le jeu",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Quitter le mini-jeu de jailbreak",
  T_46_META_WS_RANDOMFLOAT: "Flottant Aléatoire",
  T_46_META_WS_RANDOMINT: "Entier Aléatoire",
  T_46_META_WS_RANK: "Classement",
  T_46_META_WS_READCSV: "Lire CSV",
  T_46_META_WS_READCSVCELL: "Lire une cellule CSV",
  T_46_META_WS_READCSVCELLBYNAME: "Lire une cellule CSV par nom",
  T_46_META_WS_READCSVCELLFROMSERVER: "Lire une cellule CSV depuis le serveur",
  T_46_META_WS_READCSVCOLUMN: "Lire une colonne CSV",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "Lire une colonne CSV depuis le serveur",
  T_46_META_WS_READCSVFROMSERVER: "Lire CSV depuis le serveur",
  T_46_META_WS_READCSVROW: "Lire une ligne CSV",
  T_46_META_WS_READCSVROWBYKEY: "Lire une ligne CSV par clé",
  T_46_META_WS_READCSVROWFROMSERVER: "Lire une ligne CSV depuis le serveur",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Lire de la base de données accumulée",
  T_46_META_WS_READFROMDATASTORE: "Lire de la base de données",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Lire de la base de données du classement",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Lire de la base de données du classement par rang",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "Supprimer un suivi spécial AOI",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Supprimer la peau du sac à dos",
  T_46_META_WS_REMOVEBUFF: "Retirer un buff",
  T_46_META_WS_REMOVECOMPONENT: "Supprimer un composant",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Supprimer un facteur de propriété de formule",
  T_46_META_WS_REMOVEOUTFIT: "Enlever une tenue",
  T_46_META_WS_REMOVESCRIPT: "Supprimer un script",
  T_46_META_WS_REMOVEVEHICLESKIN: "Supprimer la peau du véhicule",
  T_46_META_WS_REMOVEWEAPONSKIN: "Enlever le skin d'arme",
  T_46_META_WS_REPLACE: "Remplacer",
  T_46_META_WS_REQUESTMATCHMAKING: "Demander un matchmaking",
  T_46_META_WS_RESET: "Réinitialiser",
  T_46_META_WS_RESETBACKPACKSKIN: "Réinitialiser la peau du sac à dos",
  T_46_META_WS_RESETDYEING: "Réinitialiser la teinture",
  T_46_META_WS_RESETJERSEY: "Réinitialiser le maillot",
  T_46_META_WS_RESETOUTFIT: "Réinitialiser la tenue",
  T_46_META_WS_RESETVEHICLESKIN: "Réinitialiser la peau du véhicule",
  T_46_META_WS_RESETWEAPONSKIN: "Réinitialiser le skin d'arme",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Reprendre la mise à jour fixe",
  T_46_META_WS_REVERSE: "Inverser",
  T_46_META_WS_REVIVALSOURCE: "Source de résurrection",
  T_46_META_WS_REVIVE: "Ressusciter",
  T_46_META_WS_ROUND: "Arrondir",
  T_46_META_WS_ROUNDINDEX: "Index de tour",
  T_46_META_WS_SAMPLEONCURVE: "Échantillonner sur la courbe",
  T_46_META_WS_SCENENAME: "Nom de la scène",
  T_46_META_WS_SCORE: "Score",
  T_46_META_WS_SCORER: "Buteur",
  T_46_META_WS_SCORETYPE: "Type de score",
  T_46_META_WS_SCREENMULTIRAYCAST: "Détection de rayons multiples sur écran",
  T_46_META_WS_SCREENSINGLERAYCAST: "Détection de rayon unique sur écran",
  T_46_META_WS_SCREENTOUCHRAY: "Rayon de toucher d'écran",
  T_46_META_WS_SCREENTOWORLDPOINT: "Écran à monde",
  T_46_META_WS_SENDEVENT: "Envoyer un événement",
  T_46_META_WS_SETACTIVE: "Définir actif",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Définir le Statut de Déplacement pour Tous les Joueurs",
  T_46_META_WS_SETATTACKABLEENTITY: "Définir l'entité attaquable",
  T_46_META_WS_SETATTACKABLEFACTION: "Définir la faction attaquable",
  T_46_META_WS_SETATTACKABLETEAM: "Définir l'équipe attaquable",
  T_46_META_WS_SETBACKPACKSKIN: "Définir la peau du sac à dos",
  T_46_META_WS_SETBEHAVIORSTATUS: "Définir le statut de comportement",
  T_46_META_WS_SETBLACKBOARDVALUE: "Définir la valeur du tableau noir",
  T_46_META_WS_SETBUNDLE: "Définir le pack",
  T_46_META_WS_SETCAMERAFOCUS: "Définir le focus de la caméra",
  T_46_META_WS_SETCAMERAFOLLOW: "Définir le suivi de la caméra",
  T_46_META_WS_SETCHARACTER: "Définir le personnage",
  T_46_META_WS_SETCULLINGMASK: "Définir le masque de culling",
  T_46_META_WS_SETCULLINGMASKLAYER: "Définir le masque de culling pour les couches",
  T_46_META_WS_SETDEFAULTUISTATUS: "Définir l'état UI par défaut",
  T_46_META_WS_SETDROPSTATUS: "Définir le statut de dépôt",
  T_46_META_WS_SETFALLINGDAMAGE: "Définir les dégâts de chute",
  T_46_META_WS_SETFOOTBALLPOSITION: "Définir la position du ballon",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Définir la propriété de formule absolue",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Définir la propriété de formule relative",
  T_46_META_WS_SETFORWARD: "Définir l'orientation",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Définir le seuil de sommeil global",
  T_46_META_WS_SETINVINCIBILITY: "Définir le Statut d'Invulnérabilité",
  T_46_META_WS_SETJERSEY: "Définir le maillot",
  T_46_META_WS_SETOUTFIT: "Définir une tenue",
  T_46_META_WS_SETPARENT: "Définir le parent",
  T_46_META_WS_SETPARENTCLIENT: "Définir le parent",
  T_46_META_WS_SETPICKUPSTATUS: "Définir le statut de ramassage",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Définir le statut de message rapide du joueur",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Définir le statut de voix du joueur",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Définir la propriété en douceur",
  T_46_META_WS_SETSKILLS: "Définir les compétences",
  T_46_META_WS_SETSKYBOX: "Définir le Skybox",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Définir le seuil de sommeil",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Définir le Statut de l'Élément Spécial",
  T_46_META_WS_SETVEHICLESKIN: "Définir la peau du véhicule",
  T_46_META_WS_SETWEAPONSKIN: "Définir un skin d'arme",
  T_46_META_WS_SETWIDGETPARENT: "Définir le parent du widget",
  T_46_META_WS_SHOPITEM: "Article de la boutique",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Afficher le groupe d'apparence",
  T_46_META_WS_SHUFFLE: "Mélanger",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "Détection de rayons unique",
  T_46_META_WS_SKILL: "Compétence",
  T_46_META_WS_SLEEP: "Dormir",
  T_46_META_WS_SLERPQUATERNION: "Interpolation de quaternion",
  T_46_META_WS_SPAWNABLES: "Objets générables",
  T_46_META_WS_SPAWNEDITEM: "Objet généré",
  T_46_META_WS_SPAWNNEXTWAVE: "Faire apparaître la prochaine vague",
  T_46_META_WS_SPHERECAST: "Détection de sphère",
  T_46_META_WS_SPHEREOVERLAP: "Superposition de sphère",
  T_46_META_WS_SPLIT: "Diviser",
  T_46_META_WS_SQRT: "Racine Carrée",
  T_46_META_WS_STARTPARACHUTE: "Commencer à parachuter",
  T_46_META_WS_STARTPOSITION: "Position de départ",
  T_46_META_WS_STATENAME: "Nom de l'état",
  T_46_META_WS_STATUS: "Statut",
  T_46_META_WS_STRINGTOFLOAT: "Chaîne en flottant",
  T_46_META_WS_STRINGTOINT: "Chaîne en entier",
  T_46_META_WS_STRIP: "Éliminer les espaces",
  T_46_META_WS_SUB: "Soustraire",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "Changer l'observateur proxy AOI",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Changer de groupe d'apparence",
  T_46_META_WS_SWITCHAREA: "Changer de zone",
  T_46_META_WS_SWITCHCAMERA: "Changer de caméra",
  T_46_META_WS_SWITCHPHASE: "Changer de Phase",
  T_46_META_WS_SWITCHSCENE: "Changer de scène",
  T_46_META_WS_SWITCHWEAPON: "Changer d'arme",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Cible",
  T_46_META_WS_TEAM: "Équipe",
  T_46_META_WS_TELEPORT: "Téléporter",
  T_46_META_WS_TELEPORTCCT: "Téléporter le CCT",
  T_46_META_WS_TEXT: "Texte",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Timestamp en chaîne de localisation",
  T_46_META_WS_TIRE: "Pneu",
  T_46_META_WS_TOLOWER: "Mettre en minuscules",
  T_46_META_WS_TOSTRING: "En chaîne",
  T_46_META_WS_TOUPPER: "Mettre en majuscules",
  T_46_META_WS_TRANSFERMONEY: "Transférer de l'argent",
  T_46_META_WS_TRIGGER: "Déclencheur",
  T_46_META_WS_TYPEIS: "Le type est",
  T_46_META_WS_UNLOADSCENE: "Décharger la scène",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "Mettre à jour la mission de jailbreak",
  T_46_META_WS_UPLOADGAMERESULT: "Télécharger le résultat du jeu",
  T_46_META_WS_VALUE: "Dégâts",
  T_46_META_WS_VECTOR2ANGLE: "Angle Vectoriel 2D",
  T_46_META_WS_VECTOR2DISTANCE: "Distance Vectorielle 2D",
  T_46_META_WS_VECTOR2DOT: "Produit Scalaire Vectoriel 2D",
  T_46_META_WS_VECTOR2MAGNITUDE: "Magnitude Vectorielle 2D",
  T_46_META_WS_VECTOR2NORMALIZE: "Normaliser le Vecteur 2D",
  T_46_META_WS_VECTOR2REFLECT: "Réflexion Vectorielle 2D",
  T_46_META_WS_VECTOR2TOVECTOR3: "Convertir Vecteur 2D en Vecteur 3D",
  T_46_META_WS_VECTOR3REFLECT: "Réflexion Vectorielle 3D",
  T_46_META_WS_VECTOR3TOVECTOR2: "Convertir Vecteur 3D en Vecteur 2D",
  T_46_META_WS_VEHICLE: "Véhicule",
  T_46_META_WS_VELOCITY: "Vitesse",
  T_46_META_WS_WAITFORMILESECOND: "Attendre les Millisecondes",
  T_46_META_WS_WAITFORNEXTFRAME: "Attendre le Prochain Frame",
  T_46_META_WS_WAKEUP: "Réveiller",
  T_46_META_WS_WAVES: "Vagues",
  T_46_META_WS_WEAPON: "Arme",
  T_46_META_WS_WORLDTOSCREENPOINT: "Monde à écran",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "Écrire dans la base de données accumulée",
  T_46_META_WS_WRITETODATASTORE: "Écrire dans la base de données",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "Écrire dans la base de données du classement",
  T_48_META_API_1_D: "Récupère tous les joueurs de la partie en cours et renvoie une liste de joueurs.",
  T_48_META_API_1_R_D: "Liste des joueurs",
  T_48_META_API_10_D: "Obtention d'objets de scène",
  T_48_META_API_10_P0_D: "Quels sont les types d'objets de la scène à filtrer ?",
  T_48_META_API_10_R_D: "Liste des objets de la scène",
  T_48_META_API_100_D: "Charger des scénarios sans décharger automatiquement les scénarios déjà chargés",
  T_48_META_API_100_P0_D: "ID de la scène à charger",
  T_48_META_API_10000_D: "Retourne l'entité à laquelle le script actuel est lié",
  T_48_META_API_10000_R_D: "L'entité à laquelle le script actuel est lié",
  T_48_META_API_10001_D: "Utilisez l'ID de l'entité pour trouver l'entité correspondante, cette API est réservée aux éditeurs, l'utilisation de cette API par l'utilisateur ne garantit pas sa compatibilité, comme la suppression ou l'ajustement de l'ID de l'entité.",
  T_48_META_API_10001_P0_D: "ID de l'entité cible",
  T_48_META_API_10001_R_D: "chose qui a une existence matérielle (par opposition à une existence conceptuelle, virtuelle ou en ligne)",
  T_48_META_API_10002_D: "Obtenir l'entité globale du jeu",
  T_48_META_API_10002_R_D: "entité mondiale",
  T_48_META_API_10003_D: "Téléporte les joueurs à des coordonnées spécifiques (obsolète, utiliser Téléport).",
  T_48_META_API_10003_P0_D: "Joueurs téléportés",
  T_48_META_API_10003_P1_D: "Coordonnées du point transporté",
  T_48_META_API_10004_D: "Obtient la position près des coéquipiers, ce qui permet de contourner la position des joueurs qui ne peuvent pas se tenir debout (obsolète, utiliser GetTeammateNearPosition).",
  T_48_META_API_10004_P0_D: "acteur cible",
  T_48_META_API_10004_R_D: "Coordonnées avec les coéquipiers",
  T_48_META_API_10005_D: "Joueurs appartenant à l'entité acquéreuse",
  T_48_META_API_10005_P0_D: "Entité cible, l'entité ne se synchronisera qu'avec le lecteur auquel elle appartient.",
  T_48_META_API_10005_R_D: "Joueurs appartenant à l'entité cible",
  T_48_META_API_10006_D: "Rendre le joueur invincible",
  T_48_META_API_10006_P0_D: "acteur cible",
  T_48_META_API_10006_P1_D: "Durée de l'effet d'invulnérabilité, en secondes",
  T_48_META_API_10007_D: "Clone l'entité sélectionnée et toutes ses propriétés dans la position d'origine",
  T_48_META_API_10007_P0_D: "Entités créées",
  T_48_META_API_10007_P1_D: "entité à cloner",
  T_48_META_API_10008_D: "Si aucune source de dégâts n'est sélectionnée, la cible subit les dégâts du système.",
  T_48_META_API_10008_P0_D: "Entités de jeu lésées",
  T_48_META_API_10008_P1_D: "Entités de jeu qui causent des dommages",
  T_48_META_API_10008_P2_D: "Type de dommage",
  T_48_META_API_10008_P3_D: "quantité de dommages",
  T_48_META_API_10009_D: "Ressusciter un joueur désigné",
  T_48_META_API_10009_P0_D: "Joueurs ressuscités",
  T_48_META_API_1001_D: "Si la condition est remplie, le nœud sous IF est exécuté. Si la condition n'est pas remplie, le nœud sous ELSE est exécuté s'il existe un ELSE, sinon l'instruction IF est terminée.",
  T_48_META_API_1001_P0_D: "La liste des conditions doit être cohérente avec le nombre de listes de sous-procédures (listes de branches logiques).",
  T_48_META_API_10010_D: "Crée un élément ou une liste d'éléments à un emplacement spécifié.",
  T_48_META_API_10010_P0_D: "Lieu de création de l'élément",
  T_48_META_API_10010_P1_D: "Postes ou listes de postes créés",
  T_48_META_API_10010_P2_D: "Lors de la création d'une liste d'articles, vous devez remplir une liste du nombre d'articles correspondant à l'ordre de la liste d'articles.",
  T_48_META_API_10011_D: "Entités d'IA patrouillant vers des points cibles",
  T_48_META_API_10011_P0_D: "Entités d'IA ciblées",
  T_48_META_API_10011_P1_D: "Point de mire mobile",
  T_48_META_API_10011_P2_D: "Retourner ou non au point de départ",
  T_48_META_API_10011_P3_D: "Si des cibles hostiles sont détectées et attaquées pendant la patrouille",
  T_48_META_API_10012_D: "Patrouille des entités IA dans l'ordre de la liste des coordonnées",
  T_48_META_API_10012_P0_D: "Entités d'IA ciblées",
  T_48_META_API_10012_P1_D: "Liste des points de coordonnées mobiles",
  T_48_META_API_10012_P2_D: "Type de patrouille, avec l'option d'une boucle unique, d'un aller-retour ou d'un cycle",
  T_48_META_API_10012_P3_D: "Si des cibles hostiles sont détectées et attaquées pendant la patrouille",
  T_48_META_API_10013_D: "Le générateur rafraîchit immédiatement la prochaine vague d'entités unitaires",
  T_48_META_API_10013_P0_D: "entité génératrice",
  T_48_META_API_10014_D: "Ajouter un facteur pour le calcul des attributs calculables, qui seront calculés par une formule composée de facteurs pour produire le résultat final.",
  T_48_META_API_10014_P0_D: "entité cible",
  T_48_META_API_10014_P1_D: "Types d'attributs calculables",
  T_48_META_API_10014_P2_D: "Type de facteur de calcul",
  T_48_META_API_10014_P3_D: "Calcul des valeurs des facteurs",
  T_48_META_API_10015_D: "Effacer le facteur de calcul pour les attributs calculables",
  T_48_META_API_10015_P0_D: "entité cible",
  T_48_META_API_10015_P1_D: "Types d'attributs calculables",
  T_48_META_API_10016_D: "Effacer tous les facteurs de calcul pour tous les attributs calculables de l'entité cible",
  T_48_META_API_10016_P0_D: "entité cible",
  T_48_META_API_10017_D: "Modifier les attributs",
  T_48_META_API_10017_P0_D: "entité cible",
  T_48_META_API_10017_P1_D: "Type d'attribut",
  T_48_META_API_10017_P2_D: "Méthode de modification",
  T_48_META_API_10017_P3_D: "(valoir)",
  T_48_META_API_10018_D: "Fixer la valeur d'une propriété calculable",
  T_48_META_API_10018_P0_D: "entité cible",
  T_48_META_API_10018_P1_D: "Type d'attribut",
  T_48_META_API_10018_P2_D: "(valoir)",
  T_48_META_API_10019_D: "Effacement des modifications de propriétés calculables individuelles",
  T_48_META_API_10019_P0_D: "entité cible",
  T_48_META_API_10019_P1_D: "Type d'attribut",
  T_48_META_API_1002_D: "Le paramètre i part de la valeur minimale, et chaque fois que le nœud ci-dessous est exécuté, i augmente la valeur du pas jusqu'à ce que i soit supérieur ou égal à la valeur maximale.",
  T_48_META_API_1002_P0_D: "Le nom de l'indice cyclique, qui peut être utilisé pour obtenir la valeur de l'indice cyclique sur une variable locale.",
  T_48_META_API_1002_P1_D: "Valeur initiale cyclique",
  T_48_META_API_1002_P2_D: "valeur en fin de cycle",
  T_48_META_API_1002_P3_D: "Taille du pas de la boucle, lorsque la valeur de départ est inférieure à la valeur de fin, la taille du pas doit être supérieure à 0 ; lorsque la valeur de départ est supérieure à la valeur de fin, la taille du pas doit être inférieure à 0.",
  T_48_META_API_10020_D: "Obtenir toutes les entités du jeu qui répondent aux critères de filtrage.",
  T_48_META_API_10020_P0_D: "Le résultat du filtre doit contenir le type saisi dans ce paramètre",
  T_48_META_API_10020_P1_D: "Le résultat du filtre ne doit pas contenir le type saisi dans ce paramètre.",
  T_48_META_API_10020_P2_D: "Les résultats du filtre contiennent au moins un des types saisis dans ce paramètre",
  T_48_META_API_10020_R_D: "Filtrer la liste des entités résultantes",
  T_48_META_API_10021_D: "Si l'on ajoute une vitesse au ballon, la vitesse sera modifiée par l'accélération dans la même direction.",
  T_48_META_API_10021_P0_D: "Goal Soccer",
  T_48_META_API_10021_P1_D: "Ajout de la vitesse de l'espace 3D",
  T_48_META_API_10022_D: "Destruction des entités désignées",
  T_48_META_API_10022_P0_D: "Entités cibles à détruire",
  T_48_META_API_10023_D: "Ajout d'étiquettes aux entités",
  T_48_META_API_10023_P0_D: "entité cible",
  T_48_META_API_10023_P1_D: "Étiquettes personnalisées",
  T_48_META_API_10024_D: "Suppression des étiquettes pour les entités",
  T_48_META_API_10024_P0_D: "entité cible",
  T_48_META_API_10024_P1_D: "Étiquettes personnalisées",
  T_48_META_API_10025_D: "Déterminer si l'entité cible contient l'étiquette spécifiée",
  T_48_META_API_10025_P0_D: "entité cible",
  T_48_META_API_10025_P1_D: "Étiquettes personnalisées",
  T_48_META_API_10025_R_D: "Inclure ou non la balise spécifiée",
  T_48_META_API_10026_D: "Réglage de la position du ballon",
  T_48_META_API_10026_P0_D: "entité footballistique",
  T_48_META_API_10026_P1_D: "placement",
  T_48_META_API_10026_P2_D: "Maintien de la vitesse",
  T_48_META_API_10027_D: "Obtenir l'entité caméra actuellement utilisée par le joueur cible",
  T_48_META_API_10027_P0_D: "acteur cible",
  T_48_META_API_10027_R_D: "L'entité caméra actuellement utilisée",
  T_48_META_API_10028_D: "En passant de la caméra du joueur cible à la caméra cible, la fonction",
  T_48_META_API_10028_P0_D: "acteur cible",
  T_48_META_API_10028_P1_D: "caméra cible",
  T_48_META_API_10028_P2_D: "Méthode de commutation : vous pouvez choisir de conserver la logique d'origine ou la logique progressive.",
  T_48_META_API_10028_P3_D: "Le temps de commutation est le temps nécessaire pour passer d'une caméra à l'autre en mode progressif.",
  T_48_META_API_10029_D: "Créer une caméra",
  T_48_META_API_10029_P0_D: "Type de caméra créée",
  T_48_META_API_10029_P1_D: "Entité de caméra créée",
  T_48_META_API_1003_D: "Mettre en œuvre une traversée d'un conteneur de données pour atteindre chaque sous-élément, contenant des sous-procédures, le corps de la boucle étant la sous-procédure.",
  T_48_META_API_1003_P0_D: "Itère sur le nom de l'élément enfant, qui peut être utilisé pour obtenir la valeur de l'élément enfant sur la variable locale",
  T_48_META_API_1003_P1_D: "Le nom de l'indice cyclique, qui peut être utilisé pour obtenir la valeur de l'indice cyclique sur une variable locale.",
  T_48_META_API_1003_P2_D: "Le conteneur de données à parcourir, les types suivants sont actuellement pris en charge : type de tableau",
  T_48_META_API_10030_D: "Tuer les entités combattables",
  T_48_META_API_10030_P0_D: "Entité cible, qui doit être prête au combat",
  T_48_META_API_10031_D: "Définir l'état actif de l'entité cible et de ses nœuds enfants ; la disponibilité, la visibilité, les collisions, etc. sont désactivées pour les objets inactifs.",
  T_48_META_API_10031_P0_D: "entité cible",
  T_48_META_API_10031_P1_D: "Actif ou inactif",
  T_48_META_API_10032_D: "Définir la position de l'entité caméra pour qu'elle suive toujours l'entité cible",
  T_48_META_API_10032_P0_D: "entité de la caméra cible",
  T_48_META_API_10032_P1_D: "Entité cible à suivre",
  T_48_META_API_10032_P2_D: "Décalage par rapport aux coordonnées de l'entité cible",
  T_48_META_API_10032_P3_D: "Système de coordonnées pour les décalages",
  T_48_META_API_10033_D: "Régler l'entité caméra pour qu'elle soit toujours face à l'entité cible",
  T_48_META_API_10033_P0_D: "entité de la caméra cible",
  T_48_META_API_10033_P1_D: "entité cible",
  T_48_META_API_10033_P2_D: "Décalage du point de regard par rapport aux coordonnées de la cible",
  T_48_META_API_10033_P3_D: "Système de coordonnées pour les décalages",
  T_48_META_API_10034_D: "Créer un Tween",
  T_48_META_API_10034_P0_D: "entité cible",
  T_48_META_API_10034_P1_D: "ID du bien",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Style",
  T_48_META_API_10034_P5_D: "Courbe",
  T_48_META_API_10034_P6_D: "Durée de l'accord",
  T_48_META_API_10034_P7_D: "entre entités",
  T_48_META_API_10035_D: "Pour définir le nœud parent, il faut que le parent et l'enfant aient tous deux le composant Transform",
  T_48_META_API_10035_P0_D: "nœud parent",
  T_48_META_API_10035_P1_D: "nœud enfant",
  T_48_META_API_10035_P2_D: "Conserver ou non la position actuelle du monde, la rotation et la mise à l'échelle des nœuds enfants, cet élément n'est pas valide lors de la définition de l'interface utilisateur.",
  T_48_META_API_10036_D: "NewCurve (obsolète, veuillez utiliser CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "Points de contrôle",
  T_48_META_API_10036_R_D: "Entité TwennCurve",
  T_48_META_API_10037_D: "Tente de jouer l'entité cible, qui doit avoir un composant jouable.",
  T_48_META_API_10037_P0_D: "Entité jouable cible",
  T_48_META_API_10037_P1_D: `Rejouer ou non 
vrai : rejouer 
faux : continuer la lecture`,
  T_48_META_API_10038_D: "Mettre en pause les entités jouables",
  T_48_META_API_10038_P0_D: "Entité jouable cible",
  T_48_META_API_10039_D: "Crée un mouvement balistique qui donne à l'entité cible une vitesse initiale et une accélération avec une direction.",
  T_48_META_API_10039_P0_D: "entité cible",
  T_48_META_API_10039_P1_D: "vitesse initiale",
  T_48_META_API_10039_P2_D: "l'accélération du mouvement",
  T_48_META_API_10039_P3_D: "Distance maximale de déplacement",
  T_48_META_API_10039_P4_D: "Entités de mouvement balistique créées",
  T_48_META_API_10039_P5_D: "Si la lecture démarre automatiquement après la création",
  T_48_META_API_1004_D: "Interrompt le processus de la boucle en cours et sort de la boucle",
  T_48_META_API_10040_D: "Crée un mouvement de suivi de position dans lequel l'entité cible suit l'objet spécifié.",
  T_48_META_API_10040_P0_D: "entité cible",
  T_48_META_API_10040_P1_D: "Entités objets qui suivent le mouvement",
  T_48_META_API_10040_P2_D: "La distance suit le décalage des coordonnées de la cible",
  T_48_META_API_10040_P3_D: "Système de coordonnées utilisé",
  T_48_META_API_10040_P4_D: "Création d'une entité de suivi de mouvement",
  T_48_META_API_10040_P5_D: "Si la lecture démarre automatiquement après la création",
  T_48_META_API_10041_D: "Crée un mouvement de suivi du regard dans lequel l'entité cible reste orientée vers l'objet spécifié.",
  T_48_META_API_10041_P0_D: "entité cible",
  T_48_META_API_10041_P1_D: "entité considérée",
  T_48_META_API_10041_P2_D: "Décalage du point de regard par rapport à l'entité objet",
  T_48_META_API_10041_P3_D: "Système de coordonnées utilisé",
  T_48_META_API_10041_P4_D: "Entités de mouvement créées qui suivent le regard",
  T_48_META_API_10041_P5_D: "Si la lecture démarre automatiquement après la création",
  T_48_META_API_10042_D: "abandonné",
  T_48_META_API_10042_P0_D: "entité du joueur",
  T_48_META_API_10042_P1_D: "résultats d'un concours",
  T_48_META_API_10042_P2_D: "abandonné",
  T_48_META_API_10042_P3_D: "abandonné",
  T_48_META_API_10042_P4_D: "abandonné",
  T_48_META_API_10043_D: "Le lissage définit les propriétés de l'entité cible, les propriétés changent immédiatement, mais le client bénéficie d'une transition en douceur.",
  T_48_META_API_10043_P0_D: "entité cible",
  T_48_META_API_10043_P1_D: "Un attribut de l'entité cible",
  T_48_META_API_10043_P2_D: "La valeur cible, qui doit correspondre au type requis lors de la définition de la propriété.",
  T_48_META_API_10044_D: "Effectuez une détection de rayon et renvoyez la première entité touchée dans la direction du rayon. L'entité touchée a besoin d'un composant de collision. Si le paramètre de niveau est rempli, le terrain peut être détecté.",
  T_48_META_API_10044_P0_D: "Coordonnées de la position de départ",
  T_48_META_API_10044_P1_D: "Direction de détection des rayonnements",
  T_48_META_API_10044_P2_D: "Distance de détection des rayonnements, seules les valeurs positives sont acceptées",
  T_48_META_API_10044_P3_D: "Masque de couche pour la détection des rayons, seules les couches remplies participeront à l'analyse, laisser ce champ vide signifie que toutes les couches participeront à l'analyse.",
  T_48_META_API_10044_P4_D: "Est-il possible de rechercher les déclencheurs",
  T_48_META_API_10044_P5_D: "entité touchée",
  T_48_META_API_10044_P6_D: "coordonnées du point d'impact",
  T_48_META_API_10044_P7_D: "Distance entre le point d'impact et le point de départ",
  T_48_META_API_10044_P8_D: "touche la normale à la surface",
  T_48_META_API_10045_D: "Effectuez une détection de rayon et renvoyez toutes les entités touchées dans la direction du rayon de près à loin. Si le paramètre de niveau est rempli, le terrain peut être détecté.",
  T_48_META_API_10045_P0_D: "Coordonnées de la position de départ",
  T_48_META_API_10045_P1_D: "Direction de détection des rayonnements",
  T_48_META_API_10045_P2_D: "Distance de détection des rayonnements, seules les valeurs positives sont acceptées",
  T_48_META_API_10045_P3_D: "Masque de calque, seuls les calques remplis participeront à l'analyse, laisser ce champ vide signifie que tous les calques participeront à l'analyse.",
  T_48_META_API_10045_P4_D: "Si le déclencheur peut être détecté",
  T_48_META_API_10045_P5_D: "Liste des entités touchées",
  T_48_META_API_10045_P6_D: "Liste des points de vie",
  T_48_META_API_10045_P7_D: "Liste des distances entre les points d'impact et les points de départ",
  T_48_META_API_10045_P8_D: "touche la normale à la surface",
  T_48_META_API_10046_D: "Création de solides pour les modèles à l'aide de corps préfabriqués",
  T_48_META_API_10046_P0_D: "Entités créées",
  T_48_META_API_10046_P1_D: "Corps préfabriqué ID",
  T_48_META_API_10047_D: "décolorer",
  T_48_META_API_10047_P0_D: "Définition des normales d'un objet",
  T_48_META_API_10047_P1_D: "Réglage du point de coloration",
  T_48_META_API_10047_P2_D: "couleur",
  T_48_META_API_10048_D: "État des couleurs",
  T_48_META_API_10048_P0_D: "Réglage du point de coloration",
  T_48_META_API_10048_P1_D: "Définir une orientation",
  T_48_META_API_10048_P2_D: "Distance de réglage",
  T_48_META_API_10048_R_D: "CouleurDesc",
  T_48_META_API_10049_D: "Statistiques de coloriage",
  T_48_META_API_10049_P0_D: "couleur",
  T_48_META_API_10049_R_D: "Nombre de couleurs",
  T_48_META_API_1005_D: "Sautez le reste du corps de la boucle et passez directement à la boucle suivante.",
  T_48_META_API_10050_D: "Coloration de la gamme plate",
  T_48_META_API_10050_P0_D: "Définition des normales d'un objet",
  T_48_META_API_10050_P1_D: "Réglage du point de coloration",
  T_48_META_API_10050_P2_D: "Réglage de la plage de coloration",
  T_48_META_API_10050_P3_D: "couleur",
  T_48_META_API_10050_P4_D: "Nombre de couleurs",
  T_48_META_API_10051_D: "tache régionale",
  T_48_META_API_10051_P0_D: "Définition des normales d'un objet",
  T_48_META_API_10051_P1_D: "Réglage du point de coloration",
  T_48_META_API_10051_P2_D: "Réglage de la plage de coloration",
  T_48_META_API_10051_P3_D: "couleur",
  T_48_META_API_10051_P4_D: "Zone de coloration fixe",
  T_48_META_API_10051_P5_D: "coefficient aléatoire (math.)",
  T_48_META_API_10051_P6_D: "coefficient d'atténuation aléatoire",
  T_48_META_API_10051_P7_D: "Nombre de couleurs",
  T_48_META_API_10052_D: "Obtenir tous les enfants de l'entité parentale cible",
  T_48_META_API_10052_P0_D: "entité mère",
  T_48_META_API_10052_R_D: "liste des nœuds enfants",
  T_48_META_API_10053_D: "Obtenir le nœud enfant spécifié de l'entité parentale cible en fonction de l'index",
  T_48_META_API_10053_P0_D: "entité mère",
  T_48_META_API_10053_P1_D: "Index des sous-nœuds",
  T_48_META_API_10053_R_D: "entité enfant",
  T_48_META_API_10054_D: "Obtenir le parent de l'entité enfant cible",
  T_48_META_API_10054_P0_D: "entité enfant",
  T_48_META_API_10054_R_D: "entité mère",
  T_48_META_API_10055_D: "Supprime tous les nœuds enfants sous l'entité nœud parent spécifiée ; les nœuds doivent avoir le composant Transform",
  T_48_META_API_10055_P0_D: "entité mère",
  T_48_META_API_10056_D: "Téléportation de la cible à l'endroit spécifié",
  T_48_META_API_10056_P0_D: "unité de transport (par exemple, militaire)",
  T_48_META_API_10056_P1_D: "coordonnées du point de transmission",
  T_48_META_API_10056_P2_D: "orientation de l'unité après le transfert",
  T_48_META_API_10057_D: "Obtenir l'emplacement d'un coéquipier au hasard et revenir à ses propres coordonnées lorsque l'on n'a pas de coéquipier, ce qui permet d'éviter l'emplacement des joueurs qui ne peuvent pas se lever.",
  T_48_META_API_10057_P0_D: "acteur cible",
  T_48_META_API_10057_R_D: "Coordonnées près des coéquipiers du joueur cible",
  T_48_META_API_10058_D: "Etat de coloration clair",
  T_48_META_API_10059_D: "Joue l'effet sonore spécifié et, s'il y a d'autres attributs à définir, définit ses attributs d'entité par le biais de l'entité",
  T_48_META_API_10059_P0_D: "Dans le code figure le nom du paramètre formel utilisé pour représenter l'entité qui crée l'effet sonore, et la valeur de la variable locale correspondante est l'entité qui crée l'effet sonore.",
  T_48_META_API_10059_P1_D: "L'entité du joueur à laquelle elle appartient, visible uniquement par ce joueur.",
  T_48_META_API_10059_P2_D: "Types de sons, les types d'effets sonores que le joueur peut choisir.",
  T_48_META_API_1006_D: "Terminer le processus d'exécution en cours, retourner directement à l'emplacement de l'appel, vous pouvez transporter les données avec le retour.",
  T_48_META_API_1006_P0_D: "Les données que vous souhaitez retourner sur le lieu de l'appel",
  T_48_META_API_10060_D: "Expulser le joueur cible du jeu",
  T_48_META_API_10060_P0_D: "acteur cible",
  T_48_META_API_10060_P1_D: "Affichage ou non des informations relatives au règlement",
  T_48_META_API_10061_D: "Le joueur cible demande à être associé à une carte spécifique.",
  T_48_META_API_10061_P0_D: "acteur cible",
  T_48_META_API_10061_P1_D: "code du champ de bataille",
  T_48_META_API_10061_P2_D: "Une fenêtre pop-up invite ou non à rejoindre le jeu d'origine lors de l'annulation d'un match.",
  T_48_META_API_10062_D: "Interruption de l'entité sonore en cours de lecture",
  T_48_META_API_10062_P0_D: "Entités saines à suspendre",
  T_48_META_API_10063_D: "Poursuite de la lecture des effets sonores, éventuellement depuis le début",
  T_48_META_API_10063_P0_D: "Entités sonores qui doivent continuer à jouer après avoir été mises en pause",
  T_48_META_API_10063_P1_D: "Partir de zéro ou non",
  T_48_META_API_10064_D: "Créer une goutte, la goutte a trois phases : 1. prête, 2. tombante, 3. atterrie, seul l'état 1 permet de modifier les propriétés de la goutte.",
  T_48_META_API_10064_P0_D: "Création d'entités de la boîte de dépôt",
  T_48_META_API_1007_D: "Mettez en œuvre une boucle qui continue à s'exécuter selon que la condition est vraie ou non, jusqu'à ce que la condition soit fausse et que la boucle se termine.",
  T_48_META_API_1007_P0_D: "Lorsque la condition est vraie, la boucle continue, et lorsque la condition est fausse, la boucle se termine.",
  T_48_META_API_1008_D: `Attendre le début de la prochaine image logique Sur le serveur, activer le mode "low frame rate" (faible taux de rafraîchissement), ce qui permet d'attendre plus longtemps Sur le client, le temps d'attente dépend des performances de l'appareil et de la co`,
  T_48_META_API_1009_D: "Après un certain temps, les fonctions utilisant cette API doivent être déclarées asynchrones.",
  T_48_META_API_1009_P0_D: "Temps d'attente en millisecondes",
  T_48_META_API_101_D: "Désinstallation d'une scène spécifique",
  T_48_META_API_101_P0_D: "ID de la scène à désinstaller",
  T_48_META_API_1010: "Rappel d'événement",
  T_48_META_API_1010_D: "Actions déclenchées lorsqu'un événement se produit",
  T_48_META_API_1010_P0: "Noms des paramètres d'événement",
  T_48_META_API_1010_P0_D: "Le nom du paramètre formel du paramètre d'événement, par lequel la valeur du paramètre réel peut être obtenue sur la variable locale.",
  T_48_META_API_1011: "Bloc de code",
  T_48_META_API_1011_D: "Un bloc de code pour héberger une combinaison d'API",
  T_48_META_API_1011_P0: "Noms des paramètres",
  T_48_META_API_1011_P0_D: "Noms formels des paramètres lorsque le bloc de code est une fonction personnalisée",
  T_48_META_API_1012: "Rechercher et appeler une API personnalisée avec Serial",
  T_48_META_API_1012_D: "Appelle les fonctions personnalisées en série, et s'il y a une attente dans la fonction personnalisée, l'emplacement de l'appel attend également.",
  T_48_META_API_1012_P0_D: "L'entité où réside la fonction personnalisée",
  T_48_META_API_1012_P1: "ID du graphique",
  T_48_META_API_1012_P1_D: "ID du script où se trouve la fonction personnalisée",
  T_48_META_API_1012_P2: "ID de fonction",
  T_48_META_API_1012_P2_D: "ID de la fonction de l'appel cible",
  T_48_META_API_1012_P3_D: "Liste des paramètres réels transmis à la fonction personnalisée",
  T_48_META_API_1013: "Rechercher et appeler une API personnalisée avec Parallel",
  T_48_META_API_1013_D: "Appelle des fonctions personnalisées en parallèle, en revenant immédiatement à l'emplacement de l'appel pour poursuivre la ligne, qu'il y ait ou non une attente dans la fonction personnalisée.",
  T_48_META_API_1013_P0_D: "L'entité où réside la fonction personnalisée",
  T_48_META_API_1013_P1: "ID du graphique",
  T_48_META_API_1013_P1_D: "ID du script où se trouve la fonction personnalisée",
  T_48_META_API_1013_P2: "ID de fonction",
  T_48_META_API_1013_P2_D: "ID de la fonction de l'appel cible",
  T_48_META_API_1013_P3_D: "Liste des paramètres réels transmis à la fonction personnalisée",
  T_48_META_API_1014: "Rechercher et appeler l'API personnalisée avec série",
  T_48_META_API_1014_D: "Appelle une fonction personnalisée dans le script actuel de manière sérielle, et s'il y a une attente dans la fonction personnalisée, l'emplacement de l'appel attend également.",
  T_48_META_API_1014_P0: "ID de fonction",
  T_48_META_API_1014_P0_D: "ID de la fonction de l'appel cible",
  T_48_META_API_1014_P1_D: "Liste des paramètres réels transmis à la fonction personnalisée",
  T_48_META_API_1015: "Rechercher et invoquer une API personnalisée avec Parallel",
  T_48_META_API_1015_D: "Appelle des fonctions personnalisées en parallèle, en revenant immédiatement à l'emplacement de l'appel pour poursuivre la ligne, qu'il y ait ou non une attente dans la fonction personnalisée.",
  T_48_META_API_1015_P0: "Définir une variable locale par index",
  T_48_META_API_1015_P0_D: "ID de la fonction de l'appel cible",
  T_48_META_API_1015_P1_D: "Liste des paramètres réels transmis à la fonction personnalisée",
  T_48_META_API_1016_D: "Obtenir le type de la cible lors de l'appel de cette API",
  T_48_META_API_1016_P0_D: "cible interrogée",
  T_48_META_API_1016_R_D: "Type de variable",
  T_48_META_API_1017_D: "Déterminer si la variable cible est du type spécifié",
  T_48_META_API_1017_P0_D: "cible interrogée",
  T_48_META_API_1017_P1_D: "Type de comparaison",
  T_48_META_API_1017_R_D: "cohérence",
  T_48_META_API_1018_D: "Détermine si la variable cible est une sous-classe d'un certain type, la valeur de retour est une valeur booléenne.",
  T_48_META_API_1018_P0_D: "Variable cible interrogée",
  T_48_META_API_1018_P1_D: "Type de comparaison",
  T_48_META_API_1018_R_D: "S'il s'agit ou non d'une sous-classe",
  T_48_META_API_1019_D: "L'entité cible déclenche l'événement personnalisé spécifié.",
  T_48_META_API_1019_P0_D: "Envoi d'ID d'événements personnalisés",
  T_48_META_API_1019_P1_D: "entité cible",
  T_48_META_API_1019_P2_D: "liste des paramètres",
  T_48_META_API_102_D: "Le passage à une scène spécifique décharge les autres scènes chargées.",
  T_48_META_API_102_P0_D: "ID de scène pour passer à",
  T_48_META_API_1020_D: "La mise en œuvre de la traversée d'un conteneur pour atteindre chaque paire clé-valeur contient des sous-procédures, le corps de la boucle étant la sous-procédure",
  T_48_META_API_1020_P0_D: "En itérant sur le nom d'une clé, vous pouvez l'utiliser pour obtenir la valeur de la clé sur une variable locale",
  T_48_META_API_1020_P1_D: "Itère sur le nom de la valeur, qui peut être utilisé pour accéder à la valeur de la variable locale.",
  T_48_META_API_1020_P2_D: "Conteneurs à traverser",
  T_48_META_API_1021_D: "Détruire le bot spécifié",
  T_48_META_API_1021_P0_D: "Joueurs bots qui doivent être détruits",
  T_48_META_API_1022_D: "Obliger le joueur cible à quitter le transporteur",
  T_48_META_API_1022_P0_D: "acteur cible",
  T_48_META_API_1023_D: "Création de cavaliers de blessure",
  T_48_META_API_1023_P0_D: "le contenu des mots-clés",
  T_48_META_API_1023_P1_D: "taille de la police",
  T_48_META_API_1023_P2_D: "couleur de la police",
  T_48_META_API_1023_P3_D: "Temps d'attente en millisecondes",
  T_48_META_API_1023_P4_D: "entité lésée",
  T_48_META_API_1023_P5_D: "Décalage du mot de saut des dommages par rapport aux coordonnées mondiales de l'entité cible",
  T_48_META_API_1023_P6_D: "Taille de l'intervalle des corrections de position aléatoires aux emplacements des sauts de dommages à nouveau",
  T_48_META_API_1023_P7_D: "Exécuter ou non l'animation de remplissage",
  T_48_META_API_1024_D: "abandonné",
  T_48_META_API_1024_P0_D: "abandonné",
  T_48_META_API_1024_P1_D: "entité cible",
  T_48_META_API_1024_P2_D: "Lorsqu'il est sélectionné, il est envoyé au client s'il est appelé depuis le serveur, et au serveur s'il est appelé depuis le client.",
  T_48_META_API_1024_P3_D: "liste des paramètres",
  T_48_META_API_1025_D: "Interroger la progression d'une tâche personnalisée",
  T_48_META_API_1025_P0_D: "acteur cible",
  T_48_META_API_1025_P1_D: "ID de la tâche personnalisée",
  T_48_META_API_1025_R_D: "Progrès de la mission",
  T_48_META_API_1026_D: "Obtenir le skin du sac à dos du joueur cible",
  T_48_META_API_1026_P0_D: "acteur cible",
  T_48_META_API_1026_R_D: "Sac à dos Skin ID",
  T_48_META_API_1027_D: "Définition de l'habillage du sac à dos du joueur cible",
  T_48_META_API_1027_P0_D: "acteur cible",
  T_48_META_API_1027_P1_D: "Sac à dos Skin ID",
  T_48_META_API_1028_D: "Rétablir la configuration par défaut du sac à dos du joueur cible en dehors du bureau.",
  T_48_META_API_1028_P0_D: "acteur cible",
  T_48_META_API_1029_D: "Vider le sac à dos du joueur cible",
  T_48_META_API_1029_P0_D: "acteur cible",
  T_48_META_API_103_D: "Remplacer le style d'environnement skybox du jeu par un choix de jour, de crépuscule, de nuit, etc.",
  T_48_META_API_103_P0_D: "Type de boîte à ciel",
  T_48_META_API_1030_D: "Obtenir la partie du squelette par son nom",
  T_48_META_API_1030_P0_D: "entité cible",
  T_48_META_API_1030_P1_D: "Nom du point d'accrochage squelettique",
  T_48_META_API_1030_R_D: "point d'accroche de la rig",
  T_48_META_API_1031_D: "Définit le nœud parent d'une entité objet qui prend en charge les entités sur lesquelles sont montés des composants Transform, SkeletonPart, Player, MountPoint.",
  T_48_META_API_1031_P0_D: "nœud parent",
  T_48_META_API_1031_P1_D: "nœud enfant",
  T_48_META_API_1031_P2_D: "Conserver ou non la position, la rotation et la mise à l'échelle actuelles des nœuds enfants, l'option UI n'étant pas valide.",
  T_48_META_API_1032_D: "Joue un effet d'icône animée où l'icône se déplace de la position de départ à la position de fin à la vitesse de lecture.",
  T_48_META_API_1032_P0_D: "Icône ID de la ressource",
  T_48_META_API_1032_P1_D: "couleur",
  T_48_META_API_1032_P2_D: "Icône Zoom",
  T_48_META_API_1032_P3_D: "Position de départ centre",
  T_48_META_API_1032_P4_D: "Démarrage du champ d'application régional",
  T_48_META_API_1032_P5_D: "Centre de position finale",
  T_48_META_API_1032_P6_D: "Plage de position finale",
  T_48_META_API_1032_P7_D: "La vitesse de lecture, qui est la distance parcourue par l'icône par seconde.",
  T_48_META_API_1033_D: "Effectuer une opération de tangente inverse pour obtenir l'angle",
  T_48_META_API_1033_P0_D: "Coordonnées de l'axe Y",
  T_48_META_API_1033_P1_D: "Coordonnées de l'axe X",
  T_48_META_API_1033_R_D: "Angle, plage (-180, 180)",
  T_48_META_API_1034_D: "Ajout de composants aux entités, seuls les composants personnalisés créés par l'utilisateur sont pris en charge",
  T_48_META_API_1034_P0_D: "entité cible",
  T_48_META_API_1034_P1_D: "ID du type de composant, seuls les composants personnalisés créés par l'utilisateur sont pris en charge.",
  T_48_META_API_1034_P2_D: "Qu'il soit ajouté avec succès ou non, les composants existants ou les composants non personnalisés ne seront pas ajoutés.",
  T_48_META_API_1035_D: "Supprimer les composants des entités, seuls les composants personnalisés sont pris en charge",
  T_48_META_API_1035_P0_D: "entité cible",
  T_48_META_API_1035_P1_D: "ID du type de composant, seuls les composants personnalisés créés par l'utilisateur sont pris en charge.",
  T_48_META_API_1035_P2_D: "Que la suppression soit réussie ou non, les composants inexistants ou non personnalisés ne seront pas supprimés.",
  T_48_META_API_1036_D: "Personnaliser l'écran de sortie du lecteur",
  T_48_META_API_1036_P0_D: "légende",
  T_48_META_API_1036_P1_D: "élément",
  T_48_META_API_1036_P2_D: "options",
  T_48_META_API_1036_P3_D: "Afficher ou non l'arrière-plan",
  T_48_META_API_1037_D: "Obtenir toutes les scènes actuellement chargées",
  T_48_META_API_1037_R_D: "Liste des scènes",
  T_48_META_API_1038_D: "Obtenir la direction de visée locale du joueur",
  T_48_META_API_1038_R_D: "viser dans la bonne direction",
  T_48_META_API_1039_D: "Obtenir l'horodatage local",
  T_48_META_API_1039_R_D: "horodatage",
  T_48_META_API_104_D: "Les scènes non chargées seront chargées automatiquement et ne déchargeront pas automatiquement les scènes déjà chargées.",
  T_48_META_API_104_P0_D: "joueur",
  T_48_META_API_104_P1_D: "ID de la scène à charger",
  T_48_META_API_104_P2_D: "Position du joueur dans le nouveau scénario",
  T_48_META_API_104_P3_D: "Orientation du joueur dans le nouveau scénario",
  T_48_META_API_1040_D: "Mettre en pause la mise à jour de l'image fixe pour la plate-forme actuelle, et l'événement de mise à jour de l'image fixe pour cette plate-forme ne sera pas déclenché après la pause.",
  T_48_META_API_1041_D: "Reprendre la mise à jour de la trame fixe pour la plate-forme actuelle, et l'événement de mise à jour de la trame fixe pour cette plate-forme se déclenche à nouveau après la reprise.",
  T_48_META_API_1042_D: "Déterminer la relation de copinage du joueur cible avec le joueur client actuel, le client actuel lui-même n'est pas un copain du client actuel.",
  T_48_META_API_1042_P0_D: "acteur cible",
  T_48_META_API_1042_R_D: "Si vous êtes ou non ami avec le client actuel",
  T_48_META_API_1043_D: "Déclenchement d'événements personnalisés",
  T_48_META_API_1043_P0_D: "ID de l'événement personnalisé",
  T_48_META_API_1043_P1_D: "entité cible",
  T_48_META_API_1043_P2_D: "Fonctionne sur des plates-formes côté serveur ou côté client",
  T_48_META_API_1043_P3_D: "liste des paramètres",
  T_48_META_API_1044_D: "Saut en parachute libre",
  T_48_META_API_1044_P0_D: "acteur cible",
  T_48_META_API_1044_P1_D: "En dessous de cette altitude, le parachute sera forcé de s'ouvrir.",
  T_48_META_API_1044_P2_D: "Vitesse en planant, la composante X représente la vitesse horizontale, la composante Y représente la vitesse verticale ; le joueur atterrit vers le bas lorsque la composante Y est négative.",
  T_48_META_API_1044_P3_D: "Vitesse en plongée, la composante X représente la vitesse horizontale, la composante Y représente la vitesse verticale ; le joueur descend lorsque la composante Y est négative.",
  T_48_META_API_1044_P4_D: "Vitesse lors de l'ouverture du parachute, la composante X représente la vitesse horizontale, la composante Y représente la vitesse verticale ; lorsque la composante Y est négative, le joueur atterrit vers le bas.",
  T_48_META_API_1045_D: "Lit la valeur correspondant à l'identifiant spécifié dans le tableau de données.",
  T_48_META_API_1045_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_1045_P1_D: "Identifiant unique du joueur",
  T_48_META_API_1045_P2_D: "identifiant spécifié",
  T_48_META_API_1045_P3_D: "Les résultats des lectures",
  T_48_META_API_1045_P4_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1045_P5_D: "code d'erreur",
  T_48_META_API_1046_D: "Récupère la valeur correspondant à l'identifiant spécifié dans la table de données du graphique.",
  T_48_META_API_1046_P0_D: "Nom de la table de classement dans la base de données",
  T_48_META_API_1046_P1_D: "identifiant spécifié",
  T_48_META_API_1046_P2_D: "Les résultats des lectures",
  T_48_META_API_1046_P3_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1046_P4_D: "code d'erreur",
  T_48_META_API_1047_D: "Récupérer la valeur de l'intervalle de classement spécifié dans le tableau de données du classement.",
  T_48_META_API_1047_P0_D: "Nom de la table de classement dans la base de données",
  T_48_META_API_1047_P1_D: "Le rang de départ doit être inférieur ou égal au rang de fin, et le rang commence à 1",
  T_48_META_API_1047_P2_D: "position d'arrivée",
  T_48_META_API_1047_P3_D: "Les résultats des lectures",
  T_48_META_API_1047_P4_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1047_P5_D: "code d'erreur",
  T_48_META_API_1048_D: "Lit la valeur correspondant à l'identifiant spécifié dans le tableau des données cumulées.",
  T_48_META_API_1048_P0_D: "Nom du tableau de données cumulées dans la base de données",
  T_48_META_API_1048_P1_D: "identifiant spécifié",
  T_48_META_API_1048_P2_D: "Les résultats des lectures",
  T_48_META_API_1048_P3_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1048_P4_D: "code d'erreur",
  T_48_META_API_1049_D: "Inscrire la valeur correspondant à l'identifiant spécifié dans le tableau de données.",
  T_48_META_API_1049_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_1049_P1_D: "Identifiant unique du joueur",
  T_48_META_API_1049_P2_D: "identifiant spécifié",
  T_48_META_API_1049_P3_D: "Valeur écrite",
  T_48_META_API_1049_P4_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1049_P5_D: "code d'erreur",
  T_48_META_API_105_D: "Obtenir la boîte à ciel de la scène",
  T_48_META_API_105_P0_D: "ID de la scène",
  T_48_META_API_105_R_D: "boîte à ciel",
  T_48_META_API_1050_D: "Obtenir le nombre d'éléments de la liste",
  T_48_META_API_1050_P0_D: "liste de cibles",
  T_48_META_API_1050_R_D: "Nombre d'éléments",
  T_48_META_API_1051_D: "Obtenir la valeur de l'élément à l'index spécifié dans la liste",
  T_48_META_API_1051_P0_D: "liste de cibles",
  T_48_META_API_1051_P1_D: "Valeurs de l'indice, à partir de 0",
  T_48_META_API_1051_R_D: "valeur élémentaire",
  T_48_META_API_1052_D: "Fixe la valeur de l'élément correspondant à l'index spécifié dans la liste",
  T_48_META_API_1052_P0_D: "liste de cibles",
  T_48_META_API_1052_P1_D: "Valeurs de l'indice, à partir de 0",
  T_48_META_API_1052_P2_D: "valeur élémentaire",
  T_48_META_API_1053_D: "Ajouter des éléments à la fin de la liste",
  T_48_META_API_1053_P0_D: "liste de cibles",
  T_48_META_API_1053_P1_D: "Éléments à ajouter",
  T_48_META_API_1054_D: "Supprime de la liste l'élément situé à l'index spécifié",
  T_48_META_API_1054_P0_D: "liste de cibles",
  T_48_META_API_1054_P1_D: "Valeurs de l'indice, à partir de 0",
  T_48_META_API_1055_D: "Vider la liste de tous les éléments",
  T_48_META_API_1055_P0_D: "liste de cibles",
  T_48_META_API_1056_D: "Inverse l'ordre des éléments de la liste spécifiée.",
  T_48_META_API_1056_P0_D: "liste de cibles",
  T_48_META_API_1057_D: "Copier une liste",
  T_48_META_API_1057_P0_D: "liste de cibles",
  T_48_META_API_1057_R_D: "Nouvelle liste copiée",
  T_48_META_API_1058_D: "Insère un nouvel élément à la position d'index spécifiée dans la liste, et les éléments à cette position d'index et les suivants sont reculés d'une place dans l'ordre.",
  T_48_META_API_1058_P0_D: "liste de cibles",
  T_48_META_API_1058_P1_D: "Position de l'index à insérer, l'index compte à partir de 0",
  T_48_META_API_1058_P2_D: "La valeur du nouvel élément à insérer",
  T_48_META_API_1059_D: "Re-randomiser les éléments de la liste",
  T_48_META_API_1059_P0_D: "liste de cibles",
  T_48_META_API_1060_D: "Compare les deux côtés de l'argument et renvoie un résultat vrai ou faux.",
  T_48_META_API_1060_P0_D: "La valeur de gauche utilisée pour la comparaison",
  T_48_META_API_1060_P1_D: "Les méthodes de comparaison suivantes sont prises en charge : >,>=,==, ! =,<=,<,And(qualified bool type),Or(qualified bool type)",
  T_48_META_API_1060_P2_D: "La valeur de gauche utilisée pour la comparaison",
  T_48_META_API_1060_R_D: "Résultats comparatifs",
  T_48_META_API_1061_D: "Les quatre opérations de base, à savoir l'addition, la soustraction, la multiplication, la division et le reste. L'opération du reste ne prend en charge que les nombres entiers, et les autres opérations prennent en charge les nombres entiers ou décimaux.",
  T_48_META_API_1061_P0_D: "valeur gauche d'une opération",
  T_48_META_API_1061_P1_D: "Types des quatre opérations, y compris l'addition, la soustraction, la multiplication, la division et le reste, qui ne prend pas en charge les décimales.",
  T_48_META_API_1061_P2_D: "valeur droite d'une opération",
  T_48_META_API_1061_R_D: "résultat du calcul",
  T_48_META_API_1062_D: "Générer un nombre entier aléatoire entre la valeur minimale (incluse) et la valeur maximale (non incluse).",
  T_48_META_API_1062_P0_D: "Intervalle aléatoire à gauche avec possibilité de randomiser sur la valeur remplie",
  T_48_META_API_1062_P1_D: "Intervalle aléatoire de droite, ne sera pas aléatoire par rapport à la valeur remplie.",
  T_48_META_API_1062_R_D: "Résultat aléatoire, entier",
  T_48_META_API_1063_D: "Générer une décimale aléatoire entre la valeur minimale décimale (incluse) et la valeur maximale décimale (non incluse)",
  T_48_META_API_1063_P0_D: "Intervalle aléatoire à gauche, avec une faible probabilité d'atteindre de manière aléatoire la valeur indiquée.",
  T_48_META_API_1063_P1_D: "Intervalle aléatoire de droite, ne sera pas aléatoire par rapport à la valeur remplie.",
  T_48_META_API_1063_R_D: "Résultats aléatoires, décimales, jusqu'à 7 décimales",
  T_48_META_API_1064_D: "Déterminer si un objet est vide",
  T_48_META_API_1064_P0_D: "objet vide à juger",
  T_48_META_API_1064_R_D: "Est vide",
  T_48_META_API_1065_D: "Inverse logique, valeur d'entrée : vrai ou faux, valeur de retour : faux ou vrai",
  T_48_META_API_1065_P0_D: "Les valeurs qui doivent être demandées pour les pays qui ne sont pas membres de l'Union européenne sont les suivantes",
  T_48_META_API_1065_R_D: "Le résultat du nonce",
  T_48_META_API_1066_D: "Prend en compte les valeurs absolues, prend en charge les entiers et les décimales",
  T_48_META_API_1066_P0_D: "Valeurs pour lesquelles des valeurs absolues sont requises",
  T_48_META_API_1066_R_D: "Le résultat de la prise en compte des valeurs absolues",
  T_48_META_API_1067_D: "calcul de la racine carrée",
  T_48_META_API_1067_P0_D: "Nécessité de demander la valeur de la racine carrée",
  T_48_META_API_1067_R_D: "Le résultat de la recherche de la racine carrée",
  T_48_META_API_1068_D: "Calcul des valeurs négatives",
  T_48_META_API_1068_P0_D: "Valeurs négatives à demander",
  T_48_META_API_1068_R_D: "Résultats négatifs",
  T_48_META_API_1069_D: "Assemblage de deux cordes",
  T_48_META_API_1069_P0_D: "valeur gauche d'une chaîne de caractères",
  T_48_META_API_1069_P1_D: "valeur droite d'une chaîne de caractères",
  T_48_META_API_1069_R_D: "résultat de la concaténation de chaînes de caractères",
  T_48_META_API_1070_D: "Obtenir la longueur de la chaîne",
  T_48_META_API_1070_P0_D: "chaîne de caractères",
  T_48_META_API_1070_R_D: "longueur de la chaîne",
  T_48_META_API_1071_D: "Arrondir la valeur spécifiée au nombre entier inférieur le plus proche.",
  T_48_META_API_1071_P0_D: "Valeur à arrondir à l'unité inférieure",
  T_48_META_API_1071_R_D: "arrondir vers le bas",
  T_48_META_API_1072_D: "Arrondir la valeur spécifiée au nombre entier le plus proche.",
  T_48_META_API_1072_P0_D: "Valeurs à arrondir",
  T_48_META_API_1072_R_D: "Résultats de l'arrondissement",
  T_48_META_API_1073_D: "Arrondir la valeur spécifiée au nombre entier le plus proche.",
  T_48_META_API_1073_P0_D: "Nombre de valeurs à arrondir",
  T_48_META_API_1073_R_D: "résultat arrondi",
  T_48_META_API_1074_D: "Produit une nouvelle chaîne après avoir remplacé toutes les chaînes spécifiées dans la chaîne cible.",
  T_48_META_API_1074_P0_D: "chaîne cible",
  T_48_META_API_1074_P1_D: "L'ancienne chaîne à remplacer",
  T_48_META_API_1074_P2_D: "Nouvelle chaîne à remplacer par",
  T_48_META_API_1074_R_D: "Remplacement de la chaîne terminée",
  T_48_META_API_1075_D: "Recherche la première occurrence d'une chaîne spécifiée dans la chaîne cible.",
  T_48_META_API_1075_P0_D: "chaîne cible",
  T_48_META_API_1075_P1_D: "La chaîne spécifiée à rechercher",
  T_48_META_API_1075_P2_D: "Recherche la chaîne de caractères à partir de la position de départ, la position de la chaîne est comptée à partir de 0.",
  T_48_META_API_1075_R_D: "Spécifie la position de la première occurrence de la chaîne dans la chaîne cible, la position de la chaîne est comptée à partir de 0.",
  T_48_META_API_1076_D: "Produit une nouvelle chaîne après avoir intercepté une chaîne d'une longueur spécifiée à partir d'une position spécifiée.",
  T_48_META_API_1076_P0_D: "chaîne cible",
  T_48_META_API_1076_P1_D: "Position à laquelle commencer l'interception, la position de la chaîne est comptée à partir de 0",
  T_48_META_API_1076_P2_D: "Longueur de l'interception, par défaut jusqu'à la fin de la chaîne.",
  T_48_META_API_1076_R_D: "Chaîne interceptée",
  T_48_META_API_1077_D: "Comparer deux listes avec des éléments identiques, la taille de la liste n'affecte pas le résultat.",
  T_48_META_API_1077_P0_D: "La valeur gauche de la liste utilisée pour la comparaison",
  T_48_META_API_1077_P1_D: "La valeur droite de la liste utilisée pour la comparaison",
  T_48_META_API_1077_R_D: "Comparez les résultats, la cohérence du contenu renvoie à True, l'incohérence du contenu renvoie à False.",
  T_48_META_API_1078_D: "Prend la chaîne spécifiée comme séparateur, coupe la chaîne cible en un certain nombre de tranches et produit la nouvelle chaîne, les N séparateurs consécutifs seront coupés en N-1 espaces de demi-largeur en tant qu'éléments de la liste de chaînes produit",
  T_48_META_API_1078_P0_D: "chaîne cible",
  T_48_META_API_1078_P1_D: "chaîne de délimitation",
  T_48_META_API_1078_R_D: "Produit une liste de chaînes de caractères, se terminant toujours par un espace d'une demi-largeur.",
  T_48_META_API_1079_D: "Extraire les caractères de la liste des positions de la chaîne et les combiner dans une nouvelle sortie de chaîne.",
  T_48_META_API_1079_P0_D: "chaîne cible",
  T_48_META_API_1079_P1_D: "Liste des positions des chaînes de caractères, les positions des chaînes étant comptées à partir de 0",
  T_48_META_API_1079_R_D: "Chaîne de sortie",
  T_48_META_API_1080_D: "Convertit tous les caractères de la chaîne cible en majuscules",
  T_48_META_API_1080_P0_D: "chaîne cible",
  T_48_META_API_1080_R_D: "Chaîne de sortie",
  T_48_META_API_1081_D: "Convertit tous les caractères de la chaîne cible en minuscules",
  T_48_META_API_1081_P0_D: "chaîne cible",
  T_48_META_API_1081_R_D: "Chaîne de sortie",
  T_48_META_API_1082_D: "Supprime tous les espaces avant le premier caractère non blanc et après le dernier caractère non blanc de la chaîne cible.",
  T_48_META_API_1082_P0_D: "chaîne cible",
  T_48_META_API_1082_R_D: "Chaîne de sortie",
  T_48_META_API_1083_D: "Produit une nouvelle chaîne de caractères après avoir établi un lien avec l'identificateur spécifié.",
  T_48_META_API_1083_P0_D: "Liste des chaînes cibles",
  T_48_META_API_1083_P1_D: "Identifiant spécifié utilisé pour concaténer des chaînes de caractères",
  T_48_META_API_1083_R_D: "Chaîne de sortie",
  T_48_META_API_1084_D: "Écrit la valeur correspondant à l'identifiant spécifié dans le tableau de données du classement.",
  T_48_META_API_1084_P0_D: "Nom de la table de classement dans la base de données",
  T_48_META_API_1084_P1_D: "identifiant spécifié",
  T_48_META_API_1084_P2_D: "Valeur écrite",
  T_48_META_API_1084_P3_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1084_P4_D: "code d'erreur",
  T_48_META_API_1085_D: "Écriture de la valeur de décalage correspondant à l'identifiant spécifié dans la table des données cumulées",
  T_48_META_API_1085_P0_D: "Nom du tableau de données cumulées dans la base de données",
  T_48_META_API_1085_P1_D: "identifiant spécifié",
  T_48_META_API_1085_P2_D: "Types d'opérations quadratiques",
  T_48_META_API_1085_P3_D: "Valeur d'offset écrite",
  T_48_META_API_1085_P4_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1085_P5_D: "code d'erreur",
  T_48_META_API_1086_D: "Supprime la valeur correspondant à l'identifiant spécifié dans la table de données.",
  T_48_META_API_1086_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_1086_P1_D: "Identifiant unique du joueur",
  T_48_META_API_1086_P2_D: "identifiant spécifié",
  T_48_META_API_1086_P3_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1086_P4_D: "code d'erreur",
  T_48_META_API_1087_D: "Supprime la valeur correspondant à l'identifiant spécifié dans la table de données du graphique.",
  T_48_META_API_1087_P0_D: "Nom de la table de classement dans la base de données",
  T_48_META_API_1087_P1_D: "identifiant spécifié",
  T_48_META_API_1087_P2_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1087_P3_D: "code d'erreur",
  T_48_META_API_1088_D: "Supprime la valeur correspondant au rang spécifié dans le tableau du classement.",
  T_48_META_API_1088_P0_D: "Nom de la table de classement dans la base de données",
  T_48_META_API_1088_P1_D: "occuper une fonction prestigieuse",
  T_48_META_API_1088_P2_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_1088_P3_D: "code d'erreur",
  T_48_META_API_1089_D: "Envoyer un message d'utilisateur à Persona",
  T_48_META_API_1089_P0_D: "Target PersonaID",
  T_48_META_API_1089_P1_D: "Message",
  T_48_META_API_1090_D: "Envoyer un message système à Persona",
  T_48_META_API_1090_P0_D: "Target PersonaID",
  T_48_META_API_1090_P1_D: "Message",
  T_48_META_API_1091_D: "Effacer la mémoire de Persona",
  T_48_META_API_1091_P0_D: "code d'erreur",
  T_48_META_API_1092_D: "Centre des membres Evoke",
  T_48_META_API_1092_P0_D: "code d'erreur",
  T_48_META_API_1093_D: "Obtenir l'horodatage de l'expiration du membre",
  T_48_META_API_1093_P0_D: "acteur cible",
  T_48_META_API_1093_P1_D: "horodatage",
  T_48_META_API_1093_P2_D: "code d'erreur",
  T_48_META_API_1094_D: "Déterminer si un joueur est membre",
  T_48_META_API_1094_P0_D: "code d'erreur",
  T_48_META_API_1094_P1_D: "Que vous soyez membre",
  T_48_META_API_1095_D: "Obtenir l'horodatage de l'expiration du membre",
  T_48_META_API_1095_P0_D: "horodatage",
  T_48_META_API_1095_P1_D: "code d'erreur",
  T_48_META_API_1096_D: "Déterminer si un joueur est membre",
  T_48_META_API_1096_P0_D: "acteur cible",
  T_48_META_API_1096_P1_D: "code d'erreur",
  T_48_META_API_1096_P2_D: "Que vous soyez membre",
  T_48_META_API_1097_D: "Centre des membres Evoke",
  T_48_META_API_1097_P0_D: "acteur cible",
  T_48_META_API_1097_P1_D: "code d'erreur",
  T_48_META_API_1099_D: "Mise en place d'observateurs Persona, après quoi les conversations avec Persona sont également envoyées à l'observateur",
  T_48_META_API_1099_P0_D: "Target PersonaID",
  T_48_META_API_1099_P1_D: "liste de surveillance",
  T_48_META_API_11_D: "Terminer la phase en cours et passer à la suivante",
  T_48_META_API_1100_D: "Envoi de messages d'utilisateurs à Persona à l'aide de la diffusion en continu",
  T_48_META_API_1100_P0_D: "Target PersonaID",
  T_48_META_API_1100_P1_D: "Message",
  T_48_META_API_1101_D: "Envoi de messages système à Persona à l'aide de la diffusion en continu",
  T_48_META_API_1101_P0_D: "Target PersonaID",
  T_48_META_API_1101_P1_D: "Message",
  T_48_META_API_1101_P2_D: "Répondre ou ignorer",
  T_48_META_API_1103_D: "Création de graines aléatoires",
  T_48_META_API_1103_P0_D: "torrent",
  T_48_META_API_1103_R_D: "Générateur de nombres aléatoires",
  T_48_META_API_1104_D: "Obtenir le prochain nombre aléatoire du générateur de nombres aléatoires spécifié, valeur maximale 32767",
  T_48_META_API_1104_P0_D: "Générateur de nombres aléatoires",
  T_48_META_API_1104_P1_D: "Fourchette Minimum",
  T_48_META_API_1104_P2_D: "Portée Maximum",
  T_48_META_API_1104_R_D: "nombre aléatoire",
  T_48_META_API_1108_D: "Obtenir la langue du client utilisée par le joueur",
  T_48_META_API_12_D: "Impression des journaux sur la console",
  T_48_META_API_12_P0_D: "Que faut-il imprimer ?",
  T_48_META_API_13_D: "Produit une chaîne de caractères avec des paramètres",
  T_48_META_API_13_P0_D: "Utilisez l'espace réservé %v pour un paramètre, le nombre de %v et le nombre de paramètres doivent être identiques.",
  T_48_META_API_13_P1_D: "La liste des paramètres participant à la sortie doit être cohérente avec le nombre de %v dans la description du format.",
  T_48_META_API_13_R_D: "Chaîne de sortie",
  T_48_META_API_14_D: "Nettoyage des résidus d'objets de la carte, y compris les cases de mort, les objets créés, les objets placés, les résidus de projectiles, etc.",
  T_48_META_API_15_D: "Journaux d'enterrement des concours personnalisés pour l'analyse des données relatives à l'expérience de l'utilisateur",
  T_48_META_API_15_P0_D: "Liste des noms de champs à déclarer",
  T_48_META_API_15_P1_D: "Liste des valeurs de champ à déclarer",
  T_48_META_API_1500_D: "Obtenir la composante x du vecteur 3D",
  T_48_META_API_1500_P0_D: "Vecteur 3D",
  T_48_META_API_1500_R_D: "Vecteur 3D composante x",
  T_48_META_API_1501_D: "Obtenir la composante y du vecteur 3D",
  T_48_META_API_1501_P0_D: "Vecteur 3D",
  T_48_META_API_1501_R_D: "Composante Y du vecteur 3D",
  T_48_META_API_1502_D: "Obtenir la composante z du vecteur 3D",
  T_48_META_API_1502_P0_D: "Vecteur 3D",
  T_48_META_API_1502_R_D: "Vecteur tridimensionnel composante z",
  T_48_META_API_1503_D: "Définir la composante x du vecteur 3D",
  T_48_META_API_1503_P0_D: "Vecteur 3D",
  T_48_META_API_1503_P1_D: "Composant X",
  T_48_META_API_1504_D: "Définir la composante Y du vecteur 3D",
  T_48_META_API_1504_P0_D: "Vecteur 3D",
  T_48_META_API_1504_P1_D: "Composante Y",
  T_48_META_API_1505_D: "Définir la composante z du vecteur 3D",
  T_48_META_API_1505_P0_D: "Vecteur 3D",
  T_48_META_API_1505_P1_D: "Composante Z",
  T_48_META_API_1506_D: "Additionner deux vecteurs 3D",
  T_48_META_API_1506_P0_D: "Lvalue",
  T_48_META_API_1506_P1_D: "Rvalue",
  T_48_META_API_1506_R_D: "Résultat de la somme des vecteurs 3D",
  T_48_META_API_1507_D: "Soustraire deux vecteurs 3D",
  T_48_META_API_1507_P0_D: "Lvalue",
  T_48_META_API_1507_P1_D: "Rvalue",
  T_48_META_API_1507_R_D: "Résultat de la soustraction de la valeur droite de la valeur gauche du vecteur 3D",
  T_48_META_API_1508_D: "Mise à l'échelle des vecteurs 3D",
  T_48_META_API_1508_P0_D: "Vecteurs 3D à mettre à l'échelle",
  T_48_META_API_1508_P1_D: "Déflation vectorielle 3D",
  T_48_META_API_1508_R_D: "Résultats de la mise à l'échelle des vecteurs 3D",
  T_48_META_API_1509_D: "Multiplication par points de deux vecteurs 3D, le résultat de la multiplication par points est un scalaire.",
  T_48_META_API_1509_P0_D: "Lvalue",
  T_48_META_API_1509_P1_D: "Rvalue",
  T_48_META_API_1509_R_D: "Résultat du produit scalaire",
  T_48_META_API_1510_D: "Multiplication croisée de deux vecteurs 3D, le résultat de la multiplication croisée est un vecteur perpendiculaire au plan où se trouvent les deux vecteurs.",
  T_48_META_API_1510_P0_D: "Lvalue",
  T_48_META_API_1510_P1_D: "Rvalue",
  T_48_META_API_1510_R_D: "Le résultat du produit en croix, orienté perpendiculairement au plan dans lequel se trouvent les deux vecteurs impliqués dans l'opération.",
  T_48_META_API_1511_D: "Normalisation des vecteurs 3D",
  T_48_META_API_1511_P0_D: "Vecteur 3D",
  T_48_META_API_1511_R_D: "Renvoie un nouveau vecteur normalisé. La longueur du module est de 1",
  T_48_META_API_1512_D: "Modélisation de vecteurs 3D",
  T_48_META_API_1512_P0_D: "Vecteur 3D",
  T_48_META_API_1512_R_D: "Le résultat de la modélisation, la longueur du module vectoriel",
  T_48_META_API_1513_D: "Calculer la distance euclidienne entre deux vecteurs 3D",
  T_48_META_API_1513_P0_D: "Lvalue",
  T_48_META_API_1513_P1_D: "Rvalue",
  T_48_META_API_1513_R_D: "Après la soustraction de deux vecteurs, le module du vecteur résultant",
  T_48_META_API_1514_D: "Calculer l'angle entre deux vecteurs 3D",
  T_48_META_API_1514_P0_D: "Lvalue",
  T_48_META_API_1514_P1_D: "Rvalue",
  T_48_META_API_1514_R_D: "Angle du vecteur, plage d'angle 0-180",
  T_48_META_API_1515_D: "Créer un vecteur 3D",
  T_48_META_API_1515_P0_D: "Composante X d'un vecteur 3D",
  T_48_META_API_1515_P1_D: "Composante Y d'un vecteur 3D",
  T_48_META_API_1515_P2_D: "Composante Z d'un vecteur 3D",
  T_48_META_API_1515_R_D: "Vecteurs 3D créés",
  T_48_META_API_1516_D: "Obtenir le point d'orientation d'une nouvelle construction (obsolète, ne l'utilisez pas)",
  T_48_META_API_1516_P0_D: "placement",
  T_48_META_API_1516_P1_D: "se tourner vers",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "Prendre la position du point de direction (obsolète, ne pas utiliser)",
  T_48_META_API_1517_P0_D: "point d'orientation",
  T_48_META_API_1517_R_D: "Position",
  T_48_META_API_1518_D: "Orientation du point de prise de direction (obsolète, ne pas utiliser)",
  T_48_META_API_1518_P0_D: "point d'orientation",
  T_48_META_API_1518_R_D: "En avant",
  T_48_META_API_1519_D: "Créer une liste",
  T_48_META_API_1519_P0_D: "La longueur initiale de la liste, qui doit être inférieure ou égale à la capacité initiale.",
  T_48_META_API_1519_P1_D: "La capacité initiale de la liste doit être supérieure ou égale à la longueur initiale. La capacité peut être augmentée dynamiquement, mais cela consommera des performances, il est donc recommandé de définir une valeur appropriée lors de la construction.",
  T_48_META_API_1519_R_D: "Création d'une liste",
  T_48_META_API_1520_D: "Vérifie si la liste contient l'élément spécifié",
  T_48_META_API_1520_P0_D: "liste de cibles",
  T_48_META_API_1520_P1_D: "L'élément spécifié à vérifier",
  T_48_META_API_1520_R_D: "S'il contient ou non l'élément spécifié",
  T_48_META_API_1521_D: "Ajouter plusieurs éléments à la fin de la liste cible",
  T_48_META_API_1521_P0_D: "liste de cibles",
  T_48_META_API_1521_P1_D: "Liste complémentaire",
  T_48_META_API_1522_D: "Supprime l'élément spécifié de la liste",
  T_48_META_API_1522_P0_D: "liste de cibles",
  T_48_META_API_1522_P1_D: "La valeur de l'élément à supprimer",
  T_48_META_API_1523_D: "Obtenir l'index de la première position de l'élément dans la liste. S'il n'y a pas d'élément cible dans la liste, -1 est renvoyé.",
  T_48_META_API_1523_P0_D: "liste de cibles",
  T_48_META_API_1523_P1_D: "valeur élémentaire",
  T_48_META_API_1523_R_D: "index des lieux",
  T_48_META_API_1524_D: "Obtenir l'index de la dernière position de l'élément dans la liste, s'il n'y a pas d'élément cible dans la liste, renvoyer -1.",
  T_48_META_API_1524_P0_D: "liste de cibles",
  T_48_META_API_1524_P1_D: "valeur élémentaire",
  T_48_META_API_1524_R_D: "index des lieux",
  T_48_META_API_1525_D: "Trouver le sinus de l'angle",
  T_48_META_API_1525_P0_D: "Angle, 360 pour 360 degrés",
  T_48_META_API_1525_R_D: "sinus",
  T_48_META_API_1526_D: "Trouver le cosinus d'un angle",
  T_48_META_API_1526_P0_D: "Angle, 360 pour 360 degrés",
  T_48_META_API_1526_R_D: "cosinus",
  T_48_META_API_1527_D: "Trouver la tangente d'un angle",
  T_48_META_API_1527_P0_D: "Angle, 360 pour 360 degrés",
  T_48_META_API_1527_R_D: "tangente",
  T_48_META_API_1528_D: "Construire une valeur de couleur avec une transparence fixée à la valeur décimale 255, d'abord convertir le canal en un nombre binaire, chaque 8 bits représentant un canal, séparé en fonction de R, G, B et de la transparence, puis convertir ce nombre bina",
  T_48_META_API_1528_P0_D: "La valeur du canal rouge de la couleur, dans l'intervalle [0,255], si elle dépasse l'intervalle, elle sera fixée à la valeur légale.",
  T_48_META_API_1528_P1_D: "La valeur du canal vert de la couleur, dans l'intervalle [0,255], si elle dépasse l'intervalle, elle sera fixée à la valeur légale.",
  T_48_META_API_1528_P2_D: "La valeur du canal bleu de la couleur, dans l'intervalle [0,255], si elle dépasse l'intervalle, elle sera fixée à la valeur légale.",
  T_48_META_API_1528_R_D: "Valeurs de couleur construites",
  T_48_META_API_1529_D: "Effectuer une opération de sinus inverse pour obtenir l'angle",
  T_48_META_API_1529_P0_D: "Valeur pour laquelle l'opération de sinus inverse est effectuée, dans l'intervalle [-1,1].",
  T_48_META_API_1529_R_D: "perspectives",
  T_48_META_API_1530_D: "Effectuer l'opération du cosinus inverse pour obtenir l'angle",
  T_48_META_API_1530_P0_D: "La valeur de l'opération du cosinus inverse, dans la plage [-1,1].",
  T_48_META_API_1530_R_D: "perspectives",
  T_48_META_API_1531_D: "Effectuer une opération de tangente inverse pour obtenir l'angle",
  T_48_META_API_1531_P0_D: "Valeur pour laquelle l'opération d'arctangente est effectuée",
  T_48_META_API_1531_R_D: "perspectives",
  T_48_META_API_1532_D: "Détermine si l'entité cible se trouve dans la sphère spécifiée. Si l'entité n'a pas d'attributs de position, la réponse est fausse.",
  T_48_META_API_1532_P0_D: "entité cible",
  T_48_META_API_1532_P1_D: "Spécifier le centre de la sphère",
  T_48_META_API_1532_P2_D: "Spécifier le rayon de la sphère",
  T_48_META_API_1532_R_D: "Résultats",
  T_48_META_API_1533_D: "Détermine si l'entité cible se trouve dans la plage de cylindres spécifiée. Si l'entité n'a pas d'attribut de localisation, le résultat sera faux.",
  T_48_META_API_1533_P0_D: "entité cible",
  T_48_META_API_1533_P1_D: "Spécifier le centre du cylindre",
  T_48_META_API_1533_P2_D: "Spécifier le rayon de la section transversale du cylindre",
  T_48_META_API_1533_P3_D: "Spécifier la hauteur du cylindre",
  T_48_META_API_1533_P4_D: "Préciser l'angle d'Euler d'un cylindre tournant en trois dimensions autour de son point central",
  T_48_META_API_1533_R_D: "Résultats",
  T_48_META_API_1534_D: "Déterminer si l'entité cible se trouve dans la plage de cubes spécifiée",
  T_48_META_API_1534_P0_D: "entité cible",
  T_48_META_API_1534_P1_D: "Spécifier le centre du cube",
  T_48_META_API_1534_P2_D: "Spécifier la longueur du cube",
  T_48_META_API_1534_P3_D: "Spécifier la largeur du cube",
  T_48_META_API_1534_P4_D: "Spécifier la hauteur du cube",
  T_48_META_API_1534_P5_D: "Spécifier les angles d'Euler pour la rotation tridimensionnelle du cube autour du point central",
  T_48_META_API_1534_R_D: "Résultats",
  T_48_META_API_1535_D: "Déterminer si l'entité cible se trouve dans les colonnes sectorielles spécifiées",
  T_48_META_API_1535_P0_D: "entité cible",
  T_48_META_API_1535_P1_D: "Spécifier le centre du cercle de la section centrale d'une colonne en forme de secteur",
  T_48_META_API_1535_P2_D: "Spécifier le rayon de la section centrale d'une colonne en forme de secteur",
  T_48_META_API_1535_P3_D: "Le rayon de la section transversale de la colonne en éventail qui ne sera pas détectée, dont le point central est un cercle, ne sera pas détecté dans cette région de la petite colonne en éventail, seule la différence entre la colonne en éventail prescrite",
  T_48_META_API_1535_P4_D: "Spécifier la hauteur de la colonne en éventail",
  T_48_META_API_1535_P5_D: "Le détecteur d'angle de section cylindrique en secteur, lorsque l'angle dépasse 360 degrés, la détection se fait en forme de cylindre ; lorsque l'angle est inférieur à 0, la taille de la zone de détection est de 0",
  T_48_META_API_1535_P6_D: "Spécifiez l'angle d'Euler de la rotation de la colonne en éventail autour du point central en trois endroits",
  T_48_META_API_1535_R_D: "Résultats",
  T_48_META_API_1536_D: "Compare la valeur de deux nombres et renvoie le plus grand.",
  T_48_META_API_1536_P0_D: "Lvalue",
  T_48_META_API_1536_P1_D: "Rvalue",
  T_48_META_API_1536_R_D: "chiffre plus important",
  T_48_META_API_1537_D: "Renvoie la valeur maximale de la liste",
  T_48_META_API_1537_P0_D: "Liste cible, n'accepte que les éléments de liste de type numérique",
  T_48_META_API_1537_P1_D: "Comparer les résultats, s'il y a des non-nombres dans la liste, etc., la comparaison échoue et renvoie un faux.",
  T_48_META_API_1537_P2_D: "Renvoie la plus grande valeur de la liste si la comparaison réussit, ou 0 si la comparaison échoue.",
  T_48_META_API_1538_D: "Compare la valeur de deux nombres et renvoie le plus petit.",
  T_48_META_API_1538_P0_D: "Lvalue",
  T_48_META_API_1538_P1_D: "Rvalue",
  T_48_META_API_1538_R_D: "Chiffres plus petits",
  T_48_META_API_1539_D: "Renvoie la plus petite valeur de la liste.",
  T_48_META_API_1539_P0_D: "Liste cible, n'accepte que les éléments de liste de type numérique",
  T_48_META_API_1539_P1_D: "Comparer les résultats, s'il y a des non-nombres dans la liste, etc., la comparaison échoue et renvoie un faux.",
  T_48_META_API_1539_P2_D: "Renvoie la plus petite valeur de la liste si la comparaison réussit, ou 0 si la comparaison échoue.",
  T_48_META_API_1540_D: "Interpolation linéaire, renvoyant la valeur correspondant à la progression de l'interpolation entre la valeur de départ et la valeur cible, coefficients d'interpolation [0,1].",
  T_48_META_API_1540_P0_D: "Valeur de départ de l'interpolation linéaire, qui est renvoyée lorsque la progression de l'interpolation est de 0.",
  T_48_META_API_1540_P1_D: "Valeur cible de l'interpolation linéaire, renvoyée lorsque la progression de l'interpolation est de 1",
  T_48_META_API_1540_P2_D: "Progression de l'interpolation, plage de valeurs [0,1], la valeur 0 permet de revenir à la valeur de départ, la valeur 1 permet de revenir à la valeur cible, la valeur 0,5 permet de revenir à la moyenne de la valeur de départ et de la valeur cible.",
  T_48_META_API_1540_R_D: "Valeur de retour de l'interpolation linéaire",
  T_48_META_API_1541_D: "Limiter la plage de la valeur cible, obtenir la valeur au milieu des trois entrées ; son rôle est de limiter la valeur cible à la plage spécifiée, la valeur cible est plus petite que la valeur minimale pour revenir à la plus petite valeur, plus grande que",
  T_48_META_API_1541_P0_D: "valeur cible",
  T_48_META_API_1541_P1_D: "Valeur minimale de la plage de limites",
  T_48_META_API_1541_P2_D: "Valeur maximale de la plage de limites",
  T_48_META_API_1541_R_D: "Valeur de retour après restriction",
  T_48_META_API_1542_D: "Obtenir les valeurs des canaux de la couleur cible",
  T_48_META_API_1542_P0_D: "couleur cible",
  T_48_META_API_1542_P1_D: "Valeur R de la couleur, dans la plage [0 , 255].",
  T_48_META_API_1542_P2_D: "Valeur G de la couleur, plage [0 , 255].",
  T_48_META_API_1542_P3_D: "Valeur B de la couleur, plage [0 , 255].",
  T_48_META_API_1542_P4_D: "Valeur A de la couleur, dans la plage [0 , 255].",
  T_48_META_API_1543_D: "l'opération de puissance",
  T_48_META_API_1543_P0_D: "base",
  T_48_META_API_1543_P1_D: "exposants",
  T_48_META_API_1543_R_D: "résultat du calcul",
  T_48_META_API_1544_D: "opération logarithmique",
  T_48_META_API_1544_P0_D: "base",
  T_48_META_API_1544_P1_D: "logarithme",
  T_48_META_API_1544_R_D: "résultat du calcul",
  T_48_META_API_1545_D: "Vecteur de direction de l'angle d'Euler",
  T_48_META_API_1545_P0_D: "vecteur de direction",
  T_48_META_API_1545_R_D: "Angle d'Euler",
  T_48_META_API_1546_D: "Vecteur de direction de virage de l'angle d'Euler",
  T_48_META_API_1546_P0_D: "Angle d'Euler",
  T_48_META_API_1546_R_D: "vecteur de direction",
  T_48_META_API_1547_D: "d'un nombre entier à un nombre à virgule flottante",
  T_48_META_API_1547_P0_D: "entier",
  T_48_META_API_1547_R_D: "virgule flottante",
  T_48_META_API_1548_D: "Rotation du vecteur cible en fonction du quaternion",
  T_48_META_API_1548_P0_D: "vecteur cible",
  T_48_META_API_1548_P1_D: "quaternion rotatif",
  T_48_META_API_1548_R_D: "vecteur tourné",
  T_48_META_API_1549_D: "Convertir un nombre cible en chaîne de caractères",
  T_48_META_API_1549_P0_D: "Numéro de destination de la chaîne à convertir",
  T_48_META_API_1549_P1_D: "Format de la chaîne numérique de sortie",
  T_48_META_API_1549_R_D: "chaîne de caractères",
  T_48_META_API_1598_D: "Obtenir l'horodatage du serveur",
  T_48_META_API_1598_R_D: "Renvoie le nombre de secondes à partir de 0:0:0 le 1er janvier 1970",
  T_48_META_API_1599_D: "Obtenir la zone du serveur",
  T_48_META_API_1599_R_D: "Retour aux abréviations régionales (BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "Journaux d'enterrement personnalisés pour l'analyse des données relatives à l'expérience de l'utilisateur",
  T_48_META_API_16_P0_D: "Pour suivre les joueurs signalés",
  T_48_META_API_16_P1_D: "Liste des noms de champs à déclarer",
  T_48_META_API_16_P2_D: "Liste des valeurs de champ à déclarer",
  T_48_META_API_1601_D: "Création d'un dictionnaire",
  T_48_META_API_1601_R_D: "Dictionnaire créé",
  T_48_META_API_1602_D: "Obtenir la valeur correspondant à la clé spécifiée dans le dictionnaire",
  T_48_META_API_1602_P0_D: "Dictionnaire des cibles",
  T_48_META_API_1602_P1_D: "Clé",
  T_48_META_API_1602_R_D: "Valeur",
  T_48_META_API_1603_D: "Définit la valeur correspondant à la clé spécifiée dans le dictionnaire",
  T_48_META_API_1603_P0_D: "Dictionnaire des cibles",
  T_48_META_API_1603_P1_D: "Clé",
  T_48_META_API_1603_P2_D: "Valeur",
  T_48_META_API_1604_D: "Supprime du dictionnaire la paire clé-valeur spécifiée.",
  T_48_META_API_1604_P0_D: "Dictionnaire des cibles",
  T_48_META_API_1604_P1_D: "Clé",
  T_48_META_API_1605_D: "Effacer toutes les paires clé-valeur du dictionnaire",
  T_48_META_API_1605_P0_D: "Dictionnaire des cibles",
  T_48_META_API_1606_D: "Obtenir le nombre de paires clé-valeur dans le dictionnaire",
  T_48_META_API_1606_P0_D: "Dictionnaire des cibles",
  T_48_META_API_1606_R_D: "Longueur du dictionnaire",
  T_48_META_API_1607_D: "Déterminer si une clé existe dans un dictionnaire",
  T_48_META_API_1607_P0_D: "Dictionnaire des cibles",
  T_48_META_API_1607_P1_D: "Clé",
  T_48_META_API_1607_R_D: "Existe-t-il",
  T_48_META_API_1608_D: "Récupère toutes les clés du dictionnaire et les renvoie sous forme de liste.",
  T_48_META_API_1608_P0_D: "Dictionnaire des cibles",
  T_48_META_API_1608_R_D: "Liste de toutes les valeurs des clés",
  T_48_META_API_17_D: "Utilisez une zone de mouvement linéaire en forme de boîte pour la détection et renvoyez toutes les entités rencontrées sur le parcours de la zone en forme de boîte de près à loin Si elles se trouvent initialement dans la plage en forme de boîte, elles ne seront pas détectées ; si les paramètres hiérarchiques sont remplis dans les espaces vides, ils peuvent être détectés.",
  T_48_META_API_17_P0_D: "La moitié de la longueur des trois côtés de la région encadrée, seules les valeurs positives sont acceptées.",
  T_48_META_API_17_P1_D: "Point central de la zone encadrée",
  T_48_META_API_17_P2_D: "Rotation de la zone de la boîte",
  T_48_META_API_17_P3_D: "Sens de la marche dans la zone encadrée",
  T_48_META_API_17_P4_D: "Distance parcourue dans la zone encadrée, seules les valeurs positives sont acceptées.",
  T_48_META_API_17_P5_D: "Masque de calque, seuls les calques remplis participeront à l'analyse, laisser ce champ vide signifie que tous les calques participeront à l'analyse.",
  T_48_META_API_17_P6_D: "Si le déclencheur peut être détecté",
  T_48_META_API_17_P7_D: "Liste des entités touchées",
  T_48_META_API_1700_D: "Convertir une chaîne de caractères en un nombre entier",
  T_48_META_API_1700_P0_D: "chaîne cible",
  T_48_META_API_1700_P1_D: "nombre entier résultant",
  T_48_META_API_1700_P2_D: "Si la conversion a été réussie ou non",
  T_48_META_API_1701_D: "Convertir une chaîne de caractères en un nombre à virgule flottante",
  T_48_META_API_1701_P0_D: "chaîne cible",
  T_48_META_API_1701_P1_D: "résultat flottant",
  T_48_META_API_1701_P2_D: "Si la conversion a été réussie ou non",
  T_48_META_API_18_D: "Utilisez une zone sphérique se déplaçant en ligne droite pour la détection et renvoyez toutes les entités rencontrées sur l'itinéraire de la zone sphérique de près à loin. Si elles se trouvent initialement dans la zone sphérique, elles ne seront pas détectées si le paramètre de niveau est rempli dans le champ vide. , le terrain peut être détecté",
  T_48_META_API_18_P0_D: "Rayon de la région sphérique, seules les valeurs positives sont acceptées.",
  T_48_META_API_18_P1_D: "point central de la zone sphérique",
  T_48_META_API_18_P2_D: "Sens de déplacement dans la zone sphérique",
  T_48_META_API_18_P3_D: "Distance de déplacement de la surface sphérique, seules les valeurs positives sont acceptées.",
  T_48_META_API_18_P4_D: "Masque de calque, seuls les calques remplis participeront à l'analyse, laisser ce champ vide signifie que tous les calques participeront à l'analyse.",
  T_48_META_API_18_P5_D: "Si le déclencheur peut être détecté",
  T_48_META_API_18_P6_D: "Liste des entités touchées",
  T_48_META_API_19_D: "Utilisez une zone de capsule se déplaçant linéairement pour la détection, et renvoyez toutes les entités rencontrées sur le parcours de la zone de capsule de près à loin. Si elles se trouvent initialement dans la zone de capsule, elles ne seront pas détectées si le paramètre de niveau est renseigné. peut être détecté.",
  T_48_META_API_19_P0_D: "Rayon de l'hémisphère à chaque extrémité de la région du corps de la capsule, seules les valeurs positives sont acceptées.",
  T_48_META_API_19_P1_D: "La distance entre les centres sphériques des hémisphères à chaque extrémité de la région du corps de la capsule, qui doit être supérieure à deux fois le rayon des hémisphères à chaque extrémité.",
  T_48_META_API_19_P2_D: "Point central de la région du corps de la capsule",
  T_48_META_API_19_P3_D: "Rotation de la région du corps de la capsule",
  T_48_META_API_19_P4_D: "Sens de déplacement dans la région du corps de la capsule",
  T_48_META_API_19_P5_D: "La distance parcourue dans la zone de la capsule, seules les valeurs positives sont acceptées.",
  T_48_META_API_19_P6_D: "Masque de calque, seuls les calques remplis participeront à l'analyse, laisser ce champ vide signifie que tous les calques participeront à l'analyse.",
  T_48_META_API_19_P7_D: "Si le déclencheur peut être détecté",
  T_48_META_API_19_P8_D: "Liste des entités touchées",
  T_48_META_API_2_D: "Récupère toutes les équipes du jeu en cours et renvoie la liste des équipes.",
  T_48_META_API_2_R_D: "Liste des équipes",
  T_48_META_API_20_D: "Utilisez une zone statique en forme de boîte pour la détection et renvoyez toutes les entités dans la zone en forme de boîte. Si le paramètre de niveau est rempli dans les espaces vides, le terrain peut être détecté.",
  T_48_META_API_20_P0_D: "La moitié de la longueur des trois côtés de la région encadrée, seules les valeurs positives sont acceptées.",
  T_48_META_API_20_P1_D: "Point central de la zone encadrée",
  T_48_META_API_20_P2_D: "Rotation de la zone de la boîte",
  T_48_META_API_20_P3_D: "Masque de calque, seuls les calques remplis participeront à l'analyse, laisser ce champ vide signifie que tous les calques participeront à l'analyse.",
  T_48_META_API_20_P4_D: "Si le déclencheur peut être détecté",
  T_48_META_API_20_P5_D: "Liste des entités touchées",
  T_48_META_API_2000_D: "La définition de la valeur d'un attribut de l'entité cible nécessite que l'attribut ait déjà été défini.",
  T_48_META_API_2000_P0_D: "entité cible",
  T_48_META_API_2000_P1_D: "Un attribut de l'entité cible",
  T_48_META_API_2000_P2_D: "La valeur cible, qui doit correspondre au type requis lors de la définition de la propriété.",
  T_48_META_API_2000_P3_D: "Tous les types prennent en charge l'affectation, et les types numériques prennent en charge l'auto-addition, l'auto-minoration, l'auto-multiplication, l'auto-division et l'auto-restauration.",
  T_48_META_API_2001_D: "Obtenir la valeur d'un attribut d'une entité",
  T_48_META_API_2001_P0_D: "entité cible",
  T_48_META_API_2001_P1_D: "L'ID d'un attribut de cette entité",
  T_48_META_API_2001_R_D: "valeur d'un attribut",
  T_48_META_API_2002: "Définir la propriété du graphique",
  T_48_META_API_2002_D: "Définition des variables de script",
  T_48_META_API_2002_P0_D: "entité cible",
  T_48_META_API_2002_P1: "ID du graphique",
  T_48_META_API_2002_P1_D: "ID du script cible",
  T_48_META_API_2002_P2: "ID de la propriété",
  T_48_META_API_2002_P2_D: "ID de la propriété membre définie dans le script",
  T_48_META_API_2002_P3: "Valeur de la propriété",
  T_48_META_API_2002_P3_D: "La valeur cible, qui doit correspondre au type requis lors de la définition de la propriété.",
  T_48_META_API_2002_P4_D: "Tous les types prennent en charge l'affectation, et les types numériques prennent en charge l'auto-addition, l'auto-minoration, l'auto-multiplication, l'auto-division et l'auto-restauration.",
  T_48_META_API_2003: "Obtenir la propriété du graphique",
  T_48_META_API_2003_D: "Obtenir des variables de script",
  T_48_META_API_2003_P0_D: "entité cible",
  T_48_META_API_2003_P1: "ID du graphique",
  T_48_META_API_2003_P1_D: "ID du script cible",
  T_48_META_API_2003_P2: "ID de la propriété",
  T_48_META_API_2003_P2_D: "ID de l'attribut cible",
  T_48_META_API_2003_R_D: "valeur d'un attribut",
  T_48_META_API_2004_D: "Définir et initialiser une variable locale, qui est cadrée depuis la position de la déclaration jusqu'à la fin du bloc d'instructions dans lequel elle se trouve.",
  T_48_META_API_2004_P0_D: "nom de la variable",
  T_48_META_API_2004_P1_D: "valeur initiale de la variable",
  T_48_META_API_2004_P2_D: "Type de déclaration de variable, l'affectation doit correspondre au type déclaré",
  T_48_META_API_2005_D: "Définir la valeur d'une variable locale, qui est définie à partir de la position de la déclaration jusqu'à la fin du bloc d'instructions dans lequel elle se trouve.",
  T_48_META_API_2005_P0_D: "nom de la variable",
  T_48_META_API_2005_P1: "Valeur variable",
  T_48_META_API_2005_P1_D: "valeur de la variable",
  T_48_META_API_2005_P2_D: "Tous les types prennent en charge l'affectation, et les types numériques prennent en charge l'auto-addition, l'auto-minoration, l'auto-multiplication, l'auto-division et l'auto-restauration.",
  T_48_META_API_2006: "Obtenir une variable locale",
  T_48_META_API_2006_D: "Obtenir la valeur d'une variable locale, qui est définie à partir de la position de la déclaration jusqu'à la fin du bloc d'instructions.",
  T_48_META_API_2006_P0: "Nom de la variable",
  T_48_META_API_2006_P0_D: "nom de la variable",
  T_48_META_API_2006_R_D: "valeur de la variable",
  T_48_META_API_2009: "Rechercher et appeler l'API personnalisée globale avec Serial",
  T_48_META_API_2009_D: "Appelle les fonctions personnalisées globales en série, et s'il y a une attente dans la fonction personnalisée, l'emplacement de l'appel attend également.",
  T_48_META_API_2009_P0: "ID du graphique",
  T_48_META_API_2009_P0_D: "ID du script où se trouve la fonction personnalisée",
  T_48_META_API_2009_P1: "ID de fonction",
  T_48_META_API_2009_P1_D: "ID de la fonction personnalisée appelée",
  T_48_META_API_2009_P2_D: "Liste des arguments transmis à la fonction personnalisée",
  T_48_META_API_2010: "Rechercher et appeler l'API personnalisée globale avec Parallel",
  T_48_META_API_2010_D: "Appelle des fonctions personnalisées globales de manière parallèle, en retournant immédiatement à l'emplacement de l'appel pour poursuivre la ligne, qu'il y ait ou non une attente dans la fonction personnalisée.",
  T_48_META_API_2010_P0: "ID du graphique",
  T_48_META_API_2010_P0_D: "ID du script où se trouve la fonction personnalisée",
  T_48_META_API_2010_P1: "ID de fonction",
  T_48_META_API_2010_P1_D: "ID de la fonction personnalisée appelée",
  T_48_META_API_2010_P2_D: "Liste des arguments transmis à la fonction personnalisée",
  T_48_META_API_2013: "Définir la propriété de l'auto-graphe",
  T_48_META_API_2013_D: "Définition des variables pour le script en cours",
  T_48_META_API_2013_P0: "ID de la propriété",
  T_48_META_API_2013_P0_D: "ID de l'attribut cible",
  T_48_META_API_2013_P1: "Valeur de la propriété",
  T_48_META_API_2013_P1_D: "valeur cible",
  T_48_META_API_2013_P2_D: "Tous les types prennent en charge l'affectation, et les types numériques prennent en charge l'auto-addition, l'auto-minoration, l'auto-multiplication, l'auto-division et l'auto-restauration.",
  T_48_META_API_2014: "Obtenir la propriété Self Graph",
  T_48_META_API_2014_D: "Récupération des variables du script en cours",
  T_48_META_API_2014_P0: "ID de la propriété",
  T_48_META_API_2014_P0_D: "ID de l'attribut cible",
  T_48_META_API_2014_R_D: "valeur d'un attribut",
  T_48_META_API_21_D: "Utilisez une zone sphérique statique pour la détection et renvoyez toutes les entités dans la zone sphérique. Si le paramètre de niveau est rempli dans les espaces, le terrain peut être détecté.",
  T_48_META_API_21_P0_D: "Rayon de la région sphérique, seules les valeurs positives sont acceptées.",
  T_48_META_API_21_P1_D: "point central de la zone sphérique",
  T_48_META_API_21_P2_D: "Masque de calque, seuls les calques remplis participeront à l'analyse, laisser ce champ vide signifie que tous les calques participeront à l'analyse.",
  T_48_META_API_21_P3_D: "Si le déclencheur peut être détecté",
  T_48_META_API_21_P4_D: "Liste des entités touchées",
  T_48_META_API_22_D: "Utilisez une zone de capsule statique pour la détection et renvoyez toutes les entités dans la zone de capsule. Si le paramètre de niveau est renseigné, le terrain peut être détecté.",
  T_48_META_API_22_P0_D: "Rayon de l'hémisphère à chaque extrémité de la région du corps de la capsule, seules les valeurs positives sont acceptées.",
  T_48_META_API_22_P1_D: "La distance entre les centres sphériques des hémisphères à chaque extrémité de la région du corps de la capsule, qui doit être supérieure à deux fois le rayon des hémisphères à chaque extrémité.",
  T_48_META_API_22_P2_D: "Point central de la région du corps de la capsule",
  T_48_META_API_22_P3_D: "Rotation de la région du corps de la capsule",
  T_48_META_API_22_P4_D: "Masque de calque, seuls les calques remplis participeront à l'analyse, laisser ce champ vide signifie que tous les calques participeront à l'analyse.",
  T_48_META_API_22_P5_D: "Si le déclencheur peut être détecté",
  T_48_META_API_22_P6_D: "Liste des entités touchées",
  T_48_META_API_23_D: "Définir le statut de l'objet spécial pour le joueur, les objets spéciaux ne peuvent avoir qu'un seul statut.",
  T_48_META_API_23_P0_D: "joueur",
  T_48_META_API_23_P1_D: "ID de l'article",
  T_48_META_API_23_P2_D: "Activation ou non de l'élément",
  T_48_META_API_23_P3_D: "substance spéciale",
  T_48_META_API_24_D: "Appliquer une force à la cible, qui doit être un objet physique.",
  T_48_META_API_24_P0_D: "objet physique cible",
  T_48_META_API_24_P1_D: "vecteur force",
  T_48_META_API_24_P2_D: "Type de force",
  T_48_META_API_25_D: "Appliquer une force une fois en un point, la cible doit être un corps rigide.",
  T_48_META_API_25_P0_D: "corps rigide cible",
  T_48_META_API_25_P1_D: "vecteur force",
  T_48_META_API_25_P2_D: "Position d'application de la force",
  T_48_META_API_25_P3_D: "Type de force",
  T_48_META_API_26_D: "Appliquer un couple à la cible, qui doit être rigide.",
  T_48_META_API_26_P0_D: "corps rigide cible",
  T_48_META_API_26_P1_D: "torsion",
  T_48_META_API_26_P2_D: "Type de force appliquée",
  T_48_META_API_27_D: "Déplacer le corps rigide cible à la position spécifiée",
  T_48_META_API_27_P0_D: "corps rigide cible",
  T_48_META_API_27_P1_D: "lieu désigné",
  T_48_META_API_28_D: "Rotation du corps rigide cible",
  T_48_META_API_28_P0_D: "corps rigide cible",
  T_48_META_API_28_P1_D: "quaternion rotatif",
  T_48_META_API_29_D: "Crée un mouvement interpolé dans lequel les propriétés spécifiées de l'entité cible sont lissées en fonction des paramètres.",
  T_48_META_API_29_P0_D: "entité cible",
  T_48_META_API_29_P1_D: "ID d'attribut nécessitant des modifications de mouvement",
  T_48_META_API_29_P2_D: "Valeur initiale de l'attribut",
  T_48_META_API_29_P3_D: "Valeur finale de l'attribut",
  T_48_META_API_29_P4_D: `Vous pouvez choisir entre simple, boucle et réciproque. 
 Boucle signifie qu'après chaque mouvement, l'entité se déplace à nouveau de la valeur initiale. Réciproque signifie qu'après le mouvement de la valeur initiale à la valeur cible, l'entité se déplace à nouveau de la valeur cible à la valeur initiale, puis répète le processus.`,
  T_48_META_API_29_P5_D: "Point de contrôle de la courbe de Bessel",
  T_48_META_API_29_P6_D: "Durée d'un changement en millisecondes",
  T_48_META_API_29_P7_D: "Création d'entités de mouvement interpolées",
  T_48_META_API_29_P8_D: "Si la lecture démarre automatiquement après la création",
  T_48_META_API_3_D: "En passant à la phase cible, le tour est également une phase spéciale. Lorsque l'on passe à une phase au cours d'un tour, le décompte du tour est de 0.",
  T_48_META_API_3_P0_D: "Index du tour ou de la phase cible",
  T_48_META_API_30_D: "Oblige le joueur cible à entrer dans le véhicule spécifié",
  T_48_META_API_30_P0_D: "acteur cible",
  T_48_META_API_30_P1_D: "entité porteuse",
  T_48_META_API_30_P2_D: "Numéro de siège",
  T_48_META_API_30_P3_D: "Qu'il réussisse ou non à faire entrer le joueur dans le transporteur",
  T_48_META_API_3001_D: "Le joueur cible doit se défausser d'un objet",
  T_48_META_API_3001_P0_D: "acteur cible",
  T_48_META_API_3001_P1_D: "entité physique",
  T_48_META_API_3002_D: "Obtenir les coordonnées disponibles à l'intérieur du point de naissance aléatoire actuellement disponible et qui n'est pas entièrement occupé (obsolète, veuillez utiliser GetRandomSpawnPosition).",
  T_48_META_API_3002_P0_D: "Joueurs auxquels il faut attribuer une zone de naissance",
  T_48_META_API_3002_R_D: "Coordonnées de points aléatoires attribuées au hasard",
  T_48_META_API_3003_D: "Obtenir le score total du joueur pour le type de point spécifié",
  T_48_META_API_3003_P0_D: "joueur",
  T_48_META_API_3003_P1_D: "Type de points",
  T_48_META_API_3003_R_D: "valeur du point",
  T_48_META_API_3004_D: "Fixer le score du tour pour le type de point spécifié d'un joueur",
  T_48_META_API_3004_P0_D: "entité du joueur",
  T_48_META_API_3004_P1_D: "Type de points",
  T_48_META_API_3004_P2_D: "valeur du point",
  T_48_META_API_3005_D: "Obtenir le score total de l'équipe pour le type de point spécifié",
  T_48_META_API_3005_P0_D: "entité de l'équipe",
  T_48_META_API_3005_P1_D: "Type de points",
  T_48_META_API_3005_R_D: "valeur du point",
  T_48_META_API_3006_D: "Définition du score de la manche pour le type de point spécifié d'une équipe",
  T_48_META_API_3006_P0_D: "entité de l'équipe",
  T_48_META_API_3006_P1_D: "Type de points",
  T_48_META_API_3006_P2_D: "valeur du point",
  T_48_META_API_3007_D: "Obtenir le score du joueur pour le tour et le type de point spécifiés.",
  T_48_META_API_3007_P0_D: "entité du joueur",
  T_48_META_API_3007_P1_D: "Index rond",
  T_48_META_API_3007_P2_D: "Type de points",
  T_48_META_API_3007_R_D: "valeur du point",
  T_48_META_API_3008_D: "Obtenir le score de l'équipe pour le tour spécifié, le type de point",
  T_48_META_API_3008_P0_D: "entité de l'équipe",
  T_48_META_API_3008_P1_D: "Index rond",
  T_48_META_API_3008_P2_D: "Type de points",
  T_48_META_API_3008_R_D: "valeur du point",
  T_48_META_API_3009_D: "Obtenir le classement général du joueur",
  T_48_META_API_3009_P0_D: "entité du joueur",
  T_48_META_API_3009_R_D: "position dans un classement de noms",
  T_48_META_API_3011_D: "Obtenir le classement général de l'équipe",
  T_48_META_API_3011_P0_D: "abandonné",
  T_48_META_API_3011_R_D: "position dans un classement de noms",
  T_48_META_API_3013_D: "Obtenir le classement du joueur pour un tour donné",
  T_48_META_API_3013_P0_D: "entité du joueur",
  T_48_META_API_3013_P1_D: "Index rond",
  T_48_META_API_3013_R_D: "position dans un classement de noms",
  T_48_META_API_3014_D: "Obtenir le classement des équipes pour un tour donné",
  T_48_META_API_3014_P0_D: "abandonné",
  T_48_META_API_3014_P1_D: "Index rond",
  T_48_META_API_3014_R_D: "position dans un classement de noms",
  T_48_META_API_3015_D: "Obtenir le portefeuille de l'entité cible",
  T_48_META_API_3015_P0_D: "entité cible",
  T_48_META_API_3015_P1_D: "Présence d'un portefeuille",
  T_48_META_API_3015_P2_D: "Entités de portefeuille acquises",
  T_48_META_API_3016_D: "Crée un portefeuille pour le joueur cible, non valide si le joueur a déjà un portefeuille.",
  T_48_META_API_3016_P0_D: "acteur cible",
  T_48_META_API_3016_P1_D: "Entité liée au portefeuille, propriétaire du portefeuille",
  T_48_META_API_3016_P2_D: "entité du portefeuille",
  T_48_META_API_3017_D: "Ajouter des devises à un portefeuille spécifique",
  T_48_META_API_3017_P0_D: "Portefeuille cible",
  T_48_META_API_3017_P1_D: "Type de monnaie ajoutée",
  T_48_META_API_3017_P2_D: "Augmentation du nombre de monnaies",
  T_48_META_API_3018_D: "Réduction de la monnaie pour un portefeuille donné",
  T_48_META_API_3018_P0_D: "Portefeuille cible",
  T_48_META_API_3018_P1_D: "Type de monnaie réduit",
  T_48_META_API_3018_P2_D: "Réduction du nombre de monnaies",
  T_48_META_API_3019_D: "Transférer des devises d'un portefeuille à l'autre",
  T_48_META_API_3019_P0_D: "Portefeuille pour le transfert de devises",
  T_48_META_API_3019_P1_D: "Types d'argent transféré",
  T_48_META_API_3019_P2_D: "Nombre de devises transférées",
  T_48_META_API_3019_P3_D: "Portefeuille vers lequel la monnaie est transférée",
  T_48_META_API_3020_D: "Obtenir le nombre de devises d'un type donné dans un portefeuille donné",
  T_48_META_API_3020_P0_D: "Portefeuille cible",
  T_48_META_API_3020_P1_D: "Type de devise de la demande",
  T_48_META_API_3020_R_D: "Montant de la monnaie",
  T_48_META_API_3021_D: "Obtenir les entités du type de monnaie spécifié dans le portefeuille spécifié",
  T_48_META_API_3021_P0_D: "Portefeuille cible",
  T_48_META_API_3021_P1_D: "Type de devise de la demande",
  T_48_META_API_3021_R_D: "Entités monétaires",
  T_48_META_API_3022_D: "Obtenir tous les magasins du jeu et les renvoyer sous forme de liste.",
  T_48_META_API_3022_R_D: "Liste des entités du magasin",
  T_48_META_API_3023_D: "Remplace la forme du lecteur cible par la forme d'un objet de scène spécifié.",
  T_48_META_API_3023_P0_D: "acteur cible",
  T_48_META_API_3023_P1_D: "Cibler les objets de la scène à remplacer",
  T_48_META_API_3023_P2_D: "Remplacement du composant de camouflage de la transformation du joueur créé après le",
  T_48_META_API_3024_D: "Annule le statut de camouflage du joueur",
  T_48_META_API_3024_P0_D: "acteur cible",
  T_48_META_API_3025_D: "Créer un alter ego sous la forme d'une entité de scène chez le joueur cible",
  T_48_META_API_3025_P0_D: "acteur cible",
  T_48_META_API_3025_P1_D: "Entités de scène pour les images fractionnées",
  T_48_META_API_3025_P2_D: "Entités de bilocation créées",
  T_48_META_API_3026_D: "Obtention de l'entité camouflée du joueur",
  T_48_META_API_3026_P0_D: "joueur",
  T_48_META_API_3026_R_D: "Joueurs déguisant des entités",
  T_48_META_API_3027_D: "Obtenir une entité de canal de discussion par index",
  T_48_META_API_3027_P0_D: "Index du canal de chat, plage [1,8]",
  T_48_META_API_3027_R_D: "Entités du canal de discussion",
  T_48_META_API_3028_D: "Obtient l'entité du canal de discussion dans lequel le joueur spécifié se trouve actuellement.",
  T_48_META_API_3028_P0_D: "acteur cible",
  T_48_META_API_3028_R_D: "Entités du canal de discussion",
  T_48_META_API_3029_D: "Permet aux joueurs de rejoindre le canal de discussion désigné et de basculer vers le canal cible lorsque les joueurs sont déjà dans d'autres canaux de discussion.",
  T_48_META_API_3029_P0_D: "acteur cible",
  T_48_META_API_3029_P1_D: "Entités du canal de discussion",
  T_48_META_API_3030_D: "Le joueur quitte le canal dans lequel il se trouve actuellement et se trouve dans un état où il n'est plus dans aucun canal de discussion après cela.",
  T_48_META_API_3030_P0_D: "acteur cible",
  T_48_META_API_3031_D: "abandonné",
  T_48_META_API_3031_P0_D: "Entité du canal de discussion, vide s'il n'y a pas de joueur dans le canal",
  T_48_META_API_3032_D: "Définition de l'état comportemental du joueur",
  T_48_META_API_3032_P0_D: "acteur cible",
  T_48_META_API_3032_P1_D: "Types de comportement des joueurs",
  T_48_META_API_3032_P2_D: "Activé : le bouton HUD est disponible, normalement utilisable Désactivé : le bouton HUD est désactivé, il est impossible d'accéder à l'état comportemental de manière active ou passive Masqué : le bouton HUD est masqué, il est impossible d'accéder à l'état",
  T_48_META_API_3033_D: "Le joueur se transforme en un objet dans une scène donnée",
  T_48_META_API_3033_P0_D: "acteur cible",
  T_48_META_API_3033_P1_D: "à transformer en",
  T_48_META_API_3033_P2_D: "Entités créées après transformation",
  T_48_META_API_3034_D: "Le joueur crée un alter ego de sa propre apparence",
  T_48_META_API_3034_P0_D: "acteur cible",
  T_48_META_API_3034_P1_D: "Création d'entités alter ego",
  T_48_META_API_3035_D: "Créer un magasin personnalisé avec des étagères comme niveau suivant du magasin",
  T_48_META_API_3035_P0_D: "Création d'entités de magasins",
  T_48_META_API_3036_D: "Créer une étagère personnalisée dont le niveau supérieur correspond à la boutique et le niveau inférieur aux produits.",
  T_48_META_API_3036_P0_D: "Création d'entités de l'étagère",
  T_48_META_API_3037_D: "Créer un produit personnalisé, le produit peut ajouter des articles",
  T_48_META_API_3037_P0_D: "Entités de produits de base créées",
  T_48_META_API_3038_D: "L'ajout d'articles à un produit permet d'ajouter plusieurs articles à un produit en utilisant l'élément plusieurs fois.",
  T_48_META_API_3038_P0_D: "Entités de produits de base",
  T_48_META_API_3038_P1_D: "Éléments à ajouter",
  T_48_META_API_3038_P2_D: "Nombre d'articles",
  T_48_META_API_3039_D: "Donner des récompenses pour le Jailbreak",
  T_48_META_API_3039_P0_D: "entité du joueur",
  T_48_META_API_3039_P1_D: "quantités",
  T_48_META_API_3039_P2_D: "argent réel",
  T_48_META_API_3040_D: "Mise à jour des tâches de jailbreak",
  T_48_META_API_3040_P0_D: "entité du joueur",
  T_48_META_API_3040_P1_D: "ID de la tâche",
  T_48_META_API_3040_P2_D: "(valoir)",
  T_48_META_API_3041_D: "Obtenir les coordonnées d'un point de naissance aléatoire, uniquement parmi les points de naissance disponibles qui ne sont pas entièrement occupés.",
  T_48_META_API_3041_P0_D: "acteur cible",
  T_48_META_API_3041_R_D: "Randomise les coordonnées du point de naissance. Si aucun point de naissance ne correspond aux critères, il renvoie un emplacement proche de (0, 0, 0).",
  T_48_META_API_3042_D: "Quitter le jeu Jailbreak",
  T_48_META_API_3042_P0_D: "entité du joueur",
  T_48_META_API_3042_P1_D: "ID de la tâche",
  T_48_META_API_3043_D: "Basé sur les accessoires de jailbreak",
  T_48_META_API_3043_P0_D: "entité du joueur",
  T_48_META_API_3043_P1_D: "Type d'accessoires",
  T_48_META_API_3043_P2_D: "ID des accessoires",
  T_48_META_API_31_D: "Crée un mouvement relatif à lui-même, dans lequel l'entité cible change à chaque fois par rapport à ses valeurs d'attributs actuelles.",
  T_48_META_API_31_P0_D: "entité cible",
  T_48_META_API_31_P1_D: "Propriétés nécessitant des changements de mouvement",
  T_48_META_API_31_P2_D: "Montant du changement par mouvement",
  T_48_META_API_31_P3_D: "Point de contrôle de la courbe de Bessel",
  T_48_META_API_31_P4_D: `Simple : le mouvement s'arrête lorsque l'attribut change d'une quantité Delta 
 Cyclique : le mouvement est répété, chaque fois que l'attribut change d'une quantité Delta`,
  T_48_META_API_31_P5_D: "Durée d'un changement en millisecondes",
  T_48_META_API_31_P6_D: "Entités créées qui se déplacent par rapport à elles-mêmes",
  T_48_META_API_31_P7_D: "Si la lecture démarre automatiquement après la création",
  T_48_META_API_3100_D: "La cible joue l'animation dans l'état spécifié",
  T_48_META_API_3100_P0_D: "Composants d'entité qui jouent des animations avec des contrôleurs d'animation montables",
  T_48_META_API_3100_P1_D: "L'état spécifié du contrôleur d'animation",
  T_48_META_API_3100_P2_D: "Mise à l'échelle de la vitesse de lecture de l'animation",
  T_48_META_API_3100_P3_D: "Type de boucle, vous pouvez conserver la logique originale de l'animation, la jouer une seule fois ou la faire tourner en boucle.",
  T_48_META_API_3101_D: "Jouer l'animation des personnages, prendre en charge les ressources d'animation personnalisées",
  T_48_META_API_3101_P0_D: "acteur cible",
  T_48_META_API_3101_P1_D: "ID de ressource d'animation personnalisé",
  T_48_META_API_3101_P2_D: "Boucle ou non",
  T_48_META_API_3102_D: "Définition des ressources du personnage pour un joueur donné",
  T_48_META_API_3102_P0_D: "acteur cible",
  T_48_META_API_3102_P1_D: "Rôle personnalisé ID de la ressource",
  T_48_META_API_3109_D: "La mise en marche permet de ralentir le mouvement jusqu'à la fin de la zone de sécurité.",
  T_48_META_API_3109_P0_D: "Position de départ de la zone de sécurité",
  T_48_META_API_3109_P1_D: "Emplacement de la fin de la zone de sécurité",
  T_48_META_API_3109_P2_D: "Rayon initial de la zone de sécurité",
  T_48_META_API_3109_P3_D: "Rayon final de la zone de sécurité",
  T_48_META_API_3109_P4_D: "Temps en secondes pour que la zone de sécurité atteigne son état final",
  T_48_META_API_3109_P5_D: "Quantité de dégâts par seconde subis en dehors de la zone de sécurité",
  T_48_META_API_3110_D: "Changement de groupe d'apparence des caractères",
  T_48_META_API_3110_P0_D: "les objectifs",
  T_48_META_API_3110_P1_D: "Groupe Apparence",
  T_48_META_API_3111_D: "Afficher le groupe d'apparence des rôles",
  T_48_META_API_3111_P0_D: "les objectifs",
  T_48_META_API_3111_P1_D: "Groupe Apparence",
  T_48_META_API_3112_D: "Groupe d'apparition des caractères cachés",
  T_48_META_API_3112_P0_D: "les objectifs",
  T_48_META_API_3112_P1_D: "Groupe Apparence",
  T_48_META_API_3121_D: "Envoi des résultats des assertions au PC Craftland Studio à des fins statistiques",
  T_48_META_API_3121_P0_D: "expression d'assertion",
  T_48_META_API_3121_P1_D: "attirer l'attention sur qqch.",
  T_48_META_API_32_D: "Obtenir les données du jeton du jour du joueur",
  T_48_META_API_32_P0_D: "acteur cible",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "Nombre de jetons",
  T_48_META_API_32_P3_D: "Si le tuple a été invoqué avec succès ou non",
  T_48_META_API_3200_D: "Ajouter des objets au joueur et retourner la liste des objets distribués",
  T_48_META_API_3200_P0_D: "joueur",
  T_48_META_API_3200_P1_D: "ID de l'article",
  T_48_META_API_3200_P2_D: "Nombre d'articles",
  T_48_META_API_3200_P3_D: "Une liste d'éléments ajoutés pour le joueur, même si un seul élément est ajouté, il est renvoyé sous forme de liste.",
  T_48_META_API_3201_D: "Redonne du sang au joueur désigné sans dépasser la limite de sang.",
  T_48_META_API_3201_P0_D: "acteur cible",
  T_48_META_API_3201_P1_D: "Une valeur qui ajoute du sang au joueur, seuls les nombres positifs sont acceptés.",
  T_48_META_API_3202_D: "Définition de la liste de compétences du joueur cible",
  T_48_META_API_3202_P0_D: "acteur cible",
  T_48_META_API_3202_P1_D: "Liste des compétences",
  T_48_META_API_3203_D: "Obtenir une liste des compétences du joueur cible",
  T_48_META_API_3203_P0_D: "acteur cible",
  T_48_META_API_3203_R_D: "Liste des compétences",
  T_48_META_API_3205_D: "Supprimer un certain nombre d'objets du lecteur",
  T_48_META_API_3205_P0_D: "acteur cible",
  T_48_META_API_3205_P1_D: "Type d'élément à supprimer",
  T_48_META_API_3205_P2_D: "Le nombre d'objets à supprimer, s'il est supérieur au nombre d'objets détenus par le joueur, seuls les objets détenus seront supprimés.",
  T_48_META_API_3206_D: "Obtenir le nombre spécifié d'objets détenus par un joueur",
  T_48_META_API_3206_P0_D: "acteur cible",
  T_48_META_API_3206_P1_D: "Type d'article",
  T_48_META_API_3206_R_D: "Nombre de participations des joueurs",
  T_48_META_API_3207_D: "Détecter si le joueur peut déclencher le point de contrôle actuel",
  T_48_META_API_3207_P0_D: "acteur cible",
  T_48_META_API_3207_P1_D: "Déclencheur",
  T_48_META_API_3207_R_D: "Vrai : peut être déclenché, Faux : ne peut pas être déclenché",
  T_48_META_API_3208_D: "Mode Infection Zombie Evolution",
  T_48_META_API_3208_P0_D: "acteur cible",
  T_48_META_API_3209_D: "L'entité IA arrête/renforce l'arbre de comportement par défaut",
  T_48_META_API_3209_P0_D: "Pour atteindre l'objectif de l'arbre comportemental",
  T_48_META_API_3209_P1_D: "S'il faut mettre en œuvre l'arbre de comportement par défaut",
  T_48_META_API_3210_D: "Entité IA poursuivant une cible désignée",
  T_48_META_API_3210_P0_D: "Entités d'IA effectuant des poursuites",
  T_48_META_API_3210_P1_D: "cible",
  T_48_META_API_3211_D: "Détruire les objets du joueur (obsolète, utiliser DeleteEquipment)",
  T_48_META_API_3211_P0_D: "Le joueur dont l'objet a été détruit",
  T_48_META_API_3211_P1_D: "Type d'objet détruit",
  T_48_META_API_3211_P2_D: "Emplacement d'arme, arme uniquement.",
  T_48_META_API_3212_D: "Changer de maillot",
  T_48_META_API_3212_P0_D: "acteur cible",
  T_48_META_API_3212_P1_D: "Style vestimentaire",
  T_48_META_API_3212_P2_D: "Couleurs principales I",
  T_48_META_API_3212_P3_D: "Couleur principale II",
  T_48_META_API_3212_P4_D: "configurer",
  T_48_META_API_3213_D: "Remettre le maillot du joueur dans son état d'origine",
  T_48_META_API_3213_P0_D: "acteur cible",
  T_48_META_API_3214_D: "Chat vocal du joueur Switch",
  T_48_META_API_3214_P0_D: "acteur cible",
  T_48_META_API_3214_P1_D: "Fermer ou non le chat vocal, True:Close False:Open",
  T_48_META_API_3215_D: "Changer de joueur Chat rapide",
  T_48_META_API_3215_P0_D: "acteur cible",
  T_48_META_API_3215_P1_D: "Fermer ou non la discussion rapide, True:Close False:Open",
  T_48_META_API_3216_D: "Indiquer si le joueur cible peut ramasser des objets",
  T_48_META_API_3216_P0_D: "acteur cible",
  T_48_META_API_3216_P1_D: "S'il est interdit ou non de ramasser des objets, true : le ramassage est interdit false : le ramassage est autorisé",
  T_48_META_API_3217_D: "Déterminer si le joueur cible peut se défausser d'objets",
  T_48_META_API_3217_P0_D: "acteur cible",
  T_48_META_API_3217_P1_D: "Il est interdit ou non de laisser tomber des objets, vrai : il est interdit de les ramasser faux : il est possible de les ramasser",
  T_48_META_API_3218_D: "Détruit une arme dans l'emplacement désigné par le joueur",
  T_48_META_API_3218_P0_D: "acteur cible",
  T_48_META_API_3218_P1_D: "Emplacements d'armes à détruire",
  T_48_META_API_3218_P2_D: "Nombre à détruire",
  T_48_META_API_3218_P3_D: "Destruction réussie ou non, la destruction échoue si aucune arme n'est équipée dans l'emplacement d'arme.",
  T_48_META_API_3219_D: "Vide le sac à dos du joueur cible de tous ses objets, y compris les objets équipés.",
  T_48_META_API_3219_P0_D: "acteur cible",
  T_48_META_API_3220_D: "Réglage de l'orientation du lecteur",
  T_48_META_API_3220_P0_D: "acteur cible",
  T_48_META_API_3220_P1_D: "Orientation des joueurs",
  T_48_META_API_3221_D: "<Player>(obsolète, ne pas utiliser, voir l'attribut :Skeleton pour plus d'informations)",
  T_48_META_API_3221_P0_D: "entité du joueur",
  T_48_META_API_3221_P1_D: "zone de zoom",
  T_48_META_API_3221_P2_D: "valeur du zoom",
  T_48_META_API_3222_D: "Accorder un effet de projection à un joueur, le joueur cible va chuter avec une accélération fixe et l'effet de projection sera forcé à s'arrêter en cas de collision dans les airs.",
  T_48_META_API_3222_P0_D: "acteur cible",
  T_48_META_API_3222_P1_D: "Direction du défoncement",
  T_48_META_API_3222_P2_D: "Délit de fuite",
  T_48_META_API_3222_P3_D: "Vitesse initiale de l'axe Y à l'impact",
  T_48_META_API_3222_P4_D: "Vitesse initiale dans le plan XZ à l'impact",
  T_48_META_API_3222_P5_D: "Modifier ou non l'orientation du lecteur",
  T_48_META_API_3223_D: "Obtenir l'identifiant du costume du joueur ou du PNJ cible",
  T_48_META_API_3223_P0_D: "Joueur ou PNJ cible",
  T_48_META_API_3223_P1_D: "Type de vêtements",
  T_48_META_API_3223_R_D: "Identification des vêtements",
  T_48_META_API_3224_D: "Définition de l'identifiant du costume du joueur ou du PNJ cible",
  T_48_META_API_3224_P0_D: "Joueur ou PNJ cible",
  T_48_META_API_3224_P1_D: "Identification des vêtements",
  T_48_META_API_3225_D: "Restaure les vêtements par défaut du joueur ciblé, ne peut pas être appliqué aux PNJ.",
  T_48_META_API_3225_P0_D: "acteur cible",
  T_48_META_API_3226_D: "Attaques d'entités d'intelligence artificielle Cible désignée",
  T_48_META_API_3226_P0_D: "L'entité IA qui effectue l'attaque",
  T_48_META_API_3226_P1_D: "cible",
  T_48_META_API_3227_D: "Remplace l'arme du joueur par l'arme qui se trouve dans l'emplacement spécifié.",
  T_48_META_API_3227_P0_D: "acteur cible",
  T_48_META_API_3227_P1_D: "Emplacement d'arme à changer",
  T_48_META_API_3227_P2_D: "Que la commutation soit réussie ou non, elle échoue si aucune arme n'est équipée dans l'emplacement d'arme.",
  T_48_META_API_3228_D: "Obtenir des skins d'armes pour les joueurs ou PNJ ciblés",
  T_48_META_API_3228_P0_D: "Joueur ou PNJ cible",
  T_48_META_API_3228_P1_D: "ID de la peau de l'arme",
  T_48_META_API_3228_R_D: "ID de la peau de l'arme",
  T_48_META_API_3229_D: "Définir le skin de l'arme du joueur ou du PNJ cible",
  T_48_META_API_3229_P0_D: "Joueur ou PNJ cible",
  T_48_META_API_3229_P1_D: "ID de la peau de l'arme",
  T_48_META_API_3230_D: "Restaure le skin de l'arme par défaut du joueur cible, qui ne peut pas être appliqué aux PNJ.",
  T_48_META_API_3230_P0_D: "acteur cible",
  T_48_META_API_3230_P1_D: "ID de l'arme",
  T_48_META_API_3231_D: "Mise en place du costume du joueur",
  T_48_META_API_3231_P0_D: "acteur cible",
  T_48_META_API_3231_P1_D: "Liste des vêtements",
  T_48_META_API_3232_D: "Retirer tous les costumes du type spécifié au joueur ou au PNJ cible.",
  T_48_META_API_3232_P0_D: "Joueur ou PNJ cible",
  T_48_META_API_3232_P1_D: "Type de vêtements",
  T_48_META_API_3233_D: "Enlever la peau de l'arme désignée d'un joueur ou d'un PNJ",
  T_48_META_API_3233_P0_D: "Joueur ou PNJ cible",
  T_48_META_API_3233_P1_D: "ID de l'arme",
  T_48_META_API_3234_D: "Ajoute des buffs à la cible",
  T_48_META_API_3234_P0_D: "Entité cible, doit être une entité à laquelle des buffs peuvent être ajoutés",
  T_48_META_API_3234_P1_D: "Buff id",
  T_48_META_API_3235_D: "Supprimer les buffs de la cible",
  T_48_META_API_3235_P0_D: "Entité cible, doit être une entité à laquelle des buffs peuvent être ajoutés",
  T_48_META_API_3235_P1_D: "Buff id",
  T_48_META_API_3236_D: "Obtenir le buff actuel de la cible",
  T_48_META_API_3236_P0_D: "Entité cible, doit être une entité à laquelle des buffs peuvent être ajoutés",
  T_48_META_API_3236_R_D: "Liste des buffs",
  T_48_META_API_3237_D: "Acquérir des objets dans la barre d'accessoires du sac à dos du joueur cible.",
  T_48_META_API_3237_P0_D: "acteur cible",
  T_48_META_API_3237_P1_D: "Liste des accessoires",
  T_48_META_API_3238_D: "Ajouter des accessoires à l'emplacement spécifié de l'arme, les accessoires qui ne correspondent pas à l'emplacement seront rejetés ; les accessoires correspondants mais en double remplaceront les accessoires d'origine, les accessoires d'origine seront en",
  T_48_META_API_3238_P0_D: "acteur cible",
  T_48_META_API_3238_P1_D: "équipement bar slot",
  T_48_META_API_3238_P2_D: "remplacement (pièces)",
  T_48_META_API_3238_P3_D: "L'accessoire a été ajouté avec succès ou non. Vrai : l'accessoire a été équipé à l'arme dans le slot correspondant. Faux : l'accessoire n'a pas été ajouté et n'apparaîtra pas dans le sac à dos du joueur.",
  T_48_META_API_3238_P4_D: "Accessoires ajoutés, nullité en cas d'échec",
  T_48_META_API_3239_D: "Obtenir l'équipement dans la colonne d'équipement du sac à dos",
  T_48_META_API_3239_P0_D: "acteur cible",
  T_48_META_API_3239_P1_D: "équipement bar slot",
  T_48_META_API_3239_P2_D: "Équipement dans l'emplacement spécifié, vide s'il n'est pas équipé",
  T_48_META_API_3239_P3_D: "Tous les accessoires pour cet équipement",
  T_48_META_API_3240_D: "Un vecteur 2D prend la composante x",
  T_48_META_API_3240_P0_D: "vecteur bidimensionnel",
  T_48_META_API_3240_R_D: "Vecteur 2D composante x",
  T_48_META_API_3241_D: "Les vecteurs bidimensionnels prennent la composante y",
  T_48_META_API_3241_P0_D: "vecteur bidimensionnel",
  T_48_META_API_3241_R_D: "Composante Y d'un vecteur 2D",
  T_48_META_API_3242_D: "Vecteur 2D définissant la composante x",
  T_48_META_API_3242_P0_D: "vecteur bidimensionnel",
  T_48_META_API_3242_P1_D: "Vecteur 2D composante x",
  T_48_META_API_3243_D: "vecteur 2D définissant la composante y",
  T_48_META_API_3243_P0_D: "vecteur bidimensionnel",
  T_48_META_API_3243_P1_D: "Composante Y d'un vecteur 2D",
  T_48_META_API_3244_D: "Additionner deux vecteurs 2D",
  T_48_META_API_3244_P0_D: "Lvalue",
  T_48_META_API_3244_P1_D: "Rvalue",
  T_48_META_API_3244_R_D: "Résultat de la somme des vecteurs 2D",
  T_48_META_API_3245_D: "Soustraire deux vecteurs 2D",
  T_48_META_API_3245_P0_D: "Lvalue",
  T_48_META_API_3245_P1_D: "Rvalue",
  T_48_META_API_3245_R_D: "Résultat de la soustraction du vecteur 2D",
  T_48_META_API_3246_D: "Multiplier les vecteurs bidimensionnels par",
  T_48_META_API_3246_P0_D: "vecteur bidimensionnel",
  T_48_META_API_3246_P1_D: "Valeurs de mise à l'échelle des vecteurs 2D",
  T_48_META_API_3246_R_D: "Résultat de la multiplication d'un vecteur 2D",
  T_48_META_API_3247_D: "Multiplier par points deux vecteurs 2D, le résultat de la multiplication par points est un scalaire caractérisant l'angle entre les deux vecteurs.",
  T_48_META_API_3247_P0_D: "Lvalue",
  T_48_META_API_3247_P1_D: "Rvalue",
  T_48_META_API_3247_R_D: "Résultat du produit scalaire",
  T_48_META_API_3248_D: "Calculer la distance euclidienne entre deux vecteurs 2D",
  T_48_META_API_3248_P0_D: "Lvalue",
  T_48_META_API_3248_P1_D: "Rvalue",
  T_48_META_API_3248_R_D: "Après la soustraction de deux vecteurs, le module du vecteur résultant",
  T_48_META_API_3249_D: "Calculer l'angle entre deux vecteurs 2D",
  T_48_META_API_3249_P0_D: "Lvalue",
  T_48_META_API_3249_P1_D: "Rvalue",
  T_48_META_API_3249_R_D: "Angle du vecteur, plage d'angle 0-180",
  T_48_META_API_3250_D: "Normaliser le vecteur 2D",
  T_48_META_API_3250_P0_D: "vecteur bidimensionnel",
  T_48_META_API_3250_R_D: "Résultat normalisé pour les vecteurs d'une longueur de 1 m dans la même direction que le vecteur",
  T_48_META_API_3251_D: "Modélisation d'un vecteur 2D",
  T_48_META_API_3251_P0_D: "vecteur bidimensionnel",
  T_48_META_API_3251_R_D: "Le résultat de la modélisation, en tant que longueur de vecteur",
  T_48_META_API_3252_D: "Calculer le vecteur d'un vecteur 2D après réflexion par une ligne verticale normale",
  T_48_META_API_3252_P0_D: "vecteur 2D incident",
  T_48_META_API_3252_P1_D: "Vecteur 2D normal",
  T_48_META_API_3252_R_D: "Vecteur 2D réfléchissant",
  T_48_META_API_3253_D: "Calcul des vecteurs 3D après réflexion par un plan vertical normal",
  T_48_META_API_3253_P0_D: "vecteur 3D incident",
  T_48_META_API_3253_P1_D: "Vecteur 3D normal",
  T_48_META_API_3253_R_D: "vecteur 3D réfléchissant",
  T_48_META_API_3254_D: "Conversion d'un vecteur 3D en vecteur 2D, suppression de la composante Z du vecteur 3D",
  T_48_META_API_3254_P0_D: "Vecteur 3D cible",
  T_48_META_API_3254_R_D: "Vecteur 2D converti",
  T_48_META_API_3255_D: "vecteur 2D en vecteur 3D, la composante Z du vecteur 3D est fixée à 0",
  T_48_META_API_3255_P0_D: "Vecteur 2D cible",
  T_48_META_API_3255_R_D: "Vecteur 3D converti",
  T_48_META_API_3256_D: "Créer un vecteur 2D",
  T_48_META_API_3256_P0_D: "Composante x d'un vecteur 2D",
  T_48_META_API_3256_P1_D: "Composante Y d'un vecteur 2D",
  T_48_META_API_3256_R_D: "Le vecteur 2D créé",
  T_48_META_API_3257_D: "Journaux d'enterrement des concours personnalisés pour l'analyse des données relatives à l'expérience de l'utilisateur",
  T_48_META_API_3257_P0_D: "log",
  T_48_META_API_3258_D: "Journaux d'enterrement des concours personnalisés pour l'analyse des données relatives à l'expérience de l'utilisateur",
  T_48_META_API_3258_P0_D: "Pour suivre les joueurs signalés",
  T_48_META_API_3258_P1_D: "log",
  T_48_META_API_33_D: "Filtres pour les gros mots",
  T_48_META_API_33_P0_D: "Texte original nécessitant un filtrage des mots sales",
  T_48_META_API_33_R_D: "Texte filtré",
  T_48_META_API_3301_D: "Créer une entité de camp",
  T_48_META_API_3301_P0_D: "Entités de formation",
  T_48_META_API_3302_D: "L'entité cible rejoint le camp désigné",
  T_48_META_API_3302_P0_D: "entité cible",
  T_48_META_API_3302_P1_D: "Entités de formation",
  T_48_META_API_3303_D: "Obtenir des camps pour les camps attaquables",
  T_48_META_API_3303_P0_D: "attaque du camp",
  T_48_META_API_3303_R_D: "Liste des entités du camp",
  T_48_META_API_3304_D: "Camps attaquables pour l'établissement de camps",
  T_48_META_API_3304_P0_D: "attaque du camp",
  T_48_META_API_3304_P1_D: "camp cible",
  T_48_META_API_3304_P2_D: "Attaquabilité",
  T_48_META_API_3305_D: "Mise en place de joueurs attaquables",
  T_48_META_API_3305_P0_D: "joueur",
  T_48_META_API_3305_P1_D: "Joueurs attaquables",
  T_48_META_API_3305_P2_D: "Attaquabilité",
  T_48_META_API_3306_D: "Définition de l'équipe attaquable",
  T_48_META_API_3306_P0_D: "équipe de grève",
  T_48_META_API_3306_P1_D: "groupe cible",
  T_48_META_API_3306_P2_D: "Attaquabilité",
  T_48_META_API_3307_D: "abandonné",
  T_48_META_API_3307_P0_D: "abandonné",
  T_48_META_API_3307_R_D: "Liste des entités du joueur",
  T_48_META_API_3308_D: "Retrait de l'entité désignée du camp actuel",
  T_48_META_API_3308_P0_D: "entité cible",
  T_48_META_API_3309_D: "Camp d'acquisition de la cible",
  T_48_META_API_3309_P0_D: "entité cible",
  T_48_META_API_3309_R_D: "Entités de formation",
  T_48_META_API_3310_D: "Déterminer si la cible peut être attaquée",
  T_48_META_API_3310_P0_D: "agresseurs",
  T_48_META_API_3310_P1_D: "entité cible",
  T_48_META_API_3310_R_D: "Attaquabilité",
  T_48_META_API_3311_D: "Définition des cibles attaquables d'une entité",
  T_48_META_API_3311_P0_D: "agresseurs",
  T_48_META_API_3311_P1_D: "entité cible",
  T_48_META_API_3311_P2_D: "Attaquabilité",
  T_48_META_API_3312_D: "Acquisition des cibles attaquables d'une entité",
  T_48_META_API_3312_P0_D: "agresseurs",
  T_48_META_API_3312_R_D: "Liste des entités attaquables",
  T_48_META_API_34_D: "Déterminer si un composant existe pour l'entité cible",
  T_48_META_API_34_P0_D: "entité cible",
  T_48_META_API_34_P1_D: "Type de composant",
  T_48_META_API_34_R_D: "Existe-t-il",
  T_48_META_API_35_D: "Ajouter un bot",
  T_48_META_API_35_P0_D: "Niveau de difficulté du robot",
  T_48_META_API_35_P1_D: "L'équipe de Bot",
  T_48_META_API_35_P2_D: "Entité de joueur Bot créée",
  T_48_META_API_3500_D: "Obtenir les données relatives au jeton du joueur",
  T_48_META_API_3500_P0_D: "acteur cible",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "Nombre de jetons",
  T_48_META_API_3500_P3_D: "le succès ou l'échec",
  T_48_META_API_3501_D: "Ajout de données sur les jetons au lecteur",
  T_48_META_API_3501_P0_D: "acteur cible",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "Nombre de jetons",
  T_48_META_API_3501_P3_D: "Si le tuple a été invoqué avec succès ou non",
  T_48_META_API_3502_D: "Consommer le jeton de joueur cible",
  T_48_META_API_3502_P0_D: "acteur cible",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "Nombre de jetons",
  T_48_META_API_3502_P3_D: "Si le tuple a été invoqué avec succès ou non",
  T_48_META_API_3503_D: "Ajouter un jeton à l'emplacement spécifié",
  T_48_META_API_3503_P0_D: "placement",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "Nombre de jetons",
  T_48_META_API_3503_P3_D: "Si le tuple a été invoqué avec succès ou non",
  T_48_META_API_3504_D: "L'IA cible libère la compétence spécifiée",
  T_48_META_API_3504_P0_D: "Cibler l'IA",
  T_48_META_API_3504_P1_D: "technique",
  T_48_META_API_3504_P2_D: "objectif de compétence",
  T_48_META_API_3504_P3_D: "Si la compétence est libérée avec succès ou non",
  T_48_META_API_3505_D: "Crée des chemins d'accès du début à la fin qui contournent les blocs et peuvent être utilisés par l'IA pour trouver des chemins d'accès.",
  T_48_META_API_3505_P0_D: "coordonnées du point de départ",
  T_48_META_API_3505_P1_D: "coordonnées de la destination",
  T_48_META_API_3505_P2_D: "Si le chemin d'accès a été établi avec succès ou non",
  T_48_META_API_3505_P3_D: "Rassemblement au point de passage.",
  T_48_META_API_3506_D: 'Définition de la variable "arbre de comportement" du tableau noir',
  T_48_META_API_3506_P0_D: "Arbre de comportement cible",
  T_48_META_API_3506_P1_D: "nom de la variable",
  T_48_META_API_3506_P2_D: "valeur de la variable",
  T_48_META_API_3507_D: "Obtenir les variables du tableau de l'arbre comportemental",
  T_48_META_API_3507_P0_D: "Arbre de comportement cible",
  T_48_META_API_3507_P1_D: "nom de la variable",
  T_48_META_API_3507_P2_D: "valeur de la variable",
  T_48_META_API_3508_D: "Obtenir les paramètres des nœuds de l'arbre comportemental",
  T_48_META_API_3508_P0_D: "Nœuds de l'arbre de comportement cible",
  T_48_META_API_3508_P1_D: "nom du paramètre",
  T_48_META_API_3508_P2_D: "valeur du paramètre",
  T_48_META_API_3509_D: "Obtenir l'habillage du joueur cible",
  T_48_META_API_3509_P0_D: "acteur cible",
  T_48_META_API_3509_P1_D: "ID du transporteur",
  T_48_META_API_3509_R_D: "Peau de support",
  T_48_META_API_3510_D: "Définition de la peau du porteur du joueur cible",
  T_48_META_API_3510_P0_D: "acteur cible",
  T_48_META_API_3510_P1_D: "Identifiant de la peau du transporteur",
  T_48_META_API_3511_D: "Effacer la peau du véhicule spécifié du joueur cible",
  T_48_META_API_3511_P0_D: "acteur cible",
  T_48_META_API_3511_P1_D: "ID du transporteur",
  T_48_META_API_3512_D: "Rétablir l'habillage par défaut du joueur cible",
  T_48_META_API_3512_P0_D: "acteur cible",
  T_48_META_API_3512_P1_D: "ID du transporteur",
  T_48_META_API_36_D: "Cible dormante, ne peut être utilisée que pour les corps rigides de type dynamique.",
  T_48_META_API_36_P0_D: "corps rigide cible",
  T_48_META_API_37_D: "Cible de réveil, ne peut être utilisée que sur les corps rigides de type dynamique.",
  T_48_META_API_37_P0_D: "corps rigide cible",
  T_48_META_API_38_D: "Vérifier si le corps rigide cible est dormant",
  T_48_META_API_38_P0_D: "corps rigide cible",
  T_48_META_API_38_R_D: "L'hibernation ou non",
  T_48_META_API_39_D: "Réglage du seuil d'hibernation",
  T_48_META_API_39_P0_D: "corps rigide cible",
  T_48_META_API_39_P1_D: "Seuil de dormance, le mouvement et la rotation du corps rigide sont inférieurs à cette valeur pendant un certain temps pour entrer dans l'état de dormance, l'état de dormance du corps rigide ne permet plus d'effectuer des calculs physiques.",
  T_48_META_API_4_D: "Déterminer si tous les joueurs peuvent se déplacer",
  T_48_META_API_4_P0_D: "Vrai : peut être déplacé Faux : ne peut être déplacé",
  T_48_META_API_40_D: "Obtenir le seuil d'hibernation",
  T_48_META_API_40_P0_D: "corps rigide cible",
  T_48_META_API_40_R_D: "Seuil de dormance, le mouvement et la rotation du corps rigide sont inférieurs à cette valeur pendant un certain temps pour entrer dans l'état de dormance, l'état de dormance du corps rigide ne permet plus d'effectuer des calculs physiques.",
  T_48_META_API_4000_D: "Lit le contenu du tableau entier et renvoie un tableau à deux dimensions dans l'ordre des lignes.",
  T_48_META_API_4000_P0_D: "nom du tableau",
  T_48_META_API_4000_R_D: "Contenu du tableau",
  T_48_META_API_4001_D: "Lit une ligne d'un tableau et renvoie un tableau",
  T_48_META_API_4001_P0_D: "nom du tableau",
  T_48_META_API_4001_P1_D: "Nombre de lignes à lire, en comptant à partir de 1",
  T_48_META_API_4001_R_D: "Le tableau spécifie le contenu d'une ligne",
  T_48_META_API_4002_D: "Lit le contenu d'une colonne d'un tableau et renvoie un tableau",
  T_48_META_API_4002_P0_D: "nom du tableau",
  T_48_META_API_4002_P1_D: "Nombre de colonnes à lire, en comptant à partir de 1",
  T_48_META_API_4002_R_D: "Le tableau spécifie le contenu d'une colonne",
  T_48_META_API_4003_D: "Lire le contenu d'une cellule dans un tableau",
  T_48_META_API_4003_P0_D: "nom du tableau",
  T_48_META_API_4003_P1_D: "Nombre de lignes à lire, en comptant à partir de 1",
  T_48_META_API_4003_P2_D: "Nombre de colonnes à lire, en comptant à partir de 1",
  T_48_META_API_4003_R_D: "Le contenu de la cellule spécifiée du tableau",
  T_48_META_API_4004_D: "Lire le contenu d'une cellule dans un tableau par nom de ligne et de colonne",
  T_48_META_API_4004_P0_D: "nom du tableau",
  T_48_META_API_4004_P1_D: "Nombre de lignes à lire, en comptant à partir de 1",
  T_48_META_API_4004_P2_D: "Le nom de la colonne à lire",
  T_48_META_API_4004_R_D: "Le contenu de la cellule spécifiée du tableau",
  T_48_META_API_4005_D: "Lit le contenu du tableau entier et renvoie un tableau à deux dimensions.",
  T_48_META_API_4005_P0_D: "nom du tableau",
  T_48_META_API_4005_R_D: "Le contenu du tableau, un tableau à deux dimensions",
  T_48_META_API_4006_D: "Lire une ligne d'un tableau et renvoyer un tableau.",
  T_48_META_API_4006_P0_D: "nom du tableau",
  T_48_META_API_4006_P1_D: "Nombre de lignes à lire, en comptant à partir de 1",
  T_48_META_API_4006_R_D: "Table spécifie le contenu d'une ligne, d'un tableau",
  T_48_META_API_4007_D: "Lire le contenu d'une colonne du tableau entier, retourner un tableau",
  T_48_META_API_4007_P0_D: "nom du tableau",
  T_48_META_API_4007_P1_D: "Nombre de colonnes à lire, en comptant à partir de 1",
  T_48_META_API_4007_R_D: "Le tableau spécifie le contenu d'une colonne, d'un tableau",
  T_48_META_API_4008_D: "Lire le contenu d'une cellule dans un tableau",
  T_48_META_API_4008_P0_D: "nom du tableau",
  T_48_META_API_4008_P1_D: "Nombre de lignes à lire, en comptant à partir de 1",
  T_48_META_API_4008_P2_D: "Nombre de colonnes à lire, en comptant à partir de 1",
  T_48_META_API_4008_R_D: "Le contenu de la cellule spécifiée du tableau",
  T_48_META_API_4009_D: "Recherche la ligne spécifiée en fonction du nombre de colonnes et de la valeur de la cellule.",
  T_48_META_API_4009_P0_D: "nom du tableau",
  T_48_META_API_4009_P1_D: "Nombre de colonnes à lire",
  T_48_META_API_4009_P2_D: "Valeur de la cellule à rechercher",
  T_48_META_API_4009_R_D: "Contenu des lignes trouvées, tableau",
  T_48_META_API_4010_D: "Obtenir le numéro de la colonne par son nom",
  T_48_META_API_4010_P0_D: "nom du tableau",
  T_48_META_API_4010_P1_D: "Nom de la colonne pour la recherche du numéro de série",
  T_48_META_API_4010_R_D: "Colonnes, en comptant à partir de 1",
  T_48_META_API_41_D: "Définit le seuil de sommeil global, valable uniquement pour les corps rigides de type dynamique nouvellement générés.",
  T_48_META_API_41_P0_D: "Seuil de dormance, le mouvement et la rotation du corps rigide sont inférieurs à cette valeur pendant un certain temps pour entrer dans l'état de dormance, l'état de dormance du corps rigide ne permet plus d'effectuer des calculs physiques.",
  T_48_META_API_42_D: "Obtenir le seuil global d'hibernation",
  T_48_META_API_42_R_D: "Seuil de dormance, la valeur par défaut est de 0,005, le mouvement et la rotation du corps rigide sont inférieurs à cette valeur pendant un certain temps pour entrer dans l'état de dormance, le corps rigide dormant n'effectuera plus de calculs physiques.",
  T_48_META_API_43_D: "Convertit le quaternion donné en angle d'Euler, l'ordre de rotation de l'angle d'Euler est YXZ, si le quaternion entrant n'est pas légal, retourne (0,0,0).",
  T_48_META_API_43_P0_D: "Le quaternion d'entrée",
  T_48_META_API_43_R_D: "Angles d'Euler renvoyés",
  T_48_META_API_44_D: "Conversion d'un angle d'Euler donné en quaternion",
  T_48_META_API_44_P0_D: "Entrée des angles d'Euler",
  T_48_META_API_44_R_D: "Quaternion retourné",
  T_48_META_API_45_D: "Conversion des rotations des représentations des angles axiaux en quaternions",
  T_48_META_API_45_P0_D: "axe de rotation",
  T_48_META_API_45_P1_D: "Angle de rotation dans le sens des aiguilles d'une montre autour de l'axe de rotation",
  T_48_META_API_45_R_D: "Quaternion retourné",
  T_48_META_API_46_D: "Conversion des quaternions en représentations d'angles axiaux",
  T_48_META_API_46_P0_D: "Le quaternion d'entrée",
  T_48_META_API_46_P1_D: "axe de rotation",
  T_48_META_API_46_P2_D: "Angle de rotation dans le sens des aiguilles d'une montre autour de l'axe de rotation",
  T_48_META_API_47_D: "Mise en place d'une progression personnalisée de l'achèvement des tâches",
  T_48_META_API_47_P0_D: "acteur cible",
  T_48_META_API_47_P1_D: "ID de la tâche",
  T_48_META_API_47_P2_D: "Progression vers l'achèvement, aucun chiffre négatif n'est autorisé",
  T_48_META_API_48_D: "Crée une courbe de Bézier qui peut être utilisée pour interpoler le mouvement.",
  T_48_META_API_48_P0_D: "point de contrôle de la courbe",
  T_48_META_API_48_R_D: "Courbe de Bessel",
  T_48_META_API_49_D: "Obtenir l'identifiant de la carte de scène",
  T_48_META_API_49_P0_D: "ID de la scène",
  T_48_META_API_49_R_D: "Carte d'identité",
  T_48_META_API_5_D: "Supprimer les objets placés dans la scène (obsolète, utiliser DeleteEntity)",
  T_48_META_API_5_P0_D: "Entités de l'objet à supprimer",
  T_48_META_API_50_D: "Crée un mouvement par rapport à lui-même à chaque image, l'entité cible modifiant ses propres attributs une fois par image, à chaque fois par rapport à ses valeurs d'attributs actuelles.",
  T_48_META_API_50_P0_D: "entité cible",
  T_48_META_API_50_P1_D: "Propriétés nécessitant des changements de mouvement",
  T_48_META_API_50_P2_D: "Montant du changement par mouvement",
  T_48_META_API_50_P3_D: "Configuration en combinaison avec d'autres modes de mouvement Vrai : peut être utilisé en combinaison avec un mouvement relatif Faux : peut être utilisé en combinaison avec un mouvement absolu",
  T_48_META_API_50_P4_D: "Création d'entités de mouvement par image par rapport à elles-mêmes",
  T_48_META_API_50_P5_D: "Si la lecture démarre automatiquement après la création",
  T_48_META_API_5000_D: "Lire la valeur correspondant à une clé dans une table de la base de données.",
  T_48_META_API_5000_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_5000_P1_D: "Marquage des joueurs, gestion de la concurrence",
  T_48_META_API_5000_P2_D: "Nom personnalisé utilisé pour identifier les données",
  T_48_META_API_5000_P3_D: "Renvoie le résultat de la lecture",
  T_48_META_API_5000_P4_D: "Code de champ de bataille correspondant à la base de données",
  T_48_META_API_5001_D: "Écrire la valeur correspondant à une clé dans une table de la base de données.",
  T_48_META_API_5001_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_5001_P1_D: "Marquage des joueurs, gestion de la concurrence",
  T_48_META_API_5001_P2_D: "Nom personnalisé utilisé pour identifier les données",
  T_48_META_API_5001_P3_D: "Valeur écrite",
  T_48_META_API_5001_P4_D: "Le code du champ de bataille correspondant à la base de données, qui peut être renseigné, représente le code du champ de bataille de la carte actuelle",
  T_48_META_API_5002_D: "Supprimer la valeur correspondant à une clé dans une table de la base de données.",
  T_48_META_API_5002_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_5002_P1_D: "Marquage des joueurs, gestion de la concurrence",
  T_48_META_API_5002_P2_D: "Nom personnalisé utilisé pour identifier les données",
  T_48_META_API_5002_P3_D: "Code de champ de bataille correspondant à la base de données",
  T_48_META_API_5003_D: "Récupérer la valeur d'une clé dans une table de la base de données.",
  T_48_META_API_5003_P0_D: "Nom de la table de classement dans la base de données",
  T_48_META_API_5003_P1_D: "Nom personnalisé utilisé pour identifier les données",
  T_48_META_API_5003_P2_D: "Renvoie le résultat de la lecture",
  T_48_META_API_5003_P3_D: "Code de champ de bataille correspondant à la base de données",
  T_48_META_API_5004_D: "Écrire la valeur correspondant à une clé dans une table graphique de la base de données.",
  T_48_META_API_5004_P0_D: "Nom de la table de classement dans la base de données",
  T_48_META_API_5004_P1_D: "Nom personnalisé utilisé pour identifier les données",
  T_48_META_API_5004_P2_D: "Valeur écrite",
  T_48_META_API_5004_P3_D: "Code de champ de bataille correspondant à la base de données",
  T_48_META_API_5005_D: "Supprimer la valeur correspondant à une clé dans une table graphique de la base de données.",
  T_48_META_API_5005_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_5005_P1_D: "Nom personnalisé utilisé pour identifier les données",
  T_48_META_API_5005_P2_D: "Code de champ de bataille correspondant à la base de données",
  T_48_META_API_5006_D: "Supprimer la valeur correspondant à un rang dans un tableau de classement de la base de données.",
  T_48_META_API_5006_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_5006_P1_D: "Classement dans le Leaderboard",
  T_48_META_API_5006_P2_D: "Code de champ de bataille correspondant à la base de données",
  T_48_META_API_5007_D: "Lire les valeurs d'un certain rang à un certain rang dans une table graphique de la base de données.",
  T_48_META_API_5007_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_5007_P1_D: "position de départ",
  T_48_META_API_5007_P2_D: "position d'arrivée",
  T_48_META_API_5007_P3_D: "Renvoie le résultat de la lecture",
  T_48_META_API_5007_P4_D: "Code de champ de bataille correspondant à la base de données",
  T_48_META_API_5008_D: "Lire la valeur correspondant à une clé dans une table de la base de données cumulative.",
  T_48_META_API_5008_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_5008_P1_D: "Nom personnalisé utilisé pour identifier les données",
  T_48_META_API_5008_P2_D: "Renvoie le résultat de la lecture",
  T_48_META_API_5008_P3_D: "Code de champ de bataille correspondant à la base de données",
  T_48_META_API_5009_D: "Écrire la valeur d'offset correspondant à une clé dans une table de la base de données cumulative",
  T_48_META_API_5009_P0_D: "Noms des tables dans la base de données",
  T_48_META_API_5009_P1_D: "Nom personnalisé utilisé pour identifier les données",
  T_48_META_API_5009_P2_D: "Les types des quatre opérations sont actuellement les suivants : le type Int prend en charge l'addition, la soustraction, la multiplication, la division et le reste ; le type Float prend en charge l'addition, la soustraction, la multiplication et la divis",
  T_48_META_API_5009_P3_D: "Valeur d'offset écrite",
  T_48_META_API_5009_P4_D: "Code de champ de bataille correspondant à la base de données",
  T_48_META_API_51_D: "Réinitialiser l'entité jouable, rétablit l'entité jouable dans sa forme initiale sans modifier l'état de la lecture.",
  T_48_META_API_51_P0_D: "Entité jouable cible",
  T_48_META_API_52_D: "Multiplier deux quaternions, A*B, signifie faire tourner A puis B. Un ordre de rotation différent conduira à un résultat différent.",
  T_48_META_API_52_P0_D: "quaternion à valeurs gauches",
  T_48_META_API_52_P1_D: "quaternion à valeurs droites",
  T_48_META_API_52_R_D: "Quaternion résultant",
  T_48_META_API_53_D: "Crée un quaternion rotatif orienté dans la direction spécifiée",
  T_48_META_API_53_P0_D: "indiquer la direction",
  T_48_META_API_53_P1_D: "vers le haut",
  T_48_META_API_53_R_D: "Le degré de rotation nécessaire pour s'aligner dans la direction spécifiée.",
  T_48_META_API_54_D: "Interpolation sphérique quaternaire de A à B",
  T_48_META_API_54_P0_D: "Valeur A",
  T_48_META_API_54_P1_D: "Valeur B",
  T_48_META_API_54_P2_D: "Progression de l'interpolation, plage de valeurs [0,1], la valeur 0 pour revenir au début de la valeur, la valeur 1 pour revenir à la valeur cible.",
  T_48_META_API_54_R_D: "Quaternion résultant",
  T_48_META_API_57_D: "Imprime les données de la cible sous forme d'avertissement sur la console",
  T_48_META_API_57_P0_D: "Que faut-il imprimer ?",
  T_48_META_API_58_D: "Imprime les données de la cible sur la console en tant que message d'erreur.",
  T_48_META_API_58_P0_D: "Que faut-il imprimer ?",
  T_48_META_API_59_D: "Obtenir la valeur sur la courbe",
  T_48_META_API_59_P0_D: "de manière détournée",
  T_48_META_API_59_P1_D: "Point d'échantillonnage, plage de valeurs [0,1]",
  T_48_META_API_59_R_D: "en fin de compte",
  T_48_META_API_6_D: "Crée des objets de scène aux coordonnées spécifiées",
  T_48_META_API_6_P0_D: "Entités d'objets de scène créés",
  T_48_META_API_6_P1_D: "Lieu de génération des objets",
  T_48_META_API_6_P2_D: "L'ID du type d'objet créé, qui doit être enregistré au préalable dans le registre des actifs pour être utilisé dans les scripts de code.",
  T_48_META_API_60_D: "Interpolation basée sur des courbes",
  T_48_META_API_60_P0_D: "type de valeur",
  T_48_META_API_60_P1_D: "valeur de départ",
  T_48_META_API_60_P2_D: "valeur cible",
  T_48_META_API_60_P3_D: "de manière détournée",
  T_48_META_API_60_P4_D: "Point d'échantillonnage, plage de valeurs [0,1]",
  T_48_META_API_60_R_D: "en fin de compte",
  T_48_META_API_6000_D: "Ajout de scripts aux entités cibles",
  T_48_META_API_6000_P0_D: "entité cible",
  T_48_META_API_6000_P1_D: "ID du script",
  T_48_META_API_6001_D: "Déchargement des scripts pour les entités cibles",
  T_48_META_API_6001_P0_D: "entité cible",
  T_48_META_API_6001_P1_D: "ID du script",
  T_48_META_API_6002_D: "Vérifie si le script spécifié existe pour l'entité cible",
  T_48_META_API_6002_P0_D: "entité cible",
  T_48_META_API_6002_P1_D: "ID du script",
  T_48_META_API_6002_R_D: "Existence du script spécifié",
  T_48_META_API_61_D: "Définition du nœud parent d'un contrôle d'interface utilisateur",
  T_48_META_API_61_P0_D: "Nœud parent, peut spécifier un contrôle d'interface utilisateur ou une interface utilisateur personnalisée",
  T_48_META_API_61_P1_D: "nœud enfant",
  T_48_META_API_62_D: "abandonné",
  T_48_META_API_62_P0_D: "abandonné",
  T_48_META_API_62_P1_D: "abandonné",
  T_48_META_API_62_P2_D: "abandonné",
  T_48_META_API_62_P3_D: "abandonné",
  T_48_META_API_62_P4_D: "abandonné",
  T_48_META_API_63_D: "Création d'un rayon allant de la caméra actuelle au point de contact de l'écran",
  T_48_META_API_63_P0_D: "contact écran",
  T_48_META_API_63_P1_D: "seuil",
  T_48_META_API_63_P2_D: "direction du rayon",
  T_48_META_API_64_D: "Télécharger des informations de facturation personnalisées",
  T_48_META_API_64_P0_D: "entité du joueur",
  T_48_META_API_64_P1_D: "résultats d'un concours",
  T_48_META_API_64_P2_D: "titre intégral (informatique)",
  T_48_META_API_64_P3_D: "valeur du point",
  T_48_META_API_65_D: "Joue l'effet sonore spécifié et définit les propriétés de l'entité si vous avez d'autres propriétés à définir.",
  T_48_META_API_65_P0_D: "Création d'entités sonores",
  T_48_META_API_65_P1_D: "Joueur cible, seul le joueur cible peut entendre les effets sonores.",
  T_48_META_API_65_P2_D: "Type d'effet sonore",
  T_48_META_API_65_P3_D: "Type de boucle",
  T_48_META_API_65_P4_D: "Jouer immédiatement ou non",
  T_48_META_API_66_D: "Crée l'effet visuel spécifié et définit ses attributs d'entité s'il y a d'autres attributs à définir.",
  T_48_META_API_66_P0_D: "Création d'entités d'effets spéciaux",
  T_48_META_API_66_P1_D: "Joueurs ciblés, visibles uniquement par les joueurs ciblés",
  T_48_META_API_66_P2_D: "Type d'effet spécial",
  T_48_META_API_66_P3_D: "Type de boucle",
  T_48_META_API_66_P4_D: "Jouer immédiatement ou non",
  T_48_META_API_67_D: "Crée l'effet sonore spécifié et définit les propriétés de l'entité s'il y a d'autres propriétés à définir.",
  T_48_META_API_67_P0_D: "Création d'entités sonores",
  T_48_META_API_67_P1_D: "Type d'effet sonore",
  T_48_META_API_67_P2_D: "Type de boucle",
  T_48_META_API_67_P3_D: "Jouer immédiatement ou non",
  T_48_META_API_68_D: "Coordonnées mondiales converties en coordonnées d'écran",
  T_48_META_API_68_P0_D: "coordonnées mondiales",
  T_48_META_API_68_P1_D: "S'il est cartographié ou non à l'intérieur de l'écran",
  T_48_META_API_68_P2_D: "position cartographique",
  T_48_META_API_69_D: "Conversion des coordonnées de l'écran en coordonnées mondiales",
  T_48_META_API_69_P0_D: "coordonnées de l'écran",
  T_48_META_API_69_P1_D: "Distance par rapport à l'écran",
  T_48_META_API_69_P2_D: "coordonnées mondiales",
  T_48_META_API_7_D: "Convertir la valeur cible en chaîne de caractères",
  T_48_META_API_7_P0_D: "La valeur cible de la chaîne à convertir",
  T_48_META_API_7_R_D: "chaîne de caractères",
  T_48_META_API_70_D: "La détection des rayons par le toucher de l'écran renvoie la première entité touchée.",
  T_48_META_API_70_P0_D: "Écran de démarrage Contacts",
  T_48_META_API_70_P1_D: "Distance de détection",
  T_48_META_API_70_P2_D: "Masque de calque, seuls les calques remplis participeront à l'analyse, laisser ce champ vide signifie que tous les calques participeront à l'analyse.",
  T_48_META_API_70_P3_D: "Si le déclencheur peut être détecté",
  T_48_META_API_70_P4_D: "entité touchée",
  T_48_META_API_70_P5_D: "coordonnées du point d'impact",
  T_48_META_API_70_P6_D: "Distance entre le point d'impact et le point de départ",
  T_48_META_API_70_P7_D: "touche la normale à la surface",
  T_48_META_API_71_D: "Détection des rayons par le toucher de l'écran, renvoie toutes les entités touchées",
  T_48_META_API_71_P0_D: "Écran de démarrage Contacts",
  T_48_META_API_71_P1_D: "Distance de détection",
  T_48_META_API_71_P2_D: "Masque de calque, seuls les calques remplis participeront à l'analyse, laisser ce champ vide signifie que tous les calques participeront à l'analyse.",
  T_48_META_API_71_P3_D: "Si le déclencheur peut être détecté",
  T_48_META_API_71_P4_D: "Liste des entités touchées",
  T_48_META_API_71_P5_D: "Liste des coordonnées des points d'impact",
  T_48_META_API_71_P6_D: "Liste des distances entre le point d'arrivée et le point de départ",
  T_48_META_API_71_P7_D: "Liste des normales de surface touchées",
  T_48_META_API_72_D: "Crée l'effet visuel spécifié et définit ses attributs d'entité s'il y a d'autres attributs à définir.",
  T_48_META_API_72_P0_D: "Création d'entités d'effets spéciaux",
  T_48_META_API_72_P1_D: "Type d'effet spécial",
  T_48_META_API_72_P2_D: "Type de boucle",
  T_48_META_API_72_P3_D: "Jouer immédiatement ou non",
  T_48_META_API_73_D: "Créer une interface utilisateur intégrée qui n'est pas synchronisée avec d'autres clients",
  T_48_META_API_73_P0_D: "Création d'entités d'interface utilisateur intégrées",
  T_48_META_API_73_P1_D: "Types d'interface utilisateur intégrés",
  T_48_META_API_74_D: "Créer une interface utilisateur personnalisée qui n'est pas synchronisée avec d'autres clients",
  T_48_META_API_74_P0_D: "Création d'entités d'interface utilisateur personnalisées",
  T_48_META_API_74_P1_D: "Index de l'interface utilisateur personnalisée",
  T_48_META_API_75_D: "Obtenir le joueur correspondant au client actuel",
  T_48_META_API_75_R_D: "entité du joueur",
  T_48_META_API_76_D: "Créer des monstres d'IA",
  T_48_META_API_76_P0_D: "Cibler l'IA",
  T_48_META_API_76_P1_D: "Créer un emplacement",
  T_48_META_API_76_P2_D: "Type d'IA",
  T_48_META_API_76_P3_D: "équipe affiliée",
  T_48_META_API_76_P4_D: "la revendication automatique ou non de l'ennemi",
  T_48_META_API_76_P5_D: "mode d'attaque",
  T_48_META_API_76_P6_D: "Itinéraire de voyage",
  T_48_META_API_77_D: "Fixe la première composante du vecteur",
  T_48_META_API_77_P0_D: "vecteurs",
  T_48_META_API_77_P1_D: "Valeur du premier composant",
  T_48_META_API_77_R_D: "Vecteur après modification de la première composante",
  T_48_META_API_78_D: "Fixe la deuxième composante du vecteur",
  T_48_META_API_78_P0_D: "vecteurs",
  T_48_META_API_78_P1_D: "Valeur du deuxième composant",
  T_48_META_API_78_R_D: "Vecteur après modification de la deuxième composante",
  T_48_META_API_79_D: "Fixe la troisième composante du vecteur",
  T_48_META_API_79_P0_D: "vecteurs",
  T_48_META_API_79_P1_D: "Valeur du troisième composant",
  T_48_META_API_79_R_D: "Vecteur après modification de la troisième composante",
  T_48_META_API_8_D: "Ouvrez la zone de sécurité qui se rétrécit jusqu'au point de coordonnées central.",
  T_48_META_API_8_P0_D: "Point central de la zone de sécurité",
  T_48_META_API_8_P1_D: "Rayon de la zone de sécurité",
  T_48_META_API_8_P2_D: "Temps d'attente en secondes, à l'issue duquel la zone de sécurité commencera à se rétrécir en direction du point central",
  T_48_META_API_8_P3_D: "Temps nécessaire pour que la zone de sécurité se rétrécisse jusqu'au point central, en secondes",
  T_48_META_API_8_P4_D: "Quantité de dégâts par seconde subis en dehors de la zone de sécurité",
  T_48_META_API_80_D: "Définit la première composante du vecteur 2D",
  T_48_META_API_80_P0_D: "vecteur bidimensionnel",
  T_48_META_API_80_P1_D: "Valeur du premier composant",
  T_48_META_API_80_R_D: "Le vecteur 2D après modification de la première composante",
  T_48_META_API_81_D: "Définir la deuxième composante du vecteur 2D",
  T_48_META_API_81_P0_D: "vecteur bidimensionnel",
  T_48_META_API_81_P1_D: "Valeur du deuxième composant",
  T_48_META_API_81_R_D: "Le vecteur 2D après modification de la deuxième composante",
  T_48_META_API_82_D: "Déplacer la manette du personnage à l'endroit spécifié, si elle agit sur le joueur, ce dernier doit activer la manette du joueur qui utilise l'effet physique pour qu'il prenne effet.",
  T_48_META_API_82_P0_D: "Rôle du contrôleur cible",
  T_48_META_API_82_P1_D: "lieu désigné",
  T_48_META_API_83_D: "Obtenir le nœud enfant spécifié de l'entité parentale cible par son nom",
  T_48_META_API_83_P0_D: "entité mère",
  T_48_META_API_83_P1_D: "Nom du sous-nœud",
  T_48_META_API_83_R_D: "entité enfant",
  T_48_META_API_84_D: "Accorder une attention particulière à l'AOI et toujours se synchroniser quelle que soit la distance",
  T_48_META_API_84_P0_D: "Cibles à privilégier",
  T_48_META_API_84_P1_D: "observateur",
  T_48_META_API_85_D: "Suppression de l'attention spéciale AOI et annulation de la synchronisation AOI hors vue",
  T_48_META_API_85_P0_D: "Cibles à privilégier",
  T_48_META_API_85_P1_D: "observateur",
  T_48_META_API_86_D: "Efface toutes les préoccupations spéciales de l'AOI pour la cible spécifiée.",
  T_48_META_API_86_P0_D: "Cibles à privilégier",
  T_48_META_API_87_D: "Déterminer s'il existe un site d'intérêt particulier",
  T_48_META_API_87_P0_D: "Cibles à privilégier",
  T_48_META_API_87_P1_D: "abandonné",
  T_48_META_API_87_R_D: "Existe-t-il",
  T_48_META_API_88_D: "Changement de l'observateur proxy du joueur",
  T_48_META_API_88_P0_D: "joueur",
  T_48_META_API_88_P1_D: "observateur mandataire",
  T_48_META_API_89_D: "Déplace le contrôleur du personnage une fois, et s'il agit sur le joueur, le joueur doit allumer le contrôleur du joueur qui utilise l'effet physique pour qu'il prenne effet.",
  T_48_META_API_89_P0_D: "L'objet cible, ou dans le cas d'un joueur, le joueur doit avoir un contrôleur de joueur qui utilise des effets physiques activés pour que l'effet prenne effet.",
  T_48_META_API_89_P1_D: "vecteur de déplacement",
  T_48_META_API_9_D: "Désactiver le mécanisme de la zone de sécurité, lorsque la zone de sécurité est réduite au minimum, les joueurs en dehors de la zone de sécurité continueront à subir des dégâts, une fois le mécanisme de la zone de sécurité désactivé, les joueurs se remett",
  T_48_META_API_90_D: "Définir si le joueur peut quitter librement le jeu",
  T_48_META_API_90_P0_D: "acteur cible",
  T_48_META_API_90_P1_D: "Liberté de retrait",
  T_48_META_API_9000_D: "Créer une interface utilisateur intégrée qui ne peut être vue que par les joueurs spécifiés",
  T_48_META_API_9000_P0_D: "Création d'entités d'interface utilisateur intégrées",
  T_48_META_API_9000_P1_D: "L'entité du joueur à laquelle appartient l'interface utilisateur, visible uniquement par ce joueur.",
  T_48_META_API_9000_P2_D: "Types d'interface utilisateur intégrés",
  T_48_META_API_9001_D: "Supprimer l'interface utilisateur du jeu intégré",
  T_48_META_API_9001_P0_D: "Entités de l'interface utilisateur intégrée à supprimer",
  T_48_META_API_9002_D: "Crée une icône avec le type d'icône spécifié et, s'il y a d'autres propriétés à définir, définit les propriétés de l'entité par le biais de l'entité (obsolète, utiliser CreateLevelObject).",
  T_48_META_API_9002_P0_D: "Dans le code figure le nom du paramètre formel utilisé pour représenter l'entité qui crée l'icône, et la valeur de la variable locale correspondante est l'entité qui crée l'icône.",
  T_48_META_API_9002_P1_D: "L'entité du joueur à laquelle elle appartient, visible uniquement par ce joueur.",
  T_48_META_API_9002_P2_D: "Chemin de la ressource, le chemin de la ressource correspondant à l'icône sélectionnée par le joueur",
  T_48_META_API_9003_D: "Supprimer l'icône spécifiée (obsolète, utiliser DeleteEntity)",
  T_48_META_API_9003_P0_D: "L'icône de l'entité à supprimer",
  T_48_META_API_9004_D: "Crée un texte avec le contenu spécifié et, s'il y a d'autres attributs à définir, définit ses attributs d'entité par l'intermédiaire de l'entité (obsolète, veuillez utiliser CreateLevelObject).",
  T_48_META_API_9004_P0_D: "Dans le code, le nom du paramètre formel utilisé pour représenter l'entité qui crée le texte, et la valeur de la variable locale correspondante est l'entité qui crée le texte.",
  T_48_META_API_9004_P1_D: "L'entité du joueur à laquelle elle appartient, visible uniquement par ce joueur.",
  T_48_META_API_9004_P2_D: "Contenu du texte à présenter",
  T_48_META_API_9005_D: "Supprimer le texte spécifié (obsolète, utiliser DeleteEntity)",
  T_48_META_API_9005_P0_D: "Entités de texte à supprimer",
  T_48_META_API_9006_D: "Crée une icône avec le type d'effet spécifié et, si d'autres propriétés doivent être définies, définit les propriétés de l'entité (obsolète, veuillez utiliser CreateEffect).",
  T_48_META_API_9006_P0_D: "Dans le code se trouve le nom du paramètre formel utilisé pour représenter l'entité qui crée l'effet, et la valeur de la variable locale correspondante est l'entité qui crée l'effet.",
  T_48_META_API_9006_P1_D: "L'entité du joueur à laquelle elle appartient, visible uniquement par ce joueur.",
  T_48_META_API_9006_P2_D: "Types d'effets spéciaux, les types d'effets que les joueurs peuvent choisir",
  T_48_META_API_9007_D: "Supprimer l'effet spécifié (obsolète, utiliser DeleteEntity)",
  T_48_META_API_9007_P0_D: "L'entité d'effets à supprimer",
  T_48_META_API_9008_D: "Créer une interface utilisateur personnalisée qui ne peut être vue que par les joueurs spécifiés",
  T_48_META_API_9008_P0_D: "Création d'entités d'interface utilisateur personnalisées",
  T_48_META_API_9008_P1_D: "L'entité du joueur à laquelle appartient l'interface utilisateur, visible uniquement par ce joueur.",
  T_48_META_API_9008_P2_D: "Index de l'interface utilisateur personnalisée",
  T_48_META_API_9009_D: "Supprimer l'interface utilisateur du jeu personnalisé",
  T_48_META_API_9009_P0_D: "Entités de l'interface utilisateur personnalisée à supprimer",
  T_48_META_API_9010_D: "Obtenir des contrôles d'interface utilisateur à partir d'une interface personnalisée",
  T_48_META_API_9010_P0_D: "Entité du lecteur à laquelle appartient l'interface utilisateur",
  T_48_META_API_9010_P1_D: "Entités personnalisées de l'interface utilisateur",
  T_48_META_API_9010_P2_D: "Contrôle Index unique",
  T_48_META_API_9010_R_D: "Entité de contrôle de l'interface utilisateur",
  T_48_META_API_9011_D: "Joue le son spécifié et, si d'autres propriétés doivent être définies, définit les propriétés de l'entité par le biais de l'entité (obsolète, veuillez utiliser CreateSound).",
  T_48_META_API_9011_P0_D: "Dans le code figure le nom du paramètre formel utilisé pour représenter l'entité qui crée l'effet sonore, et la valeur de la variable locale correspondante est l'entité qui crée l'effet sonore.",
  T_48_META_API_9011_P1_D: "L'entité du joueur à laquelle elle appartient, visible uniquement par ce joueur.",
  T_48_META_API_9011_P2_D: "Types de sons, les types d'effets sonores que le joueur peut choisir.",
  T_48_META_API_9012_D: "Supprimer l'effet sonore spécifié (obsolète, utiliser DeleteEntity)",
  T_48_META_API_9012_P0_D: "Entités sonores à supprimer",
  T_48_META_API_9013_D: "Obtenir un contrôle d'interface utilisateur à partir d'une interface personnalisée à l'aide d'un chemin d'accès",
  T_48_META_API_9013_P0_D: "Entité du lecteur à laquelle appartient l'interface utilisateur",
  T_48_META_API_9013_P1_D: "Interface utilisateur personnalisée",
  T_48_META_API_9013_P2_D: "Chemin de contrôle",
  T_48_META_API_9013_R_D: "Entité de contrôle de l'interface utilisateur",
  T_48_META_API_9014_D: "Entité sonore en cas d'interruption de la lecture (obsolète, utiliser PauseSound)",
  T_48_META_API_9014_P0_D: "Entités saines à suspendre",
  T_48_META_API_9015_D: "Reprendre la lecture du son, éventuellement depuis le début (obsolète, utiliser ResumeSound)",
  T_48_META_API_9015_P0_D: "Entités sonores qui doivent continuer à jouer après avoir été mises en pause",
  T_48_META_API_9015_P1_D: "Partir de zéro ou non",
  T_48_META_API_9016_D: "Création de contrôles d'interface utilisateur personnalisés",
  T_48_META_API_9016_P0_D: "Création d'entités de contrôle personnalisées",
  T_48_META_API_9016_P1_D: "Type de contrôle créé",
  T_48_META_API_9016_P2_D: "Entités affiliées à l'IU",
  T_48_META_API_9016_P3_D: "Contrôle parent, s'il n'est pas renseigné, l'entité UI sera le nœud parent.",
  T_48_META_API_9017_D: "Définition du masque de couche de la caméra cible",
  T_48_META_API_9017_P0_D: "entité de la caméra cible",
  T_48_META_API_9017_P1_D: "Masque de calque, seuls les calques remplis seront affichés dans la caméra cible, laisser ce champ vide signifie que tous les calques sont affichés.",
  T_48_META_API_9018_D: "Obtenir le masque de couche de la caméra cible",
  T_48_META_API_9018_P0_D: "entité de la caméra cible",
  T_48_META_API_9018_R_D: "Masque de calque, seuls les calques à l'intérieur du masque de calque sont affichés dans la caméra cible.",
  T_48_META_API_9019_D: "Détermine si le niveau spécifié est visible par la caméra cible",
  T_48_META_API_9019_P0_D: "entité de la caméra cible",
  T_48_META_API_9019_P1_D: "Hiérarchie de visibilité",
  T_48_META_API_9019_P2_D: "visibilité",
  T_48_META_API_9020_D: "Définition de l'état de l'interface par défaut du lecteur cible",
  T_48_META_API_9020_P0_D: "acteur cible",
  T_48_META_API_9020_P1_D: "Les types d'interface du lecteur, qui sont des éléments d'interface utilisateur utilisés pour manipuler le lecteur et le contenu lié au lecteur.",
  T_48_META_API_9020_P2_D: "Valeur du commutateur, détermine la visibilité de l'interface du joueur",
  T_48_META_API_9021_D: "Créer une chaîne de localisation de l'horodatage",
  T_48_META_API_9021_P0_D: "horodatage",
  T_48_META_API_9021_P1_D: "Styles de formatage",
  T_48_META_API_9021_R_D: "Horodatage Chaîne de localisation",
  T_48_META_API_9022_D: "Création d'une icône de mini-carte",
  T_48_META_API_9022_P0_D: "Création des entités de l'icône de la carte heuristique",
  T_48_META_API_9022_P1_D: "Le joueur auquel vous appartenez crée une icône de mini-carte qui n'est visible que par lui.",
  T_48_META_API_9022_P2_D: "Mindmap Icon Resource Path",
  T_48_META_API_9023_D: "Crée une icône avec le type d'effet spécifié et définit les propriétés de l'entité par le biais de l'entité s'il y a d'autres propriétés à définir.",
  T_48_META_API_9023_P0_D: "Dans le code se trouve le nom du paramètre formel utilisé pour représenter l'entité qui crée l'effet, et la valeur de la variable locale correspondante est l'entité qui crée l'effet.",
  T_48_META_API_9023_P1_D: "L'entité du joueur à laquelle elle appartient, visible uniquement par ce joueur.",
  T_48_META_API_9023_P2_D: "Types d'effets spéciaux, les types d'effets que les joueurs peuvent choisir",
  T_48_META_API_9024_D: "Supprimer l'effet spécifié (obsolète, utiliser DeleteEntity)",
  T_48_META_API_9024_P0_D: "L'entité d'effets à supprimer",
  T_48_META_API_9025_D: "Génère des pixels statiques sur la carte pour l'objet cible, qui ne se déplacent pas avec l'objet cible.",
  T_48_META_API_9025_P0_D: "Création d'entités de pixels statiques",
  T_48_META_API_9025_P1_D: "Le joueur auquel il appartient, créant ainsi des pixels statiques qui ne sont visibles que par ce joueur.",
  T_48_META_API_9025_P2_D: "entité de l'objet cible",
  T_48_META_API_9026_D: "Obtenir l'entité mini-map du joueur cible",
  T_48_META_API_9026_P0_D: "acteur cible",
  T_48_META_API_9026_R_D: "Mini-carte du joueur actuel",
  T_48_META_API_9027_D: "Définir les dégâts de la chute du joueur, peut définir différents dégâts en fonction des segments de hauteur.",
  T_48_META_API_9027_P0_D: "acteur cible",
  T_48_META_API_9027_P1_D: "Liste segmentée en hauteur",
  T_48_META_API_9027_P2_D: "Liste des segments de dommages",
  T_48_META_API_91_D: "L'ajout d'une cible à une équipe spécifique entraînera le départ de la cible de l'équipe dont elle était précédemment membre.",
  T_48_META_API_91_P0_D: "Cibles à ajouter à l'équipe",
  T_48_META_API_91_P1_D: "Rejoindre l'équipe",
  T_48_META_API_91_P2_D: "le succès ou l'échec",
  T_48_META_API_92_D: "L'ajout d'une cible à une équipe nouvellement créée entraînera le retrait de la cible de l'équipe à laquelle elle appartenait auparavant.",
  T_48_META_API_92_P0_D: "Cibles à ajouter à l'équipe",
  T_48_META_API_92_P1_D: "Nom de la nouvelle équipe",
  T_48_META_API_92_P2_D: "le succès ou l'échec",
  T_48_META_API_94_D: "Définir la valeur d'une variable locale par index ; avant la définition, la variable doit être définie dans le processus d'appel en cours",
  T_48_META_API_94_P0: "Indice",
  T_48_META_API_94_P0_D: "Obtenir une variable par index",
  T_48_META_API_94_P1: "Valeur variable",
  T_48_META_API_94_P1_D: "Valeur de la variable cible",
  T_48_META_API_94_P2: "Type arithmétique",
  T_48_META_API_94_P2_D: "Méthode d'opération ; tous les types prennent en charge l'affectation et les types numériques prennent également en charge les opérations d'incrémentation, de décrémentation, de multiplication, de division et de module",
  T_48_META_API_94_P3: "Nom de la variable",
  T_48_META_API_94_P3_D: "Nom de la variable cible. Utilisé uniquement pour la sortie d'erreur",
  T_48_META_API_95: "Obtenir une variable locale par index",
  T_48_META_API_95_D: "Obtenir la valeur d'une variable locale ; avant de l'obtenir, la variable doit être définie dans le processus d'appel en cours",
  T_48_META_API_95_P0: "Indice",
  T_48_META_API_95_P0_D: "Indice variable",
  T_48_META_API_95_P1: "Nom de la variable",
  T_48_META_API_95_P1_D: "Nom de la variable cible. Utilisé uniquement pour la sortie d'erreur",
  T_48_META_API_9500_D: "Effets de lecture côté client qui notifient le lecteur cible",
  T_48_META_API_9500_P0_D: "acteur cible",
  T_48_META_API_9500_P1_D: "Parcours de ressources pour les effets spéciaux",
  T_48_META_API_9500_P2_D: "couleur",
  T_48_META_API_9500_P3_D: "Taille du zoom, par défaut 1",
  T_48_META_API_9500_P4_D: "Objet lié auquel les effets sont ajoutés en tant que nœuds enfants",
  T_48_META_API_9500_P5_D: "Décalage en coordonnées mondiales par rapport à l'objet lié",
  T_48_META_API_9501_D: "Notifier au client du joueur cible de jouer un effet sonore",
  T_48_META_API_9501_P0_D: "acteur cible",
  T_48_META_API_9501_P1_D: "Type d'effet sonore",
  T_48_META_API_9502_D: "Informer le client du joueur cible qu'il doit afficher les caractères flottants",
  T_48_META_API_9502_P0_D: "acteur cible",
  T_48_META_API_9502_P1_D: 'Le contenu du mot "float',
  T_48_META_API_9502_P2_D: "Couleur des caractères flottants, Couleur du type",
  T_48_META_API_9502_P3_D: "Durée du mot flottant en millisecondes",
  T_48_META_API_9503_D: "Faire jouer à l'unité cible une expression d'action Emote une fois",
  T_48_META_API_9503_P0_D: "Objectifs de Play Emote",
  T_48_META_API_9503_P1_D: "Type d'émote",
  T_48_META_API_9504_D: "Pause/reprise de l'expression du mouvement de l'émoticône de l'unité",
  T_48_META_API_9504_P0_D: "Suspendre/reprendre les objectifs d'Emote",
  T_48_META_API_9504_P1_D: "Vrai : Pause de la lecture, Faux : Reprise de la lecture",
  T_48_META_EVT_1_D: "Déclenché au début du jeu, le serveur sera prêt quelque temps avant le client.",
  T_48_META_EVT_10_D: "Se déclenche avant que l'entité actuelle ne subisse des dommages",
  T_48_META_EVT_10_P0_D: "Entité de l'attaquant, éventuellement nulle",
  T_48_META_EVT_10_P1_D: "Type de dommage",
  T_48_META_EVT_10_P2_D: "Montant des dommages causés",
  T_48_META_EVT_10_P3_D: "partie blessée",
  T_48_META_EVT_1000_D: "Déclenché lorsque les points des joueurs changent",
  T_48_META_EVT_1000_P0_D: "Joueurs ayant changé de points",
  T_48_META_EVT_1000_P1_D: "Types de points de changement",
  T_48_META_EVT_1000_P2_D: "Valeur intégrale après modification de l'intégrale",
  T_48_META_EVT_1001_D: "Déclenché lorsque les points de l'équipe changent",
  T_48_META_EVT_1001_P0_D: "Équipes ayant changé de points",
  T_48_META_EVT_1001_P1_D: "Types de points de changement",
  T_48_META_EVT_1001_P2_D: "Valeur intégrale après modification de l'intégrale",
  T_48_META_EVT_1002_D: "Déclenché lorsque le classement du joueur change",
  T_48_META_EVT_1002_P0_D: "Joueurs dont le classement a changé",
  T_48_META_EVT_1002_P1_D: "Classement après changement de classement",
  T_48_META_EVT_1003_D: "abandonné",
  T_48_META_EVT_1003_P0_D: "abandonné",
  T_48_META_EVT_1003_P1_D: "Classement après changement de classement",
  T_48_META_EVT_11_D: "Déclenché lorsqu'un joueur quitte à mi-parcours",
  T_48_META_EVT_11_P0_D: "Le joueur qui a quitté à mi-parcours",
  T_48_META_EVT_12_D: "Déclenché lorsque le contrôleur du joueur touche une entité, et uniquement lorsque le contrôleur subit un mouvement actif.",
  T_48_META_EVT_12_P0_D: "Entités rencontrées",
  T_48_META_EVT_13_D: "Se déclenche avant que l'entité actuelle n'inflige des dégâts",
  T_48_META_EVT_13_P0_D: "Entités ayant subi un préjudice",
  T_48_META_EVT_13_P1_D: "Type de dommage",
  T_48_META_EVT_13_P2_D: "Montant des dommages causés",
  T_48_META_EVT_13_P3_D: "partie blessée",
  T_48_META_EVT_14_D: "Déclenché à chaque cycle d'une entité jouable, cet événement ne fonctionne côté client que si l'entité jouable est une entité de son, d'effet, etc.",
  T_48_META_EVT_2_D: "Déclenché lorsque la trame logique est mise à jour. La fréquence de cet événement peut varier en fonction de la plate-forme et des paramètres.",
  T_48_META_EVT_2002_D: "Déclenché à la mort du joueur",
  T_48_META_EVT_2002_P0_D: "Joueurs morts",
  T_48_META_EVT_2003_D: "Déclenché sur les passes décisives du joueur",
  T_48_META_EVT_2003_P0_D: "Joueurs ayant délivré des passes décisives",
  T_48_META_EVT_2003_P1_D: "Joueurs tués",
  T_48_META_EVT_2004_D: "Se déclenche lorsque le joueur inflige des dégâts",
  T_48_META_EVT_2004_P0_D: "Le joueur qui a causé le dommage",
  T_48_META_EVT_2004_P1_D: "lecteur endommagé",
  T_48_META_EVT_2004_P2_D: "Type de dommage",
  T_48_META_EVT_2004_P3_D: "quantité de dommages",
  T_48_META_EVT_2004_P4_D: "partie blessée",
  T_48_META_EVT_2005_D: "Déclenché lorsqu'un joueur inflige un kill",
  T_48_META_EVT_2005_P0_D: "joueur ayant réalisé un kill",
  T_48_META_EVT_2005_P1_D: "Joueurs tués",
  T_48_META_EVT_2005_P2_D: "Type de dommage",
  T_48_META_EVT_2006_D: "Déclenché lorsqu'un joueur rejoint le jeu",
  T_48_META_EVT_2006_P0_D: "Joueurs rejoignant le jeu",
  T_48_META_EVT_2007_D: "Déclenché lorsque le joueur est réanimé",
  T_48_META_EVT_2007_P0_D: "Joueurs ressuscités",
  T_48_META_EVT_2007_P1_D: "Sources de la résurrection",
  T_48_META_EVT_2008_D: "Déclenché lorsqu'un joueur est mis à terre",
  T_48_META_EVT_2008_P0_D: "Joueur assommé",
  T_48_META_EVT_2008_P1_D: "agresseur",
  T_48_META_EVT_2009_D: "Déclenché lorsque le joueur se déconnecte",
  T_48_META_EVT_2009_P0_D: "Joueurs déconnectés",
  T_48_META_EVT_2010_D: "Déclenché lorsque le joueur se reconnecte",
  T_48_META_EVT_2010_P0_D: "Joueurs reconnectés",
  T_48_META_EVT_2100_D: "Déclenché lorsque l'équipe est supprimée",
  T_48_META_EVT_2100_P0_D: "Équipes supprimées",
  T_48_META_EVT_2101_D: "Déclenché lors de l'ajout d'une équipe",
  T_48_META_EVT_2101_P0_D: "Équipes ajoutées",
  T_48_META_EVT_2102_D: "Déclenché lorsque l'équipe est détruite par le groupe",
  T_48_META_EVT_2102_P0_D: "L'équipe détruite par le régiment",
  T_48_META_EVT_3_D: "Déclenché à la fin du jeu et avant la fin du jeu sur le serveur",
  T_48_META_EVT_30_D: "Déclenché lorsque la scène est chargée avec succès",
  T_48_META_EVT_30_P0_D: "nom de la scène",
  T_48_META_EVT_3000_D: "Déclenché après la création de l'entité actuelle",
  T_48_META_EVT_3001_D: "Déclenché avant la destruction de l'entité actuelle",
  T_48_META_EVT_3002_D: "Déclenché lorsque le joueur entre dans le déclencheur",
  T_48_META_EVT_3002_P0_D: "Joueurs entrant dans le déclencheur",
  T_48_META_EVT_3003_D: "Se déclenche lorsque le joueur quitte le déclencheur",
  T_48_META_EVT_3003_P0_D: "Joueurs quittant la gâchette",
  T_48_META_EVT_3004_D: "Déclenché après avoir cliqué sur le contrôle de bouton de l'interface utilisateur",
  T_48_META_EVT_3004_P0_D: "Cliquer sur les joueurs",
  T_48_META_EVT_3005_D: "Déclenché en cliquant sur un bouton dans l'interface utilisateur intégrée",
  T_48_META_EVT_3005_P0_D: "Nom du contrôle de bouton à cliquer",
  T_48_META_EVT_3006_D: "Déclenché lorsque le joueur utilise des skis nautiques",
  T_48_META_EVT_3007_D: "Déclenché après que l'entité actuelle est disponible",
  T_48_META_EVT_3008_D: "Déclenché après l'indisponibilité de l'entité actuelle",
  T_48_META_EVT_3009_D: "Déclenché lorsqu'une entité entre dans un déclencheur. Lorsqu'un événement déclencheur est déclenché, les deux parties reçoivent l'événement. Une partie doit être un corps rigide et l'autre partie doit être un déclencheur. En particulier, lorsque le déclencheur est un objet déclencheur personnalisé, seul le déclencheur recevra l'événement.",
  T_48_META_EVT_3009_P0_D: "Entité opposante au moment de l'événement déclencheur",
  T_48_META_EVT_3010_D: "Déclenché lorsque l'entité quitte le déclencheur. Lorsque l'événement est déclenché, les deux parties reçoivent l'événement. Une partie doit être un corps rigide et l'autre partie doit être un déclencheur. En particulier, lorsque le déclencheur est un objet déclencheur personnalisé, seul le déclencheur recevra l'événement.",
  T_48_META_EVT_3010_P0_D: "Entité opposante au moment de l'événement déclencheur",
  T_48_META_EVT_3011_D: "Déclenché lorsque l'entité actuelle est détruite",
  T_48_META_EVT_3011_P0_D: "Entité de l'attaquant, éventuellement nulle",
  T_48_META_EVT_3011_P1_D: "Type de dommage",
  T_48_META_EVT_3011_P2_D: "partie blessée",
  T_48_META_EVT_3012_D: "Déclenché après l'attaque de l'entité actuelle",
  T_48_META_EVT_3012_P0_D: "Entité de l'attaquant, éventuellement nulle",
  T_48_META_EVT_3012_P1_D: "Type de dommage",
  T_48_META_EVT_3012_P2_D: "Montant des dommages causés",
  T_48_META_EVT_3012_P3_D: "partie blessée",
  T_48_META_EVT_3013_D: "Se déclenche après que l'entité actuelle ait subi des dégâts",
  T_48_META_EVT_3013_P0_D: "Entités ayant subi un préjudice",
  T_48_META_EVT_3013_P1_D: "Type de dommage",
  T_48_META_EVT_3013_P2_D: "Montant des dommages causés",
  T_48_META_EVT_3013_P3_D: "partie blessée",
  T_48_META_EVT_3014_D: "Déclenché après la destruction d'une autre entité par l'entité actuelle",
  T_48_META_EVT_3014_P0_D: "Entités éliminées",
  T_48_META_EVT_3014_P1_D: "partie blessée",
  T_48_META_EVT_3015_D: "Déclenché lorsque ce joueur est ressuscité",
  T_48_META_EVT_3015_P0_D: "Type de joueur source de résurrection",
  T_48_META_EVT_3016_D: "Déclenché lorsque le générateur génère une entité",
  T_48_META_EVT_3016_P0_D: "Liste des entités générées",
  T_48_META_EVT_3016_P1_D: "nombre d'ondes",
  T_48_META_EVT_3017_D: "Appelé lorsque le joueur entre en position d'agenouillement pour le knock-out.",
  T_48_META_EVT_3018_D: "Déclenché lorsque tous les membres de l'équipe sont morts",
  T_48_META_EVT_3019_D: "Déclenché lorsqu'il est équipé d'un casque, d'un gilet pare-balles ou d'un sac à dos.",
  T_48_META_EVT_3019_P0_D: "ID de l'équipement",
  T_48_META_EVT_3020_D: "Déclenché en tenant une arme principale, secondaire ou de mêlée, y compris en passant au poing.",
  T_48_META_EVT_3020_P0_D: "Entité d'arme équipée au moment du déclenchement",
  T_48_META_EVT_3021_D: "Déclenché après l'utilisation d'un accessoire, les accessoires dont l'utilisation prend du temps déclencheront cet événement une fois l'utilisation terminée.",
  T_48_META_EVT_3021_P0_D: "ID des accessoires",
  T_48_META_EVT_3021_P1_D: "Entité Props, éventuellement nulle",
  T_48_META_EVT_3021_P2_D: "Nouvelle entité prop créée à l'aide d'accessoires, peut être vide",
  T_48_META_EVT_3022_D: "Déclenché lors de l'acquisition d'un objet",
  T_48_META_EVT_3022_P0_D: "Type d'objet",
  T_48_META_EVT_3022_P1_D: "Entité objet, éventuellement nulle",
  T_48_META_EVT_3023_D: "Déclenché lorsque les points de l'entité changent",
  T_48_META_EVT_3023_P0_D: "Types de points de changement",
  T_48_META_EVT_3023_P1_D: "Valeur intégrale après modification de l'intégrale",
  T_48_META_EVT_3024_D: "Déclenché lorsque le classement de l'entité change",
  T_48_META_EVT_3024_P0_D: "Classement après changement de classement",
  T_48_META_EVT_3025_D: "Déclenché lors d'une assistance",
  T_48_META_EVT_3025_P0_D: "frapper",
  T_48_META_EVT_3026_D: "Déclenché lorsqu'une entité entre dans un véhicule, y compris en tant que conducteur et passager.",
  T_48_META_EVT_3026_P0_D: "Entités entrant dans le transporteur",
  T_48_META_EVT_3026_P1_D: "Transporteurs inscrits",
  T_48_META_EVT_3027_D: "Déclenché lorsque l'entité quitte le transporteur",
  T_48_META_EVT_3027_P0_D: "Entités quittant le transporteur",
  T_48_META_EVT_3027_P1_D: "Transporteurs en partance",
  T_48_META_EVT_3028_D: "Déclenché lors de la conduite physique d'un transporteur, lors de la présence d'un conducteur dans une voiture",
  T_48_META_EVT_3028_P0_D: "Entité conduisant le transporteur",
  T_48_META_EVT_3028_P1_D: "Véhicules conduits",
  T_48_META_EVT_3029_D: "Déclenché lors de l'entrée physique dans le transporteur",
  T_48_META_EVT_3029_P0_D: "entité de déclenchement",
  T_48_META_EVT_3030_D: "Déclenché au départ du transporteur",
  T_48_META_EVT_3030_P0_D: "entité de déclenchement",
  T_48_META_EVT_3031_D: "Déclenché lorsque le véhicule est conduit par une entité",
  T_48_META_EVT_3031_P0_D: "entité de déclenchement",
  T_48_META_EVT_3032_D: "Déclenché après une téléportation lorsqu'une entité utilise un portail (obsolète, utiliser OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "Entités utilisant le portail",
  T_48_META_EVT_3032_P1_D: "Portail utilisé",
  T_48_META_EVT_3033_D: "Déclenché lorsque l'entité rebondit",
  T_48_META_EVT_3033_P0_D: "entité de déclenchement",
  T_48_META_EVT_3033_P1_D: "Objets rebondissants utilisés",
  T_48_META_EVT_3034_D: "Déclenché après que le portail ait permis à l'entité de se téléporter.",
  T_48_META_EVT_3034_P0_D: "entité émettrice",
  T_48_META_EVT_3035_D: "Déclenché après que le pneu a rebondi sur l'entité",
  T_48_META_EVT_3035_P0_D: "entité pop-up",
  T_48_META_EVT_3036_D: "Déclenché lorsqu'une machine envoie une entité voler",
  T_48_META_EVT_3036_P0_D: "l'entité qui est emportée",
  T_48_META_EVT_3036_P1_D: "objet généré par une machine",
  T_48_META_EVT_3037_D: "Se déclenche lorsque l'entité entre dans le déclencheur",
  T_48_META_EVT_3037_P0_D: "Déclenchement de l'entrée",
  T_48_META_EVT_3038_D: "Se déclenche lorsque l'entité quitte le déclencheur",
  T_48_META_EVT_3038_P0_D: "Déclenchement du départ",
  T_48_META_EVT_3039_D: "Déclenché lors de l'acquisition d'une entité d'armement",
  T_48_META_EVT_3039_P0_D: "Entité chargée de l'armement",
  T_48_META_EVT_3040_D: "Déclenché lorsqu'une entité est renversée par une machine",
  T_48_META_EVT_3040_P0_D: "l'entité qui est emportée",
  T_48_META_EVT_3040_P1_D: "objet généré par une machine",
  T_48_META_EVT_3041_D: "Déclenché lors du ciblage d'une entité ciblée",
  T_48_META_EVT_3041_P0_D: "Entités ciblées",
  T_48_META_EVT_3042_D: "Déclenché lorsqu'il est ciblé par un joueur",
  T_48_META_EVT_3042_P0_D: "Viser les joueurs",
  T_48_META_EVT_3043_D: "Déclenché lorsque la balle atteint la cible",
  T_48_META_EVT_3043_P0_D: "frapper",
  T_48_META_EVT_3043_P1_D: "Coordonnées mondiales des lieux d'impact des balles",
  T_48_META_EVT_3044_D: "Déclenché lorsqu'il est touché par une arme",
  T_48_META_EVT_3044_P0_D: "armement",
  T_48_META_EVT_3044_P1_D: "Coordonnées mondiales de la zone touchée",
  T_48_META_EVT_3045_D: "Déclenché lorsque le joueur choisit de se transformer en un objet pour ce niveau.",
  T_48_META_EVT_3045_P0_D: "Le joueur se transforme en une entité, et non en l'objet de la scène lui-même.",
  T_48_META_EVT_3046_D: "Déclenché lorsqu'un joueur est ressuscité à ce point de résurrection",
  T_48_META_EVT_3046_P0_D: "Joueurs ressuscités à ce point de résurrection",
  T_48_META_EVT_3047_D: "Déclenché lorsqu'un joueur se débarrasse d'une arme",
  T_48_META_EVT_3047_P0_D: "Entités d'armes abandonnées",
  T_48_META_EVT_3048_D: "Déclenché lorsqu'un joueur se débarrasse d'un objet autre qu'une arme.",
  T_48_META_EVT_3048_P0_D: "Type d'article",
  T_48_META_EVT_3048_P1_D: "Entité objet, éventuellement nulle",
  T_48_META_EVT_3049_D: "Déclenché lorsqu'il est touché par un pistolet de football",
  T_48_META_EVT_3049_P0_D: "joueur",
  T_48_META_EVT_3049_P1_D: "Vitesse après avoir été touché",
  T_48_META_EVT_3050_D: "Déclenché en cas de collision entre le ballon et le solide",
  T_48_META_EVT_3050_P0_D: "objet de collision",
  T_48_META_EVT_3050_P1_D: "Vitesse après collision",
  T_48_META_EVT_3051_D: "Déclenché lorsqu'un joueur rejoint avec succès un canal vocal.",
  T_48_META_EVT_3051_P0_D: "entité du canal vocal",
  T_48_META_EVT_3052_D: "Déclenché lorsqu'un joueur ne parvient pas à rejoindre un canal vocal",
  T_48_META_EVT_3052_P0_D: "entité du canal vocal",
  T_48_META_EVT_3053_D: "Déclenché lorsqu'un joueur quitte un canal vocal",
  T_48_META_EVT_3053_P0_D: "entité du canal vocal",
  T_48_META_EVT_3054_D: "Déclenché lorsque le ballon entre dans le but",
  T_48_META_EVT_3054_P0_D: "bouche de but",
  T_48_META_EVT_3054_P1_D: "Le buteur est le dernier joueur à toucher le ballon avant d'entrer dans le but.",
  T_48_META_EVT_3054_P2_D: "Les assistants, avant-dernier joueur à toucher le ballon avant que le but ne soit marqué.",
  T_48_META_EVT_3055_D: "Déclenché lorsque le joueur appuie sur le bouton de tir",
  T_48_META_EVT_3056_D: "Déclenché lorsque le joueur saute",
  T_48_META_EVT_3057_D: "Déclenché lorsque le joueur s'accroupit",
  T_48_META_EVT_3058_D: "Déclenché lorsque le joueur est à terre",
  T_48_META_EVT_3059_D: "Déclenché lorsque le joueur fait un sprint",
  T_48_META_EVT_3060_D: "Déclenché lorsqu'un article est acheté avec succès dans la boutique",
  T_48_META_EVT_3060_P0_D: "Joueurs qui achètent des biens",
  T_48_META_EVT_3060_P1_D: "marchandise",
  T_48_META_EVT_3061_D: "Déclenché lorsque l'arme est équipée par le joueur",
  T_48_META_EVT_3061_P0_D: "Joueurs équipés d'armes",
  T_48_META_EVT_3062_D: "Déclenché lorsqu'une unité est tuée avec cette arme",
  T_48_META_EVT_3062_P0_D: "Entités tuées",
  T_48_META_EVT_3063_D: "Déclenché lors de l'utilisation de cette arme pour infliger des dégâts à une unité.",
  T_48_META_EVT_3063_P0_D: "entité lésée",
  T_48_META_EVT_3063_P1_D: "quantité de dommages",
  T_48_META_EVT_3064_D: "Déclenché lorsque l'arme change de balle",
  T_48_META_EVT_3065_D: "Déclenché lorsqu'une entité entre dans le transporteur, soit en tant que conducteur, soit en tant que passager.",
  T_48_META_EVT_3065_P0_D: "Transporteurs inscrits",
  T_48_META_EVT_3066_D: "Déclenché lorsque l'entité quitte le transporteur",
  T_48_META_EVT_3066_P0_D: "Transporteurs en partance",
  T_48_META_EVT_3067_D: "Déclenché lors de la conduite physique du porteur",
  T_48_META_EVT_3067_P0_D: "Véhicules conduits",
  T_48_META_EVT_3068_D: "Déclenché après une téléportation lorsqu'une entité utilise un portail",
  T_48_META_EVT_3068_P0_D: "Portail utilisé",
  T_48_META_EVT_3069_D: "Déclenché lorsqu'une entité est rebondie par un pneu",
  T_48_META_EVT_3069_P0_D: "Pneus utilisés",
  T_48_META_EVT_3070_D: "Déclenché lorsqu'une entité est renversée par une machine",
  T_48_META_EVT_3070_P0_D: "objet généré par une machine",
  T_48_META_EVT_3071_D: "Déclenché après que le joueur a appuyé sur un bouton de l'interface utilisateur.",
  T_48_META_EVT_3071_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3072_D: "Déclenché lorsque le contrôle de bouton de l'interface utilisateur est levé",
  T_48_META_EVT_3072_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3073_D: "Déclenché après un double-clic du joueur sur un bouton de l'interface utilisateur.",
  T_48_META_EVT_3073_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3074_D: "Début de la zone de jailbreak",
  T_48_META_EVT_3075_D: "Fermeture de la zone d'évasion",
  T_48_META_EVT_3076_D: "Déclenché lorsque le joueur cesse d'utiliser les skis nautiques.",
  T_48_META_EVT_3077_D: "Déclenché lorsque le contenu du texte du contrôle de la boîte de saisie de l'interface utilisateur est modifié par le lecteur.",
  T_48_META_EVT_3077_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3077_P1_D: "Contenu du texte modifié",
  T_48_META_EVT_3078_D: "Déclenché lorsque l'entité jouable commence à jouer",
  T_48_META_EVT_3078_P0_D: "entité jouable",
  T_48_META_EVT_3079_D: "Déclenché lorsqu'une entité jouable finit de jouer, cet événement ne fonctionne du côté client que si l'entité jouable est un son, un effet, etc.",
  T_48_META_EVT_3079_P0_D: "entité jouable",
  T_48_META_EVT_3080_D: "Déclenché lorsque l'entité jouable continue à jouer",
  T_48_META_EVT_3080_P0_D: "entité jouable",
  T_48_META_EVT_3081_D: "Déclenché lorsqu'une entité jouable met la lecture en pause",
  T_48_META_EVT_3081_P0_D: "entité jouable",
  T_48_META_EVT_3082_D: "Les joueurs de Jailbreak rejoignent",
  T_48_META_EVT_3082_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3083_D: "Les joueurs de Jailbreak démissionnent",
  T_48_META_EVT_3083_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3084_D: "Déclenché à la fin du compte à rebours",
  T_48_META_EVT_3084_P0_D: "entité affiliée",
  T_48_META_EVT_3085_D: "Déclenché lorsqu'un objet est ramassé",
  T_48_META_EVT_3085_P0_D: "Joueurs qui ramassent des objets",
  T_48_META_EVT_3086_D: "Déclenché lorsqu'un article est mis au rebut",
  T_48_META_EVT_3086_P0_D: "Le joueur qui a déposé l'objet",
  T_48_META_EVT_3087_D: "Déclenché lorsque cet objet est équipé",
  T_48_META_EVT_3088_D: "Déclenché lorsque l'objet est démarré après la création de la mine",
  T_48_META_EVT_3089_D: "Déclenché lorsque l'objet est déclenché après la création de la mine",
  T_48_META_EVT_3089_P0_D: "Ciblage des objets après la création d'une mine",
  T_48_META_EVT_3090_D: "Déclenché avant l'achat d'un article dans un magasin",
  T_48_META_EVT_3090_P0_D: "Joueurs qui achètent des biens",
  T_48_META_EVT_3090_P1_D: "marchandise",
  T_48_META_EVT_3091_D: "Déclenché lorsque ce dispositif est utilisé",
  T_48_META_EVT_3092_D: "Déclenché lorsque le pistolet à crochet est tiré",
  T_48_META_EVT_3093_D: "Déclenché lorsque le projectile explose après avoir été lancé.",
  T_48_META_EVT_3093_P0_D: "point d'explosion",
  T_48_META_EVT_3094_D: "Déclenché lorsqu'il est touché par un pistolet de paintball",
  T_48_META_EVT_3094_P0_D: "Entités du pistolet à peinture",
  T_48_META_EVT_3094_P1_D: "point de vie",
  T_48_META_EVT_3094_P2_D: "atteindre la ligne de mire",
  T_48_META_EVT_3095_D: "Déclenché en cas de contact avec un pistolet à peinture",
  T_48_META_EVT_3095_P0_D: "objet touché",
  T_48_META_EVT_3095_P1_D: "point de vie",
  T_48_META_EVT_3095_P2_D: "atteindre la ligne de mire",
  T_48_META_EVT_3096_D: "Déclenché par l'explosion d'un support ou d'un seau de colorants",
  T_48_META_EVT_3096_P0_D: "Le joueur qui a provoqué l'explosion",
  T_48_META_EVT_3096_P1_D: "Liste des joueurs touchés par l'explosion",
  T_48_META_EVT_3097_D: "Déclenché lorsque l'arme cesse de tirer",
  T_48_META_EVT_3097_P0_D: "Capacité actuelle des chargeurs au moment du cessez-le-feu",
  T_48_META_EVT_3098_D: "Déclenché lorsque la cible poursuivie entre dans la zone de poursuite.",
  T_48_META_EVT_3099_D: "Déclenché lorsque la cible poursuivie quitte le champ de poursuite",
  T_48_META_EVT_31_D: "Déclenché en cas de changement de scène réussi",
  T_48_META_EVT_31_P0_D: "nom de la scène",
  T_48_META_EVT_3100_D: "Déclenché lorsque la cible de l'attaque entre dans le champ d'action de l'attaque",
  T_48_META_EVT_3101_D: "Déclenché lorsque la cible de l'attaque est hors de portée",
  T_48_META_EVT_3102_D: "Déclenché lorsque la détection des rayons de la caméra est déclenchée par un événement de clic du client",
  T_48_META_EVT_3102_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3102_P1_D: "Si le rayon de la caméra touche l'objet",
  T_48_META_EVT_3102_P2_D: "Position d'impact du rayon de la caméra",
  T_48_META_EVT_3102_P3_D: "Orientation de la caméra du client",
  T_48_META_EVT_3102_P4_D: "Position de la caméra du client",
  T_48_META_EVT_3102_P5_D: "atteindre la cible",
  T_48_META_EVT_3103_D: "Déclenché à l'ouverture de l'écran de la boutique",
  T_48_META_EVT_3103_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3104_D: "Déclenché lorsque l'écran de la boutique est fermé",
  T_48_META_EVT_3104_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3105_D: "Déclenché lorsque la logique de l'arbre de comportement entre dans le nœud",
  T_48_META_EVT_3105_P0_D: "Nom du nœud",
  T_48_META_EVT_3105_P1_D: "entité affiliée",
  T_48_META_EVT_3106_D: "Déclenché lorsque la logique de l'arbre de comportement quitte le nœud",
  T_48_META_EVT_3106_P0_D: "Nom du nœud",
  T_48_META_EVT_3106_P1_D: "entité affiliée",
  T_48_META_EVT_3107_D: "Déclenché lorsqu'un corps rigide est réveillé",
  T_48_META_EVT_3108_D: "Déclenché lorsque le corps rigide se met en sommeil",
  T_48_META_EVT_3109_D: "Déclenché lorsque le joueur se déplace",
  T_48_META_EVT_3109_P0_D: "ouvertures",
  T_48_META_EVT_3110_D: "Déclenché lorsque le lecteur est en veille",
  T_48_META_EVT_3110_P0_D: "ouvertures",
  T_48_META_EVT_3111_D: "Déclenché lorsque le joueur utilise une compétence",
  T_48_META_EVT_3111_P0_D: "Compétences utilisées",
  T_48_META_EVT_3112_D: "Déclenché lorsque le joueur termine son sprint",
  T_48_META_EVT_3113_D: "Déclenché lorsque l'élément correspondant à l'emplacement dans l'énumération SwitchEquipSlot est acquis.",
  T_48_META_EVT_3113_P0_D: "Entités de l'élément acquis",
  T_48_META_EVT_3114_D: "Déclenchements lors du changement d'objets portés à la main, y compris lors du passage au poing",
  T_48_META_EVT_3114_P0_D: "Entités du poste détenues après la commutation",
  T_48_META_EVT_3115_D: "Déclenché lorsqu'un joueur dans la boutique demande à quelqu'un d'acheter un objet.",
  T_48_META_EVT_3115_P0_D: "Joueurs demandant de la marchandise",
  T_48_META_EVT_3115_P1_D: "marchandise",
  T_48_META_EVT_3116_D: "Déclenché lorsqu'un joueur dans une boutique demande un objet à quelqu'un d'autre et que la demande est acceptée.",
  T_48_META_EVT_3116_P0_D: "Aide pour les joueurs achetés",
  T_48_META_EVT_3116_P1_D: "Joueurs demandant de l'aide pour leurs achats",
  T_48_META_EVT_3116_P2_D: "marchandise",
  T_48_META_EVT_3117_D: "Déclenché sur des mises à jour d'images fixes à une fréquence fixe de 30 fois par seconde",
  T_48_META_EVT_3118_D: "Déclenché après un appel à l'API Pause du jeu",
  T_48_META_EVT_3119_D: "Déclenché après un appel à l'API Restore Game",
  T_48_META_EVT_3120_D: "Déclenché lorsqu'un joueur ajoute ou supprime un ami",
  T_48_META_EVT_3121_D: "Déclenché à la réception d'un message Persona",
  T_48_META_EVT_3121_P0_D: "Contenu de l'information",
  T_48_META_EVT_3121_P1_D: "Persona de l'expéditeur",
  T_48_META_EVT_3122_D: "Déclenché à la fin du saut d'un joueur",
  T_48_META_EVT_3123_D: "Déclenché lorsque le joueur tombe",
  T_48_META_EVT_3124_D: "Déclenché à la fin de la chute d'un joueur",
  T_48_META_EVT_3125_D: "Déclenché à la réception d'un comportement Persona",
  T_48_META_EVT_3125_P0_D: "comportement",
  T_48_META_EVT_3125_P1_D: "Persona de l'expéditeur",
  T_48_META_EVT_3126_D: "Déclenché en cas de modification des informations relatives au membre",
  T_48_META_EVT_3126_P0_D: "Changement de statut du membre",
  T_48_META_EVT_3127_D: "Déclenché lors de l'entrée dans le centre des membres",
  T_48_META_EVT_3128_D: "Déclenché lorsque l'on quitte le centre des membres",
  T_48_META_EVT_3129_D: `Déclenché lorsque le joueur entre dans l'état "knockdown".`,
  T_48_META_EVT_3129_P0_D: "Entité de l'attaquant, éventuellement nulle",
  T_48_META_EVT_3130_D: "Déclenché lorsque le statut Persona est reçu",
  T_48_META_EVT_3130_P0_D: "Persona de l'expéditeur",
  T_48_META_EVT_3130_P1_D: "code d'erreur",
  T_48_META_EVT_3131_D: "Déclenché lors de l'envoi d'un message à Persona via l'interface utilisateur.",
  T_48_META_EVT_3131_P0_D: "Contenu de l'information",
  T_48_META_EVT_3131_P1_D: "Persona de l'expéditeur",
  T_48_META_EVT_3132_D: "Déclenché à la fin de la réception de Persona",
  T_48_META_EVT_3132_P0_D: "Persona de l'expéditeur",
  T_48_META_EVT_3132_P1_D: "code d'erreur",
  T_48_META_EVT_32_D: "Déclenché lorsque le joueur change de scène",
  T_48_META_EVT_32_P0_D: "nom de la scène",
  T_48_META_EVT_3200_D: "Déclenché lorsque la lecture du clip d'animation se termine",
  T_48_META_EVT_3200_P0_D: "Nom du segment animé",
  T_48_META_EVT_3201_D: "Déclenché lorsque la lecture de l'état d'animation se termine",
  T_48_META_EVT_3201_P0_D: "Nom de l'état d'animation",
  T_48_META_EVT_3204_D: "Déclenché lorsque l'état de la commande de basculement change.",
  T_48_META_EVT_3204_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3204_P1_D: "état des lieux",
  T_48_META_EVT_3260_D: "Déclenché lorsque le joueur appuie sur le pavé tactile.",
  T_48_META_EVT_3260_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3260_P1_D: "Position de la presse",
  T_48_META_EVT_3261_D: "Déclenché lorsque le pavé tactile est relevé",
  T_48_META_EVT_3261_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3261_P1_D: "Position de levage",
  T_48_META_EVT_3262_D: "Déclenché lorsque le pavé tactile commence à glisser",
  T_48_META_EVT_3262_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3262_P1_D: "Position de départ de la glissière",
  T_48_META_EVT_3263_D: "Déclenché lors d'un glissement du pavé tactile, cet événement est déclenché une fois par image pendant le glissement.",
  T_48_META_EVT_3263_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3263_P1_D: "Position de départ de la glissière",
  T_48_META_EVT_3263_P2_D: "déplacement",
  T_48_META_EVT_3264_D: "Déclenché à la fin d'un glissement du pavé tactile",
  T_48_META_EVT_3264_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3264_P1_D: "Position de la glissière d'extrémité",
  T_48_META_EVT_3265_D: "Déclenché lorsque le JoyStick est pressé",
  T_48_META_EVT_3265_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3266_D: "Déclenché lorsque le JoyStick est levé",
  T_48_META_EVT_3266_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3267_D: "Déclenché lors de l'utilisation du joystick JoyStick",
  T_48_META_EVT_3267_P0_D: "lecteur de déclenchement",
  T_48_META_EVT_3267_P1_D: "Sortie Déplacement",
  T_48_META_EVT_3268_D: "Déclenché lorsque le joueur se lève à partir d'une autre position.",
  T_48_META_EVT_3268_P0_D: "La position du joueur avant de se lever",
  T_48_META_EVT_3269_D: "Déclenché lorsque l'arme est tirée",
  T_48_META_EVT_4_D: "Déclenché au début de chaque tour",
  T_48_META_EVT_4_P0_D: "Indice rond, comptant à partir de 0",
  T_48_META_EVT_5_D: "Déclenché à la fin de chaque tour",
  T_48_META_EVT_5_P0_D: "Indice rond, comptant à partir de 0",
  T_48_META_EVT_6_D: `Déclenché lorsqu'une entité est entrée en collision. Pris en charge uniquement par les entités ayant un composant "corps rigide" monté.`,
  T_48_META_EVT_6_P0_D: "Entités rencontrées",
  T_48_META_EVT_7_D: "Déclenché au début de chaque phase",
  T_48_META_EVT_7_P0_D: "Entité d'étape",
  T_48_META_EVT_8_D: "Déclenché à la fin de chaque phase",
  T_48_META_EVT_8_P0_D: "Entité d'étape",
  T_48_META_EVT_9_D: "Déclenché à la fin d'une collision d'entité, uniquement pris en charge par les entités sur lesquelles est monté un composant Rigid Body.",
  T_48_META_EVT_9_P0_D: "Entités rencontrées",
  T_49_META_TYP_10_I1_D: "Liste de Balise",
  T_49_META_TYP_10_I2_D: "Est-il disponible seul ?",
  T_49_META_TYP_10_I3_D: "Disponible chez tous les parents",
  T_49_META_TYP_10_I4_D: "Si elle est disponible dans la scène",
  T_49_META_TYP_10_I5_D: "Si la mise à jour logique est activée, lorsqu'elle est désactivée, le script de cette entité cesse d'être mis à jour à chaque image.",
  T_49_META_TYP_10_I6_D: "Nom de l'entité",
  T_49_META_TYP_10_I7_D: "Options de filtrage de la région, 0 pour le calcul automatique de contrôlé ou non, 1 pour non contrôlé toujours synchronisé, 2 pour contrôlé",
  T_49_META_TYP_100_I0_D: "Réglage de la plage de déclenchement",
  T_49_META_TYP_100_I1_D: "Visibilité du modèle",
  T_49_META_TYP_101_I0_D: "Joueur",
  T_49_META_TYP_101_I1_D: "ID de l'Élément Cible",
  T_49_META_TYP_101_I2_D: "Rotation Cible",
  T_49_META_TYP_101_I3_D: "Échelle Cible",
  T_49_META_TYP_1010_I1_D: "Durée de la temporisation en secondes",
  T_49_META_TYP_1010_I2_D: "L'heure de début des temporisations, en secondes du moment du jeu",
  T_49_META_TYP_1010_I3_D: "Le type de mise à jour du minuteur, voir `EUITimeUpdateType`, sélectionnable entre statique, chronométré, compte à rebours.",
  T_49_META_TYP_1010_I4_D: "Position d'affichage, lorsqu'il y a une cible à suivre, il s'agit du décalage par rapport à l'origine de la cible, lorsqu'il n'y a pas de cible à suivre, il s'agit des coordonnées de l'écran.",
  T_49_META_TYP_1011_I10_D: "Nom de l'icône de progression",
  T_49_META_TYP_1011_I2_D: "Couleur du thème",
  T_49_META_TYP_1011_I3_D: "Si l'affichage localisé doit être activé",
  T_49_META_TYP_1011_I4_D: "Titre",
  T_49_META_TYP_1011_I5_D: "Description",
  T_49_META_TYP_1011_I6_D: "Nom de la ressource Icône",
  T_49_META_TYP_1011_I7_D: "Progression maximale",
  T_49_META_TYP_1011_I8_D: "Progression actuelle",
  T_49_META_TYP_1011_I9_D: "Icône de progression",
  T_49_META_TYP_1012_I1_D: "Active ou désactive la localisation",
  T_49_META_TYP_1012_I2_D: "Texte du nombre de tours",
  T_49_META_TYP_1012_I3_D: "Paramètres de clé de tour",
  T_49_META_TYP_1012_I5_D: "Couleur à gauche",
  T_49_META_TYP_1012_I6_D: "Couleur à droite",
  T_49_META_TYP_1013_I2_D: "Texte du nombre de tours",
  T_49_META_TYP_1013_I3_D: "Paramètres de clé de tour",
  T_49_META_TYP_1014_I2_D: "Titre du premier score Texte",
  T_49_META_TYP_1014_I3_D: "Premier score",
  T_49_META_TYP_1014_I4_D: "Paramètres du premier score",
  T_49_META_TYP_1014_I5_D: "Texte du titre du deuxième score",
  T_49_META_TYP_1014_I6_D: "Valeur du deuxième score",
  T_49_META_TYP_1014_I7_D: "Paramètres du deuxième score",
  T_49_META_TYP_1016_I1_D: "Afficher le statut correspondant à la valeur, Victoire (1), Défaite (2), Egalité (3), Booyah (4)",
  T_49_META_TYP_1016_I2_D: "Afficher si le score de 2 équipes est vrai, sinon caché",
  T_49_META_TYP_1016_I3_D: "Score de l'équipe de gauche",
  T_49_META_TYP_1016_I4_D: "Score de l'équipe de droite",
  T_49_META_TYP_1016_I5_D: "Horodatage de la fin de la phase",
  T_49_META_TYP_1017_I1_D: "Nom de l'équipe de gauche",
  T_49_META_TYP_1017_I2_D: "Description à gauche",
  T_49_META_TYP_1017_I3_D: "Nom de l'équipe de droite",
  T_49_META_TYP_1017_I4_D: "Description à droite",
  T_49_META_TYP_1018_I1_D: "Numéro de tour",
  T_49_META_TYP_1018_I4_D: "Score de l'équipe gauche",
  T_49_META_TYP_1018_I6_D: "Score de l'équipe droite",
  T_49_META_TYP_1019_I1_D: "1 2 3 pour victoire/défaite/égalité",
  T_49_META_TYP_102_I0_D: "Type de source de résurrection, le joueur ressuscite de la mort",
  T_49_META_TYP_102_I1_D: "Type de source de résurrection, le joueur est ressuscité après avoir été abattu.",
  T_49_META_TYP_1020_I2_D: "Clé de texte à afficher",
  T_49_META_TYP_1020_I3_D: "Tableau de paramètres correspondant à la clé de texte",
  T_49_META_TYP_1021_I1_D: "Temps de base en secondes",
  T_49_META_TYP_1021_I2_D: "Durée en secondes",
  T_49_META_TYP_1021_I3_D: "Position d'affichage, lorsqu'il y a une cible à suivre, c'est le décalage de l'origine de la cible, lorsqu'il n'y a pas de cible à suivre, c'est la coordonnée de l'écran, la valeur par défaut est Vector3(0).",
  T_49_META_TYP_1022_I2_D: "la clé du texte à afficher",
  T_49_META_TYP_1022_I3_D: "Tableau de paramètres correspondant à la clé de texte",
  T_49_META_TYP_1023_I1_D: "afficher le score de l'équipe s'il est vrai, sinon il sera désactivé.",
  T_49_META_TYP_1023_I4_D: "Si le statut de l'équipe est vrai, alors affichage, sinon il sera fermé.",
  T_49_META_TYP_1023_I5_D: "Tableau de l'état du joueur gauche, 0 : vivant, 1 : mort, 2 : à terre.",
  T_49_META_TYP_1023_I6_D: "Tableau de l'état du joueur droit, 0 : vivant, 1 : mort, 2 : à terre.",
  T_49_META_TYP_1023_I7_D: "Nombre de drapeaux à gauche",
  T_49_META_TYP_1023_I8_D: "Nombre de drapeaux du joueur de droite",
  T_49_META_TYP_1024_I2_D: "Décalage",
  T_49_META_TYP_1024_I3_D: "Rang",
  T_49_META_TYP_1024_I4_D: "Couleur de l'équipe",
  T_49_META_TYP_1024_I5_D: "Nom de l'icône",
  T_49_META_TYP_1024_I6_D: "Affiché si la bordure est vraie, sinon il est désactivé.",
  T_49_META_TYP_1024_I7_D: "Clé du texte du score",
  T_49_META_TYP_1024_I8_D: "Paramètres de la clé du texte du score",
  T_49_META_TYP_1028_I1_D: "Nombre de joueurs vivants à gauche",
  T_49_META_TYP_1028_I2_D: "Nombre de joueurs vivants à droite",
  T_49_META_TYP_1028_I3_D: "Couleur de fond à gauche",
  T_49_META_TYP_1028_I4_D: "Couleur de fond à droite",
  T_49_META_TYP_1028_I5_D: "Nom de l'icône à gauche",
  T_49_META_TYP_1028_I6_D: "Nom de l'icône à droite",
  T_49_META_TYP_1029_I1_D: "Nom de l'icône",
  T_49_META_TYP_1029_I2_D: "Nom de l'icône de fond",
  T_49_META_TYP_103_I0_D: "Arme Principale A",
  T_49_META_TYP_103_I1_D: "Arme principale B",
  T_49_META_TYP_103_I10_D: "Bombe de gel",
  T_49_META_TYP_103_I11_D: "Mur de glace",
  T_49_META_TYP_103_I12_D: "Mine terrestre",
  T_49_META_TYP_103_I13_D: "Tourelle automatique",
  T_49_META_TYP_103_I14_D: "Grenade Factice",
  T_49_META_TYP_103_I16_D: "Planches à roulettes, camouflage ....",
  T_49_META_TYP_103_I2_D: "Arme Secondaire",
  T_49_META_TYP_103_I3_D: "Arme de choc",
  T_49_META_TYP_103_I5_D: "Arme lourde",
  T_49_META_TYP_1030_I3_D: "Nombre de joueurs vivants à gauche",
  T_49_META_TYP_1030_I4_D: "Nombre de joueurs vivants à droite",
  T_49_META_TYP_1030_I5_D: "Nom de l'icône de l'équipe de gauche",
  T_49_META_TYP_1030_I6_D: "Nom de l'icône de l'équipe de droite",
  T_49_META_TYP_1031_I2_D: "Description du message",
  T_49_META_TYP_1031_I3_D: "Horodatage du début du compte à rebours, en secondes",
  T_49_META_TYP_1031_I4_D: "Paramètres des conseils",
  T_49_META_TYP_1032_I1_D: "Type de conseil",
  T_49_META_TYP_1032_I3_D: "Paramètres de description",
  T_49_META_TYP_1033_I1_D: "Phase de basculement, 0 est le round en cours, 1 est le début du round suivant.",
  T_49_META_TYP_1033_I10_D: "Texte d'invite pour la défaite, non rempli par défaut",
  T_49_META_TYP_1033_I11_D: "Titre des revenus de round",
  T_49_META_TYP_1033_I12_D: "Revenus de round",
  T_49_META_TYP_1033_I13_D: "Titres Des Détails De Revenu Par Tour",
  T_49_META_TYP_1033_I14_D: "Liste détaillée de la valeur des revenus du tour, correspondant à la liste détaillée des titres ci-dessus, un par un",
  T_49_META_TYP_1033_I15_D: "MVP Surnom du joueur",
  T_49_META_TYP_1033_I16_D: "Indice du round suivant",
  T_49_META_TYP_1033_I17_D: "Round décisif",
  T_49_META_TYP_1033_I18_D: "Dernier round",
  T_49_META_TYP_1033_I6_D: "Nom de l'icône de l'équipe de gauche",
  T_49_META_TYP_1033_I7_D: "Nom de l'icône de l'équipe droite",
  T_49_META_TYP_1033_I8_D: "En fonction de la valeur, le statut correspondant sera affiché, Victoire (1), Défaite (2).",
  T_49_META_TYP_1033_I9_D: "Texte d'invite pour la victoire, par défaut s'il n'est pas rempli",
  T_49_META_TYP_1036_I1_D: "Indique le nombre total de niveaux",
  T_49_META_TYP_1036_I2_D: "Indique le niveau actuel du bot",
  T_49_META_TYP_1037_I1_D: "Indique le nombre de points affichés",
  T_49_META_TYP_1039_I3_D: "Horodatage du début du compte à rebours, en secondes",
  T_49_META_TYP_104_I0_D: "Style A",
  T_49_META_TYP_104_I1_D: "Style B",
  T_49_META_TYP_104_I2_D: "Style C",
  T_49_META_TYP_1040_I10_D: "Descriptions des cartes",
  T_49_META_TYP_1040_I11_D: "Index de l'élément sélectionné, à partir de 0, moins de 0 signifie non sélectionné.",
  T_49_META_TYP_1040_I12_D: "Noms des boutons",
  T_49_META_TYP_1040_I13_D: "Couleurs des boutons",
  T_49_META_TYP_1040_I2_D: "Clé du compte à rebours",
  T_49_META_TYP_1040_I3_D: "Temps du compte à rebours",
  T_49_META_TYP_1040_I4_D: "Clé de description",
  T_49_META_TYP_1040_I5_D: "Tableau des paramètres de description",
  T_49_META_TYP_1040_I6_D: "Arrière-plan des cartes",
  T_49_META_TYP_1040_I7_D: "Couleurs de fond des cartes",
  T_49_META_TYP_1040_I8_D: "Icônes des cartes",
  T_49_META_TYP_1040_I9_D: "Noms des cartes",
  T_49_META_TYP_1041_I2_D: "Position",
  T_49_META_TYP_1041_I3_D: "Icône",
  T_49_META_TYP_1041_I4_D: "Étiquette",
  T_49_META_TYP_1041_I5_D: "Couleur de fond",
  T_49_META_TYP_1042_I1_D: "Position locale",
  T_49_META_TYP_1043_I4_D: "Couleur",
  T_49_META_TYP_1043_I5_D: "Clé de l'étiquette",
  T_49_META_TYP_1043_I6_D: "Paramètres de l'étiquette",
  T_49_META_TYP_1045_I2_D: "Icône du bouton",
  T_49_META_TYP_1045_I3_D: "Couleur de l'icône",
  T_49_META_TYP_1045_I4_D: "Taille, même largeur et même hauteur",
  T_49_META_TYP_1045_I5_D: "Position par rapport à l'ancre dans le coin inférieur droit",
  T_49_META_TYP_1045_I6_D: "Nombre de charges, moins de 0 signifie caché",
  T_49_META_TYP_1045_I7_D: "Heure de début du CD, en millisecondes",
  T_49_META_TYP_1045_I8_D: "Durée du CD, en millisecondes",
  T_49_META_TYP_1045_I9_D: "True, le bouton sera grisé, False, il sera restauré.",
  T_49_META_TYP_106_I1_D: "Activer",
  T_49_META_TYP_106_I2_D: "Désactiver",
  T_49_META_TYP_109_I0_D: "ID du Canal de Chat",
  T_49_META_TYP_109_I1_D: "Player List",
  T_49_META_TYP_11_I0_D: "Si la partie en cours est illégale, cela signifie que le jeu a perdu sa valeur d'affrontement et qu'il est recommandé de mettre fin à la partie directement.",
  T_49_META_TYP_11_I1_D: "La durée de la partie en cours, en millisecondes.",
  T_49_META_TYP_11_I10_D: "Réinitialisation ou non de l'équipement à chaque tour",
  T_49_META_TYP_11_I11_D: "Activation ou non du mécanisme de l'anneau de poison",
  T_49_META_TYP_11_I12_D: "Taille de la Zone de Sécurité",
  T_49_META_TYP_11_I13_D: "Heure de Début du Rétrécissement",
  T_49_META_TYP_11_I14_D: "Durée de Rétrécissement",
  T_49_META_TYP_11_I15_D: "Dégâts Hors Zone",
  T_49_META_TYP_11_I18_D: "Type de Réanimation",
  T_49_META_TYP_11_I2_D: "Index du tour en cours, cette valeur permet d'obtenir l'entité du tour en cours.",
  T_49_META_TYP_11_I27_D: "Nombre Total De Tours",
  T_49_META_TYP_11_I3_D: "Index de l'étape en cours, cette valeur permet d'obtenir l'entité de l'étape en cours.",
  T_49_META_TYP_11_I32_D: "Nombre de pièces gagnées au début du tour",
  T_49_META_TYP_11_I33_D: "Nombre de pièces pour les meurtres",
  T_49_META_TYP_11_I34_D: "Nombre de pièces gagnées en cas de victoire",
  T_49_META_TYP_11_I35_D: "Affichage ou non de l'interface du portefeuille",
  T_49_META_TYP_11_I36_D: "Entité Skybox",
  T_49_META_TYP_11_I37_D: "Nombre d'images cumulées depuis le début du jeu",
  T_49_META_TYP_11_I38_D: "Activer Le Mouvement",
  T_49_META_TYP_11_I39_D: "Possibilité de personnaliser la colonie",
  T_49_META_TYP_11_I4_D: "L'ID du modèle du mode UGC prédéfini.",
  T_49_META_TYP_11_I40_D: "Permettre ou non de rejoindre le jeu en cours de partie",
  T_49_META_TYP_11_I41_D: 'Activer le mode "low frame rate", le jeu tournera à 15FPS, sinon à 30FPS',
  T_49_META_TYP_11_I42_D: "Intervalle logique de mise à jour des images entre deux mises à jour du serveur de jeu",
  T_49_META_TYP_11_I43_D: "Intervalle fixe de mise à jour des images en millisecondes",
  T_49_META_TYP_11_I5_D: "Désactiver la résurrection des joueurs si elle est désactivée",
  T_49_META_TYP_11_I6_D: "Désactiver la résurrection du Bot si elle est désactivée",
  T_49_META_TYP_11_I7_D: "Durée de la résurrection en secondes",
  T_49_META_TYP_11_I8_D: "Nombre total d'équipes dans le jeu",
  T_49_META_TYP_11_I9_D: "Nombre de membres dans chaque équipe",
  T_49_META_TYP_110_I0_D: "Canal A",
  T_49_META_TYP_110_I1_D: "Canal B",
  T_49_META_TYP_110_I2_D: "Canal C",
  T_49_META_TYP_110_I3_D: "Canal D",
  T_49_META_TYP_110_I4_D: "Canal E",
  T_49_META_TYP_110_I5_D: "Canal F",
  T_49_META_TYP_111_I1_D: "Sprint",
  T_49_META_TYP_111_I2_D: "Attaque",
  T_49_META_TYP_111_I3_D: "Saut",
  T_49_META_TYP_111_I4_D: "Voûte Par Dessus",
  T_49_META_TYP_111_I5_D: "Conduire",
  T_49_META_TYP_111_I6_D: "Entrer dans le véhicule",
  T_49_META_TYP_111_I7_D: "Sortir Du Véhicule",
  T_49_META_TYP_111_I8_D: "Conduire le véhicule",
  T_49_META_TYP_112_I0_D: "Activer",
  T_49_META_TYP_112_I1_D: "Désactiver",
  T_49_META_TYP_112_I2_D: "Invisible",
  T_49_META_TYP_117_I0_D: "Claps",
  T_49_META_TYP_117_I1_D: "Hihats",
  T_49_META_TYP_117_I2_D: "Kick",
  T_49_META_TYP_117_I3_D: "OpenHihats",
  T_49_META_TYP_117_I4_D: "Rides",
  T_49_META_TYP_117_I5_D: "Snares",
  T_49_META_TYP_118_I0_D: "Si tous les membres du camp sont en état de mort",
  T_49_META_TYP_118_I1_D: "Liste de tous les membres de l'équipe",
  T_49_META_TYP_118_I2_D: "Factions Alliées",
  T_49_META_TYP_118_I3_D: "Factions Attaquables",
  T_49_META_TYP_118_I4_D: "Affichage ou non du nom de l'interface utilisateur",
  T_49_META_TYP_118_I5_D: "Afficher ou non les informations de la carte",
  T_49_META_TYP_118_I6_D: "Afficher ou non",
  T_49_META_TYP_118_I7_D: "Affichage ou non",
  T_49_META_TYP_118_I8_D: "Tous les Membres",
  T_49_META_TYP_118_I9_D: "Afficher le Message Rapide",
  T_49_META_TYP_119_I0_D: "Oui",
  T_49_META_TYP_119_I1_D: "Non",
  T_49_META_TYP_120_I1_D: "Entité cible à suivre, vide par défaut",
  T_49_META_TYP_120_I2_D: "Couleur de l'interface utilisateur",
  T_49_META_TYP_120_I3_D: "Longueur de l'interface utilisateur",
  T_49_META_TYP_120_I4_D: "Valeur de la progression actuelle, de 0 à 1,0",
  T_49_META_TYP_120_I5_D: "Position d'affichage, lorsqu'il y a une cible à suivre, il s'agit du décalage par rapport à l'origine de la cible, lorsqu'il n'y a pas de cible à suivre, il s'agit des coordonnées de l'écran, la valeur par défaut est Vector3(0)",
  T_49_META_TYP_121_I0_D: "3s",
  T_49_META_TYP_121_I1_D: "5s",
  T_49_META_TYP_121_I2_D: "10s",
  T_49_META_TYP_121_I3_D: "15s",
  T_49_META_TYP_121_I4_D: "30s",
  T_49_META_TYP_121_I5_D: "9999s",
  T_49_META_TYP_122_I0_D: "Ressource Du Skybox",
  T_49_META_TYP_122_I1_D: "Couleur Claire",
  T_49_META_TYP_122_I10_D: "GUID de la sous-scène",
  T_49_META_TYP_122_I11_D: "Commutateur de fonction de brouillard",
  T_49_META_TYP_122_I12_D: "Mode d'effet de brouillard",
  T_49_META_TYP_122_I13_D: "Densité exponentielle du brouillard",
  T_49_META_TYP_122_I14_D: "Distance de départ du brouillard linéaire",
  T_49_META_TYP_122_I15_D: "Distance finale du brouillard linéaire",
  T_49_META_TYP_122_I16_D: "Activation de la fonction d'effet de brouillard",
  T_49_META_TYP_122_I17_D: "Angle de rotation de la source lumineuse principale",
  T_49_META_TYP_122_I18_D: "Activer la fonction d'angle de rotation de la source lumineuse principale",
  T_49_META_TYP_122_I2_D: "Intensité de la Lumière",
  T_49_META_TYP_122_I3_D: "Obscurité",
  T_49_META_TYP_122_I4_D: "Force de l'Ombre",
  T_49_META_TYP_122_I5_D: "Humidité du Terrain",
  T_49_META_TYP_122_I6_D: "Facteur de Flare",
  T_49_META_TYP_122_I7_D: "Couleur Brouillard",
  T_49_META_TYP_122_I8_D: "Couleur Ambiante",
  T_49_META_TYP_123_I0_D: "Jour",
  T_49_META_TYP_123_I1_D: "Nuit",
  T_49_META_TYP_123_I2_D: "Crépuscule",
  T_49_META_TYP_123_I3_D: "Vue sur la Ville",
  T_49_META_TYP_123_I4_D: "Ciel Coloré",
  T_49_META_TYP_123_I5_D: "Lune De Givre",
  T_49_META_TYP_124_I0_D: "Portée rapprochée",
  T_49_META_TYP_124_I1_D: "Moyenne portée",
  T_49_META_TYP_124_I2_D: "Longue portée",
  T_49_META_TYP_125_I0_D: "Diffuser la Couleur",
  T_49_META_TYP_125_I2_D: "Diffuser la Texture",
  T_49_META_TYP_125_I4_D: "Alpha Diffusé",
  T_49_META_TYP_126_I1_D: "Nom",
  T_49_META_TYP_126_I2_D: "Valeur actuelle de la progression",
  T_49_META_TYP_126_I3_D: "Valeur maximale de la progression",
  T_49_META_TYP_126_I4_D: "Coordonnée de l'écran, par défaut Vector3(0).",
  T_49_META_TYP_126_I5_D: "longueur de la barre de progression, la valeur par défaut est la longueur de l'interface utilisateur sur le préfabriqué.",
  T_49_META_TYP_127_I0_D: "Panoramique le long d'un axe, peut être combiné en trois axes",
  T_49_META_TYP_127_I1_D: "Rotation le long d'un axe, peut être combinée sur trois axes",
  T_49_META_TYP_127_I2_D: "Zoom le long d'un axe, peut être combiné avec trois axes",
  T_49_META_TYP_128_I0_D: "Buissons",
  T_49_META_TYP_128_I1_D: "Citrouille",
  T_49_META_TYP_128_I2_D: "Épouvantail",
  T_49_META_TYP_128_I3_D: "Armoire",
  T_49_META_TYP_129_I0_D: "Butin aléatoire",
  T_49_META_TYP_129_I1_D: "Munitions AR",
  T_49_META_TYP_129_I2_D: "Munitions SMG",
  T_49_META_TYP_129_I3_D: "Munitions SN",
  T_49_META_TYP_129_I4_D: "Munitions HG",
  T_49_META_TYP_129_I5_D: "Balles SG",
  T_49_META_TYP_129_I6_D: "Munitions Arc",
  T_49_META_TYP_13_I1_D: "Coordonnées d'ancrage par rapport au noeud parent.",
  T_49_META_TYP_13_I10_D: "Différence de taille entre le widget et le cadre de l'ancre",
  T_49_META_TYP_13_I11_D: "Pivot",
  T_49_META_TYP_13_I12_D: "Profondeur",
  T_49_META_TYP_13_I14_D: "Ordre de tous les enfants dans le même nœud parent",
  T_49_META_TYP_13_I15_D: "ID parent",
  T_49_META_TYP_13_I16_D: "ID unique",
  T_49_META_TYP_13_I17_D: "Priorité",
  T_49_META_TYP_13_I18_D: "Position réelle",
  T_49_META_TYP_13_I2_D: "Largeur",
  T_49_META_TYP_13_I4_D: "Angle de rotation de l'axe Z",
  T_49_META_TYP_13_I6_D: "ID interne du contrôle dans le préfabriqué",
  T_49_META_TYP_13_I7_D: "Entité de l'interface utilisateur où il se trouve",
  T_49_META_TYP_13_I8_D: "Ancre min",
  T_49_META_TYP_13_I9_D: "Ancre max",
  T_49_META_TYP_130_I0_D: "Butin aléatoire de consommables",
  T_49_META_TYP_130_I1_D: "Kit de soins",
  T_49_META_TYP_130_I2_D: "Kit de réparation",
  T_49_META_TYP_130_I3_D: "Horizon",
  T_49_META_TYP_130_I4_D: "Inhalateur",
  T_49_META_TYP_131_I0_D: "Butin d'armure aléatoire",
  T_49_META_TYP_131_I1_D: "Armure de niveau 1",
  T_49_META_TYP_131_I2_D: "Armure secondaire",
  T_49_META_TYP_131_I3_D: "Armure de niveau 3",
  T_49_META_TYP_132_I0_D: "Objet à lancer Loot aléatoire",
  T_49_META_TYP_132_I1_D: "Grenade",
  T_49_META_TYP_132_I4_D: "Congélation",
  T_49_META_TYP_133_I0_D: "Prise de possession d'un multiplicateur aléatoire",
  T_49_META_TYP_133_I1_D: "Lunette 2x",
  T_49_META_TYP_133_I2_D: "Lunette 4x",
  T_49_META_TYP_133_I3_D: "Lunette thermique",
  T_49_META_TYP_134_I0_D: "Butin d'arme aléatoire",
  T_49_META_TYP_134_I5_D: "Shotgun",
  T_49_META_TYP_134_I8_D: "Pistolet de football",
  T_49_META_TYP_135_I0_D: "Points de balle",
  T_49_META_TYP_136_I0_D: "Loot Consumable Points (Points de consommation)",
  T_49_META_TYP_137_I0_D: "Points de consommation",
  T_49_META_TYP_138_I0_D: "Points de multiplicateur de butin",
  T_49_META_TYP_139_I0_D: "Points d'armure",
  T_49_META_TYP_14_I0_D: "Taux sanguin actuel du joueur",
  T_49_META_TYP_14_I1_D: "Niveau maximum de sang du joueur",
  T_49_META_TYP_14_I11_D: "Le camp du joueur",
  T_49_META_TYP_14_I12_D: "Le multiplicateur de dégâts du joueur, par exemple 2x configuré comme 2.0",
  T_49_META_TYP_14_I13_D: "Utilise exactement le même squelette que le personnage masculin ou féminin, 0 signifie qu'il n'y a pas de remplacement de modèle.",
  T_49_META_TYP_14_I14_D: "N'entre pas en conflit avec l'échelle de vitesse existante.",
  T_49_META_TYP_14_I15_D: "N'entre pas en conflit avec l'échelle de hauteur de saut existante",
  T_49_META_TYP_14_I16_D: "Identité,0 Joueur normal,1 Chasseur,2 Zombie matriciel,3 Zombie normal,4 Zombie évolué de type 1, 5 Zombie évolué de type 2,6 Zombie évolué de type 3",
  T_49_META_TYP_14_I17_D: "Niveau du zombie, 1~3",
  T_49_META_TYP_14_I19_D: "Surnom du joueur",
  T_49_META_TYP_14_I2_D: "Détermine si le joueur actuel est un joueur IA, l'IA est généralement un PNJ ou un monstre PVE.",
  T_49_META_TYP_14_I20_D: "Pourcentage de dégâts infligés lorsqu'on subit des dégâts, peut être réduit ou augmenté",
  T_49_META_TYP_14_I21_D: "EP actuel du joueur",
  T_49_META_TYP_14_I22_D: "EP maximum du joueur",
  T_49_META_TYP_14_I23_D: "Arme principale actuellement en main",
  T_49_META_TYP_14_I24_D: "Est Déposé Lorsqu'éliminé",
  T_49_META_TYP_14_I26_D: "Aim Assist Type",
  T_49_META_TYP_14_I27_D: "Autoriser Le Verrouillage Par Assistance à La Visée",
  T_49_META_TYP_14_I28_D: "Activer/désactiver le chat vocal : true pour désactiver le chat vocal, false pour activer le chat vocal",
  T_49_META_TYP_14_I29_D: "Commutation du chat rapide : trueClose voice, falseOpen voice",
  T_49_META_TYP_14_I3_D: "Statut Du Joueur",
  T_49_META_TYP_14_I30_D: "Canal",
  T_49_META_TYP_14_I35_D: "Commuter le ramassage : trueCan't pickup, falseCan't pickup",
  T_49_META_TYP_14_I36_D: "Intervertir la mise au rebut de l'objet : trueNe peut pas mettre au rebut, falsePour mettre au rebut",
  T_49_META_TYP_14_I37_D: "Cibles Attaquables",
  T_49_META_TYP_14_I38_D: "Joueurs Amicaux",
  T_49_META_TYP_14_I39_D: "Faction",
  T_49_META_TYP_14_I4_D: "Le temps de survie du joueur, si le joueur meurt, le temps sera recalculé.",
  T_49_META_TYP_14_I40_D: "Numéro Dans la Faction",
  T_49_META_TYP_14_I41_D: "Caméra utilisée par le joueur",
  T_49_META_TYP_14_I42_D: "Gravité Personnalisée",
  T_49_META_TYP_14_I43_D: "Casque",
  T_49_META_TYP_14_I44_D: "Gilet",
  T_49_META_TYP_14_I5_D: "L'invincibilité du joueur",
  T_49_META_TYP_14_I52_D: "UID de l'utilisateur",
  T_49_META_TYP_14_I53_D: "Réduction Des Dégâts à La Tête",
  T_49_META_TYP_14_I54_D: "AVATAR à laquelle le joueur est lié",
  T_49_META_TYP_14_I55_D: "Genre",
  T_49_META_TYP_14_I56_D: "ID's de Skin D'arme",
  T_49_META_TYP_14_I57_D: "Point de naissance du joueur",
  T_49_META_TYP_14_I58_D: "Point de résurrection du joueur, si aucun point de contrôle n'est enregistré, c'est le point de naissance qui est utilisé, sinon ce sont les points de contrôle qui sont utilisés.",
  T_49_META_TYP_14_I59_D: "Position actuelle du joueur",
  T_49_META_TYP_14_I6_D: "L'entité de l'équipe à laquelle le joueur appartient",
  T_49_META_TYP_14_I60_D: "Orientation actuelle du joueur",
  T_49_META_TYP_14_I61_D: "Nœud utilisé pour accéder au squelette dépecé",
  T_49_META_TYP_14_I62_D: "Sac à dos",
  T_49_META_TYP_14_I63_D: "Points De Boucliers Temporaires",
  T_49_META_TYP_14_I64_D: "ID de la peau du véhicule",
  T_49_META_TYP_14_I65_D: "Est Ignorer L'animation Décalée",
  T_49_META_TYP_14_I66_D: "Désactiver les dégâts de chute",
  T_49_META_TYP_14_I67_D: "Objet Tenu Actuellement",
  T_49_META_TYP_14_I68_D: "Liste Des Articles Interdits Au Ramassage",
  T_49_META_TYP_14_I69_D: "ID de la ressource du joueur",
  T_49_META_TYP_14_I7_D: "ID du point de contrôle actuel",
  T_49_META_TYP_14_I70_D: "La cible à laquelle le message de demande d'achat a été envoyé",
  T_49_META_TYP_14_I71_D: "L'identifiant de la ressource de l'Emote en cours de lecture",
  T_49_META_TYP_14_I72_D: "Si l'Emote en cours de lecture est en boucle",
  T_49_META_TYP_14_I73_D: "Traitement de l'état de knockdown",
  T_49_META_TYP_14_I74_D: "Si le saut de dégâts doit être activé, la valeur par défaut est True, ce qui signifie qu'il est activé.",
  T_49_META_TYP_14_I76_D: "S'il faut quitter le jeu au milieu de la partie",
  T_49_META_TYP_14_I77_D: "Informations sur les vêtements à conserver lorsque le joueur se transforme en un autre personnage",
  T_49_META_TYP_14_I8_D: "ID du point de contrôle vers lequel la cible se rend.",
  T_49_META_TYP_140_I0_D: "Vague 1",
  T_49_META_TYP_140_I1_D: "Vague 2",
  T_49_META_TYP_140_I2_D: "Vague 3",
  T_49_META_TYP_140_I3_D: "Continu",
  T_49_META_TYP_141_I0_D: "Butin de football aléatoire",
  T_49_META_TYP_141_I1_D: "Bouclier de football",
  T_49_META_TYP_141_I2_D: "Grenade Gelante",
  T_49_META_TYP_142_I0_D: "Loot Soccer",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (Tir)",
  T_49_META_TYP_147_I1_D: "Troisième personne",
  T_49_META_TYP_147_I2_D: "Première personne (Tir)",
  T_49_META_TYP_147_I3_D: "Vue du dessus",
  T_49_META_TYP_147_I4_D: "Défilement horizontal",
  T_49_META_TYP_147_I5_D: "Personnalisé",
  T_49_META_TYP_147_I6_D: "Poursuite",
  T_49_META_TYP_147_I7_D: "Caméra libre contrôlée par le joueur",
  T_49_META_TYP_147_I8_D: "Nouvelle version de la caméra à la première personne",
  T_49_META_TYP_148_I0_D: "Plusieurs types de caméra prédéfinis, ainsi que des types de caméra personnalisés.",
  T_49_META_TYP_148_I1_D: "Le champ de vision est l'angle de vue de la caméra.",
  T_49_META_TYP_148_I10_D: "Type d'animation de changement de caméra",
  T_49_META_TYP_148_I11_D: "Temps de transition en millisecondes pour basculer vers cette caméra, uniquement si le type de basculement est Smooth (lisse)",
  T_49_META_TYP_148_I12_D: "Mode de mouvement de la caméra lorsqu'il y a une occlusion entre la caméra et la cible qu'elle suit.",
  T_49_META_TYP_148_I13_D: "Rendu de la caméra à l'écran",
  T_49_META_TYP_148_I14_D: "Système de coordonnées de référence du décalage de l'objet à suivre",
  T_49_META_TYP_148_I15_D: "Système de coordonnées de référence de décalage de l'objet d'observation",
  T_49_META_TYP_148_I16_D: "Le masque de la couche de rendu de la caméra, qui permet de filtrer les objets rendus par la caméra en fonction de leur niveau de visibilité.",
  T_49_META_TYP_148_I17_D: "Restriction De L'angle De Vue",
  T_49_META_TYP_148_I2_D: "Se réfère généralement au décalage de la position de la caméra par rapport à la position d'origine du joueur, avec des significations différentes selon les types de caméra.",
  T_49_META_TYP_148_I3_D: "La mise au point de la caméra est le décalage du point de mise au point de la caméra par rapport à la position initiale du joueur, qui varie selon le type de caméra.",
  T_49_META_TYP_148_I4_D: "Angle de rotation de la caméra dans le sens vertical",
  T_49_META_TYP_148_I5_D: "L'angle de rotation de la caméra dans le sens horizontal",
  T_49_META_TYP_148_I7_D: "La cible que la caméra suit",
  T_49_META_TYP_148_I8_D: "La cible que la caméra regarde",
  T_49_META_TYP_148_I9_D: "Le joueur qui utilise la caméra",
  T_49_META_TYP_15_I0_D: "Si tous les joueurs de l'équipe sont actuellement morts",
  T_49_META_TYP_15_I1_D: "Liste de tous les joueurs de l'équipe",
  T_49_META_TYP_15_I3_D: "Liste des équipes hostiles",
  T_49_META_TYP_15_I4_D: "Liste des équipes amies",
  T_49_META_TYP_15_I5_D: "Numéro d'équipe",
  T_49_META_TYP_150_I0_D: "Durabilité",
  T_49_META_TYP_150_I1_D: "Le rayon des hémisphères aux extrémités du corps de la capsule.",
  T_49_META_TYP_150_I2_D: "Facteur de Dégâts",
  T_49_META_TYP_152_I1_D: "Gravité Personnalisée",
  T_49_META_TYP_152_I2_D: "S'il est nécessaire ou non d'afficher le déclencheur, True correspond à l'affichage.",
  T_49_META_TYP_154_I0_D: "Ne peut pas être utilisé à deux",
  T_49_META_TYP_154_I1_D: "Ne peut être manié à deux qu'en combinaison avec la même arme",
  T_49_META_TYP_154_I2_D: "Peut être combiné avec une autre arme ainsi qu'avec vous-même.",
  T_49_META_TYP_155_I0_D: "Niveau",
  T_49_META_TYP_155_I1_D: "Durabilité Max",
  T_49_META_TYP_155_I2_D: "Durabilité Actuelle",
  T_49_META_TYP_155_I3_D: "Facteur de Réduction des Dégâts",
  T_49_META_TYP_155_I4_D: "Facteur de réduction des dégâts d'explosion",
  T_49_META_TYP_155_I5_D: "Peut Coûter En Durabilité",
  T_49_META_TYP_155_I6_D: "Peut Détruire",
  T_49_META_TYP_156_I1_D: "Durabilité Max",
  T_49_META_TYP_156_I2_D: "Durabilité Actuelle",
  T_49_META_TYP_156_I3_D: "Facteur de Réduction des Dégâts",
  T_49_META_TYP_156_I4_D: "Facteur de réduction des dégâts d'explosion",
  T_49_META_TYP_156_I5_D: "Peut Coûter En Durabilité",
  T_49_META_TYP_156_I6_D: "Peut Détruire",
  T_49_META_TYP_157_I0_D: "Pas d'animation",
  T_49_META_TYP_157_I1_D: "Fluide",
  T_49_META_TYP_158_I2_D: "Enumération du type d'ancre de l'interface utilisateur, la valeur par défaut est 9 (Centre)",
  T_49_META_TYP_158_I6_D: "Clé de l'étiquette",
  T_49_META_TYP_158_I7_D: "Paramètres de l'étiquette",
  T_49_META_TYP_158_I8_D: "Équipe gauche",
  T_49_META_TYP_16_I1_D: "ID de l'objet de l'entité",
  T_49_META_TYP_16_I2_D: "Uniquement pour le chargement statique d'objets, déterminer s'il s'agit d'une génération statique de NavMesh.",
  T_49_META_TYP_16_I3_D: "S'il s'agit d'un blocage dynamique du NavMesh ou non.",
  T_49_META_TYP_16_I4_D: "Chargement asynchrone",
  T_49_META_TYP_160_I0_D: "Brick A",
  T_49_META_TYP_160_I1_D: "Tile A",
  T_49_META_TYP_160_I10_D: "Sand A",
  T_49_META_TYP_160_I11_D: "Snow A",
  T_49_META_TYP_160_I12_D: "Wood A",
  T_49_META_TYP_160_I13_D: "tone A",
  T_49_META_TYP_160_I14_D: "Lawn B",
  T_49_META_TYP_160_I15_D: "Brick B",
  T_49_META_TYP_160_I16_D: "Brick C",
  T_49_META_TYP_160_I17_D: "Clear",
  T_49_META_TYP_160_I2_D: "Tile B",
  T_49_META_TYP_160_I3_D: "Tile C",
  T_49_META_TYP_160_I4_D: "Bamboo A",
  T_49_META_TYP_160_I5_D: "Cement A",
  T_49_META_TYP_160_I6_D: "Container A",
  T_49_META_TYP_160_I7_D: "Lawn A",
  T_49_META_TYP_160_I8_D: "Ice A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Activer ou non la collision",
  T_49_META_TYP_165_I1_D: "Agir ou non en tant que déclencheur",
  T_49_META_TYP_165_I2_D: "Couches physiques, configure les couches dans le module physique, jusqu'à 16.",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "Type de texture VFX",
  T_49_META_TYP_170_I0_D: "Visible ou non, le client arrête le rendu de la cible lorsqu'elle n'est pas visible.",
  T_49_META_TYP_170_I1_D: "Niveau de visibilité, valeur comprise entre [0,15], affecte la visibilité dans la caméra.",
  T_49_META_TYP_171_I0_D: "Énergie",
  T_49_META_TYP_172_I0_D: "Nombre de balles",
  T_49_META_TYP_173_I0_D: "Capacité Supplémentaire Du Sac à Dos",
  T_49_META_TYP_173_I1_D: "Les configurations de peau en dehors de la station du joueur sont prioritaires",
  T_49_META_TYP_173_I2_D: "Skin ID du sac à dos, skin configuration du sac à dos lui-même.",
  T_49_META_TYP_174_I2_D: "Dégâts Max.",
  T_49_META_TYP_174_I4_D: "Vitesse De Lancer",
  T_49_META_TYP_174_I5_D: "Délai d'explosion, en secondes",
  T_49_META_TYP_174_I6_D: "Facteur De Dégâts Personnels",
  T_49_META_TYP_174_I7_D: "Proportion du Facteur Coéquipier",
  T_49_META_TYP_174_I8_D: "Proportion Du Facteur De Véhicule",
  T_49_META_TYP_174_I9_D: "Skin",
  T_49_META_TYP_175_I0_D: "Rayon de Zone Gelée",
  T_49_META_TYP_175_I1_D: "Durée de la zone gelée en secondes",
  T_49_META_TYP_176_I0_D: "Type principal de l'arme",
  T_49_META_TYP_176_I1_D: "Sous-Type D'arme",
  T_49_META_TYP_177_I0_D: "Lorsqu'il y a un obstacle entre la caméra et l'objet à suivre, la caméra ne change pas.",
  T_49_META_TYP_177_I1_D: "Lorsqu'il y a un obstacle entre la caméra et l'objet à suivre, la caméra sera rapprochée de l'objet à suivre.",
  T_49_META_TYP_177_I2_D: "Lorsqu'il y a une occlusion entre la caméra et l'objet, l'occlusion devient translucide.",
  T_49_META_TYP_178_I0_D: "Lorsque la caméra observe un objet, l'objet proche est grand et l'objet éloigné est petit",
  T_49_META_TYP_178_I1_D: "Les objets proches et éloignés ont la même taille lorsque la caméra les observe.",
  T_49_META_TYP_184_I0_D: "L'UUID de la ressource à rendre.",
  T_49_META_TYP_185_I0_D: "Le maillage du modèle à utiliser pour le rendu",
  T_49_META_TYP_185_I1_D: "Liste des matériaux à utiliser pour le rendu",
  T_49_META_TYP_187_I0_D: "ID de L'article",
  T_49_META_TYP_190_I0_D: "Statut d'ouverture",
  T_49_META_TYP_190_I1_D: "Résultat de l'appariement",
  T_49_META_TYP_190_I10_D: "Liste des Scores 1",
  T_49_META_TYP_190_I11_D: "Liste des Scores 2",
  T_49_META_TYP_190_I12_D: "Liste des Scores 3",
  T_49_META_TYP_190_I13_D: "MVP de la Victoire",
  T_49_META_TYP_190_I14_D: "MVP de la Défaite",
  T_49_META_TYP_190_I15_D: "Afficher les Détails du Match",
  T_49_META_TYP_190_I16_D: "Afficher l'Évaluation de la Carte",
  T_49_META_TYP_190_I17_D: "Afficher le Cadeau",
  T_49_META_TYP_190_I18_D: "Afficher le Rapport",
  T_49_META_TYP_190_I19_D: "Afficher la Relecture",
  T_49_META_TYP_190_I20_D: "Afficher le Partage",
  T_49_META_TYP_190_I21_D: "Afficher le Hall",
  T_49_META_TYP_190_I22_D: "Afficher les J'aime",
  T_49_META_TYP_190_I23_D: "Afficher Ajouter un Ami",
  T_49_META_TYP_190_I24_D: "Afficher l'Économie",
  T_49_META_TYP_190_I4_D: "Équipe droite",
  T_49_META_TYP_190_I5_D: "Titres",
  T_49_META_TYP_190_I6_D: "Classement du Joueur",
  T_49_META_TYP_190_I9_D: "Titres",
  T_49_META_TYP_191_I0_D: "Portée Centrale",
  T_49_META_TYP_191_I4_D: "Durée de l'éclair central en millisecondes",
  T_49_META_TYP_191_I5_D: "Durée de l'éclair de bord en millisecondes",
  T_49_META_TYP_191_I6_D: "Commutateur D'effet De Frappe Flashbang",
  T_49_META_TYP_192_I3_D: "Durée de l'effet, en secondes",
  T_49_META_TYP_193_I1_D: "Titre du Match Gauche",
  T_49_META_TYP_193_I10_D: "Liste des Scores 1",
  T_49_META_TYP_193_I11_D: "Liste des Scores 2",
  T_49_META_TYP_193_I12_D: "Liste des Scores 3",
  T_49_META_TYP_193_I13_D: "Liste des Scores 4",
  T_49_META_TYP_193_I14_D: "Liste des Scores 5",
  T_49_META_TYP_193_I15_D: "MVP de la Victoire",
  T_49_META_TYP_193_I16_D: "MVP de la Défaite",
  T_49_META_TYP_193_I17_D: "Afficher les Détails du Match",
  T_49_META_TYP_193_I18_D: "Afficher l'Évaluation de la Carte",
  T_49_META_TYP_193_I19_D: "Afficher le Cadeau",
  T_49_META_TYP_193_I2_D: "Titre du Match Droite",
  T_49_META_TYP_193_I20_D: "Afficher le Rapport",
  T_49_META_TYP_193_I21_D: "Afficher la Relecture",
  T_49_META_TYP_193_I22_D: "Afficher le Partage",
  T_49_META_TYP_193_I23_D: "Afficher le Hall",
  T_49_META_TYP_193_I24_D: "Afficher les J'aime",
  T_49_META_TYP_193_I25_D: "Afficher Ajouter un Ami",
  T_49_META_TYP_193_I26_D: "Afficher l'Économie",
  T_49_META_TYP_193_I3_D: "Résultat du match",
  T_49_META_TYP_193_I4_D: "Classement de l'Équipe",
  T_49_META_TYP_193_I5_D: "Classement du Joueur",
  T_49_META_TYP_193_I6_D: "Position de l'équipe",
  T_49_META_TYP_193_I7_D: "Titre Principal du Score",
  T_49_META_TYP_193_I8_D: "Scores Principaux",
  T_49_META_TYP_193_I9_D: "Titres",
  T_49_META_TYP_194_I0_D: "Temps d'action de la mine, en secondes",
  T_49_META_TYP_194_I1_D: "Rayon de déclenchement",
  T_49_META_TYP_194_I2_D: "Temps nécessaire pour déclencher une mine dans son rayon d'action, en secondes",
  T_49_META_TYP_194_I3_D: "Peut être Déclenché Par Soi",
  T_49_META_TYP_194_I4_D: "Peut être Déclenché par L'équipe",
  T_49_META_TYP_194_I5_D: "Peut Être Déclenché Par Un Véhicule",
  T_49_META_TYP_194_I6_D: "Durée d'existence de la mine, qui explose automatiquement lorsqu'elle se termine, à partir du moment où elle est larguée, en secondes",
  T_49_META_TYP_194_I7_D: "Est Attaquable",
  T_49_META_TYP_194_I8_D: "Valeur de la durée de vie",
  T_49_META_TYP_195_I0_D: "Une fois",
  T_49_META_TYP_195_I2_D: "Réciprocité",
  T_49_META_TYP_197_I0_D: "Si la vague est en cours de lecture ou non",
  T_49_META_TYP_197_I1_D: "Drapeau bit",
  T_49_META_TYP_197_I2_D: "Si coché, la vague sera jouée automatiquement à la création.",
  T_49_META_TYP_198_I0_D: "L'identifiant prop de l'attachement",
  T_49_META_TYP_199_I0_D: "EP Max",
  T_49_META_TYP_199_I1_D: "Coût D'énergie",
  T_49_META_TYP_199_I10_D: "Coefficient De Dégâts De Chute",
  T_49_META_TYP_199_I11_D: "Énergie Actuelle",
  T_49_META_TYP_199_I2_D: "Coût D'augmentation De L'énergie",
  T_49_META_TYP_199_I3_D: "Coût Énergétique Pour Le Sprint",
  T_49_META_TYP_199_I4_D: "Coût D'énergie De Ruée",
  T_49_META_TYP_199_I5_D: "Vitesse Horizontale De Base",
  T_49_META_TYP_199_I6_D: "Vitesse Horizontale du Sprint",
  T_49_META_TYP_199_I7_D: "Vitesse Verticale De Base",
  T_49_META_TYP_199_I8_D: "Vitesse verticale du sprint",
  T_49_META_TYP_199_I9_D: "Distance de Ruée",
  T_49_META_TYP_200_I0_D: "ID de la zone",
  T_49_META_TYP_200_I1_D: "ID du jeu",
  T_49_META_TYP_201_I0_D: "Pourcentage de ralentissement : pourcentage de ralentissement de la vitesse de déplacement en eau libre pour les objets aquatiques",
  T_49_META_TYP_203_I0_D: "entité cible",
  T_49_META_TYP_203_I1_D: "ID du Prop",
  T_49_META_TYP_203_I10_D: "Moment où le serveur de jeu commence à faire tic-tac",
  T_49_META_TYP_203_I11_D: "Valeur de Départ",
  T_49_META_TYP_203_I12_D: "Valeur de Fin",
  T_49_META_TYP_203_I13_D: "Pourcentage de réussite",
  T_49_META_TYP_203_I4_D: "Style de Transition",
  T_49_META_TYP_203_I6_D: "Durée (s)",
  T_49_META_TYP_203_I7_D: "Inverser",
  T_49_META_TYP_203_I8_D: "Points de contrôle",
  T_49_META_TYP_203_I9_D: "Synchronisation forcée avec l'état du serveur de jeu",
  T_49_META_TYP_204_I0_D: "Hauteur De Saut Max",
  T_49_META_TYP_204_I1_D: "Pourcentage de dégâts de chute",
  T_49_META_TYP_204_I2_D: "Récupération D'énergie",
  T_49_META_TYP_204_I3_D: "Consommation d'énergie",
  T_49_META_TYP_204_I4_D: "Énergie Max",
  T_49_META_TYP_205_I0_D: "Hauteur Min. De Vol",
  T_49_META_TYP_205_I1_D: "Hauteur Minimale de Fin",
  T_49_META_TYP_205_I2_D: "Vitesse Horizontale de Vol",
  T_49_META_TYP_205_I3_D: "Vitesse Verticale De Vol",
  T_49_META_TYP_205_I4_D: "Vitesse de Chute",
  T_49_META_TYP_205_I5_D: "Vitesse de Rotation",
  T_49_META_TYP_205_I6_D: "Hauteur Max De Vol",
  T_49_META_TYP_205_I7_D: "Vitesse De Chute De La Sur-Hauteur",
  T_49_META_TYP_205_I8_D: "Changement de vitesse Accélération",
  T_49_META_TYP_206_I0_D: "Centre",
  T_49_META_TYP_206_I1_D: "Déclencheur",
  T_49_META_TYP_206_I10_D: "Angle de braquage maximal à grande vitesse",
  T_49_META_TYP_206_I11_D: "Taux de base interpolé pour l'angle de direction à grande vitesse",
  T_49_META_TYP_206_I2_D: "Vitesse de Boost",
  T_49_META_TYP_206_I3_D: "Durée du sprint, en secondes",
  T_49_META_TYP_206_I4_D: "Temps de recharge du sprint, en secondes",
  T_49_META_TYP_206_I6_D: "Cd du saut, en secondes",
  T_49_META_TYP_206_I7_D: "Cd de sprint après le skateboard, en secondes",
  T_49_META_TYP_206_I8_D: "Commutateur de CD pour Monter sur Boost",
  T_49_META_TYP_206_I9_D: "CD de montée à bord, en secondes",
  T_49_META_TYP_207_I1_D: "Index de départ",
  T_49_META_TYP_207_I2_D: "Position de Fin",
  T_49_META_TYP_207_I3_D: "ID de la tyrolienne",
  T_49_META_TYP_207_I4_D: "ID du groupe",
  T_49_META_TYP_207_I5_D: "Fin ou non",
  T_49_META_TYP_21_I0_D: "Le niveau de base de l'interface utilisateur",
  T_49_META_TYP_210_I1_D: "Décalage",
  T_49_META_TYP_210_I2_D: "Déclencheur",
  T_49_META_TYP_210_I3_D: "Attaquant",
  T_49_META_TYP_210_I4_D: "Position Initiale du Monde",
  T_49_META_TYP_210_I5_D: "Synchronisation forcée des informations de position par le serveur de jeu",
  T_49_META_TYP_211_I0_D: "Position Locale",
  T_49_META_TYP_211_I1_D: "Position dans le monde",
  T_49_META_TYP_212_I0_D: "Soi",
  T_49_META_TYP_212_I2_D: "Coordonnées de décalage",
  T_49_META_TYP_213_I0_D: "Soi",
  T_49_META_TYP_213_I2_D: "Coordonnées de décalage",
  T_49_META_TYP_215_I0_D: "Victoire",
  T_49_META_TYP_215_I1_D: "Défaite",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Égalité",
  T_49_META_TYP_218_I0_D: "Intensité",
  T_49_META_TYP_218_I1_D: "Portée",
  T_49_META_TYP_218_I2_D: "Couleur de la lumière",
  T_49_META_TYP_22_I0_D: "Affiché si on est vrai, sinon désactivé",
  T_49_META_TYP_22_I1_D: "ID préfabriqué",
  T_49_META_TYP_22_I2_D: "L'ID du plus grand contrôle actuel",
  T_49_META_TYP_22_I3_D: "Niveau de base de l'interface utilisateur",
  T_49_META_TYP_22_I4_D: "Vue du joueur",
  T_49_META_TYP_22_I5_D: "Position dans le monde",
  T_49_META_TYP_22_I6_D: "S'il se trouve ou non dans la scène",
  T_49_META_TYP_22_I7_D: "Rotation dans le système de coordonnées du monde",
  T_49_META_TYP_22_I8_D: "Zoom dans le système de coordonnées du monde",
  T_49_META_TYP_221_I0_D: "Délai de changement de vitesse, plus la valeur est grande, plus la vitesse de changement de vitesse est lente",
  T_49_META_TYP_222_I0_D: "Plus la valeur est élevée, plus le changement de vitesse est lent.",
  T_49_META_TYP_225_I0_D: "Dégâts de la tourelle",
  T_49_META_TYP_225_I1_D: "Intervalle de Dégâts (s)",
  T_49_META_TYP_225_I10_D: "Tir uniquement en angle",
  T_49_META_TYP_225_I11_D: "Taux de réduction des dégâts",
  T_49_META_TYP_225_I12_D: "Pénétration d'Armure",
  T_49_META_TYP_225_I2_D: "Précision",
  T_49_META_TYP_225_I3_D: "Portée",
  T_49_META_TYP_225_I4_D: "Vitesse Angulaire",
  T_49_META_TYP_225_I5_D: "Angle vers le Haut",
  T_49_META_TYP_225_I6_D: "Angle vers le Bas",
  T_49_META_TYP_225_I7_D: "Max. PV",
  T_49_META_TYP_225_I8_D: "Durée de Vie (s)",
  T_49_META_TYP_225_I9_D: "Max. Nombre de Tourelles",
  T_49_META_TYP_226_I0_D: "Valeur de la durée de vie de la tourelle",
  T_49_META_TYP_226_I1_D: "Activer l'Attaque",
  T_49_META_TYP_227_I0_D: "Widget simple",
  T_49_META_TYP_227_I1_D: "Widget d'image",
  T_49_META_TYP_227_I10_D: "Widget de texture",
  T_49_META_TYP_227_I11_D: "Widget de profil",
  T_49_META_TYP_227_I12_D: "Widget de bascule",
  T_49_META_TYP_227_I13_D: "Widget de pavé tactile",
  T_49_META_TYP_227_I14_D: "Widget de joystick",
  T_49_META_TYP_227_I15_D: "Widget bouton social",
  T_49_META_TYP_227_I2_D: "Widget d'étiquette",
  T_49_META_TYP_227_I3_D: "Widget de bouton",
  T_49_META_TYP_227_I4_D: "Widget d'étiquette de saisie",
  T_49_META_TYP_227_I5_D: "Panneau",
  T_49_META_TYP_227_I6_D: "Panneau de défilement",
  T_49_META_TYP_227_I7_D: "Grille",
  T_49_META_TYP_227_I8_D: "Widget de mise en page",
  T_49_META_TYP_227_I9_D: "Widget de conteneur",
  T_49_META_TYP_231_I0_D: "Récupération De Durabilité",
  T_49_META_TYP_231_I1_D: "Intervalle de temps effectif, en secondes",
  T_49_META_TYP_233_I2_D: "Délai d'expiration, en secondes",
  T_49_META_TYP_233_I4_D: "Nom de la ressource de l'icône",
  T_49_META_TYP_234_I0_D: "Temps de déclenchement, en secondes",
  T_49_META_TYP_234_I1_D: "Peut être Déclenché Par Soi",
  T_49_META_TYP_234_I10_D: "Valeur actuelle de la durée de vie",
  T_49_META_TYP_234_I2_D: "Peut être Déclenché par L'équipe",
  T_49_META_TYP_234_I3_D: "Peut Être Déclenché Par Un Véhicule",
  T_49_META_TYP_234_I4_D: "Durée en secondes",
  T_49_META_TYP_234_I5_D: "Est Attaquable",
  T_49_META_TYP_234_I6_D: "Valeur de vie",
  T_49_META_TYP_235_I0_D: "Valeur maximale de la durée de vie",
  T_49_META_TYP_235_I2_D: "Nombre Max.",
  T_49_META_TYP_237_I0_D: "Vitesse De Lancer",
  T_49_META_TYP_237_I1_D: "Vitesse De Traction Du Joueur",
  T_49_META_TYP_238_I0_D: "Couleur de spray",
  T_49_META_TYP_239_I0_D: "Vitesse initiale",
  T_49_META_TYP_239_I1_D: "Vitesse d'accélération (par exemple, gravité)",
  T_49_META_TYP_24_I0_D: "Mêlée",
  T_49_META_TYP_24_I1_D: "Arme",
  T_49_META_TYP_24_I10_D: "Dégâts des coups de l'Airdrop, dégâts des suicides des monstres",
  T_49_META_TYP_24_I11_D: "Dégâts De Brûlure Par Explosion De Véhicule",
  T_49_META_TYP_24_I12_D: "Explosion de Fût d’Huile",
  T_49_META_TYP_24_I13_D: "Arme de Type Missile",
  T_49_META_TYP_24_I14_D: "Monstre",
  T_49_META_TYP_24_I15_D: "Zone De Dégâts",
  T_49_META_TYP_24_I17_D: "Compétence du Personnage",
  T_49_META_TYP_24_I2_D: "Attaque Par Lancer",
  T_49_META_TYP_24_I3_D: "Zone de sécurité",
  T_49_META_TYP_24_I4_D: "Véhicule",
  T_49_META_TYP_24_I5_D: "Chute",
  T_49_META_TYP_24_I6_D: "Zone de Mort",
  T_49_META_TYP_24_I7_D: "Quitter",
  T_49_META_TYP_24_I8_D: "Déconnexion",
  T_49_META_TYP_24_I9_D: "Explosion de Véhicule",
  T_49_META_TYP_241_I0_D: "Vitesse de traction",
  T_49_META_TYP_241_I1_D: "Vitesse d'oscillation",
  T_49_META_TYP_241_I2_D: "Activation du bouton de traction",
  T_49_META_TYP_241_I3_D: "Activation du bouton de pivotement",
  T_49_META_TYP_241_I4_D: "Point d'ancrage du mouvement",
  T_49_META_TYP_241_I5_D: "Accélération de Sortie de Balancement",
  T_49_META_TYP_242_I2_D: "Effet Gauche Actif",
  T_49_META_TYP_242_I3_D: "Effet Droit Actif",
  T_49_META_TYP_242_I4_D: "Ligne Centrale Active",
  T_49_META_TYP_242_I5_D: "Valeur",
  T_49_META_TYP_242_I7_D: "Position de l'interface utilisateur, seules les composantes XY sont valables",
  T_49_META_TYP_242_I8_D: "Position de la médiane [0,1]",
  T_49_META_TYP_243_I0_D: "Coffre",
  T_49_META_TYP_243_I1_D: "Usure Du Bas",
  T_49_META_TYP_243_I2_D: "Chaussures",
  T_49_META_TYP_243_I3_D: "Peinture De Visage",
  T_49_META_TYP_243_I4_D: "Coiffure",
  T_49_META_TYP_243_I5_D: "Combinaison",
  T_49_META_TYP_243_I6_D: "Peinture De Visage",
  T_49_META_TYP_244_I0_D: "Contenu du texte à afficher",
  T_49_META_TYP_244_I10_D: "Vous pouvez voir la liste des joueurs de cette entité.",
  T_49_META_TYP_244_I11_D: "Niveau d'affichage",
  T_49_META_TYP_244_I2_D: "Suivre cible",
  T_49_META_TYP_244_I3_D: "Si la profondeur est ignorée, le texte peut être affiché à travers le mur, sinon cela ne fonctionnera pas.",
  T_49_META_TYP_244_I4_D: "Est Un Panneau D'affichage",
  T_49_META_TYP_244_I5_D: "Si la valeur est vraie, lorsque la position est en dehors de l'écran, le texte sera affiché à l'intérieur de l'écran.",
  T_49_META_TYP_244_I6_D: "Style De Police",
  T_49_META_TYP_244_I7_D: "Type de police",
  T_49_META_TYP_244_I8_D: "Taille de la police",
  T_49_META_TYP_245_I0_D: "Chemin de ressource d'effet",
  T_49_META_TYP_245_I11_D: "Couches d'affichage",
  T_49_META_TYP_245_I3_D: "Lorsque la profondeur est ignorée, l'affichage peut se faire à travers le mur, sinon il ne fonctionnera pas.",
  T_49_META_TYP_245_I4_D: "Lorsqu'il est défini sur true, lorsque la position est en dehors de l'écran, il sera affiché à l'intérieur de l'écran.",
  T_49_META_TYP_245_I5_D: "Est Un Panneau D'affichage",
  T_49_META_TYP_245_I6_D: "Type De Rendu",
  T_49_META_TYP_245_I7_D: "Largeur",
  T_49_META_TYP_246_I0_D: "Orange",
  T_49_META_TYP_246_I1_D: "Violet",
  T_49_META_TYP_246_I2_D: "Rouge",
  T_49_META_TYP_246_I3_D: "Vert",
  T_49_META_TYP_246_I4_D: "Bleu",
  T_49_META_TYP_247_I1_D: "Sprint",
  T_49_META_TYP_247_I14_D: "Émote",
  T_49_META_TYP_247_I15_D: "Discussion rapide",
  T_49_META_TYP_247_I16_D: "Pickups",
  T_49_META_TYP_247_I17_D: "Affichage De La Discussion Rapide",
  T_49_META_TYP_247_I18_D: "HP",
  T_49_META_TYP_247_I19_D: "EP",
  T_49_META_TYP_247_I2_D: "Attaque",
  T_49_META_TYP_247_I20_D: "Armure",
  T_49_META_TYP_247_I21_D: "Recharger",
  T_49_META_TYP_247_I22_D: "Bouton de changement rapide",
  T_49_META_TYP_247_I23_D: "Bouton de haut-parleur du transporteur",
  T_49_META_TYP_247_I24_D: "Bouton d'activation/désactivation de la voix (microphone)",
  T_49_META_TYP_247_I25_D: "Bouton d'activation/désactivation du marqueur",
  T_49_META_TYP_247_I27_D: "Bouton d'activation/désactivation du signal réseau",
  T_49_META_TYP_247_I28_D: "Compétence Active",
  T_49_META_TYP_247_I29_D: "Réticule",
  T_49_META_TYP_247_I3_D: "Saut",
  T_49_META_TYP_247_I30_D: "Compétence Passive",
  T_49_META_TYP_247_I4_D: "Conseils de mise à mort",
  T_49_META_TYP_247_I5_D: "Emplacement d'arme",
  T_49_META_TYP_247_I6_D: "Mini-Carte",
  T_49_META_TYP_247_I7_D: "IU du sac à dos",
  T_49_META_TYP_247_I8_D: "Articles Médicaux",
  T_49_META_TYP_247_I9_D: "Affiché si True, sinon désactivé",
  T_49_META_TYP_249_I3_D: "Armes de démolition",
  T_49_META_TYP_249_I5_D: "Arme lourde",
  T_49_META_TYP_249_I8_D: "Bombe de congélation",
  T_49_META_TYP_249_I9_D: "Grenade Factice",
  T_49_META_TYP_25_I0_D: "Index de l'étape en cours, correspondant à l'index dans l'éditeur de flux",
  T_49_META_TYP_25_I1_D: "Heure de début de l'étape en cours, en ms",
  T_49_META_TYP_25_I2_D: "Heure de fin de l'étape en cours, en ms",
  T_49_META_TYP_25_I3_D: "Durée de l'étape en cours, en ms",
  T_49_META_TYP_250_I1_D: "Couleur de l'effet spécial, RGBA quatre canaux, plage de valeurs d'un canal 0~255, stockée dans un Int32.",
  T_49_META_TYP_250_I3_D: "Type de texture VFX",
  T_49_META_TYP_250_I4_D: "Alpha Diffusé",
  T_49_META_TYP_2500_I1_D: "Est Un Point D'apparition Par Défaut",
  T_49_META_TYP_2500_I3_D: "Si un joueur est déjà né ou non dans la région du lieu de naissance.",
  T_49_META_TYP_2500_I4_D: "Les coordonnées de l'emplacement du point de naissance actuellement assignable.",
  T_49_META_TYP_2502_I0_D: "S'il s'agit d'un déclencheur de mort, quand ce n'est pas un déclencheur de mort, c'est un déclencheur d'invincibilité. (Il s'agit d'un problème hérité d'OB32, veuillez diviser la fonction à l'avenir !)",
  T_49_META_TYP_2502_I1_D: "Afficher ou non la bordure du trigger, true pour l'afficher",
  T_49_META_TYP_2503_I0_D: "ID de checkpoint",
  T_49_META_TYP_2503_I2_D: "Emplacement des points de contrôle",
  T_49_META_TYP_2507_I0_D: "Le camp auquel appartient la tour, si c'est le même que celui du joueur, elle ne l'attaquera pas.",
  T_49_META_TYP_2507_I1_D: "PV",
  T_49_META_TYP_2507_I10_D: "ID de l'objet",
  T_49_META_TYP_2507_I2_D: "PV Max.",
  T_49_META_TYP_2507_I3_D: "Les dégâts de l'attaque, combien de dégâts une seule attaque peut faire au joueur.",
  T_49_META_TYP_2507_I4_D: "L'intervalle entre les attaques, en secondes.",
  T_49_META_TYP_2507_I5_D: "Les attaques peuvent être effectuées dans un rayon autour du centre de la tour.",
  T_49_META_TYP_2507_I6_D: "Le taux de réduction des dégâts, un nombre décimal inférieur à 1, les dégâts finaux sont les dégâts multipliés par (1 - taux de réduction des dégâts).",
  T_49_META_TYP_2507_I7_D: "Cible d'attaque",
  T_49_META_TYP_2507_I8_D: "Angle",
  T_49_META_TYP_2507_I9_D: "État du mini-sentry",
  T_49_META_TYP_2508_I0_D: "Combien de zombies seront créés dans chaque vague ?",
  T_49_META_TYP_2508_I1_D: "Combien de vagues de zombies seront créées au total ?",
  T_49_META_TYP_2508_I2_D: "S'il y a lieu de faire apparaître des zombies en continu, mais il y aura une limite supérieure au même écran.",
  T_49_META_TYP_2508_I3_D: "Combien de vagues seront créées dans la vague actuelle ?",
  T_49_META_TYP_2508_I5_D: "Quel type de zombies est apparu dans la vague actuelle ?",
  T_49_META_TYP_2508_I6_D: "Si l'IA laisse tomber de l'équipement ou des objets lorsqu'elle meurt.",
  T_49_META_TYP_2508_I7_D: "Temps de spawn de départ (s)",
  T_49_META_TYP_2508_I8_D: "L'intervalle de temps entre la vague suivante et la vague précédente.",
  T_49_META_TYP_2509_I0_D: "Le nombre de corps d'unité qui seront générés dans chaque vague",
  T_49_META_TYP_2509_I1_D: "Combien de vagues de générateurs d'unités seront générées au total ?",
  T_49_META_TYP_2509_I2_D: "Combien de vagues sont actuellement générées",
  T_49_META_TYP_2509_I4_D: "Quelle entité sera utilisée comme modèle pour générer chaque vague ?",
  T_49_META_TYP_2509_I5_D: "Quand les unités commenceront à être générées",
  T_49_META_TYP_2509_I6_D: "Si elles seront générées de façon continue ou non, mais il y aura une limite supérieure pour le même écran",
  T_49_META_TYP_2509_I7_D: "L'intervalle de temps entre la vague suivante et la vague précédente.",
  T_49_META_TYP_2509_I8_D: "Le prefabID du modèle",
  T_49_META_TYP_2510_I0_D: "Nombre de Points D'apparition",
  T_49_META_TYP_252_I1_D: "Icône gauche",
  T_49_META_TYP_252_I2_D: "Texte gauche",
  T_49_META_TYP_252_I3_D: "Score gauche",
  T_49_META_TYP_252_I5_D: "Icône droite",
  T_49_META_TYP_252_I6_D: "Texte droite",
  T_49_META_TYP_252_I7_D: "Score droite",
  T_49_META_TYP_252_I8_D: "Progression [0,1]",
  T_49_META_TYP_253_I0_D: "Icône de sélection",
  T_49_META_TYP_253_I1_D: "Texte",
  T_49_META_TYP_253_I2_D: "Effet actif",
  T_49_META_TYP_253_I3_D: "Position de l'interface utilisateur",
  T_49_META_TYP_254_I1_D: "Par exemple, 1.25 signifie 1.25 fois la vitesse normale.",
  T_49_META_TYP_254_I2_D: "Couleur",
  T_49_META_TYP_256_I0_D: "Complètement immobile. Performance minimale",
  T_49_META_TYP_256_I1_D: "Application d'une force normale. Performance la plus coûteuse",
  T_49_META_TYP_256_I2_D: "Le mouvement peut être contrôlé par des scripts et peut être considéré comme une masse infinie.",
  T_49_META_TYP_257_I0_D: "Fonctions des différents types de corps rigides",
  T_49_META_TYP_257_I1_D: "Utilisez la Gravité",
  T_49_META_TYP_257_I2_D: "Masse (kg), la masse effective minimale est de 0,001kg, si elle est de 0, il s'agit d'une masse infinie qui ne bougera pas sous l'effet d'une force.",
  T_49_META_TYP_257_I3_D: "Position du centre de gravité, système de coordonnées locales",
  T_49_META_TYP_257_I4_D: "Vitesse linéaire du mouvement du corps rigide",
  T_49_META_TYP_257_I5_D: "Vitesse angulaire du mouvement du corps rigide",
  T_49_META_TYP_257_I6_D: "Coefficient de décroissance naturelle de la vitesse linéaire, plus le coefficient est grand, plus la décroissance de la vitesse est rapide.",
  T_49_META_TYP_257_I7_D: "Coefficient de décroissance naturelle de la vitesse angulaire, plus le coefficient est grand, plus la vitesse diminue rapidement.",
  T_49_META_TYP_257_I8_D: "Les contraintes imposées au corps rigide, une collection de RigidbodyConstrainType.",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Arrière-plan",
  T_49_META_TYP_259_I1_D: "Texte",
  T_49_META_TYP_259_I2_D: "Position de l'interface utilisateur",
  T_49_META_TYP_259_I4_D: "Couleur du texte",
  T_49_META_TYP_260_I0_D: "Icône de sélection",
  T_49_META_TYP_260_I1_D: "Couleur de la barre de progression",
  T_49_META_TYP_260_I2_D: "Valeur",
  T_49_META_TYP_260_I3_D: "Vitesse en m/s",
  T_49_META_TYP_260_I4_D: "Affichage ou non des effets spéciaux",
  T_49_META_TYP_260_I5_D: "Position de l'interface utilisateur [0,1].",
  T_49_META_TYP_260_I6_D: "Progression initiale de la compétence, valeur [0, 1], la progression sera synchronisée avec la progression actuelle immédiatement après la création de l'interface utilisateur.",
  T_49_META_TYP_260_I7_D: "Couleur de l'effet",
  T_49_META_TYP_260_I8_D: "Définir la valeur d'échelle de l'objet",
  T_49_META_TYP_265_I1_D: "Remplissage ou non de l'arrière-plan",
  T_49_META_TYP_265_I2_D: "Nom de Fond",
  T_49_META_TYP_265_I3_D: "Couleur de fond",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Type de découpe",
  T_49_META_TYP_265_I7_D: "Le type de masque est le nom de l'image sélectionnée pour le masquage",
  T_49_META_TYP_265_I8_D: "Unité d'adoucissement des bords",
  T_49_META_TYP_267_I0_D: "Point de départ du défilement, par défaut le coin supérieur gauche.",
  T_49_META_TYP_267_I1_D: "Prise en charge de plusieurs directions de défilement",
  T_49_META_TYP_267_I10_D: "Barre Horizontale",
  T_49_META_TYP_267_I11_D: "Afficher la position",
  T_49_META_TYP_267_I2_D: "Composant de glissement dans la direction XY",
  T_49_META_TYP_267_I3_D: "Prise en charge de plusieurs effets de glissement",
  T_49_META_TYP_267_I4_D: "Facteur de défilement, plus la valeur est grande, plus le défilement est rapide.",
  T_49_META_TYP_267_I5_D: "Facteur d'inertie : plus la valeur est élevée, plus l'inertie du défilement est importante.",
  T_49_META_TYP_267_I6_D: "Si le déplacement est limité ou non à la fenêtre de visualisation, la case est cochée par défaut.",
  T_49_META_TYP_267_I7_D: "Si la case est cochée, le glissement commencera à se déplacer lentement, si la case n'est pas cochée, le glissement commencera à se déplacer à la vitesse de la souris.",
  T_49_META_TYP_267_I8_D: "Le déplacement se termine lorsqu'il entre dans la fenêtre de visualisation.",
  T_49_META_TYP_267_I9_D: "Barre Verticale",
  T_49_META_TYP_268_I0_D: "Par défaut",
  T_49_META_TYP_268_I1_D: "Fermer",
  T_49_META_TYP_268_I2_D: "Afficher",
  T_49_META_TYP_269_I0_D: "Propriétaire",
  T_49_META_TYP_269_I1_D: "ID de la tenue",
  T_49_META_TYP_269_I2_D: "ID du couvre-chef",
  T_49_META_TYP_269_I3_D: "Identifiant du visage",
  T_49_META_TYP_269_I4_D: "ID Maquillage",
  T_49_META_TYP_269_I5_D: "ID du haut du corps",
  T_49_META_TYP_269_I6_D: "ID du bas",
  T_49_META_TYP_269_I7_D: "ID Chaussures",
  T_49_META_TYP_272_I0_D: "Féminin",
  T_49_META_TYP_272_I1_D: "Masculin",
  T_49_META_TYP_273_I0_D: "Coordonnées mondiales du centre de la mini-carte",
  T_49_META_TYP_273_I1_D: "Taille de la mini-carte, même largeur et même hauteur",
  T_49_META_TYP_273_I2_D: "Activer ou désactiver le mode d'affichage de la carte de profondeur de la mini-carte",
  T_49_META_TYP_274_I1_D: "Taille du zoom",
  T_49_META_TYP_274_I4_D: "Niveau d'affichage de l'icône",
  T_49_META_TYP_275_I0_D: "Détartrage Osseux",
  T_49_META_TYP_275_I1_D: "Coordonnées mondiales des nœuds osseux",
  T_49_META_TYP_276_I0_D: "Tête",
  T_49_META_TYP_276_I1_D: "Bras Gauche",
  T_49_META_TYP_276_I2_D: "Main Gauche",
  T_49_META_TYP_276_I3_D: "Bras Droit",
  T_49_META_TYP_276_I4_D: "Main Droite",
  T_49_META_TYP_276_I5_D: "Torse",
  T_49_META_TYP_276_I6_D: "Jambe Gauche",
  T_49_META_TYP_276_I7_D: "Pied Gauche",
  T_49_META_TYP_276_I8_D: "Jambe Droite",
  T_49_META_TYP_276_I9_D: "Pied Droit",
  T_49_META_TYP_277_I1_D: "Distance pour la détection des rayons de la caméra",
  T_49_META_TYP_277_I2_D: "Masque de la couche de collision pour la détection des rayons de la caméra",
  T_49_META_TYP_277_I3_D: "Décalage de la position du bouton",
  T_49_META_TYP_277_I4_D: "Icône ID de la ressource",
  T_49_META_TYP_277_I5_D: "Taille de la zone de clic",
  T_49_META_TYP_277_I6_D: "Affichage ou non d'objets au point cible",
  T_49_META_TYP_277_I7_D: "Objets affichés au point cible",
  T_49_META_TYP_278_I0_D: "Entité cible pour la génération des pixels de la carte",
  T_49_META_TYP_28_I0_D: "Possibilité ou non de réinitialiser l'équipe à chaque tour",
  T_49_META_TYP_280_I0_D: "Rayon de la sphère",
  T_49_META_TYP_281_I0_D: "Le rayon des hémisphères aux extrémités de la capsule.",
  T_49_META_TYP_29_I0_D: "Sphère",
  T_49_META_TYP_29_I1_D: "Faisceau de Lumière",
  T_49_META_TYP_29_I10_D: "Pilier de lumière sous les pieds, maintenant utilisé pour le feedback lors de l'entrée dans la ligne d'arrivée.",
  T_49_META_TYP_29_I11_D: "Congélation",
  T_49_META_TYP_29_I12_D: "Lumière",
  T_49_META_TYP_29_I13_D: "Courant Ascendant",
  T_49_META_TYP_29_I14_D: "Explosion de Gaz",
  T_49_META_TYP_29_I15_D: "Cacheur Éliminé",
  T_49_META_TYP_29_I16_D: "Carnage",
  T_49_META_TYP_29_I17_D: "Mort de Clone",
  T_49_META_TYP_29_I18_D: "Retour d’Information de Tir",
  T_49_META_TYP_29_I19_D: "Mort de Clone",
  T_49_META_TYP_29_I2_D: "Boom",
  T_49_META_TYP_29_I20_D: "Cloner",
  T_49_META_TYP_29_I21_D: "Portail",
  T_49_META_TYP_29_I22_D: "Fumée de Grenade Éclairante",
  T_49_META_TYP_29_I23_D: "Boule de Feu",
  T_49_META_TYP_29_I24_D: "Brûlage en Boucle",
  T_49_META_TYP_29_I25_D: "Gaz Toxique",
  T_49_META_TYP_29_I26_D: "Cœur",
  T_49_META_TYP_29_I29_D: "Porte",
  T_49_META_TYP_29_I30_D: "Feux d’Artifice",
  T_49_META_TYP_29_I31_D: "Effet des Chaussures de Course",
  T_49_META_TYP_29_I32_D: "VFX d’Explosion",
  T_49_META_TYP_29_I33_D: "VFX De Point D'apparition",
  T_49_META_TYP_29_I34_D: "VFX Laser",
  T_49_META_TYP_29_I35_D: "VFX de Lancement de Compétence",
  T_49_META_TYP_29_I36_D: "VFX De Balles",
  T_49_META_TYP_29_I37_D: "VFX d'Impact de Balles",
  T_49_META_TYP_29_I38_D: "VFX de Tir",
  T_49_META_TYP_29_I39_D: "VFX de Compétence",
  T_49_META_TYP_29_I40_D: "Aura",
  T_49_META_TYP_29_I41_D: "Bulles",
  T_49_META_TYP_29_I42_D: "Fumée et Poussière",
  T_49_META_TYP_29_I43_D: "Débris Volants",
  T_49_META_TYP_29_I44_D: "Lignes",
  T_49_META_TYP_29_I45_D: "Clignotement",
  T_49_META_TYP_29_I47_D: "Particules Montantes",
  T_49_META_TYP_29_I48_D: "Fumée",
  T_49_META_TYP_29_I49_D: "Talisman",
  T_49_META_TYP_29_I50_D: "Zone Gelée",
  T_49_META_TYP_29_I51_D: "Brouillard",
  T_49_META_TYP_29_I52_D: "Flocon de Neige",
  T_49_META_TYP_29_I53_D: "Fire",
  T_49_META_TYP_29_I54_D: "Faisceau Lumineux",
  T_49_META_TYP_29_I55_D: "Diffusion de Gaz Toxique",
  T_49_META_TYP_29_I56_D: "Gaz Toxique",
  T_49_META_TYP_29_I57_D: "Flammes d’Explosion",
  T_49_META_TYP_29_I58_D: "Effet Lumineux",
  T_49_META_TYP_29_I59_D: "Étoile",
  T_49_META_TYP_29_I6_D: "Halo des pieds",
  T_49_META_TYP_29_I60_D: "Bonfire Flamboyant",
  T_49_META_TYP_29_I61_D: "Éclaboussure d’Eau",
  T_49_META_TYP_29_I62_D: "Choc Électrique",
  T_49_META_TYP_29_I63_D: "VFX d’Encre",
  T_49_META_TYP_29_I64_D: "VFX De Trou Noir",
  T_49_META_TYP_29_I65_D: "VFX D'explosion De Trou Noir",
  T_49_META_TYP_29_I66_D: "Effets visuels de boule de cristal",
  T_49_META_TYP_29_I67_D: "Effet de balle laser",
  T_49_META_TYP_29_I68_D: "Effets de traînée",
  T_49_META_TYP_29_I69_D: "Nuages",
  T_49_META_TYP_29_I7_D: "Marqueur au Sol",
  T_49_META_TYP_29_I8_D: "Fumée",
  T_49_META_TYP_29_I9_D: "Explosion de Talisman",
  T_49_META_TYP_290_I0_D: "Intervalle de rafraîchissement, plus le nombre est grand, plus le rafraîchissement est lent, en millisecondes.",
  T_49_META_TYP_290_I1_D: "Permet d'activer ou non le débogage",
  T_49_META_TYP_291_I0_D: "NœudCondition",
  T_49_META_TYP_291_I1_D: "NœudAction",
  T_49_META_TYP_293_I0_D: "ID De L'arbre De Comportement",
  T_49_META_TYP_293_I1_D: "Cible d'attachement",
  T_49_META_TYP_294_I1_D: "Type de mise en page",
  T_49_META_TYP_294_I10_D: "Type de Tri",
  T_49_META_TYP_294_I2_D: "Origine du Contenu",
  T_49_META_TYP_294_I3_D: "Sens de l'alignement",
  T_49_META_TYP_294_I4_D: "Largeur et hauteur de la grille des sous-éléments",
  T_49_META_TYP_294_I5_D: "Espace entre Cellules",
  T_49_META_TYP_294_I6_D: "Contrainte",
  T_49_META_TYP_294_I7_D: "Nombre de Contraintes",
  T_49_META_TYP_294_I8_D: "Décalage vertical",
  T_49_META_TYP_294_I9_D: "Décalage horizontal",
  T_49_META_TYP_295_I2_D: "Durée (s)",
  T_49_META_TYP_296_I1_D: "Longueur du Clip",
  T_49_META_TYP_297_I0_D: "Objets liés",
  T_49_META_TYP_297_I4_D: "ID de Ressource",
  T_49_META_TYP_298_I0_D: "Par défaut",
  T_49_META_TYP_298_I2_D: "Une fois",
  T_49_META_TYP_30_I0_D: "Carré",
  T_49_META_TYP_30_I1_D: "Quadrilatère",
  T_49_META_TYP_30_I10_D: "Flèche",
  T_49_META_TYP_30_I11_D: "Appel",
  T_49_META_TYP_30_I12_D: "Pierre",
  T_49_META_TYP_30_I13_D: "Ciseaux",
  T_49_META_TYP_30_I14_D: "Papier",
  T_49_META_TYP_30_I15_D: "J'aime",
  T_49_META_TYP_30_I16_D: "Droit",
  T_49_META_TYP_30_I17_D: "Incorrect",
  T_49_META_TYP_30_I18_D: "Plus",
  T_49_META_TYP_30_I19_D: "Éclair",
  T_49_META_TYP_30_I2_D: "Trapèze À Angle Droit",
  T_49_META_TYP_30_I20_D: "Coeur",
  T_49_META_TYP_30_I21_D: "Étoile",
  T_49_META_TYP_30_I22_D: "Lune",
  T_49_META_TYP_30_I23_D: "Soleil",
  T_49_META_TYP_30_I24_D: "Lunettes",
  T_49_META_TYP_30_I25_D: "Clé",
  T_49_META_TYP_30_I26_D: "Trophée",
  T_49_META_TYP_30_I27_D: "Drapeau",
  T_49_META_TYP_30_I28_D: "Sabliers",
  T_49_META_TYP_30_I29_D: "Dossier",
  T_49_META_TYP_30_I3_D: "Trapèze",
  T_49_META_TYP_30_I30_D: "Dossier ouvert",
  T_49_META_TYP_30_I31_D: "Maison",
  T_49_META_TYP_30_I32_D: "Repos",
  T_49_META_TYP_30_I33_D: "Actualiser",
  T_49_META_TYP_30_I34_D: "Boucle",
  T_49_META_TYP_30_I35_D: "Loupe",
  T_49_META_TYP_30_I36_D: "Poubelle",
  T_49_META_TYP_30_I37_D: "Retour",
  T_49_META_TYP_30_I38_D: "Diamant",
  T_49_META_TYP_30_I39_D: "Bouée",
  T_49_META_TYP_30_I4_D: "Hexagone",
  T_49_META_TYP_30_I40_D: "Argent",
  T_49_META_TYP_30_I41_D: "Verrouiller",
  T_49_META_TYP_30_I42_D: "Paramètres",
  T_49_META_TYP_30_I43_D: "Quitter",
  T_49_META_TYP_30_I44_D: "Dialogue",
  T_49_META_TYP_30_I45_D: "Réticule",
  T_49_META_TYP_30_I46_D: "Armes",
  T_49_META_TYP_30_I47_D: "Épée",
  T_49_META_TYP_30_I48_D: "Explosion",
  T_49_META_TYP_30_I49_D: "Viser",
  T_49_META_TYP_30_I5_D: "Cercles",
  T_49_META_TYP_30_I50_D: "Croix",
  T_49_META_TYP_30_I51_D: "Défense",
  T_49_META_TYP_30_I52_D: "Zombie",
  T_49_META_TYP_30_I53_D: "Recyclage",
  T_49_META_TYP_30_I54_D: "Cadeau",
  T_49_META_TYP_30_I55_D: "Vêtements",
  T_49_META_TYP_30_I56_D: "Jeu",
  T_49_META_TYP_30_I57_D: "Position",
  T_49_META_TYP_30_I58_D: "Magasin",
  T_49_META_TYP_30_I59_D: "Sortie",
  T_49_META_TYP_30_I6_D: "Triangle",
  T_49_META_TYP_30_I60_D: "Avertissement",
  T_49_META_TYP_30_I61_D: "Texte",
  T_49_META_TYP_30_I62_D: "Objets chronométrés",
  T_49_META_TYP_30_I63_D: "Cloche",
  T_49_META_TYP_30_I64_D: "Animal",
  T_49_META_TYP_30_I65_D: "Bombe",
  T_49_META_TYP_30_I66_D: "Réparation",
  T_49_META_TYP_30_I67_D: "Visage souriant",
  T_49_META_TYP_30_I68_D: "Haut-Parleur",
  T_49_META_TYP_30_I7_D: "Point d'exclamation",
  T_49_META_TYP_30_I70_D: "Couronne",
  T_49_META_TYP_30_I71_D: "Bataille",
  T_49_META_TYP_30_I72_D: "Guilde",
  T_49_META_TYP_30_I73_D: "Battement de cœur",
  T_49_META_TYP_30_I74_D: "Musique",
  T_49_META_TYP_30_I75_D: "Véhicule",
  T_49_META_TYP_30_I76_D: "Arme de mêlée",
  T_49_META_TYP_30_I77_D: "Pistolet",
  T_49_META_TYP_30_I78_D: "Fusil",
  T_49_META_TYP_30_I79_D: "Fusil Tireur D'élite",
  T_49_META_TYP_30_I8_D: "Point d'interrogation",
  T_49_META_TYP_30_I80_D: "Shotgun",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Arme de Guérison",
  T_49_META_TYP_30_I83_D: "Briser L'armure",
  T_49_META_TYP_30_I84_D: "Tir à la tête",
  T_49_META_TYP_30_I85_D: "Compétence 1",
  T_49_META_TYP_30_I86_D: "Compétence 2",
  T_49_META_TYP_30_I87_D: "Compétence 3",
  T_49_META_TYP_30_I88_D: "Compétence 4",
  T_49_META_TYP_30_I89_D: "Compétence 5",
  T_49_META_TYP_30_I9_D: "Marque",
  T_49_META_TYP_30_I90_D: "Compétence 6",
  T_49_META_TYP_30_I91_D: "Compétence 7",
  T_49_META_TYP_30_I92_D: "Compétence 8",
  T_49_META_TYP_30_I93_D: "Compétence 9",
  T_49_META_TYP_30_I94_D: "Compétence 10",
  T_49_META_TYP_300_I0_D: "ID de Ressource",
  T_49_META_TYP_300_I2_D: "Rotation",
  T_49_META_TYP_300_I3_D: "Entité créée",
  T_49_META_TYP_301_I1_D: "Auto-destruction",
  T_49_META_TYP_301_I2_D: "Attaque Rapide",
  T_49_META_TYP_301_I3_D: "Onde De Choc",
  T_49_META_TYP_301_I4_D: "Attaque Du Vent",
  T_49_META_TYP_301_I5_D: "Attaque sautante",
  T_49_META_TYP_301_I6_D: "Levée De Bouclier",
  T_49_META_TYP_301_I7_D: "Bouclier Brisé",
  T_49_META_TYP_302_I5_D: "Sac à dos",
  T_49_META_TYP_302_I7_D: "Planche à roulettes, Camouflage ....",
  T_49_META_TYP_303_I0_D: "Ajouter Max. HP du Joueur",
  T_49_META_TYP_303_I1_D: "Restaure les HP du joueur en continu",
  T_49_META_TYP_305_I0_D: "Terminer",
  T_49_META_TYP_305_I1_D: "En cours",
  T_49_META_TYP_307_I0_D: "Exp par dégât",
  T_49_META_TYP_307_I1_D: "Exp Par Mile Parcouru",
  T_49_META_TYP_307_I2_D: "Exp par seconde",
  T_49_META_TYP_307_I3_D: "Exp De Puce",
  T_49_META_TYP_307_I4_D: "Charge max.",
  T_49_META_TYP_308_I0_D: "Créateur de gel",
  T_49_META_TYP_31_I0_D: "Explosion de grenade",
  T_49_META_TYP_31_I1_D: "Son du pistolet",
  T_49_META_TYP_31_I10_D: "Son des dommages causés par les coups",
  T_49_META_TYP_31_I11_D: "Son de l'amélioration",
  T_49_META_TYP_31_I12_D: "Effet sonore du coup de faiblesse",
  T_49_META_TYP_31_I13_D: "Effet sonore d'un pas du joueur",
  T_49_META_TYP_31_I14_D: "Son de réparation de l'équipement",
  T_49_META_TYP_31_I15_D: "Son de la réparation de l'équipement",
  T_49_META_TYP_31_I16_D: "Effet sonore de l'absence ou de la perte",
  T_49_META_TYP_31_I17_D: "Son de rappel",
  T_49_META_TYP_31_I18_D: "Son de l'abandon du ballon de football",
  T_49_META_TYP_31_I19_D: "Effet sonore des applaudissements",
  T_49_META_TYP_31_I2_D: "Beep Du Compte À Rebours",
  T_49_META_TYP_31_I20_D: "Bruit d'alerte à la bombe",
  T_49_META_TYP_31_I21_D: "Effet sonore de la bombe avant l'explosion",
  T_49_META_TYP_31_I22_D: "Effet sonore de l'apparition du chasseur",
  T_49_META_TYP_31_I23_D: "Effet sonore de l'annonce finale",
  T_49_META_TYP_31_I24_D: "Effet sonore de la boîte de recharge",
  T_49_META_TYP_31_I25_D: "Effet sonore de l'accélérateur",
  T_49_META_TYP_31_I26_D: "Son de disparition",
  T_49_META_TYP_31_I27_D: "Effets visuels",
  T_49_META_TYP_31_I28_D: "Insectes nocturnes",
  T_49_META_TYP_31_I29_D: "Effet sonore de percussion sourde",
  T_49_META_TYP_31_I3_D: "Tap interface",
  T_49_META_TYP_31_I30_D: "Effet sonore de réponse",
  T_49_META_TYP_31_I31_D: "Effet sonore de la découverte surprise",
  T_49_META_TYP_31_I32_D: "Effet sonore des fantômes qui jouent",
  T_49_META_TYP_31_I33_D: "Effet sonore de début de scène",
  T_49_META_TYP_31_I34_D: "Effet sonore Zombie",
  T_49_META_TYP_31_I35_D: "Effet sonore d'effroi",
  T_49_META_TYP_31_I36_D: "Effet sonore de transformation",
  T_49_META_TYP_31_I37_D: "Son de battement de cœur rapide",
  T_49_META_TYP_31_I38_D: "Bruit de battement de cœur moyen",
  T_49_META_TYP_31_I39_D: "Effet sonore de battements de cœur lents",
  T_49_META_TYP_31_I4_D: "Femme criant sur un coup",
  T_49_META_TYP_31_I40_D: "Effet sonore de la ruée",
  T_49_META_TYP_31_I41_D: "Son de clic",
  T_49_META_TYP_31_I42_D: "Son de récupération des compétences",
  T_49_META_TYP_31_I43_D: "Effets sonores de la participation au jeu",
  T_49_META_TYP_31_I44_D: "Son de l'écho du mécanisme",
  T_49_META_TYP_31_I45_D: "Effet sonore Mosquito",
  T_49_META_TYP_31_I46_D: "Effet sonore de Clank 1",
  T_49_META_TYP_31_I47_D: "Effet sonore de Clank 2",
  T_49_META_TYP_31_I48_D: "Effet sonore de l'ouverture du mécanisme",
  T_49_META_TYP_31_I49_D: "Effet sonore Charge 1",
  T_49_META_TYP_31_I5_D: "Homme criant sur coup",
  T_49_META_TYP_31_I50_D: "Effet sonore des bruits de pas",
  T_49_META_TYP_31_I51_D: "Effet sonore Mission Success 1",
  T_49_META_TYP_31_I52_D: "Effet sonore Danger Tone 1",
  T_49_META_TYP_31_I53_D: "Effet sonore de la tonalité de danger 2",
  T_49_META_TYP_31_I54_D: "Effet sonore du compte à rebours 3",
  T_49_META_TYP_31_I55_D: "Effet sonore Show Tips",
  T_49_META_TYP_31_I56_D: "Effet sonore du croassement d'un corbeau",
  T_49_META_TYP_31_I57_D: "Effet sonore de la téléportation dans la mauvaise zone avec un point de téléportation",
  T_49_META_TYP_31_I58_D: "Effet sonore de la téléportation dans la bonne zone avec un point de téléportation",
  T_49_META_TYP_31_I59_D: "Effet sonore de la téléportation",
  T_49_META_TYP_31_I6_D: "Effet sonore du ramassage de l'or",
  T_49_META_TYP_31_I60_D: "Effet sonore du choc électrique",
  T_49_META_TYP_31_I61_D: "Effet sonore de l'obtention d'accessoires",
  T_49_META_TYP_31_I62_D: "Effets sonores de la musique de fond du jeu électronique Fantasy Cute",
  T_49_META_TYP_31_I63_D: "Effets sonores de la musique de fond d'un jeu décontracté",
  T_49_META_TYP_31_I64_D: "Boîte Ouverte",
  T_49_META_TYP_31_I65_D: "Monter en Classement",
  T_49_META_TYP_31_I66_D: "Niveau Max.",
  T_49_META_TYP_31_I67_D: "Bouton de Tapotement",
  T_49_META_TYP_31_I68_D: "Compte à Rebours",
  T_49_META_TYP_31_I69_D: "Vaincre L'ennemi",
  T_49_META_TYP_31_I7_D: "Effet sonore de la course après la ligne d'arrivée",
  T_49_META_TYP_31_I70_D: "Fin",
  T_49_META_TYP_31_I71_D: "En avant",
  T_49_META_TYP_31_I72_D: "Victoire",
  T_49_META_TYP_31_I73_D: "Points de contrôle de la base d'entraînement",
  T_49_META_TYP_31_I74_D: "Compte à Rebours",
  T_49_META_TYP_31_I75_D: "Début du Jeu",
  T_49_META_TYP_31_I76_D: "Obtenir Or Gros",
  T_49_META_TYP_31_I77_D: "Obtenir Or Moyen",
  T_49_META_TYP_31_I78_D: "Obtenir Or Petit",
  T_49_META_TYP_31_I79_D: "Rejoindre la Bataille",
  T_49_META_TYP_31_I8_D: "Son de la gâchette",
  T_49_META_TYP_31_I80_D: "Approvisionnement de Guilde",
  T_49_META_TYP_31_I81_D: "Haut-Parleur",
  T_49_META_TYP_31_I82_D: "Révocation du Leader de Guilde",
  T_49_META_TYP_31_I83_D: "Sauver Entrepôt",
  T_49_META_TYP_31_I84_D: "Son Spécial d'Arme",
  T_49_META_TYP_31_I85_D: "Impact De Balle",
  T_49_META_TYP_31_I86_D: "Déplacer",
  T_49_META_TYP_31_I87_D: "Appuyez Sur Le Bouton Désactiver",
  T_49_META_TYP_31_I88_D: "Chargement de Compétence Complet",
  T_49_META_TYP_31_I89_D: "Compétence Laser",
  T_49_META_TYP_31_I9_D: "Son de la dégradation",
  T_49_META_TYP_31_I90_D: "Obtenir Consommable 2",
  T_49_META_TYP_31_I91_D: "Compte à Rebours 3",
  T_49_META_TYP_31_I92_D: "Fin de Jeu 2",
  T_49_META_TYP_31_I93_D: "Indice de Tuer",
  T_49_META_TYP_31_I94_D: "Explosion",
  T_49_META_TYP_31_I95_D: "Compétence Orbe d'Énergie",
  T_49_META_TYP_31_I96_D: "Bassin De Compétence Cramoisi",
  T_49_META_TYP_311_I1_D: "Dégâts Max.",
  T_49_META_TYP_311_I3_D: "Vitesse du projectile après sa libération, en m/s.",
  T_49_META_TYP_311_I4_D: "Intervalle de temps entre le moment où le projectile est libéré et celui où il fait effet, en secondes.",
  T_49_META_TYP_313_I0_D: "Rayon De La Zone",
  T_49_META_TYP_313_I1_D: "Durée de la zone de contre-mesure, en secondes",
  T_49_META_TYP_314_I0_D: "ID de ressource du contrôleur d'animation",
  T_49_META_TYP_314_I1_D: "Contrôleur D'animation",
  T_49_META_TYP_315_I0_D: "Propriétaire du sac à dos",
  T_49_META_TYP_315_I1_D: "L'espace du sac à dos",
  T_49_META_TYP_315_I2_D: "Capacité Utilisée",
  T_49_META_TYP_315_I3_D: "Toutes les Fournitures",
  T_49_META_TYP_316_I0_D: "Ressource de Texture",
  T_49_META_TYP_316_I1_D: "Nom du Shader",
  T_49_META_TYP_316_I11_D: "Méthode d'inversion",
  T_49_META_TYP_316_I2_D: "Décalage UV",
  T_49_META_TYP_316_I3_D: "Taille UV",
  T_49_META_TYP_316_I4_D: "Type de remplissage",
  T_49_META_TYP_316_I5_D: "Bord Gauche-Droit",
  T_49_META_TYP_316_I6_D: "Bord Haut-Bas",
  T_49_META_TYP_317_I0_D: "Aucun",
  T_49_META_TYP_317_I1_D: "Position de Gel X",
  T_49_META_TYP_317_I2_D: "Position de Gel Y",
  T_49_META_TYP_317_I3_D: "Position de Gel Z",
  T_49_META_TYP_317_I4_D: "Rotation restreinte autour de l'axe X",
  T_49_META_TYP_317_I5_D: "Restriction de la rotation autour de l'axe Y",
  T_49_META_TYP_317_I6_D: "Limitation de la rotation autour de l'axe Z",
  T_49_META_TYP_317_I7_D: "Position de Gel",
  T_49_META_TYP_317_I8_D: "Geler La Rotation",
  T_49_META_TYP_317_I9_D: "Tout Geler",
  T_49_META_TYP_318_I0_D: "Portée",
  T_49_META_TYP_318_I1_D: "Distance De Dégâts Complets",
  T_49_META_TYP_318_I10_D: "Facteur de Vitesse de Visée du Joueur",
  T_49_META_TYP_318_I11_D: "Coefficient d'amplification de la visée",
  T_49_META_TYP_318_I12_D: "Agrandissement FOV",
  T_49_META_TYP_318_I13_D: "Agrandissement ADS",
  T_49_META_TYP_318_I14_D: "Temps D'agrandissement ADS (s)",
  T_49_META_TYP_318_I15_D: "Temps De Récupération ADS (s)",
  T_49_META_TYP_318_I16_D: "Facteur de correction de la portée des dégâts minimaux pour les lunettes",
  T_49_META_TYP_318_I17_D: "Autoriser L'assistance à La Visée ADS",
  T_49_META_TYP_318_I18_D: "Ratio d'attraction de la réticule d'assistance à la visée sur l'écran (0-1)",
  T_49_META_TYP_318_I19_D: "Coefficient d'atténuation de la distance de l'assistance à la visée (0-1)",
  T_49_META_TYP_318_I2_D: "Distance Min De Dégâts",
  T_49_META_TYP_318_I20_D: "Autoriser La Distance D'assistance à La Visée D'abord",
  T_49_META_TYP_318_I21_D: "Distance Minimale Prioritaire Pour L'assistance à la Visée",
  T_49_META_TYP_318_I22_D: "Distance maximale prioritaire pour l'assistance à la visée",
  T_49_META_TYP_318_I23_D: "Coefficient D'impact De Priorité De La Distance D'assistance À La Visée (>=1)",
  T_49_META_TYP_318_I24_D: "Sensibilité de Rotation de L'ADS",
  T_49_META_TYP_318_I25_D: "Taux De Convergence",
  T_49_META_TYP_318_I3_D: "Taille Du Chargeur",
  T_49_META_TYP_318_I4_D: "Intervalle d'Attaque",
  T_49_META_TYP_318_I5_D: "Vitesse de rechargement",
  T_49_META_TYP_318_I6_D: "Vitesse de Rechargement Automatique",
  T_49_META_TYP_318_I7_D: "Vitesse de Dispersion",
  T_49_META_TYP_318_I8_D: "Taux de dispersion en cas d'accroupissement et de couchage, par 0,1 signifie une augmentation de la portée de 10 % par round de collision.",
  T_49_META_TYP_318_I9_D: "Dispersion maximale",
  T_49_META_TYP_319_I0_D: "Simple",
  T_49_META_TYP_319_I1_D: "Découpé",
  T_49_META_TYP_319_I2_D: "Carrelé",
  T_49_META_TYP_319_I3_D: "Rempli",
  T_49_META_TYP_319_I4_D: "Ajusté",
  T_49_META_TYP_32_I0_D: "Joueur en état actif normal",
  T_49_META_TYP_32_I1_D: "Le joueur est assommé",
  T_49_META_TYP_32_I2_D: "Le joueur est mort",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertical",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "La distance maximale à laquelle l'assistance au ciblage sera déclenchée.",
  T_49_META_TYP_321_I1_D: "Le décalage du collimateur lors du déclenchement du ciblage. Si le point de décalage n'est pas dans le solide, le ciblage sera désactivé.",
  T_49_META_TYP_322_I0_D: "Non",
  T_49_META_TYP_322_I1_D: "Tête",
  T_49_META_TYP_322_I2_D: "Corps",
  T_49_META_TYP_322_I3_D: "Membre",
  T_49_META_TYP_323_I0_D: "Échelle",
  T_49_META_TYP_323_I1_D: "ID compte",
  T_49_META_TYP_323_I2_D: "Informations sur le profil du joueur",
  T_49_META_TYP_323_I3_D: "Style",
  T_49_META_TYP_323_I4_D: "Afficher le Rang",
  T_49_META_TYP_323_I5_D: "Afficher l'Épinglette",
  T_49_META_TYP_323_I6_D: "Afficher le Surnom",
  T_49_META_TYP_324_I0_D: "Générer une force d'une magnitude spécifiée",
  T_49_META_TYP_324_I1_D: "Générer une accélération d'une magnitude spécifiée",
  T_49_META_TYP_324_I2_D: "Générer une impulsion d'une magnitude spécifiée",
  T_49_META_TYP_324_I3_D: "Générer une vitesse d'une valeur spécifiée",
  T_49_META_TYP_326_I0_D: "ID du compte",
  T_49_META_TYP_326_I1_D: "ID avatar",
  T_49_META_TYP_326_I2_D: "ID bannière",
  T_49_META_TYP_326_I3_D: "ID insigne",
  T_49_META_TYP_326_I4_D: "Surnom du joueur",
  T_49_META_TYP_326_I5_D: "Rang BR",
  T_49_META_TYP_326_I6_D: "Rang BR maximum",
  T_49_META_TYP_326_I7_D: "Rang CS",
  T_49_META_TYP_326_I8_D: "Rang CS maximum",
  T_49_META_TYP_327_I0_D: "ID de la ressource",
  T_49_META_TYP_327_I1_D: "Partie du Masque 1",
  T_49_META_TYP_327_I2_D: "Partie du Masque 2",
  T_49_META_TYP_327_I3_D: "Partie du Masque 3",
  T_49_META_TYP_327_I4_D: "Partie du Masque 4",
  T_49_META_TYP_329_I0_D: "Conducteur",
  T_49_META_TYP_329_I1_D: "Passager A",
  T_49_META_TYP_329_I2_D: "Passager B",
  T_49_META_TYP_329_I3_D: "Passager C",
  T_49_META_TYP_33_I0_D: "L'ordre croissant ignore les valeurs nulles, les valeurs nulles viennent en dernier.",
  T_49_META_TYP_33_I1_D: "Ordre décroissant, du plus grand au plus petit",
  T_49_META_TYP_33_I2_D: "Ordre croissant, du plus petit au plus grand",
  T_49_META_TYP_330_I4_D: "Durée de l'effet d'invincibilité (en secondes)",
  T_49_META_TYP_330_I5_D: "Points de contrôle",
  T_49_META_TYP_330_I8_D: "Valeur Delta",
  T_49_META_TYP_332_I0_D: "Position de départ",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "Arabe Simplifié",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "FB de l'Agence",
  T_49_META_TYP_333_I5_D: "Supermarché",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Chemin des ressources, vide par défaut",
  T_49_META_TYP_335_I1_D: "Nombre de pièces, 1 par défaut",
  T_49_META_TYP_335_I2_D: "Volume, 50 par défaut",
  T_49_META_TYP_335_I3_D: "Distance Max.",
  T_49_META_TYP_335_I4_D: "Distance Min.",
  T_49_META_TYP_335_I5_D: "Si la musique est en 3D ou non",
  T_49_META_TYP_335_I6_D: "Priorité",
  T_49_META_TYP_335_I7_D: "Temps d'attente avant le début, en secondes",
  T_49_META_TYP_335_I8_D: "Joue",
  T_49_META_TYP_338_I0_D: "Statut du mouvement",
  T_49_META_TYP_338_I1_D: "Sprint",
  T_49_META_TYP_338_I2_D: "Attaque",
  T_49_META_TYP_338_I3_D: "Saut",
  T_49_META_TYP_338_I4_D: "Dépassement",
  T_49_META_TYP_338_I5_D: "Entrer dans le véhicule (conducteur)",
  T_49_META_TYP_338_I6_D: "Entrer dans un transporteur (passager)",
  T_49_META_TYP_338_I7_D: "Sortir Du Véhicule",
  T_49_META_TYP_338_I8_D: "Conduire",
  T_49_META_TYP_339_I0_D: "Coefficient De Dégâts Aux Membres",
  T_49_META_TYP_339_I1_D: "Coefficient de dégâts à la tête",
  T_49_META_TYP_339_I2_D: "Coefficient De Durabilité Max.",
  T_49_META_TYP_339_I3_D: "Coefficient D'HP Extra",
  T_49_META_TYP_339_I4_D: "Facteur de réduction des dégâts de l'explosion supplémentaire (%)",
  T_49_META_TYP_339_I5_D: "Capacité Supplémentaire Du Sac à Dos",
  T_49_META_TYP_339_I6_D: "Priorité De Remplacement",
  T_49_META_TYP_34_I0_D: "Poing par défaut",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Fusil de chasse",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Canon à main",
  T_49_META_TYP_34_I112_D: "Pistolet de Glace",
  T_49_META_TYP_34_I113_D: "Pistolet de bouclier",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "Pistolet de bouclier",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Kar98K-II Kar98K-III Kar98K-III",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Grenade de flamme Pistolet",
  T_49_META_TYP_34_I133_D: "Grenade éclairante",
  T_49_META_TYP_34_I134_D: "Grenade fumigène",
  T_49_META_TYP_34_I135_D: "Grenade Gelante",
  T_49_META_TYP_34_I136_D: "Gilet pare-balles Lv1",
  T_49_META_TYP_34_I137_D: "Gilet pare-balles Lv2",
  T_49_META_TYP_34_I138_D: "Gilet pare-balles Lv3",
  T_49_META_TYP_34_I139_D: "Casque Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Casque Lv2",
  T_49_META_TYP_34_I141_D: "Casque Lv3",
  T_49_META_TYP_34_I142_D: "Armure antidéflagrante",
  T_49_META_TYP_34_I143_D: "Sac à dos Lv1",
  T_49_META_TYP_34_I144_D: "Sac à dos Lv2",
  T_49_META_TYP_34_I145_D: "Sac à dos Lv3",
  T_49_META_TYP_34_I146_D: "Buse Lv1",
  T_49_META_TYP_34_I147_D: "Muselière Lv2",
  T_49_META_TYP_34_I148_D: "Muselière Lv3",
  T_49_META_TYP_34_I149_D: "Silencieux",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Muselière d'assaut",
  T_49_META_TYP_34_I151_D: "Bouche large",
  T_49_META_TYP_34_I152_D: "Chargeur Lv1",
  T_49_META_TYP_34_I153_D: "Chargeur Lv2",
  T_49_META_TYP_34_I154_D: "Chargeur Lv3",
  T_49_META_TYP_34_I155_D: "Chargeur à double faisceau",
  T_49_META_TYP_34_I156_D: "Chargeur à chaîne",
  T_49_META_TYP_34_I157_D: "Poignée Lv1",
  T_49_META_TYP_34_I158_D: "Poignée Lv2",
  T_49_META_TYP_34_I159_D: "Poignée Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Support pliant",
  T_49_META_TYP_34_I161_D: "Poignée de fusil de tir",
  T_49_META_TYP_34_I162_D: "Crosse de fusil de chasse",
  T_49_META_TYP_34_I163_D: "Crosse de sniper",
  T_49_META_TYP_34_I164_D: "Lunette d'imagerie thermique",
  T_49_META_TYP_34_I165_D: "Crosse Lv1",
  T_49_META_TYP_34_I166_D: "Crosse Lv2",
  T_49_META_TYP_34_I167_D: "Crosse Lv3",
  T_49_META_TYP_34_I168_D: "Extension de bouclier",
  T_49_META_TYP_34_I169_D: "Armure complète",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Veste excédentaire",
  T_49_META_TYP_34_I171_D: "Veste antidéflagrante",
  T_49_META_TYP_34_I172_D: "Extension du sac à dos",
  T_49_META_TYP_34_I173_D: "Respirateur de soins",
  T_49_META_TYP_34_I174_D: "Horizon",
  T_49_META_TYP_34_I175_D: "Kit de soins",
  T_49_META_TYP_34_I176_D: "Kit de réparation de défense",
  T_49_META_TYP_34_I177_D: "Une tour de garde IA faite de matériaux de haute technologie qui recherche et attaque activement les ennemis dans un certain rayon d'action.",
  T_49_META_TYP_34_I178_D: "Champignon de niveau 1",
  T_49_META_TYP_34_I179_D: "Champignon de niveau 2",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Niveau 3 Champignon",
  T_49_META_TYP_34_I181_D: "Niveau 4 Champignon",
  T_49_META_TYP_34_I182_D: "Drone Personnel",
  T_49_META_TYP_34_I184_D: "Mines à capteurs",
  T_49_META_TYP_34_I185_D: "Chaussures volantes à réaction",
  T_49_META_TYP_34_I186_D: "Chaussures de puissance rebondissantes",
  T_49_META_TYP_34_I187_D: "Planeur",
  T_49_META_TYP_34_I188_D: "Grenade appât",
  T_49_META_TYP_34_I189_D: "Planche à roulettes Maglev",
  T_49_META_TYP_34_I19_D: "Desert Eagle",
  T_49_META_TYP_34_I190_D: "Pince de déminage",
  T_49_META_TYP_34_I191_D: "Amélioration d'arme",
  T_49_META_TYP_34_I192_D: "Munitions de Fusil",
  T_49_META_TYP_34_I193_D: "Munitions De Pistolet",
  T_49_META_TYP_34_I194_D: "Munitions De Fusil Tireur D'élite",
  T_49_META_TYP_34_I195_D: "Munitions De Shotgun",
  T_49_META_TYP_34_I196_D: "Munitions SMG",
  T_49_META_TYP_34_I197_D: "Flèches",
  T_49_META_TYP_34_I198_D: "Grenade M79",
  T_49_META_TYP_34_I199_D: "Balles de lance-flammes",
  T_49_META_TYP_34_I2_D: "ARCHETTE",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "LANCEUR DE BALLES2",
  T_49_META_TYP_34_I201_D: "Crochet",
  T_49_META_TYP_34_I202_D: "Pistolet de football",
  T_49_META_TYP_34_I203_D: "Boxe",
  T_49_META_TYP_34_I204_D: "Lance-Flammes",
  T_49_META_TYP_34_I205_D: "Carte Monkeygod",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "Carte Djmale",
  T_49_META_TYP_34_I208_D: "GraffitistCard",
  T_49_META_TYP_34_I209_D: "DétectiveCard",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ProfesseurCard",
  T_49_META_TYP_34_I211_D: "Carte Chasseur de primes",
  T_49_META_TYP_34_I212_D: "SuperstarCard",
  T_49_META_TYP_34_I213_D: "Carte Xtreme",
  T_49_META_TYP_34_I214_D: "Carte MusicBro",
  T_49_META_TYP_34_I215_D: "Carte Kenta",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "Carte Crazygirl",
  T_49_META_TYP_34_I218_D: "Carte RunSpeedUp",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "VillainCard",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Bouclier de football",
  T_49_META_TYP_34_I30_D: "Pistolet à énergie surchauffée",
  T_49_META_TYP_34_I31_D: "Pistolet surchauffé-I",
  T_49_META_TYP_34_I32_D: "Pistolet à surchauffe-II",
  T_49_META_TYP_34_I33_D: "Pistolet à surchauffe-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Pistolet de guérison-Y",
  T_49_META_TYP_34_I36_D: "Soigner sniper",
  T_49_META_TYP_34_I37_D: "Pistolet de guérison",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "Groza",
  T_49_META_TYP_34_I4_D: "Glace de Football",
  T_49_META_TYP_34_I40_D: "Groza",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "Pan",
  T_49_META_TYP_34_I44_D: "Machette",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Batte de baseball",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Épée de samouraï",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Pistolet à crochet",
  T_49_META_TYP_34_I71_D: "Couteau FF",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3 balles 1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Pivert",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "faux",
  T_49_META_TYP_34_I87_D: "Marteau à grosse tête",
  T_49_META_TYP_34_I88_D: "Dague volante (sélectionnable)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Martin-pêcheur",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Facile",
  T_49_META_TYP_340_I1_D: "Simple",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Modéré",
  T_49_META_TYP_340_I4_D: "Difficile",
  T_49_META_TYP_340_I5_D: "Inferno",
  T_49_META_TYP_342_I0_D: "Démarrer l'événement",
  T_49_META_TYP_342_I1_D: "Arrêter l'événement",
  T_49_META_TYP_342_I2_D: "Pause de l'événement",
  T_49_META_TYP_342_I3_D: "Temps d'attente après la création pour démarrer le minuteur, en millisecondes",
  T_49_META_TYP_342_I4_D: "Nombre de boucles",
  T_49_META_TYP_342_I5_D: "Événements",
  T_49_META_TYP_342_I6_D: "Compte à rebours ou temporisation positive",
  T_49_META_TYP_342_I7_D: "Statut Du Joueur",
  T_49_META_TYP_342_I8_D: "Heure de fin du minutage en secondes",
  T_49_META_TYP_345_I10_D: "Canon à main",
  T_49_META_TYP_345_I12_D: "Pistolet à mur de glace",
  T_49_META_TYP_345_I13_D: "Lance-Flammes",
  T_49_META_TYP_345_I4_D: "Fusil à pompe",
  T_49_META_TYP_345_I6_D: "Arme Spéciale",
  T_49_META_TYP_345_I8_D: "Accumulateur",
  T_49_META_TYP_346_I0_D: "Munitions de Fusil",
  T_49_META_TYP_346_I1_D: "Munitions De Pistolet",
  T_49_META_TYP_346_I2_D: "Munitions De Fusil Tireur D'élite",
  T_49_META_TYP_346_I3_D: "Munitions De Shotgun",
  T_49_META_TYP_346_I4_D: "Munitions SMG",
  T_49_META_TYP_346_I5_D: "Flèches",
  T_49_META_TYP_346_I6_D: "Grenade M79",
  T_49_META_TYP_346_I7_D: "Crochet",
  T_49_META_TYP_346_I8_D: "Grenade Spécialisée M79",
  T_49_META_TYP_347_I3_D: "Peut être combiné avec le mouvement relatif s'il est vrai, doit être combiné avec le mouvement absolu s'il est faux, sinon l'attribut ne prendra pas effet correctement.",
  T_49_META_TYP_347_I6_D: "Valeur Delta",
  T_49_META_TYP_350_I0_D: "Voiture de Sport",
  T_49_META_TYP_350_I1_D: "Moto",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Monster Truck",
  T_49_META_TYP_350_I5_D: "Camion mutant",
  T_49_META_TYP_352_I1_D: "Sprite Non Sélectionné",
  T_49_META_TYP_352_I2_D: "Type d'image non vérifié",
  T_49_META_TYP_352_I3_D: "Couleur Non Sélectionnée",
  T_49_META_TYP_352_I4_D: "Sprite Sélectionné",
  T_49_META_TYP_352_I5_D: "Type d'image sélectionné",
  T_49_META_TYP_352_I6_D: "Couleur Sélectionnée",
  T_49_META_TYP_353_I0_D: "Quantité De Récupération Des HP",
  T_49_META_TYP_353_I1_D: "Vitesse de Récupération des HP (ms)",
  T_49_META_TYP_353_I2_D: "Temps Requis (ms)",
  T_49_META_TYP_354_I0_D: "Quantité de Récupération d'EP",
  T_49_META_TYP_355_I0_D: "Quantité De Récupération Des HP",
  T_49_META_TYP_355_I1_D: "Quantité de Récupération d'EP",
  T_49_META_TYP_355_I2_D: "Temps Requis (ms)",
  T_49_META_TYP_356_I0_D: "Articles tombés",
  T_49_META_TYP_356_I1_D: "Temps de chute de la boîte de dépôt, en ms",
  T_49_META_TYP_356_I2_D: "État du largage aérien",
  T_49_META_TYP_357_I0_D: "Surface",
  T_49_META_TYP_357_I1_D: "Limite",
  T_49_META_TYP_359_I0_D: "L'utilisation ou non d'un contrôleur de joueur avec des effets physiques",
  T_49_META_TYP_359_I1_D: "Placé sur une pente supérieure à cet angle, il glissera vers le bas.",
  T_49_META_TYP_359_I10_D: "Accélération gravitationnelle uniquement pour ce joueur contrôleur",
  T_49_META_TYP_359_I11_D: "Masse en kg",
  T_49_META_TYP_359_I12_D: "Si la pente dépasse l'angle de montée maximum, la capsule glissera vers le bas.",
  T_49_META_TYP_359_I16_D: "Lorsque cette option est activée, le mouvement est contrôlé par des tuples ou des scripts côté serveur.",
  T_49_META_TYP_359_I17_D: "Lorsque cette option est activée, la force appliquée lorsque le personnage pousse sur un corps rigide peut être personnalisée.",
  T_49_META_TYP_359_I18_D: "La force appliquée lorsque le personnage pousse le corps rigide",
  T_49_META_TYP_359_I19_D: "Vrai lorsque la partie inférieure du corps touche le corps de collision, généralement utilisé pour déterminer si le joueur est au sol ou non.",
  T_49_META_TYP_359_I2_D: "Seuls les obstacles d'une hauteur supérieure à cette valeur auront un effet de blocage, dans l'intervalle [0,Height].",
  T_49_META_TYP_359_I20_D: "Niveau de physique personnalisable, valeur [0,15].",
  T_49_META_TYP_359_I21_D: "Rotation avec gravité",
  T_49_META_TYP_359_I3_D: "Permet de modifier la profondeur du corps de la capsule. Peut empêcher le personnage de se coincer ou de trembler, mais il n'est pas recommandé de le modifier sans besoins particuliers. Plage de valeurs [0,Radius]",
  T_49_META_TYP_359_I4_D: "Distance de mouvement minimale, tout mouvement inférieur à cette valeur ne sera pas exécuté. En l'absence de besoin particulier, il est recommandé de conserver la valeur 0.",
  T_49_META_TYP_359_I5_D: "Décalage du centre de la boîte de collision par rapport à l'origine des coordonnées locales.",
  T_49_META_TYP_359_I6_D: "Rayon de la capsule, valeur minimale 0,01.",
  T_49_META_TYP_359_I7_D: "Hauteur totale de la capsule, y compris les hémisphères supérieur et inférieur, min. 2*Radius",
  T_49_META_TYP_359_I8_D: "Vitesse linéaire actuelle, en m/s",
  T_49_META_TYP_360_I0_D: "Angle De Tir à Gauche",
  T_49_META_TYP_360_I1_D: "Angle De Tir à Droite",
  T_49_META_TYP_360_I2_D: "Angle D'élévation Min.",
  T_49_META_TYP_360_I3_D: "Angle De Dépression Max",
  T_49_META_TYP_360_I4_D: "Vélocité De La Bouche",
  T_49_META_TYP_362_I0_D: "Temps d'immobilisation causé par un coup porté au joueur, en secondes",
  T_49_META_TYP_363_I0_D: "Désactiver Hud Demander un achat",
  T_49_META_TYP_363_I1_D: "Demande l'aide de l'équipe pour acheter",
  T_49_META_TYP_363_I2_D: "Achat en demandant l'aide d'un camp",
  T_49_META_TYP_364_I0_D: "Est une position centrale",
  T_49_META_TYP_364_I1_D: "Boucle ou non",
  T_49_META_TYP_364_I2_D: "Nom de l'animation",
  T_49_META_TYP_364_I3_D: "Autoplay ou non",
  T_49_META_TYP_364_I4_D: "Utiliser une ressource personnalisée",
  T_49_META_TYP_366_I0_D: "Spécifie l'UUID de la ressource Batch à rendre.",
  T_49_META_TYP_367_I1_D: "Afficher les balises",
  T_49_META_TYP_367_I2_D: "Style d'icône pour les cibles marquées",
  T_49_META_TYP_367_I3_D: "Couleur de superposition des icônes affichées sur les cibles marquées",
  T_49_META_TYP_367_I4_D: "Style de l'icône affichée sur une échelle",
  T_49_META_TYP_367_I5_D: "Couleur de superposition de l'icône affichée sur une échelle",
  T_49_META_TYP_367_I6_D: "Afficher toujours le marqueur",
  T_49_META_TYP_370_I0_D: "Titre principal",
  T_49_META_TYP_370_I1_D: "Sous-titre",
  T_49_META_TYP_370_I2_D: "Couleur d'arrière-plan supérieure",
  T_49_META_TYP_370_I3_D: "Couleur d'arrière-plan inférieure",
  T_49_META_TYP_371_I2_D: "Score gauche",
  T_49_META_TYP_371_I3_D: "Score droite",
  T_49_META_TYP_371_I4_D: "Le dernier score à gauche, utilisé pour jouer l'animation de basculement du score",
  T_49_META_TYP_371_I5_D: "Le dernier score à droite, pour l'animation de basculement du score",
  T_49_META_TYP_372_I0_D: "Debout",
  T_49_META_TYP_372_I1_D: "Afficher accroupi",
  T_49_META_TYP_372_I10_D: "Chute haute",
  T_49_META_TYP_372_I11_D: "Chute basse, par exemple en sautant",
  T_49_META_TYP_372_I12_D: "Chaussures volantes",
  T_49_META_TYP_372_I13_D: "Deux sauts",
  T_49_META_TYP_372_I14_D: "Assis sur une chaise",
  T_49_META_TYP_372_I15_D: "Ejecté par la catapulte",
  T_49_META_TYP_372_I16_D: "Étape de préparation de la catapulte",
  T_49_META_TYP_372_I17_D: "Glissement d'un accessoire de vol à voile",
  T_49_META_TYP_372_I18_D: "Chute d'un étai de vol à voile",
  T_49_META_TYP_372_I19_D: "Rebondissement par des pneus",
  T_49_META_TYP_372_I2_D: "Courir",
  T_49_META_TYP_372_I20_D: "Rebondissement par des pneus humains",
  T_49_META_TYP_372_I21_D: "Une action dans la zone de fête",
  T_49_META_TYP_372_I22_D: "Monter dans une machine volante",
  T_49_META_TYP_372_I23_D: "Entrer dans un canon",
  T_49_META_TYP_372_I24_D: "En sortant d'un Canon, d'un Transporteur, etc., c'est l'état si l'objet est volant.",
  T_49_META_TYP_372_I25_D: "Après avoir sauté d'un tremplin",
  T_49_META_TYP_372_I26_D: "Après être descendu d'une tyrolienne",
  T_49_META_TYP_372_I27_D: "Non utilisé",
  T_49_META_TYP_372_I3_D: "Descendre et ramper",
  T_49_META_TYP_372_I4_D: "Nager",
  T_49_META_TYP_372_I5_D: "Chute verticale",
  T_49_META_TYP_372_I6_D: "Par-dessus le mur",
  T_49_META_TYP_372_I7_D: "Inutilisé",
  T_49_META_TYP_372_I8_D: "Assommé mais pas mort",
  T_49_META_TYP_372_I9_D: "Planche à roulettes aquatique",
  T_49_META_TYP_374_I0_D: "Couleurs de la vie, du niveau et du trait",
  T_49_META_TYP_374_I1_D: "Lorsque la durée de vie diminue, la partie perdue est brièvement représentée dans cette couleur.",
  T_49_META_TYP_374_I10_D: "Décalage par rapport à la cible à suivre",
  T_49_META_TYP_374_I11_D: "La durée de vie entre chaque ligne, si elle est inférieure ou égale à 0, elle ne sera pas affichée.",
  T_49_META_TYP_374_I12_D: "HP total",
  T_49_META_TYP_374_I13_D: "HP actuel",
  T_49_META_TYP_374_I14_D: "Lorsqu'il est activé, les changements de sang seront colorés différemment.",
  T_49_META_TYP_374_I15_D: "Lorsque cette option est activée, l'attribut de décalage est transféré dans le système de coordonnées mondial en utilisant le système de coordonnées local.",
  T_49_META_TYP_374_I2_D: "Cette couleur apparaît brièvement pour la partie croissante de la valeur de vie lorsque celle-ci augmente.",
  T_49_META_TYP_374_I3_D: "La couleur de la bordure de la valeur de vie et du bas de la vignette.",
  T_49_META_TYP_374_I4_D: "Plage 0~1, la transparence de l'interface utilisateur globale.",
  T_49_META_TYP_374_I5_D: "Détermine l'échelle globale de l'interface utilisateur, ainsi que l'échelle de la police.",
  T_49_META_TYP_374_I6_D: "Indique le nom du propriétaire de la tache de sang actuelle",
  T_49_META_TYP_374_I8_D: "La longueur de la tache de sang sur l'écran.",
  T_49_META_TYP_374_I9_D: "Doit suivre une entité avec un composant Transform.",
  T_49_META_TYP_375_I1_D: "Entité de combat",
  T_49_META_TYP_376_I1_D: "Entité de combat",
  T_49_META_TYP_38_I0_D: "Alpha",
  T_49_META_TYP_382_I0_D: "Défaut",
  T_49_META_TYP_382_I1_D: "Sauter l'état de knockdown et mourir simplement",
  T_49_META_TYP_382_I2_D: "Ne Pas Passer l’Abattu",
  T_49_META_TYP_387_I1_D: "Autoriser le Pressage Hors Zone",
  T_49_META_TYP_389_I0_D: "Décalage par défaut de la base",
  T_49_META_TYP_389_I1_D: "Sprite de Fond",
  T_49_META_TYP_389_I10_D: "Alpha Non Activé",
  T_49_META_TYP_389_I2_D: "Rayon de Fond",
  T_49_META_TYP_389_I3_D: "Image du Cap du Joystick",
  T_49_META_TYP_389_I4_D: "Rayon du Cap du Joystick",
  T_49_META_TYP_389_I5_D: "Rayon de Glissement du Cap du Joystick",
  T_49_META_TYP_389_I6_D: "Sprite de Flèche",
  T_49_META_TYP_389_I7_D: "Taille de Flèche",
  T_49_META_TYP_389_I8_D: "Décalage de Flèche",
  T_49_META_TYP_389_I9_D: "Alpha Activé",
  T_49_META_TYP_39_I1_D: "Forme du sprite",
  T_49_META_TYP_39_I10_D: "Dégradé Haut",
  T_49_META_TYP_39_I11_D: "Dégradé Bas",
  T_49_META_TYP_39_I12_D: "Alpha Haut",
  T_49_META_TYP_39_I13_D: "Alpha Bas",
  T_49_META_TYP_39_I3_D: "Inverser",
  T_49_META_TYP_39_I4_D: "Rempli",
  T_49_META_TYP_39_I5_D: "Centre Invisible",
  T_49_META_TYP_39_I6_D: "Direction de Remplissage",
  T_49_META_TYP_39_I7_D: "Valeur de Remplissage",
  T_49_META_TYP_39_I8_D: "Inverser le Remplissage",
  T_49_META_TYP_39_I9_D: "Dégradé",
  T_49_META_TYP_392_I0_D: "Le temps par défaut d'apparition d'une zone de sécurité dans le jeu par tour est de 0, en ms.",
  T_49_META_TYP_392_I1_D: "Temps nécessaire pour rétrécir le cercle, en ms",
  T_49_META_TYP_392_I10_D: "L'heure de fin du cercle, en ms",
  T_49_META_TYP_392_I12_D: "Rayon du cercle de fin",
  T_49_META_TYP_392_I13_D: "Heure de Début du Rétrécissement",
  T_49_META_TYP_392_I14_D: "Intervalle de dommage (ms)",
  T_49_META_TYP_392_I3_D: "Quantité de dégâts infligés à un joueur dans un cercle empoisonné en un seul tour.",
  T_49_META_TYP_392_I4_D: "Liste des joueurs dans la zone de sécurité",
  T_49_META_TYP_392_I5_D: "Le temps de disparition de la zone de sécurité, aucune zone de sécurité ne sera générée si le temps de disparition de la zone de sécurité est inférieur au temps effectif.",
  T_49_META_TYP_392_I6_D: "ID du Groupe",
  T_49_META_TYP_392_I7_D: "Le rayon du cercle de départ",
  T_49_META_TYP_392_I8_D: "État de fin",
  T_49_META_TYP_392_I9_D: "Statut",
  T_49_META_TYP_394_I0_D: "Valeur environ 3.1416",
  T_49_META_TYP_394_I1_D: "Valeur environ 2.7183",
  T_49_META_TYP_396_I0_D: "Titre",
  T_49_META_TYP_396_I1_D: "Contenu",
  T_49_META_TYP_396_I2_D: "Options",
  T_49_META_TYP_396_I3_D: "Afficher l'arrière-plan",
  T_49_META_TYP_399_I0_D: "Hauteur de saut",
  T_49_META_TYP_399_I1_D: "Nombre de sauts consécutifs pouvant être effectués avant l'atterrissage",
  T_49_META_TYP_399_I2_D: "Le nombre de sauts supplémentaires pouvant être effectués avant l'atterrissage",
  T_49_META_TYP_399_I3_D: "Déplacement en l'air",
  T_49_META_TYP_40_I1_D: "Étiquette",
  T_49_META_TYP_40_I10_D: "Espacement des Lignes",
  T_49_META_TYP_40_I11_D: "Méthode de débordement",
  T_49_META_TYP_40_I12_D: "Style De Police",
  T_49_META_TYP_40_I13_D: "Appliquer l'Ombre",
  T_49_META_TYP_40_I14_D: "Couleur de l'Ombre",
  T_49_META_TYP_40_I15_D: "Décalage de l'Ombre",
  T_49_META_TYP_40_I3_D: "Clé localisée, utilisable dans plusieurs langues",
  T_49_META_TYP_40_I5_D: "Méthode d'alignement",
  T_49_META_TYP_40_I6_D: "Alignement Vertical",
  T_49_META_TYP_40_I7_D: "Gras",
  T_49_META_TYP_40_I8_D: "Italique",
  T_49_META_TYP_40_I9_D: "Souligné",
  T_49_META_TYP_400_I0_D: "Active",
  T_49_META_TYP_400_I1_D: "Passive",
  T_49_META_TYP_400_I2_D: "Pas D'attaque",
  T_49_META_TYP_401_I0_D: "Ne peut pas tirer.",
  T_49_META_TYP_401_I1_D: "Peut tirer en continu",
  T_49_META_TYP_401_I2_D: "Tire une fois par ordre d'attaque",
  T_49_META_TYP_401_I3_D: "Trois fois par ordre d'attaque.",
  T_49_META_TYP_401_I4_D: "Tire deux fois par commande d'attaque",
  T_49_META_TYP_401_I5_D: "Parade",
  T_49_META_TYP_402_I0_D: "Cibles pour l'ami",
  T_49_META_TYP_402_I1_D: "Type de Fonction",
  T_49_META_TYP_402_I2_D: "Style",
  T_49_META_TYP_403_I0_D: "Ajouter Un Ami",
  T_49_META_TYP_403_I1_D: "Signaler",
  T_49_META_TYP_404_I0_D: "Clair",
  T_49_META_TYP_404_I1_D: "Sombre",
  T_49_META_TYP_405_I0_D: "Par hiérarchie",
  T_49_META_TYP_405_I1_D: "Par priorité de haut en bas",
  T_49_META_TYP_405_I2_D: "Par priorité de bas en haut",
  T_49_META_TYP_406_I0_D: "Contrôle la distance du mouvement de dépassement du joueur",
  T_49_META_TYP_406_I1_D: "Contrôle la hauteur du mouvement du corps du joueur pendant le saut.",
  T_49_META_TYP_407_I0_D: "Local",
  T_49_META_TYP_407_I1_D: "Client",
  T_49_META_TYP_407_I2_D: "Serveur",
  T_49_META_TYP_407_I3_D: "Les deux",
  T_49_META_TYP_409_I0_D: "Pas d'erreurs",
  T_49_META_TYP_409_I1_D: "Délai d'attente pour le stockage des données, principalement pour les opérations de lecture",
  T_49_META_TYP_409_I10_D: "Échec du changement d'équipe - équipe cible non valide",
  T_49_META_TYP_409_I11_D: "Échec du changement d'équipe - le joueur mort n'est pas autorisé à changer d'équipe",
  T_49_META_TYP_409_I12_D: "Échec du changement d'équipe - le porteur n'est pas autorisé à changer d'équipe",
  T_49_META_TYP_409_I2_D: "La fréquence de lecture et d'écriture des données stockées dépasse la limite",
  T_49_META_TYP_409_I3_D: "Paramètre Exception",
  T_49_META_TYP_409_I4_D: "Échec de la création d'une salle : pas de PersonaID valides",
  T_49_META_TYP_409_I5_D: "Statut d'erreur non défini",
  T_49_META_TYP_409_I6_D: "Service commercialisé fermé, l'utilisateur n'a plus accès au service du développeur",
  T_49_META_TYP_409_I7_D: "Échec du changement d'équipe - mode non pris en charge",
  T_49_META_TYP_409_I8_D: "Échec du changement d'équipe - l'utilisateur est déjà dans l'équipe cible",
  T_49_META_TYP_409_I9_D: "Échec du changement de file d'attente - cible non valide",
  T_49_META_TYP_41_I0_D: "Forme du sprite",
  T_49_META_TYP_41_I19_D: "Désactiver la boîte de collision",
  T_49_META_TYP_41_I3_D: "Couleur Désactivée",
  T_49_META_TYP_41_I4_D: "Couleur Pressée",
  T_49_META_TYP_41_I5_D: "Type de remplissage",
  T_49_META_TYP_41_I6_D: "Est un Bouton FE",
  T_49_META_TYP_41_I7_D: "Sprite Pressé",
  T_49_META_TYP_41_I8_D: "Type de Sprite Pressé",
  T_49_META_TYP_41_I9_D: "Type de Retour",
  T_49_META_TYP_411_I0_D: "Vitesse vers l'avant",
  T_49_META_TYP_411_I1_D: "Vitesse vers l'arrière",
  T_49_META_TYP_411_I2_D: "Vitesse vers le haut",
  T_49_META_TYP_411_I3_D: "Vitesse vers le bas",
  T_49_META_TYP_411_I4_D: "Dommages min. des grenades",
  T_49_META_TYP_411_I5_D: "Dommages max. des grenades",
  T_49_META_TYP_411_I6_D: "Portée des grenades",
  T_49_META_TYP_412_I0_D: "Puissance du véhicule lorsqu'on utilise le bouton d'accélération",
  T_49_META_TYP_412_I1_D: "Puissance du véhicule lorsque l'on utilise le bouton de marche arrière/frein",
  T_49_META_TYP_412_I2_D: "Angle de braquage maximal à grande vitesse",
  T_49_META_TYP_412_I3_D: "Seuil de vitesse appliqué à l'angle de braquage maximal à grande vitesse",
  T_49_META_TYP_412_I4_D: "Après avoir atteint la vitesse maximale, le transporteur ne fournit plus de puissance, mais il peut dépasser cette vitesse maximale (par exemple dans une descente).",
  T_49_META_TYP_412_I5_D: "Lorsque le véhicule n'est pas manœuvré, il est décéléré en multipliant l'entrée du frein à vide par le couple de freinage.",
  T_49_META_TYP_412_I6_D: "Calcul des dommages en cas de collision, en appliquant les paramètres de la formule de calcul des dommages.",
  T_49_META_TYP_412_I7_D: "Calcul des dommages en cas d'éperonnage, les dommages ne seront pas augmentés même si la vitesse est dépassée.",
  T_49_META_TYP_412_I8_D: "Calcul des dommages en cas d'éperonnage, dommages minimums",
  T_49_META_TYP_412_I9_D: "Calcul des dégâts en cas d'éperonnage, dégâts maximums",
  T_49_META_TYP_413_I0_D: "Joueur (PNJ) transformé en costume",
  T_49_META_TYP_414_I1_D: "Large gamme",
  T_49_META_TYP_415_I0_D: "ID de persona",
  T_49_META_TYP_415_I1_D: "Pseudonyme",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "La Persona à laquelle elle est liée",
  T_49_META_TYP_416_I2_D: "Décalage",
  T_49_META_TYP_416_I3_D: "Hauteur",
  T_49_META_TYP_416_I4_D: "Répondre ou non aux messages du système",
  T_49_META_TYP_416_I5_D: "Surnom de la personne",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Surnom de l'utilisateur",
  T_49_META_TYP_416_I8_D: "UserAvatar",
  T_49_META_TYP_417_I0_D: "ID de la ressource",
  T_49_META_TYP_418_I0_D: "Expiration de l'adhésion",
  T_49_META_TYP_418_I1_D: "Devenir membre",
  T_49_META_TYP_418_I2_D: "Renouveler l'adhésion",
  T_49_META_TYP_42_I0_D: "Texte Par Défaut",
  T_49_META_TYP_42_I1_D: "Texte Actif",
  T_49_META_TYP_42_I10_D: "Longueur Maximale",
  T_49_META_TYP_42_I14_D: "Couleur Pressée",
  T_49_META_TYP_42_I16_D: "Clé localisée, disponible dans plusieurs langues",
  T_49_META_TYP_42_I3_D: "Méthode d'alignement",
  T_49_META_TYP_42_I4_D: "Alignement Vertical",
  T_49_META_TYP_42_I5_D: "Gras",
  T_49_META_TYP_42_I6_D: "Italique",
  T_49_META_TYP_42_I7_D: "Souligné",
  T_49_META_TYP_42_I8_D: "Espacement des Lignes",
  T_49_META_TYP_42_I9_D: "Enveloppement de Mots",
  T_49_META_TYP_424_I0_D: "Brouillard linéaire",
  T_49_META_TYP_424_I1_D: "Brouillard exponentiel",
  T_49_META_TYP_424_I2_D: "Brouillard carré exponentiel",
  T_49_META_TYP_426_I0_D: "Intensité",
  T_49_META_TYP_426_I1_D: "Portée",
  T_49_META_TYP_426_I2_D: "Angle du cône en degrés",
  T_49_META_TYP_426_I3_D: "Couleur de la lumière",
  T_49_META_TYP_428_I0_D: "ID's de Skin D'arme",
  T_49_META_TYP_428_I2_D: "ID costume",
  T_49_META_TYP_428_I3_D: "ID couvre-chef",
  T_49_META_TYP_428_I4_D: "ID visage",
  T_49_META_TYP_428_I5_D: "ID Maquillage",
  T_49_META_TYP_428_I6_D: "ID Haut du corps",
  T_49_META_TYP_428_I7_D: "ID du bas",
  T_49_META_TYP_428_I8_D: "ID chaussures",
  T_49_META_TYP_431_I1_D: "Trajectoire de l'entité cible",
  T_49_META_TYP_431_I3_D: "Vitesse de déplacement, unité m/s",
  T_49_META_TYP_431_I4_D: `Si le mouvement est orienté vers la ligne tangente de la trajectoire ou non 
par défaut, False, le mouvement de l'objet ne changera pas de direction 
si True, le mouvement de l'objet sera orienté vers l'avant de la trajectoire`,
  T_49_META_TYP_431_I5_D: "Pourcentage joué",
  T_49_META_TYP_432_I0_D: "Angle de renversement, affecte la rotation radiale de la trajectoire de part et d'autre de ce point.",
  T_49_META_TYP_432_I1_D: "La position relative du point de contrôle de la tangente par rapport au point de passage, qui détermine la tangente de la trajectoire.",
  T_49_META_TYP_433_I0_D: "Interpolation linéaire entre les points de trajectoire",
  T_49_META_TYP_433_I1_D: "Interpolation des courbes entre les points de trajectoire pour un déplacement en douceur",
  T_49_META_TYP_433_I2_D: "Prise en charge de l'ajustement manuel des tangentes aux points de courbe",
  T_49_META_TYP_434_I0_D: "Type de trajectoire",
  T_49_META_TYP_434_I1_D: "Longueur totale de la trajectoire",
  T_49_META_TYP_434_I2_D: "Début et fin simultanés ou non de la trajectoire",
  T_49_META_TYP_434_I3_D: "Collection de points de passage",
  T_49_META_TYP_437_I3_D: "Joueurs de gauche",
  T_49_META_TYP_437_I4_D: "Joueurs de droite",
  T_49_META_TYP_437_I5_D: "Noms des types de points",
  T_49_META_TYP_437_I6_D: "Tableau de points à gauche (Liste 1D : joueurs ; Liste 2D : données de points remplies selon les types de points personnalisés)",
  T_49_META_TYP_437_I7_D: "Tableau de points à droite (Liste 1D : joueurs ; Liste 2D : données de points remplies selon les types de points personnalisés)",
  T_49_META_TYP_438_I1_D: "Tableau des joueurs regroupés",
  T_49_META_TYP_438_I2_D: "Tableau des classements groupés",
  T_49_META_TYP_438_I3_D: "Tableau des scores groupés",
  T_49_META_TYP_438_I4_D: "Tableau des noms des types de points",
  T_49_META_TYP_438_I5_D: "Tableau des couleurs du groupe",
  T_49_META_TYP_438_I6_D: "Tableau des points des joueurs (correspondant à leur ordre lorsqu'ils ne sont pas groupés)",
  T_49_META_TYP_442_I1_D: "Score gauche",
  T_49_META_TYP_442_I10_D: "Icône de mort à droite",
  T_49_META_TYP_442_I2_D: "Score droite",
  T_49_META_TYP_442_I3_D: "Nombre de survivants à gauche",
  T_49_META_TYP_442_I4_D: "Nombre de survivants à droite",
  T_49_META_TYP_442_I5_D: "Morts à gauche",
  T_49_META_TYP_442_I6_D: "Morts à droite",
  T_49_META_TYP_442_I7_D: "Icône du survivant de gauche",
  T_49_META_TYP_442_I8_D: "Icône de survie à droite",
  T_49_META_TYP_442_I9_D: "Icône de mort à gauche",
  T_49_META_TYP_444_I0_D: "Anglais",
  T_49_META_TYP_444_I1_D: "Chinois simplifié",
  T_49_META_TYP_444_I10_D: "français",
  T_49_META_TYP_444_I11_D: "allemand",
  T_49_META_TYP_444_I12_D: "Turc",
  T_49_META_TYP_444_I13_D: "hindi",
  T_49_META_TYP_444_I14_D: "Japonais",
  T_49_META_TYP_444_I15_D: "Roumain",
  T_49_META_TYP_444_I16_D: "Roumain",
  T_49_META_TYP_444_I17_D: "birman",
  T_49_META_TYP_444_I18_D: "ourdou",
  T_49_META_TYP_444_I19_D: "Bengali",
  T_49_META_TYP_444_I2_D: "Chinois traditionnel",
  T_49_META_TYP_444_I3_D: "thaïlandais",
  T_49_META_TYP_444_I4_D: "vietnamien",
  T_49_META_TYP_444_I5_D: "indonésien",
  T_49_META_TYP_444_I6_D: "Chinois (simplifié)",
  T_49_META_TYP_444_I7_D: "Espagnol (simplifié)",
  T_49_META_TYP_444_I8_D: "russe",
  T_49_META_TYP_444_I9_D: "coréen",
  T_49_META_TYP_51_I0_D: "Zombie normal",
  T_49_META_TYP_51_I1_D: "Hache Zombie",
  T_49_META_TYP_51_I10_D: "Abeille bombe volante",
  T_49_META_TYP_51_I11_D: "Dragon zombie",
  T_49_META_TYP_51_I2_D: "Zombie Lanceur",
  T_49_META_TYP_51_I3_D: "Zombie Explosif",
  T_49_META_TYP_51_I4_D: "Zombie Tyrant",
  T_49_META_TYP_51_I5_D: "Lancer Zombie Rouge",
  T_49_META_TYP_51_I6_D: "MrV",
  T_49_META_TYP_51_I7_D: "Zombie tank",
  T_49_META_TYP_51_I8_D: "Zombie De Forage",
  T_49_META_TYP_51_I9_D: "Samouraï",
  T_49_META_TYP_56_I10_D: "Délai d'explosion",
  T_49_META_TYP_56_I11_D: "Portée de l'explosion",
  T_49_META_TYP_56_I12_D: "Dégâts de l'explosion",
  T_49_META_TYP_56_I13_D: "Temps de combustion",
  T_49_META_TYP_56_I14_D: "Dégâts de combustion",
  T_49_META_TYP_56_I15_D: "Intervalle de dégâts de combustion",
  T_49_META_TYP_56_I17_D: "Pilote du véhicule",
  T_49_META_TYP_56_I18_D: "Tous les passagers du véhicule",
  T_49_META_TYP_56_I19_D: "ID de la peau du véhicule",
  T_49_META_TYP_56_I20_D: "Priorité à la configuration du joueur",
  T_49_META_TYP_56_I21_D: "PV Max.",
  T_49_META_TYP_56_I22_D: "PV",
  T_49_META_TYP_57_I0_D: "Téléportation manuelle ou automatique (par défaut, manuelle)",
  T_49_META_TYP_58_I0_D: "Type de buff généré",
  T_49_META_TYP_58_I1_D: "Le temps en secondes entre le moment où le buff est ramassé et le moment où le prochain buff est généré.",
  T_49_META_TYP_59_I0_D: "Type de mouvement",
  T_49_META_TYP_59_I1_D: "Valeur du mouvement X",
  T_49_META_TYP_59_I2_D: "Valeur du mouvement Y",
  T_49_META_TYP_59_I3_D: "Valeur du mouvement Z",
  T_49_META_TYP_59_I4_D: "Durée du mouvement",
  T_49_META_TYP_59_I5_D: "Durée d'arrêt",
  T_49_META_TYP_59_I6_D: "Désactiver le mouvement alternatif",
  T_49_META_TYP_60_I0_D: "Point d'arme de butin",
  T_49_META_TYP_61_I0_D: "Monnaie liée",
  T_49_META_TYP_61_I1_D: "Définition de la plage de déclenchement",
  T_49_META_TYP_61_I2_D: "Visibilité du modèle",
  T_49_META_TYP_62_I0_D: "Vitesse XZ",
  T_49_META_TYP_62_I1_D: "Vitesse Y",
  T_49_META_TYP_64_I0_D: "Type de composant musical",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "Path Point",
  T_49_META_TYP_68_I0_D: "Niveau de sang actuel de l'IA",
  T_49_META_TYP_68_I1_D: "Taux de sang maximum actuel de l'IA",
  T_49_META_TYP_68_I10_D: "Si l'IA laisse tomber de l'équipement ou des objets lorsqu'elle meurt.",
  T_49_META_TYP_68_I11_D: "Si l'IA est actuellement invincible",
  T_49_META_TYP_68_I12_D: "Pourcentage de dégâts infligés à l'IA lorsqu'elle subit des dégâts, soit réduit, soit augmenté.",
  T_49_META_TYP_68_I13_D: "Type d'IA",
  T_49_META_TYP_68_I14_D: "la revendication automatique ou non de l'ennemi",
  T_49_META_TYP_68_I15_D: "0 est une attaque automatique, 1 est une attaque de défense, 2 n'est pas une attaque du tout.",
  T_49_META_TYP_68_I16_D: "ID De Chemin",
  T_49_META_TYP_68_I17_D: "Cible De Chasse",
  T_49_META_TYP_68_I18_D: "Cible D'attaque",
  T_49_META_TYP_68_I19_D: "Coordonnées du point de naissance de l'IA",
  T_49_META_TYP_68_I2_D: "Obtenir l'entité de l'équipe de l'IA.",
  T_49_META_TYP_68_I20_D: "Numéro de camp de l'équipe",
  T_49_META_TYP_68_I4_D: "Ne peut modifier que la puissance d'attaque de l'attaque normale, pas celle de l'attaque de compétence.",
  T_49_META_TYP_68_I7_D: "La portée de mouvement libre de l'IA, ne peut modifier que la valeur de base, s'il y a un bonus supplémentaire, il sera ajouté en plus de cette valeur.",
  T_49_META_TYP_68_I8_D: "Portée de détection des ennemis de l'IA, ne peut modifier que la valeur de base, s'il y a un bonus supplémentaire, il sera ajouté en plus de cette valeur.",
  T_49_META_TYP_68_I9_D: "Vitesse de déplacement réelle, s'il y a une accélération de la compétence, elle sera multipliée par celle-ci.",
  T_49_META_TYP_70_I0_D: "ID de l'entité cible sur laquelle la formule fonctionne, utilisé par les implémentations internes, invisible pour le joueur.",
  T_49_META_TYP_70_I1_D: "Attribut ID de l'entité cible sur laquelle la formule fonctionne, utilisé par les implémentations internes, non visible par le joueur.",
  T_49_META_TYP_70_I2_D: "Valeur minimale autorisée",
  T_49_META_TYP_70_I3_D: "Valeur maximale autorisée",
  T_49_META_TYP_70_I4_D: "Coefficient de base",
  T_49_META_TYP_70_I5_D: "Accumulateur pré",
  T_49_META_TYP_70_I6_D: "Multiplicateur",
  T_49_META_TYP_70_I7_D: "Multiplier et accumuler",
  T_49_META_TYP_70_I8_D: "Accumulateur post",
  T_49_META_TYP_71_I0_D: "Numéro de produit",
  T_49_META_TYP_71_I1_D: "Prix",
  T_49_META_TYP_71_I10_D: "Liste des articles",
  T_49_META_TYP_71_I2_D: "Type de monnaie",
  T_49_META_TYP_71_I3_D: "Limite globale",
  T_49_META_TYP_71_I4_D: "Limite globale actuelle",
  T_49_META_TYP_71_I5_D: "Nom du produit",
  T_49_META_TYP_71_I6_D: "Description de l'article",
  T_49_META_TYP_71_I7_D: "Liste des articles",
  T_49_META_TYP_71_I8_D: "Achat possible",
  T_49_META_TYP_71_I9_D: "Chemin d'accès, vide par défaut",
  T_49_META_TYP_72_I1_D: "Liste des étagères",
  T_49_META_TYP_73_I1_D: "Fermeture manuelle désactivée",
  T_49_META_TYP_74_I0_D: "Séparateur",
  T_49_META_TYP_74_I1_D: "Casque",
  T_49_META_TYP_74_I2_D: "Gilet",
  T_49_META_TYP_74_I3_D: "Grenade",
  T_49_META_TYP_75_I0_D: "Une Voie",
  T_49_META_TYP_75_I1_D: "Aller-Retour",
  T_49_META_TYP_76_I0_D: "Patrouilles uniquement. Pas d'attaques sur les cibles en cours de route.",
  T_49_META_TYP_76_I1_D: "Patrouille Pendant L'attaque",
  T_49_META_TYP_79_I0_D: "Puissance de l'arme",
  T_49_META_TYP_79_I1_D: "Portée d'Attaque",
  T_49_META_TYP_79_I10_D: "Compte De Départ De La Dispersion De Balle",
  T_49_META_TYP_79_I11_D: "ID D'article",
  T_49_META_TYP_79_I12_D: "Temps d'attente minimum en secondes entre les tirs, plusieurs tirs peuvent être tirés par coup selon le type de tir.",
  T_49_META_TYP_79_I13_D: "Le joueur qui possède l'arme",
  T_49_META_TYP_79_I14_D: "Consomme Des Munitions",
  T_49_META_TYP_79_I15_D: "Type de maniement double (0 pas de maniement double 1 et soi 2 et n'importe quelle arme)",
  T_49_META_TYP_79_I16_D: "Facteur de dégâts de l'armure",
  T_49_META_TYP_79_I17_D: "Effets de la vitesse de déplacement du joueur",
  T_49_META_TYP_79_I18_D: "Pourcentage de dégâts touchant le torse",
  T_49_META_TYP_79_I19_D: "Pourcentage de dégâts touchant la tête",
  T_49_META_TYP_79_I2_D: "Le temps d'attente entre les tirs, en secondes.",
  T_49_META_TYP_79_I20_D: "Pourcentage de dégâts touchant les membres",
  T_49_META_TYP_79_I21_D: "Dégâts supplémentaires (véhicule, baril de pétrole, mur de glace)",
  T_49_META_TYP_79_I22_D: "Visible Sur Le Dos",
  T_49_META_TYP_79_I23_D: "Dégâts supplémentaires en cas de contact avec le sol",
  T_49_META_TYP_79_I24_D: "Munitions Par Tir",
  T_49_META_TYP_79_I25_D: "Vitesse de changement de balle (vitesse de base * facteur)",
  T_49_META_TYP_79_I26_D: "Compte actuel de munitions",
  T_49_META_TYP_79_I27_D: "ID de la peau de l'arme",
  T_49_META_TYP_79_I28_D: "Lorsque les configurations du joueur sont prioritaires, la configuration de l'habillage de l'arme sur le joueur prévaut sur les propriétés de l'habillage de l'arme elle-même.",
  T_49_META_TYP_79_I29_D: "Lors de l'ajout d'une peau d'arme aux propriétés d'une arme, la valeur de base de l'arme est affectée par la peau d'arme.",
  T_49_META_TYP_79_I3_D: "Taille Du Chargeur De Munitions",
  T_49_META_TYP_79_I30_D: "Vitesse d'augmentation de la diffusion (0.1 = 10% d'élargissement de la collimation pour chaque salve supplémentaire)",
  T_49_META_TYP_79_I31_D: "Vitesse de récupération de la diffusion",
  T_49_META_TYP_79_I32_D: "Effet de vitesse du joueur lors du tir",
  T_49_META_TYP_79_I33_D: "Taille de la diffusion en cas de mouvement (1,5 = 1,5 * taille de base du collimateur)",
  T_49_META_TYP_79_I34_D: "Weapon Type",
  T_49_META_TYP_79_I36_D: "Fire Type",
  T_49_META_TYP_79_I37_D: "Est Tir Unique",
  T_49_META_TYP_79_I38_D: "Est Mis en Silence",
  T_49_META_TYP_79_I39_D: "Taux Vitesse de Mouvement ADS",
  T_49_META_TYP_79_I4_D: "Nombre Initial De Chargeurs",
  T_49_META_TYP_79_I5_D: "Pénétration d'Armure",
  T_49_META_TYP_79_I6_D: "Distance De Dégâts Complets",
  T_49_META_TYP_79_I7_D: "Distance Min De Dégâts",
  T_49_META_TYP_79_I8_D: "Dégâts Min",
  T_49_META_TYP_79_I9_D: "Nombre de coups pouvant être tirés avant que la dispersion ne commence.",
  T_49_META_TYP_80_I1_D: "Si vrai, la désactivation manuelle est désactivée.",
  T_49_META_TYP_80_I2_D: "Entités de l'atelier lié",
  T_49_META_TYP_80_I4_D: "ID du portefeuille lié",
  T_49_META_TYP_80_I5_D: "Type de demande",
  T_49_META_TYP_80_I6_D: "Le type de la cible pour la demande du joueur de l'interface utilisateur en cours.",
  T_49_META_TYP_80_I7_D: "ID du joueur déclencheur",
  T_49_META_TYP_81_I0_D: "Random Buff",
  T_49_META_TYP_81_I1_D: "HP Buff",
  T_49_META_TYP_81_I2_D: "Bullet Buff",
  T_49_META_TYP_81_I3_D: "Armor Buff",
  T_49_META_TYP_82_I1_D: "Icône du bouton",
  T_49_META_TYP_82_I3_D: "Position par rapport au point d'ancrage",
  T_49_META_TYP_83_I1_D: "Argent",
  T_49_META_TYP_83_I2_D: "Paramètres transmis",
  T_49_META_TYP_86_I0_D: "Minimum",
  T_49_META_TYP_86_I1_D: "Maximum",
  T_49_META_TYP_86_I2_D: "Coefficient de base, multiplié par la valeur d'origine avant tout calcul.",
  T_49_META_TYP_86_I3_D: "Pré-accumulateur, accumule avant la multiplication, participe aux calculs de multiplication.",
  T_49_META_TYP_86_I4_D: "Les multiplicateurs consécutifs, par exemple (réduit à 90 %, renforcé à 110 %), ont l'effet suivant : valeur*90 %*110 %.",
  T_49_META_TYP_86_I5_D: "Accumulateur de multiplication, par exemple (ajouter 10%, ajouter 5%) l'effet est Valeur*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Post-accumulateur, non impliqué dans les calculs de multiplication, empilé à la fin.",
  T_49_META_TYP_88_I0_D: "Type de base, la monnaie la plus basique du jeu, le type de prix général des objets dans la version actuelle.",
  T_49_META_TYP_89_I0_D: "Seule la monnaie de base est disponible dans la version actuelle",
  T_49_META_TYP_89_I1_D: "Montant de la monnaie",
  T_49_META_TYP_89_I2_D: "Icône de la devise",
  T_49_META_TYP_89_I3_D: "Couleur de l'icône de la monnaie",
  T_49_META_TYP_90_I0_D: "Le contenu du portefeuille est un ensemble de devises.",
  T_49_META_TYP_92_I0_D: "Caisse en bois carrée",
  T_49_META_TYP_92_I1_D: "Caisse en bois longue",
  T_49_META_TYP_92_I10_D: "Tour de guet",
  T_49_META_TYP_92_I100_D: "Escalier",
  T_49_META_TYP_92_I101_D: "Palier de l'escalier B",
  T_49_META_TYP_92_I102_D: "Palier de l'escalier A",
  T_49_META_TYP_92_I103_D: "Cabine téléphonique",
  T_49_META_TYP_92_I104_D: "Mur à thème BIS",
  T_49_META_TYP_92_I105_D: "Parterre de fleurs à thème BIS",
  T_49_META_TYP_92_I106_D: "Distributeur automatique",
  T_49_META_TYP_92_I107_D: "Entités Monstres",
  T_49_META_TYP_92_I108_D: "Générateur d'unités",
  T_49_META_TYP_92_I109_D: "Voiture de Sport",
  T_49_META_TYP_92_I11_D: "Poste de garde",
  T_49_META_TYP_92_I110_D: "Tuk-Tuk",
  T_49_META_TYP_92_I111_D: "Caisson en bois destructible",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Moto",
  T_49_META_TYP_92_I114_D: "Camion monstre",
  T_49_META_TYP_92_I115_D: "Générateur d'Or",
  T_49_META_TYP_92_I116_D: "Palier de l'escalier C",
  T_49_META_TYP_92_I117_D: "Signe",
  T_49_META_TYP_92_I118_D: "Clôture",
  T_49_META_TYP_92_I119_D: "Machine à maillot",
  T_49_META_TYP_92_I12_D: "Maison à deux étages",
  T_49_META_TYP_92_I121_D: "Pilier en béton",
  T_49_META_TYP_92_I122_D: "Boîte à loot football",
  T_49_META_TYP_92_I123_D: "Baril de pétrole",
  T_49_META_TYP_92_I124_D: "Zone de faible gravité",
  T_49_META_TYP_92_I125_D: "Arme",
  T_49_META_TYP_92_I126_D: "Clôture B",
  T_49_META_TYP_92_I127_D: "Petite maison A",
  T_49_META_TYP_92_I128_D: "Camion endommagé",
  T_49_META_TYP_92_I129_D: "Sphère de base",
  T_49_META_TYP_92_I13_D: "Sculpture de sable",
  T_49_META_TYP_92_I130_D: "Conique de base",
  T_49_META_TYP_92_I131_D: "Cylindre de base",
  T_49_META_TYP_92_I132_D: "Générateur de consommables",
  T_49_META_TYP_92_I133_D: "Corps d'eau personnalisé",
  T_49_META_TYP_92_I134_D: "Flèche",
  T_49_META_TYP_92_I135_D: "Bloc teinté",
  T_49_META_TYP_92_I136_D: "Fût teinté",
  T_49_META_TYP_92_I137_D: "Texte",
  T_49_META_TYP_92_I138_D: "Icône",
  T_49_META_TYP_92_I139_D: "Poupée de glace",
  T_49_META_TYP_92_I14_D: "Fontaine",
  T_49_META_TYP_92_I140_D: "Déclencheur en capsule",
  T_49_META_TYP_92_I141_D: "Déclencheur de collision sphérique",
  T_49_META_TYP_92_I142_D: "Bloc de couleur unie réfléchissant 1",
  T_49_META_TYP_92_I143_D: "Fabricant de voiture à amortisseurs",
  T_49_META_TYP_92_I144_D: "Bloc de parc d'attractions à carreaux",
  T_49_META_TYP_92_I145_D: "Grand écran",
  T_49_META_TYP_92_I146_D: "Podium",
  T_49_META_TYP_92_I147_D: "Grande sucette",
  T_49_META_TYP_92_I148_D: "Camion de Nourriture B",
  T_49_META_TYP_92_I15_D: "Arbre de cerisier",
  T_49_META_TYP_92_I16_D: "Maison de plain-pied",
  T_49_META_TYP_92_I17_D: "Maison à trois étages",
  T_49_META_TYP_92_I18_D: "Arbre à bananes",
  T_49_META_TYP_92_I19_D: "Toilette",
  T_49_META_TYP_92_I2_D: "Caisse en bois longue couverte de buissons",
  T_49_META_TYP_92_I20_D: "Clôture",
  T_49_META_TYP_92_I21_D: "Conteneur destructible",
  T_49_META_TYP_92_I22_D: "Clôture destructible",
  T_49_META_TYP_92_I23_D: "Pneu",
  T_49_META_TYP_92_I24_D: "Auto-tamponneuse",
  T_49_META_TYP_92_I25_D: "Véhicule amphibie",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Poubelle",
  T_49_META_TYP_92_I28_D: "Tente médicale",
  T_49_META_TYP_92_I29_D: "Garage",
  T_49_META_TYP_92_I3_D: "Meule de foin",
  T_49_META_TYP_92_I30_D: "Mur peint",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Plateforme en fer",
  T_49_META_TYP_92_I33_D: "Maison conteneur",
  T_49_META_TYP_92_I34_D: "Remorque",
  T_49_META_TYP_92_I35_D: "Mur A",
  T_49_META_TYP_92_I36_D: "Notes de musique - Piano",
  T_49_META_TYP_92_I37_D: "Notes de musique - Piano",
  T_49_META_TYP_92_I38_D: "Notes de musique - Batterie",
  T_49_META_TYP_92_I39_D: "Notes de musique - Batterie",
  T_49_META_TYP_92_I4_D: "Voiture accidentée",
  T_49_META_TYP_92_I40_D: "Notes de musique - Synthétiseur A",
  T_49_META_TYP_92_I41_D: "Notes de musique - Synthétiseur A",
  T_49_META_TYP_92_I42_D: "Notes de musique - Synthétiseur B",
  T_49_META_TYP_92_I43_D: "Notes de musique - Synthétiseur B",
  T_49_META_TYP_92_I44_D: "Notes de musique - Synthétiseur C",
  T_49_META_TYP_92_I45_D: "Notes de musique - Synthétiseur C",
  T_49_META_TYP_92_I46_D: "Générateur de buff",
  T_49_META_TYP_92_I47_D: "Mécanismes d'hélice",
  T_49_META_TYP_92_I48_D: "Butin Pan",
  T_49_META_TYP_92_I49_D: "Butin Cube",
  T_49_META_TYP_92_I5_D: "Bus accidenté",
  T_49_META_TYP_92_I50_D: "Butin Cercle",
  T_49_META_TYP_92_I51_D: "Machine à maillet",
  T_49_META_TYP_92_I52_D: "Planche mobile",
  T_49_META_TYP_92_I53_D: "Cible mobile",
  T_49_META_TYP_92_I54_D: "Mur rétractable",
  T_49_META_TYP_92_I55_D: "Loot Point Weapon Component (Composant d'arme à points de butin)",
  T_49_META_TYP_92_I56_D: "Composant Bullet Loot Point",
  T_49_META_TYP_92_I57_D: "Loot Point Expendable Item Component (Composant d'objet à dépenser)",
  T_49_META_TYP_92_I58_D: "Composants d'objets lancés à points de butin",
  T_49_META_TYP_92_I59_D: "Multiplicateur de points de butin",
  T_49_META_TYP_92_I6_D: "Container A",
  T_49_META_TYP_92_I60_D: "Composant d'armure à points de possession",
  T_49_META_TYP_92_I61_D: "Tuyau I",
  T_49_META_TYP_92_I62_D: "Tuyau T",
  T_49_META_TYP_92_I63_D: "Tuyau croisé",
  T_49_META_TYP_92_I64_D: "Tuyau coude",
  T_49_META_TYP_92_I65_D: "Groupe de champignons géants",
  T_49_META_TYP_92_I66_D: "Séchoir",
  T_49_META_TYP_92_I67_D: "Pont en planches",
  T_49_META_TYP_92_I68_D: "Écran",
  T_49_META_TYP_92_I69_D: "Colonne en béton",
  T_49_META_TYP_92_I7_D: "Conteneur B",
  T_49_META_TYP_92_I70_D: "Cactus",
  T_49_META_TYP_92_I71_D: "Bois mort",
  T_49_META_TYP_92_I72_D: "Lantern de palais",
  T_49_META_TYP_92_I73_D: "Réverbère",
  T_49_META_TYP_92_I74_D: "Panneau solaire",
  T_49_META_TYP_92_I75_D: "Climatiseur",
  T_49_META_TYP_92_I76_D: "Carré",
  T_49_META_TYP_92_I77_D: "Pente",
  T_49_META_TYP_92_I78_D: "Camion de nourriture",
  T_49_META_TYP_92_I79_D: "Déclencheur de mort ou d'invincibilité",
  T_49_META_TYP_92_I8_D: "Conteneur C",
  T_49_META_TYP_92_I80_D: "Point de contrôle",
  T_49_META_TYP_92_I81_D: "Position finale",
  T_49_META_TYP_92_I82_D: "Dé",
  T_49_META_TYP_92_I83_D: "Banc",
  T_49_META_TYP_92_I84_D: "Station de bus",
  T_49_META_TYP_92_I85_D: "Maison pour chien",
  T_49_META_TYP_92_I86_D: "Panneau publicitaire",
  T_49_META_TYP_92_I87_D: "Pot d'eau",
  T_49_META_TYP_92_I88_D: "Mur de graffiti",
  T_49_META_TYP_92_I89_D: "Hutte en chaume",
  T_49_META_TYP_92_I9_D: "Cabine",
  T_49_META_TYP_92_I90_D: "Pont en arc en pierre",
  T_49_META_TYP_92_I91_D: "Ensemble de patio avec parasol",
  T_49_META_TYP_92_I92_D: "Bannière d'arrivée",
  T_49_META_TYP_92_I93_D: "Forteresse",
  T_49_META_TYP_92_I94_D: "Point D'apparition Du Monstre",
  T_49_META_TYP_92_I95_D: "Marque",
  T_49_META_TYP_92_I97_D: "Déclencheur personnalisé",
  T_49_META_TYP_92_I98_D: "Double porte",
  T_49_META_TYP_92_I99_D: "Barricade",
  T_49_META_TYP_94_I0_D: "Ajouter",
  T_49_META_TYP_94_I1_D: "Multiplier",
  T_49_META_TYP_95_I0_D: "Type de monnaie",
  T_49_META_TYP_95_I1_D: "Montant de la monnaie",
  T_49_META_TYP_96_I0_D: "Obtenir le portefeuille",
  T_49_META_TYP_96_I1_D: "Position d'affichage (l'ancre est en haut à droite)",
  T_49_META_TYP_97_I0_D: "Position dans le système de coordonnées du monde",
  T_49_META_TYP_97_I1_D: "Angle de rotation dans le système de coordonnées du monde, les composantes XYZ sont respectivement le tangage, le lacet et le roulis, et l'ordre de rotation YXZ.",
  T_49_META_TYP_97_I10_D: "Orientation de l'axe local x",
  T_49_META_TYP_97_I11_D: "Orientation de l'axe local z",
  T_49_META_TYP_97_I2_D: "Taille de mise à l'échelle dans le système de coordonnées du monde",
  T_49_META_TYP_97_I3_D: "Nœud parent de ce nœud",
  T_49_META_TYP_97_I4_D: "Rotation dans le système de coordonnées mondial, exprimée en quaternions",
  T_49_META_TYP_97_I5_D: "Position dans le système de coordonnées local",
  T_49_META_TYP_97_I6_D: "Rotation dans le système de coordonnées local, exprimée en quaternions",
  T_49_META_TYP_97_I7_D: "Angle de rotation dans le système de coordonnées local, avec des composantes XYZ pour le tangage, le lacet et le roulis, respectivement, et un ordre de rotation YXZ.",
  T_49_META_TYP_97_I8_D: "Dimension d'échelle dans le système de coordonnées locales",
  T_49_META_TYP_97_I9_D: "Orientation de l'axe des coordonnées locales y",
  T_49_META_TYP_99_I0_D: "Rayon de football",
  T_49_META_TYP_99_I1_D: "Coefficient de friction à l'état normal",
  T_49_META_TYP_99_I2_D: "Coefficient de friction à l'impact",
  T_49_META_TYP_99_I3_D: "Angle De Tir Min",
  T_49_META_TYP_99_I4_D: "Angle D'élévation Min.",
  T_49_META_TYP_99_I5_D: "Temps De Réinitialisation",
  T_49_META_TYP_99_I6_D: "Angle De Tir Max",
  T_49_META_TYP_99_I7_D: "Réinitialiser La Position",
  T_49_META_TYPE_0_D: "Objet, racine de la hiérarchie des types",
  T_49_META_TYPE_1_D: "Un conteneur pour un ensemble de données dans une liste",
  T_49_META_TYPE_10_D: "Composant de base de l'entité, tous les composants combinent ce composant.",
  T_49_META_TYPE_100_D: "JerseyMachine",
  T_49_META_TYPE_101_D: "Objet morphable",
  T_49_META_TYPE_1010_D: "Informations sur le minuteur",
  T_49_META_TYPE_1011_D: "Bannière d'ouverture",
  T_49_META_TYPE_1012_D: "Les entités de bannière commencent dans les rounds à deux équipes, la modification des attributs de l'entité affecte le contenu affiché sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1013_D: "Bannière de début de tour général, la modification des attributs de l'entité affectera le contenu affiché sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1014_D: "Bannière de score de la ronde des équipes, la modification des attributs de l'entité affecte l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1015_D: "Entité Checkpoint Manager, la modification des attributs de l'entité affecte l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1016_D: "Entité d'affichage de fin de tour, la modification des attributs de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1017_D: "S'il y a deux équipes au début du tour, afficher la bannière de rivalité des deux équipes.",
  T_49_META_TYPE_1018_D: "Score du tour des deux équipes",
  T_49_META_TYPE_1019_D: "Le résultat final est une égalité victoire/défaite",
  T_49_META_TYPE_102_D: "Type de source de résurrection : mort, en panne",
  T_49_META_TYPE_1020_D: "Entité de décompte du tour, la modification des attributs de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1021_D: "Entité de compte à rebours, la modification des attributs de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1022_D: "Match information subheading entity, modifier les attributs de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1023_D: "Entité d'information sur le match de deux équipes, la modification des attributs de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1024_D: "Une équipe correspond à l'entité UI information, la modification des attributs de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1027_D: "Décrit le type du type et renvoie ce type lorsque Typeof est utilisé.",
  T_49_META_TYPE_1028_D: "Information sur le camp, modifier l'attribut de l'entité pour affecter le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1029_D: "Entité d'information sur l'icône, la modification des attributs de l'entité affectera le contenu affiché sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_103_D: "Enumération des emplacements d'objets",
  T_49_META_TYPE_1030_D: "Version courte de l'entité d'information sur le match des deux équipes, la modification des attributs de l'entité aura une incidence sur le contenu affiché dans l'interface utilisateur correspondante.",
  T_49_META_TYPE_1031_D: "Entité d'interface d'indication de temps, la modification des propriétés de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1032_D: "Entité d'invite de mots flottants, la modification des attributs de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1033_D: "Entité de changement de tour, comprenant l'information sur le règlement du tour actuel et le début du prochain tour, la modification des propriétés de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_1035_D: "Ouvrir l'entité UI du bouton du tableau d'affichage, la modification des attributs de l'entité affectera le contenu de l'affichage de l'interface utilisateur correspondante.",
  T_49_META_TYPE_1036_D: "Infected mode, affiche l'interface utilisateur du niveau de zombie actuel.",
  T_49_META_TYPE_1037_D: "Ajouter l'entité UI animation des points, modifier les attributs de l'entité pour affecter le contenu de l'affichage sur l'UI correspondante.",
  T_49_META_TYPE_1038_D: "Mode infecté, effets de l'interface utilisateur des zombies",
  T_49_META_TYPE_1039_D: "Entité Countdown prompt, la modification des propriétés de l'entité affectera le contenu de l'affichage de l'interface utilisateur correspondante.",
  T_49_META_TYPE_104_D: "Jersey Style",
  T_49_META_TYPE_1040_D: "Panneau de Sélection de Cartes UI",
  T_49_META_TYPE_1041_D: "Notification D'identité UI",
  T_49_META_TYPE_1042_D: "Compte à rebours de 5 secondes UI",
  T_49_META_TYPE_1043_D: "Bannière de Titre UI",
  T_49_META_TYPE_1044_D: "Commutateur UI Intégré",
  T_49_META_TYPE_1045_D: "Bouton de compétence UI",
  T_49_META_TYPE_105_D: "But de football",
  T_49_META_TYPE_106_D: "Type d'aide à la visée",
  T_49_META_TYPE_107_D: "Entités pouvant être ciblées et touchées, mais pas nécessairement endommagées",
  T_49_META_TYPE_108_D: "Types d'entiers, entiers signés sur 64 bits",
  T_49_META_TYPE_109_D: "L'entité canal de discussion est un conteneur contenant l'identifiant du canal et les joueurs.",
  T_49_META_TYPE_11_D: "Entité globale, unique pour tout le jeu",
  T_49_META_TYPE_110_D: "Canal vocal inactif",
  T_49_META_TYPE_111_D: "Types de comportement",
  T_49_META_TYPE_112_D: "Type de statut de comportement du joueur",
  T_49_META_TYPE_113_D: "Musique de batterie",
  T_49_META_TYPE_114_D: "Musique Lead1",
  T_49_META_TYPE_115_D: "Musique Lead2",
  T_49_META_TYPE_116_D: "Musique Lead3",
  T_49_META_TYPE_117_D: "Type de composant musical Drum beat",
  T_49_META_TYPE_118_D: "Faction",
  T_49_META_TYPE_119_D: "Options d'attaque",
  T_49_META_TYPE_12_D: "Entités de combat, peuvent attaquer, prendre des coups, tuer, etc.",
  T_49_META_TYPE_120_D: "Barre de progression UI",
  T_49_META_TYPE_121_D: "Intervalle entre les vagues",
  T_49_META_TYPE_122_D: "Skybox",
  T_49_META_TYPE_123_D: "Enumération des types de base skybox",
  T_49_META_TYPE_124_D: "Plage de revendication ennemie",
  T_49_META_TYPE_125_D: "Peut modifier l'apparence de base des objets, comme le mappage et la transparence.",
  T_49_META_TYPE_126_D: "Barre de santé",
  T_49_META_TYPE_127_D: "Comment déplacer les objets",
  T_49_META_TYPE_128_D: "Objet morphable",
  T_49_META_TYPE_129_D: "Type de munitions de butin",
  T_49_META_TYPE_13_D: "Entité de contrôle de l'interface utilisateur",
  T_49_META_TYPE_130_D: "Type de consommable de butin",
  T_49_META_TYPE_131_D: "Type d'armure de butin",
  T_49_META_TYPE_132_D: "Type d'objet lançable de butin",
  T_49_META_TYPE_133_D: "Type de lunette de butin",
  T_49_META_TYPE_134_D: "Type d'arme de butin",
  T_49_META_TYPE_135_D: "Génère des largages de munitions du type sélectionné",
  T_49_META_TYPE_136_D: "Génère un type d'accessoire sélectionné",
  T_49_META_TYPE_137_D: "Génère un type de chute de projectile sélectionné",
  T_49_META_TYPE_138_D: "Génère un drop de portée du type sélectionné",
  T_49_META_TYPE_139_D: "Génère une chute de défense du type sélectionné.",
  T_49_META_TYPE_14_D: "Entités du joueur dans le jeu, une par utilisateur",
  T_49_META_TYPE_140_D: "Vague",
  T_49_META_TYPE_141_D: "Type de loot football",
  T_49_META_TYPE_142_D: "Boîte à loot football",
  T_49_META_TYPE_143_D: "Type de composant musical Lead1",
  T_49_META_TYPE_144_D: "Type de composant musical Lead2",
  T_49_META_TYPE_145_D: "Type de composant musical Lead3",
  T_49_META_TYPE_146_D: "Type de composant musical Key",
  T_49_META_TYPE_147_D: "Plusieurs types de caméra prédéfinis sont disponibles, ainsi que des types de caméra personnalisés.",
  T_49_META_TYPE_148_D: "Composants de la caméra",
  T_49_META_TYPE_149_D: "Clé de Localisation",
  T_49_META_TYPE_15_D: "Entités d'équipe dans le jeu, une par équipe",
  T_49_META_TYPE_150_D: "Baril de pétrole",
  T_49_META_TYPE_151_D: "Le quaternion est un vecteur quadridimensionnel spécial utilisé uniquement pour représenter les rotations.",
  T_49_META_TYPE_152_D: "Zone de faible gravité",
  T_49_META_TYPE_153_D: "Conteneurs d'entités, qui génèrent des entités du type correspondant à l'emplacement.",
  T_49_META_TYPE_154_D: "Dual-Wield Weapon Type",
  T_49_META_TYPE_155_D: "Entité casque",
  T_49_META_TYPE_156_D: "Armure corporelle",
  T_49_META_TYPE_157_D: "Type de transition de la caméra",
  T_49_META_TYPE_158_D: "Interface d'invite de texte",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Entités d'objets de niveau",
  T_49_META_TYPE_160_D: "Types de textures",
  T_49_META_TYPE_161_D: "VFX de texture non remplaçable",
  T_49_META_TYPE_162_D: "Liste de Types",
  T_49_META_TYPE_163_D: "Type ou Liste de Types",
  T_49_META_TYPE_164_D: "Composant est la classe de base de tous les composants de l'entité ou de classes de composants spécifiques.",
  T_49_META_TYPE_165_D: "Composants de la boîte de collision",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "L'entité Special effect représente un effet spécial affiché (supprimé, réutilisable).",
  T_49_META_TYPE_17_D: "Level Object List",
  T_49_META_TYPE_170_D: "Indique si la visibilité peut être définie",
  T_49_META_TYPE_171_D: "Champignon",
  T_49_META_TYPE_172_D: "Munitions",
  T_49_META_TYPE_173_D: "Sac à dos",
  T_49_META_TYPE_174_D: "Composant de la grenade",
  T_49_META_TYPE_175_D: "Grenade de congélation",
  T_49_META_TYPE_176_D: "Weapon Generator",
  T_49_META_TYPE_177_D: "Mode mouvement de la caméra lorsqu'il y a un obstacle entre la caméra et l'objet qu'elle suit",
  T_49_META_TYPE_178_D: "Style d'image de la caméra lors du rendu d'un écran",
  T_49_META_TYPE_179_D: "Sphère de base",
  T_49_META_TYPE_18_D: "(Déclassé, ne pas utiliser)",
  T_49_META_TYPE_180_D: "fait référence à une propriété d'un composant",
  T_49_META_TYPE_181_D: "Types utilisés pour décrire les maillages",
  T_49_META_TYPE_182_D: "Un type utilisé pour décrire une ressource matérielle",
  T_49_META_TYPE_183_D: "Un type utilisé pour décrire une texture",
  T_49_META_TYPE_184_D: "Composant de rendu ponté pour le rendu avec des ressources de modèle intégrées",
  T_49_META_TYPE_185_D: "Composant de rendu personnalisé pour le rendu avec des ressources de modèle personnalisées",
  T_49_META_TYPE_186_D: "Un assemblage d'objets vierges qui peut être utilisé en conjonction avec des assemblages de moteurs de rendu, des assemblages de collisionneurs, etc.",
  T_49_META_TYPE_187_D: "Conteneur",
  T_49_META_TYPE_188_D: "Cylindre de base",
  T_49_META_TYPE_189_D: "Liste des chaînes localisées",
  T_49_META_TYPE_19_D: "Modèles de liste, le type de contenu peut être spécifié par T",
  T_49_META_TYPE_190_D: "Panneau de score à deux équipes",
  T_49_META_TYPE_191_D: "Arme tactique lancée qui aveugle les ennemis se trouvant à une certaine distance pendant une courte période.",
  T_49_META_TYPE_192_D: "Lorsqu'elle est utilisée, elle peut produire de la fumée qui obscurcit les événements, un outil utile pour perturber les attaques ennemies.",
  T_49_META_TYPE_193_D: "Panneau de résultats multi-équipes",
  T_49_META_TYPE_194_D: "Mines à capteurs qui peuvent être placées sur le sol et qui exploseront lorsque les ennemis s'en approcheront.",
  T_49_META_TYPE_195_D: "Jeu de mouvement interpolé",
  T_49_META_TYPE_197_D: "Composants jouables",
  T_49_META_TYPE_198_D: "Base de l'objet",
  T_49_META_TYPE_199_D: "Facilite les combats aériens, mais vous devez être conscient de la consommation d'énergie à tout moment.",
  T_49_META_TYPE_2_D: "Types booléens, utilisés pour indiquer true, false, ou yes ou no",
  T_49_META_TYPE_20_D: "Énumération de types d'interface intégrée, générée automatiquement par le système de types.",
  T_49_META_TYPE_200_D: "Zone d'évasion",
  T_49_META_TYPE_201_D: "Zones où vous pouvez nager après être entré",
  T_49_META_TYPE_202_D: "ID du Collider",
  T_49_META_TYPE_203_D: "Mouvement interpolé",
  T_49_META_TYPE_204_D: "Des chaussures équipées de bonus technologiques qui permettent de sauter en l'air en deux étapes.",
  T_49_META_TYPE_205_D: "Un planeur qui peut voler dans le ciel, utilisez-le pour atterrir d'un endroit élevé afin de vous éloigner.",
  T_49_META_TYPE_206_D: "Planche à roulettes",
  T_49_META_TYPE_207_D: "Zipline",
  T_49_META_TYPE_208_D: "Liste des jouables",
  T_49_META_TYPE_209_D: "Jouable ou liste de jouables",
  T_49_META_TYPE_21_D: "Entités d'interface intégrées, qui encapsulent des fonctionnalités spécifiques.",
  T_49_META_TYPE_210_D: "L'animation balistique est une simulation de mouvement balistique.",
  T_49_META_TYPE_211_D: "Type de filtre",
  T_49_META_TYPE_212_D: "Un objet suit un autre objet",
  T_49_META_TYPE_213_D: "La face avant d'un objet fait toujours face à un autre objet.",
  T_49_META_TYPE_214_D: "Un ID pour décrire la ressource sprite de la galerie",
  T_49_META_TYPE_215_D: "résultats d'un concours",
  T_49_META_TYPE_216_D: "Conteneur de données de dictionnaire, l'élément de données est une paire de clés et de valeurs.",
  T_49_META_TYPE_217_D: "Modèle de données de dictionnaire, le type de contenu peut être spécifié par T1, T2",
  T_49_META_TYPE_218_D: "Type de source lumineuse qui émet une lumière d'intensité égale dans toutes les directions à partir de la position de la source lumineuse.",
  T_49_META_TYPE_219_D: "Porte-moto",
  T_49_META_TYPE_22_D: "Interfaces personnalisées, créées par le joueur à l'aide de l'éditeur d'interface.",
  T_49_META_TYPE_220_D: "Véhicule d'assaut (tricycle)",
  T_49_META_TYPE_221_D: "Véhicule amphibie/machine à feu Moto",
  T_49_META_TYPE_222_D: "Véhicule à quatre roues",
  T_49_META_TYPE_224_D: "Liste de Types de Compétence",
  T_49_META_TYPE_225_D: "Tourelle IA composée de matériaux de haute technologie qui recherche et attaque activement les ennemis dans un certain rayon d'action.",
  T_49_META_TYPE_226_D: "Tourelles générées à l'aide d'accessoires de tourelle",
  T_49_META_TYPE_227_D: "Énumération des types de contrôles personnalisés de l'interface utilisateur",
  T_49_META_TYPE_23_D: "Une énumération des types d'objets du niveau, générée automatiquement en fonction du type.",
  T_49_META_TYPE_231_D: "Kit de réparation",
  T_49_META_TYPE_233_D: "Cercle de progression",
  T_49_META_TYPE_234_D: "Mine créée",
  T_49_META_TYPE_235_D: "Mur de gel",
  T_49_META_TYPE_236_D: "Mur de glace créé",
  T_49_META_TYPE_237_D: "Arme à crochet",
  T_49_META_TYPE_238_D: "Pistolet à peinture arc-en-ciel",
  T_49_META_TYPE_239_D: "Fusil à spray",
  T_49_META_TYPE_24_D: "Les types de dommages actuels définis par le système",
  T_49_META_TYPE_240_D: "Les entités sont les supports de tous les composants, et les composants doivent être attachés à une entité afin de générer des instances.",
  T_49_META_TYPE_241_D: "Pistolet à crochets",
  T_49_META_TYPE_242_D: "Barre de score",
  T_49_META_TYPE_243_D: "Emplacements de vêtements",
  T_49_META_TYPE_244_D: "L'entité Texte représente un texte affiché",
  T_49_META_TYPE_245_D: "L'entité Icône représente une icône affichée",
  T_49_META_TYPE_246_D: "Couleur de spray",
  T_49_META_TYPE_247_D: "Type d'UI du Joueur",
  T_49_META_TYPE_248_D: "Entité de commutation de l'interface utilisateur générale",
  T_49_META_TYPE_249_D: "Changement de slot d'équipement",
  T_49_META_TYPE_25_D: "Les phases du jeu, telles que le début du jeu, la préparation du jeu, la fin du jeu, etc.",
  T_49_META_TYPE_250_D: "L'entité Effects représente un effet spécial affiché",
  T_49_META_TYPE_2500_D: "Le point de naissance du joueur",
  T_49_META_TYPE_2501_D: "Déclencheurs utilisés pour déclencher les événements d'entrée et de sortie du joueur (ou d'un autre objet)",
  T_49_META_TYPE_2502_D: "Déclencheurs de mort ou d'invincibilité qui contrôlent si le joueur est mort ou invincible lorsqu'il entre en fonction des attributs.",
  T_49_META_TYPE_2503_D: "Points de contrôle en mode course",
  T_49_META_TYPE_2504_D: "Généralement utilisés en mode course pour reconnaître le moment où un joueur franchit une ligne d'arrivée donnée. Il s'agit d'un déclencheur spécifique, les déclencheurs personnalisés seront ouverts ultérieurement, ce point de terminaison est juste une en",
  T_49_META_TYPE_2505_D: "Clôture autour du point de naissance, la fermer pour quitter le point de naissance",
  T_49_META_TYPE_2507_D: "Tour",
  T_49_META_TYPE_2508_D: "Spawn de monstre",
  T_49_META_TYPE_2509_D: "Des instances de ce type peuvent être générées à la demande.",
  T_49_META_TYPE_251_D: "Conteneur d'effets",
  T_49_META_TYPE_2510_D: "Zone de naissance du joueur (rectangle)",
  T_49_META_TYPE_252_D: "UI de résultats de spray",
  T_49_META_TYPE_253_D: "Bouton d'indice",
  T_49_META_TYPE_254_D: "Effet de battement de cœur",
  T_49_META_TYPE_255_D: "Chaîne de localisation de timestamp",
  T_49_META_TYPE_256_D: "Type Rigidbody",
  T_49_META_TYPE_257_D: "Composants du corps rigide",
  T_49_META_TYPE_258_D: "Стиль форматирования временной метки",
  T_49_META_TYPE_259_D: "Conseils",
  T_49_META_TYPE_26_D: "Les tours du jeu, souvent un petit jeu avec plusieurs phases.",
  T_49_META_TYPE_260_D: "Bouton de compétence de progression",
  T_49_META_TYPE_261_D: "ID unique",
  T_49_META_TYPE_262_D: "ID de Skin D'arme",
  T_49_META_TYPE_263_D: "Identification des vêtements",
  T_49_META_TYPE_264_D: "ID de l'accessoire, lorsque la version ne possède que l'ID de l'arme",
  T_49_META_TYPE_265_D: "Entité UI panel",
  T_49_META_TYPE_267_D: "Entité UI scroll view, interface utilisateur éditée par le joueur via l'éditeur d'interface utilisateur",
  T_49_META_TYPE_268_D: "Interrupteurs à trois états, avec la possibilité de conserver la logique d'origine, à l'exception de l'activation et de la désactivation.",
  T_49_META_TYPE_269_D: "Vêtements dont le joueur est équipé",
  T_49_META_TYPE_270_D: "ID D'entité ou De Préfab",
  T_49_META_TYPE_271_D: "Entité UI panel, interface utilisateur éditée par le joueur via l'éditeur d'interface utilisateur",
  T_49_META_TYPE_272_D: "Énumération des genres",
  T_49_META_TYPE_273_D: "Mini-carte",
  T_49_META_TYPE_274_D: "Icône affichée sur la mini-carte pour suivre la cible",
  T_49_META_TYPE_275_D: "Nœuds de pièces individuelles dans le squelette",
  T_49_META_TYPE_276_D: "Nœuds utilisés pour accéder au squelette skinné",
  T_49_META_TYPE_277_D: "Détection des rayons de la caméra côté client",
  T_49_META_TYPE_278_D: "Blocs de pixels affichés sur la mini-carte, représentant la taille de collision de l'objet à cette position.",
  T_49_META_TYPE_279_D: "Tambour de couleur",
  T_49_META_TYPE_28_D: "Réinitialisé au début de chaque tour.",
  T_49_META_TYPE_280_D: "Déclencheur sphérique",
  T_49_META_TYPE_281_D: "Déclencheur en capsule",
  T_49_META_TYPE_282_D: "Type décrivant l'ID de configuration de l'actif, utilisé pour indiquer que le paquet parent est livré avec l'ID de configuration de l'actif, qui doit être analysé dans la table de configuration avant d'être chargé.",
  T_49_META_TYPE_283_D: "Le type de ressource, utilisé pour indiquer l'identifiant de la ressource, peut être chargé directement.",
  T_49_META_TYPE_284_D: "Indique une ressource de modèle humanoïde qui peut être remplacée par un personnage de joueur.",
  T_49_META_TYPE_285_D: "les listes ou les dictionnaires, qui peuvent être parcourus de manière cyclique",
  T_49_META_TYPE_286_D: "ID pour décrire la ressource script",
  T_49_META_TYPE_287_D: "pour décrire l'identifiant d'une ressource script statique",
  T_49_META_TYPE_288_D: "pour décrire l'ID d'une ressource d'interface personnalisée",
  T_49_META_TYPE_289_D: "ID pour décrire le corps d'une ressource préconfigurée",
  T_49_META_TYPE_29_D: "Effets spéciaux",
  T_49_META_TYPE_290_D: "Arbre de comportement",
  T_49_META_TYPE_291_D: "Type De Nœud De L'arbre De Comportement",
  T_49_META_TYPE_292_D: "Nœud personnalisé de l'arbre de comportement",
  T_49_META_TYPE_293_D: "Arbre de comportement attachable",
  T_49_META_TYPE_294_D: "Entité UI layout, UI éditée par le joueur via l'éditeur d'UI",
  T_49_META_TYPE_295_D: "Temps d'attente (s)",
  T_49_META_TYPE_296_D: "Clip d'animation",
  T_49_META_TYPE_297_D: "Contrôleur D'animation",
  T_49_META_TYPE_298_D: "Dégâts",
  T_49_META_TYPE_3_D: "Types entiers, entiers signés de 32 bits",
  T_49_META_TYPE_30_D: "Icône",
  T_49_META_TYPE_300_D: "Entité UI3DContainer, interface utilisateur éditée par le joueur via l'éditeur d'interface utilisateur",
  T_49_META_TYPE_301_D: "Type De Compétence IA",
  T_49_META_TYPE_302_D: "Enumération des emplacements d'équipement",
  T_49_META_TYPE_303_D: "Correspond à la colonne Id dans BuffData.csv, veuillez vérifier avec GPP avant d'ajouter de nouveaux éléments.",
  T_49_META_TYPE_304_D: "Liste de Types de Buff",
  T_49_META_TYPE_305_D: "Statut Du Nœud De L'arbre De Comportement",
  T_49_META_TYPE_306_D: "Peut ajouter des buffs, en retirer, obtenir une liste des buffs déjà ajoutés",
  T_49_META_TYPE_307_D: "Créateur de Mur de Glace",
  T_49_META_TYPE_308_D: "Special Item ID Type",
  T_49_META_TYPE_309_D: "Accessoires d'objets lancés",
  T_49_META_TYPE_31_D: "Effets sonores",
  T_49_META_TYPE_310_D: "Arbalète",
  T_49_META_TYPE_311_D: "Base de grenade",
  T_49_META_TYPE_312_D: "Accessoires d'objets lancés",
  T_49_META_TYPE_313_D: "Граната для блокировки льда",
  T_49_META_TYPE_314_D: "Gestion des contrôleurs d'animation et des ressources",
  T_49_META_TYPE_315_D: "Sac À Dos Du Joueur",
  T_49_META_TYPE_316_D: "Entité UITexture, l'interface utilisateur du joueur éditée par l'éditeur d'interface utilisateur",
  T_49_META_TYPE_317_D: "Contraintes de mouvement du corps rigide, chacune pouvant être utilisée en combinaison",
  T_49_META_TYPE_318_D: "Accessoire",
  T_49_META_TYPE_319_D: "Énumération des types de remplissage",
  T_49_META_TYPE_32_D: "Type d'état du joueur",
  T_49_META_TYPE_320_D: "Direction de remplissage",
  T_49_META_TYPE_321_D: "Entités pouvant être ciblées et touchées, mais pas nécessairement endommagées",
  T_49_META_TYPE_322_D: "Type de Partie du Corps Endommagée",
  T_49_META_TYPE_323_D: "Entité UIProfileInfo, interface utilisateur éditée par le joueur via l'éditeur d'interface utilisateur",
  T_49_META_TYPE_324_D: "Plusieurs effets différents des forces du corps rigide. Notez que cela n'est disponible que pour les types dynamiques.",
  T_49_META_TYPE_325_D: "pour décrire l'ID d'un contrôle dans une interface personnalisée",
  T_49_META_TYPE_326_D: "Informations sur le profil du joueur",
  T_49_META_TYPE_327_D: "Configurer l'habillage en fonction de chaque composant",
  T_49_META_TYPE_328_D: "ID D'arbre De Comportement",
  T_49_META_TYPE_329_D: "Type de siège",
  T_49_META_TYPE_33_D: "Trier par : croissant ignorer la valeur zéro, décroissant, croissant",
  T_49_META_TYPE_330_D: "Mouvement par rapport à lui-même",
  T_49_META_TYPE_331_D: "Courbe de Bezier",
  T_49_META_TYPE_332_D: "Composants jouables en boucle",
  T_49_META_TYPE_333_D: "Type de police",
  T_49_META_TYPE_334_D: "ID De Skin De Véhicule",
  T_49_META_TYPE_335_D: "L'entité sound représente un effet sonore en cours de jeu",
  T_49_META_TYPE_336_D: "Liste des effets sonores",
  T_49_META_TYPE_337_D: "Effet sonore ou liste des effets sonores",
  T_49_META_TYPE_338_D: "Entité de synchronisation des attributs du comportement du joueur",
  T_49_META_TYPE_339_D: "Accessoire d'équipement",
  T_49_META_TYPE_34_D: "ID de l'objet",
  T_49_META_TYPE_340_D: "Type de difficulté des bots",
  T_49_META_TYPE_341_D: "Dictionnaire d'entiers",
  T_49_META_TYPE_342_D: "Objets chronométreurs",
  T_49_META_TYPE_343_D: "Dagues volantes (peuvent être ramassées)",
  T_49_META_TYPE_344_D: "Couteau de lancer",
  T_49_META_TYPE_345_D: "Weapon Type",
  T_49_META_TYPE_346_D: "Ammo Type",
  T_49_META_TYPE_347_D: "Auto-relatif par image",
  T_49_META_TYPE_348_D: "Pointeur de fonction vers une instance de fonction, utilisé pour mettre en œuvre une fonction fictive ou un mécanisme de délégation.",
  T_49_META_TYPE_349_D: "Pointeur de fonction vers une instance de fonction, utilisé pour mettre en œuvre une fonction fictive ou un mécanisme de délégation.",
  T_49_META_TYPE_350_D: "Énumération des véhicules",
  T_49_META_TYPE_351_D: "Décrit le type de l'objet",
  T_49_META_TYPE_352_D: "Entité UIToggle, interface utilisateur éditée par le joueur via l'éditeur d'interface utilisateur",
  T_49_META_TYPE_353_D: "Kit de premiers secours",
  T_49_META_TYPE_354_D: "Inhalateur",
  T_49_META_TYPE_355_D: "Ligne horizontale",
  T_49_META_TYPE_356_D: "Les parachutes, qui commencent à tomber d'un endroit élevé une fois le temps de préparation écoulé.",
  T_49_META_TYPE_357_D: "Couleurs descriptives pour les objets, par exemple les bordures, les surfaces, etc.",
  T_49_META_TYPE_358_D: "fait référence à un événement particulier.",
  T_49_META_TYPE_359_D: "Contrôleurs de joueur avec effets physiques, qui peuvent appliquer des forces aux forces",
  T_49_META_TYPE_360_D: "Plate-forme de lancement",
  T_49_META_TYPE_361_D: "Canon plié, lorsqu'il est déplié, il peut être utilisé pour lancer des personnes à l'extérieur. Attention à ne pas vous lancer vous-même hors de la zone de sécurité !",
  T_49_META_TYPE_362_D: "Combat de boules de neige ! Donnez un coup de poing !",
  T_49_META_TYPE_363_D: "Demande d'achat en boutique",
  T_49_META_TYPE_364_D: "Déclencheur d'animation",
  T_49_META_TYPE_365_D: "Composant d'interface de déclenchement animé",
  T_49_META_TYPE_366_D: "Rendu Combiné Par Lots",
  T_49_META_TYPE_367_D: "Boussole supérieure",
  T_49_META_TYPE_368_D: "Rôle personnalisé ID de la ressource",
  T_49_META_TYPE_369_D: "ID de ressource d'animation personnalisé",
  T_49_META_TYPE_370_D: "Informations affichées au début de la manche",
  T_49_META_TYPE_371_D: "A la fin de chaque round, les résultats sont affichés",
  T_49_META_TYPE_372_D: "Types d'état du joueur",
  T_49_META_TYPE_373_D: "ID de collection, utilisé pour la collecte d'informations sur les ressources",
  T_49_META_TYPE_374_D: "Barre de santé de suivi",
  T_49_META_TYPE_375_D: "Type de cible de monstre",
  T_49_META_TYPE_376_D: "Type de cible d'attaque de tour défensive",
  T_49_META_TYPE_377_D: "Alias faisant référence au type d'entité joueur ou véhicule",
  T_49_META_TYPE_378_D: "pour décrire l'ID d'une ressource audio",
  T_49_META_TYPE_379_D: "ID pour décrire la ressource table de configuration",
  T_49_META_TYPE_38_D: "Entité UI Empty Widget, UI éditée par le joueur via l'éditeur d'UI.",
  T_49_META_TYPE_380_D: "ID pour décrire la ressource d'effets",
  T_49_META_TYPE_381_D: "ID pour décrire la ressource contrôleur d'animation",
  T_49_META_TYPE_382_D: "Comment le statut de knockdown est géré",
  T_49_META_TYPE_383_D: "Surface ou décorations sur la carte elle-même",
  T_49_META_TYPE_384_D: "Objets",
  T_49_META_TYPE_385_D: "ID de la compétence du personnage",
  T_49_META_TYPE_386_D: "Liste D'ID de Compétence",
  T_49_META_TYPE_387_D: "Entité UITouchPad, interface utilisateur éditée par le joueur via l'éditeur d'interface utilisateur",
  T_49_META_TYPE_388_D: "ID De Skin De Sac À Dos",
  T_49_META_TYPE_389_D: "Entité Joystick, interface utilisateur éditée par le joueur via l'éditeur d'interface utilisateur",
  T_49_META_TYPE_39_D: "Entité UI image, l'interface utilisateur éditée par le lecteur via l'éditeur d'interface utilisateur.",
  T_49_META_TYPE_390_D: "Hiérarchique",
  T_49_META_TYPE_391_D: "UI ou Widget personnalisé",
  T_49_META_TYPE_392_D: "Les objets de l'anneau de poison qui peuvent être placés",
  T_49_META_TYPE_393_D: "Entités dotées de composants PhysicalCCT ou Rigidbody.",
  T_49_META_TYPE_394_D: "Constantes mathématiques",
  T_49_META_TYPE_395_D: "Les entités dotées de composants PhysicalCCT ou PlayerCCT peuvent se déplacer avec eux.",
  T_49_META_TYPE_396_D: "Configuration de sortie de jeu",
  T_49_META_TYPE_397_D: "Composantes utilisées pour décrire les formes de collision",
  T_49_META_TYPE_398_D: "Chaîne ou chaîne localisée",
  T_49_META_TYPE_399_D: "Contrôleur de personnage avec effets physiques, pour les personnages FF uniquement.",
  T_49_META_TYPE_4_D: "Type à virgule flottante, nombre à virgule flottante de précision unique sur 32 bits",
  T_49_META_TYPE_40_D: "Entité UI Text, l'interface utilisateur éditée par le joueur via l'éditeur d'interface utilisateur.",
  T_49_META_TYPE_400_D: "Comment exécuter le comportement d'attaque",
  T_49_META_TYPE_401_D: "Fire Type",
  T_49_META_TYPE_402_D: "Widget de bouton social",
  T_49_META_TYPE_403_D: "Types de boutons sociaux",
  T_49_META_TYPE_404_D: "Styles de boutons sociaux",
  T_49_META_TYPE_405_D: "Type de tri de mise en page",
  T_49_META_TYPE_406_D: "Peut être déclenché pour franchir des obstacles",
  T_49_META_TYPE_407_D: "Type de plateforme",
  T_49_META_TYPE_408_D: "Alias de données de base",
  T_49_META_TYPE_409_D: "Énumération de codes d'erreur",
  T_49_META_TYPE_41_D: "Entité bouton de l'interface utilisateur, l'interface utilisateur éditée par le joueur via l'éditeur d'interface utilisateur.",
  T_49_META_TYPE_410_D: "Alias faisant référence à une entité de joueur ou à un type d'entité de transformation",
  T_49_META_TYPE_411_D: "Porte-hélicoptère",
  T_49_META_TYPE_412_D: "Composant Véhicule, qui est une extension du composant Transporteur.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Limite la plage des angles de rotation de la caméra",
  T_49_META_TYPE_415_D: "Personnage",
  T_49_META_TYPE_416_D: "Interface de la fenêtre de chat de Persona",
  T_49_META_TYPE_417_D: "Composant d'entité particule",
  T_49_META_TYPE_418_D: "Énumération du statut du membre",
  T_49_META_TYPE_419_D: "Types de peau de pistolet",
  T_49_META_TYPE_42_D: "Entité d'entrée de l'interface utilisateur, l'interface utilisateur éditée par le lecteur via l'éditeur d'interface utilisateur.",
  T_49_META_TYPE_420_D: "Types de peau des véhicules",
  T_49_META_TYPE_421_D: "Types de peau",
  T_49_META_TYPE_422_D: "Types de peau de sac à dos",
  T_49_META_TYPE_423_D: "ID de persona",
  T_49_META_TYPE_424_D: "Type de base de l'effet de brouillard",
  T_49_META_TYPE_425_D: "ID de la ressource particule",
  T_49_META_TYPE_426_D: "Un type de source lumineuse qui émet un cône de lumière dans la direction négative de l'axe Y à partir de la source lumineuse, par défaut vers le sol.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Informations sur les vêtements à conserver lorsque le joueur se transforme en un autre personnage.",
  T_49_META_TYPE_429_D: "Entités joueur ou PNJ",
  T_49_META_TYPE_43_D: "Liste des types d'éléments qui doivent être des entités du joueur",
  T_49_META_TYPE_430_D: "Générateur de nombres aléatoires",
  T_49_META_TYPE_431_D: "Objets de mouvement se déplaçant le long d'une trajectoire personnalisée",
  T_49_META_TYPE_432_D: "Points de passage personnalisés de la trajectoire de la courbe",
  T_49_META_TYPE_433_D: "Types de points de passage personnalisés",
  T_49_META_TYPE_434_D: "Chemins de courbe personnalisés",
  T_49_META_TYPE_435_D: "Liste des identifiants uniques des joueurs",
  T_49_META_TYPE_436_D: "Liste des codes d'erreur",
  T_49_META_TYPE_437_D: "Deux équipes correspondent à l'entité UI détails, modifier l'attribut de l'entité pour affecter le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_438_D: "Entité UI des détails du match de plusieurs équipes, la modification des attributs de l'entité affectera le contenu de l'affichage sur l'interface utilisateur correspondante.",
  T_49_META_TYPE_439_D: "Capacité",
  T_49_META_TYPE_44_D: "Liste des entités dont le type d'élément doit être une entité d'équipe",
  T_49_META_TYPE_440_D: "Ligne de temps",
  T_49_META_TYPE_441_D: "ID de ressource de la timeline",
  T_49_META_TYPE_442_D: "Nouveau composant d'entité de la version courte de l'information sur le match des deux équipes, qui permet de personnaliser entièrement le nombre de personnes à afficher.",
  T_49_META_TYPE_443_D: "ID de l'actif du flux de dialogue",
  T_49_META_TYPE_444_D: "Type de langage",
  T_49_META_TYPE_45_D: "Liste Bool",
  T_49_META_TYPE_46_D: "Liste D'int",
  T_49_META_TYPE_47_D: "Liste Flottante",
  T_49_META_TYPE_48_D: "Liste de Chaînes",
  T_49_META_TYPE_49_D: "Liste Vector3",
  T_49_META_TYPE_5_D: "Type de chaîne, la valeur est un contenu textuel",
  T_49_META_TYPE_50_D: "Liste des types d'éléments qui doivent être des entités",
  T_49_META_TYPE_51_D: "Types de zombies",
  T_49_META_TYPE_53_D: "Objet de niveau commun",
  T_49_META_TYPE_54_D: "Objet destructible",
  T_49_META_TYPE_55_D: "Point D'apparition Général",
  T_49_META_TYPE_56_D: "Véhicule",
  T_49_META_TYPE_57_D: "Les joueurs peuvent être téléportés à un endroit spécifique dès leur entrée dans le jeu.",
  T_49_META_TYPE_58_D: "Les buffs peuvent être générés à la demande.",
  T_49_META_TYPE_59_D: "Déplacer la plate-forme",
  T_49_META_TYPE_6_D: "Vecteurs tridimensionnels, qui peuvent représenter des coordonnées ou des directions spatiales.",
  T_49_META_TYPE_60_D: "Génère un dépôt d'armes du type sélectionné",
  T_49_META_TYPE_61_D: "Entrer dans la zone de déclenchement ouvre la boutique Bound.",
  T_49_META_TYPE_62_D: "Dés rebondissants",
  T_49_META_TYPE_63_D: "Les joueurs marchent dessus et ils rebondissent vers un endroit spécifique.",
  T_49_META_TYPE_64_D: "Les joueurs émettent un son lorsqu'ils marchent dessus.",
  T_49_META_TYPE_65_D: "Échelle de base",
  T_49_META_TYPE_66_D: "Custom Path",
  T_49_META_TYPE_67_D: "Path Point",
  T_49_META_TYPE_68_D: "Entités de monstres IA, tels que les zombies",
  T_49_META_TYPE_69_D: "Les grands nombres sont des nombres à virgule flottante de haute précision.",
  T_49_META_TYPE_7_D: "Les nombres sont des alias de type qui font référence à des types d'entiers, d'entiers de 64 bits ou de nombres à virgule flottante.",
  T_49_META_TYPE_70_D: "Les formules d'attributs sont utilisées pour calculer les valeurs des attributs des entités, seuls certains attributs des joueurs et des armes sont pris en charge pour l'instant.",
  T_49_META_TYPE_71_D: "Uniquement utilisé pour les entités vendues dans les magasins, le concept de marchandises est différent du concept d'objets obtenus en achetant des marchandises.",
  T_49_META_TYPE_72_D: "Contient plusieurs objets",
  T_49_META_TYPE_73_D: "Contient plusieurs étagères",
  T_49_META_TYPE_74_D: "ID de l'objet",
  T_49_META_TYPE_75_D: "Retour",
  T_49_META_TYPE_76_D: "Style de patrouille",
  T_49_META_TYPE_77_D: "Une entité générateur qui peut générer et rafraîchir des objets.",
  T_49_META_TYPE_78_D: "Une entité unité qui peut être utilisée par le générateur d'unités pour absorber et générer des unités par lots.",
  T_49_META_TYPE_79_D: "Arme",
  T_49_META_TYPE_8_D: "Les conditionnelles sont des types Bool spéciaux",
  T_49_META_TYPE_80_D: "Interface du magasin",
  T_49_META_TYPE_81_D: "Type de buff",
  T_49_META_TYPE_82_D: "Battement de cœur UI",
  T_49_META_TYPE_83_D: "Bouton d'interaction",
  T_49_META_TYPE_84_D: "Entité classable, capable d'être classée",
  T_49_META_TYPE_85_D: "Entité pouvant être classée, possède son propre score",
  T_49_META_TYPE_86_D: "Attribut Formule Facteur Type",
  T_49_META_TYPE_87_D: "Décrit le type de couleur RGBA, chaque canal prend une valeur comprise entre 0 et 255.",
  T_49_META_TYPE_88_D: "Type de monnaie, actuellement uniquement le type de monnaie de base",
  T_49_META_TYPE_89_D: "Entité monétaire, qui décrit le type et le montant de la monnaie.",
  T_49_META_TYPE_9_D: "Un ensemble de conditions",
  T_49_META_TYPE_90_D: "Les entités de portefeuille sont des conteneurs pour un ensemble d'entités de monnaie.",
  T_49_META_TYPE_91_D: "Indique un type d'entier ou de tableau d'entiers.",
  T_49_META_TYPE_92_D: "Type d'objet de niveau créé dynamiquement",
  T_49_META_TYPE_93_D: "Entités avec attributs formulables",
  T_49_META_TYPE_94_D: "Modification des attributs",
  T_49_META_TYPE_95_D: "Générateur d'Or",
  T_49_META_TYPE_96_D: "Portefeuille",
  T_49_META_TYPE_97_D: "Position, rotation, mise à l'échelle, prise en charge de la structure parent-enfant",
  T_49_META_TYPE_98_D: "Liste de tous les types disponibles",
  T_49_META_TYPE_99_D: "Objet de niveau"
};
export {
  _ as default
};
